/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  bigint: any;
  jsonb: any;
  numeric: any;
  timestamp: any;
  timestamptz: any;
};

export type AssetUpload = {
  __typename?: 'AssetUpload';
  name: Scalars['String'];
  uploadUrl: Scalars['String'];
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

export type MuxSpaceCreated = {
  __typename?: 'MuxSpaceCreated';
  participant_jwt: Scalars['String'];
  space_id: Scalars['String'];
};

export type ObscuredRegistration = {
  __typename?: 'ObscuredRegistration';
  address_1: Scalars['String'];
  address_2: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  film_festival: Scalars['String'];
  first_name: Scalars['String'];
  id: Scalars['Int'];
  is_minor: Scalars['Boolean'];
  last_name: Scalars['String'];
  middle_name: Scalars['String'];
  primary_email: Scalars['String'];
  primary_phone: Scalars['String'];
  role: Scalars['String'];
  secondary_email: Scalars['String'];
  secondary_phone: Scalars['String'];
  signature_email?: Maybe<Scalars['String']>;
  signature_name?: Maybe<Scalars['String']>;
  signature_phone?: Maybe<Scalars['String']>;
  signature_ts?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  team: Scalars['String'];
  zip: Scalars['String'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

export type StripeLineItem = {
  priceId: Scalars['String'];
  quantity: Scalars['Int'];
};

/** columns and relationships of "asset_exports" */
export type Asset_Exports = {
  __typename?: 'asset_exports';
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at: Scalars['timestamptz'];
  file_name?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  locked_at?: Maybe<Scalars['timestamptz']>;
  status: Scalars['String'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['numeric'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "asset_exports" */
export type Asset_Exports_Aggregate = {
  __typename?: 'asset_exports_aggregate';
  aggregate?: Maybe<Asset_Exports_Aggregate_Fields>;
  nodes: Array<Asset_Exports>;
};

export type Asset_Exports_Aggregate_Bool_Exp = {
  count?: InputMaybe<Asset_Exports_Aggregate_Bool_Exp_Count>;
};

export type Asset_Exports_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Asset_Exports_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Asset_Exports_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "asset_exports" */
export type Asset_Exports_Aggregate_Fields = {
  __typename?: 'asset_exports_aggregate_fields';
  avg?: Maybe<Asset_Exports_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Asset_Exports_Max_Fields>;
  min?: Maybe<Asset_Exports_Min_Fields>;
  stddev?: Maybe<Asset_Exports_Stddev_Fields>;
  stddev_pop?: Maybe<Asset_Exports_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Asset_Exports_Stddev_Samp_Fields>;
  sum?: Maybe<Asset_Exports_Sum_Fields>;
  var_pop?: Maybe<Asset_Exports_Var_Pop_Fields>;
  var_samp?: Maybe<Asset_Exports_Var_Samp_Fields>;
  variance?: Maybe<Asset_Exports_Variance_Fields>;
};


/** aggregate fields of "asset_exports" */
export type Asset_Exports_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Asset_Exports_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "asset_exports" */
export type Asset_Exports_Aggregate_Order_By = {
  avg?: InputMaybe<Asset_Exports_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Asset_Exports_Max_Order_By>;
  min?: InputMaybe<Asset_Exports_Min_Order_By>;
  stddev?: InputMaybe<Asset_Exports_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Asset_Exports_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Asset_Exports_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Asset_Exports_Sum_Order_By>;
  var_pop?: InputMaybe<Asset_Exports_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Asset_Exports_Var_Samp_Order_By>;
  variance?: InputMaybe<Asset_Exports_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "asset_exports" */
export type Asset_Exports_Arr_Rel_Insert_Input = {
  data: Array<Asset_Exports_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Asset_Exports_On_Conflict>;
};

/** aggregate avg on columns */
export type Asset_Exports_Avg_Fields = {
  __typename?: 'asset_exports_avg_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "asset_exports" */
export type Asset_Exports_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "asset_exports". All fields are combined with a logical 'AND'. */
export type Asset_Exports_Bool_Exp = {
  _and?: InputMaybe<Array<Asset_Exports_Bool_Exp>>;
  _not?: InputMaybe<Asset_Exports_Bool_Exp>;
  _or?: InputMaybe<Array<Asset_Exports_Bool_Exp>>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  locked_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "asset_exports" */
export enum Asset_Exports_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssetExportsPkey = 'asset_exports_pkey'
}

/** input type for incrementing numeric columns in table "asset_exports" */
export type Asset_Exports_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "asset_exports" */
export type Asset_Exports_Insert_Input = {
  completed_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  file_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  locked_at?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Asset_Exports_Max_Fields = {
  __typename?: 'asset_exports_max_fields';
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  file_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  locked_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "asset_exports" */
export type Asset_Exports_Max_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locked_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Asset_Exports_Min_Fields = {
  __typename?: 'asset_exports_min_fields';
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  file_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  locked_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "asset_exports" */
export type Asset_Exports_Min_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locked_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "asset_exports" */
export type Asset_Exports_Mutation_Response = {
  __typename?: 'asset_exports_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Asset_Exports>;
};

/** on_conflict condition type for table "asset_exports" */
export type Asset_Exports_On_Conflict = {
  constraint: Asset_Exports_Constraint;
  update_columns?: Array<Asset_Exports_Update_Column>;
  where?: InputMaybe<Asset_Exports_Bool_Exp>;
};

/** Ordering options when selecting data from "asset_exports". */
export type Asset_Exports_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locked_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: asset_exports */
export type Asset_Exports_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "asset_exports" */
export enum Asset_Exports_Select_Column {
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileName = 'file_name',
  /** column name */
  Id = 'id',
  /** column name */
  LockedAt = 'locked_at',
  /** column name */
  Status = 'status',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "asset_exports" */
export type Asset_Exports_Set_Input = {
  completed_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  file_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  locked_at?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Asset_Exports_Stddev_Fields = {
  __typename?: 'asset_exports_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "asset_exports" */
export type Asset_Exports_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Asset_Exports_Stddev_Pop_Fields = {
  __typename?: 'asset_exports_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "asset_exports" */
export type Asset_Exports_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Asset_Exports_Stddev_Samp_Fields = {
  __typename?: 'asset_exports_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "asset_exports" */
export type Asset_Exports_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "asset_exports" */
export type Asset_Exports_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Asset_Exports_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Asset_Exports_Stream_Cursor_Value_Input = {
  completed_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  file_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  locked_at?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Asset_Exports_Sum_Fields = {
  __typename?: 'asset_exports_sum_fields';
  id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "asset_exports" */
export type Asset_Exports_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** update columns of table "asset_exports" */
export enum Asset_Exports_Update_Column {
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileName = 'file_name',
  /** column name */
  Id = 'id',
  /** column name */
  LockedAt = 'locked_at',
  /** column name */
  Status = 'status',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Asset_Exports_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Asset_Exports_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Asset_Exports_Set_Input>;
  /** filter the rows which have to be updated */
  where: Asset_Exports_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Asset_Exports_Var_Pop_Fields = {
  __typename?: 'asset_exports_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "asset_exports" */
export type Asset_Exports_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Asset_Exports_Var_Samp_Fields = {
  __typename?: 'asset_exports_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "asset_exports" */
export type Asset_Exports_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Asset_Exports_Variance_Fields = {
  __typename?: 'asset_exports_variance_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "asset_exports" */
export type Asset_Exports_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "asset_types" */
export type Asset_Types = {
  __typename?: 'asset_types';
  created: Scalars['timestamp'];
  created_by: Scalars['String'];
  deleted_at?: Maybe<Scalars['timestamp']>;
  description?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['String']>;
  id: Scalars['numeric'];
  title?: Maybe<Scalars['String']>;
  updated: Scalars['timestamp'];
  updated_by: Scalars['String'];
};

/** aggregated selection of "asset_types" */
export type Asset_Types_Aggregate = {
  __typename?: 'asset_types_aggregate';
  aggregate?: Maybe<Asset_Types_Aggregate_Fields>;
  nodes: Array<Asset_Types>;
};

/** aggregate fields of "asset_types" */
export type Asset_Types_Aggregate_Fields = {
  __typename?: 'asset_types_aggregate_fields';
  avg?: Maybe<Asset_Types_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Asset_Types_Max_Fields>;
  min?: Maybe<Asset_Types_Min_Fields>;
  stddev?: Maybe<Asset_Types_Stddev_Fields>;
  stddev_pop?: Maybe<Asset_Types_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Asset_Types_Stddev_Samp_Fields>;
  sum?: Maybe<Asset_Types_Sum_Fields>;
  var_pop?: Maybe<Asset_Types_Var_Pop_Fields>;
  var_samp?: Maybe<Asset_Types_Var_Samp_Fields>;
  variance?: Maybe<Asset_Types_Variance_Fields>;
};


/** aggregate fields of "asset_types" */
export type Asset_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Asset_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Asset_Types_Avg_Fields = {
  __typename?: 'asset_types_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "asset_types". All fields are combined with a logical 'AND'. */
export type Asset_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Asset_Types_Bool_Exp>>;
  _not?: InputMaybe<Asset_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Asset_Types_Bool_Exp>>;
  created?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  hidden?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Numeric_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "asset_types" */
export enum Asset_Types_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssetTypesPkey = 'asset_types_pkey'
}

/** input type for incrementing numeric columns in table "asset_types" */
export type Asset_Types_Inc_Input = {
  id?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "asset_types" */
export type Asset_Types_Insert_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  deleted_at?: InputMaybe<Scalars['timestamp']>;
  description?: InputMaybe<Scalars['String']>;
  hidden?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  title?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Asset_Types_Max_Fields = {
  __typename?: 'asset_types_max_fields';
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['timestamp']>;
  description?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  title?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Asset_Types_Min_Fields = {
  __typename?: 'asset_types_min_fields';
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['timestamp']>;
  description?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  title?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "asset_types" */
export type Asset_Types_Mutation_Response = {
  __typename?: 'asset_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Asset_Types>;
};

/** input type for inserting object relation for remote table "asset_types" */
export type Asset_Types_Obj_Rel_Insert_Input = {
  data: Asset_Types_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Asset_Types_On_Conflict>;
};

/** on_conflict condition type for table "asset_types" */
export type Asset_Types_On_Conflict = {
  constraint: Asset_Types_Constraint;
  update_columns?: Array<Asset_Types_Update_Column>;
  where?: InputMaybe<Asset_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "asset_types". */
export type Asset_Types_Order_By = {
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  hidden?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: asset_types */
export type Asset_Types_Pk_Columns_Input = {
  id: Scalars['numeric'];
};

/** select columns of table "asset_types" */
export enum Asset_Types_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** input type for updating data in table "asset_types" */
export type Asset_Types_Set_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  deleted_at?: InputMaybe<Scalars['timestamp']>;
  description?: InputMaybe<Scalars['String']>;
  hidden?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  title?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Asset_Types_Stddev_Fields = {
  __typename?: 'asset_types_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Asset_Types_Stddev_Pop_Fields = {
  __typename?: 'asset_types_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Asset_Types_Stddev_Samp_Fields = {
  __typename?: 'asset_types_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "asset_types" */
export type Asset_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Asset_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Asset_Types_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  deleted_at?: InputMaybe<Scalars['timestamp']>;
  description?: InputMaybe<Scalars['String']>;
  hidden?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  title?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Asset_Types_Sum_Fields = {
  __typename?: 'asset_types_sum_fields';
  id?: Maybe<Scalars['numeric']>;
};

/** update columns of table "asset_types" */
export enum Asset_Types_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by'
}

export type Asset_Types_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Asset_Types_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Asset_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Asset_Types_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Asset_Types_Var_Pop_Fields = {
  __typename?: 'asset_types_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Asset_Types_Var_Samp_Fields = {
  __typename?: 'asset_types_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Asset_Types_Variance_Fields = {
  __typename?: 'asset_types_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "audience_favorite_counts" */
export type Audience_Favorite_Counts = {
  __typename?: 'audience_favorite_counts';
  count?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  team?: Maybe<Teams>;
  team_id?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "audience_favorite_counts" */
export type Audience_Favorite_Counts_Aggregate = {
  __typename?: 'audience_favorite_counts_aggregate';
  aggregate?: Maybe<Audience_Favorite_Counts_Aggregate_Fields>;
  nodes: Array<Audience_Favorite_Counts>;
};

/** aggregate fields of "audience_favorite_counts" */
export type Audience_Favorite_Counts_Aggregate_Fields = {
  __typename?: 'audience_favorite_counts_aggregate_fields';
  avg?: Maybe<Audience_Favorite_Counts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Audience_Favorite_Counts_Max_Fields>;
  min?: Maybe<Audience_Favorite_Counts_Min_Fields>;
  stddev?: Maybe<Audience_Favorite_Counts_Stddev_Fields>;
  stddev_pop?: Maybe<Audience_Favorite_Counts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Audience_Favorite_Counts_Stddev_Samp_Fields>;
  sum?: Maybe<Audience_Favorite_Counts_Sum_Fields>;
  var_pop?: Maybe<Audience_Favorite_Counts_Var_Pop_Fields>;
  var_samp?: Maybe<Audience_Favorite_Counts_Var_Samp_Fields>;
  variance?: Maybe<Audience_Favorite_Counts_Variance_Fields>;
};


/** aggregate fields of "audience_favorite_counts" */
export type Audience_Favorite_Counts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Audience_Favorite_Counts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Audience_Favorite_Counts_Avg_Fields = {
  __typename?: 'audience_favorite_counts_avg_fields';
  count?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "audience_favorite_counts". All fields are combined with a logical 'AND'. */
export type Audience_Favorite_Counts_Bool_Exp = {
  _and?: InputMaybe<Array<Audience_Favorite_Counts_Bool_Exp>>;
  _not?: InputMaybe<Audience_Favorite_Counts_Bool_Exp>;
  _or?: InputMaybe<Array<Audience_Favorite_Counts_Bool_Exp>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Audience_Favorite_Counts_Max_Fields = {
  __typename?: 'audience_favorite_counts_max_fields';
  count?: Maybe<Scalars['bigint']>;
  team_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Audience_Favorite_Counts_Min_Fields = {
  __typename?: 'audience_favorite_counts_min_fields';
  count?: Maybe<Scalars['bigint']>;
  team_id?: Maybe<Scalars['Int']>;
};

/** Ordering options when selecting data from "audience_favorite_counts". */
export type Audience_Favorite_Counts_Order_By = {
  count?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** select columns of table "audience_favorite_counts" */
export enum Audience_Favorite_Counts_Select_Column {
  /** column name */
  Count = 'count',
  /** column name */
  TeamId = 'team_id'
}

/** aggregate stddev on columns */
export type Audience_Favorite_Counts_Stddev_Fields = {
  __typename?: 'audience_favorite_counts_stddev_fields';
  count?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Audience_Favorite_Counts_Stddev_Pop_Fields = {
  __typename?: 'audience_favorite_counts_stddev_pop_fields';
  count?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Audience_Favorite_Counts_Stddev_Samp_Fields = {
  __typename?: 'audience_favorite_counts_stddev_samp_fields';
  count?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "audience_favorite_counts" */
export type Audience_Favorite_Counts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Audience_Favorite_Counts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Audience_Favorite_Counts_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['bigint']>;
  team_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Audience_Favorite_Counts_Sum_Fields = {
  __typename?: 'audience_favorite_counts_sum_fields';
  count?: Maybe<Scalars['bigint']>;
  team_id?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Audience_Favorite_Counts_Var_Pop_Fields = {
  __typename?: 'audience_favorite_counts_var_pop_fields';
  count?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Audience_Favorite_Counts_Var_Samp_Fields = {
  __typename?: 'audience_favorite_counts_var_samp_fields';
  count?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Audience_Favorite_Counts_Variance_Fields = {
  __typename?: 'audience_favorite_counts_variance_fields';
  count?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "audience_favorite_votes" */
export type Audience_Favorite_Votes = {
  __typename?: 'audience_favorite_votes';
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  team_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['Int'];
};

/** aggregated selection of "audience_favorite_votes" */
export type Audience_Favorite_Votes_Aggregate = {
  __typename?: 'audience_favorite_votes_aggregate';
  aggregate?: Maybe<Audience_Favorite_Votes_Aggregate_Fields>;
  nodes: Array<Audience_Favorite_Votes>;
};

/** aggregate fields of "audience_favorite_votes" */
export type Audience_Favorite_Votes_Aggregate_Fields = {
  __typename?: 'audience_favorite_votes_aggregate_fields';
  avg?: Maybe<Audience_Favorite_Votes_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Audience_Favorite_Votes_Max_Fields>;
  min?: Maybe<Audience_Favorite_Votes_Min_Fields>;
  stddev?: Maybe<Audience_Favorite_Votes_Stddev_Fields>;
  stddev_pop?: Maybe<Audience_Favorite_Votes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Audience_Favorite_Votes_Stddev_Samp_Fields>;
  sum?: Maybe<Audience_Favorite_Votes_Sum_Fields>;
  var_pop?: Maybe<Audience_Favorite_Votes_Var_Pop_Fields>;
  var_samp?: Maybe<Audience_Favorite_Votes_Var_Samp_Fields>;
  variance?: Maybe<Audience_Favorite_Votes_Variance_Fields>;
};


/** aggregate fields of "audience_favorite_votes" */
export type Audience_Favorite_Votes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Audience_Favorite_Votes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Audience_Favorite_Votes_Avg_Fields = {
  __typename?: 'audience_favorite_votes_avg_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "audience_favorite_votes". All fields are combined with a logical 'AND'. */
export type Audience_Favorite_Votes_Bool_Exp = {
  _and?: InputMaybe<Array<Audience_Favorite_Votes_Bool_Exp>>;
  _not?: InputMaybe<Audience_Favorite_Votes_Bool_Exp>;
  _or?: InputMaybe<Array<Audience_Favorite_Votes_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  team_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "audience_favorite_votes" */
export enum Audience_Favorite_Votes_Constraint {
  /** unique or primary key constraint on columns "id" */
  AudienceFavoriteVotesPkey = 'audience_favorite_votes_pkey'
}

/** input type for incrementing numeric columns in table "audience_favorite_votes" */
export type Audience_Favorite_Votes_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "audience_favorite_votes" */
export type Audience_Favorite_Votes_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Audience_Favorite_Votes_Max_Fields = {
  __typename?: 'audience_favorite_votes_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Audience_Favorite_Votes_Min_Fields = {
  __typename?: 'audience_favorite_votes_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "audience_favorite_votes" */
export type Audience_Favorite_Votes_Mutation_Response = {
  __typename?: 'audience_favorite_votes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Audience_Favorite_Votes>;
};

/** on_conflict condition type for table "audience_favorite_votes" */
export type Audience_Favorite_Votes_On_Conflict = {
  constraint: Audience_Favorite_Votes_Constraint;
  update_columns?: Array<Audience_Favorite_Votes_Update_Column>;
  where?: InputMaybe<Audience_Favorite_Votes_Bool_Exp>;
};

/** Ordering options when selecting data from "audience_favorite_votes". */
export type Audience_Favorite_Votes_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: audience_favorite_votes */
export type Audience_Favorite_Votes_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "audience_favorite_votes" */
export enum Audience_Favorite_Votes_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "audience_favorite_votes" */
export type Audience_Favorite_Votes_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Audience_Favorite_Votes_Stddev_Fields = {
  __typename?: 'audience_favorite_votes_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Audience_Favorite_Votes_Stddev_Pop_Fields = {
  __typename?: 'audience_favorite_votes_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Audience_Favorite_Votes_Stddev_Samp_Fields = {
  __typename?: 'audience_favorite_votes_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "audience_favorite_votes" */
export type Audience_Favorite_Votes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Audience_Favorite_Votes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Audience_Favorite_Votes_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Audience_Favorite_Votes_Sum_Fields = {
  __typename?: 'audience_favorite_votes_sum_fields';
  id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "audience_favorite_votes" */
export enum Audience_Favorite_Votes_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Audience_Favorite_Votes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Audience_Favorite_Votes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Audience_Favorite_Votes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Audience_Favorite_Votes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Audience_Favorite_Votes_Var_Pop_Fields = {
  __typename?: 'audience_favorite_votes_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Audience_Favorite_Votes_Var_Samp_Fields = {
  __typename?: 'audience_favorite_votes_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Audience_Favorite_Votes_Variance_Fields = {
  __typename?: 'audience_favorite_votes_variance_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "award_asset_types" */
export type Award_Asset_Types = {
  __typename?: 'award_asset_types';
  /** An object relationship */
  asset_type: Asset_Types;
  asset_type_id: Scalars['numeric'];
  /** An object relationship */
  award: Awards;
  award_id: Scalars['numeric'];
  created: Scalars['timestamp'];
  created_by: Scalars['String'];
  id: Scalars['numeric'];
  mime?: Maybe<Scalars['String']>;
  updated: Scalars['timestamp'];
  updated_by: Scalars['String'];
};

/** aggregated selection of "award_asset_types" */
export type Award_Asset_Types_Aggregate = {
  __typename?: 'award_asset_types_aggregate';
  aggregate?: Maybe<Award_Asset_Types_Aggregate_Fields>;
  nodes: Array<Award_Asset_Types>;
};

export type Award_Asset_Types_Aggregate_Bool_Exp = {
  count?: InputMaybe<Award_Asset_Types_Aggregate_Bool_Exp_Count>;
};

export type Award_Asset_Types_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Award_Asset_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Award_Asset_Types_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "award_asset_types" */
export type Award_Asset_Types_Aggregate_Fields = {
  __typename?: 'award_asset_types_aggregate_fields';
  avg?: Maybe<Award_Asset_Types_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Award_Asset_Types_Max_Fields>;
  min?: Maybe<Award_Asset_Types_Min_Fields>;
  stddev?: Maybe<Award_Asset_Types_Stddev_Fields>;
  stddev_pop?: Maybe<Award_Asset_Types_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Award_Asset_Types_Stddev_Samp_Fields>;
  sum?: Maybe<Award_Asset_Types_Sum_Fields>;
  var_pop?: Maybe<Award_Asset_Types_Var_Pop_Fields>;
  var_samp?: Maybe<Award_Asset_Types_Var_Samp_Fields>;
  variance?: Maybe<Award_Asset_Types_Variance_Fields>;
};


/** aggregate fields of "award_asset_types" */
export type Award_Asset_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Award_Asset_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "award_asset_types" */
export type Award_Asset_Types_Aggregate_Order_By = {
  avg?: InputMaybe<Award_Asset_Types_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Award_Asset_Types_Max_Order_By>;
  min?: InputMaybe<Award_Asset_Types_Min_Order_By>;
  stddev?: InputMaybe<Award_Asset_Types_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Award_Asset_Types_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Award_Asset_Types_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Award_Asset_Types_Sum_Order_By>;
  var_pop?: InputMaybe<Award_Asset_Types_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Award_Asset_Types_Var_Samp_Order_By>;
  variance?: InputMaybe<Award_Asset_Types_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "award_asset_types" */
export type Award_Asset_Types_Arr_Rel_Insert_Input = {
  data: Array<Award_Asset_Types_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Award_Asset_Types_On_Conflict>;
};

/** aggregate avg on columns */
export type Award_Asset_Types_Avg_Fields = {
  __typename?: 'award_asset_types_avg_fields';
  asset_type_id?: Maybe<Scalars['Float']>;
  award_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "award_asset_types" */
export type Award_Asset_Types_Avg_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  award_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "award_asset_types". All fields are combined with a logical 'AND'. */
export type Award_Asset_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Award_Asset_Types_Bool_Exp>>;
  _not?: InputMaybe<Award_Asset_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Award_Asset_Types_Bool_Exp>>;
  asset_type?: InputMaybe<Asset_Types_Bool_Exp>;
  asset_type_id?: InputMaybe<Numeric_Comparison_Exp>;
  award?: InputMaybe<Awards_Bool_Exp>;
  award_id?: InputMaybe<Numeric_Comparison_Exp>;
  created?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Numeric_Comparison_Exp>;
  mime?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "award_asset_types" */
export enum Award_Asset_Types_Constraint {
  /** unique or primary key constraint on columns "id" */
  AwardAssetTypesPkey = 'award_asset_types_pkey'
}

/** input type for incrementing numeric columns in table "award_asset_types" */
export type Award_Asset_Types_Inc_Input = {
  asset_type_id?: InputMaybe<Scalars['numeric']>;
  award_id?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "award_asset_types" */
export type Award_Asset_Types_Insert_Input = {
  asset_type?: InputMaybe<Asset_Types_Obj_Rel_Insert_Input>;
  asset_type_id?: InputMaybe<Scalars['numeric']>;
  award?: InputMaybe<Awards_Obj_Rel_Insert_Input>;
  award_id?: InputMaybe<Scalars['numeric']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  mime?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Award_Asset_Types_Max_Fields = {
  __typename?: 'award_asset_types_max_fields';
  asset_type_id?: Maybe<Scalars['numeric']>;
  award_id?: Maybe<Scalars['numeric']>;
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  mime?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "award_asset_types" */
export type Award_Asset_Types_Max_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  award_id?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mime?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Award_Asset_Types_Min_Fields = {
  __typename?: 'award_asset_types_min_fields';
  asset_type_id?: Maybe<Scalars['numeric']>;
  award_id?: Maybe<Scalars['numeric']>;
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  mime?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "award_asset_types" */
export type Award_Asset_Types_Min_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  award_id?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mime?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "award_asset_types" */
export type Award_Asset_Types_Mutation_Response = {
  __typename?: 'award_asset_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Award_Asset_Types>;
};

/** on_conflict condition type for table "award_asset_types" */
export type Award_Asset_Types_On_Conflict = {
  constraint: Award_Asset_Types_Constraint;
  update_columns?: Array<Award_Asset_Types_Update_Column>;
  where?: InputMaybe<Award_Asset_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "award_asset_types". */
export type Award_Asset_Types_Order_By = {
  asset_type?: InputMaybe<Asset_Types_Order_By>;
  asset_type_id?: InputMaybe<Order_By>;
  award?: InputMaybe<Awards_Order_By>;
  award_id?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mime?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: award_asset_types */
export type Award_Asset_Types_Pk_Columns_Input = {
  id: Scalars['numeric'];
};

/** select columns of table "award_asset_types" */
export enum Award_Asset_Types_Select_Column {
  /** column name */
  AssetTypeId = 'asset_type_id',
  /** column name */
  AwardId = 'award_id',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Mime = 'mime',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** input type for updating data in table "award_asset_types" */
export type Award_Asset_Types_Set_Input = {
  asset_type_id?: InputMaybe<Scalars['numeric']>;
  award_id?: InputMaybe<Scalars['numeric']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  mime?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Award_Asset_Types_Stddev_Fields = {
  __typename?: 'award_asset_types_stddev_fields';
  asset_type_id?: Maybe<Scalars['Float']>;
  award_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "award_asset_types" */
export type Award_Asset_Types_Stddev_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  award_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Award_Asset_Types_Stddev_Pop_Fields = {
  __typename?: 'award_asset_types_stddev_pop_fields';
  asset_type_id?: Maybe<Scalars['Float']>;
  award_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "award_asset_types" */
export type Award_Asset_Types_Stddev_Pop_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  award_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Award_Asset_Types_Stddev_Samp_Fields = {
  __typename?: 'award_asset_types_stddev_samp_fields';
  asset_type_id?: Maybe<Scalars['Float']>;
  award_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "award_asset_types" */
export type Award_Asset_Types_Stddev_Samp_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  award_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "award_asset_types" */
export type Award_Asset_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Award_Asset_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Award_Asset_Types_Stream_Cursor_Value_Input = {
  asset_type_id?: InputMaybe<Scalars['numeric']>;
  award_id?: InputMaybe<Scalars['numeric']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  mime?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Award_Asset_Types_Sum_Fields = {
  __typename?: 'award_asset_types_sum_fields';
  asset_type_id?: Maybe<Scalars['numeric']>;
  award_id?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "award_asset_types" */
export type Award_Asset_Types_Sum_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  award_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "award_asset_types" */
export enum Award_Asset_Types_Update_Column {
  /** column name */
  AssetTypeId = 'asset_type_id',
  /** column name */
  AwardId = 'award_id',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Mime = 'mime',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by'
}

export type Award_Asset_Types_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Award_Asset_Types_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Award_Asset_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Award_Asset_Types_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Award_Asset_Types_Var_Pop_Fields = {
  __typename?: 'award_asset_types_var_pop_fields';
  asset_type_id?: Maybe<Scalars['Float']>;
  award_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "award_asset_types" */
export type Award_Asset_Types_Var_Pop_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  award_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Award_Asset_Types_Var_Samp_Fields = {
  __typename?: 'award_asset_types_var_samp_fields';
  asset_type_id?: Maybe<Scalars['Float']>;
  award_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "award_asset_types" */
export type Award_Asset_Types_Var_Samp_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  award_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Award_Asset_Types_Variance_Fields = {
  __typename?: 'award_asset_types_variance_fields';
  asset_type_id?: Maybe<Scalars['Float']>;
  award_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "award_asset_types" */
export type Award_Asset_Types_Variance_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  award_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "award_nominations" */
export type Award_Nominations = {
  __typename?: 'award_nominations';
  /** An array relationship */
  asset_types: Array<Award_Asset_Types>;
  /** An aggregate relationship */
  asset_types_aggregate: Award_Asset_Types_Aggregate;
  /** An array relationship */
  assets: Array<Nomination_Assets>;
  /** An aggregate relationship */
  assets_aggregate: Nomination_Assets_Aggregate;
  /** An object relationship */
  award?: Maybe<Awards>;
  award_id?: Maybe<Scalars['numeric']>;
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  membership?: Maybe<Team_Memberships>;
  /** An object relationship */
  team?: Maybe<Teams>;
  team_id?: Maybe<Scalars['numeric']>;
  team_membership_id?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};


/** columns and relationships of "award_nominations" */
export type Award_NominationsAsset_TypesArgs = {
  distinct_on?: InputMaybe<Array<Award_Asset_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Award_Asset_Types_Order_By>>;
  where?: InputMaybe<Award_Asset_Types_Bool_Exp>;
};


/** columns and relationships of "award_nominations" */
export type Award_NominationsAsset_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Award_Asset_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Award_Asset_Types_Order_By>>;
  where?: InputMaybe<Award_Asset_Types_Bool_Exp>;
};


/** columns and relationships of "award_nominations" */
export type Award_NominationsAssetsArgs = {
  distinct_on?: InputMaybe<Array<Nomination_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nomination_Assets_Order_By>>;
  where?: InputMaybe<Nomination_Assets_Bool_Exp>;
};


/** columns and relationships of "award_nominations" */
export type Award_NominationsAssets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nomination_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nomination_Assets_Order_By>>;
  where?: InputMaybe<Nomination_Assets_Bool_Exp>;
};

/** aggregated selection of "award_nominations" */
export type Award_Nominations_Aggregate = {
  __typename?: 'award_nominations_aggregate';
  aggregate?: Maybe<Award_Nominations_Aggregate_Fields>;
  nodes: Array<Award_Nominations>;
};

export type Award_Nominations_Aggregate_Bool_Exp = {
  count?: InputMaybe<Award_Nominations_Aggregate_Bool_Exp_Count>;
};

export type Award_Nominations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Award_Nominations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Award_Nominations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "award_nominations" */
export type Award_Nominations_Aggregate_Fields = {
  __typename?: 'award_nominations_aggregate_fields';
  avg?: Maybe<Award_Nominations_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Award_Nominations_Max_Fields>;
  min?: Maybe<Award_Nominations_Min_Fields>;
  stddev?: Maybe<Award_Nominations_Stddev_Fields>;
  stddev_pop?: Maybe<Award_Nominations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Award_Nominations_Stddev_Samp_Fields>;
  sum?: Maybe<Award_Nominations_Sum_Fields>;
  var_pop?: Maybe<Award_Nominations_Var_Pop_Fields>;
  var_samp?: Maybe<Award_Nominations_Var_Samp_Fields>;
  variance?: Maybe<Award_Nominations_Variance_Fields>;
};


/** aggregate fields of "award_nominations" */
export type Award_Nominations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Award_Nominations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "award_nominations" */
export type Award_Nominations_Aggregate_Order_By = {
  avg?: InputMaybe<Award_Nominations_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Award_Nominations_Max_Order_By>;
  min?: InputMaybe<Award_Nominations_Min_Order_By>;
  stddev?: InputMaybe<Award_Nominations_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Award_Nominations_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Award_Nominations_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Award_Nominations_Sum_Order_By>;
  var_pop?: InputMaybe<Award_Nominations_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Award_Nominations_Var_Samp_Order_By>;
  variance?: InputMaybe<Award_Nominations_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "award_nominations" */
export type Award_Nominations_Arr_Rel_Insert_Input = {
  data: Array<Award_Nominations_Insert_Input>;
};

/** aggregate avg on columns */
export type Award_Nominations_Avg_Fields = {
  __typename?: 'award_nominations_avg_fields';
  award_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "award_nominations" */
export type Award_Nominations_Avg_Order_By = {
  award_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  team_membership_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "award_nominations". All fields are combined with a logical 'AND'. */
export type Award_Nominations_Bool_Exp = {
  _and?: InputMaybe<Array<Award_Nominations_Bool_Exp>>;
  _not?: InputMaybe<Award_Nominations_Bool_Exp>;
  _or?: InputMaybe<Array<Award_Nominations_Bool_Exp>>;
  asset_types?: InputMaybe<Award_Asset_Types_Bool_Exp>;
  asset_types_aggregate?: InputMaybe<Award_Asset_Types_Aggregate_Bool_Exp>;
  assets?: InputMaybe<Nomination_Assets_Bool_Exp>;
  assets_aggregate?: InputMaybe<Nomination_Assets_Aggregate_Bool_Exp>;
  award?: InputMaybe<Awards_Bool_Exp>;
  award_id?: InputMaybe<Numeric_Comparison_Exp>;
  created?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Numeric_Comparison_Exp>;
  membership?: InputMaybe<Team_Memberships_Bool_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Numeric_Comparison_Exp>;
  team_membership_id?: InputMaybe<Numeric_Comparison_Exp>;
  updated?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "award_nominations" */
export type Award_Nominations_Insert_Input = {
  asset_types?: InputMaybe<Award_Asset_Types_Arr_Rel_Insert_Input>;
  assets?: InputMaybe<Nomination_Assets_Arr_Rel_Insert_Input>;
  award?: InputMaybe<Awards_Obj_Rel_Insert_Input>;
  award_id?: InputMaybe<Scalars['numeric']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  membership?: InputMaybe<Team_Memberships_Obj_Rel_Insert_Input>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['numeric']>;
  team_membership_id?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Award_Nominations_Max_Fields = {
  __typename?: 'award_nominations_max_fields';
  award_id?: Maybe<Scalars['numeric']>;
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  team_id?: Maybe<Scalars['numeric']>;
  team_membership_id?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "award_nominations" */
export type Award_Nominations_Max_Order_By = {
  award_id?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  team_membership_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Award_Nominations_Min_Fields = {
  __typename?: 'award_nominations_min_fields';
  award_id?: Maybe<Scalars['numeric']>;
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  team_id?: Maybe<Scalars['numeric']>;
  team_membership_id?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "award_nominations" */
export type Award_Nominations_Min_Order_By = {
  award_id?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  team_membership_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "award_nominations". */
export type Award_Nominations_Order_By = {
  asset_types_aggregate?: InputMaybe<Award_Asset_Types_Aggregate_Order_By>;
  assets_aggregate?: InputMaybe<Nomination_Assets_Aggregate_Order_By>;
  award?: InputMaybe<Awards_Order_By>;
  award_id?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  membership?: InputMaybe<Team_Memberships_Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  team_membership_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** select columns of table "award_nominations" */
export enum Award_Nominations_Select_Column {
  /** column name */
  AwardId = 'award_id',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TeamMembershipId = 'team_membership_id',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** aggregate stddev on columns */
export type Award_Nominations_Stddev_Fields = {
  __typename?: 'award_nominations_stddev_fields';
  award_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "award_nominations" */
export type Award_Nominations_Stddev_Order_By = {
  award_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  team_membership_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Award_Nominations_Stddev_Pop_Fields = {
  __typename?: 'award_nominations_stddev_pop_fields';
  award_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "award_nominations" */
export type Award_Nominations_Stddev_Pop_Order_By = {
  award_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  team_membership_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Award_Nominations_Stddev_Samp_Fields = {
  __typename?: 'award_nominations_stddev_samp_fields';
  award_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "award_nominations" */
export type Award_Nominations_Stddev_Samp_Order_By = {
  award_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  team_membership_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "award_nominations" */
export type Award_Nominations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Award_Nominations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Award_Nominations_Stream_Cursor_Value_Input = {
  award_id?: InputMaybe<Scalars['numeric']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  team_membership_id?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Award_Nominations_Sum_Fields = {
  __typename?: 'award_nominations_sum_fields';
  award_id?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['numeric']>;
  team_id?: Maybe<Scalars['numeric']>;
  team_membership_id?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "award_nominations" */
export type Award_Nominations_Sum_Order_By = {
  award_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  team_membership_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Award_Nominations_Var_Pop_Fields = {
  __typename?: 'award_nominations_var_pop_fields';
  award_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "award_nominations" */
export type Award_Nominations_Var_Pop_Order_By = {
  award_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  team_membership_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Award_Nominations_Var_Samp_Fields = {
  __typename?: 'award_nominations_var_samp_fields';
  award_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "award_nominations" */
export type Award_Nominations_Var_Samp_Order_By = {
  award_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  team_membership_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Award_Nominations_Variance_Fields = {
  __typename?: 'award_nominations_variance_fields';
  award_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "award_nominations" */
export type Award_Nominations_Variance_Order_By = {
  award_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  team_membership_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "award_winners" */
export type Award_Winners = {
  __typename?: 'award_winners';
  /** An object relationship */
  award: Awards;
  award_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  film_festival: Film_Festivals;
  film_festival_id: Scalars['Int'];
  id: Scalars['Int'];
  rank: Scalars['Int'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "award_winners" */
export type Award_Winners_Aggregate = {
  __typename?: 'award_winners_aggregate';
  aggregate?: Maybe<Award_Winners_Aggregate_Fields>;
  nodes: Array<Award_Winners>;
};

export type Award_Winners_Aggregate_Bool_Exp = {
  count?: InputMaybe<Award_Winners_Aggregate_Bool_Exp_Count>;
};

export type Award_Winners_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Award_Winners_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Award_Winners_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "award_winners" */
export type Award_Winners_Aggregate_Fields = {
  __typename?: 'award_winners_aggregate_fields';
  avg?: Maybe<Award_Winners_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Award_Winners_Max_Fields>;
  min?: Maybe<Award_Winners_Min_Fields>;
  stddev?: Maybe<Award_Winners_Stddev_Fields>;
  stddev_pop?: Maybe<Award_Winners_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Award_Winners_Stddev_Samp_Fields>;
  sum?: Maybe<Award_Winners_Sum_Fields>;
  var_pop?: Maybe<Award_Winners_Var_Pop_Fields>;
  var_samp?: Maybe<Award_Winners_Var_Samp_Fields>;
  variance?: Maybe<Award_Winners_Variance_Fields>;
};


/** aggregate fields of "award_winners" */
export type Award_Winners_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Award_Winners_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "award_winners" */
export type Award_Winners_Aggregate_Order_By = {
  avg?: InputMaybe<Award_Winners_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Award_Winners_Max_Order_By>;
  min?: InputMaybe<Award_Winners_Min_Order_By>;
  stddev?: InputMaybe<Award_Winners_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Award_Winners_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Award_Winners_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Award_Winners_Sum_Order_By>;
  var_pop?: InputMaybe<Award_Winners_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Award_Winners_Var_Samp_Order_By>;
  variance?: InputMaybe<Award_Winners_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "award_winners" */
export type Award_Winners_Arr_Rel_Insert_Input = {
  data: Array<Award_Winners_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Award_Winners_On_Conflict>;
};

/** aggregate avg on columns */
export type Award_Winners_Avg_Fields = {
  __typename?: 'award_winners_avg_fields';
  award_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "award_winners" */
export type Award_Winners_Avg_Order_By = {
  award_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "award_winners". All fields are combined with a logical 'AND'. */
export type Award_Winners_Bool_Exp = {
  _and?: InputMaybe<Array<Award_Winners_Bool_Exp>>;
  _not?: InputMaybe<Award_Winners_Bool_Exp>;
  _or?: InputMaybe<Array<Award_Winners_Bool_Exp>>;
  award?: InputMaybe<Awards_Bool_Exp>;
  award_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  film_festival?: InputMaybe<Film_Festivals_Bool_Exp>;
  film_festival_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  rank?: InputMaybe<Int_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "award_winners" */
export enum Award_Winners_Constraint {
  /** unique or primary key constraint on columns "id" */
  AwardWinnersPkey = 'award_winners_pkey'
}

/** input type for incrementing numeric columns in table "award_winners" */
export type Award_Winners_Inc_Input = {
  award_id?: InputMaybe<Scalars['Int']>;
  film_festival_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  rank?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "award_winners" */
export type Award_Winners_Insert_Input = {
  award?: InputMaybe<Awards_Obj_Rel_Insert_Input>;
  award_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  film_festival?: InputMaybe<Film_Festivals_Obj_Rel_Insert_Input>;
  film_festival_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  rank?: InputMaybe<Scalars['Int']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Award_Winners_Max_Fields = {
  __typename?: 'award_winners_max_fields';
  award_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  film_festival_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  rank?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "award_winners" */
export type Award_Winners_Max_Order_By = {
  award_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Award_Winners_Min_Fields = {
  __typename?: 'award_winners_min_fields';
  award_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  film_festival_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  rank?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "award_winners" */
export type Award_Winners_Min_Order_By = {
  award_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "award_winners" */
export type Award_Winners_Mutation_Response = {
  __typename?: 'award_winners_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Award_Winners>;
};

/** on_conflict condition type for table "award_winners" */
export type Award_Winners_On_Conflict = {
  constraint: Award_Winners_Constraint;
  update_columns?: Array<Award_Winners_Update_Column>;
  where?: InputMaybe<Award_Winners_Bool_Exp>;
};

/** Ordering options when selecting data from "award_winners". */
export type Award_Winners_Order_By = {
  award?: InputMaybe<Awards_Order_By>;
  award_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  film_festival?: InputMaybe<Film_Festivals_Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: award_winners */
export type Award_Winners_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "award_winners" */
export enum Award_Winners_Select_Column {
  /** column name */
  AwardId = 'award_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FilmFestivalId = 'film_festival_id',
  /** column name */
  Id = 'id',
  /** column name */
  Rank = 'rank',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "award_winners" */
export type Award_Winners_Set_Input = {
  award_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  film_festival_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  rank?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Award_Winners_Stddev_Fields = {
  __typename?: 'award_winners_stddev_fields';
  award_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "award_winners" */
export type Award_Winners_Stddev_Order_By = {
  award_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Award_Winners_Stddev_Pop_Fields = {
  __typename?: 'award_winners_stddev_pop_fields';
  award_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "award_winners" */
export type Award_Winners_Stddev_Pop_Order_By = {
  award_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Award_Winners_Stddev_Samp_Fields = {
  __typename?: 'award_winners_stddev_samp_fields';
  award_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "award_winners" */
export type Award_Winners_Stddev_Samp_Order_By = {
  award_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "award_winners" */
export type Award_Winners_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Award_Winners_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Award_Winners_Stream_Cursor_Value_Input = {
  award_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  film_festival_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  rank?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Award_Winners_Sum_Fields = {
  __typename?: 'award_winners_sum_fields';
  award_id?: Maybe<Scalars['Int']>;
  film_festival_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  rank?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "award_winners" */
export type Award_Winners_Sum_Order_By = {
  award_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** update columns of table "award_winners" */
export enum Award_Winners_Update_Column {
  /** column name */
  AwardId = 'award_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FilmFestivalId = 'film_festival_id',
  /** column name */
  Id = 'id',
  /** column name */
  Rank = 'rank',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Award_Winners_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Award_Winners_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Award_Winners_Set_Input>;
  /** filter the rows which have to be updated */
  where: Award_Winners_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Award_Winners_Var_Pop_Fields = {
  __typename?: 'award_winners_var_pop_fields';
  award_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "award_winners" */
export type Award_Winners_Var_Pop_Order_By = {
  award_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Award_Winners_Var_Samp_Fields = {
  __typename?: 'award_winners_var_samp_fields';
  award_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "award_winners" */
export type Award_Winners_Var_Samp_Order_By = {
  award_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Award_Winners_Variance_Fields = {
  __typename?: 'award_winners_variance_fields';
  award_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  rank?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "award_winners" */
export type Award_Winners_Variance_Order_By = {
  award_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "awards" */
export type Awards = {
  __typename?: 'awards';
  /** An array relationship */
  award_nominations: Array<Award_Nominations>;
  /** An aggregate relationship */
  award_nominations_aggregate: Award_Nominations_Aggregate;
  created: Scalars['timestamp'];
  created_by: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['numeric'];
  max_nominations: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  nominations: Array<Nominations>;
  /** An aggregate relationship */
  nominations_aggregate: Nominations_Aggregate;
  /** An array relationship */
  required_asset_types: Array<Award_Asset_Types>;
  /** An aggregate relationship */
  required_asset_types_aggregate: Award_Asset_Types_Aggregate;
  /** An array relationship */
  selection_metrics: Array<Selection_Metrics>;
  /** An aggregate relationship */
  selection_metrics_aggregate: Selection_Metrics_Aggregate;
  updated: Scalars['timestamp'];
  updated_by: Scalars['String'];
};


/** columns and relationships of "awards" */
export type AwardsAward_NominationsArgs = {
  distinct_on?: InputMaybe<Array<Award_Nominations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Award_Nominations_Order_By>>;
  where?: InputMaybe<Award_Nominations_Bool_Exp>;
};


/** columns and relationships of "awards" */
export type AwardsAward_Nominations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Award_Nominations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Award_Nominations_Order_By>>;
  where?: InputMaybe<Award_Nominations_Bool_Exp>;
};


/** columns and relationships of "awards" */
export type AwardsNominationsArgs = {
  distinct_on?: InputMaybe<Array<Nominations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nominations_Order_By>>;
  where?: InputMaybe<Nominations_Bool_Exp>;
};


/** columns and relationships of "awards" */
export type AwardsNominations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nominations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nominations_Order_By>>;
  where?: InputMaybe<Nominations_Bool_Exp>;
};


/** columns and relationships of "awards" */
export type AwardsRequired_Asset_TypesArgs = {
  distinct_on?: InputMaybe<Array<Award_Asset_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Award_Asset_Types_Order_By>>;
  where?: InputMaybe<Award_Asset_Types_Bool_Exp>;
};


/** columns and relationships of "awards" */
export type AwardsRequired_Asset_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Award_Asset_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Award_Asset_Types_Order_By>>;
  where?: InputMaybe<Award_Asset_Types_Bool_Exp>;
};


/** columns and relationships of "awards" */
export type AwardsSelection_MetricsArgs = {
  distinct_on?: InputMaybe<Array<Selection_Metrics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Selection_Metrics_Order_By>>;
  where?: InputMaybe<Selection_Metrics_Bool_Exp>;
};


/** columns and relationships of "awards" */
export type AwardsSelection_Metrics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Selection_Metrics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Selection_Metrics_Order_By>>;
  where?: InputMaybe<Selection_Metrics_Bool_Exp>;
};

/** aggregated selection of "awards" */
export type Awards_Aggregate = {
  __typename?: 'awards_aggregate';
  aggregate?: Maybe<Awards_Aggregate_Fields>;
  nodes: Array<Awards>;
};

/** aggregate fields of "awards" */
export type Awards_Aggregate_Fields = {
  __typename?: 'awards_aggregate_fields';
  avg?: Maybe<Awards_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Awards_Max_Fields>;
  min?: Maybe<Awards_Min_Fields>;
  stddev?: Maybe<Awards_Stddev_Fields>;
  stddev_pop?: Maybe<Awards_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Awards_Stddev_Samp_Fields>;
  sum?: Maybe<Awards_Sum_Fields>;
  var_pop?: Maybe<Awards_Var_Pop_Fields>;
  var_samp?: Maybe<Awards_Var_Samp_Fields>;
  variance?: Maybe<Awards_Variance_Fields>;
};


/** aggregate fields of "awards" */
export type Awards_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Awards_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Awards_Avg_Fields = {
  __typename?: 'awards_avg_fields';
  id?: Maybe<Scalars['Float']>;
  max_nominations?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "awards". All fields are combined with a logical 'AND'. */
export type Awards_Bool_Exp = {
  _and?: InputMaybe<Array<Awards_Bool_Exp>>;
  _not?: InputMaybe<Awards_Bool_Exp>;
  _or?: InputMaybe<Array<Awards_Bool_Exp>>;
  award_nominations?: InputMaybe<Award_Nominations_Bool_Exp>;
  award_nominations_aggregate?: InputMaybe<Award_Nominations_Aggregate_Bool_Exp>;
  created?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Numeric_Comparison_Exp>;
  max_nominations?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  nominations?: InputMaybe<Nominations_Bool_Exp>;
  nominations_aggregate?: InputMaybe<Nominations_Aggregate_Bool_Exp>;
  required_asset_types?: InputMaybe<Award_Asset_Types_Bool_Exp>;
  required_asset_types_aggregate?: InputMaybe<Award_Asset_Types_Aggregate_Bool_Exp>;
  selection_metrics?: InputMaybe<Selection_Metrics_Bool_Exp>;
  selection_metrics_aggregate?: InputMaybe<Selection_Metrics_Aggregate_Bool_Exp>;
  updated?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "awards_ceremony_checkins" */
export type Awards_Ceremony_Checkins = {
  __typename?: 'awards_ceremony_checkins';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  festival_submission?: Maybe<Festival_Submissions>;
  festival_submission_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  phone?: Maybe<Scalars['String']>;
  /** An object relationship */
  team?: Maybe<Teams>;
  team_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  team_membership?: Maybe<Team_Memberships>;
  team_membership_id?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "awards_ceremony_checkins" */
export type Awards_Ceremony_Checkins_Aggregate = {
  __typename?: 'awards_ceremony_checkins_aggregate';
  aggregate?: Maybe<Awards_Ceremony_Checkins_Aggregate_Fields>;
  nodes: Array<Awards_Ceremony_Checkins>;
};

/** aggregate fields of "awards_ceremony_checkins" */
export type Awards_Ceremony_Checkins_Aggregate_Fields = {
  __typename?: 'awards_ceremony_checkins_aggregate_fields';
  avg?: Maybe<Awards_Ceremony_Checkins_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Awards_Ceremony_Checkins_Max_Fields>;
  min?: Maybe<Awards_Ceremony_Checkins_Min_Fields>;
  stddev?: Maybe<Awards_Ceremony_Checkins_Stddev_Fields>;
  stddev_pop?: Maybe<Awards_Ceremony_Checkins_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Awards_Ceremony_Checkins_Stddev_Samp_Fields>;
  sum?: Maybe<Awards_Ceremony_Checkins_Sum_Fields>;
  var_pop?: Maybe<Awards_Ceremony_Checkins_Var_Pop_Fields>;
  var_samp?: Maybe<Awards_Ceremony_Checkins_Var_Samp_Fields>;
  variance?: Maybe<Awards_Ceremony_Checkins_Variance_Fields>;
};


/** aggregate fields of "awards_ceremony_checkins" */
export type Awards_Ceremony_Checkins_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Awards_Ceremony_Checkins_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Awards_Ceremony_Checkins_Avg_Fields = {
  __typename?: 'awards_ceremony_checkins_avg_fields';
  festival_submission_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "awards_ceremony_checkins". All fields are combined with a logical 'AND'. */
export type Awards_Ceremony_Checkins_Bool_Exp = {
  _and?: InputMaybe<Array<Awards_Ceremony_Checkins_Bool_Exp>>;
  _not?: InputMaybe<Awards_Ceremony_Checkins_Bool_Exp>;
  _or?: InputMaybe<Array<Awards_Ceremony_Checkins_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  festival_submission?: InputMaybe<Festival_Submissions_Bool_Exp>;
  festival_submission_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Int_Comparison_Exp>;
  team_membership?: InputMaybe<Team_Memberships_Bool_Exp>;
  team_membership_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "awards_ceremony_checkins" */
export enum Awards_Ceremony_Checkins_Constraint {
  /** unique or primary key constraint on columns "id" */
  AwardsCeremonyCheckinsPkey = 'awards_ceremony_checkins_pkey'
}

/** input type for incrementing numeric columns in table "awards_ceremony_checkins" */
export type Awards_Ceremony_Checkins_Inc_Input = {
  festival_submission_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
  team_membership_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "awards_ceremony_checkins" */
export type Awards_Ceremony_Checkins_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  festival_submission?: InputMaybe<Festival_Submissions_Obj_Rel_Insert_Input>;
  festival_submission_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['Int']>;
  team_membership?: InputMaybe<Team_Memberships_Obj_Rel_Insert_Input>;
  team_membership_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Awards_Ceremony_Checkins_Max_Fields = {
  __typename?: 'awards_ceremony_checkins_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  festival_submission_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['Int']>;
  team_membership_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Awards_Ceremony_Checkins_Min_Fields = {
  __typename?: 'awards_ceremony_checkins_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  festival_submission_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['Int']>;
  team_membership_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "awards_ceremony_checkins" */
export type Awards_Ceremony_Checkins_Mutation_Response = {
  __typename?: 'awards_ceremony_checkins_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Awards_Ceremony_Checkins>;
};

/** on_conflict condition type for table "awards_ceremony_checkins" */
export type Awards_Ceremony_Checkins_On_Conflict = {
  constraint: Awards_Ceremony_Checkins_Constraint;
  update_columns?: Array<Awards_Ceremony_Checkins_Update_Column>;
  where?: InputMaybe<Awards_Ceremony_Checkins_Bool_Exp>;
};

/** Ordering options when selecting data from "awards_ceremony_checkins". */
export type Awards_Ceremony_Checkins_Order_By = {
  created_at?: InputMaybe<Order_By>;
  festival_submission?: InputMaybe<Festival_Submissions_Order_By>;
  festival_submission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  team_membership?: InputMaybe<Team_Memberships_Order_By>;
  team_membership_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: awards_ceremony_checkins */
export type Awards_Ceremony_Checkins_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "awards_ceremony_checkins" */
export enum Awards_Ceremony_Checkins_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FestivalSubmissionId = 'festival_submission_id',
  /** column name */
  Id = 'id',
  /** column name */
  Phone = 'phone',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TeamMembershipId = 'team_membership_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "awards_ceremony_checkins" */
export type Awards_Ceremony_Checkins_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  festival_submission_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  team_id?: InputMaybe<Scalars['Int']>;
  team_membership_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Awards_Ceremony_Checkins_Stddev_Fields = {
  __typename?: 'awards_ceremony_checkins_stddev_fields';
  festival_submission_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Awards_Ceremony_Checkins_Stddev_Pop_Fields = {
  __typename?: 'awards_ceremony_checkins_stddev_pop_fields';
  festival_submission_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Awards_Ceremony_Checkins_Stddev_Samp_Fields = {
  __typename?: 'awards_ceremony_checkins_stddev_samp_fields';
  festival_submission_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "awards_ceremony_checkins" */
export type Awards_Ceremony_Checkins_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Awards_Ceremony_Checkins_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Awards_Ceremony_Checkins_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  festival_submission_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  team_id?: InputMaybe<Scalars['Int']>;
  team_membership_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Awards_Ceremony_Checkins_Sum_Fields = {
  __typename?: 'awards_ceremony_checkins_sum_fields';
  festival_submission_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
  team_membership_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "awards_ceremony_checkins" */
export enum Awards_Ceremony_Checkins_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FestivalSubmissionId = 'festival_submission_id',
  /** column name */
  Id = 'id',
  /** column name */
  Phone = 'phone',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TeamMembershipId = 'team_membership_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Awards_Ceremony_Checkins_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Awards_Ceremony_Checkins_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Awards_Ceremony_Checkins_Set_Input>;
  /** filter the rows which have to be updated */
  where: Awards_Ceremony_Checkins_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Awards_Ceremony_Checkins_Var_Pop_Fields = {
  __typename?: 'awards_ceremony_checkins_var_pop_fields';
  festival_submission_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Awards_Ceremony_Checkins_Var_Samp_Fields = {
  __typename?: 'awards_ceremony_checkins_var_samp_fields';
  festival_submission_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Awards_Ceremony_Checkins_Variance_Fields = {
  __typename?: 'awards_ceremony_checkins_variance_fields';
  festival_submission_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
};

/** unique or primary key constraints on table "awards" */
export enum Awards_Constraint {
  /** unique or primary key constraint on columns "id" */
  AwardsPkey = 'awards_pkey'
}

/** input type for incrementing numeric columns in table "awards" */
export type Awards_Inc_Input = {
  id?: InputMaybe<Scalars['numeric']>;
  max_nominations?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "awards" */
export type Awards_Insert_Input = {
  award_nominations?: InputMaybe<Award_Nominations_Arr_Rel_Insert_Input>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  max_nominations?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nominations?: InputMaybe<Nominations_Arr_Rel_Insert_Input>;
  required_asset_types?: InputMaybe<Award_Asset_Types_Arr_Rel_Insert_Input>;
  selection_metrics?: InputMaybe<Selection_Metrics_Arr_Rel_Insert_Input>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Awards_Max_Fields = {
  __typename?: 'awards_max_fields';
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  max_nominations?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Awards_Min_Fields = {
  __typename?: 'awards_min_fields';
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  max_nominations?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "awards" */
export type Awards_Mutation_Response = {
  __typename?: 'awards_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Awards>;
};

/** input type for inserting object relation for remote table "awards" */
export type Awards_Obj_Rel_Insert_Input = {
  data: Awards_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Awards_On_Conflict>;
};

/** on_conflict condition type for table "awards" */
export type Awards_On_Conflict = {
  constraint: Awards_Constraint;
  update_columns?: Array<Awards_Update_Column>;
  where?: InputMaybe<Awards_Bool_Exp>;
};

/** Ordering options when selecting data from "awards". */
export type Awards_Order_By = {
  award_nominations_aggregate?: InputMaybe<Award_Nominations_Aggregate_Order_By>;
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_nominations?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  nominations_aggregate?: InputMaybe<Nominations_Aggregate_Order_By>;
  required_asset_types_aggregate?: InputMaybe<Award_Asset_Types_Aggregate_Order_By>;
  selection_metrics_aggregate?: InputMaybe<Selection_Metrics_Aggregate_Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: awards */
export type Awards_Pk_Columns_Input = {
  id: Scalars['numeric'];
};

/** select columns of table "awards" */
export enum Awards_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  MaxNominations = 'max_nominations',
  /** column name */
  Name = 'name',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** input type for updating data in table "awards" */
export type Awards_Set_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  max_nominations?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Awards_Stddev_Fields = {
  __typename?: 'awards_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  max_nominations?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Awards_Stddev_Pop_Fields = {
  __typename?: 'awards_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  max_nominations?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Awards_Stddev_Samp_Fields = {
  __typename?: 'awards_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  max_nominations?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "awards" */
export type Awards_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Awards_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Awards_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  max_nominations?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Awards_Sum_Fields = {
  __typename?: 'awards_sum_fields';
  id?: Maybe<Scalars['numeric']>;
  max_nominations?: Maybe<Scalars['Int']>;
};

/** update columns of table "awards" */
export enum Awards_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  MaxNominations = 'max_nominations',
  /** column name */
  Name = 'name',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by'
}

export type Awards_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Awards_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Awards_Set_Input>;
  /** filter the rows which have to be updated */
  where: Awards_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Awards_Var_Pop_Fields = {
  __typename?: 'awards_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  max_nominations?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Awards_Var_Samp_Fields = {
  __typename?: 'awards_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  max_nominations?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Awards_Variance_Fields = {
  __typename?: 'awards_variance_fields';
  id?: Maybe<Scalars['Float']>;
  max_nominations?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** columns and relationships of "countries" */
export type Countries = {
  __typename?: 'countries';
  code?: Maybe<Scalars['String']>;
  id: Scalars['numeric'];
  name?: Maybe<Scalars['String']>;
};

/** aggregated selection of "countries" */
export type Countries_Aggregate = {
  __typename?: 'countries_aggregate';
  aggregate?: Maybe<Countries_Aggregate_Fields>;
  nodes: Array<Countries>;
};

/** aggregate fields of "countries" */
export type Countries_Aggregate_Fields = {
  __typename?: 'countries_aggregate_fields';
  avg?: Maybe<Countries_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Countries_Max_Fields>;
  min?: Maybe<Countries_Min_Fields>;
  stddev?: Maybe<Countries_Stddev_Fields>;
  stddev_pop?: Maybe<Countries_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Countries_Stddev_Samp_Fields>;
  sum?: Maybe<Countries_Sum_Fields>;
  var_pop?: Maybe<Countries_Var_Pop_Fields>;
  var_samp?: Maybe<Countries_Var_Samp_Fields>;
  variance?: Maybe<Countries_Variance_Fields>;
};


/** aggregate fields of "countries" */
export type Countries_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Countries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Countries_Avg_Fields = {
  __typename?: 'countries_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "countries". All fields are combined with a logical 'AND'. */
export type Countries_Bool_Exp = {
  _and?: InputMaybe<Array<Countries_Bool_Exp>>;
  _not?: InputMaybe<Countries_Bool_Exp>;
  _or?: InputMaybe<Array<Countries_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Numeric_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "countries" */
export enum Countries_Constraint {
  /** unique or primary key constraint on columns "id" */
  CountriesPkey = 'countries_pkey'
}

/** input type for incrementing numeric columns in table "countries" */
export type Countries_Inc_Input = {
  id?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "countries" */
export type Countries_Insert_Input = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Countries_Max_Fields = {
  __typename?: 'countries_max_fields';
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Countries_Min_Fields = {
  __typename?: 'countries_min_fields';
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "countries" */
export type Countries_Mutation_Response = {
  __typename?: 'countries_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Countries>;
};

/** on_conflict condition type for table "countries" */
export type Countries_On_Conflict = {
  constraint: Countries_Constraint;
  update_columns?: Array<Countries_Update_Column>;
  where?: InputMaybe<Countries_Bool_Exp>;
};

/** Ordering options when selecting data from "countries". */
export type Countries_Order_By = {
  code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: countries */
export type Countries_Pk_Columns_Input = {
  id: Scalars['numeric'];
};

/** select columns of table "countries" */
export enum Countries_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "countries" */
export type Countries_Set_Input = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Countries_Stddev_Fields = {
  __typename?: 'countries_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Countries_Stddev_Pop_Fields = {
  __typename?: 'countries_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Countries_Stddev_Samp_Fields = {
  __typename?: 'countries_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "countries" */
export type Countries_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Countries_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Countries_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Countries_Sum_Fields = {
  __typename?: 'countries_sum_fields';
  id?: Maybe<Scalars['numeric']>;
};

/** update columns of table "countries" */
export enum Countries_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Countries_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Countries_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Countries_Set_Input>;
  /** filter the rows which have to be updated */
  where: Countries_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Countries_Var_Pop_Fields = {
  __typename?: 'countries_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Countries_Var_Samp_Fields = {
  __typename?: 'countries_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Countries_Variance_Fields = {
  __typename?: 'countries_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "exit_interview_recordings" */
export type Exit_Interview_Recordings = {
  __typename?: 'exit_interview_recordings';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  exit_interview: Exit_Interviews;
  exit_interview_id: Scalars['Int'];
  id: Scalars['Int'];
  mux_asset_id: Scalars['String'];
  mux_playback_id: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "exit_interview_recordings" */
export type Exit_Interview_Recordings_Aggregate = {
  __typename?: 'exit_interview_recordings_aggregate';
  aggregate?: Maybe<Exit_Interview_Recordings_Aggregate_Fields>;
  nodes: Array<Exit_Interview_Recordings>;
};

export type Exit_Interview_Recordings_Aggregate_Bool_Exp = {
  count?: InputMaybe<Exit_Interview_Recordings_Aggregate_Bool_Exp_Count>;
};

export type Exit_Interview_Recordings_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Exit_Interview_Recordings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Exit_Interview_Recordings_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "exit_interview_recordings" */
export type Exit_Interview_Recordings_Aggregate_Fields = {
  __typename?: 'exit_interview_recordings_aggregate_fields';
  avg?: Maybe<Exit_Interview_Recordings_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Exit_Interview_Recordings_Max_Fields>;
  min?: Maybe<Exit_Interview_Recordings_Min_Fields>;
  stddev?: Maybe<Exit_Interview_Recordings_Stddev_Fields>;
  stddev_pop?: Maybe<Exit_Interview_Recordings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Exit_Interview_Recordings_Stddev_Samp_Fields>;
  sum?: Maybe<Exit_Interview_Recordings_Sum_Fields>;
  var_pop?: Maybe<Exit_Interview_Recordings_Var_Pop_Fields>;
  var_samp?: Maybe<Exit_Interview_Recordings_Var_Samp_Fields>;
  variance?: Maybe<Exit_Interview_Recordings_Variance_Fields>;
};


/** aggregate fields of "exit_interview_recordings" */
export type Exit_Interview_Recordings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Exit_Interview_Recordings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "exit_interview_recordings" */
export type Exit_Interview_Recordings_Aggregate_Order_By = {
  avg?: InputMaybe<Exit_Interview_Recordings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Exit_Interview_Recordings_Max_Order_By>;
  min?: InputMaybe<Exit_Interview_Recordings_Min_Order_By>;
  stddev?: InputMaybe<Exit_Interview_Recordings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Exit_Interview_Recordings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Exit_Interview_Recordings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Exit_Interview_Recordings_Sum_Order_By>;
  var_pop?: InputMaybe<Exit_Interview_Recordings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Exit_Interview_Recordings_Var_Samp_Order_By>;
  variance?: InputMaybe<Exit_Interview_Recordings_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "exit_interview_recordings" */
export type Exit_Interview_Recordings_Arr_Rel_Insert_Input = {
  data: Array<Exit_Interview_Recordings_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Exit_Interview_Recordings_On_Conflict>;
};

/** aggregate avg on columns */
export type Exit_Interview_Recordings_Avg_Fields = {
  __typename?: 'exit_interview_recordings_avg_fields';
  exit_interview_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "exit_interview_recordings" */
export type Exit_Interview_Recordings_Avg_Order_By = {
  exit_interview_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "exit_interview_recordings". All fields are combined with a logical 'AND'. */
export type Exit_Interview_Recordings_Bool_Exp = {
  _and?: InputMaybe<Array<Exit_Interview_Recordings_Bool_Exp>>;
  _not?: InputMaybe<Exit_Interview_Recordings_Bool_Exp>;
  _or?: InputMaybe<Array<Exit_Interview_Recordings_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  exit_interview?: InputMaybe<Exit_Interviews_Bool_Exp>;
  exit_interview_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  mux_asset_id?: InputMaybe<String_Comparison_Exp>;
  mux_playback_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "exit_interview_recordings" */
export enum Exit_Interview_Recordings_Constraint {
  /** unique or primary key constraint on columns "id" */
  ExitInterviewRecordingsPkey = 'exit_interview_recordings_pkey'
}

/** input type for incrementing numeric columns in table "exit_interview_recordings" */
export type Exit_Interview_Recordings_Inc_Input = {
  exit_interview_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "exit_interview_recordings" */
export type Exit_Interview_Recordings_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  exit_interview?: InputMaybe<Exit_Interviews_Obj_Rel_Insert_Input>;
  exit_interview_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  mux_asset_id?: InputMaybe<Scalars['String']>;
  mux_playback_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Exit_Interview_Recordings_Max_Fields = {
  __typename?: 'exit_interview_recordings_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  exit_interview_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  mux_asset_id?: Maybe<Scalars['String']>;
  mux_playback_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "exit_interview_recordings" */
export type Exit_Interview_Recordings_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  exit_interview_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mux_asset_id?: InputMaybe<Order_By>;
  mux_playback_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Exit_Interview_Recordings_Min_Fields = {
  __typename?: 'exit_interview_recordings_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  exit_interview_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  mux_asset_id?: Maybe<Scalars['String']>;
  mux_playback_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "exit_interview_recordings" */
export type Exit_Interview_Recordings_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  exit_interview_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mux_asset_id?: InputMaybe<Order_By>;
  mux_playback_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "exit_interview_recordings" */
export type Exit_Interview_Recordings_Mutation_Response = {
  __typename?: 'exit_interview_recordings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Exit_Interview_Recordings>;
};

/** on_conflict condition type for table "exit_interview_recordings" */
export type Exit_Interview_Recordings_On_Conflict = {
  constraint: Exit_Interview_Recordings_Constraint;
  update_columns?: Array<Exit_Interview_Recordings_Update_Column>;
  where?: InputMaybe<Exit_Interview_Recordings_Bool_Exp>;
};

/** Ordering options when selecting data from "exit_interview_recordings". */
export type Exit_Interview_Recordings_Order_By = {
  created_at?: InputMaybe<Order_By>;
  exit_interview?: InputMaybe<Exit_Interviews_Order_By>;
  exit_interview_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mux_asset_id?: InputMaybe<Order_By>;
  mux_playback_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: exit_interview_recordings */
export type Exit_Interview_Recordings_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "exit_interview_recordings" */
export enum Exit_Interview_Recordings_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExitInterviewId = 'exit_interview_id',
  /** column name */
  Id = 'id',
  /** column name */
  MuxAssetId = 'mux_asset_id',
  /** column name */
  MuxPlaybackId = 'mux_playback_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "exit_interview_recordings" */
export type Exit_Interview_Recordings_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  exit_interview_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  mux_asset_id?: InputMaybe<Scalars['String']>;
  mux_playback_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Exit_Interview_Recordings_Stddev_Fields = {
  __typename?: 'exit_interview_recordings_stddev_fields';
  exit_interview_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "exit_interview_recordings" */
export type Exit_Interview_Recordings_Stddev_Order_By = {
  exit_interview_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Exit_Interview_Recordings_Stddev_Pop_Fields = {
  __typename?: 'exit_interview_recordings_stddev_pop_fields';
  exit_interview_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "exit_interview_recordings" */
export type Exit_Interview_Recordings_Stddev_Pop_Order_By = {
  exit_interview_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Exit_Interview_Recordings_Stddev_Samp_Fields = {
  __typename?: 'exit_interview_recordings_stddev_samp_fields';
  exit_interview_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "exit_interview_recordings" */
export type Exit_Interview_Recordings_Stddev_Samp_Order_By = {
  exit_interview_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "exit_interview_recordings" */
export type Exit_Interview_Recordings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Exit_Interview_Recordings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Exit_Interview_Recordings_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  exit_interview_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  mux_asset_id?: InputMaybe<Scalars['String']>;
  mux_playback_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Exit_Interview_Recordings_Sum_Fields = {
  __typename?: 'exit_interview_recordings_sum_fields';
  exit_interview_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "exit_interview_recordings" */
export type Exit_Interview_Recordings_Sum_Order_By = {
  exit_interview_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "exit_interview_recordings" */
export enum Exit_Interview_Recordings_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExitInterviewId = 'exit_interview_id',
  /** column name */
  Id = 'id',
  /** column name */
  MuxAssetId = 'mux_asset_id',
  /** column name */
  MuxPlaybackId = 'mux_playback_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Exit_Interview_Recordings_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Exit_Interview_Recordings_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Exit_Interview_Recordings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Exit_Interview_Recordings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Exit_Interview_Recordings_Var_Pop_Fields = {
  __typename?: 'exit_interview_recordings_var_pop_fields';
  exit_interview_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "exit_interview_recordings" */
export type Exit_Interview_Recordings_Var_Pop_Order_By = {
  exit_interview_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Exit_Interview_Recordings_Var_Samp_Fields = {
  __typename?: 'exit_interview_recordings_var_samp_fields';
  exit_interview_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "exit_interview_recordings" */
export type Exit_Interview_Recordings_Var_Samp_Order_By = {
  exit_interview_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Exit_Interview_Recordings_Variance_Fields = {
  __typename?: 'exit_interview_recordings_variance_fields';
  exit_interview_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "exit_interview_recordings" */
export type Exit_Interview_Recordings_Variance_Order_By = {
  exit_interview_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "exit_interviews" */
export type Exit_Interviews = {
  __typename?: 'exit_interviews';
  claimed_by?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  /** An object relationship */
  interviewer?: Maybe<Users>;
  live_kit_room_status?: Maybe<Scalars['String']>;
  mux_broadcast_id?: Maybe<Scalars['String']>;
  mux_live_stream_id: Scalars['String'];
  mux_live_stream_key?: Maybe<Scalars['String']>;
  mux_live_stream_playback_id?: Maybe<Scalars['String']>;
  mux_live_stream_status?: Maybe<Scalars['String']>;
  mux_space_id?: Maybe<Scalars['String']>;
  mux_space_status?: Maybe<Scalars['String']>;
  ready_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  recordings: Array<Exit_Interview_Recordings>;
  /** An aggregate relationship */
  recordings_aggregate: Exit_Interview_Recordings_Aggregate;
  /** An object relationship */
  team: Teams;
  team_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "exit_interviews" */
export type Exit_InterviewsRecordingsArgs = {
  distinct_on?: InputMaybe<Array<Exit_Interview_Recordings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exit_Interview_Recordings_Order_By>>;
  where?: InputMaybe<Exit_Interview_Recordings_Bool_Exp>;
};


/** columns and relationships of "exit_interviews" */
export type Exit_InterviewsRecordings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exit_Interview_Recordings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exit_Interview_Recordings_Order_By>>;
  where?: InputMaybe<Exit_Interview_Recordings_Bool_Exp>;
};

/** aggregated selection of "exit_interviews" */
export type Exit_Interviews_Aggregate = {
  __typename?: 'exit_interviews_aggregate';
  aggregate?: Maybe<Exit_Interviews_Aggregate_Fields>;
  nodes: Array<Exit_Interviews>;
};

/** aggregate fields of "exit_interviews" */
export type Exit_Interviews_Aggregate_Fields = {
  __typename?: 'exit_interviews_aggregate_fields';
  avg?: Maybe<Exit_Interviews_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Exit_Interviews_Max_Fields>;
  min?: Maybe<Exit_Interviews_Min_Fields>;
  stddev?: Maybe<Exit_Interviews_Stddev_Fields>;
  stddev_pop?: Maybe<Exit_Interviews_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Exit_Interviews_Stddev_Samp_Fields>;
  sum?: Maybe<Exit_Interviews_Sum_Fields>;
  var_pop?: Maybe<Exit_Interviews_Var_Pop_Fields>;
  var_samp?: Maybe<Exit_Interviews_Var_Samp_Fields>;
  variance?: Maybe<Exit_Interviews_Variance_Fields>;
};


/** aggregate fields of "exit_interviews" */
export type Exit_Interviews_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Exit_Interviews_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Exit_Interviews_Avg_Fields = {
  __typename?: 'exit_interviews_avg_fields';
  claimed_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "exit_interviews". All fields are combined with a logical 'AND'. */
export type Exit_Interviews_Bool_Exp = {
  _and?: InputMaybe<Array<Exit_Interviews_Bool_Exp>>;
  _not?: InputMaybe<Exit_Interviews_Bool_Exp>;
  _or?: InputMaybe<Array<Exit_Interviews_Bool_Exp>>;
  claimed_by?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  interviewer?: InputMaybe<Users_Bool_Exp>;
  live_kit_room_status?: InputMaybe<String_Comparison_Exp>;
  mux_broadcast_id?: InputMaybe<String_Comparison_Exp>;
  mux_live_stream_id?: InputMaybe<String_Comparison_Exp>;
  mux_live_stream_key?: InputMaybe<String_Comparison_Exp>;
  mux_live_stream_playback_id?: InputMaybe<String_Comparison_Exp>;
  mux_live_stream_status?: InputMaybe<String_Comparison_Exp>;
  mux_space_id?: InputMaybe<String_Comparison_Exp>;
  mux_space_status?: InputMaybe<String_Comparison_Exp>;
  ready_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  recordings?: InputMaybe<Exit_Interview_Recordings_Bool_Exp>;
  recordings_aggregate?: InputMaybe<Exit_Interview_Recordings_Aggregate_Bool_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "exit_interviews" */
export enum Exit_Interviews_Constraint {
  /** unique or primary key constraint on columns "id" */
  ExitInterviewsPkey = 'exit_interviews_pkey'
}

/** input type for incrementing numeric columns in table "exit_interviews" */
export type Exit_Interviews_Inc_Input = {
  claimed_by?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "exit_interviews" */
export type Exit_Interviews_Insert_Input = {
  claimed_by?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  interviewer?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  live_kit_room_status?: InputMaybe<Scalars['String']>;
  mux_broadcast_id?: InputMaybe<Scalars['String']>;
  mux_live_stream_id?: InputMaybe<Scalars['String']>;
  mux_live_stream_key?: InputMaybe<Scalars['String']>;
  mux_live_stream_playback_id?: InputMaybe<Scalars['String']>;
  mux_live_stream_status?: InputMaybe<Scalars['String']>;
  mux_space_id?: InputMaybe<Scalars['String']>;
  mux_space_status?: InputMaybe<Scalars['String']>;
  ready_at?: InputMaybe<Scalars['timestamptz']>;
  recordings?: InputMaybe<Exit_Interview_Recordings_Arr_Rel_Insert_Input>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Exit_Interviews_Max_Fields = {
  __typename?: 'exit_interviews_max_fields';
  claimed_by?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  live_kit_room_status?: Maybe<Scalars['String']>;
  mux_broadcast_id?: Maybe<Scalars['String']>;
  mux_live_stream_id?: Maybe<Scalars['String']>;
  mux_live_stream_key?: Maybe<Scalars['String']>;
  mux_live_stream_playback_id?: Maybe<Scalars['String']>;
  mux_live_stream_status?: Maybe<Scalars['String']>;
  mux_space_id?: Maybe<Scalars['String']>;
  mux_space_status?: Maybe<Scalars['String']>;
  ready_at?: Maybe<Scalars['timestamptz']>;
  team_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Exit_Interviews_Min_Fields = {
  __typename?: 'exit_interviews_min_fields';
  claimed_by?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  live_kit_room_status?: Maybe<Scalars['String']>;
  mux_broadcast_id?: Maybe<Scalars['String']>;
  mux_live_stream_id?: Maybe<Scalars['String']>;
  mux_live_stream_key?: Maybe<Scalars['String']>;
  mux_live_stream_playback_id?: Maybe<Scalars['String']>;
  mux_live_stream_status?: Maybe<Scalars['String']>;
  mux_space_id?: Maybe<Scalars['String']>;
  mux_space_status?: Maybe<Scalars['String']>;
  ready_at?: Maybe<Scalars['timestamptz']>;
  team_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "exit_interviews" */
export type Exit_Interviews_Mutation_Response = {
  __typename?: 'exit_interviews_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Exit_Interviews>;
};

/** input type for inserting object relation for remote table "exit_interviews" */
export type Exit_Interviews_Obj_Rel_Insert_Input = {
  data: Exit_Interviews_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Exit_Interviews_On_Conflict>;
};

/** on_conflict condition type for table "exit_interviews" */
export type Exit_Interviews_On_Conflict = {
  constraint: Exit_Interviews_Constraint;
  update_columns?: Array<Exit_Interviews_Update_Column>;
  where?: InputMaybe<Exit_Interviews_Bool_Exp>;
};

/** Ordering options when selecting data from "exit_interviews". */
export type Exit_Interviews_Order_By = {
  claimed_by?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interviewer?: InputMaybe<Users_Order_By>;
  live_kit_room_status?: InputMaybe<Order_By>;
  mux_broadcast_id?: InputMaybe<Order_By>;
  mux_live_stream_id?: InputMaybe<Order_By>;
  mux_live_stream_key?: InputMaybe<Order_By>;
  mux_live_stream_playback_id?: InputMaybe<Order_By>;
  mux_live_stream_status?: InputMaybe<Order_By>;
  mux_space_id?: InputMaybe<Order_By>;
  mux_space_status?: InputMaybe<Order_By>;
  ready_at?: InputMaybe<Order_By>;
  recordings_aggregate?: InputMaybe<Exit_Interview_Recordings_Aggregate_Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: exit_interviews */
export type Exit_Interviews_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "exit_interviews" */
export enum Exit_Interviews_Select_Column {
  /** column name */
  ClaimedBy = 'claimed_by',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LiveKitRoomStatus = 'live_kit_room_status',
  /** column name */
  MuxBroadcastId = 'mux_broadcast_id',
  /** column name */
  MuxLiveStreamId = 'mux_live_stream_id',
  /** column name */
  MuxLiveStreamKey = 'mux_live_stream_key',
  /** column name */
  MuxLiveStreamPlaybackId = 'mux_live_stream_playback_id',
  /** column name */
  MuxLiveStreamStatus = 'mux_live_stream_status',
  /** column name */
  MuxSpaceId = 'mux_space_id',
  /** column name */
  MuxSpaceStatus = 'mux_space_status',
  /** column name */
  ReadyAt = 'ready_at',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "exit_interviews" */
export type Exit_Interviews_Set_Input = {
  claimed_by?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  live_kit_room_status?: InputMaybe<Scalars['String']>;
  mux_broadcast_id?: InputMaybe<Scalars['String']>;
  mux_live_stream_id?: InputMaybe<Scalars['String']>;
  mux_live_stream_key?: InputMaybe<Scalars['String']>;
  mux_live_stream_playback_id?: InputMaybe<Scalars['String']>;
  mux_live_stream_status?: InputMaybe<Scalars['String']>;
  mux_space_id?: InputMaybe<Scalars['String']>;
  mux_space_status?: InputMaybe<Scalars['String']>;
  ready_at?: InputMaybe<Scalars['timestamptz']>;
  team_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Exit_Interviews_Stddev_Fields = {
  __typename?: 'exit_interviews_stddev_fields';
  claimed_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Exit_Interviews_Stddev_Pop_Fields = {
  __typename?: 'exit_interviews_stddev_pop_fields';
  claimed_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Exit_Interviews_Stddev_Samp_Fields = {
  __typename?: 'exit_interviews_stddev_samp_fields';
  claimed_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "exit_interviews" */
export type Exit_Interviews_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Exit_Interviews_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Exit_Interviews_Stream_Cursor_Value_Input = {
  claimed_by?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  live_kit_room_status?: InputMaybe<Scalars['String']>;
  mux_broadcast_id?: InputMaybe<Scalars['String']>;
  mux_live_stream_id?: InputMaybe<Scalars['String']>;
  mux_live_stream_key?: InputMaybe<Scalars['String']>;
  mux_live_stream_playback_id?: InputMaybe<Scalars['String']>;
  mux_live_stream_status?: InputMaybe<Scalars['String']>;
  mux_space_id?: InputMaybe<Scalars['String']>;
  mux_space_status?: InputMaybe<Scalars['String']>;
  ready_at?: InputMaybe<Scalars['timestamptz']>;
  team_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Exit_Interviews_Sum_Fields = {
  __typename?: 'exit_interviews_sum_fields';
  claimed_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "exit_interviews" */
export enum Exit_Interviews_Update_Column {
  /** column name */
  ClaimedBy = 'claimed_by',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LiveKitRoomStatus = 'live_kit_room_status',
  /** column name */
  MuxBroadcastId = 'mux_broadcast_id',
  /** column name */
  MuxLiveStreamId = 'mux_live_stream_id',
  /** column name */
  MuxLiveStreamKey = 'mux_live_stream_key',
  /** column name */
  MuxLiveStreamPlaybackId = 'mux_live_stream_playback_id',
  /** column name */
  MuxLiveStreamStatus = 'mux_live_stream_status',
  /** column name */
  MuxSpaceId = 'mux_space_id',
  /** column name */
  MuxSpaceStatus = 'mux_space_status',
  /** column name */
  ReadyAt = 'ready_at',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Exit_Interviews_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Exit_Interviews_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Exit_Interviews_Set_Input>;
  /** filter the rows which have to be updated */
  where: Exit_Interviews_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Exit_Interviews_Var_Pop_Fields = {
  __typename?: 'exit_interviews_var_pop_fields';
  claimed_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Exit_Interviews_Var_Samp_Fields = {
  __typename?: 'exit_interviews_var_samp_fields';
  claimed_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Exit_Interviews_Variance_Fields = {
  __typename?: 'exit_interviews_variance_fields';
  claimed_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "expertise" */
export type Expertise = {
  __typename?: 'expertise';
  description?: Maybe<Scalars['String']>;
  id: Scalars['numeric'];
  name: Scalars['String'];
};

/** aggregated selection of "expertise" */
export type Expertise_Aggregate = {
  __typename?: 'expertise_aggregate';
  aggregate?: Maybe<Expertise_Aggregate_Fields>;
  nodes: Array<Expertise>;
};

/** aggregate fields of "expertise" */
export type Expertise_Aggregate_Fields = {
  __typename?: 'expertise_aggregate_fields';
  avg?: Maybe<Expertise_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Expertise_Max_Fields>;
  min?: Maybe<Expertise_Min_Fields>;
  stddev?: Maybe<Expertise_Stddev_Fields>;
  stddev_pop?: Maybe<Expertise_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Expertise_Stddev_Samp_Fields>;
  sum?: Maybe<Expertise_Sum_Fields>;
  var_pop?: Maybe<Expertise_Var_Pop_Fields>;
  var_samp?: Maybe<Expertise_Var_Samp_Fields>;
  variance?: Maybe<Expertise_Variance_Fields>;
};


/** aggregate fields of "expertise" */
export type Expertise_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Expertise_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Expertise_Avg_Fields = {
  __typename?: 'expertise_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "expertise". All fields are combined with a logical 'AND'. */
export type Expertise_Bool_Exp = {
  _and?: InputMaybe<Array<Expertise_Bool_Exp>>;
  _not?: InputMaybe<Expertise_Bool_Exp>;
  _or?: InputMaybe<Array<Expertise_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Numeric_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "expertise" */
export enum Expertise_Constraint {
  /** unique or primary key constraint on columns "id" */
  ExpertisePkey = 'expertise_pkey'
}

/** input type for incrementing numeric columns in table "expertise" */
export type Expertise_Inc_Input = {
  id?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "expertise" */
export type Expertise_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Expertise_Max_Fields = {
  __typename?: 'expertise_max_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Expertise_Min_Fields = {
  __typename?: 'expertise_min_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "expertise" */
export type Expertise_Mutation_Response = {
  __typename?: 'expertise_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Expertise>;
};

/** on_conflict condition type for table "expertise" */
export type Expertise_On_Conflict = {
  constraint: Expertise_Constraint;
  update_columns?: Array<Expertise_Update_Column>;
  where?: InputMaybe<Expertise_Bool_Exp>;
};

/** Ordering options when selecting data from "expertise". */
export type Expertise_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: expertise */
export type Expertise_Pk_Columns_Input = {
  id: Scalars['numeric'];
};

/** select columns of table "expertise" */
export enum Expertise_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "expertise" */
export type Expertise_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Expertise_Stddev_Fields = {
  __typename?: 'expertise_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Expertise_Stddev_Pop_Fields = {
  __typename?: 'expertise_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Expertise_Stddev_Samp_Fields = {
  __typename?: 'expertise_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "expertise" */
export type Expertise_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Expertise_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Expertise_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Expertise_Sum_Fields = {
  __typename?: 'expertise_sum_fields';
  id?: Maybe<Scalars['numeric']>;
};

/** update columns of table "expertise" */
export enum Expertise_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Expertise_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Expertise_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Expertise_Set_Input>;
  /** filter the rows which have to be updated */
  where: Expertise_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Expertise_Var_Pop_Fields = {
  __typename?: 'expertise_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Expertise_Var_Samp_Fields = {
  __typename?: 'expertise_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Expertise_Variance_Fields = {
  __typename?: 'expertise_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "festival_badge_type_event_type" */
export type Festival_Badge_Type_Event_Type = {
  __typename?: 'festival_badge_type_event_type';
  created_at: Scalars['timestamptz'];
  credits: Scalars['Int'];
  /** An object relationship */
  festival_badge_type: Festival_Badge_Types;
  festival_badge_type_id: Scalars['Int'];
  /** An object relationship */
  festival_event_type: Festival_Event_Types;
  festival_event_type_id: Scalars['Int'];
  id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "festival_badge_type_event_type" */
export type Festival_Badge_Type_Event_Type_Aggregate = {
  __typename?: 'festival_badge_type_event_type_aggregate';
  aggregate?: Maybe<Festival_Badge_Type_Event_Type_Aggregate_Fields>;
  nodes: Array<Festival_Badge_Type_Event_Type>;
};

export type Festival_Badge_Type_Event_Type_Aggregate_Bool_Exp = {
  count?: InputMaybe<Festival_Badge_Type_Event_Type_Aggregate_Bool_Exp_Count>;
};

export type Festival_Badge_Type_Event_Type_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Festival_Badge_Type_Event_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Festival_Badge_Type_Event_Type_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "festival_badge_type_event_type" */
export type Festival_Badge_Type_Event_Type_Aggregate_Fields = {
  __typename?: 'festival_badge_type_event_type_aggregate_fields';
  avg?: Maybe<Festival_Badge_Type_Event_Type_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Festival_Badge_Type_Event_Type_Max_Fields>;
  min?: Maybe<Festival_Badge_Type_Event_Type_Min_Fields>;
  stddev?: Maybe<Festival_Badge_Type_Event_Type_Stddev_Fields>;
  stddev_pop?: Maybe<Festival_Badge_Type_Event_Type_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Festival_Badge_Type_Event_Type_Stddev_Samp_Fields>;
  sum?: Maybe<Festival_Badge_Type_Event_Type_Sum_Fields>;
  var_pop?: Maybe<Festival_Badge_Type_Event_Type_Var_Pop_Fields>;
  var_samp?: Maybe<Festival_Badge_Type_Event_Type_Var_Samp_Fields>;
  variance?: Maybe<Festival_Badge_Type_Event_Type_Variance_Fields>;
};


/** aggregate fields of "festival_badge_type_event_type" */
export type Festival_Badge_Type_Event_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Festival_Badge_Type_Event_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "festival_badge_type_event_type" */
export type Festival_Badge_Type_Event_Type_Aggregate_Order_By = {
  avg?: InputMaybe<Festival_Badge_Type_Event_Type_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Festival_Badge_Type_Event_Type_Max_Order_By>;
  min?: InputMaybe<Festival_Badge_Type_Event_Type_Min_Order_By>;
  stddev?: InputMaybe<Festival_Badge_Type_Event_Type_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Festival_Badge_Type_Event_Type_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Festival_Badge_Type_Event_Type_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Festival_Badge_Type_Event_Type_Sum_Order_By>;
  var_pop?: InputMaybe<Festival_Badge_Type_Event_Type_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Festival_Badge_Type_Event_Type_Var_Samp_Order_By>;
  variance?: InputMaybe<Festival_Badge_Type_Event_Type_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "festival_badge_type_event_type" */
export type Festival_Badge_Type_Event_Type_Arr_Rel_Insert_Input = {
  data: Array<Festival_Badge_Type_Event_Type_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Festival_Badge_Type_Event_Type_On_Conflict>;
};

/** aggregate avg on columns */
export type Festival_Badge_Type_Event_Type_Avg_Fields = {
  __typename?: 'festival_badge_type_event_type_avg_fields';
  credits?: Maybe<Scalars['Float']>;
  festival_badge_type_id?: Maybe<Scalars['Float']>;
  festival_event_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "festival_badge_type_event_type" */
export type Festival_Badge_Type_Event_Type_Avg_Order_By = {
  credits?: InputMaybe<Order_By>;
  festival_badge_type_id?: InputMaybe<Order_By>;
  festival_event_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "festival_badge_type_event_type". All fields are combined with a logical 'AND'. */
export type Festival_Badge_Type_Event_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Festival_Badge_Type_Event_Type_Bool_Exp>>;
  _not?: InputMaybe<Festival_Badge_Type_Event_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Festival_Badge_Type_Event_Type_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credits?: InputMaybe<Int_Comparison_Exp>;
  festival_badge_type?: InputMaybe<Festival_Badge_Types_Bool_Exp>;
  festival_badge_type_id?: InputMaybe<Int_Comparison_Exp>;
  festival_event_type?: InputMaybe<Festival_Event_Types_Bool_Exp>;
  festival_event_type_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "festival_badge_type_event_type" */
export enum Festival_Badge_Type_Event_Type_Constraint {
  /** unique or primary key constraint on columns "festival_event_type_id", "festival_badge_type_id" */
  FestivalBadgeTypeEventTypFestivalBadgeTypeIdFestivKey = 'festival_badge_type_event_typ_festival_badge_type_id_festiv_key',
  /** unique or primary key constraint on columns "id" */
  FestivalBadgeTypeEventTypePkey = 'festival_badge_type_event_type_pkey'
}

/** input type for incrementing numeric columns in table "festival_badge_type_event_type" */
export type Festival_Badge_Type_Event_Type_Inc_Input = {
  credits?: InputMaybe<Scalars['Int']>;
  festival_badge_type_id?: InputMaybe<Scalars['Int']>;
  festival_event_type_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "festival_badge_type_event_type" */
export type Festival_Badge_Type_Event_Type_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  credits?: InputMaybe<Scalars['Int']>;
  festival_badge_type?: InputMaybe<Festival_Badge_Types_Obj_Rel_Insert_Input>;
  festival_badge_type_id?: InputMaybe<Scalars['Int']>;
  festival_event_type?: InputMaybe<Festival_Event_Types_Obj_Rel_Insert_Input>;
  festival_event_type_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Festival_Badge_Type_Event_Type_Max_Fields = {
  __typename?: 'festival_badge_type_event_type_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  credits?: Maybe<Scalars['Int']>;
  festival_badge_type_id?: Maybe<Scalars['Int']>;
  festival_event_type_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "festival_badge_type_event_type" */
export type Festival_Badge_Type_Event_Type_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  credits?: InputMaybe<Order_By>;
  festival_badge_type_id?: InputMaybe<Order_By>;
  festival_event_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Festival_Badge_Type_Event_Type_Min_Fields = {
  __typename?: 'festival_badge_type_event_type_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  credits?: Maybe<Scalars['Int']>;
  festival_badge_type_id?: Maybe<Scalars['Int']>;
  festival_event_type_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "festival_badge_type_event_type" */
export type Festival_Badge_Type_Event_Type_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  credits?: InputMaybe<Order_By>;
  festival_badge_type_id?: InputMaybe<Order_By>;
  festival_event_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "festival_badge_type_event_type" */
export type Festival_Badge_Type_Event_Type_Mutation_Response = {
  __typename?: 'festival_badge_type_event_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Festival_Badge_Type_Event_Type>;
};

/** on_conflict condition type for table "festival_badge_type_event_type" */
export type Festival_Badge_Type_Event_Type_On_Conflict = {
  constraint: Festival_Badge_Type_Event_Type_Constraint;
  update_columns?: Array<Festival_Badge_Type_Event_Type_Update_Column>;
  where?: InputMaybe<Festival_Badge_Type_Event_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "festival_badge_type_event_type". */
export type Festival_Badge_Type_Event_Type_Order_By = {
  created_at?: InputMaybe<Order_By>;
  credits?: InputMaybe<Order_By>;
  festival_badge_type?: InputMaybe<Festival_Badge_Types_Order_By>;
  festival_badge_type_id?: InputMaybe<Order_By>;
  festival_event_type?: InputMaybe<Festival_Event_Types_Order_By>;
  festival_event_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: festival_badge_type_event_type */
export type Festival_Badge_Type_Event_Type_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "festival_badge_type_event_type" */
export enum Festival_Badge_Type_Event_Type_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Credits = 'credits',
  /** column name */
  FestivalBadgeTypeId = 'festival_badge_type_id',
  /** column name */
  FestivalEventTypeId = 'festival_event_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "festival_badge_type_event_type" */
export type Festival_Badge_Type_Event_Type_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  credits?: InputMaybe<Scalars['Int']>;
  festival_badge_type_id?: InputMaybe<Scalars['Int']>;
  festival_event_type_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Festival_Badge_Type_Event_Type_Stddev_Fields = {
  __typename?: 'festival_badge_type_event_type_stddev_fields';
  credits?: Maybe<Scalars['Float']>;
  festival_badge_type_id?: Maybe<Scalars['Float']>;
  festival_event_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "festival_badge_type_event_type" */
export type Festival_Badge_Type_Event_Type_Stddev_Order_By = {
  credits?: InputMaybe<Order_By>;
  festival_badge_type_id?: InputMaybe<Order_By>;
  festival_event_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Festival_Badge_Type_Event_Type_Stddev_Pop_Fields = {
  __typename?: 'festival_badge_type_event_type_stddev_pop_fields';
  credits?: Maybe<Scalars['Float']>;
  festival_badge_type_id?: Maybe<Scalars['Float']>;
  festival_event_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "festival_badge_type_event_type" */
export type Festival_Badge_Type_Event_Type_Stddev_Pop_Order_By = {
  credits?: InputMaybe<Order_By>;
  festival_badge_type_id?: InputMaybe<Order_By>;
  festival_event_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Festival_Badge_Type_Event_Type_Stddev_Samp_Fields = {
  __typename?: 'festival_badge_type_event_type_stddev_samp_fields';
  credits?: Maybe<Scalars['Float']>;
  festival_badge_type_id?: Maybe<Scalars['Float']>;
  festival_event_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "festival_badge_type_event_type" */
export type Festival_Badge_Type_Event_Type_Stddev_Samp_Order_By = {
  credits?: InputMaybe<Order_By>;
  festival_badge_type_id?: InputMaybe<Order_By>;
  festival_event_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "festival_badge_type_event_type" */
export type Festival_Badge_Type_Event_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Festival_Badge_Type_Event_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Festival_Badge_Type_Event_Type_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  credits?: InputMaybe<Scalars['Int']>;
  festival_badge_type_id?: InputMaybe<Scalars['Int']>;
  festival_event_type_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Festival_Badge_Type_Event_Type_Sum_Fields = {
  __typename?: 'festival_badge_type_event_type_sum_fields';
  credits?: Maybe<Scalars['Int']>;
  festival_badge_type_id?: Maybe<Scalars['Int']>;
  festival_event_type_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "festival_badge_type_event_type" */
export type Festival_Badge_Type_Event_Type_Sum_Order_By = {
  credits?: InputMaybe<Order_By>;
  festival_badge_type_id?: InputMaybe<Order_By>;
  festival_event_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "festival_badge_type_event_type" */
export enum Festival_Badge_Type_Event_Type_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Credits = 'credits',
  /** column name */
  FestivalBadgeTypeId = 'festival_badge_type_id',
  /** column name */
  FestivalEventTypeId = 'festival_event_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Festival_Badge_Type_Event_Type_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Festival_Badge_Type_Event_Type_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Festival_Badge_Type_Event_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Festival_Badge_Type_Event_Type_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Festival_Badge_Type_Event_Type_Var_Pop_Fields = {
  __typename?: 'festival_badge_type_event_type_var_pop_fields';
  credits?: Maybe<Scalars['Float']>;
  festival_badge_type_id?: Maybe<Scalars['Float']>;
  festival_event_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "festival_badge_type_event_type" */
export type Festival_Badge_Type_Event_Type_Var_Pop_Order_By = {
  credits?: InputMaybe<Order_By>;
  festival_badge_type_id?: InputMaybe<Order_By>;
  festival_event_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Festival_Badge_Type_Event_Type_Var_Samp_Fields = {
  __typename?: 'festival_badge_type_event_type_var_samp_fields';
  credits?: Maybe<Scalars['Float']>;
  festival_badge_type_id?: Maybe<Scalars['Float']>;
  festival_event_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "festival_badge_type_event_type" */
export type Festival_Badge_Type_Event_Type_Var_Samp_Order_By = {
  credits?: InputMaybe<Order_By>;
  festival_badge_type_id?: InputMaybe<Order_By>;
  festival_event_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Festival_Badge_Type_Event_Type_Variance_Fields = {
  __typename?: 'festival_badge_type_event_type_variance_fields';
  credits?: Maybe<Scalars['Float']>;
  festival_badge_type_id?: Maybe<Scalars['Float']>;
  festival_event_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "festival_badge_type_event_type" */
export type Festival_Badge_Type_Event_Type_Variance_Order_By = {
  credits?: InputMaybe<Order_By>;
  festival_badge_type_id?: InputMaybe<Order_By>;
  festival_event_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "festival_badge_types" */
export type Festival_Badge_Types = {
  __typename?: 'festival_badge_types';
  color: Scalars['String'];
  created_at: Scalars['timestamptz'];
  features: Scalars['jsonb'];
  /** An array relationship */
  festival_badge_type_event_types: Array<Festival_Badge_Type_Event_Type>;
  /** An aggregate relationship */
  festival_badge_type_event_types_aggregate: Festival_Badge_Type_Event_Type_Aggregate;
  /** An array relationship */
  festival_badges: Array<Festival_Badges>;
  /** An aggregate relationship */
  festival_badges_aggregate: Festival_Badges_Aggregate;
  /** An object relationship */
  film_festival: Film_Festivals;
  film_festival_id: Scalars['Int'];
  filmmaker_price: Scalars['numeric'];
  filmmaker_price_id: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  price: Scalars['numeric'];
  price_id: Scalars['String'];
  product_id?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  visible: Scalars['Boolean'];
};


/** columns and relationships of "festival_badge_types" */
export type Festival_Badge_TypesFeaturesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "festival_badge_types" */
export type Festival_Badge_TypesFestival_Badge_Type_Event_TypesArgs = {
  distinct_on?: InputMaybe<Array<Festival_Badge_Type_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Badge_Type_Event_Type_Order_By>>;
  where?: InputMaybe<Festival_Badge_Type_Event_Type_Bool_Exp>;
};


/** columns and relationships of "festival_badge_types" */
export type Festival_Badge_TypesFestival_Badge_Type_Event_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Badge_Type_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Badge_Type_Event_Type_Order_By>>;
  where?: InputMaybe<Festival_Badge_Type_Event_Type_Bool_Exp>;
};


/** columns and relationships of "festival_badge_types" */
export type Festival_Badge_TypesFestival_BadgesArgs = {
  distinct_on?: InputMaybe<Array<Festival_Badges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Badges_Order_By>>;
  where?: InputMaybe<Festival_Badges_Bool_Exp>;
};


/** columns and relationships of "festival_badge_types" */
export type Festival_Badge_TypesFestival_Badges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Badges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Badges_Order_By>>;
  where?: InputMaybe<Festival_Badges_Bool_Exp>;
};

/** aggregated selection of "festival_badge_types" */
export type Festival_Badge_Types_Aggregate = {
  __typename?: 'festival_badge_types_aggregate';
  aggregate?: Maybe<Festival_Badge_Types_Aggregate_Fields>;
  nodes: Array<Festival_Badge_Types>;
};

/** aggregate fields of "festival_badge_types" */
export type Festival_Badge_Types_Aggregate_Fields = {
  __typename?: 'festival_badge_types_aggregate_fields';
  avg?: Maybe<Festival_Badge_Types_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Festival_Badge_Types_Max_Fields>;
  min?: Maybe<Festival_Badge_Types_Min_Fields>;
  stddev?: Maybe<Festival_Badge_Types_Stddev_Fields>;
  stddev_pop?: Maybe<Festival_Badge_Types_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Festival_Badge_Types_Stddev_Samp_Fields>;
  sum?: Maybe<Festival_Badge_Types_Sum_Fields>;
  var_pop?: Maybe<Festival_Badge_Types_Var_Pop_Fields>;
  var_samp?: Maybe<Festival_Badge_Types_Var_Samp_Fields>;
  variance?: Maybe<Festival_Badge_Types_Variance_Fields>;
};


/** aggregate fields of "festival_badge_types" */
export type Festival_Badge_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Festival_Badge_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Festival_Badge_Types_Append_Input = {
  features?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Festival_Badge_Types_Avg_Fields = {
  __typename?: 'festival_badge_types_avg_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  filmmaker_price?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "festival_badge_types". All fields are combined with a logical 'AND'. */
export type Festival_Badge_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Festival_Badge_Types_Bool_Exp>>;
  _not?: InputMaybe<Festival_Badge_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Festival_Badge_Types_Bool_Exp>>;
  color?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  features?: InputMaybe<Jsonb_Comparison_Exp>;
  festival_badge_type_event_types?: InputMaybe<Festival_Badge_Type_Event_Type_Bool_Exp>;
  festival_badge_type_event_types_aggregate?: InputMaybe<Festival_Badge_Type_Event_Type_Aggregate_Bool_Exp>;
  festival_badges?: InputMaybe<Festival_Badges_Bool_Exp>;
  festival_badges_aggregate?: InputMaybe<Festival_Badges_Aggregate_Bool_Exp>;
  film_festival?: InputMaybe<Film_Festivals_Bool_Exp>;
  film_festival_id?: InputMaybe<Int_Comparison_Exp>;
  filmmaker_price?: InputMaybe<Numeric_Comparison_Exp>;
  filmmaker_price_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  price_id?: InputMaybe<String_Comparison_Exp>;
  product_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  visible?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "festival_badge_types" */
export enum Festival_Badge_Types_Constraint {
  /** unique or primary key constraint on columns "id" */
  FestivalBadgeTypesPkey = 'festival_badge_types_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Festival_Badge_Types_Delete_At_Path_Input = {
  features?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Festival_Badge_Types_Delete_Elem_Input = {
  features?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Festival_Badge_Types_Delete_Key_Input = {
  features?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "festival_badge_types" */
export type Festival_Badge_Types_Inc_Input = {
  film_festival_id?: InputMaybe<Scalars['Int']>;
  filmmaker_price?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "festival_badge_types" */
export type Festival_Badge_Types_Insert_Input = {
  color?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  features?: InputMaybe<Scalars['jsonb']>;
  festival_badge_type_event_types?: InputMaybe<Festival_Badge_Type_Event_Type_Arr_Rel_Insert_Input>;
  festival_badges?: InputMaybe<Festival_Badges_Arr_Rel_Insert_Input>;
  film_festival?: InputMaybe<Film_Festivals_Obj_Rel_Insert_Input>;
  film_festival_id?: InputMaybe<Scalars['Int']>;
  filmmaker_price?: InputMaybe<Scalars['numeric']>;
  filmmaker_price_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['numeric']>;
  price_id?: InputMaybe<Scalars['String']>;
  product_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Festival_Badge_Types_Max_Fields = {
  __typename?: 'festival_badge_types_max_fields';
  color?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  film_festival_id?: Maybe<Scalars['Int']>;
  filmmaker_price?: Maybe<Scalars['numeric']>;
  filmmaker_price_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['numeric']>;
  price_id?: Maybe<Scalars['String']>;
  product_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Festival_Badge_Types_Min_Fields = {
  __typename?: 'festival_badge_types_min_fields';
  color?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  film_festival_id?: Maybe<Scalars['Int']>;
  filmmaker_price?: Maybe<Scalars['numeric']>;
  filmmaker_price_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['numeric']>;
  price_id?: Maybe<Scalars['String']>;
  product_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "festival_badge_types" */
export type Festival_Badge_Types_Mutation_Response = {
  __typename?: 'festival_badge_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Festival_Badge_Types>;
};

/** input type for inserting object relation for remote table "festival_badge_types" */
export type Festival_Badge_Types_Obj_Rel_Insert_Input = {
  data: Festival_Badge_Types_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Festival_Badge_Types_On_Conflict>;
};

/** on_conflict condition type for table "festival_badge_types" */
export type Festival_Badge_Types_On_Conflict = {
  constraint: Festival_Badge_Types_Constraint;
  update_columns?: Array<Festival_Badge_Types_Update_Column>;
  where?: InputMaybe<Festival_Badge_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "festival_badge_types". */
export type Festival_Badge_Types_Order_By = {
  color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  features?: InputMaybe<Order_By>;
  festival_badge_type_event_types_aggregate?: InputMaybe<Festival_Badge_Type_Event_Type_Aggregate_Order_By>;
  festival_badges_aggregate?: InputMaybe<Festival_Badges_Aggregate_Order_By>;
  film_festival?: InputMaybe<Film_Festivals_Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  filmmaker_price?: InputMaybe<Order_By>;
  filmmaker_price_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  price_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  visible?: InputMaybe<Order_By>;
};

/** primary key columns input for table: festival_badge_types */
export type Festival_Badge_Types_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Festival_Badge_Types_Prepend_Input = {
  features?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "festival_badge_types" */
export enum Festival_Badge_Types_Select_Column {
  /** column name */
  Color = 'color',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Features = 'features',
  /** column name */
  FilmFestivalId = 'film_festival_id',
  /** column name */
  FilmmakerPrice = 'filmmaker_price',
  /** column name */
  FilmmakerPriceId = 'filmmaker_price_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Price = 'price',
  /** column name */
  PriceId = 'price_id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Visible = 'visible'
}

/** input type for updating data in table "festival_badge_types" */
export type Festival_Badge_Types_Set_Input = {
  color?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  features?: InputMaybe<Scalars['jsonb']>;
  film_festival_id?: InputMaybe<Scalars['Int']>;
  filmmaker_price?: InputMaybe<Scalars['numeric']>;
  filmmaker_price_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['numeric']>;
  price_id?: InputMaybe<Scalars['String']>;
  product_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Festival_Badge_Types_Stddev_Fields = {
  __typename?: 'festival_badge_types_stddev_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  filmmaker_price?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Festival_Badge_Types_Stddev_Pop_Fields = {
  __typename?: 'festival_badge_types_stddev_pop_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  filmmaker_price?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Festival_Badge_Types_Stddev_Samp_Fields = {
  __typename?: 'festival_badge_types_stddev_samp_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  filmmaker_price?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "festival_badge_types" */
export type Festival_Badge_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Festival_Badge_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Festival_Badge_Types_Stream_Cursor_Value_Input = {
  color?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  features?: InputMaybe<Scalars['jsonb']>;
  film_festival_id?: InputMaybe<Scalars['Int']>;
  filmmaker_price?: InputMaybe<Scalars['numeric']>;
  filmmaker_price_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['numeric']>;
  price_id?: InputMaybe<Scalars['String']>;
  product_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Festival_Badge_Types_Sum_Fields = {
  __typename?: 'festival_badge_types_sum_fields';
  film_festival_id?: Maybe<Scalars['Int']>;
  filmmaker_price?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['numeric']>;
};

/** update columns of table "festival_badge_types" */
export enum Festival_Badge_Types_Update_Column {
  /** column name */
  Color = 'color',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Features = 'features',
  /** column name */
  FilmFestivalId = 'film_festival_id',
  /** column name */
  FilmmakerPrice = 'filmmaker_price',
  /** column name */
  FilmmakerPriceId = 'filmmaker_price_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Price = 'price',
  /** column name */
  PriceId = 'price_id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Visible = 'visible'
}

export type Festival_Badge_Types_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Festival_Badge_Types_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Festival_Badge_Types_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Festival_Badge_Types_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Festival_Badge_Types_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Festival_Badge_Types_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Festival_Badge_Types_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Festival_Badge_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Festival_Badge_Types_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Festival_Badge_Types_Var_Pop_Fields = {
  __typename?: 'festival_badge_types_var_pop_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  filmmaker_price?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Festival_Badge_Types_Var_Samp_Fields = {
  __typename?: 'festival_badge_types_var_samp_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  filmmaker_price?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Festival_Badge_Types_Variance_Fields = {
  __typename?: 'festival_badge_types_variance_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  filmmaker_price?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "festival_badges" */
export type Festival_Badges = {
  __typename?: 'festival_badges';
  created_at: Scalars['timestamptz'];
  email: Scalars['String'];
  /** An object relationship */
  festival_badge_type: Festival_Badge_Types;
  festival_badge_type_id: Scalars['Int'];
  /** An array relationship */
  festival_tickets: Array<Festival_Tickets>;
  /** An aggregate relationship */
  festival_tickets_aggregate: Festival_Tickets_Aggregate;
  /** An object relationship */
  film_festival: Film_Festivals;
  film_festival_id: Scalars['Int'];
  id: Scalars['Int'];
  issued_at: Scalars['timestamptz'];
  /** An object relationship */
  team?: Maybe<Teams>;
  team_id?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
  user_id?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "festival_badges" */
export type Festival_BadgesFestival_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Festival_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Tickets_Order_By>>;
  where?: InputMaybe<Festival_Tickets_Bool_Exp>;
};


/** columns and relationships of "festival_badges" */
export type Festival_BadgesFestival_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Tickets_Order_By>>;
  where?: InputMaybe<Festival_Tickets_Bool_Exp>;
};

/** aggregated selection of "festival_badges" */
export type Festival_Badges_Aggregate = {
  __typename?: 'festival_badges_aggregate';
  aggregate?: Maybe<Festival_Badges_Aggregate_Fields>;
  nodes: Array<Festival_Badges>;
};

export type Festival_Badges_Aggregate_Bool_Exp = {
  count?: InputMaybe<Festival_Badges_Aggregate_Bool_Exp_Count>;
};

export type Festival_Badges_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Festival_Badges_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Festival_Badges_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "festival_badges" */
export type Festival_Badges_Aggregate_Fields = {
  __typename?: 'festival_badges_aggregate_fields';
  avg?: Maybe<Festival_Badges_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Festival_Badges_Max_Fields>;
  min?: Maybe<Festival_Badges_Min_Fields>;
  stddev?: Maybe<Festival_Badges_Stddev_Fields>;
  stddev_pop?: Maybe<Festival_Badges_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Festival_Badges_Stddev_Samp_Fields>;
  sum?: Maybe<Festival_Badges_Sum_Fields>;
  var_pop?: Maybe<Festival_Badges_Var_Pop_Fields>;
  var_samp?: Maybe<Festival_Badges_Var_Samp_Fields>;
  variance?: Maybe<Festival_Badges_Variance_Fields>;
};


/** aggregate fields of "festival_badges" */
export type Festival_Badges_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Festival_Badges_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "festival_badges" */
export type Festival_Badges_Aggregate_Order_By = {
  avg?: InputMaybe<Festival_Badges_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Festival_Badges_Max_Order_By>;
  min?: InputMaybe<Festival_Badges_Min_Order_By>;
  stddev?: InputMaybe<Festival_Badges_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Festival_Badges_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Festival_Badges_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Festival_Badges_Sum_Order_By>;
  var_pop?: InputMaybe<Festival_Badges_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Festival_Badges_Var_Samp_Order_By>;
  variance?: InputMaybe<Festival_Badges_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "festival_badges" */
export type Festival_Badges_Arr_Rel_Insert_Input = {
  data: Array<Festival_Badges_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Festival_Badges_On_Conflict>;
};

/** aggregate avg on columns */
export type Festival_Badges_Avg_Fields = {
  __typename?: 'festival_badges_avg_fields';
  festival_badge_type_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "festival_badges" */
export type Festival_Badges_Avg_Order_By = {
  festival_badge_type_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "festival_badges". All fields are combined with a logical 'AND'. */
export type Festival_Badges_Bool_Exp = {
  _and?: InputMaybe<Array<Festival_Badges_Bool_Exp>>;
  _not?: InputMaybe<Festival_Badges_Bool_Exp>;
  _or?: InputMaybe<Array<Festival_Badges_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  festival_badge_type?: InputMaybe<Festival_Badge_Types_Bool_Exp>;
  festival_badge_type_id?: InputMaybe<Int_Comparison_Exp>;
  festival_tickets?: InputMaybe<Festival_Tickets_Bool_Exp>;
  festival_tickets_aggregate?: InputMaybe<Festival_Tickets_Aggregate_Bool_Exp>;
  film_festival?: InputMaybe<Film_Festivals_Bool_Exp>;
  film_festival_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  issued_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "festival_badges" */
export enum Festival_Badges_Constraint {
  /** unique or primary key constraint on columns "id" */
  FestivalBadgesPkey = 'festival_badges_pkey'
}

/** input type for incrementing numeric columns in table "festival_badges" */
export type Festival_Badges_Inc_Input = {
  festival_badge_type_id?: InputMaybe<Scalars['Int']>;
  film_festival_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "festival_badges" */
export type Festival_Badges_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  festival_badge_type?: InputMaybe<Festival_Badge_Types_Obj_Rel_Insert_Input>;
  festival_badge_type_id?: InputMaybe<Scalars['Int']>;
  festival_tickets?: InputMaybe<Festival_Tickets_Arr_Rel_Insert_Input>;
  film_festival?: InputMaybe<Film_Festivals_Obj_Rel_Insert_Input>;
  film_festival_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  issued_at?: InputMaybe<Scalars['timestamptz']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Festival_Badges_Max_Fields = {
  __typename?: 'festival_badges_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  festival_badge_type_id?: Maybe<Scalars['Int']>;
  film_festival_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  issued_at?: Maybe<Scalars['timestamptz']>;
  team_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "festival_badges" */
export type Festival_Badges_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  festival_badge_type_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issued_at?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Festival_Badges_Min_Fields = {
  __typename?: 'festival_badges_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  festival_badge_type_id?: Maybe<Scalars['Int']>;
  film_festival_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  issued_at?: Maybe<Scalars['timestamptz']>;
  team_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "festival_badges" */
export type Festival_Badges_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  festival_badge_type_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issued_at?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "festival_badges" */
export type Festival_Badges_Mutation_Response = {
  __typename?: 'festival_badges_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Festival_Badges>;
};

/** input type for inserting object relation for remote table "festival_badges" */
export type Festival_Badges_Obj_Rel_Insert_Input = {
  data: Festival_Badges_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Festival_Badges_On_Conflict>;
};

/** on_conflict condition type for table "festival_badges" */
export type Festival_Badges_On_Conflict = {
  constraint: Festival_Badges_Constraint;
  update_columns?: Array<Festival_Badges_Update_Column>;
  where?: InputMaybe<Festival_Badges_Bool_Exp>;
};

/** Ordering options when selecting data from "festival_badges". */
export type Festival_Badges_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  festival_badge_type?: InputMaybe<Festival_Badge_Types_Order_By>;
  festival_badge_type_id?: InputMaybe<Order_By>;
  festival_tickets_aggregate?: InputMaybe<Festival_Tickets_Aggregate_Order_By>;
  film_festival?: InputMaybe<Film_Festivals_Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issued_at?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: festival_badges */
export type Festival_Badges_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "festival_badges" */
export enum Festival_Badges_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FestivalBadgeTypeId = 'festival_badge_type_id',
  /** column name */
  FilmFestivalId = 'film_festival_id',
  /** column name */
  Id = 'id',
  /** column name */
  IssuedAt = 'issued_at',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "festival_badges" */
export type Festival_Badges_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  festival_badge_type_id?: InputMaybe<Scalars['Int']>;
  film_festival_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  issued_at?: InputMaybe<Scalars['timestamptz']>;
  team_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Festival_Badges_Stddev_Fields = {
  __typename?: 'festival_badges_stddev_fields';
  festival_badge_type_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "festival_badges" */
export type Festival_Badges_Stddev_Order_By = {
  festival_badge_type_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Festival_Badges_Stddev_Pop_Fields = {
  __typename?: 'festival_badges_stddev_pop_fields';
  festival_badge_type_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "festival_badges" */
export type Festival_Badges_Stddev_Pop_Order_By = {
  festival_badge_type_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Festival_Badges_Stddev_Samp_Fields = {
  __typename?: 'festival_badges_stddev_samp_fields';
  festival_badge_type_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "festival_badges" */
export type Festival_Badges_Stddev_Samp_Order_By = {
  festival_badge_type_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "festival_badges" */
export type Festival_Badges_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Festival_Badges_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Festival_Badges_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  festival_badge_type_id?: InputMaybe<Scalars['Int']>;
  film_festival_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  issued_at?: InputMaybe<Scalars['timestamptz']>;
  team_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Festival_Badges_Sum_Fields = {
  __typename?: 'festival_badges_sum_fields';
  festival_badge_type_id?: Maybe<Scalars['Int']>;
  film_festival_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "festival_badges" */
export type Festival_Badges_Sum_Order_By = {
  festival_badge_type_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "festival_badges" */
export enum Festival_Badges_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FestivalBadgeTypeId = 'festival_badge_type_id',
  /** column name */
  FilmFestivalId = 'film_festival_id',
  /** column name */
  Id = 'id',
  /** column name */
  IssuedAt = 'issued_at',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Festival_Badges_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Festival_Badges_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Festival_Badges_Set_Input>;
  /** filter the rows which have to be updated */
  where: Festival_Badges_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Festival_Badges_Var_Pop_Fields = {
  __typename?: 'festival_badges_var_pop_fields';
  festival_badge_type_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "festival_badges" */
export type Festival_Badges_Var_Pop_Order_By = {
  festival_badge_type_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Festival_Badges_Var_Samp_Fields = {
  __typename?: 'festival_badges_var_samp_fields';
  festival_badge_type_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "festival_badges" */
export type Festival_Badges_Var_Samp_Order_By = {
  festival_badge_type_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Festival_Badges_Variance_Fields = {
  __typename?: 'festival_badges_variance_fields';
  festival_badge_type_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "festival_badges" */
export type Festival_Badges_Variance_Order_By = {
  festival_badge_type_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "festival_event_locations" */
export type Festival_Event_Locations = {
  __typename?: 'festival_event_locations';
  address_1: Scalars['String'];
  address_2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  festival_events: Array<Festival_Events>;
  /** An aggregate relationship */
  festival_events_aggregate: Festival_Events_Aggregate;
  id: Scalars['Int'];
  lat: Scalars['numeric'];
  lon: Scalars['numeric'];
  name: Scalars['String'];
  state: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  zip: Scalars['String'];
};


/** columns and relationships of "festival_event_locations" */
export type Festival_Event_LocationsFestival_EventsArgs = {
  distinct_on?: InputMaybe<Array<Festival_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Events_Order_By>>;
  where?: InputMaybe<Festival_Events_Bool_Exp>;
};


/** columns and relationships of "festival_event_locations" */
export type Festival_Event_LocationsFestival_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Events_Order_By>>;
  where?: InputMaybe<Festival_Events_Bool_Exp>;
};

/** aggregated selection of "festival_event_locations" */
export type Festival_Event_Locations_Aggregate = {
  __typename?: 'festival_event_locations_aggregate';
  aggregate?: Maybe<Festival_Event_Locations_Aggregate_Fields>;
  nodes: Array<Festival_Event_Locations>;
};

/** aggregate fields of "festival_event_locations" */
export type Festival_Event_Locations_Aggregate_Fields = {
  __typename?: 'festival_event_locations_aggregate_fields';
  avg?: Maybe<Festival_Event_Locations_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Festival_Event_Locations_Max_Fields>;
  min?: Maybe<Festival_Event_Locations_Min_Fields>;
  stddev?: Maybe<Festival_Event_Locations_Stddev_Fields>;
  stddev_pop?: Maybe<Festival_Event_Locations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Festival_Event_Locations_Stddev_Samp_Fields>;
  sum?: Maybe<Festival_Event_Locations_Sum_Fields>;
  var_pop?: Maybe<Festival_Event_Locations_Var_Pop_Fields>;
  var_samp?: Maybe<Festival_Event_Locations_Var_Samp_Fields>;
  variance?: Maybe<Festival_Event_Locations_Variance_Fields>;
};


/** aggregate fields of "festival_event_locations" */
export type Festival_Event_Locations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Festival_Event_Locations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Festival_Event_Locations_Avg_Fields = {
  __typename?: 'festival_event_locations_avg_fields';
  id?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "festival_event_locations". All fields are combined with a logical 'AND'. */
export type Festival_Event_Locations_Bool_Exp = {
  _and?: InputMaybe<Array<Festival_Event_Locations_Bool_Exp>>;
  _not?: InputMaybe<Festival_Event_Locations_Bool_Exp>;
  _or?: InputMaybe<Array<Festival_Event_Locations_Bool_Exp>>;
  address_1?: InputMaybe<String_Comparison_Exp>;
  address_2?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  festival_events?: InputMaybe<Festival_Events_Bool_Exp>;
  festival_events_aggregate?: InputMaybe<Festival_Events_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  lat?: InputMaybe<Numeric_Comparison_Exp>;
  lon?: InputMaybe<Numeric_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  zip?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "festival_event_locations" */
export enum Festival_Event_Locations_Constraint {
  /** unique or primary key constraint on columns "id" */
  FestivalEventLocationsPkey = 'festival_event_locations_pkey'
}

/** input type for incrementing numeric columns in table "festival_event_locations" */
export type Festival_Event_Locations_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  lat?: InputMaybe<Scalars['numeric']>;
  lon?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "festival_event_locations" */
export type Festival_Event_Locations_Insert_Input = {
  address_1?: InputMaybe<Scalars['String']>;
  address_2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  festival_events?: InputMaybe<Festival_Events_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  lat?: InputMaybe<Scalars['numeric']>;
  lon?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Festival_Event_Locations_Max_Fields = {
  __typename?: 'festival_event_locations_max_fields';
  address_1?: Maybe<Scalars['String']>;
  address_2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['numeric']>;
  lon?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zip?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Festival_Event_Locations_Min_Fields = {
  __typename?: 'festival_event_locations_min_fields';
  address_1?: Maybe<Scalars['String']>;
  address_2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['numeric']>;
  lon?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zip?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "festival_event_locations" */
export type Festival_Event_Locations_Mutation_Response = {
  __typename?: 'festival_event_locations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Festival_Event_Locations>;
};

/** input type for inserting object relation for remote table "festival_event_locations" */
export type Festival_Event_Locations_Obj_Rel_Insert_Input = {
  data: Festival_Event_Locations_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Festival_Event_Locations_On_Conflict>;
};

/** on_conflict condition type for table "festival_event_locations" */
export type Festival_Event_Locations_On_Conflict = {
  constraint: Festival_Event_Locations_Constraint;
  update_columns?: Array<Festival_Event_Locations_Update_Column>;
  where?: InputMaybe<Festival_Event_Locations_Bool_Exp>;
};

/** Ordering options when selecting data from "festival_event_locations". */
export type Festival_Event_Locations_Order_By = {
  address_1?: InputMaybe<Order_By>;
  address_2?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  festival_events_aggregate?: InputMaybe<Festival_Events_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lon?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  zip?: InputMaybe<Order_By>;
};

/** primary key columns input for table: festival_event_locations */
export type Festival_Event_Locations_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "festival_event_locations" */
export enum Festival_Event_Locations_Select_Column {
  /** column name */
  Address_1 = 'address_1',
  /** column name */
  Address_2 = 'address_2',
  /** column name */
  City = 'city',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lon = 'lon',
  /** column name */
  Name = 'name',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Zip = 'zip'
}

/** input type for updating data in table "festival_event_locations" */
export type Festival_Event_Locations_Set_Input = {
  address_1?: InputMaybe<Scalars['String']>;
  address_2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  lat?: InputMaybe<Scalars['numeric']>;
  lon?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Festival_Event_Locations_Stddev_Fields = {
  __typename?: 'festival_event_locations_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Festival_Event_Locations_Stddev_Pop_Fields = {
  __typename?: 'festival_event_locations_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Festival_Event_Locations_Stddev_Samp_Fields = {
  __typename?: 'festival_event_locations_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "festival_event_locations" */
export type Festival_Event_Locations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Festival_Event_Locations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Festival_Event_Locations_Stream_Cursor_Value_Input = {
  address_1?: InputMaybe<Scalars['String']>;
  address_2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  lat?: InputMaybe<Scalars['numeric']>;
  lon?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Festival_Event_Locations_Sum_Fields = {
  __typename?: 'festival_event_locations_sum_fields';
  id?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['numeric']>;
  lon?: Maybe<Scalars['numeric']>;
};

/** update columns of table "festival_event_locations" */
export enum Festival_Event_Locations_Update_Column {
  /** column name */
  Address_1 = 'address_1',
  /** column name */
  Address_2 = 'address_2',
  /** column name */
  City = 'city',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lon = 'lon',
  /** column name */
  Name = 'name',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Zip = 'zip'
}

export type Festival_Event_Locations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Festival_Event_Locations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Festival_Event_Locations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Festival_Event_Locations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Festival_Event_Locations_Var_Pop_Fields = {
  __typename?: 'festival_event_locations_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Festival_Event_Locations_Var_Samp_Fields = {
  __typename?: 'festival_event_locations_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Festival_Event_Locations_Variance_Fields = {
  __typename?: 'festival_event_locations_variance_fields';
  id?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "festival_event_types" */
export type Festival_Event_Types = {
  __typename?: 'festival_event_types';
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  festival_badge_type_event_types: Array<Festival_Badge_Type_Event_Type>;
  /** An aggregate relationship */
  festival_badge_type_event_types_aggregate: Festival_Badge_Type_Event_Type_Aggregate;
  /** An array relationship */
  festival_events: Array<Festival_Events>;
  /** An aggregate relationship */
  festival_events_aggregate: Festival_Events_Aggregate;
  id: Scalars['Int'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "festival_event_types" */
export type Festival_Event_TypesFestival_Badge_Type_Event_TypesArgs = {
  distinct_on?: InputMaybe<Array<Festival_Badge_Type_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Badge_Type_Event_Type_Order_By>>;
  where?: InputMaybe<Festival_Badge_Type_Event_Type_Bool_Exp>;
};


/** columns and relationships of "festival_event_types" */
export type Festival_Event_TypesFestival_Badge_Type_Event_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Badge_Type_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Badge_Type_Event_Type_Order_By>>;
  where?: InputMaybe<Festival_Badge_Type_Event_Type_Bool_Exp>;
};


/** columns and relationships of "festival_event_types" */
export type Festival_Event_TypesFestival_EventsArgs = {
  distinct_on?: InputMaybe<Array<Festival_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Events_Order_By>>;
  where?: InputMaybe<Festival_Events_Bool_Exp>;
};


/** columns and relationships of "festival_event_types" */
export type Festival_Event_TypesFestival_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Events_Order_By>>;
  where?: InputMaybe<Festival_Events_Bool_Exp>;
};

/** aggregated selection of "festival_event_types" */
export type Festival_Event_Types_Aggregate = {
  __typename?: 'festival_event_types_aggregate';
  aggregate?: Maybe<Festival_Event_Types_Aggregate_Fields>;
  nodes: Array<Festival_Event_Types>;
};

/** aggregate fields of "festival_event_types" */
export type Festival_Event_Types_Aggregate_Fields = {
  __typename?: 'festival_event_types_aggregate_fields';
  avg?: Maybe<Festival_Event_Types_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Festival_Event_Types_Max_Fields>;
  min?: Maybe<Festival_Event_Types_Min_Fields>;
  stddev?: Maybe<Festival_Event_Types_Stddev_Fields>;
  stddev_pop?: Maybe<Festival_Event_Types_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Festival_Event_Types_Stddev_Samp_Fields>;
  sum?: Maybe<Festival_Event_Types_Sum_Fields>;
  var_pop?: Maybe<Festival_Event_Types_Var_Pop_Fields>;
  var_samp?: Maybe<Festival_Event_Types_Var_Samp_Fields>;
  variance?: Maybe<Festival_Event_Types_Variance_Fields>;
};


/** aggregate fields of "festival_event_types" */
export type Festival_Event_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Festival_Event_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Festival_Event_Types_Avg_Fields = {
  __typename?: 'festival_event_types_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "festival_event_types". All fields are combined with a logical 'AND'. */
export type Festival_Event_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Festival_Event_Types_Bool_Exp>>;
  _not?: InputMaybe<Festival_Event_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Festival_Event_Types_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  festival_badge_type_event_types?: InputMaybe<Festival_Badge_Type_Event_Type_Bool_Exp>;
  festival_badge_type_event_types_aggregate?: InputMaybe<Festival_Badge_Type_Event_Type_Aggregate_Bool_Exp>;
  festival_events?: InputMaybe<Festival_Events_Bool_Exp>;
  festival_events_aggregate?: InputMaybe<Festival_Events_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "festival_event_types" */
export enum Festival_Event_Types_Constraint {
  /** unique or primary key constraint on columns "id" */
  FestivalEventTypesPkey = 'festival_event_types_pkey'
}

/** input type for incrementing numeric columns in table "festival_event_types" */
export type Festival_Event_Types_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "festival_event_types" */
export type Festival_Event_Types_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  festival_badge_type_event_types?: InputMaybe<Festival_Badge_Type_Event_Type_Arr_Rel_Insert_Input>;
  festival_events?: InputMaybe<Festival_Events_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Festival_Event_Types_Max_Fields = {
  __typename?: 'festival_event_types_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Festival_Event_Types_Min_Fields = {
  __typename?: 'festival_event_types_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "festival_event_types" */
export type Festival_Event_Types_Mutation_Response = {
  __typename?: 'festival_event_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Festival_Event_Types>;
};

/** input type for inserting object relation for remote table "festival_event_types" */
export type Festival_Event_Types_Obj_Rel_Insert_Input = {
  data: Festival_Event_Types_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Festival_Event_Types_On_Conflict>;
};

/** on_conflict condition type for table "festival_event_types" */
export type Festival_Event_Types_On_Conflict = {
  constraint: Festival_Event_Types_Constraint;
  update_columns?: Array<Festival_Event_Types_Update_Column>;
  where?: InputMaybe<Festival_Event_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "festival_event_types". */
export type Festival_Event_Types_Order_By = {
  created_at?: InputMaybe<Order_By>;
  festival_badge_type_event_types_aggregate?: InputMaybe<Festival_Badge_Type_Event_Type_Aggregate_Order_By>;
  festival_events_aggregate?: InputMaybe<Festival_Events_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: festival_event_types */
export type Festival_Event_Types_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "festival_event_types" */
export enum Festival_Event_Types_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "festival_event_types" */
export type Festival_Event_Types_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Festival_Event_Types_Stddev_Fields = {
  __typename?: 'festival_event_types_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Festival_Event_Types_Stddev_Pop_Fields = {
  __typename?: 'festival_event_types_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Festival_Event_Types_Stddev_Samp_Fields = {
  __typename?: 'festival_event_types_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "festival_event_types" */
export type Festival_Event_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Festival_Event_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Festival_Event_Types_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Festival_Event_Types_Sum_Fields = {
  __typename?: 'festival_event_types_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "festival_event_types" */
export enum Festival_Event_Types_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Festival_Event_Types_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Festival_Event_Types_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Festival_Event_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Festival_Event_Types_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Festival_Event_Types_Var_Pop_Fields = {
  __typename?: 'festival_event_types_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Festival_Event_Types_Var_Samp_Fields = {
  __typename?: 'festival_event_types_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Festival_Event_Types_Variance_Fields = {
  __typename?: 'festival_event_types_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "festival_events" */
export type Festival_Events = {
  __typename?: 'festival_events';
  created_at: Scalars['timestamptz'];
  description: Scalars['String'];
  ends_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  festival_event_location: Festival_Event_Locations;
  festival_event_location_id: Scalars['Int'];
  /** An object relationship */
  festival_event_type: Festival_Event_Types;
  /** An array relationship */
  festival_tickets: Array<Festival_Tickets>;
  /** An aggregate relationship */
  festival_tickets_aggregate: Festival_Tickets_Aggregate;
  festvial_event_type_id: Scalars['Int'];
  /** An object relationship */
  film_festival: Film_Festivals;
  film_festival_id: Scalars['Int'];
  id: Scalars['Int'];
  price: Scalars['numeric'];
  price_id?: Maybe<Scalars['String']>;
  starts_at: Scalars['timestamptz'];
  title: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "festival_events" */
export type Festival_EventsFestival_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Festival_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Tickets_Order_By>>;
  where?: InputMaybe<Festival_Tickets_Bool_Exp>;
};


/** columns and relationships of "festival_events" */
export type Festival_EventsFestival_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Tickets_Order_By>>;
  where?: InputMaybe<Festival_Tickets_Bool_Exp>;
};

/** aggregated selection of "festival_events" */
export type Festival_Events_Aggregate = {
  __typename?: 'festival_events_aggregate';
  aggregate?: Maybe<Festival_Events_Aggregate_Fields>;
  nodes: Array<Festival_Events>;
};

export type Festival_Events_Aggregate_Bool_Exp = {
  count?: InputMaybe<Festival_Events_Aggregate_Bool_Exp_Count>;
};

export type Festival_Events_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Festival_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Festival_Events_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "festival_events" */
export type Festival_Events_Aggregate_Fields = {
  __typename?: 'festival_events_aggregate_fields';
  avg?: Maybe<Festival_Events_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Festival_Events_Max_Fields>;
  min?: Maybe<Festival_Events_Min_Fields>;
  stddev?: Maybe<Festival_Events_Stddev_Fields>;
  stddev_pop?: Maybe<Festival_Events_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Festival_Events_Stddev_Samp_Fields>;
  sum?: Maybe<Festival_Events_Sum_Fields>;
  var_pop?: Maybe<Festival_Events_Var_Pop_Fields>;
  var_samp?: Maybe<Festival_Events_Var_Samp_Fields>;
  variance?: Maybe<Festival_Events_Variance_Fields>;
};


/** aggregate fields of "festival_events" */
export type Festival_Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Festival_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "festival_events" */
export type Festival_Events_Aggregate_Order_By = {
  avg?: InputMaybe<Festival_Events_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Festival_Events_Max_Order_By>;
  min?: InputMaybe<Festival_Events_Min_Order_By>;
  stddev?: InputMaybe<Festival_Events_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Festival_Events_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Festival_Events_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Festival_Events_Sum_Order_By>;
  var_pop?: InputMaybe<Festival_Events_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Festival_Events_Var_Samp_Order_By>;
  variance?: InputMaybe<Festival_Events_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "festival_events" */
export type Festival_Events_Arr_Rel_Insert_Input = {
  data: Array<Festival_Events_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Festival_Events_On_Conflict>;
};

/** aggregate avg on columns */
export type Festival_Events_Avg_Fields = {
  __typename?: 'festival_events_avg_fields';
  festival_event_location_id?: Maybe<Scalars['Float']>;
  festvial_event_type_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "festival_events" */
export type Festival_Events_Avg_Order_By = {
  festival_event_location_id?: InputMaybe<Order_By>;
  festvial_event_type_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "festival_events". All fields are combined with a logical 'AND'. */
export type Festival_Events_Bool_Exp = {
  _and?: InputMaybe<Array<Festival_Events_Bool_Exp>>;
  _not?: InputMaybe<Festival_Events_Bool_Exp>;
  _or?: InputMaybe<Array<Festival_Events_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  ends_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  festival_event_location?: InputMaybe<Festival_Event_Locations_Bool_Exp>;
  festival_event_location_id?: InputMaybe<Int_Comparison_Exp>;
  festival_event_type?: InputMaybe<Festival_Event_Types_Bool_Exp>;
  festival_tickets?: InputMaybe<Festival_Tickets_Bool_Exp>;
  festival_tickets_aggregate?: InputMaybe<Festival_Tickets_Aggregate_Bool_Exp>;
  festvial_event_type_id?: InputMaybe<Int_Comparison_Exp>;
  film_festival?: InputMaybe<Film_Festivals_Bool_Exp>;
  film_festival_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  price_id?: InputMaybe<String_Comparison_Exp>;
  starts_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "festival_events" */
export enum Festival_Events_Constraint {
  /** unique or primary key constraint on columns "id" */
  FestivalEventsPkey = 'festival_events_pkey'
}

/** input type for incrementing numeric columns in table "festival_events" */
export type Festival_Events_Inc_Input = {
  festival_event_location_id?: InputMaybe<Scalars['Int']>;
  festvial_event_type_id?: InputMaybe<Scalars['Int']>;
  film_festival_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "festival_events" */
export type Festival_Events_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  ends_at?: InputMaybe<Scalars['timestamptz']>;
  festival_event_location?: InputMaybe<Festival_Event_Locations_Obj_Rel_Insert_Input>;
  festival_event_location_id?: InputMaybe<Scalars['Int']>;
  festival_event_type?: InputMaybe<Festival_Event_Types_Obj_Rel_Insert_Input>;
  festival_tickets?: InputMaybe<Festival_Tickets_Arr_Rel_Insert_Input>;
  festvial_event_type_id?: InputMaybe<Scalars['Int']>;
  film_festival?: InputMaybe<Film_Festivals_Obj_Rel_Insert_Input>;
  film_festival_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
  price_id?: InputMaybe<Scalars['String']>;
  starts_at?: InputMaybe<Scalars['timestamptz']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Festival_Events_Max_Fields = {
  __typename?: 'festival_events_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  ends_at?: Maybe<Scalars['timestamptz']>;
  festival_event_location_id?: Maybe<Scalars['Int']>;
  festvial_event_type_id?: Maybe<Scalars['Int']>;
  film_festival_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['numeric']>;
  price_id?: Maybe<Scalars['String']>;
  starts_at?: Maybe<Scalars['timestamptz']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "festival_events" */
export type Festival_Events_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  ends_at?: InputMaybe<Order_By>;
  festival_event_location_id?: InputMaybe<Order_By>;
  festvial_event_type_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  price_id?: InputMaybe<Order_By>;
  starts_at?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Festival_Events_Min_Fields = {
  __typename?: 'festival_events_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  ends_at?: Maybe<Scalars['timestamptz']>;
  festival_event_location_id?: Maybe<Scalars['Int']>;
  festvial_event_type_id?: Maybe<Scalars['Int']>;
  film_festival_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['numeric']>;
  price_id?: Maybe<Scalars['String']>;
  starts_at?: Maybe<Scalars['timestamptz']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "festival_events" */
export type Festival_Events_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  ends_at?: InputMaybe<Order_By>;
  festival_event_location_id?: InputMaybe<Order_By>;
  festvial_event_type_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  price_id?: InputMaybe<Order_By>;
  starts_at?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "festival_events" */
export type Festival_Events_Mutation_Response = {
  __typename?: 'festival_events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Festival_Events>;
};

/** input type for inserting object relation for remote table "festival_events" */
export type Festival_Events_Obj_Rel_Insert_Input = {
  data: Festival_Events_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Festival_Events_On_Conflict>;
};

/** on_conflict condition type for table "festival_events" */
export type Festival_Events_On_Conflict = {
  constraint: Festival_Events_Constraint;
  update_columns?: Array<Festival_Events_Update_Column>;
  where?: InputMaybe<Festival_Events_Bool_Exp>;
};

/** Ordering options when selecting data from "festival_events". */
export type Festival_Events_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  ends_at?: InputMaybe<Order_By>;
  festival_event_location?: InputMaybe<Festival_Event_Locations_Order_By>;
  festival_event_location_id?: InputMaybe<Order_By>;
  festival_event_type?: InputMaybe<Festival_Event_Types_Order_By>;
  festival_tickets_aggregate?: InputMaybe<Festival_Tickets_Aggregate_Order_By>;
  festvial_event_type_id?: InputMaybe<Order_By>;
  film_festival?: InputMaybe<Film_Festivals_Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  price_id?: InputMaybe<Order_By>;
  starts_at?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: festival_events */
export type Festival_Events_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "festival_events" */
export enum Festival_Events_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  EndsAt = 'ends_at',
  /** column name */
  FestivalEventLocationId = 'festival_event_location_id',
  /** column name */
  FestvialEventTypeId = 'festvial_event_type_id',
  /** column name */
  FilmFestivalId = 'film_festival_id',
  /** column name */
  Id = 'id',
  /** column name */
  Price = 'price',
  /** column name */
  PriceId = 'price_id',
  /** column name */
  StartsAt = 'starts_at',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "festival_events" */
export type Festival_Events_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  ends_at?: InputMaybe<Scalars['timestamptz']>;
  festival_event_location_id?: InputMaybe<Scalars['Int']>;
  festvial_event_type_id?: InputMaybe<Scalars['Int']>;
  film_festival_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
  price_id?: InputMaybe<Scalars['String']>;
  starts_at?: InputMaybe<Scalars['timestamptz']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Festival_Events_Stddev_Fields = {
  __typename?: 'festival_events_stddev_fields';
  festival_event_location_id?: Maybe<Scalars['Float']>;
  festvial_event_type_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "festival_events" */
export type Festival_Events_Stddev_Order_By = {
  festival_event_location_id?: InputMaybe<Order_By>;
  festvial_event_type_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Festival_Events_Stddev_Pop_Fields = {
  __typename?: 'festival_events_stddev_pop_fields';
  festival_event_location_id?: Maybe<Scalars['Float']>;
  festvial_event_type_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "festival_events" */
export type Festival_Events_Stddev_Pop_Order_By = {
  festival_event_location_id?: InputMaybe<Order_By>;
  festvial_event_type_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Festival_Events_Stddev_Samp_Fields = {
  __typename?: 'festival_events_stddev_samp_fields';
  festival_event_location_id?: Maybe<Scalars['Float']>;
  festvial_event_type_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "festival_events" */
export type Festival_Events_Stddev_Samp_Order_By = {
  festival_event_location_id?: InputMaybe<Order_By>;
  festvial_event_type_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "festival_events" */
export type Festival_Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Festival_Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Festival_Events_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  ends_at?: InputMaybe<Scalars['timestamptz']>;
  festival_event_location_id?: InputMaybe<Scalars['Int']>;
  festvial_event_type_id?: InputMaybe<Scalars['Int']>;
  film_festival_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
  price_id?: InputMaybe<Scalars['String']>;
  starts_at?: InputMaybe<Scalars['timestamptz']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Festival_Events_Sum_Fields = {
  __typename?: 'festival_events_sum_fields';
  festival_event_location_id?: Maybe<Scalars['Int']>;
  festvial_event_type_id?: Maybe<Scalars['Int']>;
  film_festival_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "festival_events" */
export type Festival_Events_Sum_Order_By = {
  festival_event_location_id?: InputMaybe<Order_By>;
  festvial_event_type_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** update columns of table "festival_events" */
export enum Festival_Events_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  EndsAt = 'ends_at',
  /** column name */
  FestivalEventLocationId = 'festival_event_location_id',
  /** column name */
  FestvialEventTypeId = 'festvial_event_type_id',
  /** column name */
  FilmFestivalId = 'film_festival_id',
  /** column name */
  Id = 'id',
  /** column name */
  Price = 'price',
  /** column name */
  PriceId = 'price_id',
  /** column name */
  StartsAt = 'starts_at',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Festival_Events_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Festival_Events_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Festival_Events_Set_Input>;
  /** filter the rows which have to be updated */
  where: Festival_Events_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Festival_Events_Var_Pop_Fields = {
  __typename?: 'festival_events_var_pop_fields';
  festival_event_location_id?: Maybe<Scalars['Float']>;
  festvial_event_type_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "festival_events" */
export type Festival_Events_Var_Pop_Order_By = {
  festival_event_location_id?: InputMaybe<Order_By>;
  festvial_event_type_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Festival_Events_Var_Samp_Fields = {
  __typename?: 'festival_events_var_samp_fields';
  festival_event_location_id?: Maybe<Scalars['Float']>;
  festvial_event_type_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "festival_events" */
export type Festival_Events_Var_Samp_Order_By = {
  festival_event_location_id?: InputMaybe<Order_By>;
  festvial_event_type_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Festival_Events_Variance_Fields = {
  __typename?: 'festival_events_variance_fields';
  festival_event_location_id?: Maybe<Scalars['Float']>;
  festvial_event_type_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "festival_events" */
export type Festival_Events_Variance_Order_By = {
  festival_event_location_id?: InputMaybe<Order_By>;
  festvial_event_type_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** Specifically for FiveFest, not Film Challenge */
export type Festival_Genres = {
  __typename?: 'festival_genres';
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  /** An object relationship */
  film_festival: Film_Festivals;
  film_festival_id: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "festival_genres" */
export type Festival_Genres_Aggregate = {
  __typename?: 'festival_genres_aggregate';
  aggregate?: Maybe<Festival_Genres_Aggregate_Fields>;
  nodes: Array<Festival_Genres>;
};

export type Festival_Genres_Aggregate_Bool_Exp = {
  count?: InputMaybe<Festival_Genres_Aggregate_Bool_Exp_Count>;
};

export type Festival_Genres_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Festival_Genres_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Festival_Genres_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "festival_genres" */
export type Festival_Genres_Aggregate_Fields = {
  __typename?: 'festival_genres_aggregate_fields';
  avg?: Maybe<Festival_Genres_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Festival_Genres_Max_Fields>;
  min?: Maybe<Festival_Genres_Min_Fields>;
  stddev?: Maybe<Festival_Genres_Stddev_Fields>;
  stddev_pop?: Maybe<Festival_Genres_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Festival_Genres_Stddev_Samp_Fields>;
  sum?: Maybe<Festival_Genres_Sum_Fields>;
  var_pop?: Maybe<Festival_Genres_Var_Pop_Fields>;
  var_samp?: Maybe<Festival_Genres_Var_Samp_Fields>;
  variance?: Maybe<Festival_Genres_Variance_Fields>;
};


/** aggregate fields of "festival_genres" */
export type Festival_Genres_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Festival_Genres_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "festival_genres" */
export type Festival_Genres_Aggregate_Order_By = {
  avg?: InputMaybe<Festival_Genres_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Festival_Genres_Max_Order_By>;
  min?: InputMaybe<Festival_Genres_Min_Order_By>;
  stddev?: InputMaybe<Festival_Genres_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Festival_Genres_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Festival_Genres_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Festival_Genres_Sum_Order_By>;
  var_pop?: InputMaybe<Festival_Genres_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Festival_Genres_Var_Samp_Order_By>;
  variance?: InputMaybe<Festival_Genres_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "festival_genres" */
export type Festival_Genres_Arr_Rel_Insert_Input = {
  data: Array<Festival_Genres_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Festival_Genres_On_Conflict>;
};

/** aggregate avg on columns */
export type Festival_Genres_Avg_Fields = {
  __typename?: 'festival_genres_avg_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "festival_genres" */
export type Festival_Genres_Avg_Order_By = {
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "festival_genres". All fields are combined with a logical 'AND'. */
export type Festival_Genres_Bool_Exp = {
  _and?: InputMaybe<Array<Festival_Genres_Bool_Exp>>;
  _not?: InputMaybe<Festival_Genres_Bool_Exp>;
  _or?: InputMaybe<Array<Festival_Genres_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  film_festival?: InputMaybe<Film_Festivals_Bool_Exp>;
  film_festival_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "festival_genres" */
export enum Festival_Genres_Constraint {
  /** unique or primary key constraint on columns "id" */
  FestivalGenresPkey = 'festival_genres_pkey'
}

/** input type for incrementing numeric columns in table "festival_genres" */
export type Festival_Genres_Inc_Input = {
  film_festival_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "festival_genres" */
export type Festival_Genres_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  film_festival?: InputMaybe<Film_Festivals_Obj_Rel_Insert_Input>;
  film_festival_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Festival_Genres_Max_Fields = {
  __typename?: 'festival_genres_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  film_festival_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "festival_genres" */
export type Festival_Genres_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Festival_Genres_Min_Fields = {
  __typename?: 'festival_genres_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  film_festival_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "festival_genres" */
export type Festival_Genres_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "festival_genres" */
export type Festival_Genres_Mutation_Response = {
  __typename?: 'festival_genres_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Festival_Genres>;
};

/** input type for inserting object relation for remote table "festival_genres" */
export type Festival_Genres_Obj_Rel_Insert_Input = {
  data: Festival_Genres_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Festival_Genres_On_Conflict>;
};

/** on_conflict condition type for table "festival_genres" */
export type Festival_Genres_On_Conflict = {
  constraint: Festival_Genres_Constraint;
  update_columns?: Array<Festival_Genres_Update_Column>;
  where?: InputMaybe<Festival_Genres_Bool_Exp>;
};

/** Ordering options when selecting data from "festival_genres". */
export type Festival_Genres_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  film_festival?: InputMaybe<Film_Festivals_Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: festival_genres */
export type Festival_Genres_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "festival_genres" */
export enum Festival_Genres_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  FilmFestivalId = 'film_festival_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "festival_genres" */
export type Festival_Genres_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  film_festival_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Festival_Genres_Stddev_Fields = {
  __typename?: 'festival_genres_stddev_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "festival_genres" */
export type Festival_Genres_Stddev_Order_By = {
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Festival_Genres_Stddev_Pop_Fields = {
  __typename?: 'festival_genres_stddev_pop_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "festival_genres" */
export type Festival_Genres_Stddev_Pop_Order_By = {
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Festival_Genres_Stddev_Samp_Fields = {
  __typename?: 'festival_genres_stddev_samp_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "festival_genres" */
export type Festival_Genres_Stddev_Samp_Order_By = {
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "festival_genres" */
export type Festival_Genres_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Festival_Genres_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Festival_Genres_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  film_festival_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Festival_Genres_Sum_Fields = {
  __typename?: 'festival_genres_sum_fields';
  film_festival_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "festival_genres" */
export type Festival_Genres_Sum_Order_By = {
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "festival_genres" */
export enum Festival_Genres_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  FilmFestivalId = 'film_festival_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Festival_Genres_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Festival_Genres_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Festival_Genres_Set_Input>;
  /** filter the rows which have to be updated */
  where: Festival_Genres_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Festival_Genres_Var_Pop_Fields = {
  __typename?: 'festival_genres_var_pop_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "festival_genres" */
export type Festival_Genres_Var_Pop_Order_By = {
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Festival_Genres_Var_Samp_Fields = {
  __typename?: 'festival_genres_var_samp_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "festival_genres" */
export type Festival_Genres_Var_Samp_Order_By = {
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Festival_Genres_Variance_Fields = {
  __typename?: 'festival_genres_variance_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "festival_genres" */
export type Festival_Genres_Variance_Order_By = {
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "festival_submission_assets" */
export type Festival_Submission_Assets = {
  __typename?: 'festival_submission_assets';
  /** An object relationship */
  asset_type: Asset_Types;
  asset_type_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  festival_submission: Festival_Submissions;
  festival_submission_id: Scalars['Int'];
  file_name: Scalars['String'];
  id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "festival_submission_assets" */
export type Festival_Submission_Assets_Aggregate = {
  __typename?: 'festival_submission_assets_aggregate';
  aggregate?: Maybe<Festival_Submission_Assets_Aggregate_Fields>;
  nodes: Array<Festival_Submission_Assets>;
};

export type Festival_Submission_Assets_Aggregate_Bool_Exp = {
  count?: InputMaybe<Festival_Submission_Assets_Aggregate_Bool_Exp_Count>;
};

export type Festival_Submission_Assets_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Festival_Submission_Assets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Festival_Submission_Assets_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "festival_submission_assets" */
export type Festival_Submission_Assets_Aggregate_Fields = {
  __typename?: 'festival_submission_assets_aggregate_fields';
  avg?: Maybe<Festival_Submission_Assets_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Festival_Submission_Assets_Max_Fields>;
  min?: Maybe<Festival_Submission_Assets_Min_Fields>;
  stddev?: Maybe<Festival_Submission_Assets_Stddev_Fields>;
  stddev_pop?: Maybe<Festival_Submission_Assets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Festival_Submission_Assets_Stddev_Samp_Fields>;
  sum?: Maybe<Festival_Submission_Assets_Sum_Fields>;
  var_pop?: Maybe<Festival_Submission_Assets_Var_Pop_Fields>;
  var_samp?: Maybe<Festival_Submission_Assets_Var_Samp_Fields>;
  variance?: Maybe<Festival_Submission_Assets_Variance_Fields>;
};


/** aggregate fields of "festival_submission_assets" */
export type Festival_Submission_Assets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Festival_Submission_Assets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "festival_submission_assets" */
export type Festival_Submission_Assets_Aggregate_Order_By = {
  avg?: InputMaybe<Festival_Submission_Assets_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Festival_Submission_Assets_Max_Order_By>;
  min?: InputMaybe<Festival_Submission_Assets_Min_Order_By>;
  stddev?: InputMaybe<Festival_Submission_Assets_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Festival_Submission_Assets_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Festival_Submission_Assets_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Festival_Submission_Assets_Sum_Order_By>;
  var_pop?: InputMaybe<Festival_Submission_Assets_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Festival_Submission_Assets_Var_Samp_Order_By>;
  variance?: InputMaybe<Festival_Submission_Assets_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "festival_submission_assets" */
export type Festival_Submission_Assets_Arr_Rel_Insert_Input = {
  data: Array<Festival_Submission_Assets_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Festival_Submission_Assets_On_Conflict>;
};

/** aggregate avg on columns */
export type Festival_Submission_Assets_Avg_Fields = {
  __typename?: 'festival_submission_assets_avg_fields';
  asset_type_id?: Maybe<Scalars['Float']>;
  festival_submission_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "festival_submission_assets" */
export type Festival_Submission_Assets_Avg_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  festival_submission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "festival_submission_assets". All fields are combined with a logical 'AND'. */
export type Festival_Submission_Assets_Bool_Exp = {
  _and?: InputMaybe<Array<Festival_Submission_Assets_Bool_Exp>>;
  _not?: InputMaybe<Festival_Submission_Assets_Bool_Exp>;
  _or?: InputMaybe<Array<Festival_Submission_Assets_Bool_Exp>>;
  asset_type?: InputMaybe<Asset_Types_Bool_Exp>;
  asset_type_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  festival_submission?: InputMaybe<Festival_Submissions_Bool_Exp>;
  festival_submission_id?: InputMaybe<Int_Comparison_Exp>;
  file_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "festival_submission_assets" */
export enum Festival_Submission_Assets_Constraint {
  /** unique or primary key constraint on columns "id" */
  FestivalSubmissionAssetsPkey = 'festival_submission_assets_pkey'
}

/** input type for incrementing numeric columns in table "festival_submission_assets" */
export type Festival_Submission_Assets_Inc_Input = {
  asset_type_id?: InputMaybe<Scalars['Int']>;
  festival_submission_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "festival_submission_assets" */
export type Festival_Submission_Assets_Insert_Input = {
  asset_type?: InputMaybe<Asset_Types_Obj_Rel_Insert_Input>;
  asset_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  festival_submission?: InputMaybe<Festival_Submissions_Obj_Rel_Insert_Input>;
  festival_submission_id?: InputMaybe<Scalars['Int']>;
  file_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Festival_Submission_Assets_Max_Fields = {
  __typename?: 'festival_submission_assets_max_fields';
  asset_type_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  festival_submission_id?: Maybe<Scalars['Int']>;
  file_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "festival_submission_assets" */
export type Festival_Submission_Assets_Max_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  festival_submission_id?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Festival_Submission_Assets_Min_Fields = {
  __typename?: 'festival_submission_assets_min_fields';
  asset_type_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  festival_submission_id?: Maybe<Scalars['Int']>;
  file_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "festival_submission_assets" */
export type Festival_Submission_Assets_Min_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  festival_submission_id?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "festival_submission_assets" */
export type Festival_Submission_Assets_Mutation_Response = {
  __typename?: 'festival_submission_assets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Festival_Submission_Assets>;
};

/** on_conflict condition type for table "festival_submission_assets" */
export type Festival_Submission_Assets_On_Conflict = {
  constraint: Festival_Submission_Assets_Constraint;
  update_columns?: Array<Festival_Submission_Assets_Update_Column>;
  where?: InputMaybe<Festival_Submission_Assets_Bool_Exp>;
};

/** Ordering options when selecting data from "festival_submission_assets". */
export type Festival_Submission_Assets_Order_By = {
  asset_type?: InputMaybe<Asset_Types_Order_By>;
  asset_type_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  festival_submission?: InputMaybe<Festival_Submissions_Order_By>;
  festival_submission_id?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: festival_submission_assets */
export type Festival_Submission_Assets_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "festival_submission_assets" */
export enum Festival_Submission_Assets_Select_Column {
  /** column name */
  AssetTypeId = 'asset_type_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FestivalSubmissionId = 'festival_submission_id',
  /** column name */
  FileName = 'file_name',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "festival_submission_assets" */
export type Festival_Submission_Assets_Set_Input = {
  asset_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  festival_submission_id?: InputMaybe<Scalars['Int']>;
  file_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Festival_Submission_Assets_Stddev_Fields = {
  __typename?: 'festival_submission_assets_stddev_fields';
  asset_type_id?: Maybe<Scalars['Float']>;
  festival_submission_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "festival_submission_assets" */
export type Festival_Submission_Assets_Stddev_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  festival_submission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Festival_Submission_Assets_Stddev_Pop_Fields = {
  __typename?: 'festival_submission_assets_stddev_pop_fields';
  asset_type_id?: Maybe<Scalars['Float']>;
  festival_submission_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "festival_submission_assets" */
export type Festival_Submission_Assets_Stddev_Pop_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  festival_submission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Festival_Submission_Assets_Stddev_Samp_Fields = {
  __typename?: 'festival_submission_assets_stddev_samp_fields';
  asset_type_id?: Maybe<Scalars['Float']>;
  festival_submission_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "festival_submission_assets" */
export type Festival_Submission_Assets_Stddev_Samp_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  festival_submission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "festival_submission_assets" */
export type Festival_Submission_Assets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Festival_Submission_Assets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Festival_Submission_Assets_Stream_Cursor_Value_Input = {
  asset_type_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  festival_submission_id?: InputMaybe<Scalars['Int']>;
  file_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Festival_Submission_Assets_Sum_Fields = {
  __typename?: 'festival_submission_assets_sum_fields';
  asset_type_id?: Maybe<Scalars['Int']>;
  festival_submission_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "festival_submission_assets" */
export type Festival_Submission_Assets_Sum_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  festival_submission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "festival_submission_assets" */
export enum Festival_Submission_Assets_Update_Column {
  /** column name */
  AssetTypeId = 'asset_type_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FestivalSubmissionId = 'festival_submission_id',
  /** column name */
  FileName = 'file_name',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Festival_Submission_Assets_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Festival_Submission_Assets_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Festival_Submission_Assets_Set_Input>;
  /** filter the rows which have to be updated */
  where: Festival_Submission_Assets_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Festival_Submission_Assets_Var_Pop_Fields = {
  __typename?: 'festival_submission_assets_var_pop_fields';
  asset_type_id?: Maybe<Scalars['Float']>;
  festival_submission_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "festival_submission_assets" */
export type Festival_Submission_Assets_Var_Pop_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  festival_submission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Festival_Submission_Assets_Var_Samp_Fields = {
  __typename?: 'festival_submission_assets_var_samp_fields';
  asset_type_id?: Maybe<Scalars['Float']>;
  festival_submission_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "festival_submission_assets" */
export type Festival_Submission_Assets_Var_Samp_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  festival_submission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Festival_Submission_Assets_Variance_Fields = {
  __typename?: 'festival_submission_assets_variance_fields';
  asset_type_id?: Maybe<Scalars['Float']>;
  festival_submission_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "festival_submission_assets" */
export type Festival_Submission_Assets_Variance_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  festival_submission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "festival_submission_feedback" */
export type Festival_Submission_Feedback = {
  __typename?: 'festival_submission_feedback';
  censored: Scalars['Boolean'];
  comments: Scalars['String'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  festival_submission: Festival_Submissions;
  festival_submission_id: Scalars['Int'];
  id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['Int'];
};

/** aggregated selection of "festival_submission_feedback" */
export type Festival_Submission_Feedback_Aggregate = {
  __typename?: 'festival_submission_feedback_aggregate';
  aggregate?: Maybe<Festival_Submission_Feedback_Aggregate_Fields>;
  nodes: Array<Festival_Submission_Feedback>;
};

export type Festival_Submission_Feedback_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Festival_Submission_Feedback_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Festival_Submission_Feedback_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Festival_Submission_Feedback_Aggregate_Bool_Exp_Count>;
};

export type Festival_Submission_Feedback_Aggregate_Bool_Exp_Bool_And = {
  arguments: Festival_Submission_Feedback_Select_Column_Festival_Submission_Feedback_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Festival_Submission_Feedback_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Festival_Submission_Feedback_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Festival_Submission_Feedback_Select_Column_Festival_Submission_Feedback_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Festival_Submission_Feedback_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Festival_Submission_Feedback_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Festival_Submission_Feedback_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Festival_Submission_Feedback_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "festival_submission_feedback" */
export type Festival_Submission_Feedback_Aggregate_Fields = {
  __typename?: 'festival_submission_feedback_aggregate_fields';
  avg?: Maybe<Festival_Submission_Feedback_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Festival_Submission_Feedback_Max_Fields>;
  min?: Maybe<Festival_Submission_Feedback_Min_Fields>;
  stddev?: Maybe<Festival_Submission_Feedback_Stddev_Fields>;
  stddev_pop?: Maybe<Festival_Submission_Feedback_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Festival_Submission_Feedback_Stddev_Samp_Fields>;
  sum?: Maybe<Festival_Submission_Feedback_Sum_Fields>;
  var_pop?: Maybe<Festival_Submission_Feedback_Var_Pop_Fields>;
  var_samp?: Maybe<Festival_Submission_Feedback_Var_Samp_Fields>;
  variance?: Maybe<Festival_Submission_Feedback_Variance_Fields>;
};


/** aggregate fields of "festival_submission_feedback" */
export type Festival_Submission_Feedback_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Festival_Submission_Feedback_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "festival_submission_feedback" */
export type Festival_Submission_Feedback_Aggregate_Order_By = {
  avg?: InputMaybe<Festival_Submission_Feedback_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Festival_Submission_Feedback_Max_Order_By>;
  min?: InputMaybe<Festival_Submission_Feedback_Min_Order_By>;
  stddev?: InputMaybe<Festival_Submission_Feedback_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Festival_Submission_Feedback_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Festival_Submission_Feedback_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Festival_Submission_Feedback_Sum_Order_By>;
  var_pop?: InputMaybe<Festival_Submission_Feedback_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Festival_Submission_Feedback_Var_Samp_Order_By>;
  variance?: InputMaybe<Festival_Submission_Feedback_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "festival_submission_feedback" */
export type Festival_Submission_Feedback_Arr_Rel_Insert_Input = {
  data: Array<Festival_Submission_Feedback_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Festival_Submission_Feedback_On_Conflict>;
};

/** aggregate avg on columns */
export type Festival_Submission_Feedback_Avg_Fields = {
  __typename?: 'festival_submission_feedback_avg_fields';
  festival_submission_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "festival_submission_feedback" */
export type Festival_Submission_Feedback_Avg_Order_By = {
  festival_submission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "festival_submission_feedback". All fields are combined with a logical 'AND'. */
export type Festival_Submission_Feedback_Bool_Exp = {
  _and?: InputMaybe<Array<Festival_Submission_Feedback_Bool_Exp>>;
  _not?: InputMaybe<Festival_Submission_Feedback_Bool_Exp>;
  _or?: InputMaybe<Array<Festival_Submission_Feedback_Bool_Exp>>;
  censored?: InputMaybe<Boolean_Comparison_Exp>;
  comments?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  festival_submission?: InputMaybe<Festival_Submissions_Bool_Exp>;
  festival_submission_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "festival_submission_feedback" */
export enum Festival_Submission_Feedback_Constraint {
  /** unique or primary key constraint on columns "festival_submission_id", "user_id" */
  FestivalSubmissionFeedbackFestivalSubmissionIdUserIdKey = 'festival_submission_feedback_festival_submission_id_user_id_key',
  /** unique or primary key constraint on columns "id" */
  FestivalSubmissionFeedbackPkey = 'festival_submission_feedback_pkey'
}

/** input type for incrementing numeric columns in table "festival_submission_feedback" */
export type Festival_Submission_Feedback_Inc_Input = {
  festival_submission_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "festival_submission_feedback" */
export type Festival_Submission_Feedback_Insert_Input = {
  censored?: InputMaybe<Scalars['Boolean']>;
  comments?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  festival_submission?: InputMaybe<Festival_Submissions_Obj_Rel_Insert_Input>;
  festival_submission_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Festival_Submission_Feedback_Max_Fields = {
  __typename?: 'festival_submission_feedback_max_fields';
  comments?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  festival_submission_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "festival_submission_feedback" */
export type Festival_Submission_Feedback_Max_Order_By = {
  comments?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  festival_submission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Festival_Submission_Feedback_Min_Fields = {
  __typename?: 'festival_submission_feedback_min_fields';
  comments?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  festival_submission_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "festival_submission_feedback" */
export type Festival_Submission_Feedback_Min_Order_By = {
  comments?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  festival_submission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "festival_submission_feedback" */
export type Festival_Submission_Feedback_Mutation_Response = {
  __typename?: 'festival_submission_feedback_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Festival_Submission_Feedback>;
};

/** on_conflict condition type for table "festival_submission_feedback" */
export type Festival_Submission_Feedback_On_Conflict = {
  constraint: Festival_Submission_Feedback_Constraint;
  update_columns?: Array<Festival_Submission_Feedback_Update_Column>;
  where?: InputMaybe<Festival_Submission_Feedback_Bool_Exp>;
};

/** Ordering options when selecting data from "festival_submission_feedback". */
export type Festival_Submission_Feedback_Order_By = {
  censored?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  festival_submission?: InputMaybe<Festival_Submissions_Order_By>;
  festival_submission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: festival_submission_feedback */
export type Festival_Submission_Feedback_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "festival_submission_feedback" */
export enum Festival_Submission_Feedback_Select_Column {
  /** column name */
  Censored = 'censored',
  /** column name */
  Comments = 'comments',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FestivalSubmissionId = 'festival_submission_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "festival_submission_feedback_aggregate_bool_exp_bool_and_arguments_columns" columns of table "festival_submission_feedback" */
export enum Festival_Submission_Feedback_Select_Column_Festival_Submission_Feedback_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Censored = 'censored'
}

/** select "festival_submission_feedback_aggregate_bool_exp_bool_or_arguments_columns" columns of table "festival_submission_feedback" */
export enum Festival_Submission_Feedback_Select_Column_Festival_Submission_Feedback_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Censored = 'censored'
}

/** input type for updating data in table "festival_submission_feedback" */
export type Festival_Submission_Feedback_Set_Input = {
  censored?: InputMaybe<Scalars['Boolean']>;
  comments?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  festival_submission_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Festival_Submission_Feedback_Stddev_Fields = {
  __typename?: 'festival_submission_feedback_stddev_fields';
  festival_submission_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "festival_submission_feedback" */
export type Festival_Submission_Feedback_Stddev_Order_By = {
  festival_submission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Festival_Submission_Feedback_Stddev_Pop_Fields = {
  __typename?: 'festival_submission_feedback_stddev_pop_fields';
  festival_submission_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "festival_submission_feedback" */
export type Festival_Submission_Feedback_Stddev_Pop_Order_By = {
  festival_submission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Festival_Submission_Feedback_Stddev_Samp_Fields = {
  __typename?: 'festival_submission_feedback_stddev_samp_fields';
  festival_submission_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "festival_submission_feedback" */
export type Festival_Submission_Feedback_Stddev_Samp_Order_By = {
  festival_submission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "festival_submission_feedback" */
export type Festival_Submission_Feedback_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Festival_Submission_Feedback_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Festival_Submission_Feedback_Stream_Cursor_Value_Input = {
  censored?: InputMaybe<Scalars['Boolean']>;
  comments?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  festival_submission_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Festival_Submission_Feedback_Sum_Fields = {
  __typename?: 'festival_submission_feedback_sum_fields';
  festival_submission_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "festival_submission_feedback" */
export type Festival_Submission_Feedback_Sum_Order_By = {
  festival_submission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "festival_submission_feedback" */
export enum Festival_Submission_Feedback_Update_Column {
  /** column name */
  Censored = 'censored',
  /** column name */
  Comments = 'comments',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FestivalSubmissionId = 'festival_submission_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Festival_Submission_Feedback_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Festival_Submission_Feedback_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Festival_Submission_Feedback_Set_Input>;
  /** filter the rows which have to be updated */
  where: Festival_Submission_Feedback_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Festival_Submission_Feedback_Var_Pop_Fields = {
  __typename?: 'festival_submission_feedback_var_pop_fields';
  festival_submission_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "festival_submission_feedback" */
export type Festival_Submission_Feedback_Var_Pop_Order_By = {
  festival_submission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Festival_Submission_Feedback_Var_Samp_Fields = {
  __typename?: 'festival_submission_feedback_var_samp_fields';
  festival_submission_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "festival_submission_feedback" */
export type Festival_Submission_Feedback_Var_Samp_Order_By = {
  festival_submission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Festival_Submission_Feedback_Variance_Fields = {
  __typename?: 'festival_submission_feedback_variance_fields';
  festival_submission_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "festival_submission_feedback" */
export type Festival_Submission_Feedback_Variance_Order_By = {
  festival_submission_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "festival_submission_vouchers" */
export type Festival_Submission_Vouchers = {
  __typename?: 'festival_submission_vouchers';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  festival_submission?: Maybe<Festival_Submissions>;
  festival_submission_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  film_festival: Film_Festivals;
  film_festival_id: Scalars['Int'];
  id: Scalars['Int'];
  redeemed_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  team: Teams;
  team_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['Int'];
};

/** aggregated selection of "festival_submission_vouchers" */
export type Festival_Submission_Vouchers_Aggregate = {
  __typename?: 'festival_submission_vouchers_aggregate';
  aggregate?: Maybe<Festival_Submission_Vouchers_Aggregate_Fields>;
  nodes: Array<Festival_Submission_Vouchers>;
};

export type Festival_Submission_Vouchers_Aggregate_Bool_Exp = {
  count?: InputMaybe<Festival_Submission_Vouchers_Aggregate_Bool_Exp_Count>;
};

export type Festival_Submission_Vouchers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Festival_Submission_Vouchers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Festival_Submission_Vouchers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "festival_submission_vouchers" */
export type Festival_Submission_Vouchers_Aggregate_Fields = {
  __typename?: 'festival_submission_vouchers_aggregate_fields';
  avg?: Maybe<Festival_Submission_Vouchers_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Festival_Submission_Vouchers_Max_Fields>;
  min?: Maybe<Festival_Submission_Vouchers_Min_Fields>;
  stddev?: Maybe<Festival_Submission_Vouchers_Stddev_Fields>;
  stddev_pop?: Maybe<Festival_Submission_Vouchers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Festival_Submission_Vouchers_Stddev_Samp_Fields>;
  sum?: Maybe<Festival_Submission_Vouchers_Sum_Fields>;
  var_pop?: Maybe<Festival_Submission_Vouchers_Var_Pop_Fields>;
  var_samp?: Maybe<Festival_Submission_Vouchers_Var_Samp_Fields>;
  variance?: Maybe<Festival_Submission_Vouchers_Variance_Fields>;
};


/** aggregate fields of "festival_submission_vouchers" */
export type Festival_Submission_Vouchers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Festival_Submission_Vouchers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "festival_submission_vouchers" */
export type Festival_Submission_Vouchers_Aggregate_Order_By = {
  avg?: InputMaybe<Festival_Submission_Vouchers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Festival_Submission_Vouchers_Max_Order_By>;
  min?: InputMaybe<Festival_Submission_Vouchers_Min_Order_By>;
  stddev?: InputMaybe<Festival_Submission_Vouchers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Festival_Submission_Vouchers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Festival_Submission_Vouchers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Festival_Submission_Vouchers_Sum_Order_By>;
  var_pop?: InputMaybe<Festival_Submission_Vouchers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Festival_Submission_Vouchers_Var_Samp_Order_By>;
  variance?: InputMaybe<Festival_Submission_Vouchers_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "festival_submission_vouchers" */
export type Festival_Submission_Vouchers_Arr_Rel_Insert_Input = {
  data: Array<Festival_Submission_Vouchers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Festival_Submission_Vouchers_On_Conflict>;
};

/** aggregate avg on columns */
export type Festival_Submission_Vouchers_Avg_Fields = {
  __typename?: 'festival_submission_vouchers_avg_fields';
  festival_submission_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "festival_submission_vouchers" */
export type Festival_Submission_Vouchers_Avg_Order_By = {
  festival_submission_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "festival_submission_vouchers". All fields are combined with a logical 'AND'. */
export type Festival_Submission_Vouchers_Bool_Exp = {
  _and?: InputMaybe<Array<Festival_Submission_Vouchers_Bool_Exp>>;
  _not?: InputMaybe<Festival_Submission_Vouchers_Bool_Exp>;
  _or?: InputMaybe<Array<Festival_Submission_Vouchers_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  festival_submission?: InputMaybe<Festival_Submissions_Bool_Exp>;
  festival_submission_id?: InputMaybe<Int_Comparison_Exp>;
  film_festival?: InputMaybe<Film_Festivals_Bool_Exp>;
  film_festival_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  redeemed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "festival_submission_vouchers" */
export enum Festival_Submission_Vouchers_Constraint {
  /** unique or primary key constraint on columns "id" */
  FestivalSubmissionVouchersPkey = 'festival_submission_vouchers_pkey'
}

/** input type for incrementing numeric columns in table "festival_submission_vouchers" */
export type Festival_Submission_Vouchers_Inc_Input = {
  festival_submission_id?: InputMaybe<Scalars['Int']>;
  film_festival_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "festival_submission_vouchers" */
export type Festival_Submission_Vouchers_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  festival_submission?: InputMaybe<Festival_Submissions_Obj_Rel_Insert_Input>;
  festival_submission_id?: InputMaybe<Scalars['Int']>;
  film_festival?: InputMaybe<Film_Festivals_Obj_Rel_Insert_Input>;
  film_festival_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  redeemed_at?: InputMaybe<Scalars['timestamptz']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Festival_Submission_Vouchers_Max_Fields = {
  __typename?: 'festival_submission_vouchers_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  festival_submission_id?: Maybe<Scalars['Int']>;
  film_festival_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  redeemed_at?: Maybe<Scalars['timestamptz']>;
  team_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "festival_submission_vouchers" */
export type Festival_Submission_Vouchers_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  festival_submission_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  redeemed_at?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Festival_Submission_Vouchers_Min_Fields = {
  __typename?: 'festival_submission_vouchers_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  festival_submission_id?: Maybe<Scalars['Int']>;
  film_festival_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  redeemed_at?: Maybe<Scalars['timestamptz']>;
  team_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "festival_submission_vouchers" */
export type Festival_Submission_Vouchers_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  festival_submission_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  redeemed_at?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "festival_submission_vouchers" */
export type Festival_Submission_Vouchers_Mutation_Response = {
  __typename?: 'festival_submission_vouchers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Festival_Submission_Vouchers>;
};

/** on_conflict condition type for table "festival_submission_vouchers" */
export type Festival_Submission_Vouchers_On_Conflict = {
  constraint: Festival_Submission_Vouchers_Constraint;
  update_columns?: Array<Festival_Submission_Vouchers_Update_Column>;
  where?: InputMaybe<Festival_Submission_Vouchers_Bool_Exp>;
};

/** Ordering options when selecting data from "festival_submission_vouchers". */
export type Festival_Submission_Vouchers_Order_By = {
  created_at?: InputMaybe<Order_By>;
  festival_submission?: InputMaybe<Festival_Submissions_Order_By>;
  festival_submission_id?: InputMaybe<Order_By>;
  film_festival?: InputMaybe<Film_Festivals_Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  redeemed_at?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: festival_submission_vouchers */
export type Festival_Submission_Vouchers_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "festival_submission_vouchers" */
export enum Festival_Submission_Vouchers_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FestivalSubmissionId = 'festival_submission_id',
  /** column name */
  FilmFestivalId = 'film_festival_id',
  /** column name */
  Id = 'id',
  /** column name */
  RedeemedAt = 'redeemed_at',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "festival_submission_vouchers" */
export type Festival_Submission_Vouchers_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  festival_submission_id?: InputMaybe<Scalars['Int']>;
  film_festival_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  redeemed_at?: InputMaybe<Scalars['timestamptz']>;
  team_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Festival_Submission_Vouchers_Stddev_Fields = {
  __typename?: 'festival_submission_vouchers_stddev_fields';
  festival_submission_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "festival_submission_vouchers" */
export type Festival_Submission_Vouchers_Stddev_Order_By = {
  festival_submission_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Festival_Submission_Vouchers_Stddev_Pop_Fields = {
  __typename?: 'festival_submission_vouchers_stddev_pop_fields';
  festival_submission_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "festival_submission_vouchers" */
export type Festival_Submission_Vouchers_Stddev_Pop_Order_By = {
  festival_submission_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Festival_Submission_Vouchers_Stddev_Samp_Fields = {
  __typename?: 'festival_submission_vouchers_stddev_samp_fields';
  festival_submission_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "festival_submission_vouchers" */
export type Festival_Submission_Vouchers_Stddev_Samp_Order_By = {
  festival_submission_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "festival_submission_vouchers" */
export type Festival_Submission_Vouchers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Festival_Submission_Vouchers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Festival_Submission_Vouchers_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  festival_submission_id?: InputMaybe<Scalars['Int']>;
  film_festival_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  redeemed_at?: InputMaybe<Scalars['timestamptz']>;
  team_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Festival_Submission_Vouchers_Sum_Fields = {
  __typename?: 'festival_submission_vouchers_sum_fields';
  festival_submission_id?: Maybe<Scalars['Int']>;
  film_festival_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "festival_submission_vouchers" */
export type Festival_Submission_Vouchers_Sum_Order_By = {
  festival_submission_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "festival_submission_vouchers" */
export enum Festival_Submission_Vouchers_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FestivalSubmissionId = 'festival_submission_id',
  /** column name */
  FilmFestivalId = 'film_festival_id',
  /** column name */
  Id = 'id',
  /** column name */
  RedeemedAt = 'redeemed_at',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Festival_Submission_Vouchers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Festival_Submission_Vouchers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Festival_Submission_Vouchers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Festival_Submission_Vouchers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Festival_Submission_Vouchers_Var_Pop_Fields = {
  __typename?: 'festival_submission_vouchers_var_pop_fields';
  festival_submission_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "festival_submission_vouchers" */
export type Festival_Submission_Vouchers_Var_Pop_Order_By = {
  festival_submission_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Festival_Submission_Vouchers_Var_Samp_Fields = {
  __typename?: 'festival_submission_vouchers_var_samp_fields';
  festival_submission_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "festival_submission_vouchers" */
export type Festival_Submission_Vouchers_Var_Samp_Order_By = {
  festival_submission_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Festival_Submission_Vouchers_Variance_Fields = {
  __typename?: 'festival_submission_vouchers_variance_fields';
  festival_submission_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "festival_submission_vouchers" */
export type Festival_Submission_Vouchers_Variance_Order_By = {
  festival_submission_id?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "festival_submissions" */
export type Festival_Submissions = {
  __typename?: 'festival_submissions';
  address_1: Scalars['String'];
  address_2?: Maybe<Scalars['String']>;
  /** An array relationship */
  assets: Array<Festival_Submission_Assets>;
  /** An aggregate relationship */
  assets_aggregate: Festival_Submission_Assets_Aggregate;
  city: Scalars['String'];
  comments?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  feedback: Array<Festival_Submission_Feedback>;
  /** An aggregate relationship */
  feedback_aggregate: Festival_Submission_Feedback_Aggregate;
  /** An object relationship */
  film_festival: Film_Festivals;
  film_festival_id: Scalars['Int'];
  /** An array relationship */
  film_groups: Array<Film_Group_Festival_Submissions>;
  /** An aggregate relationship */
  film_groups_aggregate: Film_Group_Festival_Submissions_Aggregate;
  film_title: Scalars['String'];
  first_name: Scalars['String'];
  /** An object relationship */
  genre: Festival_Genres;
  genre_id: Scalars['Int'];
  id: Scalars['Int'];
  is_minor?: Maybe<Scalars['Boolean']>;
  last_name: Scalars['String'];
  middle_name?: Maybe<Scalars['String']>;
  mux_asset_data?: Maybe<Scalars['jsonb']>;
  mux_asset_id?: Maybe<Scalars['String']>;
  mux_playback_id?: Maybe<Scalars['String']>;
  mux_thumbnail_time?: Maybe<Scalars['numeric']>;
  mux_upload_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  owner: Users;
  owner_id: Scalars['Int'];
  paid_at?: Maybe<Scalars['timestamptz']>;
  primary_email: Scalars['String'];
  primary_phone: Scalars['String'];
  production_company: Scalars['String'];
  production_year: Scalars['String'];
  secondary_email?: Maybe<Scalars['String']>;
  secondary_phone?: Maybe<Scalars['String']>;
  signature_email?: Maybe<Scalars['String']>;
  signature_ip?: Maybe<Scalars['String']>;
  signature_name?: Maybe<Scalars['String']>;
  signature_phone?: Maybe<Scalars['String']>;
  signature_ts?: Maybe<Scalars['timestamptz']>;
  state: Scalars['String'];
  stripe_payment_id?: Maybe<Scalars['String']>;
  submitted_at?: Maybe<Scalars['timestamptz']>;
  synopsis: Scalars['String'];
  tagline?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  vouchers: Array<Festival_Submission_Vouchers>;
  /** An aggregate relationship */
  vouchers_aggregate: Festival_Submission_Vouchers_Aggregate;
  zip: Scalars['String'];
};


/** columns and relationships of "festival_submissions" */
export type Festival_SubmissionsAssetsArgs = {
  distinct_on?: InputMaybe<Array<Festival_Submission_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Submission_Assets_Order_By>>;
  where?: InputMaybe<Festival_Submission_Assets_Bool_Exp>;
};


/** columns and relationships of "festival_submissions" */
export type Festival_SubmissionsAssets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Submission_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Submission_Assets_Order_By>>;
  where?: InputMaybe<Festival_Submission_Assets_Bool_Exp>;
};


/** columns and relationships of "festival_submissions" */
export type Festival_SubmissionsFeedbackArgs = {
  distinct_on?: InputMaybe<Array<Festival_Submission_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Submission_Feedback_Order_By>>;
  where?: InputMaybe<Festival_Submission_Feedback_Bool_Exp>;
};


/** columns and relationships of "festival_submissions" */
export type Festival_SubmissionsFeedback_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Submission_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Submission_Feedback_Order_By>>;
  where?: InputMaybe<Festival_Submission_Feedback_Bool_Exp>;
};


/** columns and relationships of "festival_submissions" */
export type Festival_SubmissionsFilm_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Film_Group_Festival_Submissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Film_Group_Festival_Submissions_Order_By>>;
  where?: InputMaybe<Film_Group_Festival_Submissions_Bool_Exp>;
};


/** columns and relationships of "festival_submissions" */
export type Festival_SubmissionsFilm_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Film_Group_Festival_Submissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Film_Group_Festival_Submissions_Order_By>>;
  where?: InputMaybe<Film_Group_Festival_Submissions_Bool_Exp>;
};


/** columns and relationships of "festival_submissions" */
export type Festival_SubmissionsMux_Asset_DataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "festival_submissions" */
export type Festival_SubmissionsVouchersArgs = {
  distinct_on?: InputMaybe<Array<Festival_Submission_Vouchers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Submission_Vouchers_Order_By>>;
  where?: InputMaybe<Festival_Submission_Vouchers_Bool_Exp>;
};


/** columns and relationships of "festival_submissions" */
export type Festival_SubmissionsVouchers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Submission_Vouchers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Submission_Vouchers_Order_By>>;
  where?: InputMaybe<Festival_Submission_Vouchers_Bool_Exp>;
};

/** aggregated selection of "festival_submissions" */
export type Festival_Submissions_Aggregate = {
  __typename?: 'festival_submissions_aggregate';
  aggregate?: Maybe<Festival_Submissions_Aggregate_Fields>;
  nodes: Array<Festival_Submissions>;
};

/** aggregate fields of "festival_submissions" */
export type Festival_Submissions_Aggregate_Fields = {
  __typename?: 'festival_submissions_aggregate_fields';
  avg?: Maybe<Festival_Submissions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Festival_Submissions_Max_Fields>;
  min?: Maybe<Festival_Submissions_Min_Fields>;
  stddev?: Maybe<Festival_Submissions_Stddev_Fields>;
  stddev_pop?: Maybe<Festival_Submissions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Festival_Submissions_Stddev_Samp_Fields>;
  sum?: Maybe<Festival_Submissions_Sum_Fields>;
  var_pop?: Maybe<Festival_Submissions_Var_Pop_Fields>;
  var_samp?: Maybe<Festival_Submissions_Var_Samp_Fields>;
  variance?: Maybe<Festival_Submissions_Variance_Fields>;
};


/** aggregate fields of "festival_submissions" */
export type Festival_Submissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Festival_Submissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Festival_Submissions_Append_Input = {
  mux_asset_data?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Festival_Submissions_Avg_Fields = {
  __typename?: 'festival_submissions_avg_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  genre_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mux_thumbnail_time?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "festival_submissions". All fields are combined with a logical 'AND'. */
export type Festival_Submissions_Bool_Exp = {
  _and?: InputMaybe<Array<Festival_Submissions_Bool_Exp>>;
  _not?: InputMaybe<Festival_Submissions_Bool_Exp>;
  _or?: InputMaybe<Array<Festival_Submissions_Bool_Exp>>;
  address_1?: InputMaybe<String_Comparison_Exp>;
  address_2?: InputMaybe<String_Comparison_Exp>;
  assets?: InputMaybe<Festival_Submission_Assets_Bool_Exp>;
  assets_aggregate?: InputMaybe<Festival_Submission_Assets_Aggregate_Bool_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  comments?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  feedback?: InputMaybe<Festival_Submission_Feedback_Bool_Exp>;
  feedback_aggregate?: InputMaybe<Festival_Submission_Feedback_Aggregate_Bool_Exp>;
  film_festival?: InputMaybe<Film_Festivals_Bool_Exp>;
  film_festival_id?: InputMaybe<Int_Comparison_Exp>;
  film_groups?: InputMaybe<Film_Group_Festival_Submissions_Bool_Exp>;
  film_groups_aggregate?: InputMaybe<Film_Group_Festival_Submissions_Aggregate_Bool_Exp>;
  film_title?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  genre?: InputMaybe<Festival_Genres_Bool_Exp>;
  genre_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_minor?: InputMaybe<Boolean_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  middle_name?: InputMaybe<String_Comparison_Exp>;
  mux_asset_data?: InputMaybe<Jsonb_Comparison_Exp>;
  mux_asset_id?: InputMaybe<String_Comparison_Exp>;
  mux_playback_id?: InputMaybe<String_Comparison_Exp>;
  mux_thumbnail_time?: InputMaybe<Numeric_Comparison_Exp>;
  mux_upload_id?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<Users_Bool_Exp>;
  owner_id?: InputMaybe<Int_Comparison_Exp>;
  paid_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  primary_email?: InputMaybe<String_Comparison_Exp>;
  primary_phone?: InputMaybe<String_Comparison_Exp>;
  production_company?: InputMaybe<String_Comparison_Exp>;
  production_year?: InputMaybe<String_Comparison_Exp>;
  secondary_email?: InputMaybe<String_Comparison_Exp>;
  secondary_phone?: InputMaybe<String_Comparison_Exp>;
  signature_email?: InputMaybe<String_Comparison_Exp>;
  signature_ip?: InputMaybe<String_Comparison_Exp>;
  signature_name?: InputMaybe<String_Comparison_Exp>;
  signature_phone?: InputMaybe<String_Comparison_Exp>;
  signature_ts?: InputMaybe<Timestamptz_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  stripe_payment_id?: InputMaybe<String_Comparison_Exp>;
  submitted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  synopsis?: InputMaybe<String_Comparison_Exp>;
  tagline?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vouchers?: InputMaybe<Festival_Submission_Vouchers_Bool_Exp>;
  vouchers_aggregate?: InputMaybe<Festival_Submission_Vouchers_Aggregate_Bool_Exp>;
  zip?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "festival_submissions" */
export enum Festival_Submissions_Constraint {
  /** unique or primary key constraint on columns "id" */
  FestivalSubmissionsPkey = 'festival_submissions_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Festival_Submissions_Delete_At_Path_Input = {
  mux_asset_data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Festival_Submissions_Delete_Elem_Input = {
  mux_asset_data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Festival_Submissions_Delete_Key_Input = {
  mux_asset_data?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "festival_submissions" */
export type Festival_Submissions_Inc_Input = {
  film_festival_id?: InputMaybe<Scalars['Int']>;
  genre_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  mux_thumbnail_time?: InputMaybe<Scalars['numeric']>;
  owner_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "festival_submissions" */
export type Festival_Submissions_Insert_Input = {
  address_1?: InputMaybe<Scalars['String']>;
  address_2?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<Festival_Submission_Assets_Arr_Rel_Insert_Input>;
  city?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  feedback?: InputMaybe<Festival_Submission_Feedback_Arr_Rel_Insert_Input>;
  film_festival?: InputMaybe<Film_Festivals_Obj_Rel_Insert_Input>;
  film_festival_id?: InputMaybe<Scalars['Int']>;
  film_groups?: InputMaybe<Film_Group_Festival_Submissions_Arr_Rel_Insert_Input>;
  film_title?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  genre?: InputMaybe<Festival_Genres_Obj_Rel_Insert_Input>;
  genre_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_minor?: InputMaybe<Scalars['Boolean']>;
  last_name?: InputMaybe<Scalars['String']>;
  middle_name?: InputMaybe<Scalars['String']>;
  mux_asset_data?: InputMaybe<Scalars['jsonb']>;
  mux_asset_id?: InputMaybe<Scalars['String']>;
  mux_playback_id?: InputMaybe<Scalars['String']>;
  mux_thumbnail_time?: InputMaybe<Scalars['numeric']>;
  mux_upload_id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  owner_id?: InputMaybe<Scalars['Int']>;
  paid_at?: InputMaybe<Scalars['timestamptz']>;
  primary_email?: InputMaybe<Scalars['String']>;
  primary_phone?: InputMaybe<Scalars['String']>;
  production_company?: InputMaybe<Scalars['String']>;
  production_year?: InputMaybe<Scalars['String']>;
  secondary_email?: InputMaybe<Scalars['String']>;
  secondary_phone?: InputMaybe<Scalars['String']>;
  signature_email?: InputMaybe<Scalars['String']>;
  signature_ip?: InputMaybe<Scalars['String']>;
  signature_name?: InputMaybe<Scalars['String']>;
  signature_phone?: InputMaybe<Scalars['String']>;
  signature_ts?: InputMaybe<Scalars['timestamptz']>;
  state?: InputMaybe<Scalars['String']>;
  stripe_payment_id?: InputMaybe<Scalars['String']>;
  submitted_at?: InputMaybe<Scalars['timestamptz']>;
  synopsis?: InputMaybe<Scalars['String']>;
  tagline?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  vouchers?: InputMaybe<Festival_Submission_Vouchers_Arr_Rel_Insert_Input>;
  zip?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Festival_Submissions_Max_Fields = {
  __typename?: 'festival_submissions_max_fields';
  address_1?: Maybe<Scalars['String']>;
  address_2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  film_festival_id?: Maybe<Scalars['Int']>;
  film_title?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  genre_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  last_name?: Maybe<Scalars['String']>;
  middle_name?: Maybe<Scalars['String']>;
  mux_asset_id?: Maybe<Scalars['String']>;
  mux_playback_id?: Maybe<Scalars['String']>;
  mux_thumbnail_time?: Maybe<Scalars['numeric']>;
  mux_upload_id?: Maybe<Scalars['String']>;
  owner_id?: Maybe<Scalars['Int']>;
  paid_at?: Maybe<Scalars['timestamptz']>;
  primary_email?: Maybe<Scalars['String']>;
  primary_phone?: Maybe<Scalars['String']>;
  production_company?: Maybe<Scalars['String']>;
  production_year?: Maybe<Scalars['String']>;
  secondary_email?: Maybe<Scalars['String']>;
  secondary_phone?: Maybe<Scalars['String']>;
  signature_email?: Maybe<Scalars['String']>;
  signature_ip?: Maybe<Scalars['String']>;
  signature_name?: Maybe<Scalars['String']>;
  signature_phone?: Maybe<Scalars['String']>;
  signature_ts?: Maybe<Scalars['timestamptz']>;
  state?: Maybe<Scalars['String']>;
  stripe_payment_id?: Maybe<Scalars['String']>;
  submitted_at?: Maybe<Scalars['timestamptz']>;
  synopsis?: Maybe<Scalars['String']>;
  tagline?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zip?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Festival_Submissions_Min_Fields = {
  __typename?: 'festival_submissions_min_fields';
  address_1?: Maybe<Scalars['String']>;
  address_2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  film_festival_id?: Maybe<Scalars['Int']>;
  film_title?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  genre_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  last_name?: Maybe<Scalars['String']>;
  middle_name?: Maybe<Scalars['String']>;
  mux_asset_id?: Maybe<Scalars['String']>;
  mux_playback_id?: Maybe<Scalars['String']>;
  mux_thumbnail_time?: Maybe<Scalars['numeric']>;
  mux_upload_id?: Maybe<Scalars['String']>;
  owner_id?: Maybe<Scalars['Int']>;
  paid_at?: Maybe<Scalars['timestamptz']>;
  primary_email?: Maybe<Scalars['String']>;
  primary_phone?: Maybe<Scalars['String']>;
  production_company?: Maybe<Scalars['String']>;
  production_year?: Maybe<Scalars['String']>;
  secondary_email?: Maybe<Scalars['String']>;
  secondary_phone?: Maybe<Scalars['String']>;
  signature_email?: Maybe<Scalars['String']>;
  signature_ip?: Maybe<Scalars['String']>;
  signature_name?: Maybe<Scalars['String']>;
  signature_phone?: Maybe<Scalars['String']>;
  signature_ts?: Maybe<Scalars['timestamptz']>;
  state?: Maybe<Scalars['String']>;
  stripe_payment_id?: Maybe<Scalars['String']>;
  submitted_at?: Maybe<Scalars['timestamptz']>;
  synopsis?: Maybe<Scalars['String']>;
  tagline?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zip?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "festival_submissions" */
export type Festival_Submissions_Mutation_Response = {
  __typename?: 'festival_submissions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Festival_Submissions>;
};

/** input type for inserting object relation for remote table "festival_submissions" */
export type Festival_Submissions_Obj_Rel_Insert_Input = {
  data: Festival_Submissions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Festival_Submissions_On_Conflict>;
};

/** on_conflict condition type for table "festival_submissions" */
export type Festival_Submissions_On_Conflict = {
  constraint: Festival_Submissions_Constraint;
  update_columns?: Array<Festival_Submissions_Update_Column>;
  where?: InputMaybe<Festival_Submissions_Bool_Exp>;
};

/** Ordering options when selecting data from "festival_submissions". */
export type Festival_Submissions_Order_By = {
  address_1?: InputMaybe<Order_By>;
  address_2?: InputMaybe<Order_By>;
  assets_aggregate?: InputMaybe<Festival_Submission_Assets_Aggregate_Order_By>;
  city?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  feedback_aggregate?: InputMaybe<Festival_Submission_Feedback_Aggregate_Order_By>;
  film_festival?: InputMaybe<Film_Festivals_Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  film_groups_aggregate?: InputMaybe<Film_Group_Festival_Submissions_Aggregate_Order_By>;
  film_title?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  genre?: InputMaybe<Festival_Genres_Order_By>;
  genre_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_minor?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  middle_name?: InputMaybe<Order_By>;
  mux_asset_data?: InputMaybe<Order_By>;
  mux_asset_id?: InputMaybe<Order_By>;
  mux_playback_id?: InputMaybe<Order_By>;
  mux_thumbnail_time?: InputMaybe<Order_By>;
  mux_upload_id?: InputMaybe<Order_By>;
  owner?: InputMaybe<Users_Order_By>;
  owner_id?: InputMaybe<Order_By>;
  paid_at?: InputMaybe<Order_By>;
  primary_email?: InputMaybe<Order_By>;
  primary_phone?: InputMaybe<Order_By>;
  production_company?: InputMaybe<Order_By>;
  production_year?: InputMaybe<Order_By>;
  secondary_email?: InputMaybe<Order_By>;
  secondary_phone?: InputMaybe<Order_By>;
  signature_email?: InputMaybe<Order_By>;
  signature_ip?: InputMaybe<Order_By>;
  signature_name?: InputMaybe<Order_By>;
  signature_phone?: InputMaybe<Order_By>;
  signature_ts?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  stripe_payment_id?: InputMaybe<Order_By>;
  submitted_at?: InputMaybe<Order_By>;
  synopsis?: InputMaybe<Order_By>;
  tagline?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vouchers_aggregate?: InputMaybe<Festival_Submission_Vouchers_Aggregate_Order_By>;
  zip?: InputMaybe<Order_By>;
};

/** primary key columns input for table: festival_submissions */
export type Festival_Submissions_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Festival_Submissions_Prepend_Input = {
  mux_asset_data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "festival_submissions" */
export enum Festival_Submissions_Select_Column {
  /** column name */
  Address_1 = 'address_1',
  /** column name */
  Address_2 = 'address_2',
  /** column name */
  City = 'city',
  /** column name */
  Comments = 'comments',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FilmFestivalId = 'film_festival_id',
  /** column name */
  FilmTitle = 'film_title',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  GenreId = 'genre_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsMinor = 'is_minor',
  /** column name */
  LastName = 'last_name',
  /** column name */
  MiddleName = 'middle_name',
  /** column name */
  MuxAssetData = 'mux_asset_data',
  /** column name */
  MuxAssetId = 'mux_asset_id',
  /** column name */
  MuxPlaybackId = 'mux_playback_id',
  /** column name */
  MuxThumbnailTime = 'mux_thumbnail_time',
  /** column name */
  MuxUploadId = 'mux_upload_id',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  PaidAt = 'paid_at',
  /** column name */
  PrimaryEmail = 'primary_email',
  /** column name */
  PrimaryPhone = 'primary_phone',
  /** column name */
  ProductionCompany = 'production_company',
  /** column name */
  ProductionYear = 'production_year',
  /** column name */
  SecondaryEmail = 'secondary_email',
  /** column name */
  SecondaryPhone = 'secondary_phone',
  /** column name */
  SignatureEmail = 'signature_email',
  /** column name */
  SignatureIp = 'signature_ip',
  /** column name */
  SignatureName = 'signature_name',
  /** column name */
  SignaturePhone = 'signature_phone',
  /** column name */
  SignatureTs = 'signature_ts',
  /** column name */
  State = 'state',
  /** column name */
  StripePaymentId = 'stripe_payment_id',
  /** column name */
  SubmittedAt = 'submitted_at',
  /** column name */
  Synopsis = 'synopsis',
  /** column name */
  Tagline = 'tagline',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Zip = 'zip'
}

/** input type for updating data in table "festival_submissions" */
export type Festival_Submissions_Set_Input = {
  address_1?: InputMaybe<Scalars['String']>;
  address_2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  film_festival_id?: InputMaybe<Scalars['Int']>;
  film_title?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  genre_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_minor?: InputMaybe<Scalars['Boolean']>;
  last_name?: InputMaybe<Scalars['String']>;
  middle_name?: InputMaybe<Scalars['String']>;
  mux_asset_data?: InputMaybe<Scalars['jsonb']>;
  mux_asset_id?: InputMaybe<Scalars['String']>;
  mux_playback_id?: InputMaybe<Scalars['String']>;
  mux_thumbnail_time?: InputMaybe<Scalars['numeric']>;
  mux_upload_id?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['Int']>;
  paid_at?: InputMaybe<Scalars['timestamptz']>;
  primary_email?: InputMaybe<Scalars['String']>;
  primary_phone?: InputMaybe<Scalars['String']>;
  production_company?: InputMaybe<Scalars['String']>;
  production_year?: InputMaybe<Scalars['String']>;
  secondary_email?: InputMaybe<Scalars['String']>;
  secondary_phone?: InputMaybe<Scalars['String']>;
  signature_email?: InputMaybe<Scalars['String']>;
  signature_ip?: InputMaybe<Scalars['String']>;
  signature_name?: InputMaybe<Scalars['String']>;
  signature_phone?: InputMaybe<Scalars['String']>;
  signature_ts?: InputMaybe<Scalars['timestamptz']>;
  state?: InputMaybe<Scalars['String']>;
  stripe_payment_id?: InputMaybe<Scalars['String']>;
  submitted_at?: InputMaybe<Scalars['timestamptz']>;
  synopsis?: InputMaybe<Scalars['String']>;
  tagline?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Festival_Submissions_Stddev_Fields = {
  __typename?: 'festival_submissions_stddev_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  genre_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mux_thumbnail_time?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Festival_Submissions_Stddev_Pop_Fields = {
  __typename?: 'festival_submissions_stddev_pop_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  genre_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mux_thumbnail_time?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Festival_Submissions_Stddev_Samp_Fields = {
  __typename?: 'festival_submissions_stddev_samp_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  genre_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mux_thumbnail_time?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "festival_submissions" */
export type Festival_Submissions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Festival_Submissions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Festival_Submissions_Stream_Cursor_Value_Input = {
  address_1?: InputMaybe<Scalars['String']>;
  address_2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  film_festival_id?: InputMaybe<Scalars['Int']>;
  film_title?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  genre_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_minor?: InputMaybe<Scalars['Boolean']>;
  last_name?: InputMaybe<Scalars['String']>;
  middle_name?: InputMaybe<Scalars['String']>;
  mux_asset_data?: InputMaybe<Scalars['jsonb']>;
  mux_asset_id?: InputMaybe<Scalars['String']>;
  mux_playback_id?: InputMaybe<Scalars['String']>;
  mux_thumbnail_time?: InputMaybe<Scalars['numeric']>;
  mux_upload_id?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['Int']>;
  paid_at?: InputMaybe<Scalars['timestamptz']>;
  primary_email?: InputMaybe<Scalars['String']>;
  primary_phone?: InputMaybe<Scalars['String']>;
  production_company?: InputMaybe<Scalars['String']>;
  production_year?: InputMaybe<Scalars['String']>;
  secondary_email?: InputMaybe<Scalars['String']>;
  secondary_phone?: InputMaybe<Scalars['String']>;
  signature_email?: InputMaybe<Scalars['String']>;
  signature_ip?: InputMaybe<Scalars['String']>;
  signature_name?: InputMaybe<Scalars['String']>;
  signature_phone?: InputMaybe<Scalars['String']>;
  signature_ts?: InputMaybe<Scalars['timestamptz']>;
  state?: InputMaybe<Scalars['String']>;
  stripe_payment_id?: InputMaybe<Scalars['String']>;
  submitted_at?: InputMaybe<Scalars['timestamptz']>;
  synopsis?: InputMaybe<Scalars['String']>;
  tagline?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Festival_Submissions_Sum_Fields = {
  __typename?: 'festival_submissions_sum_fields';
  film_festival_id?: Maybe<Scalars['Int']>;
  genre_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  mux_thumbnail_time?: Maybe<Scalars['numeric']>;
  owner_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "festival_submissions" */
export enum Festival_Submissions_Update_Column {
  /** column name */
  Address_1 = 'address_1',
  /** column name */
  Address_2 = 'address_2',
  /** column name */
  City = 'city',
  /** column name */
  Comments = 'comments',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FilmFestivalId = 'film_festival_id',
  /** column name */
  FilmTitle = 'film_title',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  GenreId = 'genre_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsMinor = 'is_minor',
  /** column name */
  LastName = 'last_name',
  /** column name */
  MiddleName = 'middle_name',
  /** column name */
  MuxAssetData = 'mux_asset_data',
  /** column name */
  MuxAssetId = 'mux_asset_id',
  /** column name */
  MuxPlaybackId = 'mux_playback_id',
  /** column name */
  MuxThumbnailTime = 'mux_thumbnail_time',
  /** column name */
  MuxUploadId = 'mux_upload_id',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  PaidAt = 'paid_at',
  /** column name */
  PrimaryEmail = 'primary_email',
  /** column name */
  PrimaryPhone = 'primary_phone',
  /** column name */
  ProductionCompany = 'production_company',
  /** column name */
  ProductionYear = 'production_year',
  /** column name */
  SecondaryEmail = 'secondary_email',
  /** column name */
  SecondaryPhone = 'secondary_phone',
  /** column name */
  SignatureEmail = 'signature_email',
  /** column name */
  SignatureIp = 'signature_ip',
  /** column name */
  SignatureName = 'signature_name',
  /** column name */
  SignaturePhone = 'signature_phone',
  /** column name */
  SignatureTs = 'signature_ts',
  /** column name */
  State = 'state',
  /** column name */
  StripePaymentId = 'stripe_payment_id',
  /** column name */
  SubmittedAt = 'submitted_at',
  /** column name */
  Synopsis = 'synopsis',
  /** column name */
  Tagline = 'tagline',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Zip = 'zip'
}

export type Festival_Submissions_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Festival_Submissions_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Festival_Submissions_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Festival_Submissions_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Festival_Submissions_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Festival_Submissions_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Festival_Submissions_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Festival_Submissions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Festival_Submissions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Festival_Submissions_Var_Pop_Fields = {
  __typename?: 'festival_submissions_var_pop_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  genre_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mux_thumbnail_time?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Festival_Submissions_Var_Samp_Fields = {
  __typename?: 'festival_submissions_var_samp_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  genre_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mux_thumbnail_time?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Festival_Submissions_Variance_Fields = {
  __typename?: 'festival_submissions_variance_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  genre_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mux_thumbnail_time?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "festival_tickets" */
export type Festival_Tickets = {
  __typename?: 'festival_tickets';
  created_at: Scalars['timestamptz'];
  email: Scalars['String'];
  /** An object relationship */
  festival_badge: Festival_Badges;
  festival_badge_id: Scalars['Int'];
  /** An object relationship */
  festival_event: Festival_Events;
  festival_event_id: Scalars['Int'];
  id: Scalars['Int'];
  issued_at: Scalars['timestamptz'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "festival_tickets" */
export type Festival_Tickets_Aggregate = {
  __typename?: 'festival_tickets_aggregate';
  aggregate?: Maybe<Festival_Tickets_Aggregate_Fields>;
  nodes: Array<Festival_Tickets>;
};

export type Festival_Tickets_Aggregate_Bool_Exp = {
  count?: InputMaybe<Festival_Tickets_Aggregate_Bool_Exp_Count>;
};

export type Festival_Tickets_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Festival_Tickets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Festival_Tickets_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "festival_tickets" */
export type Festival_Tickets_Aggregate_Fields = {
  __typename?: 'festival_tickets_aggregate_fields';
  avg?: Maybe<Festival_Tickets_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Festival_Tickets_Max_Fields>;
  min?: Maybe<Festival_Tickets_Min_Fields>;
  stddev?: Maybe<Festival_Tickets_Stddev_Fields>;
  stddev_pop?: Maybe<Festival_Tickets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Festival_Tickets_Stddev_Samp_Fields>;
  sum?: Maybe<Festival_Tickets_Sum_Fields>;
  var_pop?: Maybe<Festival_Tickets_Var_Pop_Fields>;
  var_samp?: Maybe<Festival_Tickets_Var_Samp_Fields>;
  variance?: Maybe<Festival_Tickets_Variance_Fields>;
};


/** aggregate fields of "festival_tickets" */
export type Festival_Tickets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Festival_Tickets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "festival_tickets" */
export type Festival_Tickets_Aggregate_Order_By = {
  avg?: InputMaybe<Festival_Tickets_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Festival_Tickets_Max_Order_By>;
  min?: InputMaybe<Festival_Tickets_Min_Order_By>;
  stddev?: InputMaybe<Festival_Tickets_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Festival_Tickets_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Festival_Tickets_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Festival_Tickets_Sum_Order_By>;
  var_pop?: InputMaybe<Festival_Tickets_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Festival_Tickets_Var_Samp_Order_By>;
  variance?: InputMaybe<Festival_Tickets_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "festival_tickets" */
export type Festival_Tickets_Arr_Rel_Insert_Input = {
  data: Array<Festival_Tickets_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Festival_Tickets_On_Conflict>;
};

/** aggregate avg on columns */
export type Festival_Tickets_Avg_Fields = {
  __typename?: 'festival_tickets_avg_fields';
  festival_badge_id?: Maybe<Scalars['Float']>;
  festival_event_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "festival_tickets" */
export type Festival_Tickets_Avg_Order_By = {
  festival_badge_id?: InputMaybe<Order_By>;
  festival_event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "festival_tickets". All fields are combined with a logical 'AND'. */
export type Festival_Tickets_Bool_Exp = {
  _and?: InputMaybe<Array<Festival_Tickets_Bool_Exp>>;
  _not?: InputMaybe<Festival_Tickets_Bool_Exp>;
  _or?: InputMaybe<Array<Festival_Tickets_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  festival_badge?: InputMaybe<Festival_Badges_Bool_Exp>;
  festival_badge_id?: InputMaybe<Int_Comparison_Exp>;
  festival_event?: InputMaybe<Festival_Events_Bool_Exp>;
  festival_event_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  issued_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "festival_tickets" */
export enum Festival_Tickets_Constraint {
  /** unique or primary key constraint on columns "id" */
  FestivalTicketsPkey = 'festival_tickets_pkey'
}

/** input type for incrementing numeric columns in table "festival_tickets" */
export type Festival_Tickets_Inc_Input = {
  festival_badge_id?: InputMaybe<Scalars['Int']>;
  festival_event_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "festival_tickets" */
export type Festival_Tickets_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  festival_badge?: InputMaybe<Festival_Badges_Obj_Rel_Insert_Input>;
  festival_badge_id?: InputMaybe<Scalars['Int']>;
  festival_event?: InputMaybe<Festival_Events_Obj_Rel_Insert_Input>;
  festival_event_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  issued_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Festival_Tickets_Max_Fields = {
  __typename?: 'festival_tickets_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  festival_badge_id?: Maybe<Scalars['Int']>;
  festival_event_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  issued_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "festival_tickets" */
export type Festival_Tickets_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  festival_badge_id?: InputMaybe<Order_By>;
  festival_event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issued_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Festival_Tickets_Min_Fields = {
  __typename?: 'festival_tickets_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  festival_badge_id?: Maybe<Scalars['Int']>;
  festival_event_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  issued_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "festival_tickets" */
export type Festival_Tickets_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  festival_badge_id?: InputMaybe<Order_By>;
  festival_event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issued_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "festival_tickets" */
export type Festival_Tickets_Mutation_Response = {
  __typename?: 'festival_tickets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Festival_Tickets>;
};

/** on_conflict condition type for table "festival_tickets" */
export type Festival_Tickets_On_Conflict = {
  constraint: Festival_Tickets_Constraint;
  update_columns?: Array<Festival_Tickets_Update_Column>;
  where?: InputMaybe<Festival_Tickets_Bool_Exp>;
};

/** Ordering options when selecting data from "festival_tickets". */
export type Festival_Tickets_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  festival_badge?: InputMaybe<Festival_Badges_Order_By>;
  festival_badge_id?: InputMaybe<Order_By>;
  festival_event?: InputMaybe<Festival_Events_Order_By>;
  festival_event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issued_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: festival_tickets */
export type Festival_Tickets_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "festival_tickets" */
export enum Festival_Tickets_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FestivalBadgeId = 'festival_badge_id',
  /** column name */
  FestivalEventId = 'festival_event_id',
  /** column name */
  Id = 'id',
  /** column name */
  IssuedAt = 'issued_at',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "festival_tickets" */
export type Festival_Tickets_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  festival_badge_id?: InputMaybe<Scalars['Int']>;
  festival_event_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  issued_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Festival_Tickets_Stddev_Fields = {
  __typename?: 'festival_tickets_stddev_fields';
  festival_badge_id?: Maybe<Scalars['Float']>;
  festival_event_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "festival_tickets" */
export type Festival_Tickets_Stddev_Order_By = {
  festival_badge_id?: InputMaybe<Order_By>;
  festival_event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Festival_Tickets_Stddev_Pop_Fields = {
  __typename?: 'festival_tickets_stddev_pop_fields';
  festival_badge_id?: Maybe<Scalars['Float']>;
  festival_event_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "festival_tickets" */
export type Festival_Tickets_Stddev_Pop_Order_By = {
  festival_badge_id?: InputMaybe<Order_By>;
  festival_event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Festival_Tickets_Stddev_Samp_Fields = {
  __typename?: 'festival_tickets_stddev_samp_fields';
  festival_badge_id?: Maybe<Scalars['Float']>;
  festival_event_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "festival_tickets" */
export type Festival_Tickets_Stddev_Samp_Order_By = {
  festival_badge_id?: InputMaybe<Order_By>;
  festival_event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "festival_tickets" */
export type Festival_Tickets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Festival_Tickets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Festival_Tickets_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  festival_badge_id?: InputMaybe<Scalars['Int']>;
  festival_event_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  issued_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Festival_Tickets_Sum_Fields = {
  __typename?: 'festival_tickets_sum_fields';
  festival_badge_id?: Maybe<Scalars['Int']>;
  festival_event_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "festival_tickets" */
export type Festival_Tickets_Sum_Order_By = {
  festival_badge_id?: InputMaybe<Order_By>;
  festival_event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "festival_tickets" */
export enum Festival_Tickets_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FestivalBadgeId = 'festival_badge_id',
  /** column name */
  FestivalEventId = 'festival_event_id',
  /** column name */
  Id = 'id',
  /** column name */
  IssuedAt = 'issued_at',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Festival_Tickets_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Festival_Tickets_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Festival_Tickets_Set_Input>;
  /** filter the rows which have to be updated */
  where: Festival_Tickets_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Festival_Tickets_Var_Pop_Fields = {
  __typename?: 'festival_tickets_var_pop_fields';
  festival_badge_id?: Maybe<Scalars['Float']>;
  festival_event_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "festival_tickets" */
export type Festival_Tickets_Var_Pop_Order_By = {
  festival_badge_id?: InputMaybe<Order_By>;
  festival_event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Festival_Tickets_Var_Samp_Fields = {
  __typename?: 'festival_tickets_var_samp_fields';
  festival_badge_id?: Maybe<Scalars['Float']>;
  festival_event_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "festival_tickets" */
export type Festival_Tickets_Var_Samp_Order_By = {
  festival_badge_id?: InputMaybe<Order_By>;
  festival_event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Festival_Tickets_Variance_Fields = {
  __typename?: 'festival_tickets_variance_fields';
  festival_badge_id?: Maybe<Scalars['Float']>;
  festival_event_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "festival_tickets" */
export type Festival_Tickets_Variance_Order_By = {
  festival_badge_id?: InputMaybe<Order_By>;
  festival_event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "film_festivals" */
export type Film_Festivals = {
  __typename?: 'film_festivals';
  created: Scalars['timestamp'];
  created_by: Scalars['String'];
  due_at?: Maybe<Scalars['timestamp']>;
  /** An array relationship */
  festival_genres: Array<Festival_Genres>;
  /** An aggregate relationship */
  festival_genres_aggregate: Festival_Genres_Aggregate;
  id: Scalars['numeric'];
  inspiration_package?: Maybe<Scalars['String']>;
  is_fm: Scalars['Boolean'];
  is_public: Scalars['Boolean'];
  name: Scalars['String'];
  publish_at?: Maybe<Scalars['timestamp']>;
  registration_closes?: Maybe<Scalars['timestamp']>;
  registration_fee: Scalars['numeric'];
  registration_opens?: Maybe<Scalars['timestamp']>;
  rules?: Maybe<Scalars['String']>;
  /** An array relationship */
  sponsors: Array<Sponsors>;
  /** An aggregate relationship */
  sponsors_aggregate: Sponsors_Aggregate;
  /** An array relationship */
  teams: Array<Teams>;
  /** An aggregate relationship */
  teams_aggregate: Teams_Aggregate;
  updated: Scalars['timestamp'];
  updated_by: Scalars['String'];
  vimeo_url?: Maybe<Scalars['String']>;
};


/** columns and relationships of "film_festivals" */
export type Film_FestivalsFestival_GenresArgs = {
  distinct_on?: InputMaybe<Array<Festival_Genres_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Genres_Order_By>>;
  where?: InputMaybe<Festival_Genres_Bool_Exp>;
};


/** columns and relationships of "film_festivals" */
export type Film_FestivalsFestival_Genres_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Genres_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Genres_Order_By>>;
  where?: InputMaybe<Festival_Genres_Bool_Exp>;
};


/** columns and relationships of "film_festivals" */
export type Film_FestivalsSponsorsArgs = {
  distinct_on?: InputMaybe<Array<Sponsors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsors_Order_By>>;
  where?: InputMaybe<Sponsors_Bool_Exp>;
};


/** columns and relationships of "film_festivals" */
export type Film_FestivalsSponsors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sponsors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsors_Order_By>>;
  where?: InputMaybe<Sponsors_Bool_Exp>;
};


/** columns and relationships of "film_festivals" */
export type Film_FestivalsTeamsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


/** columns and relationships of "film_festivals" */
export type Film_FestivalsTeams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};

/** aggregated selection of "film_festivals" */
export type Film_Festivals_Aggregate = {
  __typename?: 'film_festivals_aggregate';
  aggregate?: Maybe<Film_Festivals_Aggregate_Fields>;
  nodes: Array<Film_Festivals>;
};

/** aggregate fields of "film_festivals" */
export type Film_Festivals_Aggregate_Fields = {
  __typename?: 'film_festivals_aggregate_fields';
  avg?: Maybe<Film_Festivals_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Film_Festivals_Max_Fields>;
  min?: Maybe<Film_Festivals_Min_Fields>;
  stddev?: Maybe<Film_Festivals_Stddev_Fields>;
  stddev_pop?: Maybe<Film_Festivals_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Film_Festivals_Stddev_Samp_Fields>;
  sum?: Maybe<Film_Festivals_Sum_Fields>;
  var_pop?: Maybe<Film_Festivals_Var_Pop_Fields>;
  var_samp?: Maybe<Film_Festivals_Var_Samp_Fields>;
  variance?: Maybe<Film_Festivals_Variance_Fields>;
};


/** aggregate fields of "film_festivals" */
export type Film_Festivals_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Film_Festivals_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Film_Festivals_Avg_Fields = {
  __typename?: 'film_festivals_avg_fields';
  id?: Maybe<Scalars['Float']>;
  registration_fee?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "film_festivals". All fields are combined with a logical 'AND'. */
export type Film_Festivals_Bool_Exp = {
  _and?: InputMaybe<Array<Film_Festivals_Bool_Exp>>;
  _not?: InputMaybe<Film_Festivals_Bool_Exp>;
  _or?: InputMaybe<Array<Film_Festivals_Bool_Exp>>;
  created?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  due_at?: InputMaybe<Timestamp_Comparison_Exp>;
  festival_genres?: InputMaybe<Festival_Genres_Bool_Exp>;
  festival_genres_aggregate?: InputMaybe<Festival_Genres_Aggregate_Bool_Exp>;
  id?: InputMaybe<Numeric_Comparison_Exp>;
  inspiration_package?: InputMaybe<String_Comparison_Exp>;
  is_fm?: InputMaybe<Boolean_Comparison_Exp>;
  is_public?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  publish_at?: InputMaybe<Timestamp_Comparison_Exp>;
  registration_closes?: InputMaybe<Timestamp_Comparison_Exp>;
  registration_fee?: InputMaybe<Numeric_Comparison_Exp>;
  registration_opens?: InputMaybe<Timestamp_Comparison_Exp>;
  rules?: InputMaybe<String_Comparison_Exp>;
  sponsors?: InputMaybe<Sponsors_Bool_Exp>;
  sponsors_aggregate?: InputMaybe<Sponsors_Aggregate_Bool_Exp>;
  teams?: InputMaybe<Teams_Bool_Exp>;
  teams_aggregate?: InputMaybe<Teams_Aggregate_Bool_Exp>;
  updated?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
  vimeo_url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "film_festivals" */
export enum Film_Festivals_Constraint {
  /** unique or primary key constraint on columns "id" */
  FilmFestivalsPkey = 'film_festivals_pkey'
}

/** input type for incrementing numeric columns in table "film_festivals" */
export type Film_Festivals_Inc_Input = {
  id?: InputMaybe<Scalars['numeric']>;
  registration_fee?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "film_festivals" */
export type Film_Festivals_Insert_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  due_at?: InputMaybe<Scalars['timestamp']>;
  festival_genres?: InputMaybe<Festival_Genres_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['numeric']>;
  inspiration_package?: InputMaybe<Scalars['String']>;
  is_fm?: InputMaybe<Scalars['Boolean']>;
  is_public?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  publish_at?: InputMaybe<Scalars['timestamp']>;
  registration_closes?: InputMaybe<Scalars['timestamp']>;
  registration_fee?: InputMaybe<Scalars['numeric']>;
  registration_opens?: InputMaybe<Scalars['timestamp']>;
  rules?: InputMaybe<Scalars['String']>;
  sponsors?: InputMaybe<Sponsors_Arr_Rel_Insert_Input>;
  teams?: InputMaybe<Teams_Arr_Rel_Insert_Input>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
  vimeo_url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Film_Festivals_Max_Fields = {
  __typename?: 'film_festivals_max_fields';
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  due_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['numeric']>;
  inspiration_package?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  publish_at?: Maybe<Scalars['timestamp']>;
  registration_closes?: Maybe<Scalars['timestamp']>;
  registration_fee?: Maybe<Scalars['numeric']>;
  registration_opens?: Maybe<Scalars['timestamp']>;
  rules?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
  vimeo_url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Film_Festivals_Min_Fields = {
  __typename?: 'film_festivals_min_fields';
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  due_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['numeric']>;
  inspiration_package?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  publish_at?: Maybe<Scalars['timestamp']>;
  registration_closes?: Maybe<Scalars['timestamp']>;
  registration_fee?: Maybe<Scalars['numeric']>;
  registration_opens?: Maybe<Scalars['timestamp']>;
  rules?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
  vimeo_url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "film_festivals" */
export type Film_Festivals_Mutation_Response = {
  __typename?: 'film_festivals_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Film_Festivals>;
};

/** input type for inserting object relation for remote table "film_festivals" */
export type Film_Festivals_Obj_Rel_Insert_Input = {
  data: Film_Festivals_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Film_Festivals_On_Conflict>;
};

/** on_conflict condition type for table "film_festivals" */
export type Film_Festivals_On_Conflict = {
  constraint: Film_Festivals_Constraint;
  update_columns?: Array<Film_Festivals_Update_Column>;
  where?: InputMaybe<Film_Festivals_Bool_Exp>;
};

/** Ordering options when selecting data from "film_festivals". */
export type Film_Festivals_Order_By = {
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  due_at?: InputMaybe<Order_By>;
  festival_genres_aggregate?: InputMaybe<Festival_Genres_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  inspiration_package?: InputMaybe<Order_By>;
  is_fm?: InputMaybe<Order_By>;
  is_public?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  publish_at?: InputMaybe<Order_By>;
  registration_closes?: InputMaybe<Order_By>;
  registration_fee?: InputMaybe<Order_By>;
  registration_opens?: InputMaybe<Order_By>;
  rules?: InputMaybe<Order_By>;
  sponsors_aggregate?: InputMaybe<Sponsors_Aggregate_Order_By>;
  teams_aggregate?: InputMaybe<Teams_Aggregate_Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  vimeo_url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: film_festivals */
export type Film_Festivals_Pk_Columns_Input = {
  id: Scalars['numeric'];
};

/** select columns of table "film_festivals" */
export enum Film_Festivals_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DueAt = 'due_at',
  /** column name */
  Id = 'id',
  /** column name */
  InspirationPackage = 'inspiration_package',
  /** column name */
  IsFm = 'is_fm',
  /** column name */
  IsPublic = 'is_public',
  /** column name */
  Name = 'name',
  /** column name */
  PublishAt = 'publish_at',
  /** column name */
  RegistrationCloses = 'registration_closes',
  /** column name */
  RegistrationFee = 'registration_fee',
  /** column name */
  RegistrationOpens = 'registration_opens',
  /** column name */
  Rules = 'rules',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  VimeoUrl = 'vimeo_url'
}

/** input type for updating data in table "film_festivals" */
export type Film_Festivals_Set_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  due_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['numeric']>;
  inspiration_package?: InputMaybe<Scalars['String']>;
  is_fm?: InputMaybe<Scalars['Boolean']>;
  is_public?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  publish_at?: InputMaybe<Scalars['timestamp']>;
  registration_closes?: InputMaybe<Scalars['timestamp']>;
  registration_fee?: InputMaybe<Scalars['numeric']>;
  registration_opens?: InputMaybe<Scalars['timestamp']>;
  rules?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
  vimeo_url?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Film_Festivals_Stddev_Fields = {
  __typename?: 'film_festivals_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  registration_fee?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Film_Festivals_Stddev_Pop_Fields = {
  __typename?: 'film_festivals_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  registration_fee?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Film_Festivals_Stddev_Samp_Fields = {
  __typename?: 'film_festivals_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  registration_fee?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "film_festivals" */
export type Film_Festivals_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Film_Festivals_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Film_Festivals_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  due_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['numeric']>;
  inspiration_package?: InputMaybe<Scalars['String']>;
  is_fm?: InputMaybe<Scalars['Boolean']>;
  is_public?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  publish_at?: InputMaybe<Scalars['timestamp']>;
  registration_closes?: InputMaybe<Scalars['timestamp']>;
  registration_fee?: InputMaybe<Scalars['numeric']>;
  registration_opens?: InputMaybe<Scalars['timestamp']>;
  rules?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
  vimeo_url?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Film_Festivals_Sum_Fields = {
  __typename?: 'film_festivals_sum_fields';
  id?: Maybe<Scalars['numeric']>;
  registration_fee?: Maybe<Scalars['numeric']>;
};

/** update columns of table "film_festivals" */
export enum Film_Festivals_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DueAt = 'due_at',
  /** column name */
  Id = 'id',
  /** column name */
  InspirationPackage = 'inspiration_package',
  /** column name */
  IsFm = 'is_fm',
  /** column name */
  IsPublic = 'is_public',
  /** column name */
  Name = 'name',
  /** column name */
  PublishAt = 'publish_at',
  /** column name */
  RegistrationCloses = 'registration_closes',
  /** column name */
  RegistrationFee = 'registration_fee',
  /** column name */
  RegistrationOpens = 'registration_opens',
  /** column name */
  Rules = 'rules',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  VimeoUrl = 'vimeo_url'
}

export type Film_Festivals_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Film_Festivals_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Film_Festivals_Set_Input>;
  /** filter the rows which have to be updated */
  where: Film_Festivals_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Film_Festivals_Var_Pop_Fields = {
  __typename?: 'film_festivals_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  registration_fee?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Film_Festivals_Var_Samp_Fields = {
  __typename?: 'film_festivals_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  registration_fee?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Film_Festivals_Variance_Fields = {
  __typename?: 'film_festivals_variance_fields';
  id?: Maybe<Scalars['Float']>;
  registration_fee?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "film_group_festival_submissions" */
export type Film_Group_Festival_Submissions = {
  __typename?: 'film_group_festival_submissions';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  festival_submission: Festival_Submissions;
  festival_submission_id: Scalars['Int'];
  /** An object relationship */
  film_group: Film_Groups;
  film_group_id: Scalars['Int'];
  id: Scalars['Int'];
  sort: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "film_group_festival_submissions" */
export type Film_Group_Festival_Submissions_Aggregate = {
  __typename?: 'film_group_festival_submissions_aggregate';
  aggregate?: Maybe<Film_Group_Festival_Submissions_Aggregate_Fields>;
  nodes: Array<Film_Group_Festival_Submissions>;
};

export type Film_Group_Festival_Submissions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Film_Group_Festival_Submissions_Aggregate_Bool_Exp_Count>;
};

export type Film_Group_Festival_Submissions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Film_Group_Festival_Submissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Film_Group_Festival_Submissions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "film_group_festival_submissions" */
export type Film_Group_Festival_Submissions_Aggregate_Fields = {
  __typename?: 'film_group_festival_submissions_aggregate_fields';
  avg?: Maybe<Film_Group_Festival_Submissions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Film_Group_Festival_Submissions_Max_Fields>;
  min?: Maybe<Film_Group_Festival_Submissions_Min_Fields>;
  stddev?: Maybe<Film_Group_Festival_Submissions_Stddev_Fields>;
  stddev_pop?: Maybe<Film_Group_Festival_Submissions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Film_Group_Festival_Submissions_Stddev_Samp_Fields>;
  sum?: Maybe<Film_Group_Festival_Submissions_Sum_Fields>;
  var_pop?: Maybe<Film_Group_Festival_Submissions_Var_Pop_Fields>;
  var_samp?: Maybe<Film_Group_Festival_Submissions_Var_Samp_Fields>;
  variance?: Maybe<Film_Group_Festival_Submissions_Variance_Fields>;
};


/** aggregate fields of "film_group_festival_submissions" */
export type Film_Group_Festival_Submissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Film_Group_Festival_Submissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "film_group_festival_submissions" */
export type Film_Group_Festival_Submissions_Aggregate_Order_By = {
  avg?: InputMaybe<Film_Group_Festival_Submissions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Film_Group_Festival_Submissions_Max_Order_By>;
  min?: InputMaybe<Film_Group_Festival_Submissions_Min_Order_By>;
  stddev?: InputMaybe<Film_Group_Festival_Submissions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Film_Group_Festival_Submissions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Film_Group_Festival_Submissions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Film_Group_Festival_Submissions_Sum_Order_By>;
  var_pop?: InputMaybe<Film_Group_Festival_Submissions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Film_Group_Festival_Submissions_Var_Samp_Order_By>;
  variance?: InputMaybe<Film_Group_Festival_Submissions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "film_group_festival_submissions" */
export type Film_Group_Festival_Submissions_Arr_Rel_Insert_Input = {
  data: Array<Film_Group_Festival_Submissions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Film_Group_Festival_Submissions_On_Conflict>;
};

/** aggregate avg on columns */
export type Film_Group_Festival_Submissions_Avg_Fields = {
  __typename?: 'film_group_festival_submissions_avg_fields';
  festival_submission_id?: Maybe<Scalars['Float']>;
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "film_group_festival_submissions" */
export type Film_Group_Festival_Submissions_Avg_Order_By = {
  festival_submission_id?: InputMaybe<Order_By>;
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "film_group_festival_submissions". All fields are combined with a logical 'AND'. */
export type Film_Group_Festival_Submissions_Bool_Exp = {
  _and?: InputMaybe<Array<Film_Group_Festival_Submissions_Bool_Exp>>;
  _not?: InputMaybe<Film_Group_Festival_Submissions_Bool_Exp>;
  _or?: InputMaybe<Array<Film_Group_Festival_Submissions_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  festival_submission?: InputMaybe<Festival_Submissions_Bool_Exp>;
  festival_submission_id?: InputMaybe<Int_Comparison_Exp>;
  film_group?: InputMaybe<Film_Groups_Bool_Exp>;
  film_group_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  sort?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "film_group_festival_submissions" */
export enum Film_Group_Festival_Submissions_Constraint {
  /** unique or primary key constraint on columns "film_group_id", "sort" */
  FilmGroupFestivalSubmissionsFilmGroupIdSortKey = 'film_group_festival_submissions_film_group_id_sort_key',
  /** unique or primary key constraint on columns "id" */
  FilmGroupFestivalSubmissionsPkey = 'film_group_festival_submissions_pkey'
}

/** input type for incrementing numeric columns in table "film_group_festival_submissions" */
export type Film_Group_Festival_Submissions_Inc_Input = {
  festival_submission_id?: InputMaybe<Scalars['Int']>;
  film_group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "film_group_festival_submissions" */
export type Film_Group_Festival_Submissions_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  festival_submission?: InputMaybe<Festival_Submissions_Obj_Rel_Insert_Input>;
  festival_submission_id?: InputMaybe<Scalars['Int']>;
  film_group?: InputMaybe<Film_Groups_Obj_Rel_Insert_Input>;
  film_group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Film_Group_Festival_Submissions_Max_Fields = {
  __typename?: 'film_group_festival_submissions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  festival_submission_id?: Maybe<Scalars['Int']>;
  film_group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "film_group_festival_submissions" */
export type Film_Group_Festival_Submissions_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  festival_submission_id?: InputMaybe<Order_By>;
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Film_Group_Festival_Submissions_Min_Fields = {
  __typename?: 'film_group_festival_submissions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  festival_submission_id?: Maybe<Scalars['Int']>;
  film_group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "film_group_festival_submissions" */
export type Film_Group_Festival_Submissions_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  festival_submission_id?: InputMaybe<Order_By>;
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "film_group_festival_submissions" */
export type Film_Group_Festival_Submissions_Mutation_Response = {
  __typename?: 'film_group_festival_submissions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Film_Group_Festival_Submissions>;
};

/** on_conflict condition type for table "film_group_festival_submissions" */
export type Film_Group_Festival_Submissions_On_Conflict = {
  constraint: Film_Group_Festival_Submissions_Constraint;
  update_columns?: Array<Film_Group_Festival_Submissions_Update_Column>;
  where?: InputMaybe<Film_Group_Festival_Submissions_Bool_Exp>;
};

/** Ordering options when selecting data from "film_group_festival_submissions". */
export type Film_Group_Festival_Submissions_Order_By = {
  created_at?: InputMaybe<Order_By>;
  festival_submission?: InputMaybe<Festival_Submissions_Order_By>;
  festival_submission_id?: InputMaybe<Order_By>;
  film_group?: InputMaybe<Film_Groups_Order_By>;
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: film_group_festival_submissions */
export type Film_Group_Festival_Submissions_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "film_group_festival_submissions" */
export enum Film_Group_Festival_Submissions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FestivalSubmissionId = 'festival_submission_id',
  /** column name */
  FilmGroupId = 'film_group_id',
  /** column name */
  Id = 'id',
  /** column name */
  Sort = 'sort',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "film_group_festival_submissions" */
export type Film_Group_Festival_Submissions_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  festival_submission_id?: InputMaybe<Scalars['Int']>;
  film_group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Film_Group_Festival_Submissions_Stddev_Fields = {
  __typename?: 'film_group_festival_submissions_stddev_fields';
  festival_submission_id?: Maybe<Scalars['Float']>;
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "film_group_festival_submissions" */
export type Film_Group_Festival_Submissions_Stddev_Order_By = {
  festival_submission_id?: InputMaybe<Order_By>;
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Film_Group_Festival_Submissions_Stddev_Pop_Fields = {
  __typename?: 'film_group_festival_submissions_stddev_pop_fields';
  festival_submission_id?: Maybe<Scalars['Float']>;
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "film_group_festival_submissions" */
export type Film_Group_Festival_Submissions_Stddev_Pop_Order_By = {
  festival_submission_id?: InputMaybe<Order_By>;
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Film_Group_Festival_Submissions_Stddev_Samp_Fields = {
  __typename?: 'film_group_festival_submissions_stddev_samp_fields';
  festival_submission_id?: Maybe<Scalars['Float']>;
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "film_group_festival_submissions" */
export type Film_Group_Festival_Submissions_Stddev_Samp_Order_By = {
  festival_submission_id?: InputMaybe<Order_By>;
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "film_group_festival_submissions" */
export type Film_Group_Festival_Submissions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Film_Group_Festival_Submissions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Film_Group_Festival_Submissions_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  festival_submission_id?: InputMaybe<Scalars['Int']>;
  film_group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Film_Group_Festival_Submissions_Sum_Fields = {
  __typename?: 'film_group_festival_submissions_sum_fields';
  festival_submission_id?: Maybe<Scalars['Int']>;
  film_group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "film_group_festival_submissions" */
export type Film_Group_Festival_Submissions_Sum_Order_By = {
  festival_submission_id?: InputMaybe<Order_By>;
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
};

/** update columns of table "film_group_festival_submissions" */
export enum Film_Group_Festival_Submissions_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FestivalSubmissionId = 'festival_submission_id',
  /** column name */
  FilmGroupId = 'film_group_id',
  /** column name */
  Id = 'id',
  /** column name */
  Sort = 'sort',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Film_Group_Festival_Submissions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Film_Group_Festival_Submissions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Film_Group_Festival_Submissions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Film_Group_Festival_Submissions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Film_Group_Festival_Submissions_Var_Pop_Fields = {
  __typename?: 'film_group_festival_submissions_var_pop_fields';
  festival_submission_id?: Maybe<Scalars['Float']>;
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "film_group_festival_submissions" */
export type Film_Group_Festival_Submissions_Var_Pop_Order_By = {
  festival_submission_id?: InputMaybe<Order_By>;
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Film_Group_Festival_Submissions_Var_Samp_Fields = {
  __typename?: 'film_group_festival_submissions_var_samp_fields';
  festival_submission_id?: Maybe<Scalars['Float']>;
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "film_group_festival_submissions" */
export type Film_Group_Festival_Submissions_Var_Samp_Order_By = {
  festival_submission_id?: InputMaybe<Order_By>;
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Film_Group_Festival_Submissions_Variance_Fields = {
  __typename?: 'film_group_festival_submissions_variance_fields';
  festival_submission_id?: Maybe<Scalars['Float']>;
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "film_group_festival_submissions" */
export type Film_Group_Festival_Submissions_Variance_Order_By = {
  festival_submission_id?: InputMaybe<Order_By>;
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
};

/** columns and relationships of "film_group_films" */
export type Film_Group_Films = {
  __typename?: 'film_group_films';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  film_group: Film_Groups;
  film_group_id: Scalars['Int'];
  id: Scalars['Int'];
  sort: Scalars['Int'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['numeric'];
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "film_group_films" */
export type Film_Group_Films_Aggregate = {
  __typename?: 'film_group_films_aggregate';
  aggregate?: Maybe<Film_Group_Films_Aggregate_Fields>;
  nodes: Array<Film_Group_Films>;
};

export type Film_Group_Films_Aggregate_Bool_Exp = {
  count?: InputMaybe<Film_Group_Films_Aggregate_Bool_Exp_Count>;
};

export type Film_Group_Films_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Film_Group_Films_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Film_Group_Films_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "film_group_films" */
export type Film_Group_Films_Aggregate_Fields = {
  __typename?: 'film_group_films_aggregate_fields';
  avg?: Maybe<Film_Group_Films_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Film_Group_Films_Max_Fields>;
  min?: Maybe<Film_Group_Films_Min_Fields>;
  stddev?: Maybe<Film_Group_Films_Stddev_Fields>;
  stddev_pop?: Maybe<Film_Group_Films_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Film_Group_Films_Stddev_Samp_Fields>;
  sum?: Maybe<Film_Group_Films_Sum_Fields>;
  var_pop?: Maybe<Film_Group_Films_Var_Pop_Fields>;
  var_samp?: Maybe<Film_Group_Films_Var_Samp_Fields>;
  variance?: Maybe<Film_Group_Films_Variance_Fields>;
};


/** aggregate fields of "film_group_films" */
export type Film_Group_Films_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Film_Group_Films_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "film_group_films" */
export type Film_Group_Films_Aggregate_Order_By = {
  avg?: InputMaybe<Film_Group_Films_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Film_Group_Films_Max_Order_By>;
  min?: InputMaybe<Film_Group_Films_Min_Order_By>;
  stddev?: InputMaybe<Film_Group_Films_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Film_Group_Films_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Film_Group_Films_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Film_Group_Films_Sum_Order_By>;
  var_pop?: InputMaybe<Film_Group_Films_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Film_Group_Films_Var_Samp_Order_By>;
  variance?: InputMaybe<Film_Group_Films_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "film_group_films" */
export type Film_Group_Films_Arr_Rel_Insert_Input = {
  data: Array<Film_Group_Films_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Film_Group_Films_On_Conflict>;
};

/** aggregate avg on columns */
export type Film_Group_Films_Avg_Fields = {
  __typename?: 'film_group_films_avg_fields';
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "film_group_films" */
export type Film_Group_Films_Avg_Order_By = {
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "film_group_films". All fields are combined with a logical 'AND'. */
export type Film_Group_Films_Bool_Exp = {
  _and?: InputMaybe<Array<Film_Group_Films_Bool_Exp>>;
  _not?: InputMaybe<Film_Group_Films_Bool_Exp>;
  _or?: InputMaybe<Array<Film_Group_Films_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  film_group?: InputMaybe<Film_Groups_Bool_Exp>;
  film_group_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  sort?: InputMaybe<Int_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "film_group_films" */
export enum Film_Group_Films_Constraint {
  /** unique or primary key constraint on columns "film_group_id", "sort" */
  FilmGroupFilmsFilmGroupIdSortKey = 'film_group_films_film_group_id_sort_key',
  /** unique or primary key constraint on columns "id" */
  FilmGroupFilmsPkey = 'film_group_films_pkey'
}

/** input type for incrementing numeric columns in table "film_group_films" */
export type Film_Group_Films_Inc_Input = {
  film_group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "film_group_films" */
export type Film_Group_Films_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  film_group?: InputMaybe<Film_Groups_Obj_Rel_Insert_Input>;
  film_group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['Int']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Film_Group_Films_Max_Fields = {
  __typename?: 'film_group_films_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  film_group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "film_group_films" */
export type Film_Group_Films_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Film_Group_Films_Min_Fields = {
  __typename?: 'film_group_films_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  film_group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "film_group_films" */
export type Film_Group_Films_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "film_group_films" */
export type Film_Group_Films_Mutation_Response = {
  __typename?: 'film_group_films_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Film_Group_Films>;
};

/** input type for inserting object relation for remote table "film_group_films" */
export type Film_Group_Films_Obj_Rel_Insert_Input = {
  data: Film_Group_Films_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Film_Group_Films_On_Conflict>;
};

/** on_conflict condition type for table "film_group_films" */
export type Film_Group_Films_On_Conflict = {
  constraint: Film_Group_Films_Constraint;
  update_columns?: Array<Film_Group_Films_Update_Column>;
  where?: InputMaybe<Film_Group_Films_Bool_Exp>;
};

/** Ordering options when selecting data from "film_group_films". */
export type Film_Group_Films_Order_By = {
  created_at?: InputMaybe<Order_By>;
  film_group?: InputMaybe<Film_Groups_Order_By>;
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: film_group_films */
export type Film_Group_Films_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "film_group_films" */
export enum Film_Group_Films_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FilmGroupId = 'film_group_id',
  /** column name */
  Id = 'id',
  /** column name */
  Sort = 'sort',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "film_group_films" */
export type Film_Group_Films_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  film_group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Film_Group_Films_Stddev_Fields = {
  __typename?: 'film_group_films_stddev_fields';
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "film_group_films" */
export type Film_Group_Films_Stddev_Order_By = {
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Film_Group_Films_Stddev_Pop_Fields = {
  __typename?: 'film_group_films_stddev_pop_fields';
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "film_group_films" */
export type Film_Group_Films_Stddev_Pop_Order_By = {
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Film_Group_Films_Stddev_Samp_Fields = {
  __typename?: 'film_group_films_stddev_samp_fields';
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "film_group_films" */
export type Film_Group_Films_Stddev_Samp_Order_By = {
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "film_group_films" */
export type Film_Group_Films_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Film_Group_Films_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Film_Group_Films_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  film_group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Film_Group_Films_Sum_Fields = {
  __typename?: 'film_group_films_sum_fields';
  film_group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "film_group_films" */
export type Film_Group_Films_Sum_Order_By = {
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** update columns of table "film_group_films" */
export enum Film_Group_Films_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FilmGroupId = 'film_group_id',
  /** column name */
  Id = 'id',
  /** column name */
  Sort = 'sort',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Film_Group_Films_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Film_Group_Films_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Film_Group_Films_Set_Input>;
  /** filter the rows which have to be updated */
  where: Film_Group_Films_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Film_Group_Films_Var_Pop_Fields = {
  __typename?: 'film_group_films_var_pop_fields';
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "film_group_films" */
export type Film_Group_Films_Var_Pop_Order_By = {
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Film_Group_Films_Var_Samp_Fields = {
  __typename?: 'film_group_films_var_samp_fields';
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "film_group_films" */
export type Film_Group_Films_Var_Samp_Order_By = {
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Film_Group_Films_Variance_Fields = {
  __typename?: 'film_group_films_variance_fields';
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "film_group_films" */
export type Film_Group_Films_Variance_Order_By = {
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "film_group_users" */
export type Film_Group_Users = {
  __typename?: 'film_group_users';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  film_group: Film_Groups;
  film_group_id: Scalars['Int'];
  id: Scalars['Int'];
  rankings: Scalars['jsonb'];
  submitted_at?: Maybe<Scalars['timestamptz']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['Int'];
};


/** columns and relationships of "film_group_users" */
export type Film_Group_UsersRankingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "film_group_users" */
export type Film_Group_Users_Aggregate = {
  __typename?: 'film_group_users_aggregate';
  aggregate?: Maybe<Film_Group_Users_Aggregate_Fields>;
  nodes: Array<Film_Group_Users>;
};

export type Film_Group_Users_Aggregate_Bool_Exp = {
  count?: InputMaybe<Film_Group_Users_Aggregate_Bool_Exp_Count>;
};

export type Film_Group_Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Film_Group_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Film_Group_Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "film_group_users" */
export type Film_Group_Users_Aggregate_Fields = {
  __typename?: 'film_group_users_aggregate_fields';
  avg?: Maybe<Film_Group_Users_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Film_Group_Users_Max_Fields>;
  min?: Maybe<Film_Group_Users_Min_Fields>;
  stddev?: Maybe<Film_Group_Users_Stddev_Fields>;
  stddev_pop?: Maybe<Film_Group_Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Film_Group_Users_Stddev_Samp_Fields>;
  sum?: Maybe<Film_Group_Users_Sum_Fields>;
  var_pop?: Maybe<Film_Group_Users_Var_Pop_Fields>;
  var_samp?: Maybe<Film_Group_Users_Var_Samp_Fields>;
  variance?: Maybe<Film_Group_Users_Variance_Fields>;
};


/** aggregate fields of "film_group_users" */
export type Film_Group_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Film_Group_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "film_group_users" */
export type Film_Group_Users_Aggregate_Order_By = {
  avg?: InputMaybe<Film_Group_Users_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Film_Group_Users_Max_Order_By>;
  min?: InputMaybe<Film_Group_Users_Min_Order_By>;
  stddev?: InputMaybe<Film_Group_Users_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Film_Group_Users_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Film_Group_Users_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Film_Group_Users_Sum_Order_By>;
  var_pop?: InputMaybe<Film_Group_Users_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Film_Group_Users_Var_Samp_Order_By>;
  variance?: InputMaybe<Film_Group_Users_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Film_Group_Users_Append_Input = {
  rankings?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "film_group_users" */
export type Film_Group_Users_Arr_Rel_Insert_Input = {
  data: Array<Film_Group_Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Film_Group_Users_On_Conflict>;
};

/** aggregate avg on columns */
export type Film_Group_Users_Avg_Fields = {
  __typename?: 'film_group_users_avg_fields';
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "film_group_users" */
export type Film_Group_Users_Avg_Order_By = {
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "film_group_users". All fields are combined with a logical 'AND'. */
export type Film_Group_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Film_Group_Users_Bool_Exp>>;
  _not?: InputMaybe<Film_Group_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Film_Group_Users_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  film_group?: InputMaybe<Film_Groups_Bool_Exp>;
  film_group_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  rankings?: InputMaybe<Jsonb_Comparison_Exp>;
  submitted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "film_group_users" */
export enum Film_Group_Users_Constraint {
  /** unique or primary key constraint on columns "id" */
  FilmGroupUsersPkey = 'film_group_users_pkey',
  /** unique or primary key constraint on columns "user_id", "film_group_id" */
  FilmGroupUsersUserIdFilmGroupIdKey = 'film_group_users_user_id_film_group_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Film_Group_Users_Delete_At_Path_Input = {
  rankings?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Film_Group_Users_Delete_Elem_Input = {
  rankings?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Film_Group_Users_Delete_Key_Input = {
  rankings?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "film_group_users" */
export type Film_Group_Users_Inc_Input = {
  film_group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "film_group_users" */
export type Film_Group_Users_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  film_group?: InputMaybe<Film_Groups_Obj_Rel_Insert_Input>;
  film_group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  rankings?: InputMaybe<Scalars['jsonb']>;
  submitted_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Film_Group_Users_Max_Fields = {
  __typename?: 'film_group_users_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  film_group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  submitted_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "film_group_users" */
export type Film_Group_Users_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  submitted_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Film_Group_Users_Min_Fields = {
  __typename?: 'film_group_users_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  film_group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  submitted_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "film_group_users" */
export type Film_Group_Users_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  submitted_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "film_group_users" */
export type Film_Group_Users_Mutation_Response = {
  __typename?: 'film_group_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Film_Group_Users>;
};

/** on_conflict condition type for table "film_group_users" */
export type Film_Group_Users_On_Conflict = {
  constraint: Film_Group_Users_Constraint;
  update_columns?: Array<Film_Group_Users_Update_Column>;
  where?: InputMaybe<Film_Group_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "film_group_users". */
export type Film_Group_Users_Order_By = {
  created_at?: InputMaybe<Order_By>;
  film_group?: InputMaybe<Film_Groups_Order_By>;
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rankings?: InputMaybe<Order_By>;
  submitted_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: film_group_users */
export type Film_Group_Users_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Film_Group_Users_Prepend_Input = {
  rankings?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "film_group_users" */
export enum Film_Group_Users_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FilmGroupId = 'film_group_id',
  /** column name */
  Id = 'id',
  /** column name */
  Rankings = 'rankings',
  /** column name */
  SubmittedAt = 'submitted_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "film_group_users" */
export type Film_Group_Users_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  film_group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  rankings?: InputMaybe<Scalars['jsonb']>;
  submitted_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Film_Group_Users_Stddev_Fields = {
  __typename?: 'film_group_users_stddev_fields';
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "film_group_users" */
export type Film_Group_Users_Stddev_Order_By = {
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Film_Group_Users_Stddev_Pop_Fields = {
  __typename?: 'film_group_users_stddev_pop_fields';
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "film_group_users" */
export type Film_Group_Users_Stddev_Pop_Order_By = {
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Film_Group_Users_Stddev_Samp_Fields = {
  __typename?: 'film_group_users_stddev_samp_fields';
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "film_group_users" */
export type Film_Group_Users_Stddev_Samp_Order_By = {
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "film_group_users" */
export type Film_Group_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Film_Group_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Film_Group_Users_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  film_group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  rankings?: InputMaybe<Scalars['jsonb']>;
  submitted_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Film_Group_Users_Sum_Fields = {
  __typename?: 'film_group_users_sum_fields';
  film_group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "film_group_users" */
export type Film_Group_Users_Sum_Order_By = {
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "film_group_users" */
export enum Film_Group_Users_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FilmGroupId = 'film_group_id',
  /** column name */
  Id = 'id',
  /** column name */
  Rankings = 'rankings',
  /** column name */
  SubmittedAt = 'submitted_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Film_Group_Users_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Film_Group_Users_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Film_Group_Users_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Film_Group_Users_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Film_Group_Users_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Film_Group_Users_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Film_Group_Users_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Film_Group_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Film_Group_Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Film_Group_Users_Var_Pop_Fields = {
  __typename?: 'film_group_users_var_pop_fields';
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "film_group_users" */
export type Film_Group_Users_Var_Pop_Order_By = {
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Film_Group_Users_Var_Samp_Fields = {
  __typename?: 'film_group_users_var_samp_fields';
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "film_group_users" */
export type Film_Group_Users_Var_Samp_Order_By = {
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Film_Group_Users_Variance_Fields = {
  __typename?: 'film_group_users_variance_fields';
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "film_group_users" */
export type Film_Group_Users_Variance_Order_By = {
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "film_groups" */
export type Film_Groups = {
  __typename?: 'film_groups';
  /** An object relationship */
  award?: Maybe<Awards>;
  award_id?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  festival_genre?: Maybe<Festival_Genres>;
  festival_genre_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  festival_submissions: Array<Film_Group_Festival_Submissions>;
  /** An aggregate relationship */
  festival_submissions_aggregate: Film_Group_Festival_Submissions_Aggregate;
  /** An object relationship */
  film_festival: Film_Festivals;
  film_festival_id: Scalars['numeric'];
  id: Scalars['Int'];
  name: Scalars['String'];
  /** An array relationship */
  selection_progresses: Array<Selection_Progress>;
  /** An aggregate relationship */
  selection_progresses_aggregate: Selection_Progress_Aggregate;
  /** An array relationship */
  teams: Array<Film_Group_Films>;
  /** An aggregate relationship */
  teams_aggregate: Film_Group_Films_Aggregate;
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  users: Array<Film_Group_Users>;
  /** An aggregate relationship */
  users_aggregate: Film_Group_Users_Aggregate;
};


/** columns and relationships of "film_groups" */
export type Film_GroupsFestival_SubmissionsArgs = {
  distinct_on?: InputMaybe<Array<Film_Group_Festival_Submissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Film_Group_Festival_Submissions_Order_By>>;
  where?: InputMaybe<Film_Group_Festival_Submissions_Bool_Exp>;
};


/** columns and relationships of "film_groups" */
export type Film_GroupsFestival_Submissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Film_Group_Festival_Submissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Film_Group_Festival_Submissions_Order_By>>;
  where?: InputMaybe<Film_Group_Festival_Submissions_Bool_Exp>;
};


/** columns and relationships of "film_groups" */
export type Film_GroupsSelection_ProgressesArgs = {
  distinct_on?: InputMaybe<Array<Selection_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Selection_Progress_Order_By>>;
  where?: InputMaybe<Selection_Progress_Bool_Exp>;
};


/** columns and relationships of "film_groups" */
export type Film_GroupsSelection_Progresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Selection_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Selection_Progress_Order_By>>;
  where?: InputMaybe<Selection_Progress_Bool_Exp>;
};


/** columns and relationships of "film_groups" */
export type Film_GroupsTeamsArgs = {
  distinct_on?: InputMaybe<Array<Film_Group_Films_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Film_Group_Films_Order_By>>;
  where?: InputMaybe<Film_Group_Films_Bool_Exp>;
};


/** columns and relationships of "film_groups" */
export type Film_GroupsTeams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Film_Group_Films_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Film_Group_Films_Order_By>>;
  where?: InputMaybe<Film_Group_Films_Bool_Exp>;
};


/** columns and relationships of "film_groups" */
export type Film_GroupsUsersArgs = {
  distinct_on?: InputMaybe<Array<Film_Group_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Film_Group_Users_Order_By>>;
  where?: InputMaybe<Film_Group_Users_Bool_Exp>;
};


/** columns and relationships of "film_groups" */
export type Film_GroupsUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Film_Group_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Film_Group_Users_Order_By>>;
  where?: InputMaybe<Film_Group_Users_Bool_Exp>;
};

/** aggregated selection of "film_groups" */
export type Film_Groups_Aggregate = {
  __typename?: 'film_groups_aggregate';
  aggregate?: Maybe<Film_Groups_Aggregate_Fields>;
  nodes: Array<Film_Groups>;
};

/** aggregate fields of "film_groups" */
export type Film_Groups_Aggregate_Fields = {
  __typename?: 'film_groups_aggregate_fields';
  avg?: Maybe<Film_Groups_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Film_Groups_Max_Fields>;
  min?: Maybe<Film_Groups_Min_Fields>;
  stddev?: Maybe<Film_Groups_Stddev_Fields>;
  stddev_pop?: Maybe<Film_Groups_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Film_Groups_Stddev_Samp_Fields>;
  sum?: Maybe<Film_Groups_Sum_Fields>;
  var_pop?: Maybe<Film_Groups_Var_Pop_Fields>;
  var_samp?: Maybe<Film_Groups_Var_Samp_Fields>;
  variance?: Maybe<Film_Groups_Variance_Fields>;
};


/** aggregate fields of "film_groups" */
export type Film_Groups_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Film_Groups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Film_Groups_Avg_Fields = {
  __typename?: 'film_groups_avg_fields';
  award_id?: Maybe<Scalars['Float']>;
  festival_genre_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "film_groups". All fields are combined with a logical 'AND'. */
export type Film_Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Film_Groups_Bool_Exp>>;
  _not?: InputMaybe<Film_Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Film_Groups_Bool_Exp>>;
  award?: InputMaybe<Awards_Bool_Exp>;
  award_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  festival_genre?: InputMaybe<Festival_Genres_Bool_Exp>;
  festival_genre_id?: InputMaybe<Int_Comparison_Exp>;
  festival_submissions?: InputMaybe<Film_Group_Festival_Submissions_Bool_Exp>;
  festival_submissions_aggregate?: InputMaybe<Film_Group_Festival_Submissions_Aggregate_Bool_Exp>;
  film_festival?: InputMaybe<Film_Festivals_Bool_Exp>;
  film_festival_id?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  selection_progresses?: InputMaybe<Selection_Progress_Bool_Exp>;
  selection_progresses_aggregate?: InputMaybe<Selection_Progress_Aggregate_Bool_Exp>;
  teams?: InputMaybe<Film_Group_Films_Bool_Exp>;
  teams_aggregate?: InputMaybe<Film_Group_Films_Aggregate_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  users?: InputMaybe<Film_Group_Users_Bool_Exp>;
  users_aggregate?: InputMaybe<Film_Group_Users_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "film_groups" */
export enum Film_Groups_Constraint {
  /** unique or primary key constraint on columns "id" */
  FilmGroupsPkey = 'film_groups_pkey'
}

/** input type for incrementing numeric columns in table "film_groups" */
export type Film_Groups_Inc_Input = {
  award_id?: InputMaybe<Scalars['Int']>;
  festival_genre_id?: InputMaybe<Scalars['Int']>;
  film_festival_id?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "film_groups" */
export type Film_Groups_Insert_Input = {
  award?: InputMaybe<Awards_Obj_Rel_Insert_Input>;
  award_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  festival_genre?: InputMaybe<Festival_Genres_Obj_Rel_Insert_Input>;
  festival_genre_id?: InputMaybe<Scalars['Int']>;
  festival_submissions?: InputMaybe<Film_Group_Festival_Submissions_Arr_Rel_Insert_Input>;
  film_festival?: InputMaybe<Film_Festivals_Obj_Rel_Insert_Input>;
  film_festival_id?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  selection_progresses?: InputMaybe<Selection_Progress_Arr_Rel_Insert_Input>;
  teams?: InputMaybe<Film_Group_Films_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  users?: InputMaybe<Film_Group_Users_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Film_Groups_Max_Fields = {
  __typename?: 'film_groups_max_fields';
  award_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  festival_genre_id?: Maybe<Scalars['Int']>;
  film_festival_id?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Film_Groups_Min_Fields = {
  __typename?: 'film_groups_min_fields';
  award_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  festival_genre_id?: Maybe<Scalars['Int']>;
  film_festival_id?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "film_groups" */
export type Film_Groups_Mutation_Response = {
  __typename?: 'film_groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Film_Groups>;
};

/** input type for inserting object relation for remote table "film_groups" */
export type Film_Groups_Obj_Rel_Insert_Input = {
  data: Film_Groups_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Film_Groups_On_Conflict>;
};

/** on_conflict condition type for table "film_groups" */
export type Film_Groups_On_Conflict = {
  constraint: Film_Groups_Constraint;
  update_columns?: Array<Film_Groups_Update_Column>;
  where?: InputMaybe<Film_Groups_Bool_Exp>;
};

/** Ordering options when selecting data from "film_groups". */
export type Film_Groups_Order_By = {
  award?: InputMaybe<Awards_Order_By>;
  award_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  festival_genre?: InputMaybe<Festival_Genres_Order_By>;
  festival_genre_id?: InputMaybe<Order_By>;
  festival_submissions_aggregate?: InputMaybe<Film_Group_Festival_Submissions_Aggregate_Order_By>;
  film_festival?: InputMaybe<Film_Festivals_Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  selection_progresses_aggregate?: InputMaybe<Selection_Progress_Aggregate_Order_By>;
  teams_aggregate?: InputMaybe<Film_Group_Films_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  users_aggregate?: InputMaybe<Film_Group_Users_Aggregate_Order_By>;
};

/** primary key columns input for table: film_groups */
export type Film_Groups_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "film_groups" */
export enum Film_Groups_Select_Column {
  /** column name */
  AwardId = 'award_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FestivalGenreId = 'festival_genre_id',
  /** column name */
  FilmFestivalId = 'film_festival_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "film_groups" */
export type Film_Groups_Set_Input = {
  award_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  festival_genre_id?: InputMaybe<Scalars['Int']>;
  film_festival_id?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Film_Groups_Stddev_Fields = {
  __typename?: 'film_groups_stddev_fields';
  award_id?: Maybe<Scalars['Float']>;
  festival_genre_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Film_Groups_Stddev_Pop_Fields = {
  __typename?: 'film_groups_stddev_pop_fields';
  award_id?: Maybe<Scalars['Float']>;
  festival_genre_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Film_Groups_Stddev_Samp_Fields = {
  __typename?: 'film_groups_stddev_samp_fields';
  award_id?: Maybe<Scalars['Float']>;
  festival_genre_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "film_groups" */
export type Film_Groups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Film_Groups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Film_Groups_Stream_Cursor_Value_Input = {
  award_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  festival_genre_id?: InputMaybe<Scalars['Int']>;
  film_festival_id?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Film_Groups_Sum_Fields = {
  __typename?: 'film_groups_sum_fields';
  award_id?: Maybe<Scalars['Int']>;
  festival_genre_id?: Maybe<Scalars['Int']>;
  film_festival_id?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "film_groups" */
export enum Film_Groups_Update_Column {
  /** column name */
  AwardId = 'award_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FestivalGenreId = 'festival_genre_id',
  /** column name */
  FilmFestivalId = 'film_festival_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Film_Groups_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Film_Groups_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Film_Groups_Set_Input>;
  /** filter the rows which have to be updated */
  where: Film_Groups_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Film_Groups_Var_Pop_Fields = {
  __typename?: 'film_groups_var_pop_fields';
  award_id?: Maybe<Scalars['Float']>;
  festival_genre_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Film_Groups_Var_Samp_Fields = {
  __typename?: 'film_groups_var_samp_fields';
  award_id?: Maybe<Scalars['Float']>;
  festival_genre_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Film_Groups_Variance_Fields = {
  __typename?: 'film_groups_variance_fields';
  award_id?: Maybe<Scalars['Float']>;
  festival_genre_id?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "films" */
export type Films = {
  __typename?: 'films';
  created: Scalars['timestamp'];
  created_by: Scalars['String'];
  duration?: Maybe<Scalars['numeric']>;
  gpt_contains_fuck?: Maybe<Scalars['Boolean']>;
  gpt_genre?: Maybe<Scalars['String']>;
  gpt_mpaa_rating?: Maybe<Scalars['String']>;
  gpt_synopses?: Maybe<Scalars['jsonb']>;
  gpt_synopsis?: Maybe<Scalars['String']>;
  gpt_tagline?: Maybe<Scalars['String']>;
  id: Scalars['numeric'];
  initiated_at?: Maybe<Scalars['timestamp']>;
  mux_asset_data?: Maybe<Scalars['jsonb']>;
  mux_asset_id?: Maybe<Scalars['String']>;
  mux_playback_id?: Maybe<Scalars['String']>;
  mux_thumbnail_time?: Maybe<Scalars['numeric']>;
  mux_upload_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  team: Teams;
  team_id: Scalars['numeric'];
  transcript?: Maybe<Scalars['String']>;
  updated: Scalars['timestamp'];
  updated_by: Scalars['String'];
  upload_size?: Maybe<Scalars['numeric']>;
  upload_url?: Maybe<Scalars['String']>;
  uploaded_at?: Maybe<Scalars['timestamp']>;
  vimeo_url?: Maybe<Scalars['String']>;
};


/** columns and relationships of "films" */
export type FilmsGpt_SynopsesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "films" */
export type FilmsMux_Asset_DataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "films" */
export type Films_Aggregate = {
  __typename?: 'films_aggregate';
  aggregate?: Maybe<Films_Aggregate_Fields>;
  nodes: Array<Films>;
};

/** aggregate fields of "films" */
export type Films_Aggregate_Fields = {
  __typename?: 'films_aggregate_fields';
  avg?: Maybe<Films_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Films_Max_Fields>;
  min?: Maybe<Films_Min_Fields>;
  stddev?: Maybe<Films_Stddev_Fields>;
  stddev_pop?: Maybe<Films_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Films_Stddev_Samp_Fields>;
  sum?: Maybe<Films_Sum_Fields>;
  var_pop?: Maybe<Films_Var_Pop_Fields>;
  var_samp?: Maybe<Films_Var_Samp_Fields>;
  variance?: Maybe<Films_Variance_Fields>;
};


/** aggregate fields of "films" */
export type Films_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Films_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Films_Append_Input = {
  gpt_synopses?: InputMaybe<Scalars['jsonb']>;
  mux_asset_data?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Films_Avg_Fields = {
  __typename?: 'films_avg_fields';
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mux_thumbnail_time?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  upload_size?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "films". All fields are combined with a logical 'AND'. */
export type Films_Bool_Exp = {
  _and?: InputMaybe<Array<Films_Bool_Exp>>;
  _not?: InputMaybe<Films_Bool_Exp>;
  _or?: InputMaybe<Array<Films_Bool_Exp>>;
  created?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  duration?: InputMaybe<Numeric_Comparison_Exp>;
  gpt_contains_fuck?: InputMaybe<Boolean_Comparison_Exp>;
  gpt_genre?: InputMaybe<String_Comparison_Exp>;
  gpt_mpaa_rating?: InputMaybe<String_Comparison_Exp>;
  gpt_synopses?: InputMaybe<Jsonb_Comparison_Exp>;
  gpt_synopsis?: InputMaybe<String_Comparison_Exp>;
  gpt_tagline?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Numeric_Comparison_Exp>;
  initiated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  mux_asset_data?: InputMaybe<Jsonb_Comparison_Exp>;
  mux_asset_id?: InputMaybe<String_Comparison_Exp>;
  mux_playback_id?: InputMaybe<String_Comparison_Exp>;
  mux_thumbnail_time?: InputMaybe<Numeric_Comparison_Exp>;
  mux_upload_id?: InputMaybe<String_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Numeric_Comparison_Exp>;
  transcript?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
  upload_size?: InputMaybe<Numeric_Comparison_Exp>;
  upload_url?: InputMaybe<String_Comparison_Exp>;
  uploaded_at?: InputMaybe<Timestamp_Comparison_Exp>;
  vimeo_url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "films" */
export enum Films_Constraint {
  /** unique or primary key constraint on columns "mux_asset_id" */
  FilmsMuxAssetIdKey = 'films_mux_asset_id_key',
  /** unique or primary key constraint on columns "mux_playback_id" */
  FilmsMuxPlaybackIdKey = 'films_mux_playback_id_key',
  /** unique or primary key constraint on columns "mux_upload_id" */
  FilmsMuxUploadIdKey = 'films_mux_upload_id_key',
  /** unique or primary key constraint on columns "id" */
  FilmsPkey = 'films_pkey',
  /** unique or primary key constraint on columns "team_id" */
  FilmsTeamIdKey = 'films_team_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Films_Delete_At_Path_Input = {
  gpt_synopses?: InputMaybe<Array<Scalars['String']>>;
  mux_asset_data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Films_Delete_Elem_Input = {
  gpt_synopses?: InputMaybe<Scalars['Int']>;
  mux_asset_data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Films_Delete_Key_Input = {
  gpt_synopses?: InputMaybe<Scalars['String']>;
  mux_asset_data?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "films" */
export type Films_Inc_Input = {
  duration?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['numeric']>;
  mux_thumbnail_time?: InputMaybe<Scalars['numeric']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  upload_size?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "films" */
export type Films_Insert_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['numeric']>;
  gpt_contains_fuck?: InputMaybe<Scalars['Boolean']>;
  gpt_genre?: InputMaybe<Scalars['String']>;
  gpt_mpaa_rating?: InputMaybe<Scalars['String']>;
  gpt_synopses?: InputMaybe<Scalars['jsonb']>;
  gpt_synopsis?: InputMaybe<Scalars['String']>;
  gpt_tagline?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  initiated_at?: InputMaybe<Scalars['timestamp']>;
  mux_asset_data?: InputMaybe<Scalars['jsonb']>;
  mux_asset_id?: InputMaybe<Scalars['String']>;
  mux_playback_id?: InputMaybe<Scalars['String']>;
  mux_thumbnail_time?: InputMaybe<Scalars['numeric']>;
  mux_upload_id?: InputMaybe<Scalars['String']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['numeric']>;
  transcript?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
  upload_size?: InputMaybe<Scalars['numeric']>;
  upload_url?: InputMaybe<Scalars['String']>;
  uploaded_at?: InputMaybe<Scalars['timestamp']>;
  vimeo_url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Films_Max_Fields = {
  __typename?: 'films_max_fields';
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['numeric']>;
  gpt_genre?: Maybe<Scalars['String']>;
  gpt_mpaa_rating?: Maybe<Scalars['String']>;
  gpt_synopsis?: Maybe<Scalars['String']>;
  gpt_tagline?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  initiated_at?: Maybe<Scalars['timestamp']>;
  mux_asset_id?: Maybe<Scalars['String']>;
  mux_playback_id?: Maybe<Scalars['String']>;
  mux_thumbnail_time?: Maybe<Scalars['numeric']>;
  mux_upload_id?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['numeric']>;
  transcript?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
  upload_size?: Maybe<Scalars['numeric']>;
  upload_url?: Maybe<Scalars['String']>;
  uploaded_at?: Maybe<Scalars['timestamp']>;
  vimeo_url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Films_Min_Fields = {
  __typename?: 'films_min_fields';
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['numeric']>;
  gpt_genre?: Maybe<Scalars['String']>;
  gpt_mpaa_rating?: Maybe<Scalars['String']>;
  gpt_synopsis?: Maybe<Scalars['String']>;
  gpt_tagline?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  initiated_at?: Maybe<Scalars['timestamp']>;
  mux_asset_id?: Maybe<Scalars['String']>;
  mux_playback_id?: Maybe<Scalars['String']>;
  mux_thumbnail_time?: Maybe<Scalars['numeric']>;
  mux_upload_id?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['numeric']>;
  transcript?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
  upload_size?: Maybe<Scalars['numeric']>;
  upload_url?: Maybe<Scalars['String']>;
  uploaded_at?: Maybe<Scalars['timestamp']>;
  vimeo_url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "films" */
export type Films_Mutation_Response = {
  __typename?: 'films_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Films>;
};

/** input type for inserting object relation for remote table "films" */
export type Films_Obj_Rel_Insert_Input = {
  data: Films_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Films_On_Conflict>;
};

/** on_conflict condition type for table "films" */
export type Films_On_Conflict = {
  constraint: Films_Constraint;
  update_columns?: Array<Films_Update_Column>;
  where?: InputMaybe<Films_Bool_Exp>;
};

/** Ordering options when selecting data from "films". */
export type Films_Order_By = {
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  gpt_contains_fuck?: InputMaybe<Order_By>;
  gpt_genre?: InputMaybe<Order_By>;
  gpt_mpaa_rating?: InputMaybe<Order_By>;
  gpt_synopses?: InputMaybe<Order_By>;
  gpt_synopsis?: InputMaybe<Order_By>;
  gpt_tagline?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initiated_at?: InputMaybe<Order_By>;
  mux_asset_data?: InputMaybe<Order_By>;
  mux_asset_id?: InputMaybe<Order_By>;
  mux_playback_id?: InputMaybe<Order_By>;
  mux_thumbnail_time?: InputMaybe<Order_By>;
  mux_upload_id?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  transcript?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  upload_size?: InputMaybe<Order_By>;
  upload_url?: InputMaybe<Order_By>;
  uploaded_at?: InputMaybe<Order_By>;
  vimeo_url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: films */
export type Films_Pk_Columns_Input = {
  id: Scalars['numeric'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Films_Prepend_Input = {
  gpt_synopses?: InputMaybe<Scalars['jsonb']>;
  mux_asset_data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "films" */
export enum Films_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Duration = 'duration',
  /** column name */
  GptContainsFuck = 'gpt_contains_fuck',
  /** column name */
  GptGenre = 'gpt_genre',
  /** column name */
  GptMpaaRating = 'gpt_mpaa_rating',
  /** column name */
  GptSynopses = 'gpt_synopses',
  /** column name */
  GptSynopsis = 'gpt_synopsis',
  /** column name */
  GptTagline = 'gpt_tagline',
  /** column name */
  Id = 'id',
  /** column name */
  InitiatedAt = 'initiated_at',
  /** column name */
  MuxAssetData = 'mux_asset_data',
  /** column name */
  MuxAssetId = 'mux_asset_id',
  /** column name */
  MuxPlaybackId = 'mux_playback_id',
  /** column name */
  MuxThumbnailTime = 'mux_thumbnail_time',
  /** column name */
  MuxUploadId = 'mux_upload_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Transcript = 'transcript',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  UploadSize = 'upload_size',
  /** column name */
  UploadUrl = 'upload_url',
  /** column name */
  UploadedAt = 'uploaded_at',
  /** column name */
  VimeoUrl = 'vimeo_url'
}

/** input type for updating data in table "films" */
export type Films_Set_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['numeric']>;
  gpt_contains_fuck?: InputMaybe<Scalars['Boolean']>;
  gpt_genre?: InputMaybe<Scalars['String']>;
  gpt_mpaa_rating?: InputMaybe<Scalars['String']>;
  gpt_synopses?: InputMaybe<Scalars['jsonb']>;
  gpt_synopsis?: InputMaybe<Scalars['String']>;
  gpt_tagline?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  initiated_at?: InputMaybe<Scalars['timestamp']>;
  mux_asset_data?: InputMaybe<Scalars['jsonb']>;
  mux_asset_id?: InputMaybe<Scalars['String']>;
  mux_playback_id?: InputMaybe<Scalars['String']>;
  mux_thumbnail_time?: InputMaybe<Scalars['numeric']>;
  mux_upload_id?: InputMaybe<Scalars['String']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  transcript?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
  upload_size?: InputMaybe<Scalars['numeric']>;
  upload_url?: InputMaybe<Scalars['String']>;
  uploaded_at?: InputMaybe<Scalars['timestamp']>;
  vimeo_url?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Films_Stddev_Fields = {
  __typename?: 'films_stddev_fields';
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mux_thumbnail_time?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  upload_size?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Films_Stddev_Pop_Fields = {
  __typename?: 'films_stddev_pop_fields';
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mux_thumbnail_time?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  upload_size?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Films_Stddev_Samp_Fields = {
  __typename?: 'films_stddev_samp_fields';
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mux_thumbnail_time?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  upload_size?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "films" */
export type Films_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Films_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Films_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['numeric']>;
  gpt_contains_fuck?: InputMaybe<Scalars['Boolean']>;
  gpt_genre?: InputMaybe<Scalars['String']>;
  gpt_mpaa_rating?: InputMaybe<Scalars['String']>;
  gpt_synopses?: InputMaybe<Scalars['jsonb']>;
  gpt_synopsis?: InputMaybe<Scalars['String']>;
  gpt_tagline?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  initiated_at?: InputMaybe<Scalars['timestamp']>;
  mux_asset_data?: InputMaybe<Scalars['jsonb']>;
  mux_asset_id?: InputMaybe<Scalars['String']>;
  mux_playback_id?: InputMaybe<Scalars['String']>;
  mux_thumbnail_time?: InputMaybe<Scalars['numeric']>;
  mux_upload_id?: InputMaybe<Scalars['String']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  transcript?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
  upload_size?: InputMaybe<Scalars['numeric']>;
  upload_url?: InputMaybe<Scalars['String']>;
  uploaded_at?: InputMaybe<Scalars['timestamp']>;
  vimeo_url?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Films_Sum_Fields = {
  __typename?: 'films_sum_fields';
  duration?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['numeric']>;
  mux_thumbnail_time?: Maybe<Scalars['numeric']>;
  team_id?: Maybe<Scalars['numeric']>;
  upload_size?: Maybe<Scalars['numeric']>;
};

/** update columns of table "films" */
export enum Films_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Duration = 'duration',
  /** column name */
  GptContainsFuck = 'gpt_contains_fuck',
  /** column name */
  GptGenre = 'gpt_genre',
  /** column name */
  GptMpaaRating = 'gpt_mpaa_rating',
  /** column name */
  GptSynopses = 'gpt_synopses',
  /** column name */
  GptSynopsis = 'gpt_synopsis',
  /** column name */
  GptTagline = 'gpt_tagline',
  /** column name */
  Id = 'id',
  /** column name */
  InitiatedAt = 'initiated_at',
  /** column name */
  MuxAssetData = 'mux_asset_data',
  /** column name */
  MuxAssetId = 'mux_asset_id',
  /** column name */
  MuxPlaybackId = 'mux_playback_id',
  /** column name */
  MuxThumbnailTime = 'mux_thumbnail_time',
  /** column name */
  MuxUploadId = 'mux_upload_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Transcript = 'transcript',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  UploadSize = 'upload_size',
  /** column name */
  UploadUrl = 'upload_url',
  /** column name */
  UploadedAt = 'uploaded_at',
  /** column name */
  VimeoUrl = 'vimeo_url'
}

export type Films_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Films_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Films_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Films_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Films_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Films_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Films_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Films_Set_Input>;
  /** filter the rows which have to be updated */
  where: Films_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Films_Var_Pop_Fields = {
  __typename?: 'films_var_pop_fields';
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mux_thumbnail_time?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  upload_size?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Films_Var_Samp_Fields = {
  __typename?: 'films_var_samp_fields';
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mux_thumbnail_time?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  upload_size?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Films_Variance_Fields = {
  __typename?: 'films_variance_fields';
  duration?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  mux_thumbnail_time?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  upload_size?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "genres" */
export type Genres = {
  __typename?: 'genres';
  description?: Maybe<Scalars['String']>;
  id: Scalars['numeric'];
  name: Scalars['String'];
};

/** aggregated selection of "genres" */
export type Genres_Aggregate = {
  __typename?: 'genres_aggregate';
  aggregate?: Maybe<Genres_Aggregate_Fields>;
  nodes: Array<Genres>;
};

/** aggregate fields of "genres" */
export type Genres_Aggregate_Fields = {
  __typename?: 'genres_aggregate_fields';
  avg?: Maybe<Genres_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Genres_Max_Fields>;
  min?: Maybe<Genres_Min_Fields>;
  stddev?: Maybe<Genres_Stddev_Fields>;
  stddev_pop?: Maybe<Genres_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Genres_Stddev_Samp_Fields>;
  sum?: Maybe<Genres_Sum_Fields>;
  var_pop?: Maybe<Genres_Var_Pop_Fields>;
  var_samp?: Maybe<Genres_Var_Samp_Fields>;
  variance?: Maybe<Genres_Variance_Fields>;
};


/** aggregate fields of "genres" */
export type Genres_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Genres_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Genres_Avg_Fields = {
  __typename?: 'genres_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "genres". All fields are combined with a logical 'AND'. */
export type Genres_Bool_Exp = {
  _and?: InputMaybe<Array<Genres_Bool_Exp>>;
  _not?: InputMaybe<Genres_Bool_Exp>;
  _or?: InputMaybe<Array<Genres_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Numeric_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "genres" */
export enum Genres_Constraint {
  /** unique or primary key constraint on columns "id" */
  GenresPkey = 'genres_pkey'
}

/** input type for incrementing numeric columns in table "genres" */
export type Genres_Inc_Input = {
  id?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "genres" */
export type Genres_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Genres_Max_Fields = {
  __typename?: 'genres_max_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Genres_Min_Fields = {
  __typename?: 'genres_min_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "genres" */
export type Genres_Mutation_Response = {
  __typename?: 'genres_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Genres>;
};

/** on_conflict condition type for table "genres" */
export type Genres_On_Conflict = {
  constraint: Genres_Constraint;
  update_columns?: Array<Genres_Update_Column>;
  where?: InputMaybe<Genres_Bool_Exp>;
};

/** Ordering options when selecting data from "genres". */
export type Genres_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: genres */
export type Genres_Pk_Columns_Input = {
  id: Scalars['numeric'];
};

/** select columns of table "genres" */
export enum Genres_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "genres" */
export type Genres_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Genres_Stddev_Fields = {
  __typename?: 'genres_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Genres_Stddev_Pop_Fields = {
  __typename?: 'genres_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Genres_Stddev_Samp_Fields = {
  __typename?: 'genres_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "genres" */
export type Genres_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Genres_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Genres_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Genres_Sum_Fields = {
  __typename?: 'genres_sum_fields';
  id?: Maybe<Scalars['numeric']>;
};

/** update columns of table "genres" */
export enum Genres_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Genres_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Genres_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Genres_Set_Input>;
  /** filter the rows which have to be updated */
  where: Genres_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Genres_Var_Pop_Fields = {
  __typename?: 'genres_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Genres_Var_Samp_Fields = {
  __typename?: 'genres_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Genres_Variance_Fields = {
  __typename?: 'genres_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "kickoff_checkins" */
export type Kickoff_Checkins = {
  __typename?: 'kickoff_checkins';
  created: Scalars['timestamp'];
  created_by: Scalars['String'];
  id: Scalars['numeric'];
  phone?: Maybe<Scalars['String']>;
  /** An object relationship */
  team_membership?: Maybe<Team_Memberships>;
  team_membership_id?: Maybe<Scalars['numeric']>;
  updated: Scalars['timestamp'];
  updated_by: Scalars['String'];
};

/** aggregated selection of "kickoff_checkins" */
export type Kickoff_Checkins_Aggregate = {
  __typename?: 'kickoff_checkins_aggregate';
  aggregate?: Maybe<Kickoff_Checkins_Aggregate_Fields>;
  nodes: Array<Kickoff_Checkins>;
};

/** aggregate fields of "kickoff_checkins" */
export type Kickoff_Checkins_Aggregate_Fields = {
  __typename?: 'kickoff_checkins_aggregate_fields';
  avg?: Maybe<Kickoff_Checkins_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Kickoff_Checkins_Max_Fields>;
  min?: Maybe<Kickoff_Checkins_Min_Fields>;
  stddev?: Maybe<Kickoff_Checkins_Stddev_Fields>;
  stddev_pop?: Maybe<Kickoff_Checkins_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Kickoff_Checkins_Stddev_Samp_Fields>;
  sum?: Maybe<Kickoff_Checkins_Sum_Fields>;
  var_pop?: Maybe<Kickoff_Checkins_Var_Pop_Fields>;
  var_samp?: Maybe<Kickoff_Checkins_Var_Samp_Fields>;
  variance?: Maybe<Kickoff_Checkins_Variance_Fields>;
};


/** aggregate fields of "kickoff_checkins" */
export type Kickoff_Checkins_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Kickoff_Checkins_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Kickoff_Checkins_Avg_Fields = {
  __typename?: 'kickoff_checkins_avg_fields';
  id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "kickoff_checkins". All fields are combined with a logical 'AND'. */
export type Kickoff_Checkins_Bool_Exp = {
  _and?: InputMaybe<Array<Kickoff_Checkins_Bool_Exp>>;
  _not?: InputMaybe<Kickoff_Checkins_Bool_Exp>;
  _or?: InputMaybe<Array<Kickoff_Checkins_Bool_Exp>>;
  created?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Numeric_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  team_membership?: InputMaybe<Team_Memberships_Bool_Exp>;
  team_membership_id?: InputMaybe<Numeric_Comparison_Exp>;
  updated?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "kickoff_checkins" */
export enum Kickoff_Checkins_Constraint {
  /** unique or primary key constraint on columns "id" */
  KickoffCheckinsPkey = 'kickoff_checkins_pkey'
}

/** input type for incrementing numeric columns in table "kickoff_checkins" */
export type Kickoff_Checkins_Inc_Input = {
  id?: InputMaybe<Scalars['numeric']>;
  team_membership_id?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "kickoff_checkins" */
export type Kickoff_Checkins_Insert_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  phone?: InputMaybe<Scalars['String']>;
  team_membership?: InputMaybe<Team_Memberships_Obj_Rel_Insert_Input>;
  team_membership_id?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Kickoff_Checkins_Max_Fields = {
  __typename?: 'kickoff_checkins_max_fields';
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  phone?: Maybe<Scalars['String']>;
  team_membership_id?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Kickoff_Checkins_Min_Fields = {
  __typename?: 'kickoff_checkins_min_fields';
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  phone?: Maybe<Scalars['String']>;
  team_membership_id?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "kickoff_checkins" */
export type Kickoff_Checkins_Mutation_Response = {
  __typename?: 'kickoff_checkins_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Kickoff_Checkins>;
};

/** on_conflict condition type for table "kickoff_checkins" */
export type Kickoff_Checkins_On_Conflict = {
  constraint: Kickoff_Checkins_Constraint;
  update_columns?: Array<Kickoff_Checkins_Update_Column>;
  where?: InputMaybe<Kickoff_Checkins_Bool_Exp>;
};

/** Ordering options when selecting data from "kickoff_checkins". */
export type Kickoff_Checkins_Order_By = {
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  team_membership?: InputMaybe<Team_Memberships_Order_By>;
  team_membership_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: kickoff_checkins */
export type Kickoff_Checkins_Pk_Columns_Input = {
  id: Scalars['numeric'];
};

/** select columns of table "kickoff_checkins" */
export enum Kickoff_Checkins_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Phone = 'phone',
  /** column name */
  TeamMembershipId = 'team_membership_id',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** input type for updating data in table "kickoff_checkins" */
export type Kickoff_Checkins_Set_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  phone?: InputMaybe<Scalars['String']>;
  team_membership_id?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Kickoff_Checkins_Stddev_Fields = {
  __typename?: 'kickoff_checkins_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Kickoff_Checkins_Stddev_Pop_Fields = {
  __typename?: 'kickoff_checkins_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Kickoff_Checkins_Stddev_Samp_Fields = {
  __typename?: 'kickoff_checkins_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "kickoff_checkins" */
export type Kickoff_Checkins_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Kickoff_Checkins_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Kickoff_Checkins_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  phone?: InputMaybe<Scalars['String']>;
  team_membership_id?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Kickoff_Checkins_Sum_Fields = {
  __typename?: 'kickoff_checkins_sum_fields';
  id?: Maybe<Scalars['numeric']>;
  team_membership_id?: Maybe<Scalars['numeric']>;
};

/** update columns of table "kickoff_checkins" */
export enum Kickoff_Checkins_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Phone = 'phone',
  /** column name */
  TeamMembershipId = 'team_membership_id',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by'
}

export type Kickoff_Checkins_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Kickoff_Checkins_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Kickoff_Checkins_Set_Input>;
  /** filter the rows which have to be updated */
  where: Kickoff_Checkins_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Kickoff_Checkins_Var_Pop_Fields = {
  __typename?: 'kickoff_checkins_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Kickoff_Checkins_Var_Samp_Fields = {
  __typename?: 'kickoff_checkins_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Kickoff_Checkins_Variance_Fields = {
  __typename?: 'kickoff_checkins_variance_fields';
  id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "location_releases" */
export type Location_Releases = {
  __typename?: 'location_releases';
  address_1?: Maybe<Scalars['String']>;
  address_2?: Maybe<Scalars['String']>;
  /** An object relationship */
  asset?: Maybe<Team_Assets>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created: Scalars['timestamp'];
  created_by: Scalars['String'];
  first_name?: Maybe<Scalars['String']>;
  id: Scalars['numeric'];
  is_owned_by_team?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['numeric']>;
  lon?: Maybe<Scalars['numeric']>;
  middle_name?: Maybe<Scalars['String']>;
  release_asset_id?: Maybe<Scalars['numeric']>;
  state?: Maybe<Scalars['String']>;
  /** An object relationship */
  team: Teams;
  team_id: Scalars['numeric'];
  updated: Scalars['timestamp'];
  updated_by: Scalars['String'];
  venue_name?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

/** aggregated selection of "location_releases" */
export type Location_Releases_Aggregate = {
  __typename?: 'location_releases_aggregate';
  aggregate?: Maybe<Location_Releases_Aggregate_Fields>;
  nodes: Array<Location_Releases>;
};

export type Location_Releases_Aggregate_Bool_Exp = {
  count?: InputMaybe<Location_Releases_Aggregate_Bool_Exp_Count>;
};

export type Location_Releases_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Location_Releases_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Location_Releases_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "location_releases" */
export type Location_Releases_Aggregate_Fields = {
  __typename?: 'location_releases_aggregate_fields';
  avg?: Maybe<Location_Releases_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Location_Releases_Max_Fields>;
  min?: Maybe<Location_Releases_Min_Fields>;
  stddev?: Maybe<Location_Releases_Stddev_Fields>;
  stddev_pop?: Maybe<Location_Releases_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Location_Releases_Stddev_Samp_Fields>;
  sum?: Maybe<Location_Releases_Sum_Fields>;
  var_pop?: Maybe<Location_Releases_Var_Pop_Fields>;
  var_samp?: Maybe<Location_Releases_Var_Samp_Fields>;
  variance?: Maybe<Location_Releases_Variance_Fields>;
};


/** aggregate fields of "location_releases" */
export type Location_Releases_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Location_Releases_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "location_releases" */
export type Location_Releases_Aggregate_Order_By = {
  avg?: InputMaybe<Location_Releases_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Location_Releases_Max_Order_By>;
  min?: InputMaybe<Location_Releases_Min_Order_By>;
  stddev?: InputMaybe<Location_Releases_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Location_Releases_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Location_Releases_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Location_Releases_Sum_Order_By>;
  var_pop?: InputMaybe<Location_Releases_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Location_Releases_Var_Samp_Order_By>;
  variance?: InputMaybe<Location_Releases_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "location_releases" */
export type Location_Releases_Arr_Rel_Insert_Input = {
  data: Array<Location_Releases_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Location_Releases_On_Conflict>;
};

/** aggregate avg on columns */
export type Location_Releases_Avg_Fields = {
  __typename?: 'location_releases_avg_fields';
  id?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
  release_asset_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "location_releases" */
export type Location_Releases_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lon?: InputMaybe<Order_By>;
  release_asset_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "location_releases". All fields are combined with a logical 'AND'. */
export type Location_Releases_Bool_Exp = {
  _and?: InputMaybe<Array<Location_Releases_Bool_Exp>>;
  _not?: InputMaybe<Location_Releases_Bool_Exp>;
  _or?: InputMaybe<Array<Location_Releases_Bool_Exp>>;
  address_1?: InputMaybe<String_Comparison_Exp>;
  address_2?: InputMaybe<String_Comparison_Exp>;
  asset?: InputMaybe<Team_Assets_Bool_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Numeric_Comparison_Exp>;
  is_owned_by_team?: InputMaybe<String_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  lat?: InputMaybe<Numeric_Comparison_Exp>;
  lon?: InputMaybe<Numeric_Comparison_Exp>;
  middle_name?: InputMaybe<String_Comparison_Exp>;
  release_asset_id?: InputMaybe<Numeric_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Numeric_Comparison_Exp>;
  updated?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
  venue_name?: InputMaybe<String_Comparison_Exp>;
  zip?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "location_releases" */
export enum Location_Releases_Constraint {
  /** unique or primary key constraint on columns "id" */
  LocationReleasesPkey = 'location_releases_pkey'
}

/** input type for incrementing numeric columns in table "location_releases" */
export type Location_Releases_Inc_Input = {
  id?: InputMaybe<Scalars['numeric']>;
  lat?: InputMaybe<Scalars['numeric']>;
  lon?: InputMaybe<Scalars['numeric']>;
  release_asset_id?: InputMaybe<Scalars['numeric']>;
  team_id?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "location_releases" */
export type Location_Releases_Insert_Input = {
  address_1?: InputMaybe<Scalars['String']>;
  address_2?: InputMaybe<Scalars['String']>;
  asset?: InputMaybe<Team_Assets_Obj_Rel_Insert_Input>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  is_owned_by_team?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['numeric']>;
  lon?: InputMaybe<Scalars['numeric']>;
  middle_name?: InputMaybe<Scalars['String']>;
  release_asset_id?: InputMaybe<Scalars['numeric']>;
  state?: InputMaybe<Scalars['String']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
  venue_name?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Location_Releases_Max_Fields = {
  __typename?: 'location_releases_max_fields';
  address_1?: Maybe<Scalars['String']>;
  address_2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  is_owned_by_team?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['numeric']>;
  lon?: Maybe<Scalars['numeric']>;
  middle_name?: Maybe<Scalars['String']>;
  release_asset_id?: Maybe<Scalars['numeric']>;
  state?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
  venue_name?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "location_releases" */
export type Location_Releases_Max_Order_By = {
  address_1?: InputMaybe<Order_By>;
  address_2?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_owned_by_team?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lon?: InputMaybe<Order_By>;
  middle_name?: InputMaybe<Order_By>;
  release_asset_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  venue_name?: InputMaybe<Order_By>;
  zip?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Location_Releases_Min_Fields = {
  __typename?: 'location_releases_min_fields';
  address_1?: Maybe<Scalars['String']>;
  address_2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  is_owned_by_team?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['numeric']>;
  lon?: Maybe<Scalars['numeric']>;
  middle_name?: Maybe<Scalars['String']>;
  release_asset_id?: Maybe<Scalars['numeric']>;
  state?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
  venue_name?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "location_releases" */
export type Location_Releases_Min_Order_By = {
  address_1?: InputMaybe<Order_By>;
  address_2?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_owned_by_team?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lon?: InputMaybe<Order_By>;
  middle_name?: InputMaybe<Order_By>;
  release_asset_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  venue_name?: InputMaybe<Order_By>;
  zip?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "location_releases" */
export type Location_Releases_Mutation_Response = {
  __typename?: 'location_releases_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Location_Releases>;
};

/** on_conflict condition type for table "location_releases" */
export type Location_Releases_On_Conflict = {
  constraint: Location_Releases_Constraint;
  update_columns?: Array<Location_Releases_Update_Column>;
  where?: InputMaybe<Location_Releases_Bool_Exp>;
};

/** Ordering options when selecting data from "location_releases". */
export type Location_Releases_Order_By = {
  address_1?: InputMaybe<Order_By>;
  address_2?: InputMaybe<Order_By>;
  asset?: InputMaybe<Team_Assets_Order_By>;
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_owned_by_team?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lon?: InputMaybe<Order_By>;
  middle_name?: InputMaybe<Order_By>;
  release_asset_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  venue_name?: InputMaybe<Order_By>;
  zip?: InputMaybe<Order_By>;
};

/** primary key columns input for table: location_releases */
export type Location_Releases_Pk_Columns_Input = {
  id: Scalars['numeric'];
};

/** select columns of table "location_releases" */
export enum Location_Releases_Select_Column {
  /** column name */
  Address_1 = 'address_1',
  /** column name */
  Address_2 = 'address_2',
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsOwnedByTeam = 'is_owned_by_team',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lon = 'lon',
  /** column name */
  MiddleName = 'middle_name',
  /** column name */
  ReleaseAssetId = 'release_asset_id',
  /** column name */
  State = 'state',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  VenueName = 'venue_name',
  /** column name */
  Zip = 'zip'
}

/** input type for updating data in table "location_releases" */
export type Location_Releases_Set_Input = {
  address_1?: InputMaybe<Scalars['String']>;
  address_2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  is_owned_by_team?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['numeric']>;
  lon?: InputMaybe<Scalars['numeric']>;
  middle_name?: InputMaybe<Scalars['String']>;
  release_asset_id?: InputMaybe<Scalars['numeric']>;
  state?: InputMaybe<Scalars['String']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
  venue_name?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Location_Releases_Stddev_Fields = {
  __typename?: 'location_releases_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
  release_asset_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "location_releases" */
export type Location_Releases_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lon?: InputMaybe<Order_By>;
  release_asset_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Location_Releases_Stddev_Pop_Fields = {
  __typename?: 'location_releases_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
  release_asset_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "location_releases" */
export type Location_Releases_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lon?: InputMaybe<Order_By>;
  release_asset_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Location_Releases_Stddev_Samp_Fields = {
  __typename?: 'location_releases_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
  release_asset_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "location_releases" */
export type Location_Releases_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lon?: InputMaybe<Order_By>;
  release_asset_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "location_releases" */
export type Location_Releases_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Location_Releases_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Location_Releases_Stream_Cursor_Value_Input = {
  address_1?: InputMaybe<Scalars['String']>;
  address_2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  is_owned_by_team?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['numeric']>;
  lon?: InputMaybe<Scalars['numeric']>;
  middle_name?: InputMaybe<Scalars['String']>;
  release_asset_id?: InputMaybe<Scalars['numeric']>;
  state?: InputMaybe<Scalars['String']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
  venue_name?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Location_Releases_Sum_Fields = {
  __typename?: 'location_releases_sum_fields';
  id?: Maybe<Scalars['numeric']>;
  lat?: Maybe<Scalars['numeric']>;
  lon?: Maybe<Scalars['numeric']>;
  release_asset_id?: Maybe<Scalars['numeric']>;
  team_id?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "location_releases" */
export type Location_Releases_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lon?: InputMaybe<Order_By>;
  release_asset_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** update columns of table "location_releases" */
export enum Location_Releases_Update_Column {
  /** column name */
  Address_1 = 'address_1',
  /** column name */
  Address_2 = 'address_2',
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsOwnedByTeam = 'is_owned_by_team',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lon = 'lon',
  /** column name */
  MiddleName = 'middle_name',
  /** column name */
  ReleaseAssetId = 'release_asset_id',
  /** column name */
  State = 'state',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  VenueName = 'venue_name',
  /** column name */
  Zip = 'zip'
}

export type Location_Releases_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Location_Releases_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Location_Releases_Set_Input>;
  /** filter the rows which have to be updated */
  where: Location_Releases_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Location_Releases_Var_Pop_Fields = {
  __typename?: 'location_releases_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
  release_asset_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "location_releases" */
export type Location_Releases_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lon?: InputMaybe<Order_By>;
  release_asset_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Location_Releases_Var_Samp_Fields = {
  __typename?: 'location_releases_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
  release_asset_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "location_releases" */
export type Location_Releases_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lon?: InputMaybe<Order_By>;
  release_asset_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Location_Releases_Variance_Fields = {
  __typename?: 'location_releases_variance_fields';
  id?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
  release_asset_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "location_releases" */
export type Location_Releases_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lon?: InputMaybe<Order_By>;
  release_asset_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "matchup_requests" */
export type Matchup_Requests = {
  __typename?: 'matchup_requests';
  created: Scalars['timestamp'];
  created_by: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  expertise?: Maybe<Scalars['String']>;
  expertise_json: Scalars['jsonb'];
  /** An object relationship */
  film_festival: Film_Festivals;
  film_festival_id: Scalars['numeric'];
  first_name: Scalars['String'];
  genres?: Maybe<Scalars['String']>;
  genres_json: Scalars['jsonb'];
  id: Scalars['numeric'];
  last_name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  /** An object relationship */
  team?: Maybe<Teams>;
  team_id?: Maybe<Scalars['numeric']>;
  type?: Maybe<Scalars['String']>;
  updated: Scalars['timestamp'];
  updated_by: Scalars['String'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['numeric'];
  withdrawn?: Maybe<Scalars['timestamp']>;
  withdrawn_type?: Maybe<Scalars['String']>;
};


/** columns and relationships of "matchup_requests" */
export type Matchup_RequestsExpertise_JsonArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "matchup_requests" */
export type Matchup_RequestsGenres_JsonArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "matchup_requests" */
export type Matchup_Requests_Aggregate = {
  __typename?: 'matchup_requests_aggregate';
  aggregate?: Maybe<Matchup_Requests_Aggregate_Fields>;
  nodes: Array<Matchup_Requests>;
};

export type Matchup_Requests_Aggregate_Bool_Exp = {
  count?: InputMaybe<Matchup_Requests_Aggregate_Bool_Exp_Count>;
};

export type Matchup_Requests_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Matchup_Requests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Matchup_Requests_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "matchup_requests" */
export type Matchup_Requests_Aggregate_Fields = {
  __typename?: 'matchup_requests_aggregate_fields';
  avg?: Maybe<Matchup_Requests_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Matchup_Requests_Max_Fields>;
  min?: Maybe<Matchup_Requests_Min_Fields>;
  stddev?: Maybe<Matchup_Requests_Stddev_Fields>;
  stddev_pop?: Maybe<Matchup_Requests_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Matchup_Requests_Stddev_Samp_Fields>;
  sum?: Maybe<Matchup_Requests_Sum_Fields>;
  var_pop?: Maybe<Matchup_Requests_Var_Pop_Fields>;
  var_samp?: Maybe<Matchup_Requests_Var_Samp_Fields>;
  variance?: Maybe<Matchup_Requests_Variance_Fields>;
};


/** aggregate fields of "matchup_requests" */
export type Matchup_Requests_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Matchup_Requests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "matchup_requests" */
export type Matchup_Requests_Aggregate_Order_By = {
  avg?: InputMaybe<Matchup_Requests_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Matchup_Requests_Max_Order_By>;
  min?: InputMaybe<Matchup_Requests_Min_Order_By>;
  stddev?: InputMaybe<Matchup_Requests_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Matchup_Requests_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Matchup_Requests_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Matchup_Requests_Sum_Order_By>;
  var_pop?: InputMaybe<Matchup_Requests_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Matchup_Requests_Var_Samp_Order_By>;
  variance?: InputMaybe<Matchup_Requests_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Matchup_Requests_Append_Input = {
  expertise_json?: InputMaybe<Scalars['jsonb']>;
  genres_json?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "matchup_requests" */
export type Matchup_Requests_Arr_Rel_Insert_Input = {
  data: Array<Matchup_Requests_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Matchup_Requests_On_Conflict>;
};

/** aggregate avg on columns */
export type Matchup_Requests_Avg_Fields = {
  __typename?: 'matchup_requests_avg_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "matchup_requests" */
export type Matchup_Requests_Avg_Order_By = {
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "matchup_requests". All fields are combined with a logical 'AND'. */
export type Matchup_Requests_Bool_Exp = {
  _and?: InputMaybe<Array<Matchup_Requests_Bool_Exp>>;
  _not?: InputMaybe<Matchup_Requests_Bool_Exp>;
  _or?: InputMaybe<Array<Matchup_Requests_Bool_Exp>>;
  created?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  expertise?: InputMaybe<String_Comparison_Exp>;
  expertise_json?: InputMaybe<Jsonb_Comparison_Exp>;
  film_festival?: InputMaybe<Film_Festivals_Bool_Exp>;
  film_festival_id?: InputMaybe<Numeric_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  genres?: InputMaybe<String_Comparison_Exp>;
  genres_json?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Numeric_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Numeric_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Numeric_Comparison_Exp>;
  withdrawn?: InputMaybe<Timestamp_Comparison_Exp>;
  withdrawn_type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "matchup_requests" */
export enum Matchup_Requests_Constraint {
  /** unique or primary key constraint on columns "user_id", "film_festival_id" */
  MatchupRequestsFilmFestivalIdUserIdKey = 'matchup_requests_film_festival_id_user_id_key',
  /** unique or primary key constraint on columns "id" */
  MatchupRequestsPkey = 'matchup_requests_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Matchup_Requests_Delete_At_Path_Input = {
  expertise_json?: InputMaybe<Array<Scalars['String']>>;
  genres_json?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Matchup_Requests_Delete_Elem_Input = {
  expertise_json?: InputMaybe<Scalars['Int']>;
  genres_json?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Matchup_Requests_Delete_Key_Input = {
  expertise_json?: InputMaybe<Scalars['String']>;
  genres_json?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "matchup_requests" */
export type Matchup_Requests_Inc_Input = {
  film_festival_id?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['numeric']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  user_id?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "matchup_requests" */
export type Matchup_Requests_Insert_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  expertise?: InputMaybe<Scalars['String']>;
  expertise_json?: InputMaybe<Scalars['jsonb']>;
  film_festival?: InputMaybe<Film_Festivals_Obj_Rel_Insert_Input>;
  film_festival_id?: InputMaybe<Scalars['numeric']>;
  first_name?: InputMaybe<Scalars['String']>;
  genres?: InputMaybe<Scalars['String']>;
  genres_json?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['numeric']>;
  last_name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['numeric']>;
  type?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['numeric']>;
  withdrawn?: InputMaybe<Scalars['timestamp']>;
  withdrawn_type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Matchup_Requests_Max_Fields = {
  __typename?: 'matchup_requests_max_fields';
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  expertise?: Maybe<Scalars['String']>;
  film_festival_id?: Maybe<Scalars['numeric']>;
  first_name?: Maybe<Scalars['String']>;
  genres?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  last_name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['numeric']>;
  type?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['numeric']>;
  withdrawn?: Maybe<Scalars['timestamp']>;
  withdrawn_type?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "matchup_requests" */
export type Matchup_Requests_Max_Order_By = {
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  expertise?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  genres?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  withdrawn?: InputMaybe<Order_By>;
  withdrawn_type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Matchup_Requests_Min_Fields = {
  __typename?: 'matchup_requests_min_fields';
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  expertise?: Maybe<Scalars['String']>;
  film_festival_id?: Maybe<Scalars['numeric']>;
  first_name?: Maybe<Scalars['String']>;
  genres?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  last_name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['numeric']>;
  type?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['numeric']>;
  withdrawn?: Maybe<Scalars['timestamp']>;
  withdrawn_type?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "matchup_requests" */
export type Matchup_Requests_Min_Order_By = {
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  expertise?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  genres?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  withdrawn?: InputMaybe<Order_By>;
  withdrawn_type?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "matchup_requests" */
export type Matchup_Requests_Mutation_Response = {
  __typename?: 'matchup_requests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Matchup_Requests>;
};

/** on_conflict condition type for table "matchup_requests" */
export type Matchup_Requests_On_Conflict = {
  constraint: Matchup_Requests_Constraint;
  update_columns?: Array<Matchup_Requests_Update_Column>;
  where?: InputMaybe<Matchup_Requests_Bool_Exp>;
};

/** Ordering options when selecting data from "matchup_requests". */
export type Matchup_Requests_Order_By = {
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  expertise?: InputMaybe<Order_By>;
  expertise_json?: InputMaybe<Order_By>;
  film_festival?: InputMaybe<Film_Festivals_Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  genres?: InputMaybe<Order_By>;
  genres_json?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  withdrawn?: InputMaybe<Order_By>;
  withdrawn_type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: matchup_requests */
export type Matchup_Requests_Pk_Columns_Input = {
  id: Scalars['numeric'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Matchup_Requests_Prepend_Input = {
  expertise_json?: InputMaybe<Scalars['jsonb']>;
  genres_json?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "matchup_requests" */
export enum Matchup_Requests_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Email = 'email',
  /** column name */
  Expertise = 'expertise',
  /** column name */
  ExpertiseJson = 'expertise_json',
  /** column name */
  FilmFestivalId = 'film_festival_id',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Genres = 'genres',
  /** column name */
  GenresJson = 'genres_json',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Notes = 'notes',
  /** column name */
  Phone = 'phone',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Type = 'type',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Withdrawn = 'withdrawn',
  /** column name */
  WithdrawnType = 'withdrawn_type'
}

/** input type for updating data in table "matchup_requests" */
export type Matchup_Requests_Set_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  expertise?: InputMaybe<Scalars['String']>;
  expertise_json?: InputMaybe<Scalars['jsonb']>;
  film_festival_id?: InputMaybe<Scalars['numeric']>;
  first_name?: InputMaybe<Scalars['String']>;
  genres?: InputMaybe<Scalars['String']>;
  genres_json?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['numeric']>;
  last_name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  type?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['numeric']>;
  withdrawn?: InputMaybe<Scalars['timestamp']>;
  withdrawn_type?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Matchup_Requests_Stddev_Fields = {
  __typename?: 'matchup_requests_stddev_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "matchup_requests" */
export type Matchup_Requests_Stddev_Order_By = {
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Matchup_Requests_Stddev_Pop_Fields = {
  __typename?: 'matchup_requests_stddev_pop_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "matchup_requests" */
export type Matchup_Requests_Stddev_Pop_Order_By = {
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Matchup_Requests_Stddev_Samp_Fields = {
  __typename?: 'matchup_requests_stddev_samp_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "matchup_requests" */
export type Matchup_Requests_Stddev_Samp_Order_By = {
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "matchup_requests" */
export type Matchup_Requests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Matchup_Requests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Matchup_Requests_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  expertise?: InputMaybe<Scalars['String']>;
  expertise_json?: InputMaybe<Scalars['jsonb']>;
  film_festival_id?: InputMaybe<Scalars['numeric']>;
  first_name?: InputMaybe<Scalars['String']>;
  genres?: InputMaybe<Scalars['String']>;
  genres_json?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['numeric']>;
  last_name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  type?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['numeric']>;
  withdrawn?: InputMaybe<Scalars['timestamp']>;
  withdrawn_type?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Matchup_Requests_Sum_Fields = {
  __typename?: 'matchup_requests_sum_fields';
  film_festival_id?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['numeric']>;
  team_id?: Maybe<Scalars['numeric']>;
  user_id?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "matchup_requests" */
export type Matchup_Requests_Sum_Order_By = {
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "matchup_requests" */
export enum Matchup_Requests_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Email = 'email',
  /** column name */
  Expertise = 'expertise',
  /** column name */
  ExpertiseJson = 'expertise_json',
  /** column name */
  FilmFestivalId = 'film_festival_id',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Genres = 'genres',
  /** column name */
  GenresJson = 'genres_json',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Notes = 'notes',
  /** column name */
  Phone = 'phone',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Type = 'type',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Withdrawn = 'withdrawn',
  /** column name */
  WithdrawnType = 'withdrawn_type'
}

export type Matchup_Requests_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Matchup_Requests_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Matchup_Requests_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Matchup_Requests_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Matchup_Requests_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Matchup_Requests_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Matchup_Requests_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Matchup_Requests_Set_Input>;
  /** filter the rows which have to be updated */
  where: Matchup_Requests_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Matchup_Requests_Var_Pop_Fields = {
  __typename?: 'matchup_requests_var_pop_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "matchup_requests" */
export type Matchup_Requests_Var_Pop_Order_By = {
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Matchup_Requests_Var_Samp_Fields = {
  __typename?: 'matchup_requests_var_samp_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "matchup_requests" */
export type Matchup_Requests_Var_Samp_Order_By = {
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Matchup_Requests_Variance_Fields = {
  __typename?: 'matchup_requests_variance_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "matchup_requests" */
export type Matchup_Requests_Variance_Order_By = {
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "music_releases" */
export type Music_Releases = {
  __typename?: 'music_releases';
  /** An object relationship */
  asset?: Maybe<Team_Assets>;
  composer?: Maybe<Scalars['String']>;
  created: Scalars['timestamp'];
  created_by: Scalars['String'];
  duration?: Maybe<Scalars['String']>;
  id: Scalars['numeric'];
  is_original?: Maybe<Scalars['String']>;
  is_royalty_free?: Maybe<Scalars['String']>;
  publisher?: Maybe<Scalars['String']>;
  release_asset_id?: Maybe<Scalars['numeric']>;
  royalty_free_source?: Maybe<Scalars['String']>;
  society?: Maybe<Scalars['String']>;
  song_title?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['String']>;
  /** An object relationship */
  team: Teams;
  team_id: Scalars['numeric'];
  updated: Scalars['timestamp'];
  updated_by: Scalars['String'];
  use_type?: Maybe<Scalars['String']>;
};

/** aggregated selection of "music_releases" */
export type Music_Releases_Aggregate = {
  __typename?: 'music_releases_aggregate';
  aggregate?: Maybe<Music_Releases_Aggregate_Fields>;
  nodes: Array<Music_Releases>;
};

export type Music_Releases_Aggregate_Bool_Exp = {
  count?: InputMaybe<Music_Releases_Aggregate_Bool_Exp_Count>;
};

export type Music_Releases_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Music_Releases_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Music_Releases_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "music_releases" */
export type Music_Releases_Aggregate_Fields = {
  __typename?: 'music_releases_aggregate_fields';
  avg?: Maybe<Music_Releases_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Music_Releases_Max_Fields>;
  min?: Maybe<Music_Releases_Min_Fields>;
  stddev?: Maybe<Music_Releases_Stddev_Fields>;
  stddev_pop?: Maybe<Music_Releases_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Music_Releases_Stddev_Samp_Fields>;
  sum?: Maybe<Music_Releases_Sum_Fields>;
  var_pop?: Maybe<Music_Releases_Var_Pop_Fields>;
  var_samp?: Maybe<Music_Releases_Var_Samp_Fields>;
  variance?: Maybe<Music_Releases_Variance_Fields>;
};


/** aggregate fields of "music_releases" */
export type Music_Releases_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Music_Releases_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "music_releases" */
export type Music_Releases_Aggregate_Order_By = {
  avg?: InputMaybe<Music_Releases_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Music_Releases_Max_Order_By>;
  min?: InputMaybe<Music_Releases_Min_Order_By>;
  stddev?: InputMaybe<Music_Releases_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Music_Releases_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Music_Releases_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Music_Releases_Sum_Order_By>;
  var_pop?: InputMaybe<Music_Releases_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Music_Releases_Var_Samp_Order_By>;
  variance?: InputMaybe<Music_Releases_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "music_releases" */
export type Music_Releases_Arr_Rel_Insert_Input = {
  data: Array<Music_Releases_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Music_Releases_On_Conflict>;
};

/** aggregate avg on columns */
export type Music_Releases_Avg_Fields = {
  __typename?: 'music_releases_avg_fields';
  id?: Maybe<Scalars['Float']>;
  release_asset_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "music_releases" */
export type Music_Releases_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  release_asset_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "music_releases". All fields are combined with a logical 'AND'. */
export type Music_Releases_Bool_Exp = {
  _and?: InputMaybe<Array<Music_Releases_Bool_Exp>>;
  _not?: InputMaybe<Music_Releases_Bool_Exp>;
  _or?: InputMaybe<Array<Music_Releases_Bool_Exp>>;
  asset?: InputMaybe<Team_Assets_Bool_Exp>;
  composer?: InputMaybe<String_Comparison_Exp>;
  created?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  duration?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Numeric_Comparison_Exp>;
  is_original?: InputMaybe<String_Comparison_Exp>;
  is_royalty_free?: InputMaybe<String_Comparison_Exp>;
  publisher?: InputMaybe<String_Comparison_Exp>;
  release_asset_id?: InputMaybe<Numeric_Comparison_Exp>;
  royalty_free_source?: InputMaybe<String_Comparison_Exp>;
  society?: InputMaybe<String_Comparison_Exp>;
  song_title?: InputMaybe<String_Comparison_Exp>;
  start_time?: InputMaybe<String_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Numeric_Comparison_Exp>;
  updated?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
  use_type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "music_releases" */
export enum Music_Releases_Constraint {
  /** unique or primary key constraint on columns "id" */
  MusicReleasesPkey = 'music_releases_pkey'
}

/** input type for incrementing numeric columns in table "music_releases" */
export type Music_Releases_Inc_Input = {
  id?: InputMaybe<Scalars['numeric']>;
  release_asset_id?: InputMaybe<Scalars['numeric']>;
  team_id?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "music_releases" */
export type Music_Releases_Insert_Input = {
  asset?: InputMaybe<Team_Assets_Obj_Rel_Insert_Input>;
  composer?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  is_original?: InputMaybe<Scalars['String']>;
  is_royalty_free?: InputMaybe<Scalars['String']>;
  publisher?: InputMaybe<Scalars['String']>;
  release_asset_id?: InputMaybe<Scalars['numeric']>;
  royalty_free_source?: InputMaybe<Scalars['String']>;
  society?: InputMaybe<Scalars['String']>;
  song_title?: InputMaybe<Scalars['String']>;
  start_time?: InputMaybe<Scalars['String']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
  use_type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Music_Releases_Max_Fields = {
  __typename?: 'music_releases_max_fields';
  composer?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  is_original?: Maybe<Scalars['String']>;
  is_royalty_free?: Maybe<Scalars['String']>;
  publisher?: Maybe<Scalars['String']>;
  release_asset_id?: Maybe<Scalars['numeric']>;
  royalty_free_source?: Maybe<Scalars['String']>;
  society?: Maybe<Scalars['String']>;
  song_title?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
  use_type?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "music_releases" */
export type Music_Releases_Max_Order_By = {
  composer?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_original?: InputMaybe<Order_By>;
  is_royalty_free?: InputMaybe<Order_By>;
  publisher?: InputMaybe<Order_By>;
  release_asset_id?: InputMaybe<Order_By>;
  royalty_free_source?: InputMaybe<Order_By>;
  society?: InputMaybe<Order_By>;
  song_title?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  use_type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Music_Releases_Min_Fields = {
  __typename?: 'music_releases_min_fields';
  composer?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  is_original?: Maybe<Scalars['String']>;
  is_royalty_free?: Maybe<Scalars['String']>;
  publisher?: Maybe<Scalars['String']>;
  release_asset_id?: Maybe<Scalars['numeric']>;
  royalty_free_source?: Maybe<Scalars['String']>;
  society?: Maybe<Scalars['String']>;
  song_title?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
  use_type?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "music_releases" */
export type Music_Releases_Min_Order_By = {
  composer?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_original?: InputMaybe<Order_By>;
  is_royalty_free?: InputMaybe<Order_By>;
  publisher?: InputMaybe<Order_By>;
  release_asset_id?: InputMaybe<Order_By>;
  royalty_free_source?: InputMaybe<Order_By>;
  society?: InputMaybe<Order_By>;
  song_title?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  use_type?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "music_releases" */
export type Music_Releases_Mutation_Response = {
  __typename?: 'music_releases_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Music_Releases>;
};

/** on_conflict condition type for table "music_releases" */
export type Music_Releases_On_Conflict = {
  constraint: Music_Releases_Constraint;
  update_columns?: Array<Music_Releases_Update_Column>;
  where?: InputMaybe<Music_Releases_Bool_Exp>;
};

/** Ordering options when selecting data from "music_releases". */
export type Music_Releases_Order_By = {
  asset?: InputMaybe<Team_Assets_Order_By>;
  composer?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_original?: InputMaybe<Order_By>;
  is_royalty_free?: InputMaybe<Order_By>;
  publisher?: InputMaybe<Order_By>;
  release_asset_id?: InputMaybe<Order_By>;
  royalty_free_source?: InputMaybe<Order_By>;
  society?: InputMaybe<Order_By>;
  song_title?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  use_type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: music_releases */
export type Music_Releases_Pk_Columns_Input = {
  id: Scalars['numeric'];
};

/** select columns of table "music_releases" */
export enum Music_Releases_Select_Column {
  /** column name */
  Composer = 'composer',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Duration = 'duration',
  /** column name */
  Id = 'id',
  /** column name */
  IsOriginal = 'is_original',
  /** column name */
  IsRoyaltyFree = 'is_royalty_free',
  /** column name */
  Publisher = 'publisher',
  /** column name */
  ReleaseAssetId = 'release_asset_id',
  /** column name */
  RoyaltyFreeSource = 'royalty_free_source',
  /** column name */
  Society = 'society',
  /** column name */
  SongTitle = 'song_title',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  UseType = 'use_type'
}

/** input type for updating data in table "music_releases" */
export type Music_Releases_Set_Input = {
  composer?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  is_original?: InputMaybe<Scalars['String']>;
  is_royalty_free?: InputMaybe<Scalars['String']>;
  publisher?: InputMaybe<Scalars['String']>;
  release_asset_id?: InputMaybe<Scalars['numeric']>;
  royalty_free_source?: InputMaybe<Scalars['String']>;
  society?: InputMaybe<Scalars['String']>;
  song_title?: InputMaybe<Scalars['String']>;
  start_time?: InputMaybe<Scalars['String']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
  use_type?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Music_Releases_Stddev_Fields = {
  __typename?: 'music_releases_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  release_asset_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "music_releases" */
export type Music_Releases_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  release_asset_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Music_Releases_Stddev_Pop_Fields = {
  __typename?: 'music_releases_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  release_asset_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "music_releases" */
export type Music_Releases_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  release_asset_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Music_Releases_Stddev_Samp_Fields = {
  __typename?: 'music_releases_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  release_asset_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "music_releases" */
export type Music_Releases_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  release_asset_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "music_releases" */
export type Music_Releases_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Music_Releases_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Music_Releases_Stream_Cursor_Value_Input = {
  composer?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  is_original?: InputMaybe<Scalars['String']>;
  is_royalty_free?: InputMaybe<Scalars['String']>;
  publisher?: InputMaybe<Scalars['String']>;
  release_asset_id?: InputMaybe<Scalars['numeric']>;
  royalty_free_source?: InputMaybe<Scalars['String']>;
  society?: InputMaybe<Scalars['String']>;
  song_title?: InputMaybe<Scalars['String']>;
  start_time?: InputMaybe<Scalars['String']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
  use_type?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Music_Releases_Sum_Fields = {
  __typename?: 'music_releases_sum_fields';
  id?: Maybe<Scalars['numeric']>;
  release_asset_id?: Maybe<Scalars['numeric']>;
  team_id?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "music_releases" */
export type Music_Releases_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  release_asset_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** update columns of table "music_releases" */
export enum Music_Releases_Update_Column {
  /** column name */
  Composer = 'composer',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Duration = 'duration',
  /** column name */
  Id = 'id',
  /** column name */
  IsOriginal = 'is_original',
  /** column name */
  IsRoyaltyFree = 'is_royalty_free',
  /** column name */
  Publisher = 'publisher',
  /** column name */
  ReleaseAssetId = 'release_asset_id',
  /** column name */
  RoyaltyFreeSource = 'royalty_free_source',
  /** column name */
  Society = 'society',
  /** column name */
  SongTitle = 'song_title',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  UseType = 'use_type'
}

export type Music_Releases_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Music_Releases_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Music_Releases_Set_Input>;
  /** filter the rows which have to be updated */
  where: Music_Releases_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Music_Releases_Var_Pop_Fields = {
  __typename?: 'music_releases_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  release_asset_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "music_releases" */
export type Music_Releases_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  release_asset_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Music_Releases_Var_Samp_Fields = {
  __typename?: 'music_releases_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  release_asset_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "music_releases" */
export type Music_Releases_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  release_asset_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Music_Releases_Variance_Fields = {
  __typename?: 'music_releases_variance_fields';
  id?: Maybe<Scalars['Float']>;
  release_asset_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "music_releases" */
export type Music_Releases_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  release_asset_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  assetSign?: Maybe<Scalars['String']>;
  assetUpload?: Maybe<AssetUpload>;
  claimFestivalSubmissionVoucher: Scalars['Boolean'];
  crispRequestSignature?: Maybe<Scalars['String']>;
  crispTriggerInvite?: Maybe<Scalars['String']>;
  /** delete data from the table: "asset_exports" */
  delete_asset_exports?: Maybe<Asset_Exports_Mutation_Response>;
  /** delete single row from the table: "asset_exports" */
  delete_asset_exports_by_pk?: Maybe<Asset_Exports>;
  /** delete data from the table: "asset_types" */
  delete_asset_types?: Maybe<Asset_Types_Mutation_Response>;
  /** delete single row from the table: "asset_types" */
  delete_asset_types_by_pk?: Maybe<Asset_Types>;
  /** delete data from the table: "audience_favorite_votes" */
  delete_audience_favorite_votes?: Maybe<Audience_Favorite_Votes_Mutation_Response>;
  /** delete single row from the table: "audience_favorite_votes" */
  delete_audience_favorite_votes_by_pk?: Maybe<Audience_Favorite_Votes>;
  /** delete data from the table: "award_asset_types" */
  delete_award_asset_types?: Maybe<Award_Asset_Types_Mutation_Response>;
  /** delete single row from the table: "award_asset_types" */
  delete_award_asset_types_by_pk?: Maybe<Award_Asset_Types>;
  /** delete data from the table: "award_winners" */
  delete_award_winners?: Maybe<Award_Winners_Mutation_Response>;
  /** delete single row from the table: "award_winners" */
  delete_award_winners_by_pk?: Maybe<Award_Winners>;
  /** delete data from the table: "awards" */
  delete_awards?: Maybe<Awards_Mutation_Response>;
  /** delete single row from the table: "awards" */
  delete_awards_by_pk?: Maybe<Awards>;
  /** delete data from the table: "awards_ceremony_checkins" */
  delete_awards_ceremony_checkins?: Maybe<Awards_Ceremony_Checkins_Mutation_Response>;
  /** delete single row from the table: "awards_ceremony_checkins" */
  delete_awards_ceremony_checkins_by_pk?: Maybe<Awards_Ceremony_Checkins>;
  /** delete data from the table: "countries" */
  delete_countries?: Maybe<Countries_Mutation_Response>;
  /** delete single row from the table: "countries" */
  delete_countries_by_pk?: Maybe<Countries>;
  /** delete data from the table: "exit_interview_recordings" */
  delete_exit_interview_recordings?: Maybe<Exit_Interview_Recordings_Mutation_Response>;
  /** delete single row from the table: "exit_interview_recordings" */
  delete_exit_interview_recordings_by_pk?: Maybe<Exit_Interview_Recordings>;
  /** delete data from the table: "exit_interviews" */
  delete_exit_interviews?: Maybe<Exit_Interviews_Mutation_Response>;
  /** delete single row from the table: "exit_interviews" */
  delete_exit_interviews_by_pk?: Maybe<Exit_Interviews>;
  /** delete data from the table: "expertise" */
  delete_expertise?: Maybe<Expertise_Mutation_Response>;
  /** delete single row from the table: "expertise" */
  delete_expertise_by_pk?: Maybe<Expertise>;
  /** delete data from the table: "festival_badge_type_event_type" */
  delete_festival_badge_type_event_type?: Maybe<Festival_Badge_Type_Event_Type_Mutation_Response>;
  /** delete single row from the table: "festival_badge_type_event_type" */
  delete_festival_badge_type_event_type_by_pk?: Maybe<Festival_Badge_Type_Event_Type>;
  /** delete data from the table: "festival_badge_types" */
  delete_festival_badge_types?: Maybe<Festival_Badge_Types_Mutation_Response>;
  /** delete single row from the table: "festival_badge_types" */
  delete_festival_badge_types_by_pk?: Maybe<Festival_Badge_Types>;
  /** delete data from the table: "festival_badges" */
  delete_festival_badges?: Maybe<Festival_Badges_Mutation_Response>;
  /** delete single row from the table: "festival_badges" */
  delete_festival_badges_by_pk?: Maybe<Festival_Badges>;
  /** delete data from the table: "festival_event_locations" */
  delete_festival_event_locations?: Maybe<Festival_Event_Locations_Mutation_Response>;
  /** delete single row from the table: "festival_event_locations" */
  delete_festival_event_locations_by_pk?: Maybe<Festival_Event_Locations>;
  /** delete data from the table: "festival_event_types" */
  delete_festival_event_types?: Maybe<Festival_Event_Types_Mutation_Response>;
  /** delete single row from the table: "festival_event_types" */
  delete_festival_event_types_by_pk?: Maybe<Festival_Event_Types>;
  /** delete data from the table: "festival_events" */
  delete_festival_events?: Maybe<Festival_Events_Mutation_Response>;
  /** delete single row from the table: "festival_events" */
  delete_festival_events_by_pk?: Maybe<Festival_Events>;
  /** delete data from the table: "festival_genres" */
  delete_festival_genres?: Maybe<Festival_Genres_Mutation_Response>;
  /** delete single row from the table: "festival_genres" */
  delete_festival_genres_by_pk?: Maybe<Festival_Genres>;
  /** delete data from the table: "festival_submission_assets" */
  delete_festival_submission_assets?: Maybe<Festival_Submission_Assets_Mutation_Response>;
  /** delete single row from the table: "festival_submission_assets" */
  delete_festival_submission_assets_by_pk?: Maybe<Festival_Submission_Assets>;
  /** delete data from the table: "festival_submission_feedback" */
  delete_festival_submission_feedback?: Maybe<Festival_Submission_Feedback_Mutation_Response>;
  /** delete single row from the table: "festival_submission_feedback" */
  delete_festival_submission_feedback_by_pk?: Maybe<Festival_Submission_Feedback>;
  /** delete data from the table: "festival_submission_vouchers" */
  delete_festival_submission_vouchers?: Maybe<Festival_Submission_Vouchers_Mutation_Response>;
  /** delete single row from the table: "festival_submission_vouchers" */
  delete_festival_submission_vouchers_by_pk?: Maybe<Festival_Submission_Vouchers>;
  /** delete data from the table: "festival_submissions" */
  delete_festival_submissions?: Maybe<Festival_Submissions_Mutation_Response>;
  /** delete single row from the table: "festival_submissions" */
  delete_festival_submissions_by_pk?: Maybe<Festival_Submissions>;
  /** delete data from the table: "festival_tickets" */
  delete_festival_tickets?: Maybe<Festival_Tickets_Mutation_Response>;
  /** delete single row from the table: "festival_tickets" */
  delete_festival_tickets_by_pk?: Maybe<Festival_Tickets>;
  /** delete data from the table: "film_festivals" */
  delete_film_festivals?: Maybe<Film_Festivals_Mutation_Response>;
  /** delete single row from the table: "film_festivals" */
  delete_film_festivals_by_pk?: Maybe<Film_Festivals>;
  /** delete data from the table: "film_group_festival_submissions" */
  delete_film_group_festival_submissions?: Maybe<Film_Group_Festival_Submissions_Mutation_Response>;
  /** delete single row from the table: "film_group_festival_submissions" */
  delete_film_group_festival_submissions_by_pk?: Maybe<Film_Group_Festival_Submissions>;
  /** delete data from the table: "film_group_films" */
  delete_film_group_films?: Maybe<Film_Group_Films_Mutation_Response>;
  /** delete single row from the table: "film_group_films" */
  delete_film_group_films_by_pk?: Maybe<Film_Group_Films>;
  /** delete data from the table: "film_group_users" */
  delete_film_group_users?: Maybe<Film_Group_Users_Mutation_Response>;
  /** delete single row from the table: "film_group_users" */
  delete_film_group_users_by_pk?: Maybe<Film_Group_Users>;
  /** delete data from the table: "film_groups" */
  delete_film_groups?: Maybe<Film_Groups_Mutation_Response>;
  /** delete single row from the table: "film_groups" */
  delete_film_groups_by_pk?: Maybe<Film_Groups>;
  /** delete data from the table: "films" */
  delete_films?: Maybe<Films_Mutation_Response>;
  /** delete single row from the table: "films" */
  delete_films_by_pk?: Maybe<Films>;
  /** delete data from the table: "genres" */
  delete_genres?: Maybe<Genres_Mutation_Response>;
  /** delete single row from the table: "genres" */
  delete_genres_by_pk?: Maybe<Genres>;
  /** delete data from the table: "kickoff_checkins" */
  delete_kickoff_checkins?: Maybe<Kickoff_Checkins_Mutation_Response>;
  /** delete single row from the table: "kickoff_checkins" */
  delete_kickoff_checkins_by_pk?: Maybe<Kickoff_Checkins>;
  /** delete data from the table: "location_releases" */
  delete_location_releases?: Maybe<Location_Releases_Mutation_Response>;
  /** delete single row from the table: "location_releases" */
  delete_location_releases_by_pk?: Maybe<Location_Releases>;
  /** delete data from the table: "matchup_requests" */
  delete_matchup_requests?: Maybe<Matchup_Requests_Mutation_Response>;
  /** delete single row from the table: "matchup_requests" */
  delete_matchup_requests_by_pk?: Maybe<Matchup_Requests>;
  /** delete data from the table: "music_releases" */
  delete_music_releases?: Maybe<Music_Releases_Mutation_Response>;
  /** delete single row from the table: "music_releases" */
  delete_music_releases_by_pk?: Maybe<Music_Releases>;
  /** delete data from the table: "nomination_assets" */
  delete_nomination_assets?: Maybe<Nomination_Assets_Mutation_Response>;
  /** delete single row from the table: "nomination_assets" */
  delete_nomination_assets_by_pk?: Maybe<Nomination_Assets>;
  /** delete data from the table: "nominations" */
  delete_nominations?: Maybe<Nominations_Mutation_Response>;
  /** delete single row from the table: "nominations" */
  delete_nominations_by_pk?: Maybe<Nominations>;
  /** delete data from the table: "online_screening_tickets" */
  delete_online_screening_tickets?: Maybe<Online_Screening_Tickets_Mutation_Response>;
  /** delete single row from the table: "online_screening_tickets" */
  delete_online_screening_tickets_by_pk?: Maybe<Online_Screening_Tickets>;
  /** delete data from the table: "payments" */
  delete_payments?: Maybe<Payments_Mutation_Response>;
  /** delete single row from the table: "payments" */
  delete_payments_by_pk?: Maybe<Payments>;
  /** delete data from the table: "playlist_team" */
  delete_playlist_team?: Maybe<Playlist_Team_Mutation_Response>;
  /** delete single row from the table: "playlist_team" */
  delete_playlist_team_by_pk?: Maybe<Playlist_Team>;
  /** delete data from the table: "playlists" */
  delete_playlists?: Maybe<Playlists_Mutation_Response>;
  /** delete single row from the table: "playlists" */
  delete_playlists_by_pk?: Maybe<Playlists>;
  /** delete data from the table: "prize_elections" */
  delete_prize_elections?: Maybe<Prize_Elections_Mutation_Response>;
  /** delete data from the table: "prizes" */
  delete_prizes?: Maybe<Prizes_Mutation_Response>;
  /** delete single row from the table: "prizes" */
  delete_prizes_by_pk?: Maybe<Prizes>;
  /** delete data from the table: "registrations" */
  delete_registrations?: Maybe<Registrations_Mutation_Response>;
  /** delete single row from the table: "registrations" */
  delete_registrations_by_pk?: Maybe<Registrations>;
  /** delete data from the table: "selection_ballots" */
  delete_selection_ballots?: Maybe<Selection_Ballots_Mutation_Response>;
  /** delete single row from the table: "selection_ballots" */
  delete_selection_ballots_by_pk?: Maybe<Selection_Ballots>;
  /** delete data from the table: "selection_feedback" */
  delete_selection_feedback?: Maybe<Selection_Feedback_Mutation_Response>;
  /** delete single row from the table: "selection_feedback" */
  delete_selection_feedback_by_pk?: Maybe<Selection_Feedback>;
  /** delete data from the table: "selection_metrics" */
  delete_selection_metrics?: Maybe<Selection_Metrics_Mutation_Response>;
  /** delete single row from the table: "selection_metrics" */
  delete_selection_metrics_by_pk?: Maybe<Selection_Metrics>;
  /** delete data from the table: "selection_progress" */
  delete_selection_progress?: Maybe<Selection_Progress_Mutation_Response>;
  /** delete single row from the table: "selection_progress" */
  delete_selection_progress_by_pk?: Maybe<Selection_Progress>;
  /** delete data from the table: "sharables" */
  delete_sharables?: Maybe<Sharables_Mutation_Response>;
  /** delete single row from the table: "sharables" */
  delete_sharables_by_pk?: Maybe<Sharables>;
  /** delete data from the table: "sms_votes" */
  delete_sms_votes?: Maybe<Sms_Votes_Mutation_Response>;
  /** delete single row from the table: "sms_votes" */
  delete_sms_votes_by_pk?: Maybe<Sms_Votes>;
  /** delete data from the table: "sponsors" */
  delete_sponsors?: Maybe<Sponsors_Mutation_Response>;
  /** delete single row from the table: "sponsors" */
  delete_sponsors_by_pk?: Maybe<Sponsors>;
  /** delete data from the table: "studios" */
  delete_studios?: Maybe<Studios_Mutation_Response>;
  /** delete single row from the table: "studios" */
  delete_studios_by_pk?: Maybe<Studios>;
  /** delete data from the table: "team_assets" */
  delete_team_assets?: Maybe<Team_Assets_Mutation_Response>;
  /** delete single row from the table: "team_assets" */
  delete_team_assets_by_pk?: Maybe<Team_Assets>;
  /** delete data from the table: "team_memberships" */
  delete_team_memberships?: Maybe<Team_Memberships_Mutation_Response>;
  /** delete single row from the table: "team_memberships" */
  delete_team_memberships_by_pk?: Maybe<Team_Memberships>;
  /** delete data from the table: "team_roles" */
  delete_team_roles?: Maybe<Team_Roles_Mutation_Response>;
  /** delete single row from the table: "team_roles" */
  delete_team_roles_by_pk?: Maybe<Team_Roles>;
  /** delete data from the table: "teams" */
  delete_teams?: Maybe<Teams_Mutation_Response>;
  /** delete single row from the table: "teams" */
  delete_teams_by_pk?: Maybe<Teams>;
  /** delete data from the table: "teams_with_awards_ceremony_checkins" */
  delete_teams_with_awards_ceremony_checkins?: Maybe<Teams_With_Awards_Ceremony_Checkins_Mutation_Response>;
  /** delete data from the table: "teams_with_checkins" */
  delete_teams_with_checkins?: Maybe<Teams_With_Checkins_Mutation_Response>;
  /** delete data from the table: "ticket_tailor_vouchers" */
  delete_ticket_tailor_vouchers?: Maybe<Ticket_Tailor_Vouchers_Mutation_Response>;
  /** delete single row from the table: "ticket_tailor_vouchers" */
  delete_ticket_tailor_vouchers_by_pk?: Maybe<Ticket_Tailor_Vouchers>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  /** insert data into the table: "asset_exports" */
  insert_asset_exports?: Maybe<Asset_Exports_Mutation_Response>;
  /** insert a single row into the table: "asset_exports" */
  insert_asset_exports_one?: Maybe<Asset_Exports>;
  /** insert data into the table: "asset_types" */
  insert_asset_types?: Maybe<Asset_Types_Mutation_Response>;
  /** insert a single row into the table: "asset_types" */
  insert_asset_types_one?: Maybe<Asset_Types>;
  /** insert data into the table: "audience_favorite_votes" */
  insert_audience_favorite_votes?: Maybe<Audience_Favorite_Votes_Mutation_Response>;
  /** insert a single row into the table: "audience_favorite_votes" */
  insert_audience_favorite_votes_one?: Maybe<Audience_Favorite_Votes>;
  /** insert data into the table: "award_asset_types" */
  insert_award_asset_types?: Maybe<Award_Asset_Types_Mutation_Response>;
  /** insert a single row into the table: "award_asset_types" */
  insert_award_asset_types_one?: Maybe<Award_Asset_Types>;
  /** insert data into the table: "award_winners" */
  insert_award_winners?: Maybe<Award_Winners_Mutation_Response>;
  /** insert a single row into the table: "award_winners" */
  insert_award_winners_one?: Maybe<Award_Winners>;
  /** insert data into the table: "awards" */
  insert_awards?: Maybe<Awards_Mutation_Response>;
  /** insert data into the table: "awards_ceremony_checkins" */
  insert_awards_ceremony_checkins?: Maybe<Awards_Ceremony_Checkins_Mutation_Response>;
  /** insert a single row into the table: "awards_ceremony_checkins" */
  insert_awards_ceremony_checkins_one?: Maybe<Awards_Ceremony_Checkins>;
  /** insert a single row into the table: "awards" */
  insert_awards_one?: Maybe<Awards>;
  /** insert data into the table: "countries" */
  insert_countries?: Maybe<Countries_Mutation_Response>;
  /** insert a single row into the table: "countries" */
  insert_countries_one?: Maybe<Countries>;
  /** insert data into the table: "exit_interview_recordings" */
  insert_exit_interview_recordings?: Maybe<Exit_Interview_Recordings_Mutation_Response>;
  /** insert a single row into the table: "exit_interview_recordings" */
  insert_exit_interview_recordings_one?: Maybe<Exit_Interview_Recordings>;
  /** insert data into the table: "exit_interviews" */
  insert_exit_interviews?: Maybe<Exit_Interviews_Mutation_Response>;
  /** insert a single row into the table: "exit_interviews" */
  insert_exit_interviews_one?: Maybe<Exit_Interviews>;
  /** insert data into the table: "expertise" */
  insert_expertise?: Maybe<Expertise_Mutation_Response>;
  /** insert a single row into the table: "expertise" */
  insert_expertise_one?: Maybe<Expertise>;
  /** insert data into the table: "festival_badge_type_event_type" */
  insert_festival_badge_type_event_type?: Maybe<Festival_Badge_Type_Event_Type_Mutation_Response>;
  /** insert a single row into the table: "festival_badge_type_event_type" */
  insert_festival_badge_type_event_type_one?: Maybe<Festival_Badge_Type_Event_Type>;
  /** insert data into the table: "festival_badge_types" */
  insert_festival_badge_types?: Maybe<Festival_Badge_Types_Mutation_Response>;
  /** insert a single row into the table: "festival_badge_types" */
  insert_festival_badge_types_one?: Maybe<Festival_Badge_Types>;
  /** insert data into the table: "festival_badges" */
  insert_festival_badges?: Maybe<Festival_Badges_Mutation_Response>;
  /** insert a single row into the table: "festival_badges" */
  insert_festival_badges_one?: Maybe<Festival_Badges>;
  /** insert data into the table: "festival_event_locations" */
  insert_festival_event_locations?: Maybe<Festival_Event_Locations_Mutation_Response>;
  /** insert a single row into the table: "festival_event_locations" */
  insert_festival_event_locations_one?: Maybe<Festival_Event_Locations>;
  /** insert data into the table: "festival_event_types" */
  insert_festival_event_types?: Maybe<Festival_Event_Types_Mutation_Response>;
  /** insert a single row into the table: "festival_event_types" */
  insert_festival_event_types_one?: Maybe<Festival_Event_Types>;
  /** insert data into the table: "festival_events" */
  insert_festival_events?: Maybe<Festival_Events_Mutation_Response>;
  /** insert a single row into the table: "festival_events" */
  insert_festival_events_one?: Maybe<Festival_Events>;
  /** insert data into the table: "festival_genres" */
  insert_festival_genres?: Maybe<Festival_Genres_Mutation_Response>;
  /** insert a single row into the table: "festival_genres" */
  insert_festival_genres_one?: Maybe<Festival_Genres>;
  /** insert data into the table: "festival_submission_assets" */
  insert_festival_submission_assets?: Maybe<Festival_Submission_Assets_Mutation_Response>;
  /** insert a single row into the table: "festival_submission_assets" */
  insert_festival_submission_assets_one?: Maybe<Festival_Submission_Assets>;
  /** insert data into the table: "festival_submission_feedback" */
  insert_festival_submission_feedback?: Maybe<Festival_Submission_Feedback_Mutation_Response>;
  /** insert a single row into the table: "festival_submission_feedback" */
  insert_festival_submission_feedback_one?: Maybe<Festival_Submission_Feedback>;
  /** insert data into the table: "festival_submission_vouchers" */
  insert_festival_submission_vouchers?: Maybe<Festival_Submission_Vouchers_Mutation_Response>;
  /** insert a single row into the table: "festival_submission_vouchers" */
  insert_festival_submission_vouchers_one?: Maybe<Festival_Submission_Vouchers>;
  /** insert data into the table: "festival_submissions" */
  insert_festival_submissions?: Maybe<Festival_Submissions_Mutation_Response>;
  /** insert a single row into the table: "festival_submissions" */
  insert_festival_submissions_one?: Maybe<Festival_Submissions>;
  /** insert data into the table: "festival_tickets" */
  insert_festival_tickets?: Maybe<Festival_Tickets_Mutation_Response>;
  /** insert a single row into the table: "festival_tickets" */
  insert_festival_tickets_one?: Maybe<Festival_Tickets>;
  /** insert data into the table: "film_festivals" */
  insert_film_festivals?: Maybe<Film_Festivals_Mutation_Response>;
  /** insert a single row into the table: "film_festivals" */
  insert_film_festivals_one?: Maybe<Film_Festivals>;
  /** insert data into the table: "film_group_festival_submissions" */
  insert_film_group_festival_submissions?: Maybe<Film_Group_Festival_Submissions_Mutation_Response>;
  /** insert a single row into the table: "film_group_festival_submissions" */
  insert_film_group_festival_submissions_one?: Maybe<Film_Group_Festival_Submissions>;
  /** insert data into the table: "film_group_films" */
  insert_film_group_films?: Maybe<Film_Group_Films_Mutation_Response>;
  /** insert a single row into the table: "film_group_films" */
  insert_film_group_films_one?: Maybe<Film_Group_Films>;
  /** insert data into the table: "film_group_users" */
  insert_film_group_users?: Maybe<Film_Group_Users_Mutation_Response>;
  /** insert a single row into the table: "film_group_users" */
  insert_film_group_users_one?: Maybe<Film_Group_Users>;
  /** insert data into the table: "film_groups" */
  insert_film_groups?: Maybe<Film_Groups_Mutation_Response>;
  /** insert a single row into the table: "film_groups" */
  insert_film_groups_one?: Maybe<Film_Groups>;
  /** insert data into the table: "films" */
  insert_films?: Maybe<Films_Mutation_Response>;
  /** insert a single row into the table: "films" */
  insert_films_one?: Maybe<Films>;
  /** insert data into the table: "genres" */
  insert_genres?: Maybe<Genres_Mutation_Response>;
  /** insert a single row into the table: "genres" */
  insert_genres_one?: Maybe<Genres>;
  /** insert data into the table: "kickoff_checkins" */
  insert_kickoff_checkins?: Maybe<Kickoff_Checkins_Mutation_Response>;
  /** insert a single row into the table: "kickoff_checkins" */
  insert_kickoff_checkins_one?: Maybe<Kickoff_Checkins>;
  /** insert data into the table: "location_releases" */
  insert_location_releases?: Maybe<Location_Releases_Mutation_Response>;
  /** insert a single row into the table: "location_releases" */
  insert_location_releases_one?: Maybe<Location_Releases>;
  /** insert data into the table: "matchup_requests" */
  insert_matchup_requests?: Maybe<Matchup_Requests_Mutation_Response>;
  /** insert a single row into the table: "matchup_requests" */
  insert_matchup_requests_one?: Maybe<Matchup_Requests>;
  /** insert data into the table: "music_releases" */
  insert_music_releases?: Maybe<Music_Releases_Mutation_Response>;
  /** insert a single row into the table: "music_releases" */
  insert_music_releases_one?: Maybe<Music_Releases>;
  /** insert data into the table: "nomination_assets" */
  insert_nomination_assets?: Maybe<Nomination_Assets_Mutation_Response>;
  /** insert a single row into the table: "nomination_assets" */
  insert_nomination_assets_one?: Maybe<Nomination_Assets>;
  /** insert data into the table: "nominations" */
  insert_nominations?: Maybe<Nominations_Mutation_Response>;
  /** insert a single row into the table: "nominations" */
  insert_nominations_one?: Maybe<Nominations>;
  /** insert data into the table: "online_screening_tickets" */
  insert_online_screening_tickets?: Maybe<Online_Screening_Tickets_Mutation_Response>;
  /** insert a single row into the table: "online_screening_tickets" */
  insert_online_screening_tickets_one?: Maybe<Online_Screening_Tickets>;
  /** insert data into the table: "payments" */
  insert_payments?: Maybe<Payments_Mutation_Response>;
  /** insert a single row into the table: "payments" */
  insert_payments_one?: Maybe<Payments>;
  /** insert data into the table: "playlist_team" */
  insert_playlist_team?: Maybe<Playlist_Team_Mutation_Response>;
  /** insert a single row into the table: "playlist_team" */
  insert_playlist_team_one?: Maybe<Playlist_Team>;
  /** insert data into the table: "playlists" */
  insert_playlists?: Maybe<Playlists_Mutation_Response>;
  /** insert a single row into the table: "playlists" */
  insert_playlists_one?: Maybe<Playlists>;
  /** insert data into the table: "prize_elections" */
  insert_prize_elections?: Maybe<Prize_Elections_Mutation_Response>;
  /** insert a single row into the table: "prize_elections" */
  insert_prize_elections_one?: Maybe<Prize_Elections>;
  /** insert data into the table: "prizes" */
  insert_prizes?: Maybe<Prizes_Mutation_Response>;
  /** insert a single row into the table: "prizes" */
  insert_prizes_one?: Maybe<Prizes>;
  /** insert data into the table: "registrations" */
  insert_registrations?: Maybe<Registrations_Mutation_Response>;
  /** insert a single row into the table: "registrations" */
  insert_registrations_one?: Maybe<Registrations>;
  /** insert data into the table: "selection_ballots" */
  insert_selection_ballots?: Maybe<Selection_Ballots_Mutation_Response>;
  /** insert a single row into the table: "selection_ballots" */
  insert_selection_ballots_one?: Maybe<Selection_Ballots>;
  /** insert data into the table: "selection_feedback" */
  insert_selection_feedback?: Maybe<Selection_Feedback_Mutation_Response>;
  /** insert a single row into the table: "selection_feedback" */
  insert_selection_feedback_one?: Maybe<Selection_Feedback>;
  /** insert data into the table: "selection_metrics" */
  insert_selection_metrics?: Maybe<Selection_Metrics_Mutation_Response>;
  /** insert a single row into the table: "selection_metrics" */
  insert_selection_metrics_one?: Maybe<Selection_Metrics>;
  /** insert data into the table: "selection_progress" */
  insert_selection_progress?: Maybe<Selection_Progress_Mutation_Response>;
  /** insert a single row into the table: "selection_progress" */
  insert_selection_progress_one?: Maybe<Selection_Progress>;
  /** insert data into the table: "sharables" */
  insert_sharables?: Maybe<Sharables_Mutation_Response>;
  /** insert a single row into the table: "sharables" */
  insert_sharables_one?: Maybe<Sharables>;
  /** insert data into the table: "sms_votes" */
  insert_sms_votes?: Maybe<Sms_Votes_Mutation_Response>;
  /** insert a single row into the table: "sms_votes" */
  insert_sms_votes_one?: Maybe<Sms_Votes>;
  /** insert data into the table: "sponsors" */
  insert_sponsors?: Maybe<Sponsors_Mutation_Response>;
  /** insert a single row into the table: "sponsors" */
  insert_sponsors_one?: Maybe<Sponsors>;
  /** insert data into the table: "studios" */
  insert_studios?: Maybe<Studios_Mutation_Response>;
  /** insert a single row into the table: "studios" */
  insert_studios_one?: Maybe<Studios>;
  /** insert data into the table: "team_assets" */
  insert_team_assets?: Maybe<Team_Assets_Mutation_Response>;
  /** insert a single row into the table: "team_assets" */
  insert_team_assets_one?: Maybe<Team_Assets>;
  /** insert data into the table: "team_memberships" */
  insert_team_memberships?: Maybe<Team_Memberships_Mutation_Response>;
  /** insert a single row into the table: "team_memberships" */
  insert_team_memberships_one?: Maybe<Team_Memberships>;
  /** insert data into the table: "team_roles" */
  insert_team_roles?: Maybe<Team_Roles_Mutation_Response>;
  /** insert a single row into the table: "team_roles" */
  insert_team_roles_one?: Maybe<Team_Roles>;
  /** insert data into the table: "teams" */
  insert_teams?: Maybe<Teams_Mutation_Response>;
  /** insert a single row into the table: "teams" */
  insert_teams_one?: Maybe<Teams>;
  /** insert data into the table: "teams_with_awards_ceremony_checkins" */
  insert_teams_with_awards_ceremony_checkins?: Maybe<Teams_With_Awards_Ceremony_Checkins_Mutation_Response>;
  /** insert a single row into the table: "teams_with_awards_ceremony_checkins" */
  insert_teams_with_awards_ceremony_checkins_one?: Maybe<Teams_With_Awards_Ceremony_Checkins>;
  /** insert data into the table: "teams_with_checkins" */
  insert_teams_with_checkins?: Maybe<Teams_With_Checkins_Mutation_Response>;
  /** insert a single row into the table: "teams_with_checkins" */
  insert_teams_with_checkins_one?: Maybe<Teams_With_Checkins>;
  /** insert data into the table: "ticket_tailor_vouchers" */
  insert_ticket_tailor_vouchers?: Maybe<Ticket_Tailor_Vouchers_Mutation_Response>;
  /** insert a single row into the table: "ticket_tailor_vouchers" */
  insert_ticket_tailor_vouchers_one?: Maybe<Ticket_Tailor_Vouchers>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  joinLiveKitExitInterview: Scalars['String'];
  muxCreateFiveFestUpload: Scalars['String'];
  muxCreateSpace?: Maybe<MuxSpaceCreated>;
  muxCreateUpload: Scalars['String'];
  muxJoinSpace: Scalars['String'];
  muxStreamSpace: Scalars['String'];
  obscureRegistrationLink: Scalars['String'];
  provideRegistrationSignature: Scalars['Boolean'];
  recordAwardsCeremonyCheckin: Scalars['Boolean'];
  sendGuestSignatureMail?: Maybe<Scalars['String']>;
  sendTeamInvitationMail?: Maybe<Scalars['String']>;
  stripeCreateCheckoutSession: Scalars['String'];
  stripeCreatePurchase: Scalars['String'];
  stripeTerminalCancel: Scalars['Boolean'];
  stripeTerminalCharge: Scalars['String'];
  submitFiveFest: Scalars['Boolean'];
  submitTeam: Scalars['Boolean'];
  /** update data of the table: "asset_exports" */
  update_asset_exports?: Maybe<Asset_Exports_Mutation_Response>;
  /** update single row of the table: "asset_exports" */
  update_asset_exports_by_pk?: Maybe<Asset_Exports>;
  /** update multiples rows of table: "asset_exports" */
  update_asset_exports_many?: Maybe<Array<Maybe<Asset_Exports_Mutation_Response>>>;
  /** update data of the table: "asset_types" */
  update_asset_types?: Maybe<Asset_Types_Mutation_Response>;
  /** update single row of the table: "asset_types" */
  update_asset_types_by_pk?: Maybe<Asset_Types>;
  /** update multiples rows of table: "asset_types" */
  update_asset_types_many?: Maybe<Array<Maybe<Asset_Types_Mutation_Response>>>;
  /** update data of the table: "audience_favorite_votes" */
  update_audience_favorite_votes?: Maybe<Audience_Favorite_Votes_Mutation_Response>;
  /** update single row of the table: "audience_favorite_votes" */
  update_audience_favorite_votes_by_pk?: Maybe<Audience_Favorite_Votes>;
  /** update multiples rows of table: "audience_favorite_votes" */
  update_audience_favorite_votes_many?: Maybe<Array<Maybe<Audience_Favorite_Votes_Mutation_Response>>>;
  /** update data of the table: "award_asset_types" */
  update_award_asset_types?: Maybe<Award_Asset_Types_Mutation_Response>;
  /** update single row of the table: "award_asset_types" */
  update_award_asset_types_by_pk?: Maybe<Award_Asset_Types>;
  /** update multiples rows of table: "award_asset_types" */
  update_award_asset_types_many?: Maybe<Array<Maybe<Award_Asset_Types_Mutation_Response>>>;
  /** update data of the table: "award_winners" */
  update_award_winners?: Maybe<Award_Winners_Mutation_Response>;
  /** update single row of the table: "award_winners" */
  update_award_winners_by_pk?: Maybe<Award_Winners>;
  /** update multiples rows of table: "award_winners" */
  update_award_winners_many?: Maybe<Array<Maybe<Award_Winners_Mutation_Response>>>;
  /** update data of the table: "awards" */
  update_awards?: Maybe<Awards_Mutation_Response>;
  /** update single row of the table: "awards" */
  update_awards_by_pk?: Maybe<Awards>;
  /** update data of the table: "awards_ceremony_checkins" */
  update_awards_ceremony_checkins?: Maybe<Awards_Ceremony_Checkins_Mutation_Response>;
  /** update single row of the table: "awards_ceremony_checkins" */
  update_awards_ceremony_checkins_by_pk?: Maybe<Awards_Ceremony_Checkins>;
  /** update multiples rows of table: "awards_ceremony_checkins" */
  update_awards_ceremony_checkins_many?: Maybe<Array<Maybe<Awards_Ceremony_Checkins_Mutation_Response>>>;
  /** update multiples rows of table: "awards" */
  update_awards_many?: Maybe<Array<Maybe<Awards_Mutation_Response>>>;
  /** update data of the table: "countries" */
  update_countries?: Maybe<Countries_Mutation_Response>;
  /** update single row of the table: "countries" */
  update_countries_by_pk?: Maybe<Countries>;
  /** update multiples rows of table: "countries" */
  update_countries_many?: Maybe<Array<Maybe<Countries_Mutation_Response>>>;
  /** update data of the table: "exit_interview_recordings" */
  update_exit_interview_recordings?: Maybe<Exit_Interview_Recordings_Mutation_Response>;
  /** update single row of the table: "exit_interview_recordings" */
  update_exit_interview_recordings_by_pk?: Maybe<Exit_Interview_Recordings>;
  /** update multiples rows of table: "exit_interview_recordings" */
  update_exit_interview_recordings_many?: Maybe<Array<Maybe<Exit_Interview_Recordings_Mutation_Response>>>;
  /** update data of the table: "exit_interviews" */
  update_exit_interviews?: Maybe<Exit_Interviews_Mutation_Response>;
  /** update single row of the table: "exit_interviews" */
  update_exit_interviews_by_pk?: Maybe<Exit_Interviews>;
  /** update multiples rows of table: "exit_interviews" */
  update_exit_interviews_many?: Maybe<Array<Maybe<Exit_Interviews_Mutation_Response>>>;
  /** update data of the table: "expertise" */
  update_expertise?: Maybe<Expertise_Mutation_Response>;
  /** update single row of the table: "expertise" */
  update_expertise_by_pk?: Maybe<Expertise>;
  /** update multiples rows of table: "expertise" */
  update_expertise_many?: Maybe<Array<Maybe<Expertise_Mutation_Response>>>;
  /** update data of the table: "festival_badge_type_event_type" */
  update_festival_badge_type_event_type?: Maybe<Festival_Badge_Type_Event_Type_Mutation_Response>;
  /** update single row of the table: "festival_badge_type_event_type" */
  update_festival_badge_type_event_type_by_pk?: Maybe<Festival_Badge_Type_Event_Type>;
  /** update multiples rows of table: "festival_badge_type_event_type" */
  update_festival_badge_type_event_type_many?: Maybe<Array<Maybe<Festival_Badge_Type_Event_Type_Mutation_Response>>>;
  /** update data of the table: "festival_badge_types" */
  update_festival_badge_types?: Maybe<Festival_Badge_Types_Mutation_Response>;
  /** update single row of the table: "festival_badge_types" */
  update_festival_badge_types_by_pk?: Maybe<Festival_Badge_Types>;
  /** update multiples rows of table: "festival_badge_types" */
  update_festival_badge_types_many?: Maybe<Array<Maybe<Festival_Badge_Types_Mutation_Response>>>;
  /** update data of the table: "festival_badges" */
  update_festival_badges?: Maybe<Festival_Badges_Mutation_Response>;
  /** update single row of the table: "festival_badges" */
  update_festival_badges_by_pk?: Maybe<Festival_Badges>;
  /** update multiples rows of table: "festival_badges" */
  update_festival_badges_many?: Maybe<Array<Maybe<Festival_Badges_Mutation_Response>>>;
  /** update data of the table: "festival_event_locations" */
  update_festival_event_locations?: Maybe<Festival_Event_Locations_Mutation_Response>;
  /** update single row of the table: "festival_event_locations" */
  update_festival_event_locations_by_pk?: Maybe<Festival_Event_Locations>;
  /** update multiples rows of table: "festival_event_locations" */
  update_festival_event_locations_many?: Maybe<Array<Maybe<Festival_Event_Locations_Mutation_Response>>>;
  /** update data of the table: "festival_event_types" */
  update_festival_event_types?: Maybe<Festival_Event_Types_Mutation_Response>;
  /** update single row of the table: "festival_event_types" */
  update_festival_event_types_by_pk?: Maybe<Festival_Event_Types>;
  /** update multiples rows of table: "festival_event_types" */
  update_festival_event_types_many?: Maybe<Array<Maybe<Festival_Event_Types_Mutation_Response>>>;
  /** update data of the table: "festival_events" */
  update_festival_events?: Maybe<Festival_Events_Mutation_Response>;
  /** update single row of the table: "festival_events" */
  update_festival_events_by_pk?: Maybe<Festival_Events>;
  /** update multiples rows of table: "festival_events" */
  update_festival_events_many?: Maybe<Array<Maybe<Festival_Events_Mutation_Response>>>;
  /** update data of the table: "festival_genres" */
  update_festival_genres?: Maybe<Festival_Genres_Mutation_Response>;
  /** update single row of the table: "festival_genres" */
  update_festival_genres_by_pk?: Maybe<Festival_Genres>;
  /** update multiples rows of table: "festival_genres" */
  update_festival_genres_many?: Maybe<Array<Maybe<Festival_Genres_Mutation_Response>>>;
  /** update data of the table: "festival_submission_assets" */
  update_festival_submission_assets?: Maybe<Festival_Submission_Assets_Mutation_Response>;
  /** update single row of the table: "festival_submission_assets" */
  update_festival_submission_assets_by_pk?: Maybe<Festival_Submission_Assets>;
  /** update multiples rows of table: "festival_submission_assets" */
  update_festival_submission_assets_many?: Maybe<Array<Maybe<Festival_Submission_Assets_Mutation_Response>>>;
  /** update data of the table: "festival_submission_feedback" */
  update_festival_submission_feedback?: Maybe<Festival_Submission_Feedback_Mutation_Response>;
  /** update single row of the table: "festival_submission_feedback" */
  update_festival_submission_feedback_by_pk?: Maybe<Festival_Submission_Feedback>;
  /** update multiples rows of table: "festival_submission_feedback" */
  update_festival_submission_feedback_many?: Maybe<Array<Maybe<Festival_Submission_Feedback_Mutation_Response>>>;
  /** update data of the table: "festival_submission_vouchers" */
  update_festival_submission_vouchers?: Maybe<Festival_Submission_Vouchers_Mutation_Response>;
  /** update single row of the table: "festival_submission_vouchers" */
  update_festival_submission_vouchers_by_pk?: Maybe<Festival_Submission_Vouchers>;
  /** update multiples rows of table: "festival_submission_vouchers" */
  update_festival_submission_vouchers_many?: Maybe<Array<Maybe<Festival_Submission_Vouchers_Mutation_Response>>>;
  /** update data of the table: "festival_submissions" */
  update_festival_submissions?: Maybe<Festival_Submissions_Mutation_Response>;
  /** update single row of the table: "festival_submissions" */
  update_festival_submissions_by_pk?: Maybe<Festival_Submissions>;
  /** update multiples rows of table: "festival_submissions" */
  update_festival_submissions_many?: Maybe<Array<Maybe<Festival_Submissions_Mutation_Response>>>;
  /** update data of the table: "festival_tickets" */
  update_festival_tickets?: Maybe<Festival_Tickets_Mutation_Response>;
  /** update single row of the table: "festival_tickets" */
  update_festival_tickets_by_pk?: Maybe<Festival_Tickets>;
  /** update multiples rows of table: "festival_tickets" */
  update_festival_tickets_many?: Maybe<Array<Maybe<Festival_Tickets_Mutation_Response>>>;
  /** update data of the table: "film_festivals" */
  update_film_festivals?: Maybe<Film_Festivals_Mutation_Response>;
  /** update single row of the table: "film_festivals" */
  update_film_festivals_by_pk?: Maybe<Film_Festivals>;
  /** update multiples rows of table: "film_festivals" */
  update_film_festivals_many?: Maybe<Array<Maybe<Film_Festivals_Mutation_Response>>>;
  /** update data of the table: "film_group_festival_submissions" */
  update_film_group_festival_submissions?: Maybe<Film_Group_Festival_Submissions_Mutation_Response>;
  /** update single row of the table: "film_group_festival_submissions" */
  update_film_group_festival_submissions_by_pk?: Maybe<Film_Group_Festival_Submissions>;
  /** update multiples rows of table: "film_group_festival_submissions" */
  update_film_group_festival_submissions_many?: Maybe<Array<Maybe<Film_Group_Festival_Submissions_Mutation_Response>>>;
  /** update data of the table: "film_group_films" */
  update_film_group_films?: Maybe<Film_Group_Films_Mutation_Response>;
  /** update single row of the table: "film_group_films" */
  update_film_group_films_by_pk?: Maybe<Film_Group_Films>;
  /** update multiples rows of table: "film_group_films" */
  update_film_group_films_many?: Maybe<Array<Maybe<Film_Group_Films_Mutation_Response>>>;
  /** update data of the table: "film_group_users" */
  update_film_group_users?: Maybe<Film_Group_Users_Mutation_Response>;
  /** update single row of the table: "film_group_users" */
  update_film_group_users_by_pk?: Maybe<Film_Group_Users>;
  /** update multiples rows of table: "film_group_users" */
  update_film_group_users_many?: Maybe<Array<Maybe<Film_Group_Users_Mutation_Response>>>;
  /** update data of the table: "film_groups" */
  update_film_groups?: Maybe<Film_Groups_Mutation_Response>;
  /** update single row of the table: "film_groups" */
  update_film_groups_by_pk?: Maybe<Film_Groups>;
  /** update multiples rows of table: "film_groups" */
  update_film_groups_many?: Maybe<Array<Maybe<Film_Groups_Mutation_Response>>>;
  /** update data of the table: "films" */
  update_films?: Maybe<Films_Mutation_Response>;
  /** update single row of the table: "films" */
  update_films_by_pk?: Maybe<Films>;
  /** update multiples rows of table: "films" */
  update_films_many?: Maybe<Array<Maybe<Films_Mutation_Response>>>;
  /** update data of the table: "genres" */
  update_genres?: Maybe<Genres_Mutation_Response>;
  /** update single row of the table: "genres" */
  update_genres_by_pk?: Maybe<Genres>;
  /** update multiples rows of table: "genres" */
  update_genres_many?: Maybe<Array<Maybe<Genres_Mutation_Response>>>;
  /** update data of the table: "kickoff_checkins" */
  update_kickoff_checkins?: Maybe<Kickoff_Checkins_Mutation_Response>;
  /** update single row of the table: "kickoff_checkins" */
  update_kickoff_checkins_by_pk?: Maybe<Kickoff_Checkins>;
  /** update multiples rows of table: "kickoff_checkins" */
  update_kickoff_checkins_many?: Maybe<Array<Maybe<Kickoff_Checkins_Mutation_Response>>>;
  /** update data of the table: "location_releases" */
  update_location_releases?: Maybe<Location_Releases_Mutation_Response>;
  /** update single row of the table: "location_releases" */
  update_location_releases_by_pk?: Maybe<Location_Releases>;
  /** update multiples rows of table: "location_releases" */
  update_location_releases_many?: Maybe<Array<Maybe<Location_Releases_Mutation_Response>>>;
  /** update data of the table: "matchup_requests" */
  update_matchup_requests?: Maybe<Matchup_Requests_Mutation_Response>;
  /** update single row of the table: "matchup_requests" */
  update_matchup_requests_by_pk?: Maybe<Matchup_Requests>;
  /** update multiples rows of table: "matchup_requests" */
  update_matchup_requests_many?: Maybe<Array<Maybe<Matchup_Requests_Mutation_Response>>>;
  /** update data of the table: "music_releases" */
  update_music_releases?: Maybe<Music_Releases_Mutation_Response>;
  /** update single row of the table: "music_releases" */
  update_music_releases_by_pk?: Maybe<Music_Releases>;
  /** update multiples rows of table: "music_releases" */
  update_music_releases_many?: Maybe<Array<Maybe<Music_Releases_Mutation_Response>>>;
  /** update data of the table: "nomination_assets" */
  update_nomination_assets?: Maybe<Nomination_Assets_Mutation_Response>;
  /** update single row of the table: "nomination_assets" */
  update_nomination_assets_by_pk?: Maybe<Nomination_Assets>;
  /** update multiples rows of table: "nomination_assets" */
  update_nomination_assets_many?: Maybe<Array<Maybe<Nomination_Assets_Mutation_Response>>>;
  /** update data of the table: "nominations" */
  update_nominations?: Maybe<Nominations_Mutation_Response>;
  /** update single row of the table: "nominations" */
  update_nominations_by_pk?: Maybe<Nominations>;
  /** update multiples rows of table: "nominations" */
  update_nominations_many?: Maybe<Array<Maybe<Nominations_Mutation_Response>>>;
  /** update data of the table: "online_screening_tickets" */
  update_online_screening_tickets?: Maybe<Online_Screening_Tickets_Mutation_Response>;
  /** update single row of the table: "online_screening_tickets" */
  update_online_screening_tickets_by_pk?: Maybe<Online_Screening_Tickets>;
  /** update multiples rows of table: "online_screening_tickets" */
  update_online_screening_tickets_many?: Maybe<Array<Maybe<Online_Screening_Tickets_Mutation_Response>>>;
  /** update data of the table: "payments" */
  update_payments?: Maybe<Payments_Mutation_Response>;
  /** update single row of the table: "payments" */
  update_payments_by_pk?: Maybe<Payments>;
  /** update multiples rows of table: "payments" */
  update_payments_many?: Maybe<Array<Maybe<Payments_Mutation_Response>>>;
  /** update data of the table: "playlist_team" */
  update_playlist_team?: Maybe<Playlist_Team_Mutation_Response>;
  /** update single row of the table: "playlist_team" */
  update_playlist_team_by_pk?: Maybe<Playlist_Team>;
  /** update multiples rows of table: "playlist_team" */
  update_playlist_team_many?: Maybe<Array<Maybe<Playlist_Team_Mutation_Response>>>;
  /** update data of the table: "playlists" */
  update_playlists?: Maybe<Playlists_Mutation_Response>;
  /** update single row of the table: "playlists" */
  update_playlists_by_pk?: Maybe<Playlists>;
  /** update multiples rows of table: "playlists" */
  update_playlists_many?: Maybe<Array<Maybe<Playlists_Mutation_Response>>>;
  /** update data of the table: "prize_elections" */
  update_prize_elections?: Maybe<Prize_Elections_Mutation_Response>;
  /** update multiples rows of table: "prize_elections" */
  update_prize_elections_many?: Maybe<Array<Maybe<Prize_Elections_Mutation_Response>>>;
  /** update data of the table: "prizes" */
  update_prizes?: Maybe<Prizes_Mutation_Response>;
  /** update single row of the table: "prizes" */
  update_prizes_by_pk?: Maybe<Prizes>;
  /** update multiples rows of table: "prizes" */
  update_prizes_many?: Maybe<Array<Maybe<Prizes_Mutation_Response>>>;
  /** update data of the table: "registrations" */
  update_registrations?: Maybe<Registrations_Mutation_Response>;
  /** update single row of the table: "registrations" */
  update_registrations_by_pk?: Maybe<Registrations>;
  /** update multiples rows of table: "registrations" */
  update_registrations_many?: Maybe<Array<Maybe<Registrations_Mutation_Response>>>;
  /** update data of the table: "selection_ballots" */
  update_selection_ballots?: Maybe<Selection_Ballots_Mutation_Response>;
  /** update single row of the table: "selection_ballots" */
  update_selection_ballots_by_pk?: Maybe<Selection_Ballots>;
  /** update multiples rows of table: "selection_ballots" */
  update_selection_ballots_many?: Maybe<Array<Maybe<Selection_Ballots_Mutation_Response>>>;
  /** update data of the table: "selection_feedback" */
  update_selection_feedback?: Maybe<Selection_Feedback_Mutation_Response>;
  /** update single row of the table: "selection_feedback" */
  update_selection_feedback_by_pk?: Maybe<Selection_Feedback>;
  /** update multiples rows of table: "selection_feedback" */
  update_selection_feedback_many?: Maybe<Array<Maybe<Selection_Feedback_Mutation_Response>>>;
  /** update data of the table: "selection_metrics" */
  update_selection_metrics?: Maybe<Selection_Metrics_Mutation_Response>;
  /** update single row of the table: "selection_metrics" */
  update_selection_metrics_by_pk?: Maybe<Selection_Metrics>;
  /** update multiples rows of table: "selection_metrics" */
  update_selection_metrics_many?: Maybe<Array<Maybe<Selection_Metrics_Mutation_Response>>>;
  /** update data of the table: "selection_progress" */
  update_selection_progress?: Maybe<Selection_Progress_Mutation_Response>;
  /** update single row of the table: "selection_progress" */
  update_selection_progress_by_pk?: Maybe<Selection_Progress>;
  /** update multiples rows of table: "selection_progress" */
  update_selection_progress_many?: Maybe<Array<Maybe<Selection_Progress_Mutation_Response>>>;
  /** update data of the table: "sharables" */
  update_sharables?: Maybe<Sharables_Mutation_Response>;
  /** update single row of the table: "sharables" */
  update_sharables_by_pk?: Maybe<Sharables>;
  /** update multiples rows of table: "sharables" */
  update_sharables_many?: Maybe<Array<Maybe<Sharables_Mutation_Response>>>;
  /** update data of the table: "sms_votes" */
  update_sms_votes?: Maybe<Sms_Votes_Mutation_Response>;
  /** update single row of the table: "sms_votes" */
  update_sms_votes_by_pk?: Maybe<Sms_Votes>;
  /** update multiples rows of table: "sms_votes" */
  update_sms_votes_many?: Maybe<Array<Maybe<Sms_Votes_Mutation_Response>>>;
  /** update data of the table: "sponsors" */
  update_sponsors?: Maybe<Sponsors_Mutation_Response>;
  /** update single row of the table: "sponsors" */
  update_sponsors_by_pk?: Maybe<Sponsors>;
  /** update multiples rows of table: "sponsors" */
  update_sponsors_many?: Maybe<Array<Maybe<Sponsors_Mutation_Response>>>;
  /** update data of the table: "studios" */
  update_studios?: Maybe<Studios_Mutation_Response>;
  /** update single row of the table: "studios" */
  update_studios_by_pk?: Maybe<Studios>;
  /** update multiples rows of table: "studios" */
  update_studios_many?: Maybe<Array<Maybe<Studios_Mutation_Response>>>;
  /** update data of the table: "team_assets" */
  update_team_assets?: Maybe<Team_Assets_Mutation_Response>;
  /** update single row of the table: "team_assets" */
  update_team_assets_by_pk?: Maybe<Team_Assets>;
  /** update multiples rows of table: "team_assets" */
  update_team_assets_many?: Maybe<Array<Maybe<Team_Assets_Mutation_Response>>>;
  /** update data of the table: "team_memberships" */
  update_team_memberships?: Maybe<Team_Memberships_Mutation_Response>;
  /** update single row of the table: "team_memberships" */
  update_team_memberships_by_pk?: Maybe<Team_Memberships>;
  /** update multiples rows of table: "team_memberships" */
  update_team_memberships_many?: Maybe<Array<Maybe<Team_Memberships_Mutation_Response>>>;
  /** update data of the table: "team_roles" */
  update_team_roles?: Maybe<Team_Roles_Mutation_Response>;
  /** update single row of the table: "team_roles" */
  update_team_roles_by_pk?: Maybe<Team_Roles>;
  /** update multiples rows of table: "team_roles" */
  update_team_roles_many?: Maybe<Array<Maybe<Team_Roles_Mutation_Response>>>;
  /** update data of the table: "teams" */
  update_teams?: Maybe<Teams_Mutation_Response>;
  /** update single row of the table: "teams" */
  update_teams_by_pk?: Maybe<Teams>;
  /** update multiples rows of table: "teams" */
  update_teams_many?: Maybe<Array<Maybe<Teams_Mutation_Response>>>;
  /** update data of the table: "teams_with_awards_ceremony_checkins" */
  update_teams_with_awards_ceremony_checkins?: Maybe<Teams_With_Awards_Ceremony_Checkins_Mutation_Response>;
  /** update multiples rows of table: "teams_with_awards_ceremony_checkins" */
  update_teams_with_awards_ceremony_checkins_many?: Maybe<Array<Maybe<Teams_With_Awards_Ceremony_Checkins_Mutation_Response>>>;
  /** update data of the table: "teams_with_checkins" */
  update_teams_with_checkins?: Maybe<Teams_With_Checkins_Mutation_Response>;
  /** update multiples rows of table: "teams_with_checkins" */
  update_teams_with_checkins_many?: Maybe<Array<Maybe<Teams_With_Checkins_Mutation_Response>>>;
  /** update data of the table: "ticket_tailor_vouchers" */
  update_ticket_tailor_vouchers?: Maybe<Ticket_Tailor_Vouchers_Mutation_Response>;
  /** update single row of the table: "ticket_tailor_vouchers" */
  update_ticket_tailor_vouchers_by_pk?: Maybe<Ticket_Tailor_Vouchers>;
  /** update multiples rows of table: "ticket_tailor_vouchers" */
  update_ticket_tailor_vouchers_many?: Maybe<Array<Maybe<Ticket_Tailor_Vouchers_Mutation_Response>>>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootAssetSignArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootAssetUploadArgs = {
  filename: Scalars['String'];
};


/** mutation root */
export type Mutation_RootClaimFestivalSubmissionVoucherArgs = {
  festivalSubmissionId: Scalars['Int'];
  voucherId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootCrispRequestSignatureArgs = {
  teamMembershipId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootCrispTriggerInviteArgs = {
  teamMembershipId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Asset_ExportsArgs = {
  where: Asset_Exports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Asset_Exports_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Asset_TypesArgs = {
  where: Asset_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Asset_Types_By_PkArgs = {
  id: Scalars['numeric'];
};


/** mutation root */
export type Mutation_RootDelete_Audience_Favorite_VotesArgs = {
  where: Audience_Favorite_Votes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Audience_Favorite_Votes_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Award_Asset_TypesArgs = {
  where: Award_Asset_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Award_Asset_Types_By_PkArgs = {
  id: Scalars['numeric'];
};


/** mutation root */
export type Mutation_RootDelete_Award_WinnersArgs = {
  where: Award_Winners_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Award_Winners_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_AwardsArgs = {
  where: Awards_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Awards_By_PkArgs = {
  id: Scalars['numeric'];
};


/** mutation root */
export type Mutation_RootDelete_Awards_Ceremony_CheckinsArgs = {
  where: Awards_Ceremony_Checkins_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Awards_Ceremony_Checkins_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_CountriesArgs = {
  where: Countries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Countries_By_PkArgs = {
  id: Scalars['numeric'];
};


/** mutation root */
export type Mutation_RootDelete_Exit_Interview_RecordingsArgs = {
  where: Exit_Interview_Recordings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Exit_Interview_Recordings_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Exit_InterviewsArgs = {
  where: Exit_Interviews_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Exit_Interviews_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ExpertiseArgs = {
  where: Expertise_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Expertise_By_PkArgs = {
  id: Scalars['numeric'];
};


/** mutation root */
export type Mutation_RootDelete_Festival_Badge_Type_Event_TypeArgs = {
  where: Festival_Badge_Type_Event_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Festival_Badge_Type_Event_Type_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Festival_Badge_TypesArgs = {
  where: Festival_Badge_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Festival_Badge_Types_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Festival_BadgesArgs = {
  where: Festival_Badges_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Festival_Badges_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Festival_Event_LocationsArgs = {
  where: Festival_Event_Locations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Festival_Event_Locations_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Festival_Event_TypesArgs = {
  where: Festival_Event_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Festival_Event_Types_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Festival_EventsArgs = {
  where: Festival_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Festival_Events_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Festival_GenresArgs = {
  where: Festival_Genres_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Festival_Genres_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Festival_Submission_AssetsArgs = {
  where: Festival_Submission_Assets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Festival_Submission_Assets_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Festival_Submission_FeedbackArgs = {
  where: Festival_Submission_Feedback_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Festival_Submission_Feedback_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Festival_Submission_VouchersArgs = {
  where: Festival_Submission_Vouchers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Festival_Submission_Vouchers_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Festival_SubmissionsArgs = {
  where: Festival_Submissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Festival_Submissions_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Festival_TicketsArgs = {
  where: Festival_Tickets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Festival_Tickets_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Film_FestivalsArgs = {
  where: Film_Festivals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Film_Festivals_By_PkArgs = {
  id: Scalars['numeric'];
};


/** mutation root */
export type Mutation_RootDelete_Film_Group_Festival_SubmissionsArgs = {
  where: Film_Group_Festival_Submissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Film_Group_Festival_Submissions_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Film_Group_FilmsArgs = {
  where: Film_Group_Films_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Film_Group_Films_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Film_Group_UsersArgs = {
  where: Film_Group_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Film_Group_Users_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Film_GroupsArgs = {
  where: Film_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Film_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_FilmsArgs = {
  where: Films_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Films_By_PkArgs = {
  id: Scalars['numeric'];
};


/** mutation root */
export type Mutation_RootDelete_GenresArgs = {
  where: Genres_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Genres_By_PkArgs = {
  id: Scalars['numeric'];
};


/** mutation root */
export type Mutation_RootDelete_Kickoff_CheckinsArgs = {
  where: Kickoff_Checkins_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Kickoff_Checkins_By_PkArgs = {
  id: Scalars['numeric'];
};


/** mutation root */
export type Mutation_RootDelete_Location_ReleasesArgs = {
  where: Location_Releases_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Location_Releases_By_PkArgs = {
  id: Scalars['numeric'];
};


/** mutation root */
export type Mutation_RootDelete_Matchup_RequestsArgs = {
  where: Matchup_Requests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Matchup_Requests_By_PkArgs = {
  id: Scalars['numeric'];
};


/** mutation root */
export type Mutation_RootDelete_Music_ReleasesArgs = {
  where: Music_Releases_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Music_Releases_By_PkArgs = {
  id: Scalars['numeric'];
};


/** mutation root */
export type Mutation_RootDelete_Nomination_AssetsArgs = {
  where: Nomination_Assets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Nomination_Assets_By_PkArgs = {
  id: Scalars['numeric'];
};


/** mutation root */
export type Mutation_RootDelete_NominationsArgs = {
  where: Nominations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Nominations_By_PkArgs = {
  id: Scalars['numeric'];
};


/** mutation root */
export type Mutation_RootDelete_Online_Screening_TicketsArgs = {
  where: Online_Screening_Tickets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Online_Screening_Tickets_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_PaymentsArgs = {
  where: Payments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Payments_By_PkArgs = {
  id: Scalars['numeric'];
};


/** mutation root */
export type Mutation_RootDelete_Playlist_TeamArgs = {
  where: Playlist_Team_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Playlist_Team_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_PlaylistsArgs = {
  where: Playlists_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Playlists_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Prize_ElectionsArgs = {
  where: Prize_Elections_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PrizesArgs = {
  where: Prizes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Prizes_By_PkArgs = {
  id: Scalars['numeric'];
};


/** mutation root */
export type Mutation_RootDelete_RegistrationsArgs = {
  where: Registrations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Registrations_By_PkArgs = {
  id: Scalars['numeric'];
};


/** mutation root */
export type Mutation_RootDelete_Selection_BallotsArgs = {
  where: Selection_Ballots_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Selection_Ballots_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Selection_FeedbackArgs = {
  where: Selection_Feedback_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Selection_Feedback_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Selection_MetricsArgs = {
  where: Selection_Metrics_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Selection_Metrics_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Selection_ProgressArgs = {
  where: Selection_Progress_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Selection_Progress_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_SharablesArgs = {
  where: Sharables_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sharables_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Sms_VotesArgs = {
  where: Sms_Votes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sms_Votes_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_SponsorsArgs = {
  where: Sponsors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sponsors_By_PkArgs = {
  id: Scalars['numeric'];
};


/** mutation root */
export type Mutation_RootDelete_StudiosArgs = {
  where: Studios_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Studios_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Team_AssetsArgs = {
  where: Team_Assets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Team_Assets_By_PkArgs = {
  id: Scalars['numeric'];
};


/** mutation root */
export type Mutation_RootDelete_Team_MembershipsArgs = {
  where: Team_Memberships_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Team_Memberships_By_PkArgs = {
  id: Scalars['numeric'];
};


/** mutation root */
export type Mutation_RootDelete_Team_RolesArgs = {
  where: Team_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Team_Roles_By_PkArgs = {
  id: Scalars['numeric'];
};


/** mutation root */
export type Mutation_RootDelete_TeamsArgs = {
  where: Teams_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Teams_By_PkArgs = {
  id: Scalars['numeric'];
};


/** mutation root */
export type Mutation_RootDelete_Teams_With_Awards_Ceremony_CheckinsArgs = {
  where: Teams_With_Awards_Ceremony_Checkins_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Teams_With_CheckinsArgs = {
  where: Teams_With_Checkins_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ticket_Tailor_VouchersArgs = {
  where: Ticket_Tailor_Vouchers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ticket_Tailor_Vouchers_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  id: Scalars['numeric'];
};


/** mutation root */
export type Mutation_RootInsert_Asset_ExportsArgs = {
  objects: Array<Asset_Exports_Insert_Input>;
  on_conflict?: InputMaybe<Asset_Exports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_Exports_OneArgs = {
  object: Asset_Exports_Insert_Input;
  on_conflict?: InputMaybe<Asset_Exports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_TypesArgs = {
  objects: Array<Asset_Types_Insert_Input>;
  on_conflict?: InputMaybe<Asset_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Asset_Types_OneArgs = {
  object: Asset_Types_Insert_Input;
  on_conflict?: InputMaybe<Asset_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Audience_Favorite_VotesArgs = {
  objects: Array<Audience_Favorite_Votes_Insert_Input>;
  on_conflict?: InputMaybe<Audience_Favorite_Votes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Audience_Favorite_Votes_OneArgs = {
  object: Audience_Favorite_Votes_Insert_Input;
  on_conflict?: InputMaybe<Audience_Favorite_Votes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Award_Asset_TypesArgs = {
  objects: Array<Award_Asset_Types_Insert_Input>;
  on_conflict?: InputMaybe<Award_Asset_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Award_Asset_Types_OneArgs = {
  object: Award_Asset_Types_Insert_Input;
  on_conflict?: InputMaybe<Award_Asset_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Award_WinnersArgs = {
  objects: Array<Award_Winners_Insert_Input>;
  on_conflict?: InputMaybe<Award_Winners_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Award_Winners_OneArgs = {
  object: Award_Winners_Insert_Input;
  on_conflict?: InputMaybe<Award_Winners_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AwardsArgs = {
  objects: Array<Awards_Insert_Input>;
  on_conflict?: InputMaybe<Awards_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Awards_Ceremony_CheckinsArgs = {
  objects: Array<Awards_Ceremony_Checkins_Insert_Input>;
  on_conflict?: InputMaybe<Awards_Ceremony_Checkins_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Awards_Ceremony_Checkins_OneArgs = {
  object: Awards_Ceremony_Checkins_Insert_Input;
  on_conflict?: InputMaybe<Awards_Ceremony_Checkins_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Awards_OneArgs = {
  object: Awards_Insert_Input;
  on_conflict?: InputMaybe<Awards_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CountriesArgs = {
  objects: Array<Countries_Insert_Input>;
  on_conflict?: InputMaybe<Countries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Countries_OneArgs = {
  object: Countries_Insert_Input;
  on_conflict?: InputMaybe<Countries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Exit_Interview_RecordingsArgs = {
  objects: Array<Exit_Interview_Recordings_Insert_Input>;
  on_conflict?: InputMaybe<Exit_Interview_Recordings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Exit_Interview_Recordings_OneArgs = {
  object: Exit_Interview_Recordings_Insert_Input;
  on_conflict?: InputMaybe<Exit_Interview_Recordings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Exit_InterviewsArgs = {
  objects: Array<Exit_Interviews_Insert_Input>;
  on_conflict?: InputMaybe<Exit_Interviews_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Exit_Interviews_OneArgs = {
  object: Exit_Interviews_Insert_Input;
  on_conflict?: InputMaybe<Exit_Interviews_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ExpertiseArgs = {
  objects: Array<Expertise_Insert_Input>;
  on_conflict?: InputMaybe<Expertise_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Expertise_OneArgs = {
  object: Expertise_Insert_Input;
  on_conflict?: InputMaybe<Expertise_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Festival_Badge_Type_Event_TypeArgs = {
  objects: Array<Festival_Badge_Type_Event_Type_Insert_Input>;
  on_conflict?: InputMaybe<Festival_Badge_Type_Event_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Festival_Badge_Type_Event_Type_OneArgs = {
  object: Festival_Badge_Type_Event_Type_Insert_Input;
  on_conflict?: InputMaybe<Festival_Badge_Type_Event_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Festival_Badge_TypesArgs = {
  objects: Array<Festival_Badge_Types_Insert_Input>;
  on_conflict?: InputMaybe<Festival_Badge_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Festival_Badge_Types_OneArgs = {
  object: Festival_Badge_Types_Insert_Input;
  on_conflict?: InputMaybe<Festival_Badge_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Festival_BadgesArgs = {
  objects: Array<Festival_Badges_Insert_Input>;
  on_conflict?: InputMaybe<Festival_Badges_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Festival_Badges_OneArgs = {
  object: Festival_Badges_Insert_Input;
  on_conflict?: InputMaybe<Festival_Badges_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Festival_Event_LocationsArgs = {
  objects: Array<Festival_Event_Locations_Insert_Input>;
  on_conflict?: InputMaybe<Festival_Event_Locations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Festival_Event_Locations_OneArgs = {
  object: Festival_Event_Locations_Insert_Input;
  on_conflict?: InputMaybe<Festival_Event_Locations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Festival_Event_TypesArgs = {
  objects: Array<Festival_Event_Types_Insert_Input>;
  on_conflict?: InputMaybe<Festival_Event_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Festival_Event_Types_OneArgs = {
  object: Festival_Event_Types_Insert_Input;
  on_conflict?: InputMaybe<Festival_Event_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Festival_EventsArgs = {
  objects: Array<Festival_Events_Insert_Input>;
  on_conflict?: InputMaybe<Festival_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Festival_Events_OneArgs = {
  object: Festival_Events_Insert_Input;
  on_conflict?: InputMaybe<Festival_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Festival_GenresArgs = {
  objects: Array<Festival_Genres_Insert_Input>;
  on_conflict?: InputMaybe<Festival_Genres_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Festival_Genres_OneArgs = {
  object: Festival_Genres_Insert_Input;
  on_conflict?: InputMaybe<Festival_Genres_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Festival_Submission_AssetsArgs = {
  objects: Array<Festival_Submission_Assets_Insert_Input>;
  on_conflict?: InputMaybe<Festival_Submission_Assets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Festival_Submission_Assets_OneArgs = {
  object: Festival_Submission_Assets_Insert_Input;
  on_conflict?: InputMaybe<Festival_Submission_Assets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Festival_Submission_FeedbackArgs = {
  objects: Array<Festival_Submission_Feedback_Insert_Input>;
  on_conflict?: InputMaybe<Festival_Submission_Feedback_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Festival_Submission_Feedback_OneArgs = {
  object: Festival_Submission_Feedback_Insert_Input;
  on_conflict?: InputMaybe<Festival_Submission_Feedback_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Festival_Submission_VouchersArgs = {
  objects: Array<Festival_Submission_Vouchers_Insert_Input>;
  on_conflict?: InputMaybe<Festival_Submission_Vouchers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Festival_Submission_Vouchers_OneArgs = {
  object: Festival_Submission_Vouchers_Insert_Input;
  on_conflict?: InputMaybe<Festival_Submission_Vouchers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Festival_SubmissionsArgs = {
  objects: Array<Festival_Submissions_Insert_Input>;
  on_conflict?: InputMaybe<Festival_Submissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Festival_Submissions_OneArgs = {
  object: Festival_Submissions_Insert_Input;
  on_conflict?: InputMaybe<Festival_Submissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Festival_TicketsArgs = {
  objects: Array<Festival_Tickets_Insert_Input>;
  on_conflict?: InputMaybe<Festival_Tickets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Festival_Tickets_OneArgs = {
  object: Festival_Tickets_Insert_Input;
  on_conflict?: InputMaybe<Festival_Tickets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Film_FestivalsArgs = {
  objects: Array<Film_Festivals_Insert_Input>;
  on_conflict?: InputMaybe<Film_Festivals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Film_Festivals_OneArgs = {
  object: Film_Festivals_Insert_Input;
  on_conflict?: InputMaybe<Film_Festivals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Film_Group_Festival_SubmissionsArgs = {
  objects: Array<Film_Group_Festival_Submissions_Insert_Input>;
  on_conflict?: InputMaybe<Film_Group_Festival_Submissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Film_Group_Festival_Submissions_OneArgs = {
  object: Film_Group_Festival_Submissions_Insert_Input;
  on_conflict?: InputMaybe<Film_Group_Festival_Submissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Film_Group_FilmsArgs = {
  objects: Array<Film_Group_Films_Insert_Input>;
  on_conflict?: InputMaybe<Film_Group_Films_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Film_Group_Films_OneArgs = {
  object: Film_Group_Films_Insert_Input;
  on_conflict?: InputMaybe<Film_Group_Films_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Film_Group_UsersArgs = {
  objects: Array<Film_Group_Users_Insert_Input>;
  on_conflict?: InputMaybe<Film_Group_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Film_Group_Users_OneArgs = {
  object: Film_Group_Users_Insert_Input;
  on_conflict?: InputMaybe<Film_Group_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Film_GroupsArgs = {
  objects: Array<Film_Groups_Insert_Input>;
  on_conflict?: InputMaybe<Film_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Film_Groups_OneArgs = {
  object: Film_Groups_Insert_Input;
  on_conflict?: InputMaybe<Film_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FilmsArgs = {
  objects: Array<Films_Insert_Input>;
  on_conflict?: InputMaybe<Films_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Films_OneArgs = {
  object: Films_Insert_Input;
  on_conflict?: InputMaybe<Films_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GenresArgs = {
  objects: Array<Genres_Insert_Input>;
  on_conflict?: InputMaybe<Genres_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Genres_OneArgs = {
  object: Genres_Insert_Input;
  on_conflict?: InputMaybe<Genres_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Kickoff_CheckinsArgs = {
  objects: Array<Kickoff_Checkins_Insert_Input>;
  on_conflict?: InputMaybe<Kickoff_Checkins_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Kickoff_Checkins_OneArgs = {
  object: Kickoff_Checkins_Insert_Input;
  on_conflict?: InputMaybe<Kickoff_Checkins_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Location_ReleasesArgs = {
  objects: Array<Location_Releases_Insert_Input>;
  on_conflict?: InputMaybe<Location_Releases_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Location_Releases_OneArgs = {
  object: Location_Releases_Insert_Input;
  on_conflict?: InputMaybe<Location_Releases_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Matchup_RequestsArgs = {
  objects: Array<Matchup_Requests_Insert_Input>;
  on_conflict?: InputMaybe<Matchup_Requests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Matchup_Requests_OneArgs = {
  object: Matchup_Requests_Insert_Input;
  on_conflict?: InputMaybe<Matchup_Requests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Music_ReleasesArgs = {
  objects: Array<Music_Releases_Insert_Input>;
  on_conflict?: InputMaybe<Music_Releases_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Music_Releases_OneArgs = {
  object: Music_Releases_Insert_Input;
  on_conflict?: InputMaybe<Music_Releases_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nomination_AssetsArgs = {
  objects: Array<Nomination_Assets_Insert_Input>;
  on_conflict?: InputMaybe<Nomination_Assets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nomination_Assets_OneArgs = {
  object: Nomination_Assets_Insert_Input;
  on_conflict?: InputMaybe<Nomination_Assets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_NominationsArgs = {
  objects: Array<Nominations_Insert_Input>;
  on_conflict?: InputMaybe<Nominations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nominations_OneArgs = {
  object: Nominations_Insert_Input;
  on_conflict?: InputMaybe<Nominations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Online_Screening_TicketsArgs = {
  objects: Array<Online_Screening_Tickets_Insert_Input>;
  on_conflict?: InputMaybe<Online_Screening_Tickets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Online_Screening_Tickets_OneArgs = {
  object: Online_Screening_Tickets_Insert_Input;
  on_conflict?: InputMaybe<Online_Screening_Tickets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PaymentsArgs = {
  objects: Array<Payments_Insert_Input>;
  on_conflict?: InputMaybe<Payments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payments_OneArgs = {
  object: Payments_Insert_Input;
  on_conflict?: InputMaybe<Payments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Playlist_TeamArgs = {
  objects: Array<Playlist_Team_Insert_Input>;
  on_conflict?: InputMaybe<Playlist_Team_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Playlist_Team_OneArgs = {
  object: Playlist_Team_Insert_Input;
  on_conflict?: InputMaybe<Playlist_Team_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PlaylistsArgs = {
  objects: Array<Playlists_Insert_Input>;
  on_conflict?: InputMaybe<Playlists_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Playlists_OneArgs = {
  object: Playlists_Insert_Input;
  on_conflict?: InputMaybe<Playlists_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Prize_ElectionsArgs = {
  objects: Array<Prize_Elections_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Prize_Elections_OneArgs = {
  object: Prize_Elections_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_PrizesArgs = {
  objects: Array<Prizes_Insert_Input>;
  on_conflict?: InputMaybe<Prizes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Prizes_OneArgs = {
  object: Prizes_Insert_Input;
  on_conflict?: InputMaybe<Prizes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RegistrationsArgs = {
  objects: Array<Registrations_Insert_Input>;
  on_conflict?: InputMaybe<Registrations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Registrations_OneArgs = {
  object: Registrations_Insert_Input;
  on_conflict?: InputMaybe<Registrations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Selection_BallotsArgs = {
  objects: Array<Selection_Ballots_Insert_Input>;
  on_conflict?: InputMaybe<Selection_Ballots_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Selection_Ballots_OneArgs = {
  object: Selection_Ballots_Insert_Input;
  on_conflict?: InputMaybe<Selection_Ballots_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Selection_FeedbackArgs = {
  objects: Array<Selection_Feedback_Insert_Input>;
  on_conflict?: InputMaybe<Selection_Feedback_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Selection_Feedback_OneArgs = {
  object: Selection_Feedback_Insert_Input;
  on_conflict?: InputMaybe<Selection_Feedback_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Selection_MetricsArgs = {
  objects: Array<Selection_Metrics_Insert_Input>;
  on_conflict?: InputMaybe<Selection_Metrics_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Selection_Metrics_OneArgs = {
  object: Selection_Metrics_Insert_Input;
  on_conflict?: InputMaybe<Selection_Metrics_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Selection_ProgressArgs = {
  objects: Array<Selection_Progress_Insert_Input>;
  on_conflict?: InputMaybe<Selection_Progress_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Selection_Progress_OneArgs = {
  object: Selection_Progress_Insert_Input;
  on_conflict?: InputMaybe<Selection_Progress_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SharablesArgs = {
  objects: Array<Sharables_Insert_Input>;
  on_conflict?: InputMaybe<Sharables_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sharables_OneArgs = {
  object: Sharables_Insert_Input;
  on_conflict?: InputMaybe<Sharables_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sms_VotesArgs = {
  objects: Array<Sms_Votes_Insert_Input>;
  on_conflict?: InputMaybe<Sms_Votes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sms_Votes_OneArgs = {
  object: Sms_Votes_Insert_Input;
  on_conflict?: InputMaybe<Sms_Votes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SponsorsArgs = {
  objects: Array<Sponsors_Insert_Input>;
  on_conflict?: InputMaybe<Sponsors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sponsors_OneArgs = {
  object: Sponsors_Insert_Input;
  on_conflict?: InputMaybe<Sponsors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StudiosArgs = {
  objects: Array<Studios_Insert_Input>;
  on_conflict?: InputMaybe<Studios_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Studios_OneArgs = {
  object: Studios_Insert_Input;
  on_conflict?: InputMaybe<Studios_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Team_AssetsArgs = {
  objects: Array<Team_Assets_Insert_Input>;
  on_conflict?: InputMaybe<Team_Assets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Team_Assets_OneArgs = {
  object: Team_Assets_Insert_Input;
  on_conflict?: InputMaybe<Team_Assets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Team_MembershipsArgs = {
  objects: Array<Team_Memberships_Insert_Input>;
  on_conflict?: InputMaybe<Team_Memberships_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Team_Memberships_OneArgs = {
  object: Team_Memberships_Insert_Input;
  on_conflict?: InputMaybe<Team_Memberships_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Team_RolesArgs = {
  objects: Array<Team_Roles_Insert_Input>;
  on_conflict?: InputMaybe<Team_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Team_Roles_OneArgs = {
  object: Team_Roles_Insert_Input;
  on_conflict?: InputMaybe<Team_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TeamsArgs = {
  objects: Array<Teams_Insert_Input>;
  on_conflict?: InputMaybe<Teams_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Teams_OneArgs = {
  object: Teams_Insert_Input;
  on_conflict?: InputMaybe<Teams_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Teams_With_Awards_Ceremony_CheckinsArgs = {
  objects: Array<Teams_With_Awards_Ceremony_Checkins_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Teams_With_Awards_Ceremony_Checkins_OneArgs = {
  object: Teams_With_Awards_Ceremony_Checkins_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Teams_With_CheckinsArgs = {
  objects: Array<Teams_With_Checkins_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Teams_With_Checkins_OneArgs = {
  object: Teams_With_Checkins_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Ticket_Tailor_VouchersArgs = {
  objects: Array<Ticket_Tailor_Vouchers_Insert_Input>;
  on_conflict?: InputMaybe<Ticket_Tailor_Vouchers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ticket_Tailor_Vouchers_OneArgs = {
  object: Ticket_Tailor_Vouchers_Insert_Input;
  on_conflict?: InputMaybe<Ticket_Tailor_Vouchers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootJoinLiveKitExitInterviewArgs = {
  displayName: Scalars['String'];
  teamId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootMuxCreateFiveFestUploadArgs = {
  fileName: Scalars['String'];
  fileSize: Scalars['Int'];
  submissionId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootMuxCreateUploadArgs = {
  fileName: Scalars['String'];
  fileSize: Scalars['Int'];
  teamId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootMuxJoinSpaceArgs = {
  spaceId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootMuxStreamSpaceArgs = {
  spaceId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootObscureRegistrationLinkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootProvideRegistrationSignatureArgs = {
  hash?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  is_minor: Scalars['Boolean'];
  signature_email?: InputMaybe<Scalars['String']>;
  signature_name: Scalars['String'];
  signature_phone?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootRecordAwardsCeremonyCheckinArgs = {
  announce: Scalars['String'];
  festivalSubmissionId?: InputMaybe<Scalars['Int']>;
  teamId?: InputMaybe<Scalars['Int']>;
};


/** mutation root */
export type Mutation_RootSendGuestSignatureMailArgs = {
  teamMembershipId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootSendTeamInvitationMailArgs = {
  teamMembershipId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootStripeCreateCheckoutSessionArgs = {
  returnUrl: Scalars['String'];
  teamId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootStripeCreatePurchaseArgs = {
  badgeId?: InputMaybe<Scalars['Int']>;
  festivalSubmissionId?: InputMaybe<Scalars['Int']>;
  lineItems: Array<StripeLineItem>;
  returnUrl: Scalars['String'];
  teamId?: InputMaybe<Scalars['Int']>;
};


/** mutation root */
export type Mutation_RootStripeTerminalChargeArgs = {
  amount: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootSubmitFiveFestArgs = {
  id: Scalars['Int'];
  is_minor: Scalars['Boolean'];
  signature_email?: InputMaybe<Scalars['String']>;
  signature_name: Scalars['String'];
  signature_phone?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootSubmitTeamArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootUpdate_Asset_ExportsArgs = {
  _inc?: InputMaybe<Asset_Exports_Inc_Input>;
  _set?: InputMaybe<Asset_Exports_Set_Input>;
  where: Asset_Exports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Exports_By_PkArgs = {
  _inc?: InputMaybe<Asset_Exports_Inc_Input>;
  _set?: InputMaybe<Asset_Exports_Set_Input>;
  pk_columns: Asset_Exports_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Exports_ManyArgs = {
  updates: Array<Asset_Exports_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_TypesArgs = {
  _inc?: InputMaybe<Asset_Types_Inc_Input>;
  _set?: InputMaybe<Asset_Types_Set_Input>;
  where: Asset_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Types_By_PkArgs = {
  _inc?: InputMaybe<Asset_Types_Inc_Input>;
  _set?: InputMaybe<Asset_Types_Set_Input>;
  pk_columns: Asset_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_Types_ManyArgs = {
  updates: Array<Asset_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Audience_Favorite_VotesArgs = {
  _inc?: InputMaybe<Audience_Favorite_Votes_Inc_Input>;
  _set?: InputMaybe<Audience_Favorite_Votes_Set_Input>;
  where: Audience_Favorite_Votes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Audience_Favorite_Votes_By_PkArgs = {
  _inc?: InputMaybe<Audience_Favorite_Votes_Inc_Input>;
  _set?: InputMaybe<Audience_Favorite_Votes_Set_Input>;
  pk_columns: Audience_Favorite_Votes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Audience_Favorite_Votes_ManyArgs = {
  updates: Array<Audience_Favorite_Votes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Award_Asset_TypesArgs = {
  _inc?: InputMaybe<Award_Asset_Types_Inc_Input>;
  _set?: InputMaybe<Award_Asset_Types_Set_Input>;
  where: Award_Asset_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Award_Asset_Types_By_PkArgs = {
  _inc?: InputMaybe<Award_Asset_Types_Inc_Input>;
  _set?: InputMaybe<Award_Asset_Types_Set_Input>;
  pk_columns: Award_Asset_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Award_Asset_Types_ManyArgs = {
  updates: Array<Award_Asset_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Award_WinnersArgs = {
  _inc?: InputMaybe<Award_Winners_Inc_Input>;
  _set?: InputMaybe<Award_Winners_Set_Input>;
  where: Award_Winners_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Award_Winners_By_PkArgs = {
  _inc?: InputMaybe<Award_Winners_Inc_Input>;
  _set?: InputMaybe<Award_Winners_Set_Input>;
  pk_columns: Award_Winners_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Award_Winners_ManyArgs = {
  updates: Array<Award_Winners_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AwardsArgs = {
  _inc?: InputMaybe<Awards_Inc_Input>;
  _set?: InputMaybe<Awards_Set_Input>;
  where: Awards_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Awards_By_PkArgs = {
  _inc?: InputMaybe<Awards_Inc_Input>;
  _set?: InputMaybe<Awards_Set_Input>;
  pk_columns: Awards_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Awards_Ceremony_CheckinsArgs = {
  _inc?: InputMaybe<Awards_Ceremony_Checkins_Inc_Input>;
  _set?: InputMaybe<Awards_Ceremony_Checkins_Set_Input>;
  where: Awards_Ceremony_Checkins_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Awards_Ceremony_Checkins_By_PkArgs = {
  _inc?: InputMaybe<Awards_Ceremony_Checkins_Inc_Input>;
  _set?: InputMaybe<Awards_Ceremony_Checkins_Set_Input>;
  pk_columns: Awards_Ceremony_Checkins_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Awards_Ceremony_Checkins_ManyArgs = {
  updates: Array<Awards_Ceremony_Checkins_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Awards_ManyArgs = {
  updates: Array<Awards_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CountriesArgs = {
  _inc?: InputMaybe<Countries_Inc_Input>;
  _set?: InputMaybe<Countries_Set_Input>;
  where: Countries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Countries_By_PkArgs = {
  _inc?: InputMaybe<Countries_Inc_Input>;
  _set?: InputMaybe<Countries_Set_Input>;
  pk_columns: Countries_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Countries_ManyArgs = {
  updates: Array<Countries_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Exit_Interview_RecordingsArgs = {
  _inc?: InputMaybe<Exit_Interview_Recordings_Inc_Input>;
  _set?: InputMaybe<Exit_Interview_Recordings_Set_Input>;
  where: Exit_Interview_Recordings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Exit_Interview_Recordings_By_PkArgs = {
  _inc?: InputMaybe<Exit_Interview_Recordings_Inc_Input>;
  _set?: InputMaybe<Exit_Interview_Recordings_Set_Input>;
  pk_columns: Exit_Interview_Recordings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Exit_Interview_Recordings_ManyArgs = {
  updates: Array<Exit_Interview_Recordings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Exit_InterviewsArgs = {
  _inc?: InputMaybe<Exit_Interviews_Inc_Input>;
  _set?: InputMaybe<Exit_Interviews_Set_Input>;
  where: Exit_Interviews_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Exit_Interviews_By_PkArgs = {
  _inc?: InputMaybe<Exit_Interviews_Inc_Input>;
  _set?: InputMaybe<Exit_Interviews_Set_Input>;
  pk_columns: Exit_Interviews_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Exit_Interviews_ManyArgs = {
  updates: Array<Exit_Interviews_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ExpertiseArgs = {
  _inc?: InputMaybe<Expertise_Inc_Input>;
  _set?: InputMaybe<Expertise_Set_Input>;
  where: Expertise_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Expertise_By_PkArgs = {
  _inc?: InputMaybe<Expertise_Inc_Input>;
  _set?: InputMaybe<Expertise_Set_Input>;
  pk_columns: Expertise_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Expertise_ManyArgs = {
  updates: Array<Expertise_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_Badge_Type_Event_TypeArgs = {
  _inc?: InputMaybe<Festival_Badge_Type_Event_Type_Inc_Input>;
  _set?: InputMaybe<Festival_Badge_Type_Event_Type_Set_Input>;
  where: Festival_Badge_Type_Event_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_Badge_Type_Event_Type_By_PkArgs = {
  _inc?: InputMaybe<Festival_Badge_Type_Event_Type_Inc_Input>;
  _set?: InputMaybe<Festival_Badge_Type_Event_Type_Set_Input>;
  pk_columns: Festival_Badge_Type_Event_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_Badge_Type_Event_Type_ManyArgs = {
  updates: Array<Festival_Badge_Type_Event_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_Badge_TypesArgs = {
  _append?: InputMaybe<Festival_Badge_Types_Append_Input>;
  _delete_at_path?: InputMaybe<Festival_Badge_Types_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Festival_Badge_Types_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Festival_Badge_Types_Delete_Key_Input>;
  _inc?: InputMaybe<Festival_Badge_Types_Inc_Input>;
  _prepend?: InputMaybe<Festival_Badge_Types_Prepend_Input>;
  _set?: InputMaybe<Festival_Badge_Types_Set_Input>;
  where: Festival_Badge_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_Badge_Types_By_PkArgs = {
  _append?: InputMaybe<Festival_Badge_Types_Append_Input>;
  _delete_at_path?: InputMaybe<Festival_Badge_Types_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Festival_Badge_Types_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Festival_Badge_Types_Delete_Key_Input>;
  _inc?: InputMaybe<Festival_Badge_Types_Inc_Input>;
  _prepend?: InputMaybe<Festival_Badge_Types_Prepend_Input>;
  _set?: InputMaybe<Festival_Badge_Types_Set_Input>;
  pk_columns: Festival_Badge_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_Badge_Types_ManyArgs = {
  updates: Array<Festival_Badge_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_BadgesArgs = {
  _inc?: InputMaybe<Festival_Badges_Inc_Input>;
  _set?: InputMaybe<Festival_Badges_Set_Input>;
  where: Festival_Badges_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_Badges_By_PkArgs = {
  _inc?: InputMaybe<Festival_Badges_Inc_Input>;
  _set?: InputMaybe<Festival_Badges_Set_Input>;
  pk_columns: Festival_Badges_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_Badges_ManyArgs = {
  updates: Array<Festival_Badges_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_Event_LocationsArgs = {
  _inc?: InputMaybe<Festival_Event_Locations_Inc_Input>;
  _set?: InputMaybe<Festival_Event_Locations_Set_Input>;
  where: Festival_Event_Locations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_Event_Locations_By_PkArgs = {
  _inc?: InputMaybe<Festival_Event_Locations_Inc_Input>;
  _set?: InputMaybe<Festival_Event_Locations_Set_Input>;
  pk_columns: Festival_Event_Locations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_Event_Locations_ManyArgs = {
  updates: Array<Festival_Event_Locations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_Event_TypesArgs = {
  _inc?: InputMaybe<Festival_Event_Types_Inc_Input>;
  _set?: InputMaybe<Festival_Event_Types_Set_Input>;
  where: Festival_Event_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_Event_Types_By_PkArgs = {
  _inc?: InputMaybe<Festival_Event_Types_Inc_Input>;
  _set?: InputMaybe<Festival_Event_Types_Set_Input>;
  pk_columns: Festival_Event_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_Event_Types_ManyArgs = {
  updates: Array<Festival_Event_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_EventsArgs = {
  _inc?: InputMaybe<Festival_Events_Inc_Input>;
  _set?: InputMaybe<Festival_Events_Set_Input>;
  where: Festival_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_Events_By_PkArgs = {
  _inc?: InputMaybe<Festival_Events_Inc_Input>;
  _set?: InputMaybe<Festival_Events_Set_Input>;
  pk_columns: Festival_Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_Events_ManyArgs = {
  updates: Array<Festival_Events_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_GenresArgs = {
  _inc?: InputMaybe<Festival_Genres_Inc_Input>;
  _set?: InputMaybe<Festival_Genres_Set_Input>;
  where: Festival_Genres_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_Genres_By_PkArgs = {
  _inc?: InputMaybe<Festival_Genres_Inc_Input>;
  _set?: InputMaybe<Festival_Genres_Set_Input>;
  pk_columns: Festival_Genres_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_Genres_ManyArgs = {
  updates: Array<Festival_Genres_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_Submission_AssetsArgs = {
  _inc?: InputMaybe<Festival_Submission_Assets_Inc_Input>;
  _set?: InputMaybe<Festival_Submission_Assets_Set_Input>;
  where: Festival_Submission_Assets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_Submission_Assets_By_PkArgs = {
  _inc?: InputMaybe<Festival_Submission_Assets_Inc_Input>;
  _set?: InputMaybe<Festival_Submission_Assets_Set_Input>;
  pk_columns: Festival_Submission_Assets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_Submission_Assets_ManyArgs = {
  updates: Array<Festival_Submission_Assets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_Submission_FeedbackArgs = {
  _inc?: InputMaybe<Festival_Submission_Feedback_Inc_Input>;
  _set?: InputMaybe<Festival_Submission_Feedback_Set_Input>;
  where: Festival_Submission_Feedback_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_Submission_Feedback_By_PkArgs = {
  _inc?: InputMaybe<Festival_Submission_Feedback_Inc_Input>;
  _set?: InputMaybe<Festival_Submission_Feedback_Set_Input>;
  pk_columns: Festival_Submission_Feedback_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_Submission_Feedback_ManyArgs = {
  updates: Array<Festival_Submission_Feedback_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_Submission_VouchersArgs = {
  _inc?: InputMaybe<Festival_Submission_Vouchers_Inc_Input>;
  _set?: InputMaybe<Festival_Submission_Vouchers_Set_Input>;
  where: Festival_Submission_Vouchers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_Submission_Vouchers_By_PkArgs = {
  _inc?: InputMaybe<Festival_Submission_Vouchers_Inc_Input>;
  _set?: InputMaybe<Festival_Submission_Vouchers_Set_Input>;
  pk_columns: Festival_Submission_Vouchers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_Submission_Vouchers_ManyArgs = {
  updates: Array<Festival_Submission_Vouchers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_SubmissionsArgs = {
  _append?: InputMaybe<Festival_Submissions_Append_Input>;
  _delete_at_path?: InputMaybe<Festival_Submissions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Festival_Submissions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Festival_Submissions_Delete_Key_Input>;
  _inc?: InputMaybe<Festival_Submissions_Inc_Input>;
  _prepend?: InputMaybe<Festival_Submissions_Prepend_Input>;
  _set?: InputMaybe<Festival_Submissions_Set_Input>;
  where: Festival_Submissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_Submissions_By_PkArgs = {
  _append?: InputMaybe<Festival_Submissions_Append_Input>;
  _delete_at_path?: InputMaybe<Festival_Submissions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Festival_Submissions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Festival_Submissions_Delete_Key_Input>;
  _inc?: InputMaybe<Festival_Submissions_Inc_Input>;
  _prepend?: InputMaybe<Festival_Submissions_Prepend_Input>;
  _set?: InputMaybe<Festival_Submissions_Set_Input>;
  pk_columns: Festival_Submissions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_Submissions_ManyArgs = {
  updates: Array<Festival_Submissions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_TicketsArgs = {
  _inc?: InputMaybe<Festival_Tickets_Inc_Input>;
  _set?: InputMaybe<Festival_Tickets_Set_Input>;
  where: Festival_Tickets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_Tickets_By_PkArgs = {
  _inc?: InputMaybe<Festival_Tickets_Inc_Input>;
  _set?: InputMaybe<Festival_Tickets_Set_Input>;
  pk_columns: Festival_Tickets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Festival_Tickets_ManyArgs = {
  updates: Array<Festival_Tickets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Film_FestivalsArgs = {
  _inc?: InputMaybe<Film_Festivals_Inc_Input>;
  _set?: InputMaybe<Film_Festivals_Set_Input>;
  where: Film_Festivals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Film_Festivals_By_PkArgs = {
  _inc?: InputMaybe<Film_Festivals_Inc_Input>;
  _set?: InputMaybe<Film_Festivals_Set_Input>;
  pk_columns: Film_Festivals_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Film_Festivals_ManyArgs = {
  updates: Array<Film_Festivals_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Film_Group_Festival_SubmissionsArgs = {
  _inc?: InputMaybe<Film_Group_Festival_Submissions_Inc_Input>;
  _set?: InputMaybe<Film_Group_Festival_Submissions_Set_Input>;
  where: Film_Group_Festival_Submissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Film_Group_Festival_Submissions_By_PkArgs = {
  _inc?: InputMaybe<Film_Group_Festival_Submissions_Inc_Input>;
  _set?: InputMaybe<Film_Group_Festival_Submissions_Set_Input>;
  pk_columns: Film_Group_Festival_Submissions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Film_Group_Festival_Submissions_ManyArgs = {
  updates: Array<Film_Group_Festival_Submissions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Film_Group_FilmsArgs = {
  _inc?: InputMaybe<Film_Group_Films_Inc_Input>;
  _set?: InputMaybe<Film_Group_Films_Set_Input>;
  where: Film_Group_Films_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Film_Group_Films_By_PkArgs = {
  _inc?: InputMaybe<Film_Group_Films_Inc_Input>;
  _set?: InputMaybe<Film_Group_Films_Set_Input>;
  pk_columns: Film_Group_Films_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Film_Group_Films_ManyArgs = {
  updates: Array<Film_Group_Films_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Film_Group_UsersArgs = {
  _append?: InputMaybe<Film_Group_Users_Append_Input>;
  _delete_at_path?: InputMaybe<Film_Group_Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Film_Group_Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Film_Group_Users_Delete_Key_Input>;
  _inc?: InputMaybe<Film_Group_Users_Inc_Input>;
  _prepend?: InputMaybe<Film_Group_Users_Prepend_Input>;
  _set?: InputMaybe<Film_Group_Users_Set_Input>;
  where: Film_Group_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Film_Group_Users_By_PkArgs = {
  _append?: InputMaybe<Film_Group_Users_Append_Input>;
  _delete_at_path?: InputMaybe<Film_Group_Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Film_Group_Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Film_Group_Users_Delete_Key_Input>;
  _inc?: InputMaybe<Film_Group_Users_Inc_Input>;
  _prepend?: InputMaybe<Film_Group_Users_Prepend_Input>;
  _set?: InputMaybe<Film_Group_Users_Set_Input>;
  pk_columns: Film_Group_Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Film_Group_Users_ManyArgs = {
  updates: Array<Film_Group_Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Film_GroupsArgs = {
  _inc?: InputMaybe<Film_Groups_Inc_Input>;
  _set?: InputMaybe<Film_Groups_Set_Input>;
  where: Film_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Film_Groups_By_PkArgs = {
  _inc?: InputMaybe<Film_Groups_Inc_Input>;
  _set?: InputMaybe<Film_Groups_Set_Input>;
  pk_columns: Film_Groups_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Film_Groups_ManyArgs = {
  updates: Array<Film_Groups_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FilmsArgs = {
  _append?: InputMaybe<Films_Append_Input>;
  _delete_at_path?: InputMaybe<Films_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Films_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Films_Delete_Key_Input>;
  _inc?: InputMaybe<Films_Inc_Input>;
  _prepend?: InputMaybe<Films_Prepend_Input>;
  _set?: InputMaybe<Films_Set_Input>;
  where: Films_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Films_By_PkArgs = {
  _append?: InputMaybe<Films_Append_Input>;
  _delete_at_path?: InputMaybe<Films_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Films_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Films_Delete_Key_Input>;
  _inc?: InputMaybe<Films_Inc_Input>;
  _prepend?: InputMaybe<Films_Prepend_Input>;
  _set?: InputMaybe<Films_Set_Input>;
  pk_columns: Films_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Films_ManyArgs = {
  updates: Array<Films_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_GenresArgs = {
  _inc?: InputMaybe<Genres_Inc_Input>;
  _set?: InputMaybe<Genres_Set_Input>;
  where: Genres_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Genres_By_PkArgs = {
  _inc?: InputMaybe<Genres_Inc_Input>;
  _set?: InputMaybe<Genres_Set_Input>;
  pk_columns: Genres_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Genres_ManyArgs = {
  updates: Array<Genres_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Kickoff_CheckinsArgs = {
  _inc?: InputMaybe<Kickoff_Checkins_Inc_Input>;
  _set?: InputMaybe<Kickoff_Checkins_Set_Input>;
  where: Kickoff_Checkins_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Kickoff_Checkins_By_PkArgs = {
  _inc?: InputMaybe<Kickoff_Checkins_Inc_Input>;
  _set?: InputMaybe<Kickoff_Checkins_Set_Input>;
  pk_columns: Kickoff_Checkins_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Kickoff_Checkins_ManyArgs = {
  updates: Array<Kickoff_Checkins_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Location_ReleasesArgs = {
  _inc?: InputMaybe<Location_Releases_Inc_Input>;
  _set?: InputMaybe<Location_Releases_Set_Input>;
  where: Location_Releases_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Location_Releases_By_PkArgs = {
  _inc?: InputMaybe<Location_Releases_Inc_Input>;
  _set?: InputMaybe<Location_Releases_Set_Input>;
  pk_columns: Location_Releases_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Location_Releases_ManyArgs = {
  updates: Array<Location_Releases_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Matchup_RequestsArgs = {
  _append?: InputMaybe<Matchup_Requests_Append_Input>;
  _delete_at_path?: InputMaybe<Matchup_Requests_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Matchup_Requests_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Matchup_Requests_Delete_Key_Input>;
  _inc?: InputMaybe<Matchup_Requests_Inc_Input>;
  _prepend?: InputMaybe<Matchup_Requests_Prepend_Input>;
  _set?: InputMaybe<Matchup_Requests_Set_Input>;
  where: Matchup_Requests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Matchup_Requests_By_PkArgs = {
  _append?: InputMaybe<Matchup_Requests_Append_Input>;
  _delete_at_path?: InputMaybe<Matchup_Requests_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Matchup_Requests_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Matchup_Requests_Delete_Key_Input>;
  _inc?: InputMaybe<Matchup_Requests_Inc_Input>;
  _prepend?: InputMaybe<Matchup_Requests_Prepend_Input>;
  _set?: InputMaybe<Matchup_Requests_Set_Input>;
  pk_columns: Matchup_Requests_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Matchup_Requests_ManyArgs = {
  updates: Array<Matchup_Requests_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Music_ReleasesArgs = {
  _inc?: InputMaybe<Music_Releases_Inc_Input>;
  _set?: InputMaybe<Music_Releases_Set_Input>;
  where: Music_Releases_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Music_Releases_By_PkArgs = {
  _inc?: InputMaybe<Music_Releases_Inc_Input>;
  _set?: InputMaybe<Music_Releases_Set_Input>;
  pk_columns: Music_Releases_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Music_Releases_ManyArgs = {
  updates: Array<Music_Releases_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Nomination_AssetsArgs = {
  _inc?: InputMaybe<Nomination_Assets_Inc_Input>;
  _set?: InputMaybe<Nomination_Assets_Set_Input>;
  where: Nomination_Assets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nomination_Assets_By_PkArgs = {
  _inc?: InputMaybe<Nomination_Assets_Inc_Input>;
  _set?: InputMaybe<Nomination_Assets_Set_Input>;
  pk_columns: Nomination_Assets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Nomination_Assets_ManyArgs = {
  updates: Array<Nomination_Assets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NominationsArgs = {
  _inc?: InputMaybe<Nominations_Inc_Input>;
  _set?: InputMaybe<Nominations_Set_Input>;
  where: Nominations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nominations_By_PkArgs = {
  _inc?: InputMaybe<Nominations_Inc_Input>;
  _set?: InputMaybe<Nominations_Set_Input>;
  pk_columns: Nominations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Nominations_ManyArgs = {
  updates: Array<Nominations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Online_Screening_TicketsArgs = {
  _inc?: InputMaybe<Online_Screening_Tickets_Inc_Input>;
  _set?: InputMaybe<Online_Screening_Tickets_Set_Input>;
  where: Online_Screening_Tickets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Online_Screening_Tickets_By_PkArgs = {
  _inc?: InputMaybe<Online_Screening_Tickets_Inc_Input>;
  _set?: InputMaybe<Online_Screening_Tickets_Set_Input>;
  pk_columns: Online_Screening_Tickets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Online_Screening_Tickets_ManyArgs = {
  updates: Array<Online_Screening_Tickets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PaymentsArgs = {
  _inc?: InputMaybe<Payments_Inc_Input>;
  _set?: InputMaybe<Payments_Set_Input>;
  where: Payments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Payments_By_PkArgs = {
  _inc?: InputMaybe<Payments_Inc_Input>;
  _set?: InputMaybe<Payments_Set_Input>;
  pk_columns: Payments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Payments_ManyArgs = {
  updates: Array<Payments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Playlist_TeamArgs = {
  _inc?: InputMaybe<Playlist_Team_Inc_Input>;
  _set?: InputMaybe<Playlist_Team_Set_Input>;
  where: Playlist_Team_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Playlist_Team_By_PkArgs = {
  _inc?: InputMaybe<Playlist_Team_Inc_Input>;
  _set?: InputMaybe<Playlist_Team_Set_Input>;
  pk_columns: Playlist_Team_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Playlist_Team_ManyArgs = {
  updates: Array<Playlist_Team_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PlaylistsArgs = {
  _inc?: InputMaybe<Playlists_Inc_Input>;
  _set?: InputMaybe<Playlists_Set_Input>;
  where: Playlists_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Playlists_By_PkArgs = {
  _inc?: InputMaybe<Playlists_Inc_Input>;
  _set?: InputMaybe<Playlists_Set_Input>;
  pk_columns: Playlists_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Playlists_ManyArgs = {
  updates: Array<Playlists_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Prize_ElectionsArgs = {
  _inc?: InputMaybe<Prize_Elections_Inc_Input>;
  _set?: InputMaybe<Prize_Elections_Set_Input>;
  where: Prize_Elections_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Prize_Elections_ManyArgs = {
  updates: Array<Prize_Elections_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PrizesArgs = {
  _inc?: InputMaybe<Prizes_Inc_Input>;
  _set?: InputMaybe<Prizes_Set_Input>;
  where: Prizes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Prizes_By_PkArgs = {
  _inc?: InputMaybe<Prizes_Inc_Input>;
  _set?: InputMaybe<Prizes_Set_Input>;
  pk_columns: Prizes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Prizes_ManyArgs = {
  updates: Array<Prizes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RegistrationsArgs = {
  _inc?: InputMaybe<Registrations_Inc_Input>;
  _set?: InputMaybe<Registrations_Set_Input>;
  where: Registrations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Registrations_By_PkArgs = {
  _inc?: InputMaybe<Registrations_Inc_Input>;
  _set?: InputMaybe<Registrations_Set_Input>;
  pk_columns: Registrations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Registrations_ManyArgs = {
  updates: Array<Registrations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Selection_BallotsArgs = {
  _inc?: InputMaybe<Selection_Ballots_Inc_Input>;
  _set?: InputMaybe<Selection_Ballots_Set_Input>;
  where: Selection_Ballots_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Selection_Ballots_By_PkArgs = {
  _inc?: InputMaybe<Selection_Ballots_Inc_Input>;
  _set?: InputMaybe<Selection_Ballots_Set_Input>;
  pk_columns: Selection_Ballots_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Selection_Ballots_ManyArgs = {
  updates: Array<Selection_Ballots_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Selection_FeedbackArgs = {
  _inc?: InputMaybe<Selection_Feedback_Inc_Input>;
  _set?: InputMaybe<Selection_Feedback_Set_Input>;
  where: Selection_Feedback_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Selection_Feedback_By_PkArgs = {
  _inc?: InputMaybe<Selection_Feedback_Inc_Input>;
  _set?: InputMaybe<Selection_Feedback_Set_Input>;
  pk_columns: Selection_Feedback_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Selection_Feedback_ManyArgs = {
  updates: Array<Selection_Feedback_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Selection_MetricsArgs = {
  _inc?: InputMaybe<Selection_Metrics_Inc_Input>;
  _set?: InputMaybe<Selection_Metrics_Set_Input>;
  where: Selection_Metrics_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Selection_Metrics_By_PkArgs = {
  _inc?: InputMaybe<Selection_Metrics_Inc_Input>;
  _set?: InputMaybe<Selection_Metrics_Set_Input>;
  pk_columns: Selection_Metrics_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Selection_Metrics_ManyArgs = {
  updates: Array<Selection_Metrics_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Selection_ProgressArgs = {
  _inc?: InputMaybe<Selection_Progress_Inc_Input>;
  _set?: InputMaybe<Selection_Progress_Set_Input>;
  where: Selection_Progress_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Selection_Progress_By_PkArgs = {
  _inc?: InputMaybe<Selection_Progress_Inc_Input>;
  _set?: InputMaybe<Selection_Progress_Set_Input>;
  pk_columns: Selection_Progress_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Selection_Progress_ManyArgs = {
  updates: Array<Selection_Progress_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SharablesArgs = {
  _inc?: InputMaybe<Sharables_Inc_Input>;
  _set?: InputMaybe<Sharables_Set_Input>;
  where: Sharables_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sharables_By_PkArgs = {
  _inc?: InputMaybe<Sharables_Inc_Input>;
  _set?: InputMaybe<Sharables_Set_Input>;
  pk_columns: Sharables_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sharables_ManyArgs = {
  updates: Array<Sharables_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sms_VotesArgs = {
  _inc?: InputMaybe<Sms_Votes_Inc_Input>;
  _set?: InputMaybe<Sms_Votes_Set_Input>;
  where: Sms_Votes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sms_Votes_By_PkArgs = {
  _inc?: InputMaybe<Sms_Votes_Inc_Input>;
  _set?: InputMaybe<Sms_Votes_Set_Input>;
  pk_columns: Sms_Votes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sms_Votes_ManyArgs = {
  updates: Array<Sms_Votes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SponsorsArgs = {
  _inc?: InputMaybe<Sponsors_Inc_Input>;
  _set?: InputMaybe<Sponsors_Set_Input>;
  where: Sponsors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sponsors_By_PkArgs = {
  _inc?: InputMaybe<Sponsors_Inc_Input>;
  _set?: InputMaybe<Sponsors_Set_Input>;
  pk_columns: Sponsors_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sponsors_ManyArgs = {
  updates: Array<Sponsors_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StudiosArgs = {
  _inc?: InputMaybe<Studios_Inc_Input>;
  _set?: InputMaybe<Studios_Set_Input>;
  where: Studios_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Studios_By_PkArgs = {
  _inc?: InputMaybe<Studios_Inc_Input>;
  _set?: InputMaybe<Studios_Set_Input>;
  pk_columns: Studios_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Studios_ManyArgs = {
  updates: Array<Studios_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Team_AssetsArgs = {
  _inc?: InputMaybe<Team_Assets_Inc_Input>;
  _set?: InputMaybe<Team_Assets_Set_Input>;
  where: Team_Assets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Team_Assets_By_PkArgs = {
  _inc?: InputMaybe<Team_Assets_Inc_Input>;
  _set?: InputMaybe<Team_Assets_Set_Input>;
  pk_columns: Team_Assets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Team_Assets_ManyArgs = {
  updates: Array<Team_Assets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Team_MembershipsArgs = {
  _inc?: InputMaybe<Team_Memberships_Inc_Input>;
  _set?: InputMaybe<Team_Memberships_Set_Input>;
  where: Team_Memberships_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Team_Memberships_By_PkArgs = {
  _inc?: InputMaybe<Team_Memberships_Inc_Input>;
  _set?: InputMaybe<Team_Memberships_Set_Input>;
  pk_columns: Team_Memberships_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Team_Memberships_ManyArgs = {
  updates: Array<Team_Memberships_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Team_RolesArgs = {
  _inc?: InputMaybe<Team_Roles_Inc_Input>;
  _set?: InputMaybe<Team_Roles_Set_Input>;
  where: Team_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Team_Roles_By_PkArgs = {
  _inc?: InputMaybe<Team_Roles_Inc_Input>;
  _set?: InputMaybe<Team_Roles_Set_Input>;
  pk_columns: Team_Roles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Team_Roles_ManyArgs = {
  updates: Array<Team_Roles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TeamsArgs = {
  _append?: InputMaybe<Teams_Append_Input>;
  _delete_at_path?: InputMaybe<Teams_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Teams_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Teams_Delete_Key_Input>;
  _inc?: InputMaybe<Teams_Inc_Input>;
  _prepend?: InputMaybe<Teams_Prepend_Input>;
  _set?: InputMaybe<Teams_Set_Input>;
  where: Teams_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_By_PkArgs = {
  _append?: InputMaybe<Teams_Append_Input>;
  _delete_at_path?: InputMaybe<Teams_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Teams_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Teams_Delete_Key_Input>;
  _inc?: InputMaybe<Teams_Inc_Input>;
  _prepend?: InputMaybe<Teams_Prepend_Input>;
  _set?: InputMaybe<Teams_Set_Input>;
  pk_columns: Teams_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_ManyArgs = {
  updates: Array<Teams_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_With_Awards_Ceremony_CheckinsArgs = {
  _inc?: InputMaybe<Teams_With_Awards_Ceremony_Checkins_Inc_Input>;
  _set?: InputMaybe<Teams_With_Awards_Ceremony_Checkins_Set_Input>;
  where: Teams_With_Awards_Ceremony_Checkins_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_With_Awards_Ceremony_Checkins_ManyArgs = {
  updates: Array<Teams_With_Awards_Ceremony_Checkins_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_With_CheckinsArgs = {
  _inc?: InputMaybe<Teams_With_Checkins_Inc_Input>;
  _set?: InputMaybe<Teams_With_Checkins_Set_Input>;
  where: Teams_With_Checkins_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_With_Checkins_ManyArgs = {
  updates: Array<Teams_With_Checkins_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ticket_Tailor_VouchersArgs = {
  _inc?: InputMaybe<Ticket_Tailor_Vouchers_Inc_Input>;
  _set?: InputMaybe<Ticket_Tailor_Vouchers_Set_Input>;
  where: Ticket_Tailor_Vouchers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ticket_Tailor_Vouchers_By_PkArgs = {
  _inc?: InputMaybe<Ticket_Tailor_Vouchers_Inc_Input>;
  _set?: InputMaybe<Ticket_Tailor_Vouchers_Set_Input>;
  pk_columns: Ticket_Tailor_Vouchers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ticket_Tailor_Vouchers_ManyArgs = {
  updates: Array<Ticket_Tailor_Vouchers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _inc?: InputMaybe<Users_Inc_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _inc?: InputMaybe<Users_Inc_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};

/** columns and relationships of "nomination_assets" */
export type Nomination_Assets = {
  __typename?: 'nomination_assets';
  /** An object relationship */
  asset_type: Asset_Types;
  asset_type_id: Scalars['numeric'];
  created: Scalars['timestamp'];
  created_by: Scalars['String'];
  file_name: Scalars['String'];
  id: Scalars['numeric'];
  /** An object relationship */
  nomination: Nominations;
  nomination_id: Scalars['numeric'];
  updated: Scalars['timestamp'];
  updated_by: Scalars['String'];
};

/** aggregated selection of "nomination_assets" */
export type Nomination_Assets_Aggregate = {
  __typename?: 'nomination_assets_aggregate';
  aggregate?: Maybe<Nomination_Assets_Aggregate_Fields>;
  nodes: Array<Nomination_Assets>;
};

export type Nomination_Assets_Aggregate_Bool_Exp = {
  count?: InputMaybe<Nomination_Assets_Aggregate_Bool_Exp_Count>;
};

export type Nomination_Assets_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Nomination_Assets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Nomination_Assets_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "nomination_assets" */
export type Nomination_Assets_Aggregate_Fields = {
  __typename?: 'nomination_assets_aggregate_fields';
  avg?: Maybe<Nomination_Assets_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Nomination_Assets_Max_Fields>;
  min?: Maybe<Nomination_Assets_Min_Fields>;
  stddev?: Maybe<Nomination_Assets_Stddev_Fields>;
  stddev_pop?: Maybe<Nomination_Assets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Nomination_Assets_Stddev_Samp_Fields>;
  sum?: Maybe<Nomination_Assets_Sum_Fields>;
  var_pop?: Maybe<Nomination_Assets_Var_Pop_Fields>;
  var_samp?: Maybe<Nomination_Assets_Var_Samp_Fields>;
  variance?: Maybe<Nomination_Assets_Variance_Fields>;
};


/** aggregate fields of "nomination_assets" */
export type Nomination_Assets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Nomination_Assets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "nomination_assets" */
export type Nomination_Assets_Aggregate_Order_By = {
  avg?: InputMaybe<Nomination_Assets_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Nomination_Assets_Max_Order_By>;
  min?: InputMaybe<Nomination_Assets_Min_Order_By>;
  stddev?: InputMaybe<Nomination_Assets_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Nomination_Assets_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Nomination_Assets_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Nomination_Assets_Sum_Order_By>;
  var_pop?: InputMaybe<Nomination_Assets_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Nomination_Assets_Var_Samp_Order_By>;
  variance?: InputMaybe<Nomination_Assets_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "nomination_assets" */
export type Nomination_Assets_Arr_Rel_Insert_Input = {
  data: Array<Nomination_Assets_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Nomination_Assets_On_Conflict>;
};

/** aggregate avg on columns */
export type Nomination_Assets_Avg_Fields = {
  __typename?: 'nomination_assets_avg_fields';
  asset_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nomination_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "nomination_assets" */
export type Nomination_Assets_Avg_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nomination_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "nomination_assets". All fields are combined with a logical 'AND'. */
export type Nomination_Assets_Bool_Exp = {
  _and?: InputMaybe<Array<Nomination_Assets_Bool_Exp>>;
  _not?: InputMaybe<Nomination_Assets_Bool_Exp>;
  _or?: InputMaybe<Array<Nomination_Assets_Bool_Exp>>;
  asset_type?: InputMaybe<Asset_Types_Bool_Exp>;
  asset_type_id?: InputMaybe<Numeric_Comparison_Exp>;
  created?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  file_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Numeric_Comparison_Exp>;
  nomination?: InputMaybe<Nominations_Bool_Exp>;
  nomination_id?: InputMaybe<Numeric_Comparison_Exp>;
  updated?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "nomination_assets" */
export enum Nomination_Assets_Constraint {
  /** unique or primary key constraint on columns "id" */
  NominationAssetsPkey = 'nomination_assets_pkey'
}

/** input type for incrementing numeric columns in table "nomination_assets" */
export type Nomination_Assets_Inc_Input = {
  asset_type_id?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['numeric']>;
  nomination_id?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "nomination_assets" */
export type Nomination_Assets_Insert_Input = {
  asset_type?: InputMaybe<Asset_Types_Obj_Rel_Insert_Input>;
  asset_type_id?: InputMaybe<Scalars['numeric']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  file_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  nomination?: InputMaybe<Nominations_Obj_Rel_Insert_Input>;
  nomination_id?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Nomination_Assets_Max_Fields = {
  __typename?: 'nomination_assets_max_fields';
  asset_type_id?: Maybe<Scalars['numeric']>;
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  file_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  nomination_id?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "nomination_assets" */
export type Nomination_Assets_Max_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nomination_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Nomination_Assets_Min_Fields = {
  __typename?: 'nomination_assets_min_fields';
  asset_type_id?: Maybe<Scalars['numeric']>;
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  file_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  nomination_id?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "nomination_assets" */
export type Nomination_Assets_Min_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nomination_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "nomination_assets" */
export type Nomination_Assets_Mutation_Response = {
  __typename?: 'nomination_assets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Nomination_Assets>;
};

/** on_conflict condition type for table "nomination_assets" */
export type Nomination_Assets_On_Conflict = {
  constraint: Nomination_Assets_Constraint;
  update_columns?: Array<Nomination_Assets_Update_Column>;
  where?: InputMaybe<Nomination_Assets_Bool_Exp>;
};

/** Ordering options when selecting data from "nomination_assets". */
export type Nomination_Assets_Order_By = {
  asset_type?: InputMaybe<Asset_Types_Order_By>;
  asset_type_id?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nomination?: InputMaybe<Nominations_Order_By>;
  nomination_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: nomination_assets */
export type Nomination_Assets_Pk_Columns_Input = {
  id: Scalars['numeric'];
};

/** select columns of table "nomination_assets" */
export enum Nomination_Assets_Select_Column {
  /** column name */
  AssetTypeId = 'asset_type_id',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  FileName = 'file_name',
  /** column name */
  Id = 'id',
  /** column name */
  NominationId = 'nomination_id',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** input type for updating data in table "nomination_assets" */
export type Nomination_Assets_Set_Input = {
  asset_type_id?: InputMaybe<Scalars['numeric']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  file_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  nomination_id?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Nomination_Assets_Stddev_Fields = {
  __typename?: 'nomination_assets_stddev_fields';
  asset_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nomination_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "nomination_assets" */
export type Nomination_Assets_Stddev_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nomination_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Nomination_Assets_Stddev_Pop_Fields = {
  __typename?: 'nomination_assets_stddev_pop_fields';
  asset_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nomination_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "nomination_assets" */
export type Nomination_Assets_Stddev_Pop_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nomination_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Nomination_Assets_Stddev_Samp_Fields = {
  __typename?: 'nomination_assets_stddev_samp_fields';
  asset_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nomination_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "nomination_assets" */
export type Nomination_Assets_Stddev_Samp_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nomination_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "nomination_assets" */
export type Nomination_Assets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Nomination_Assets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Nomination_Assets_Stream_Cursor_Value_Input = {
  asset_type_id?: InputMaybe<Scalars['numeric']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  file_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  nomination_id?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Nomination_Assets_Sum_Fields = {
  __typename?: 'nomination_assets_sum_fields';
  asset_type_id?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['numeric']>;
  nomination_id?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "nomination_assets" */
export type Nomination_Assets_Sum_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nomination_id?: InputMaybe<Order_By>;
};

/** update columns of table "nomination_assets" */
export enum Nomination_Assets_Update_Column {
  /** column name */
  AssetTypeId = 'asset_type_id',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  FileName = 'file_name',
  /** column name */
  Id = 'id',
  /** column name */
  NominationId = 'nomination_id',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by'
}

export type Nomination_Assets_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Nomination_Assets_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Nomination_Assets_Set_Input>;
  /** filter the rows which have to be updated */
  where: Nomination_Assets_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Nomination_Assets_Var_Pop_Fields = {
  __typename?: 'nomination_assets_var_pop_fields';
  asset_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nomination_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "nomination_assets" */
export type Nomination_Assets_Var_Pop_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nomination_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Nomination_Assets_Var_Samp_Fields = {
  __typename?: 'nomination_assets_var_samp_fields';
  asset_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nomination_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "nomination_assets" */
export type Nomination_Assets_Var_Samp_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nomination_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Nomination_Assets_Variance_Fields = {
  __typename?: 'nomination_assets_variance_fields';
  asset_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nomination_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "nomination_assets" */
export type Nomination_Assets_Variance_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nomination_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "nominations" */
export type Nominations = {
  __typename?: 'nominations';
  /** An array relationship */
  assets: Array<Nomination_Assets>;
  /** An aggregate relationship */
  assets_aggregate: Nomination_Assets_Aggregate;
  /** An object relationship */
  award?: Maybe<Awards>;
  award_id?: Maybe<Scalars['numeric']>;
  created: Scalars['timestamp'];
  created_by: Scalars['String'];
  id: Scalars['numeric'];
  /** An object relationship */
  prize?: Maybe<Prizes>;
  prize_id?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  team?: Maybe<Teams>;
  team_id?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  team_membership?: Maybe<Team_Memberships>;
  team_membership_id?: Maybe<Scalars['numeric']>;
  updated: Scalars['timestamp'];
  updated_by: Scalars['String'];
};


/** columns and relationships of "nominations" */
export type NominationsAssetsArgs = {
  distinct_on?: InputMaybe<Array<Nomination_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nomination_Assets_Order_By>>;
  where?: InputMaybe<Nomination_Assets_Bool_Exp>;
};


/** columns and relationships of "nominations" */
export type NominationsAssets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nomination_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nomination_Assets_Order_By>>;
  where?: InputMaybe<Nomination_Assets_Bool_Exp>;
};

/** aggregated selection of "nominations" */
export type Nominations_Aggregate = {
  __typename?: 'nominations_aggregate';
  aggregate?: Maybe<Nominations_Aggregate_Fields>;
  nodes: Array<Nominations>;
};

export type Nominations_Aggregate_Bool_Exp = {
  count?: InputMaybe<Nominations_Aggregate_Bool_Exp_Count>;
};

export type Nominations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Nominations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Nominations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "nominations" */
export type Nominations_Aggregate_Fields = {
  __typename?: 'nominations_aggregate_fields';
  avg?: Maybe<Nominations_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Nominations_Max_Fields>;
  min?: Maybe<Nominations_Min_Fields>;
  stddev?: Maybe<Nominations_Stddev_Fields>;
  stddev_pop?: Maybe<Nominations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Nominations_Stddev_Samp_Fields>;
  sum?: Maybe<Nominations_Sum_Fields>;
  var_pop?: Maybe<Nominations_Var_Pop_Fields>;
  var_samp?: Maybe<Nominations_Var_Samp_Fields>;
  variance?: Maybe<Nominations_Variance_Fields>;
};


/** aggregate fields of "nominations" */
export type Nominations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Nominations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "nominations" */
export type Nominations_Aggregate_Order_By = {
  avg?: InputMaybe<Nominations_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Nominations_Max_Order_By>;
  min?: InputMaybe<Nominations_Min_Order_By>;
  stddev?: InputMaybe<Nominations_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Nominations_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Nominations_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Nominations_Sum_Order_By>;
  var_pop?: InputMaybe<Nominations_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Nominations_Var_Samp_Order_By>;
  variance?: InputMaybe<Nominations_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "nominations" */
export type Nominations_Arr_Rel_Insert_Input = {
  data: Array<Nominations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Nominations_On_Conflict>;
};

/** aggregate avg on columns */
export type Nominations_Avg_Fields = {
  __typename?: 'nominations_avg_fields';
  award_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  prize_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "nominations" */
export type Nominations_Avg_Order_By = {
  award_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  team_membership_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "nominations". All fields are combined with a logical 'AND'. */
export type Nominations_Bool_Exp = {
  _and?: InputMaybe<Array<Nominations_Bool_Exp>>;
  _not?: InputMaybe<Nominations_Bool_Exp>;
  _or?: InputMaybe<Array<Nominations_Bool_Exp>>;
  assets?: InputMaybe<Nomination_Assets_Bool_Exp>;
  assets_aggregate?: InputMaybe<Nomination_Assets_Aggregate_Bool_Exp>;
  award?: InputMaybe<Awards_Bool_Exp>;
  award_id?: InputMaybe<Numeric_Comparison_Exp>;
  created?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Numeric_Comparison_Exp>;
  prize?: InputMaybe<Prizes_Bool_Exp>;
  prize_id?: InputMaybe<Numeric_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Numeric_Comparison_Exp>;
  team_membership?: InputMaybe<Team_Memberships_Bool_Exp>;
  team_membership_id?: InputMaybe<Numeric_Comparison_Exp>;
  updated?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "nominations" */
export enum Nominations_Constraint {
  /** unique or primary key constraint on columns "id" */
  NominationsPkey = 'nominations_pkey'
}

/** input type for incrementing numeric columns in table "nominations" */
export type Nominations_Inc_Input = {
  award_id?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['numeric']>;
  prize_id?: InputMaybe<Scalars['numeric']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  team_membership_id?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "nominations" */
export type Nominations_Insert_Input = {
  assets?: InputMaybe<Nomination_Assets_Arr_Rel_Insert_Input>;
  award?: InputMaybe<Awards_Obj_Rel_Insert_Input>;
  award_id?: InputMaybe<Scalars['numeric']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  prize?: InputMaybe<Prizes_Obj_Rel_Insert_Input>;
  prize_id?: InputMaybe<Scalars['numeric']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['numeric']>;
  team_membership?: InputMaybe<Team_Memberships_Obj_Rel_Insert_Input>;
  team_membership_id?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Nominations_Max_Fields = {
  __typename?: 'nominations_max_fields';
  award_id?: Maybe<Scalars['numeric']>;
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  prize_id?: Maybe<Scalars['numeric']>;
  team_id?: Maybe<Scalars['numeric']>;
  team_membership_id?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "nominations" */
export type Nominations_Max_Order_By = {
  award_id?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  team_membership_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Nominations_Min_Fields = {
  __typename?: 'nominations_min_fields';
  award_id?: Maybe<Scalars['numeric']>;
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  prize_id?: Maybe<Scalars['numeric']>;
  team_id?: Maybe<Scalars['numeric']>;
  team_membership_id?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "nominations" */
export type Nominations_Min_Order_By = {
  award_id?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  team_membership_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "nominations" */
export type Nominations_Mutation_Response = {
  __typename?: 'nominations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Nominations>;
};

/** input type for inserting object relation for remote table "nominations" */
export type Nominations_Obj_Rel_Insert_Input = {
  data: Nominations_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Nominations_On_Conflict>;
};

/** on_conflict condition type for table "nominations" */
export type Nominations_On_Conflict = {
  constraint: Nominations_Constraint;
  update_columns?: Array<Nominations_Update_Column>;
  where?: InputMaybe<Nominations_Bool_Exp>;
};

/** Ordering options when selecting data from "nominations". */
export type Nominations_Order_By = {
  assets_aggregate?: InputMaybe<Nomination_Assets_Aggregate_Order_By>;
  award?: InputMaybe<Awards_Order_By>;
  award_id?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  prize?: InputMaybe<Prizes_Order_By>;
  prize_id?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  team_membership?: InputMaybe<Team_Memberships_Order_By>;
  team_membership_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: nominations */
export type Nominations_Pk_Columns_Input = {
  id: Scalars['numeric'];
};

/** select columns of table "nominations" */
export enum Nominations_Select_Column {
  /** column name */
  AwardId = 'award_id',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  PrizeId = 'prize_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TeamMembershipId = 'team_membership_id',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** input type for updating data in table "nominations" */
export type Nominations_Set_Input = {
  award_id?: InputMaybe<Scalars['numeric']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  prize_id?: InputMaybe<Scalars['numeric']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  team_membership_id?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Nominations_Stddev_Fields = {
  __typename?: 'nominations_stddev_fields';
  award_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  prize_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "nominations" */
export type Nominations_Stddev_Order_By = {
  award_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  team_membership_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Nominations_Stddev_Pop_Fields = {
  __typename?: 'nominations_stddev_pop_fields';
  award_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  prize_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "nominations" */
export type Nominations_Stddev_Pop_Order_By = {
  award_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  team_membership_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Nominations_Stddev_Samp_Fields = {
  __typename?: 'nominations_stddev_samp_fields';
  award_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  prize_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "nominations" */
export type Nominations_Stddev_Samp_Order_By = {
  award_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  team_membership_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "nominations" */
export type Nominations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Nominations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Nominations_Stream_Cursor_Value_Input = {
  award_id?: InputMaybe<Scalars['numeric']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  prize_id?: InputMaybe<Scalars['numeric']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  team_membership_id?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Nominations_Sum_Fields = {
  __typename?: 'nominations_sum_fields';
  award_id?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['numeric']>;
  prize_id?: Maybe<Scalars['numeric']>;
  team_id?: Maybe<Scalars['numeric']>;
  team_membership_id?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "nominations" */
export type Nominations_Sum_Order_By = {
  award_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  team_membership_id?: InputMaybe<Order_By>;
};

/** update columns of table "nominations" */
export enum Nominations_Update_Column {
  /** column name */
  AwardId = 'award_id',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  PrizeId = 'prize_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TeamMembershipId = 'team_membership_id',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by'
}

export type Nominations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Nominations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Nominations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Nominations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Nominations_Var_Pop_Fields = {
  __typename?: 'nominations_var_pop_fields';
  award_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  prize_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "nominations" */
export type Nominations_Var_Pop_Order_By = {
  award_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  team_membership_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Nominations_Var_Samp_Fields = {
  __typename?: 'nominations_var_samp_fields';
  award_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  prize_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "nominations" */
export type Nominations_Var_Samp_Order_By = {
  award_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  team_membership_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Nominations_Variance_Fields = {
  __typename?: 'nominations_variance_fields';
  award_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  prize_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "nominations" */
export type Nominations_Variance_Order_By = {
  award_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  team_membership_id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** columns and relationships of "online_screening_tickets" */
export type Online_Screening_Tickets = {
  __typename?: 'online_screening_tickets';
  barcode: Scalars['String'];
  created_at: Scalars['timestamptz'];
  email: Scalars['String'];
  event_id: Scalars['String'];
  full_name: Scalars['String'];
  id: Scalars['Int'];
  ticket_type_id: Scalars['String'];
  tt_id: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  voided_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "online_screening_tickets" */
export type Online_Screening_Tickets_Aggregate = {
  __typename?: 'online_screening_tickets_aggregate';
  aggregate?: Maybe<Online_Screening_Tickets_Aggregate_Fields>;
  nodes: Array<Online_Screening_Tickets>;
};

export type Online_Screening_Tickets_Aggregate_Bool_Exp = {
  count?: InputMaybe<Online_Screening_Tickets_Aggregate_Bool_Exp_Count>;
};

export type Online_Screening_Tickets_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Online_Screening_Tickets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Online_Screening_Tickets_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "online_screening_tickets" */
export type Online_Screening_Tickets_Aggregate_Fields = {
  __typename?: 'online_screening_tickets_aggregate_fields';
  avg?: Maybe<Online_Screening_Tickets_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Online_Screening_Tickets_Max_Fields>;
  min?: Maybe<Online_Screening_Tickets_Min_Fields>;
  stddev?: Maybe<Online_Screening_Tickets_Stddev_Fields>;
  stddev_pop?: Maybe<Online_Screening_Tickets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Online_Screening_Tickets_Stddev_Samp_Fields>;
  sum?: Maybe<Online_Screening_Tickets_Sum_Fields>;
  var_pop?: Maybe<Online_Screening_Tickets_Var_Pop_Fields>;
  var_samp?: Maybe<Online_Screening_Tickets_Var_Samp_Fields>;
  variance?: Maybe<Online_Screening_Tickets_Variance_Fields>;
};


/** aggregate fields of "online_screening_tickets" */
export type Online_Screening_Tickets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Online_Screening_Tickets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "online_screening_tickets" */
export type Online_Screening_Tickets_Aggregate_Order_By = {
  avg?: InputMaybe<Online_Screening_Tickets_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Online_Screening_Tickets_Max_Order_By>;
  min?: InputMaybe<Online_Screening_Tickets_Min_Order_By>;
  stddev?: InputMaybe<Online_Screening_Tickets_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Online_Screening_Tickets_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Online_Screening_Tickets_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Online_Screening_Tickets_Sum_Order_By>;
  var_pop?: InputMaybe<Online_Screening_Tickets_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Online_Screening_Tickets_Var_Samp_Order_By>;
  variance?: InputMaybe<Online_Screening_Tickets_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "online_screening_tickets" */
export type Online_Screening_Tickets_Arr_Rel_Insert_Input = {
  data: Array<Online_Screening_Tickets_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Online_Screening_Tickets_On_Conflict>;
};

/** aggregate avg on columns */
export type Online_Screening_Tickets_Avg_Fields = {
  __typename?: 'online_screening_tickets_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "online_screening_tickets" */
export type Online_Screening_Tickets_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "online_screening_tickets". All fields are combined with a logical 'AND'. */
export type Online_Screening_Tickets_Bool_Exp = {
  _and?: InputMaybe<Array<Online_Screening_Tickets_Bool_Exp>>;
  _not?: InputMaybe<Online_Screening_Tickets_Bool_Exp>;
  _or?: InputMaybe<Array<Online_Screening_Tickets_Bool_Exp>>;
  barcode?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  event_id?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  ticket_type_id?: InputMaybe<String_Comparison_Exp>;
  tt_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  voided_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "online_screening_tickets" */
export enum Online_Screening_Tickets_Constraint {
  /** unique or primary key constraint on columns "id" */
  OnlineScreeningTicketsPkey = 'online_screening_tickets_pkey'
}

/** input type for incrementing numeric columns in table "online_screening_tickets" */
export type Online_Screening_Tickets_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "online_screening_tickets" */
export type Online_Screening_Tickets_Insert_Input = {
  barcode?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  event_id?: InputMaybe<Scalars['String']>;
  full_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  ticket_type_id?: InputMaybe<Scalars['String']>;
  tt_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  voided_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Online_Screening_Tickets_Max_Fields = {
  __typename?: 'online_screening_tickets_max_fields';
  barcode?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  event_id?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  ticket_type_id?: Maybe<Scalars['String']>;
  tt_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  voided_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "online_screening_tickets" */
export type Online_Screening_Tickets_Max_Order_By = {
  barcode?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ticket_type_id?: InputMaybe<Order_By>;
  tt_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  voided_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Online_Screening_Tickets_Min_Fields = {
  __typename?: 'online_screening_tickets_min_fields';
  barcode?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  event_id?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  ticket_type_id?: Maybe<Scalars['String']>;
  tt_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  voided_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "online_screening_tickets" */
export type Online_Screening_Tickets_Min_Order_By = {
  barcode?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ticket_type_id?: InputMaybe<Order_By>;
  tt_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  voided_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "online_screening_tickets" */
export type Online_Screening_Tickets_Mutation_Response = {
  __typename?: 'online_screening_tickets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Online_Screening_Tickets>;
};

/** on_conflict condition type for table "online_screening_tickets" */
export type Online_Screening_Tickets_On_Conflict = {
  constraint: Online_Screening_Tickets_Constraint;
  update_columns?: Array<Online_Screening_Tickets_Update_Column>;
  where?: InputMaybe<Online_Screening_Tickets_Bool_Exp>;
};

/** Ordering options when selecting data from "online_screening_tickets". */
export type Online_Screening_Tickets_Order_By = {
  barcode?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ticket_type_id?: InputMaybe<Order_By>;
  tt_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  voided_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: online_screening_tickets */
export type Online_Screening_Tickets_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "online_screening_tickets" */
export enum Online_Screening_Tickets_Select_Column {
  /** column name */
  Barcode = 'barcode',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  EventId = 'event_id',
  /** column name */
  FullName = 'full_name',
  /** column name */
  Id = 'id',
  /** column name */
  TicketTypeId = 'ticket_type_id',
  /** column name */
  TtId = 'tt_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VoidedAt = 'voided_at'
}

/** input type for updating data in table "online_screening_tickets" */
export type Online_Screening_Tickets_Set_Input = {
  barcode?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  event_id?: InputMaybe<Scalars['String']>;
  full_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  ticket_type_id?: InputMaybe<Scalars['String']>;
  tt_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  voided_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Online_Screening_Tickets_Stddev_Fields = {
  __typename?: 'online_screening_tickets_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "online_screening_tickets" */
export type Online_Screening_Tickets_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Online_Screening_Tickets_Stddev_Pop_Fields = {
  __typename?: 'online_screening_tickets_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "online_screening_tickets" */
export type Online_Screening_Tickets_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Online_Screening_Tickets_Stddev_Samp_Fields = {
  __typename?: 'online_screening_tickets_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "online_screening_tickets" */
export type Online_Screening_Tickets_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "online_screening_tickets" */
export type Online_Screening_Tickets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Online_Screening_Tickets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Online_Screening_Tickets_Stream_Cursor_Value_Input = {
  barcode?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  event_id?: InputMaybe<Scalars['String']>;
  full_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  ticket_type_id?: InputMaybe<Scalars['String']>;
  tt_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  voided_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Online_Screening_Tickets_Sum_Fields = {
  __typename?: 'online_screening_tickets_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "online_screening_tickets" */
export type Online_Screening_Tickets_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "online_screening_tickets" */
export enum Online_Screening_Tickets_Update_Column {
  /** column name */
  Barcode = 'barcode',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  EventId = 'event_id',
  /** column name */
  FullName = 'full_name',
  /** column name */
  Id = 'id',
  /** column name */
  TicketTypeId = 'ticket_type_id',
  /** column name */
  TtId = 'tt_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VoidedAt = 'voided_at'
}

export type Online_Screening_Tickets_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Online_Screening_Tickets_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Online_Screening_Tickets_Set_Input>;
  /** filter the rows which have to be updated */
  where: Online_Screening_Tickets_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Online_Screening_Tickets_Var_Pop_Fields = {
  __typename?: 'online_screening_tickets_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "online_screening_tickets" */
export type Online_Screening_Tickets_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Online_Screening_Tickets_Var_Samp_Fields = {
  __typename?: 'online_screening_tickets_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "online_screening_tickets" */
export type Online_Screening_Tickets_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Online_Screening_Tickets_Variance_Fields = {
  __typename?: 'online_screening_tickets_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "online_screening_tickets" */
export type Online_Screening_Tickets_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "payments" */
export type Payments = {
  __typename?: 'payments';
  amount: Scalars['numeric'];
  created: Scalars['timestamp'];
  created_by: Scalars['String'];
  id: Scalars['numeric'];
  method?: Maybe<Scalars['String']>;
  refunded_at?: Maybe<Scalars['timestamp']>;
  stripe_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  team: Teams;
  team_id: Scalars['numeric'];
  updated: Scalars['timestamp'];
  updated_by: Scalars['String'];
};

/** aggregated selection of "payments" */
export type Payments_Aggregate = {
  __typename?: 'payments_aggregate';
  aggregate?: Maybe<Payments_Aggregate_Fields>;
  nodes: Array<Payments>;
};

export type Payments_Aggregate_Bool_Exp = {
  count?: InputMaybe<Payments_Aggregate_Bool_Exp_Count>;
};

export type Payments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Payments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Payments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "payments" */
export type Payments_Aggregate_Fields = {
  __typename?: 'payments_aggregate_fields';
  avg?: Maybe<Payments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Payments_Max_Fields>;
  min?: Maybe<Payments_Min_Fields>;
  stddev?: Maybe<Payments_Stddev_Fields>;
  stddev_pop?: Maybe<Payments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Payments_Stddev_Samp_Fields>;
  sum?: Maybe<Payments_Sum_Fields>;
  var_pop?: Maybe<Payments_Var_Pop_Fields>;
  var_samp?: Maybe<Payments_Var_Samp_Fields>;
  variance?: Maybe<Payments_Variance_Fields>;
};


/** aggregate fields of "payments" */
export type Payments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "payments" */
export type Payments_Aggregate_Order_By = {
  avg?: InputMaybe<Payments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Payments_Max_Order_By>;
  min?: InputMaybe<Payments_Min_Order_By>;
  stddev?: InputMaybe<Payments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Payments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Payments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Payments_Sum_Order_By>;
  var_pop?: InputMaybe<Payments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Payments_Var_Samp_Order_By>;
  variance?: InputMaybe<Payments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "payments" */
export type Payments_Arr_Rel_Insert_Input = {
  data: Array<Payments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Payments_On_Conflict>;
};

/** aggregate avg on columns */
export type Payments_Avg_Fields = {
  __typename?: 'payments_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "payments" */
export type Payments_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "payments". All fields are combined with a logical 'AND'. */
export type Payments_Bool_Exp = {
  _and?: InputMaybe<Array<Payments_Bool_Exp>>;
  _not?: InputMaybe<Payments_Bool_Exp>;
  _or?: InputMaybe<Array<Payments_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  created?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Numeric_Comparison_Exp>;
  method?: InputMaybe<String_Comparison_Exp>;
  refunded_at?: InputMaybe<Timestamp_Comparison_Exp>;
  stripe_id?: InputMaybe<String_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Numeric_Comparison_Exp>;
  updated?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "payments" */
export enum Payments_Constraint {
  /** unique or primary key constraint on columns "id" */
  PaymentsPkey = 'payments_pkey',
  /** unique or primary key constraint on columns "stripe_id" */
  PaymentsStripeIdKey = 'payments_stripe_id_key'
}

/** input type for incrementing numeric columns in table "payments" */
export type Payments_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['numeric']>;
  team_id?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "payments" */
export type Payments_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  method?: InputMaybe<Scalars['String']>;
  refunded_at?: InputMaybe<Scalars['timestamp']>;
  stripe_id?: InputMaybe<Scalars['String']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Payments_Max_Fields = {
  __typename?: 'payments_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  method?: Maybe<Scalars['String']>;
  refunded_at?: Maybe<Scalars['timestamp']>;
  stripe_id?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "payments" */
export type Payments_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  method?: InputMaybe<Order_By>;
  refunded_at?: InputMaybe<Order_By>;
  stripe_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Payments_Min_Fields = {
  __typename?: 'payments_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  method?: Maybe<Scalars['String']>;
  refunded_at?: Maybe<Scalars['timestamp']>;
  stripe_id?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "payments" */
export type Payments_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  method?: InputMaybe<Order_By>;
  refunded_at?: InputMaybe<Order_By>;
  stripe_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "payments" */
export type Payments_Mutation_Response = {
  __typename?: 'payments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Payments>;
};

/** on_conflict condition type for table "payments" */
export type Payments_On_Conflict = {
  constraint: Payments_Constraint;
  update_columns?: Array<Payments_Update_Column>;
  where?: InputMaybe<Payments_Bool_Exp>;
};

/** Ordering options when selecting data from "payments". */
export type Payments_Order_By = {
  amount?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  method?: InputMaybe<Order_By>;
  refunded_at?: InputMaybe<Order_By>;
  stripe_id?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: payments */
export type Payments_Pk_Columns_Input = {
  id: Scalars['numeric'];
};

/** select columns of table "payments" */
export enum Payments_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Method = 'method',
  /** column name */
  RefundedAt = 'refunded_at',
  /** column name */
  StripeId = 'stripe_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** input type for updating data in table "payments" */
export type Payments_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  method?: InputMaybe<Scalars['String']>;
  refunded_at?: InputMaybe<Scalars['timestamp']>;
  stripe_id?: InputMaybe<Scalars['String']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Payments_Stddev_Fields = {
  __typename?: 'payments_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "payments" */
export type Payments_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Payments_Stddev_Pop_Fields = {
  __typename?: 'payments_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "payments" */
export type Payments_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Payments_Stddev_Samp_Fields = {
  __typename?: 'payments_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "payments" */
export type Payments_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "payments" */
export type Payments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Payments_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  method?: InputMaybe<Scalars['String']>;
  refunded_at?: InputMaybe<Scalars['timestamp']>;
  stripe_id?: InputMaybe<Scalars['String']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Payments_Sum_Fields = {
  __typename?: 'payments_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['numeric']>;
  team_id?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "payments" */
export type Payments_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** update columns of table "payments" */
export enum Payments_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Method = 'method',
  /** column name */
  RefundedAt = 'refunded_at',
  /** column name */
  StripeId = 'stripe_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by'
}

export type Payments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Payments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Payments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Payments_Var_Pop_Fields = {
  __typename?: 'payments_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "payments" */
export type Payments_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Payments_Var_Samp_Fields = {
  __typename?: 'payments_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "payments" */
export type Payments_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Payments_Variance_Fields = {
  __typename?: 'payments_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "payments" */
export type Payments_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "playlist_team" */
export type Playlist_Team = {
  __typename?: 'playlist_team';
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  /** An object relationship */
  playlist: Playlists;
  playlist_id: Scalars['Int'];
  sort: Scalars['Int'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "playlist_team" */
export type Playlist_Team_Aggregate = {
  __typename?: 'playlist_team_aggregate';
  aggregate?: Maybe<Playlist_Team_Aggregate_Fields>;
  nodes: Array<Playlist_Team>;
};

export type Playlist_Team_Aggregate_Bool_Exp = {
  count?: InputMaybe<Playlist_Team_Aggregate_Bool_Exp_Count>;
};

export type Playlist_Team_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Playlist_Team_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Playlist_Team_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "playlist_team" */
export type Playlist_Team_Aggregate_Fields = {
  __typename?: 'playlist_team_aggregate_fields';
  avg?: Maybe<Playlist_Team_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Playlist_Team_Max_Fields>;
  min?: Maybe<Playlist_Team_Min_Fields>;
  stddev?: Maybe<Playlist_Team_Stddev_Fields>;
  stddev_pop?: Maybe<Playlist_Team_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Playlist_Team_Stddev_Samp_Fields>;
  sum?: Maybe<Playlist_Team_Sum_Fields>;
  var_pop?: Maybe<Playlist_Team_Var_Pop_Fields>;
  var_samp?: Maybe<Playlist_Team_Var_Samp_Fields>;
  variance?: Maybe<Playlist_Team_Variance_Fields>;
};


/** aggregate fields of "playlist_team" */
export type Playlist_Team_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Playlist_Team_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "playlist_team" */
export type Playlist_Team_Aggregate_Order_By = {
  avg?: InputMaybe<Playlist_Team_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Playlist_Team_Max_Order_By>;
  min?: InputMaybe<Playlist_Team_Min_Order_By>;
  stddev?: InputMaybe<Playlist_Team_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Playlist_Team_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Playlist_Team_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Playlist_Team_Sum_Order_By>;
  var_pop?: InputMaybe<Playlist_Team_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Playlist_Team_Var_Samp_Order_By>;
  variance?: InputMaybe<Playlist_Team_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "playlist_team" */
export type Playlist_Team_Arr_Rel_Insert_Input = {
  data: Array<Playlist_Team_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Playlist_Team_On_Conflict>;
};

/** aggregate avg on columns */
export type Playlist_Team_Avg_Fields = {
  __typename?: 'playlist_team_avg_fields';
  id?: Maybe<Scalars['Float']>;
  playlist_id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "playlist_team" */
export type Playlist_Team_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  playlist_id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "playlist_team". All fields are combined with a logical 'AND'. */
export type Playlist_Team_Bool_Exp = {
  _and?: InputMaybe<Array<Playlist_Team_Bool_Exp>>;
  _not?: InputMaybe<Playlist_Team_Bool_Exp>;
  _or?: InputMaybe<Array<Playlist_Team_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  playlist?: InputMaybe<Playlists_Bool_Exp>;
  playlist_id?: InputMaybe<Int_Comparison_Exp>;
  sort?: InputMaybe<Int_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "playlist_team" */
export enum Playlist_Team_Constraint {
  /** unique or primary key constraint on columns "id" */
  PlaylistTeamPkey = 'playlist_team_pkey',
  /** unique or primary key constraint on columns "playlist_id", "sort" */
  PlaylistTeamPlaylistIdSortKey = 'playlist_team_playlist_id_sort_key'
}

/** input type for incrementing numeric columns in table "playlist_team" */
export type Playlist_Team_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  playlist_id?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "playlist_team" */
export type Playlist_Team_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  playlist?: InputMaybe<Playlists_Obj_Rel_Insert_Input>;
  playlist_id?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['Int']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Playlist_Team_Max_Fields = {
  __typename?: 'playlist_team_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  playlist_id?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "playlist_team" */
export type Playlist_Team_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  playlist_id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Playlist_Team_Min_Fields = {
  __typename?: 'playlist_team_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  playlist_id?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "playlist_team" */
export type Playlist_Team_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  playlist_id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "playlist_team" */
export type Playlist_Team_Mutation_Response = {
  __typename?: 'playlist_team_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Playlist_Team>;
};

/** on_conflict condition type for table "playlist_team" */
export type Playlist_Team_On_Conflict = {
  constraint: Playlist_Team_Constraint;
  update_columns?: Array<Playlist_Team_Update_Column>;
  where?: InputMaybe<Playlist_Team_Bool_Exp>;
};

/** Ordering options when selecting data from "playlist_team". */
export type Playlist_Team_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  playlist?: InputMaybe<Playlists_Order_By>;
  playlist_id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: playlist_team */
export type Playlist_Team_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "playlist_team" */
export enum Playlist_Team_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PlaylistId = 'playlist_id',
  /** column name */
  Sort = 'sort',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "playlist_team" */
export type Playlist_Team_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  playlist_id?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Playlist_Team_Stddev_Fields = {
  __typename?: 'playlist_team_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  playlist_id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "playlist_team" */
export type Playlist_Team_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  playlist_id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Playlist_Team_Stddev_Pop_Fields = {
  __typename?: 'playlist_team_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  playlist_id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "playlist_team" */
export type Playlist_Team_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  playlist_id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Playlist_Team_Stddev_Samp_Fields = {
  __typename?: 'playlist_team_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  playlist_id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "playlist_team" */
export type Playlist_Team_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  playlist_id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "playlist_team" */
export type Playlist_Team_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Playlist_Team_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Playlist_Team_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  playlist_id?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Playlist_Team_Sum_Fields = {
  __typename?: 'playlist_team_sum_fields';
  id?: Maybe<Scalars['Int']>;
  playlist_id?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "playlist_team" */
export type Playlist_Team_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  playlist_id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** update columns of table "playlist_team" */
export enum Playlist_Team_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PlaylistId = 'playlist_id',
  /** column name */
  Sort = 'sort',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Playlist_Team_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Playlist_Team_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Playlist_Team_Set_Input>;
  /** filter the rows which have to be updated */
  where: Playlist_Team_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Playlist_Team_Var_Pop_Fields = {
  __typename?: 'playlist_team_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  playlist_id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "playlist_team" */
export type Playlist_Team_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  playlist_id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Playlist_Team_Var_Samp_Fields = {
  __typename?: 'playlist_team_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  playlist_id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "playlist_team" */
export type Playlist_Team_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  playlist_id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Playlist_Team_Variance_Fields = {
  __typename?: 'playlist_team_variance_fields';
  id?: Maybe<Scalars['Float']>;
  playlist_id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "playlist_team" */
export type Playlist_Team_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  playlist_id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "playlists" */
export type Playlists = {
  __typename?: 'playlists';
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  instructions: Scalars['String'];
  name: Scalars['String'];
  /** An array relationship */
  teams: Array<Playlist_Team>;
  /** An aggregate relationship */
  teams_aggregate: Playlist_Team_Aggregate;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "playlists" */
export type PlaylistsTeamsArgs = {
  distinct_on?: InputMaybe<Array<Playlist_Team_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Playlist_Team_Order_By>>;
  where?: InputMaybe<Playlist_Team_Bool_Exp>;
};


/** columns and relationships of "playlists" */
export type PlaylistsTeams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Playlist_Team_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Playlist_Team_Order_By>>;
  where?: InputMaybe<Playlist_Team_Bool_Exp>;
};

/** aggregated selection of "playlists" */
export type Playlists_Aggregate = {
  __typename?: 'playlists_aggregate';
  aggregate?: Maybe<Playlists_Aggregate_Fields>;
  nodes: Array<Playlists>;
};

/** aggregate fields of "playlists" */
export type Playlists_Aggregate_Fields = {
  __typename?: 'playlists_aggregate_fields';
  avg?: Maybe<Playlists_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Playlists_Max_Fields>;
  min?: Maybe<Playlists_Min_Fields>;
  stddev?: Maybe<Playlists_Stddev_Fields>;
  stddev_pop?: Maybe<Playlists_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Playlists_Stddev_Samp_Fields>;
  sum?: Maybe<Playlists_Sum_Fields>;
  var_pop?: Maybe<Playlists_Var_Pop_Fields>;
  var_samp?: Maybe<Playlists_Var_Samp_Fields>;
  variance?: Maybe<Playlists_Variance_Fields>;
};


/** aggregate fields of "playlists" */
export type Playlists_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Playlists_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Playlists_Avg_Fields = {
  __typename?: 'playlists_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "playlists". All fields are combined with a logical 'AND'. */
export type Playlists_Bool_Exp = {
  _and?: InputMaybe<Array<Playlists_Bool_Exp>>;
  _not?: InputMaybe<Playlists_Bool_Exp>;
  _or?: InputMaybe<Array<Playlists_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  instructions?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  teams?: InputMaybe<Playlist_Team_Bool_Exp>;
  teams_aggregate?: InputMaybe<Playlist_Team_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "playlists" */
export enum Playlists_Constraint {
  /** unique or primary key constraint on columns "id" */
  PlaylistsPkey = 'playlists_pkey'
}

/** input type for incrementing numeric columns in table "playlists" */
export type Playlists_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "playlists" */
export type Playlists_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  instructions?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  teams?: InputMaybe<Playlist_Team_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Playlists_Max_Fields = {
  __typename?: 'playlists_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  instructions?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Playlists_Min_Fields = {
  __typename?: 'playlists_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  instructions?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "playlists" */
export type Playlists_Mutation_Response = {
  __typename?: 'playlists_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Playlists>;
};

/** input type for inserting object relation for remote table "playlists" */
export type Playlists_Obj_Rel_Insert_Input = {
  data: Playlists_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Playlists_On_Conflict>;
};

/** on_conflict condition type for table "playlists" */
export type Playlists_On_Conflict = {
  constraint: Playlists_Constraint;
  update_columns?: Array<Playlists_Update_Column>;
  where?: InputMaybe<Playlists_Bool_Exp>;
};

/** Ordering options when selecting data from "playlists". */
export type Playlists_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instructions?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  teams_aggregate?: InputMaybe<Playlist_Team_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: playlists */
export type Playlists_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "playlists" */
export enum Playlists_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Instructions = 'instructions',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "playlists" */
export type Playlists_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  instructions?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Playlists_Stddev_Fields = {
  __typename?: 'playlists_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Playlists_Stddev_Pop_Fields = {
  __typename?: 'playlists_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Playlists_Stddev_Samp_Fields = {
  __typename?: 'playlists_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "playlists" */
export type Playlists_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Playlists_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Playlists_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  instructions?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Playlists_Sum_Fields = {
  __typename?: 'playlists_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "playlists" */
export enum Playlists_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Instructions = 'instructions',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Playlists_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Playlists_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Playlists_Set_Input>;
  /** filter the rows which have to be updated */
  where: Playlists_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Playlists_Var_Pop_Fields = {
  __typename?: 'playlists_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Playlists_Var_Samp_Fields = {
  __typename?: 'playlists_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Playlists_Variance_Fields = {
  __typename?: 'playlists_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "prize_elections" */
export type Prize_Elections = {
  __typename?: 'prize_elections';
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  prize?: Maybe<Prizes>;
  prize_id?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  team?: Maybe<Teams>;
  team_id?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** aggregated selection of "prize_elections" */
export type Prize_Elections_Aggregate = {
  __typename?: 'prize_elections_aggregate';
  aggregate?: Maybe<Prize_Elections_Aggregate_Fields>;
  nodes: Array<Prize_Elections>;
};

export type Prize_Elections_Aggregate_Bool_Exp = {
  count?: InputMaybe<Prize_Elections_Aggregate_Bool_Exp_Count>;
};

export type Prize_Elections_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Prize_Elections_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Prize_Elections_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "prize_elections" */
export type Prize_Elections_Aggregate_Fields = {
  __typename?: 'prize_elections_aggregate_fields';
  avg?: Maybe<Prize_Elections_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Prize_Elections_Max_Fields>;
  min?: Maybe<Prize_Elections_Min_Fields>;
  stddev?: Maybe<Prize_Elections_Stddev_Fields>;
  stddev_pop?: Maybe<Prize_Elections_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Prize_Elections_Stddev_Samp_Fields>;
  sum?: Maybe<Prize_Elections_Sum_Fields>;
  var_pop?: Maybe<Prize_Elections_Var_Pop_Fields>;
  var_samp?: Maybe<Prize_Elections_Var_Samp_Fields>;
  variance?: Maybe<Prize_Elections_Variance_Fields>;
};


/** aggregate fields of "prize_elections" */
export type Prize_Elections_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Prize_Elections_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "prize_elections" */
export type Prize_Elections_Aggregate_Order_By = {
  avg?: InputMaybe<Prize_Elections_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Prize_Elections_Max_Order_By>;
  min?: InputMaybe<Prize_Elections_Min_Order_By>;
  stddev?: InputMaybe<Prize_Elections_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Prize_Elections_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Prize_Elections_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Prize_Elections_Sum_Order_By>;
  var_pop?: InputMaybe<Prize_Elections_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Prize_Elections_Var_Samp_Order_By>;
  variance?: InputMaybe<Prize_Elections_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "prize_elections" */
export type Prize_Elections_Arr_Rel_Insert_Input = {
  data: Array<Prize_Elections_Insert_Input>;
};

/** aggregate avg on columns */
export type Prize_Elections_Avg_Fields = {
  __typename?: 'prize_elections_avg_fields';
  id?: Maybe<Scalars['Float']>;
  prize_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "prize_elections" */
export type Prize_Elections_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "prize_elections". All fields are combined with a logical 'AND'. */
export type Prize_Elections_Bool_Exp = {
  _and?: InputMaybe<Array<Prize_Elections_Bool_Exp>>;
  _not?: InputMaybe<Prize_Elections_Bool_Exp>;
  _or?: InputMaybe<Array<Prize_Elections_Bool_Exp>>;
  created?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Numeric_Comparison_Exp>;
  prize?: InputMaybe<Prizes_Bool_Exp>;
  prize_id?: InputMaybe<Numeric_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Numeric_Comparison_Exp>;
  updated?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "prize_elections" */
export type Prize_Elections_Inc_Input = {
  id?: InputMaybe<Scalars['numeric']>;
  prize_id?: InputMaybe<Scalars['numeric']>;
  team_id?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "prize_elections" */
export type Prize_Elections_Insert_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  prize?: InputMaybe<Prizes_Obj_Rel_Insert_Input>;
  prize_id?: InputMaybe<Scalars['numeric']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Prize_Elections_Max_Fields = {
  __typename?: 'prize_elections_max_fields';
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  prize_id?: Maybe<Scalars['numeric']>;
  team_id?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "prize_elections" */
export type Prize_Elections_Max_Order_By = {
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Prize_Elections_Min_Fields = {
  __typename?: 'prize_elections_min_fields';
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  prize_id?: Maybe<Scalars['numeric']>;
  team_id?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "prize_elections" */
export type Prize_Elections_Min_Order_By = {
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "prize_elections" */
export type Prize_Elections_Mutation_Response = {
  __typename?: 'prize_elections_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Prize_Elections>;
};

/** Ordering options when selecting data from "prize_elections". */
export type Prize_Elections_Order_By = {
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  prize?: InputMaybe<Prizes_Order_By>;
  prize_id?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** select columns of table "prize_elections" */
export enum Prize_Elections_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  PrizeId = 'prize_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** input type for updating data in table "prize_elections" */
export type Prize_Elections_Set_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  prize_id?: InputMaybe<Scalars['numeric']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Prize_Elections_Stddev_Fields = {
  __typename?: 'prize_elections_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  prize_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "prize_elections" */
export type Prize_Elections_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Prize_Elections_Stddev_Pop_Fields = {
  __typename?: 'prize_elections_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  prize_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "prize_elections" */
export type Prize_Elections_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Prize_Elections_Stddev_Samp_Fields = {
  __typename?: 'prize_elections_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  prize_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "prize_elections" */
export type Prize_Elections_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "prize_elections" */
export type Prize_Elections_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Prize_Elections_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Prize_Elections_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  prize_id?: InputMaybe<Scalars['numeric']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Prize_Elections_Sum_Fields = {
  __typename?: 'prize_elections_sum_fields';
  id?: Maybe<Scalars['numeric']>;
  prize_id?: Maybe<Scalars['numeric']>;
  team_id?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "prize_elections" */
export type Prize_Elections_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

export type Prize_Elections_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Prize_Elections_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Prize_Elections_Set_Input>;
  /** filter the rows which have to be updated */
  where: Prize_Elections_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Prize_Elections_Var_Pop_Fields = {
  __typename?: 'prize_elections_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  prize_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "prize_elections" */
export type Prize_Elections_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Prize_Elections_Var_Samp_Fields = {
  __typename?: 'prize_elections_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  prize_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "prize_elections" */
export type Prize_Elections_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Prize_Elections_Variance_Fields = {
  __typename?: 'prize_elections_variance_fields';
  id?: Maybe<Scalars['Float']>;
  prize_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "prize_elections" */
export type Prize_Elections_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  prize_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "prizes" */
export type Prizes = {
  __typename?: 'prizes';
  created: Scalars['timestamp'];
  created_by: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  film_festival_id: Scalars['numeric'];
  id: Scalars['numeric'];
  mux_asset_id?: Maybe<Scalars['String']>;
  mux_playback_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  nominations: Array<Nominations>;
  /** An aggregate relationship */
  nominations_aggregate: Nominations_Aggregate;
  /** An object relationship */
  sponsor?: Maybe<Sponsors>;
  sponsored_by?: Maybe<Scalars['numeric']>;
  updated: Scalars['timestamp'];
  updated_by: Scalars['String'];
};


/** columns and relationships of "prizes" */
export type PrizesNominationsArgs = {
  distinct_on?: InputMaybe<Array<Nominations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nominations_Order_By>>;
  where?: InputMaybe<Nominations_Bool_Exp>;
};


/** columns and relationships of "prizes" */
export type PrizesNominations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nominations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nominations_Order_By>>;
  where?: InputMaybe<Nominations_Bool_Exp>;
};

/** aggregated selection of "prizes" */
export type Prizes_Aggregate = {
  __typename?: 'prizes_aggregate';
  aggregate?: Maybe<Prizes_Aggregate_Fields>;
  nodes: Array<Prizes>;
};

/** aggregate fields of "prizes" */
export type Prizes_Aggregate_Fields = {
  __typename?: 'prizes_aggregate_fields';
  avg?: Maybe<Prizes_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Prizes_Max_Fields>;
  min?: Maybe<Prizes_Min_Fields>;
  stddev?: Maybe<Prizes_Stddev_Fields>;
  stddev_pop?: Maybe<Prizes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Prizes_Stddev_Samp_Fields>;
  sum?: Maybe<Prizes_Sum_Fields>;
  var_pop?: Maybe<Prizes_Var_Pop_Fields>;
  var_samp?: Maybe<Prizes_Var_Samp_Fields>;
  variance?: Maybe<Prizes_Variance_Fields>;
};


/** aggregate fields of "prizes" */
export type Prizes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Prizes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Prizes_Avg_Fields = {
  __typename?: 'prizes_avg_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sponsored_by?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "prizes". All fields are combined with a logical 'AND'. */
export type Prizes_Bool_Exp = {
  _and?: InputMaybe<Array<Prizes_Bool_Exp>>;
  _not?: InputMaybe<Prizes_Bool_Exp>;
  _or?: InputMaybe<Array<Prizes_Bool_Exp>>;
  created?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  film_festival_id?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Numeric_Comparison_Exp>;
  mux_asset_id?: InputMaybe<String_Comparison_Exp>;
  mux_playback_id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  nominations?: InputMaybe<Nominations_Bool_Exp>;
  nominations_aggregate?: InputMaybe<Nominations_Aggregate_Bool_Exp>;
  sponsor?: InputMaybe<Sponsors_Bool_Exp>;
  sponsored_by?: InputMaybe<Numeric_Comparison_Exp>;
  updated?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "prizes" */
export enum Prizes_Constraint {
  /** unique or primary key constraint on columns "id" */
  PrizesPkey = 'prizes_pkey'
}

/** input type for incrementing numeric columns in table "prizes" */
export type Prizes_Inc_Input = {
  film_festival_id?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['numeric']>;
  sponsored_by?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "prizes" */
export type Prizes_Insert_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  film_festival_id?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['numeric']>;
  mux_asset_id?: InputMaybe<Scalars['String']>;
  mux_playback_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nominations?: InputMaybe<Nominations_Arr_Rel_Insert_Input>;
  sponsor?: InputMaybe<Sponsors_Obj_Rel_Insert_Input>;
  sponsored_by?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Prizes_Max_Fields = {
  __typename?: 'prizes_max_fields';
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  film_festival_id?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['numeric']>;
  mux_asset_id?: Maybe<Scalars['String']>;
  mux_playback_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sponsored_by?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Prizes_Min_Fields = {
  __typename?: 'prizes_min_fields';
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  film_festival_id?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['numeric']>;
  mux_asset_id?: Maybe<Scalars['String']>;
  mux_playback_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sponsored_by?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "prizes" */
export type Prizes_Mutation_Response = {
  __typename?: 'prizes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Prizes>;
};

/** input type for inserting object relation for remote table "prizes" */
export type Prizes_Obj_Rel_Insert_Input = {
  data: Prizes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Prizes_On_Conflict>;
};

/** on_conflict condition type for table "prizes" */
export type Prizes_On_Conflict = {
  constraint: Prizes_Constraint;
  update_columns?: Array<Prizes_Update_Column>;
  where?: InputMaybe<Prizes_Bool_Exp>;
};

/** Ordering options when selecting data from "prizes". */
export type Prizes_Order_By = {
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mux_asset_id?: InputMaybe<Order_By>;
  mux_playback_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  nominations_aggregate?: InputMaybe<Nominations_Aggregate_Order_By>;
  sponsor?: InputMaybe<Sponsors_Order_By>;
  sponsored_by?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: prizes */
export type Prizes_Pk_Columns_Input = {
  id: Scalars['numeric'];
};

/** select columns of table "prizes" */
export enum Prizes_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  FilmFestivalId = 'film_festival_id',
  /** column name */
  Id = 'id',
  /** column name */
  MuxAssetId = 'mux_asset_id',
  /** column name */
  MuxPlaybackId = 'mux_playback_id',
  /** column name */
  Name = 'name',
  /** column name */
  SponsoredBy = 'sponsored_by',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** input type for updating data in table "prizes" */
export type Prizes_Set_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  film_festival_id?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['numeric']>;
  mux_asset_id?: InputMaybe<Scalars['String']>;
  mux_playback_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sponsored_by?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Prizes_Stddev_Fields = {
  __typename?: 'prizes_stddev_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sponsored_by?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Prizes_Stddev_Pop_Fields = {
  __typename?: 'prizes_stddev_pop_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sponsored_by?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Prizes_Stddev_Samp_Fields = {
  __typename?: 'prizes_stddev_samp_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sponsored_by?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "prizes" */
export type Prizes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Prizes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Prizes_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  film_festival_id?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['numeric']>;
  mux_asset_id?: InputMaybe<Scalars['String']>;
  mux_playback_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sponsored_by?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Prizes_Sum_Fields = {
  __typename?: 'prizes_sum_fields';
  film_festival_id?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['numeric']>;
  sponsored_by?: Maybe<Scalars['numeric']>;
};

/** update columns of table "prizes" */
export enum Prizes_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  FilmFestivalId = 'film_festival_id',
  /** column name */
  Id = 'id',
  /** column name */
  MuxAssetId = 'mux_asset_id',
  /** column name */
  MuxPlaybackId = 'mux_playback_id',
  /** column name */
  Name = 'name',
  /** column name */
  SponsoredBy = 'sponsored_by',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by'
}

export type Prizes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Prizes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Prizes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Prizes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Prizes_Var_Pop_Fields = {
  __typename?: 'prizes_var_pop_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sponsored_by?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Prizes_Var_Samp_Fields = {
  __typename?: 'prizes_var_samp_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sponsored_by?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Prizes_Variance_Fields = {
  __typename?: 'prizes_variance_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sponsored_by?: Maybe<Scalars['Float']>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** An array relationship */
  asset_exports: Array<Asset_Exports>;
  /** An aggregate relationship */
  asset_exports_aggregate: Asset_Exports_Aggregate;
  /** fetch data from the table: "asset_exports" using primary key columns */
  asset_exports_by_pk?: Maybe<Asset_Exports>;
  /** fetch data from the table: "asset_types" */
  asset_types: Array<Asset_Types>;
  /** fetch aggregated fields from the table: "asset_types" */
  asset_types_aggregate: Asset_Types_Aggregate;
  /** fetch data from the table: "asset_types" using primary key columns */
  asset_types_by_pk?: Maybe<Asset_Types>;
  /** fetch data from the table: "audience_favorite_counts" */
  audience_favorite_counts: Array<Audience_Favorite_Counts>;
  /** fetch aggregated fields from the table: "audience_favorite_counts" */
  audience_favorite_counts_aggregate: Audience_Favorite_Counts_Aggregate;
  /** fetch data from the table: "audience_favorite_votes" */
  audience_favorite_votes: Array<Audience_Favorite_Votes>;
  /** fetch aggregated fields from the table: "audience_favorite_votes" */
  audience_favorite_votes_aggregate: Audience_Favorite_Votes_Aggregate;
  /** fetch data from the table: "audience_favorite_votes" using primary key columns */
  audience_favorite_votes_by_pk?: Maybe<Audience_Favorite_Votes>;
  /** fetch data from the table: "award_asset_types" */
  award_asset_types: Array<Award_Asset_Types>;
  /** fetch aggregated fields from the table: "award_asset_types" */
  award_asset_types_aggregate: Award_Asset_Types_Aggregate;
  /** fetch data from the table: "award_asset_types" using primary key columns */
  award_asset_types_by_pk?: Maybe<Award_Asset_Types>;
  /** An array relationship */
  award_nominations: Array<Award_Nominations>;
  /** An aggregate relationship */
  award_nominations_aggregate: Award_Nominations_Aggregate;
  /** fetch data from the table: "award_winners" */
  award_winners: Array<Award_Winners>;
  /** fetch aggregated fields from the table: "award_winners" */
  award_winners_aggregate: Award_Winners_Aggregate;
  /** fetch data from the table: "award_winners" using primary key columns */
  award_winners_by_pk?: Maybe<Award_Winners>;
  /** fetch data from the table: "awards" */
  awards: Array<Awards>;
  /** fetch aggregated fields from the table: "awards" */
  awards_aggregate: Awards_Aggregate;
  /** fetch data from the table: "awards" using primary key columns */
  awards_by_pk?: Maybe<Awards>;
  /** fetch data from the table: "awards_ceremony_checkins" */
  awards_ceremony_checkins: Array<Awards_Ceremony_Checkins>;
  /** fetch aggregated fields from the table: "awards_ceremony_checkins" */
  awards_ceremony_checkins_aggregate: Awards_Ceremony_Checkins_Aggregate;
  /** fetch data from the table: "awards_ceremony_checkins" using primary key columns */
  awards_ceremony_checkins_by_pk?: Maybe<Awards_Ceremony_Checkins>;
  /** fetch data from the table: "countries" */
  countries: Array<Countries>;
  /** fetch aggregated fields from the table: "countries" */
  countries_aggregate: Countries_Aggregate;
  /** fetch data from the table: "countries" using primary key columns */
  countries_by_pk?: Maybe<Countries>;
  /** fetch data from the table: "exit_interview_recordings" */
  exit_interview_recordings: Array<Exit_Interview_Recordings>;
  /** fetch aggregated fields from the table: "exit_interview_recordings" */
  exit_interview_recordings_aggregate: Exit_Interview_Recordings_Aggregate;
  /** fetch data from the table: "exit_interview_recordings" using primary key columns */
  exit_interview_recordings_by_pk?: Maybe<Exit_Interview_Recordings>;
  /** fetch data from the table: "exit_interviews" */
  exit_interviews: Array<Exit_Interviews>;
  /** fetch aggregated fields from the table: "exit_interviews" */
  exit_interviews_aggregate: Exit_Interviews_Aggregate;
  /** fetch data from the table: "exit_interviews" using primary key columns */
  exit_interviews_by_pk?: Maybe<Exit_Interviews>;
  /** fetch data from the table: "expertise" */
  expertise: Array<Expertise>;
  /** fetch aggregated fields from the table: "expertise" */
  expertise_aggregate: Expertise_Aggregate;
  /** fetch data from the table: "expertise" using primary key columns */
  expertise_by_pk?: Maybe<Expertise>;
  /** fetch data from the table: "festival_badge_type_event_type" */
  festival_badge_type_event_type: Array<Festival_Badge_Type_Event_Type>;
  /** fetch aggregated fields from the table: "festival_badge_type_event_type" */
  festival_badge_type_event_type_aggregate: Festival_Badge_Type_Event_Type_Aggregate;
  /** fetch data from the table: "festival_badge_type_event_type" using primary key columns */
  festival_badge_type_event_type_by_pk?: Maybe<Festival_Badge_Type_Event_Type>;
  /** fetch data from the table: "festival_badge_types" */
  festival_badge_types: Array<Festival_Badge_Types>;
  /** fetch aggregated fields from the table: "festival_badge_types" */
  festival_badge_types_aggregate: Festival_Badge_Types_Aggregate;
  /** fetch data from the table: "festival_badge_types" using primary key columns */
  festival_badge_types_by_pk?: Maybe<Festival_Badge_Types>;
  /** An array relationship */
  festival_badges: Array<Festival_Badges>;
  /** An aggregate relationship */
  festival_badges_aggregate: Festival_Badges_Aggregate;
  /** fetch data from the table: "festival_badges" using primary key columns */
  festival_badges_by_pk?: Maybe<Festival_Badges>;
  /** fetch data from the table: "festival_event_locations" */
  festival_event_locations: Array<Festival_Event_Locations>;
  /** fetch aggregated fields from the table: "festival_event_locations" */
  festival_event_locations_aggregate: Festival_Event_Locations_Aggregate;
  /** fetch data from the table: "festival_event_locations" using primary key columns */
  festival_event_locations_by_pk?: Maybe<Festival_Event_Locations>;
  /** fetch data from the table: "festival_event_types" */
  festival_event_types: Array<Festival_Event_Types>;
  /** fetch aggregated fields from the table: "festival_event_types" */
  festival_event_types_aggregate: Festival_Event_Types_Aggregate;
  /** fetch data from the table: "festival_event_types" using primary key columns */
  festival_event_types_by_pk?: Maybe<Festival_Event_Types>;
  /** An array relationship */
  festival_events: Array<Festival_Events>;
  /** An aggregate relationship */
  festival_events_aggregate: Festival_Events_Aggregate;
  /** fetch data from the table: "festival_events" using primary key columns */
  festival_events_by_pk?: Maybe<Festival_Events>;
  /** An array relationship */
  festival_genres: Array<Festival_Genres>;
  /** An aggregate relationship */
  festival_genres_aggregate: Festival_Genres_Aggregate;
  /** fetch data from the table: "festival_genres" using primary key columns */
  festival_genres_by_pk?: Maybe<Festival_Genres>;
  /** fetch data from the table: "festival_submission_assets" */
  festival_submission_assets: Array<Festival_Submission_Assets>;
  /** fetch aggregated fields from the table: "festival_submission_assets" */
  festival_submission_assets_aggregate: Festival_Submission_Assets_Aggregate;
  /** fetch data from the table: "festival_submission_assets" using primary key columns */
  festival_submission_assets_by_pk?: Maybe<Festival_Submission_Assets>;
  /** fetch data from the table: "festival_submission_feedback" */
  festival_submission_feedback: Array<Festival_Submission_Feedback>;
  /** fetch aggregated fields from the table: "festival_submission_feedback" */
  festival_submission_feedback_aggregate: Festival_Submission_Feedback_Aggregate;
  /** fetch data from the table: "festival_submission_feedback" using primary key columns */
  festival_submission_feedback_by_pk?: Maybe<Festival_Submission_Feedback>;
  /** An array relationship */
  festival_submission_vouchers: Array<Festival_Submission_Vouchers>;
  /** An aggregate relationship */
  festival_submission_vouchers_aggregate: Festival_Submission_Vouchers_Aggregate;
  /** fetch data from the table: "festival_submission_vouchers" using primary key columns */
  festival_submission_vouchers_by_pk?: Maybe<Festival_Submission_Vouchers>;
  /** fetch data from the table: "festival_submissions" */
  festival_submissions: Array<Festival_Submissions>;
  /** fetch aggregated fields from the table: "festival_submissions" */
  festival_submissions_aggregate: Festival_Submissions_Aggregate;
  /** fetch data from the table: "festival_submissions" using primary key columns */
  festival_submissions_by_pk?: Maybe<Festival_Submissions>;
  /** An array relationship */
  festival_tickets: Array<Festival_Tickets>;
  /** An aggregate relationship */
  festival_tickets_aggregate: Festival_Tickets_Aggregate;
  /** fetch data from the table: "festival_tickets" using primary key columns */
  festival_tickets_by_pk?: Maybe<Festival_Tickets>;
  fetchedObscuredRegistration?: Maybe<ObscuredRegistration>;
  /** fetch data from the table: "film_festivals" */
  film_festivals: Array<Film_Festivals>;
  /** fetch aggregated fields from the table: "film_festivals" */
  film_festivals_aggregate: Film_Festivals_Aggregate;
  /** fetch data from the table: "film_festivals" using primary key columns */
  film_festivals_by_pk?: Maybe<Film_Festivals>;
  /** fetch data from the table: "film_group_festival_submissions" */
  film_group_festival_submissions: Array<Film_Group_Festival_Submissions>;
  /** fetch aggregated fields from the table: "film_group_festival_submissions" */
  film_group_festival_submissions_aggregate: Film_Group_Festival_Submissions_Aggregate;
  /** fetch data from the table: "film_group_festival_submissions" using primary key columns */
  film_group_festival_submissions_by_pk?: Maybe<Film_Group_Festival_Submissions>;
  /** fetch data from the table: "film_group_films" */
  film_group_films: Array<Film_Group_Films>;
  /** fetch aggregated fields from the table: "film_group_films" */
  film_group_films_aggregate: Film_Group_Films_Aggregate;
  /** fetch data from the table: "film_group_films" using primary key columns */
  film_group_films_by_pk?: Maybe<Film_Group_Films>;
  /** fetch data from the table: "film_group_users" */
  film_group_users: Array<Film_Group_Users>;
  /** fetch aggregated fields from the table: "film_group_users" */
  film_group_users_aggregate: Film_Group_Users_Aggregate;
  /** fetch data from the table: "film_group_users" using primary key columns */
  film_group_users_by_pk?: Maybe<Film_Group_Users>;
  /** fetch data from the table: "film_groups" */
  film_groups: Array<Film_Groups>;
  /** fetch aggregated fields from the table: "film_groups" */
  film_groups_aggregate: Film_Groups_Aggregate;
  /** fetch data from the table: "film_groups" using primary key columns */
  film_groups_by_pk?: Maybe<Film_Groups>;
  /** fetch data from the table: "films" */
  films: Array<Films>;
  /** fetch aggregated fields from the table: "films" */
  films_aggregate: Films_Aggregate;
  /** fetch data from the table: "films" using primary key columns */
  films_by_pk?: Maybe<Films>;
  /** fetch data from the table: "genres" */
  genres: Array<Genres>;
  /** fetch aggregated fields from the table: "genres" */
  genres_aggregate: Genres_Aggregate;
  /** fetch data from the table: "genres" using primary key columns */
  genres_by_pk?: Maybe<Genres>;
  /** fetch data from the table: "kickoff_checkins" */
  kickoff_checkins: Array<Kickoff_Checkins>;
  /** fetch aggregated fields from the table: "kickoff_checkins" */
  kickoff_checkins_aggregate: Kickoff_Checkins_Aggregate;
  /** fetch data from the table: "kickoff_checkins" using primary key columns */
  kickoff_checkins_by_pk?: Maybe<Kickoff_Checkins>;
  /** An array relationship */
  location_releases: Array<Location_Releases>;
  /** An aggregate relationship */
  location_releases_aggregate: Location_Releases_Aggregate;
  /** fetch data from the table: "location_releases" using primary key columns */
  location_releases_by_pk?: Maybe<Location_Releases>;
  /** An array relationship */
  matchup_requests: Array<Matchup_Requests>;
  /** An aggregate relationship */
  matchup_requests_aggregate: Matchup_Requests_Aggregate;
  /** fetch data from the table: "matchup_requests" using primary key columns */
  matchup_requests_by_pk?: Maybe<Matchup_Requests>;
  /** An array relationship */
  music_releases: Array<Music_Releases>;
  /** An aggregate relationship */
  music_releases_aggregate: Music_Releases_Aggregate;
  /** fetch data from the table: "music_releases" using primary key columns */
  music_releases_by_pk?: Maybe<Music_Releases>;
  /** fetch data from the table: "nomination_assets" */
  nomination_assets: Array<Nomination_Assets>;
  /** fetch aggregated fields from the table: "nomination_assets" */
  nomination_assets_aggregate: Nomination_Assets_Aggregate;
  /** fetch data from the table: "nomination_assets" using primary key columns */
  nomination_assets_by_pk?: Maybe<Nomination_Assets>;
  /** An array relationship */
  nominations: Array<Nominations>;
  /** An aggregate relationship */
  nominations_aggregate: Nominations_Aggregate;
  /** fetch data from the table: "nominations" using primary key columns */
  nominations_by_pk?: Maybe<Nominations>;
  /** An array relationship */
  online_screening_tickets: Array<Online_Screening_Tickets>;
  /** An aggregate relationship */
  online_screening_tickets_aggregate: Online_Screening_Tickets_Aggregate;
  /** fetch data from the table: "online_screening_tickets" using primary key columns */
  online_screening_tickets_by_pk?: Maybe<Online_Screening_Tickets>;
  passPublicKey?: Maybe<Scalars['String']>;
  /** An array relationship */
  payments: Array<Payments>;
  /** An aggregate relationship */
  payments_aggregate: Payments_Aggregate;
  /** fetch data from the table: "payments" using primary key columns */
  payments_by_pk?: Maybe<Payments>;
  /** fetch data from the table: "playlist_team" */
  playlist_team: Array<Playlist_Team>;
  /** fetch aggregated fields from the table: "playlist_team" */
  playlist_team_aggregate: Playlist_Team_Aggregate;
  /** fetch data from the table: "playlist_team" using primary key columns */
  playlist_team_by_pk?: Maybe<Playlist_Team>;
  /** fetch data from the table: "playlists" */
  playlists: Array<Playlists>;
  /** fetch aggregated fields from the table: "playlists" */
  playlists_aggregate: Playlists_Aggregate;
  /** fetch data from the table: "playlists" using primary key columns */
  playlists_by_pk?: Maybe<Playlists>;
  /** An array relationship */
  prize_elections: Array<Prize_Elections>;
  /** An aggregate relationship */
  prize_elections_aggregate: Prize_Elections_Aggregate;
  /** fetch data from the table: "prizes" */
  prizes: Array<Prizes>;
  /** fetch aggregated fields from the table: "prizes" */
  prizes_aggregate: Prizes_Aggregate;
  /** fetch data from the table: "prizes" using primary key columns */
  prizes_by_pk?: Maybe<Prizes>;
  /** fetch data from the table: "registrations" */
  registrations: Array<Registrations>;
  /** fetch aggregated fields from the table: "registrations" */
  registrations_aggregate: Registrations_Aggregate;
  /** fetch data from the table: "registrations" using primary key columns */
  registrations_by_pk?: Maybe<Registrations>;
  /** fetch data from the table: "selection_ballots" */
  selection_ballots: Array<Selection_Ballots>;
  /** fetch aggregated fields from the table: "selection_ballots" */
  selection_ballots_aggregate: Selection_Ballots_Aggregate;
  /** fetch data from the table: "selection_ballots" using primary key columns */
  selection_ballots_by_pk?: Maybe<Selection_Ballots>;
  /** fetch data from the table: "selection_feedback" */
  selection_feedback: Array<Selection_Feedback>;
  /** fetch aggregated fields from the table: "selection_feedback" */
  selection_feedback_aggregate: Selection_Feedback_Aggregate;
  /** fetch data from the table: "selection_feedback" using primary key columns */
  selection_feedback_by_pk?: Maybe<Selection_Feedback>;
  /** An array relationship */
  selection_metrics: Array<Selection_Metrics>;
  /** An aggregate relationship */
  selection_metrics_aggregate: Selection_Metrics_Aggregate;
  /** fetch data from the table: "selection_metrics" using primary key columns */
  selection_metrics_by_pk?: Maybe<Selection_Metrics>;
  /** fetch data from the table: "selection_progress" */
  selection_progress: Array<Selection_Progress>;
  /** fetch aggregated fields from the table: "selection_progress" */
  selection_progress_aggregate: Selection_Progress_Aggregate;
  /** fetch data from the table: "selection_progress" using primary key columns */
  selection_progress_by_pk?: Maybe<Selection_Progress>;
  /** fetch data from the table: "selection_results" */
  selection_results: Array<Selection_Results>;
  /** fetch aggregated fields from the table: "selection_results" */
  selection_results_aggregate: Selection_Results_Aggregate;
  /** fetch data from the table: "sharables" */
  sharables: Array<Sharables>;
  /** fetch aggregated fields from the table: "sharables" */
  sharables_aggregate: Sharables_Aggregate;
  /** fetch data from the table: "sharables" using primary key columns */
  sharables_by_pk?: Maybe<Sharables>;
  /** fetch data from the table: "sms_votes" */
  sms_votes: Array<Sms_Votes>;
  /** fetch aggregated fields from the table: "sms_votes" */
  sms_votes_aggregate: Sms_Votes_Aggregate;
  /** fetch data from the table: "sms_votes" using primary key columns */
  sms_votes_by_pk?: Maybe<Sms_Votes>;
  /** An array relationship */
  sponsors: Array<Sponsors>;
  /** An aggregate relationship */
  sponsors_aggregate: Sponsors_Aggregate;
  /** fetch data from the table: "sponsors" using primary key columns */
  sponsors_by_pk?: Maybe<Sponsors>;
  streamGetAuthToken: Scalars['String'];
  streamGetFeedAuthToken: Scalars['String'];
  /** fetch data from the table: "studios" */
  studios: Array<Studios>;
  /** fetch aggregated fields from the table: "studios" */
  studios_aggregate: Studios_Aggregate;
  /** fetch data from the table: "studios" using primary key columns */
  studios_by_pk?: Maybe<Studios>;
  /** fetch data from the table: "submission_summary" */
  submission_summary: Array<Submission_Summary>;
  /** fetch aggregated fields from the table: "submission_summary" */
  submission_summary_aggregate: Submission_Summary_Aggregate;
  /** fetch data from the table: "team_assets" */
  team_assets: Array<Team_Assets>;
  /** fetch aggregated fields from the table: "team_assets" */
  team_assets_aggregate: Team_Assets_Aggregate;
  /** fetch data from the table: "team_assets" using primary key columns */
  team_assets_by_pk?: Maybe<Team_Assets>;
  /** An array relationship */
  team_memberships: Array<Team_Memberships>;
  /** An aggregate relationship */
  team_memberships_aggregate: Team_Memberships_Aggregate;
  /** fetch data from the table: "team_memberships" using primary key columns */
  team_memberships_by_pk?: Maybe<Team_Memberships>;
  /** fetch data from the table: "team_roles" */
  team_roles: Array<Team_Roles>;
  /** fetch aggregated fields from the table: "team_roles" */
  team_roles_aggregate: Team_Roles_Aggregate;
  /** fetch data from the table: "team_roles" using primary key columns */
  team_roles_by_pk?: Maybe<Team_Roles>;
  /** An array relationship */
  teams: Array<Teams>;
  /** An aggregate relationship */
  teams_aggregate: Teams_Aggregate;
  /** fetch data from the table: "teams" using primary key columns */
  teams_by_pk?: Maybe<Teams>;
  /** fetch data from the table: "teams_with_awards_ceremony_checkins" */
  teams_with_awards_ceremony_checkins: Array<Teams_With_Awards_Ceremony_Checkins>;
  /** fetch aggregated fields from the table: "teams_with_awards_ceremony_checkins" */
  teams_with_awards_ceremony_checkins_aggregate: Teams_With_Awards_Ceremony_Checkins_Aggregate;
  /** fetch data from the table: "teams_with_checkins" */
  teams_with_checkins: Array<Teams_With_Checkins>;
  /** fetch aggregated fields from the table: "teams_with_checkins" */
  teams_with_checkins_aggregate: Teams_With_Checkins_Aggregate;
  /** fetch data from the table: "ticket_tailor_vouchers" */
  ticket_tailor_vouchers: Array<Ticket_Tailor_Vouchers>;
  /** fetch aggregated fields from the table: "ticket_tailor_vouchers" */
  ticket_tailor_vouchers_aggregate: Ticket_Tailor_Vouchers_Aggregate;
  /** fetch data from the table: "ticket_tailor_vouchers" using primary key columns */
  ticket_tailor_vouchers_by_pk?: Maybe<Ticket_Tailor_Vouchers>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  whoami?: Maybe<Scalars['String']>;
};


export type Query_RootAsset_ExportsArgs = {
  distinct_on?: InputMaybe<Array<Asset_Exports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Asset_Exports_Order_By>>;
  where?: InputMaybe<Asset_Exports_Bool_Exp>;
};


export type Query_RootAsset_Exports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Exports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Asset_Exports_Order_By>>;
  where?: InputMaybe<Asset_Exports_Bool_Exp>;
};


export type Query_RootAsset_Exports_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAsset_TypesArgs = {
  distinct_on?: InputMaybe<Array<Asset_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Asset_Types_Order_By>>;
  where?: InputMaybe<Asset_Types_Bool_Exp>;
};


export type Query_RootAsset_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Asset_Types_Order_By>>;
  where?: InputMaybe<Asset_Types_Bool_Exp>;
};


export type Query_RootAsset_Types_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Query_RootAudience_Favorite_CountsArgs = {
  distinct_on?: InputMaybe<Array<Audience_Favorite_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Audience_Favorite_Counts_Order_By>>;
  where?: InputMaybe<Audience_Favorite_Counts_Bool_Exp>;
};


export type Query_RootAudience_Favorite_Counts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Audience_Favorite_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Audience_Favorite_Counts_Order_By>>;
  where?: InputMaybe<Audience_Favorite_Counts_Bool_Exp>;
};


export type Query_RootAudience_Favorite_VotesArgs = {
  distinct_on?: InputMaybe<Array<Audience_Favorite_Votes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Audience_Favorite_Votes_Order_By>>;
  where?: InputMaybe<Audience_Favorite_Votes_Bool_Exp>;
};


export type Query_RootAudience_Favorite_Votes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Audience_Favorite_Votes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Audience_Favorite_Votes_Order_By>>;
  where?: InputMaybe<Audience_Favorite_Votes_Bool_Exp>;
};


export type Query_RootAudience_Favorite_Votes_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAward_Asset_TypesArgs = {
  distinct_on?: InputMaybe<Array<Award_Asset_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Award_Asset_Types_Order_By>>;
  where?: InputMaybe<Award_Asset_Types_Bool_Exp>;
};


export type Query_RootAward_Asset_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Award_Asset_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Award_Asset_Types_Order_By>>;
  where?: InputMaybe<Award_Asset_Types_Bool_Exp>;
};


export type Query_RootAward_Asset_Types_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Query_RootAward_NominationsArgs = {
  distinct_on?: InputMaybe<Array<Award_Nominations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Award_Nominations_Order_By>>;
  where?: InputMaybe<Award_Nominations_Bool_Exp>;
};


export type Query_RootAward_Nominations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Award_Nominations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Award_Nominations_Order_By>>;
  where?: InputMaybe<Award_Nominations_Bool_Exp>;
};


export type Query_RootAward_WinnersArgs = {
  distinct_on?: InputMaybe<Array<Award_Winners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Award_Winners_Order_By>>;
  where?: InputMaybe<Award_Winners_Bool_Exp>;
};


export type Query_RootAward_Winners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Award_Winners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Award_Winners_Order_By>>;
  where?: InputMaybe<Award_Winners_Bool_Exp>;
};


export type Query_RootAward_Winners_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAwardsArgs = {
  distinct_on?: InputMaybe<Array<Awards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Awards_Order_By>>;
  where?: InputMaybe<Awards_Bool_Exp>;
};


export type Query_RootAwards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Awards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Awards_Order_By>>;
  where?: InputMaybe<Awards_Bool_Exp>;
};


export type Query_RootAwards_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Query_RootAwards_Ceremony_CheckinsArgs = {
  distinct_on?: InputMaybe<Array<Awards_Ceremony_Checkins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Awards_Ceremony_Checkins_Order_By>>;
  where?: InputMaybe<Awards_Ceremony_Checkins_Bool_Exp>;
};


export type Query_RootAwards_Ceremony_Checkins_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Awards_Ceremony_Checkins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Awards_Ceremony_Checkins_Order_By>>;
  where?: InputMaybe<Awards_Ceremony_Checkins_Bool_Exp>;
};


export type Query_RootAwards_Ceremony_Checkins_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCountriesArgs = {
  distinct_on?: InputMaybe<Array<Countries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Countries_Order_By>>;
  where?: InputMaybe<Countries_Bool_Exp>;
};


export type Query_RootCountries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Countries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Countries_Order_By>>;
  where?: InputMaybe<Countries_Bool_Exp>;
};


export type Query_RootCountries_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Query_RootExit_Interview_RecordingsArgs = {
  distinct_on?: InputMaybe<Array<Exit_Interview_Recordings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exit_Interview_Recordings_Order_By>>;
  where?: InputMaybe<Exit_Interview_Recordings_Bool_Exp>;
};


export type Query_RootExit_Interview_Recordings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exit_Interview_Recordings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exit_Interview_Recordings_Order_By>>;
  where?: InputMaybe<Exit_Interview_Recordings_Bool_Exp>;
};


export type Query_RootExit_Interview_Recordings_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootExit_InterviewsArgs = {
  distinct_on?: InputMaybe<Array<Exit_Interviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exit_Interviews_Order_By>>;
  where?: InputMaybe<Exit_Interviews_Bool_Exp>;
};


export type Query_RootExit_Interviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exit_Interviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exit_Interviews_Order_By>>;
  where?: InputMaybe<Exit_Interviews_Bool_Exp>;
};


export type Query_RootExit_Interviews_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootExpertiseArgs = {
  distinct_on?: InputMaybe<Array<Expertise_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expertise_Order_By>>;
  where?: InputMaybe<Expertise_Bool_Exp>;
};


export type Query_RootExpertise_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Expertise_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expertise_Order_By>>;
  where?: InputMaybe<Expertise_Bool_Exp>;
};


export type Query_RootExpertise_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Query_RootFestival_Badge_Type_Event_TypeArgs = {
  distinct_on?: InputMaybe<Array<Festival_Badge_Type_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Badge_Type_Event_Type_Order_By>>;
  where?: InputMaybe<Festival_Badge_Type_Event_Type_Bool_Exp>;
};


export type Query_RootFestival_Badge_Type_Event_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Badge_Type_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Badge_Type_Event_Type_Order_By>>;
  where?: InputMaybe<Festival_Badge_Type_Event_Type_Bool_Exp>;
};


export type Query_RootFestival_Badge_Type_Event_Type_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootFestival_Badge_TypesArgs = {
  distinct_on?: InputMaybe<Array<Festival_Badge_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Badge_Types_Order_By>>;
  where?: InputMaybe<Festival_Badge_Types_Bool_Exp>;
};


export type Query_RootFestival_Badge_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Badge_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Badge_Types_Order_By>>;
  where?: InputMaybe<Festival_Badge_Types_Bool_Exp>;
};


export type Query_RootFestival_Badge_Types_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootFestival_BadgesArgs = {
  distinct_on?: InputMaybe<Array<Festival_Badges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Badges_Order_By>>;
  where?: InputMaybe<Festival_Badges_Bool_Exp>;
};


export type Query_RootFestival_Badges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Badges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Badges_Order_By>>;
  where?: InputMaybe<Festival_Badges_Bool_Exp>;
};


export type Query_RootFestival_Badges_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootFestival_Event_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Festival_Event_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Event_Locations_Order_By>>;
  where?: InputMaybe<Festival_Event_Locations_Bool_Exp>;
};


export type Query_RootFestival_Event_Locations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Event_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Event_Locations_Order_By>>;
  where?: InputMaybe<Festival_Event_Locations_Bool_Exp>;
};


export type Query_RootFestival_Event_Locations_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootFestival_Event_TypesArgs = {
  distinct_on?: InputMaybe<Array<Festival_Event_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Event_Types_Order_By>>;
  where?: InputMaybe<Festival_Event_Types_Bool_Exp>;
};


export type Query_RootFestival_Event_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Event_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Event_Types_Order_By>>;
  where?: InputMaybe<Festival_Event_Types_Bool_Exp>;
};


export type Query_RootFestival_Event_Types_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootFestival_EventsArgs = {
  distinct_on?: InputMaybe<Array<Festival_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Events_Order_By>>;
  where?: InputMaybe<Festival_Events_Bool_Exp>;
};


export type Query_RootFestival_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Events_Order_By>>;
  where?: InputMaybe<Festival_Events_Bool_Exp>;
};


export type Query_RootFestival_Events_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootFestival_GenresArgs = {
  distinct_on?: InputMaybe<Array<Festival_Genres_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Genres_Order_By>>;
  where?: InputMaybe<Festival_Genres_Bool_Exp>;
};


export type Query_RootFestival_Genres_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Genres_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Genres_Order_By>>;
  where?: InputMaybe<Festival_Genres_Bool_Exp>;
};


export type Query_RootFestival_Genres_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootFestival_Submission_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Festival_Submission_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Submission_Assets_Order_By>>;
  where?: InputMaybe<Festival_Submission_Assets_Bool_Exp>;
};


export type Query_RootFestival_Submission_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Submission_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Submission_Assets_Order_By>>;
  where?: InputMaybe<Festival_Submission_Assets_Bool_Exp>;
};


export type Query_RootFestival_Submission_Assets_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootFestival_Submission_FeedbackArgs = {
  distinct_on?: InputMaybe<Array<Festival_Submission_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Submission_Feedback_Order_By>>;
  where?: InputMaybe<Festival_Submission_Feedback_Bool_Exp>;
};


export type Query_RootFestival_Submission_Feedback_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Submission_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Submission_Feedback_Order_By>>;
  where?: InputMaybe<Festival_Submission_Feedback_Bool_Exp>;
};


export type Query_RootFestival_Submission_Feedback_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootFestival_Submission_VouchersArgs = {
  distinct_on?: InputMaybe<Array<Festival_Submission_Vouchers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Submission_Vouchers_Order_By>>;
  where?: InputMaybe<Festival_Submission_Vouchers_Bool_Exp>;
};


export type Query_RootFestival_Submission_Vouchers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Submission_Vouchers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Submission_Vouchers_Order_By>>;
  where?: InputMaybe<Festival_Submission_Vouchers_Bool_Exp>;
};


export type Query_RootFestival_Submission_Vouchers_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootFestival_SubmissionsArgs = {
  distinct_on?: InputMaybe<Array<Festival_Submissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Submissions_Order_By>>;
  where?: InputMaybe<Festival_Submissions_Bool_Exp>;
};


export type Query_RootFestival_Submissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Submissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Submissions_Order_By>>;
  where?: InputMaybe<Festival_Submissions_Bool_Exp>;
};


export type Query_RootFestival_Submissions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootFestival_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Festival_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Tickets_Order_By>>;
  where?: InputMaybe<Festival_Tickets_Bool_Exp>;
};


export type Query_RootFestival_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Tickets_Order_By>>;
  where?: InputMaybe<Festival_Tickets_Bool_Exp>;
};


export type Query_RootFestival_Tickets_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootFetchedObscuredRegistrationArgs = {
  hash: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
};


export type Query_RootFilm_FestivalsArgs = {
  distinct_on?: InputMaybe<Array<Film_Festivals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Film_Festivals_Order_By>>;
  where?: InputMaybe<Film_Festivals_Bool_Exp>;
};


export type Query_RootFilm_Festivals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Film_Festivals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Film_Festivals_Order_By>>;
  where?: InputMaybe<Film_Festivals_Bool_Exp>;
};


export type Query_RootFilm_Festivals_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Query_RootFilm_Group_Festival_SubmissionsArgs = {
  distinct_on?: InputMaybe<Array<Film_Group_Festival_Submissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Film_Group_Festival_Submissions_Order_By>>;
  where?: InputMaybe<Film_Group_Festival_Submissions_Bool_Exp>;
};


export type Query_RootFilm_Group_Festival_Submissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Film_Group_Festival_Submissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Film_Group_Festival_Submissions_Order_By>>;
  where?: InputMaybe<Film_Group_Festival_Submissions_Bool_Exp>;
};


export type Query_RootFilm_Group_Festival_Submissions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootFilm_Group_FilmsArgs = {
  distinct_on?: InputMaybe<Array<Film_Group_Films_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Film_Group_Films_Order_By>>;
  where?: InputMaybe<Film_Group_Films_Bool_Exp>;
};


export type Query_RootFilm_Group_Films_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Film_Group_Films_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Film_Group_Films_Order_By>>;
  where?: InputMaybe<Film_Group_Films_Bool_Exp>;
};


export type Query_RootFilm_Group_Films_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootFilm_Group_UsersArgs = {
  distinct_on?: InputMaybe<Array<Film_Group_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Film_Group_Users_Order_By>>;
  where?: InputMaybe<Film_Group_Users_Bool_Exp>;
};


export type Query_RootFilm_Group_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Film_Group_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Film_Group_Users_Order_By>>;
  where?: InputMaybe<Film_Group_Users_Bool_Exp>;
};


export type Query_RootFilm_Group_Users_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootFilm_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Film_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Film_Groups_Order_By>>;
  where?: InputMaybe<Film_Groups_Bool_Exp>;
};


export type Query_RootFilm_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Film_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Film_Groups_Order_By>>;
  where?: InputMaybe<Film_Groups_Bool_Exp>;
};


export type Query_RootFilm_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootFilmsArgs = {
  distinct_on?: InputMaybe<Array<Films_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Films_Order_By>>;
  where?: InputMaybe<Films_Bool_Exp>;
};


export type Query_RootFilms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Films_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Films_Order_By>>;
  where?: InputMaybe<Films_Bool_Exp>;
};


export type Query_RootFilms_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Query_RootGenresArgs = {
  distinct_on?: InputMaybe<Array<Genres_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Genres_Order_By>>;
  where?: InputMaybe<Genres_Bool_Exp>;
};


export type Query_RootGenres_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Genres_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Genres_Order_By>>;
  where?: InputMaybe<Genres_Bool_Exp>;
};


export type Query_RootGenres_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Query_RootKickoff_CheckinsArgs = {
  distinct_on?: InputMaybe<Array<Kickoff_Checkins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Kickoff_Checkins_Order_By>>;
  where?: InputMaybe<Kickoff_Checkins_Bool_Exp>;
};


export type Query_RootKickoff_Checkins_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Kickoff_Checkins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Kickoff_Checkins_Order_By>>;
  where?: InputMaybe<Kickoff_Checkins_Bool_Exp>;
};


export type Query_RootKickoff_Checkins_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Query_RootLocation_ReleasesArgs = {
  distinct_on?: InputMaybe<Array<Location_Releases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Releases_Order_By>>;
  where?: InputMaybe<Location_Releases_Bool_Exp>;
};


export type Query_RootLocation_Releases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Location_Releases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Releases_Order_By>>;
  where?: InputMaybe<Location_Releases_Bool_Exp>;
};


export type Query_RootLocation_Releases_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Query_RootMatchup_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Matchup_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Matchup_Requests_Order_By>>;
  where?: InputMaybe<Matchup_Requests_Bool_Exp>;
};


export type Query_RootMatchup_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Matchup_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Matchup_Requests_Order_By>>;
  where?: InputMaybe<Matchup_Requests_Bool_Exp>;
};


export type Query_RootMatchup_Requests_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Query_RootMusic_ReleasesArgs = {
  distinct_on?: InputMaybe<Array<Music_Releases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Music_Releases_Order_By>>;
  where?: InputMaybe<Music_Releases_Bool_Exp>;
};


export type Query_RootMusic_Releases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Music_Releases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Music_Releases_Order_By>>;
  where?: InputMaybe<Music_Releases_Bool_Exp>;
};


export type Query_RootMusic_Releases_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Query_RootNomination_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Nomination_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nomination_Assets_Order_By>>;
  where?: InputMaybe<Nomination_Assets_Bool_Exp>;
};


export type Query_RootNomination_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nomination_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nomination_Assets_Order_By>>;
  where?: InputMaybe<Nomination_Assets_Bool_Exp>;
};


export type Query_RootNomination_Assets_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Query_RootNominationsArgs = {
  distinct_on?: InputMaybe<Array<Nominations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nominations_Order_By>>;
  where?: InputMaybe<Nominations_Bool_Exp>;
};


export type Query_RootNominations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nominations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nominations_Order_By>>;
  where?: InputMaybe<Nominations_Bool_Exp>;
};


export type Query_RootNominations_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Query_RootOnline_Screening_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Online_Screening_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Online_Screening_Tickets_Order_By>>;
  where?: InputMaybe<Online_Screening_Tickets_Bool_Exp>;
};


export type Query_RootOnline_Screening_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Online_Screening_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Online_Screening_Tickets_Order_By>>;
  where?: InputMaybe<Online_Screening_Tickets_Bool_Exp>;
};


export type Query_RootOnline_Screening_Tickets_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


export type Query_RootPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


export type Query_RootPayments_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Query_RootPlaylist_TeamArgs = {
  distinct_on?: InputMaybe<Array<Playlist_Team_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Playlist_Team_Order_By>>;
  where?: InputMaybe<Playlist_Team_Bool_Exp>;
};


export type Query_RootPlaylist_Team_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Playlist_Team_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Playlist_Team_Order_By>>;
  where?: InputMaybe<Playlist_Team_Bool_Exp>;
};


export type Query_RootPlaylist_Team_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPlaylistsArgs = {
  distinct_on?: InputMaybe<Array<Playlists_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Playlists_Order_By>>;
  where?: InputMaybe<Playlists_Bool_Exp>;
};


export type Query_RootPlaylists_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Playlists_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Playlists_Order_By>>;
  where?: InputMaybe<Playlists_Bool_Exp>;
};


export type Query_RootPlaylists_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPrize_ElectionsArgs = {
  distinct_on?: InputMaybe<Array<Prize_Elections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prize_Elections_Order_By>>;
  where?: InputMaybe<Prize_Elections_Bool_Exp>;
};


export type Query_RootPrize_Elections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prize_Elections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prize_Elections_Order_By>>;
  where?: InputMaybe<Prize_Elections_Bool_Exp>;
};


export type Query_RootPrizesArgs = {
  distinct_on?: InputMaybe<Array<Prizes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prizes_Order_By>>;
  where?: InputMaybe<Prizes_Bool_Exp>;
};


export type Query_RootPrizes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prizes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prizes_Order_By>>;
  where?: InputMaybe<Prizes_Bool_Exp>;
};


export type Query_RootPrizes_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Query_RootRegistrationsArgs = {
  distinct_on?: InputMaybe<Array<Registrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Registrations_Order_By>>;
  where?: InputMaybe<Registrations_Bool_Exp>;
};


export type Query_RootRegistrations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Registrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Registrations_Order_By>>;
  where?: InputMaybe<Registrations_Bool_Exp>;
};


export type Query_RootRegistrations_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Query_RootSelection_BallotsArgs = {
  distinct_on?: InputMaybe<Array<Selection_Ballots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Selection_Ballots_Order_By>>;
  where?: InputMaybe<Selection_Ballots_Bool_Exp>;
};


export type Query_RootSelection_Ballots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Selection_Ballots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Selection_Ballots_Order_By>>;
  where?: InputMaybe<Selection_Ballots_Bool_Exp>;
};


export type Query_RootSelection_Ballots_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSelection_FeedbackArgs = {
  distinct_on?: InputMaybe<Array<Selection_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Selection_Feedback_Order_By>>;
  where?: InputMaybe<Selection_Feedback_Bool_Exp>;
};


export type Query_RootSelection_Feedback_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Selection_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Selection_Feedback_Order_By>>;
  where?: InputMaybe<Selection_Feedback_Bool_Exp>;
};


export type Query_RootSelection_Feedback_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSelection_MetricsArgs = {
  distinct_on?: InputMaybe<Array<Selection_Metrics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Selection_Metrics_Order_By>>;
  where?: InputMaybe<Selection_Metrics_Bool_Exp>;
};


export type Query_RootSelection_Metrics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Selection_Metrics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Selection_Metrics_Order_By>>;
  where?: InputMaybe<Selection_Metrics_Bool_Exp>;
};


export type Query_RootSelection_Metrics_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSelection_ProgressArgs = {
  distinct_on?: InputMaybe<Array<Selection_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Selection_Progress_Order_By>>;
  where?: InputMaybe<Selection_Progress_Bool_Exp>;
};


export type Query_RootSelection_Progress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Selection_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Selection_Progress_Order_By>>;
  where?: InputMaybe<Selection_Progress_Bool_Exp>;
};


export type Query_RootSelection_Progress_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSelection_ResultsArgs = {
  distinct_on?: InputMaybe<Array<Selection_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Selection_Results_Order_By>>;
  where?: InputMaybe<Selection_Results_Bool_Exp>;
};


export type Query_RootSelection_Results_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Selection_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Selection_Results_Order_By>>;
  where?: InputMaybe<Selection_Results_Bool_Exp>;
};


export type Query_RootSharablesArgs = {
  distinct_on?: InputMaybe<Array<Sharables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sharables_Order_By>>;
  where?: InputMaybe<Sharables_Bool_Exp>;
};


export type Query_RootSharables_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sharables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sharables_Order_By>>;
  where?: InputMaybe<Sharables_Bool_Exp>;
};


export type Query_RootSharables_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSms_VotesArgs = {
  distinct_on?: InputMaybe<Array<Sms_Votes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sms_Votes_Order_By>>;
  where?: InputMaybe<Sms_Votes_Bool_Exp>;
};


export type Query_RootSms_Votes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sms_Votes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sms_Votes_Order_By>>;
  where?: InputMaybe<Sms_Votes_Bool_Exp>;
};


export type Query_RootSms_Votes_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSponsorsArgs = {
  distinct_on?: InputMaybe<Array<Sponsors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsors_Order_By>>;
  where?: InputMaybe<Sponsors_Bool_Exp>;
};


export type Query_RootSponsors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sponsors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsors_Order_By>>;
  where?: InputMaybe<Sponsors_Bool_Exp>;
};


export type Query_RootSponsors_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Query_RootStudiosArgs = {
  distinct_on?: InputMaybe<Array<Studios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Studios_Order_By>>;
  where?: InputMaybe<Studios_Bool_Exp>;
};


export type Query_RootStudios_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Studios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Studios_Order_By>>;
  where?: InputMaybe<Studios_Bool_Exp>;
};


export type Query_RootStudios_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSubmission_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Submission_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Submission_Summary_Order_By>>;
  where?: InputMaybe<Submission_Summary_Bool_Exp>;
};


export type Query_RootSubmission_Summary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Submission_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Submission_Summary_Order_By>>;
  where?: InputMaybe<Submission_Summary_Bool_Exp>;
};


export type Query_RootTeam_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Team_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Assets_Order_By>>;
  where?: InputMaybe<Team_Assets_Bool_Exp>;
};


export type Query_RootTeam_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Team_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Assets_Order_By>>;
  where?: InputMaybe<Team_Assets_Bool_Exp>;
};


export type Query_RootTeam_Assets_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Query_RootTeam_MembershipsArgs = {
  distinct_on?: InputMaybe<Array<Team_Memberships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Memberships_Order_By>>;
  where?: InputMaybe<Team_Memberships_Bool_Exp>;
};


export type Query_RootTeam_Memberships_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Team_Memberships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Memberships_Order_By>>;
  where?: InputMaybe<Team_Memberships_Bool_Exp>;
};


export type Query_RootTeam_Memberships_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Query_RootTeam_RolesArgs = {
  distinct_on?: InputMaybe<Array<Team_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Roles_Order_By>>;
  where?: InputMaybe<Team_Roles_Bool_Exp>;
};


export type Query_RootTeam_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Team_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Roles_Order_By>>;
  where?: InputMaybe<Team_Roles_Bool_Exp>;
};


export type Query_RootTeam_Roles_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Query_RootTeamsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Query_RootTeams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Query_RootTeams_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Query_RootTeams_With_Awards_Ceremony_CheckinsArgs = {
  distinct_on?: InputMaybe<Array<Teams_With_Awards_Ceremony_Checkins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_With_Awards_Ceremony_Checkins_Order_By>>;
  where?: InputMaybe<Teams_With_Awards_Ceremony_Checkins_Bool_Exp>;
};


export type Query_RootTeams_With_Awards_Ceremony_Checkins_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_With_Awards_Ceremony_Checkins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_With_Awards_Ceremony_Checkins_Order_By>>;
  where?: InputMaybe<Teams_With_Awards_Ceremony_Checkins_Bool_Exp>;
};


export type Query_RootTeams_With_CheckinsArgs = {
  distinct_on?: InputMaybe<Array<Teams_With_Checkins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_With_Checkins_Order_By>>;
  where?: InputMaybe<Teams_With_Checkins_Bool_Exp>;
};


export type Query_RootTeams_With_Checkins_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_With_Checkins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_With_Checkins_Order_By>>;
  where?: InputMaybe<Teams_With_Checkins_Bool_Exp>;
};


export type Query_RootTicket_Tailor_VouchersArgs = {
  distinct_on?: InputMaybe<Array<Ticket_Tailor_Vouchers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticket_Tailor_Vouchers_Order_By>>;
  where?: InputMaybe<Ticket_Tailor_Vouchers_Bool_Exp>;
};


export type Query_RootTicket_Tailor_Vouchers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticket_Tailor_Vouchers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticket_Tailor_Vouchers_Order_By>>;
  where?: InputMaybe<Ticket_Tailor_Vouchers_Bool_Exp>;
};


export type Query_RootTicket_Tailor_Vouchers_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  id: Scalars['numeric'];
};

/** columns and relationships of "registrations" */
export type Registrations = {
  __typename?: 'registrations';
  address_1?: Maybe<Scalars['String']>;
  address_2?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created: Scalars['timestamp'];
  created_by: Scalars['String'];
  first_name?: Maybe<Scalars['String']>;
  id: Scalars['numeric'];
  is_minor?: Maybe<Scalars['String']>;
  is_notify_primary_email?: Maybe<Scalars['String']>;
  is_notify_secondary_email?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  middle_name?: Maybe<Scalars['String']>;
  primary_email?: Maybe<Scalars['String']>;
  primary_phone?: Maybe<Scalars['String']>;
  secondary_email?: Maybe<Scalars['String']>;
  secondary_phone?: Maybe<Scalars['String']>;
  signature_email?: Maybe<Scalars['String']>;
  signature_ip?: Maybe<Scalars['String']>;
  signature_name?: Maybe<Scalars['String']>;
  signature_phone?: Maybe<Scalars['String']>;
  signature_ts?: Maybe<Scalars['timestamp']>;
  state?: Maybe<Scalars['String']>;
  /** An object relationship */
  team_membership: Team_Memberships;
  team_membership_id: Scalars['numeric'];
  updated: Scalars['timestamp'];
  updated_by: Scalars['String'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['numeric']>;
  zip?: Maybe<Scalars['String']>;
};

/** aggregated selection of "registrations" */
export type Registrations_Aggregate = {
  __typename?: 'registrations_aggregate';
  aggregate?: Maybe<Registrations_Aggregate_Fields>;
  nodes: Array<Registrations>;
};

/** aggregate fields of "registrations" */
export type Registrations_Aggregate_Fields = {
  __typename?: 'registrations_aggregate_fields';
  avg?: Maybe<Registrations_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Registrations_Max_Fields>;
  min?: Maybe<Registrations_Min_Fields>;
  stddev?: Maybe<Registrations_Stddev_Fields>;
  stddev_pop?: Maybe<Registrations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Registrations_Stddev_Samp_Fields>;
  sum?: Maybe<Registrations_Sum_Fields>;
  var_pop?: Maybe<Registrations_Var_Pop_Fields>;
  var_samp?: Maybe<Registrations_Var_Samp_Fields>;
  variance?: Maybe<Registrations_Variance_Fields>;
};


/** aggregate fields of "registrations" */
export type Registrations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Registrations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Registrations_Avg_Fields = {
  __typename?: 'registrations_avg_fields';
  id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "registrations". All fields are combined with a logical 'AND'. */
export type Registrations_Bool_Exp = {
  _and?: InputMaybe<Array<Registrations_Bool_Exp>>;
  _not?: InputMaybe<Registrations_Bool_Exp>;
  _or?: InputMaybe<Array<Registrations_Bool_Exp>>;
  address_1?: InputMaybe<String_Comparison_Exp>;
  address_2?: InputMaybe<String_Comparison_Exp>;
  bio?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Numeric_Comparison_Exp>;
  is_minor?: InputMaybe<String_Comparison_Exp>;
  is_notify_primary_email?: InputMaybe<String_Comparison_Exp>;
  is_notify_secondary_email?: InputMaybe<String_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  middle_name?: InputMaybe<String_Comparison_Exp>;
  primary_email?: InputMaybe<String_Comparison_Exp>;
  primary_phone?: InputMaybe<String_Comparison_Exp>;
  secondary_email?: InputMaybe<String_Comparison_Exp>;
  secondary_phone?: InputMaybe<String_Comparison_Exp>;
  signature_email?: InputMaybe<String_Comparison_Exp>;
  signature_ip?: InputMaybe<String_Comparison_Exp>;
  signature_name?: InputMaybe<String_Comparison_Exp>;
  signature_phone?: InputMaybe<String_Comparison_Exp>;
  signature_ts?: InputMaybe<Timestamp_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  team_membership?: InputMaybe<Team_Memberships_Bool_Exp>;
  team_membership_id?: InputMaybe<Numeric_Comparison_Exp>;
  updated?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Numeric_Comparison_Exp>;
  zip?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "registrations" */
export enum Registrations_Constraint {
  /** unique or primary key constraint on columns "id" */
  RegistrationsPkey = 'registrations_pkey'
}

/** input type for incrementing numeric columns in table "registrations" */
export type Registrations_Inc_Input = {
  id?: InputMaybe<Scalars['numeric']>;
  team_membership_id?: InputMaybe<Scalars['numeric']>;
  user_id?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "registrations" */
export type Registrations_Insert_Input = {
  address_1?: InputMaybe<Scalars['String']>;
  address_2?: InputMaybe<Scalars['String']>;
  bio?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  is_minor?: InputMaybe<Scalars['String']>;
  is_notify_primary_email?: InputMaybe<Scalars['String']>;
  is_notify_secondary_email?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  middle_name?: InputMaybe<Scalars['String']>;
  primary_email?: InputMaybe<Scalars['String']>;
  primary_phone?: InputMaybe<Scalars['String']>;
  secondary_email?: InputMaybe<Scalars['String']>;
  secondary_phone?: InputMaybe<Scalars['String']>;
  signature_email?: InputMaybe<Scalars['String']>;
  signature_ip?: InputMaybe<Scalars['String']>;
  signature_name?: InputMaybe<Scalars['String']>;
  signature_phone?: InputMaybe<Scalars['String']>;
  signature_ts?: InputMaybe<Scalars['timestamp']>;
  state?: InputMaybe<Scalars['String']>;
  team_membership?: InputMaybe<Team_Memberships_Obj_Rel_Insert_Input>;
  team_membership_id?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['numeric']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Registrations_Max_Fields = {
  __typename?: 'registrations_max_fields';
  address_1?: Maybe<Scalars['String']>;
  address_2?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  is_minor?: Maybe<Scalars['String']>;
  is_notify_primary_email?: Maybe<Scalars['String']>;
  is_notify_secondary_email?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  middle_name?: Maybe<Scalars['String']>;
  primary_email?: Maybe<Scalars['String']>;
  primary_phone?: Maybe<Scalars['String']>;
  secondary_email?: Maybe<Scalars['String']>;
  secondary_phone?: Maybe<Scalars['String']>;
  signature_email?: Maybe<Scalars['String']>;
  signature_ip?: Maybe<Scalars['String']>;
  signature_name?: Maybe<Scalars['String']>;
  signature_phone?: Maybe<Scalars['String']>;
  signature_ts?: Maybe<Scalars['timestamp']>;
  state?: Maybe<Scalars['String']>;
  team_membership_id?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['numeric']>;
  zip?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Registrations_Min_Fields = {
  __typename?: 'registrations_min_fields';
  address_1?: Maybe<Scalars['String']>;
  address_2?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  is_minor?: Maybe<Scalars['String']>;
  is_notify_primary_email?: Maybe<Scalars['String']>;
  is_notify_secondary_email?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  middle_name?: Maybe<Scalars['String']>;
  primary_email?: Maybe<Scalars['String']>;
  primary_phone?: Maybe<Scalars['String']>;
  secondary_email?: Maybe<Scalars['String']>;
  secondary_phone?: Maybe<Scalars['String']>;
  signature_email?: Maybe<Scalars['String']>;
  signature_ip?: Maybe<Scalars['String']>;
  signature_name?: Maybe<Scalars['String']>;
  signature_phone?: Maybe<Scalars['String']>;
  signature_ts?: Maybe<Scalars['timestamp']>;
  state?: Maybe<Scalars['String']>;
  team_membership_id?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['numeric']>;
  zip?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "registrations" */
export type Registrations_Mutation_Response = {
  __typename?: 'registrations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Registrations>;
};

/** input type for inserting object relation for remote table "registrations" */
export type Registrations_Obj_Rel_Insert_Input = {
  data: Registrations_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Registrations_On_Conflict>;
};

/** on_conflict condition type for table "registrations" */
export type Registrations_On_Conflict = {
  constraint: Registrations_Constraint;
  update_columns?: Array<Registrations_Update_Column>;
  where?: InputMaybe<Registrations_Bool_Exp>;
};

/** Ordering options when selecting data from "registrations". */
export type Registrations_Order_By = {
  address_1?: InputMaybe<Order_By>;
  address_2?: InputMaybe<Order_By>;
  bio?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_minor?: InputMaybe<Order_By>;
  is_notify_primary_email?: InputMaybe<Order_By>;
  is_notify_secondary_email?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  middle_name?: InputMaybe<Order_By>;
  primary_email?: InputMaybe<Order_By>;
  primary_phone?: InputMaybe<Order_By>;
  secondary_email?: InputMaybe<Order_By>;
  secondary_phone?: InputMaybe<Order_By>;
  signature_email?: InputMaybe<Order_By>;
  signature_ip?: InputMaybe<Order_By>;
  signature_name?: InputMaybe<Order_By>;
  signature_phone?: InputMaybe<Order_By>;
  signature_ts?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  team_membership?: InputMaybe<Team_Memberships_Order_By>;
  team_membership_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  zip?: InputMaybe<Order_By>;
};

/** primary key columns input for table: registrations */
export type Registrations_Pk_Columns_Input = {
  id: Scalars['numeric'];
};

/** select columns of table "registrations" */
export enum Registrations_Select_Column {
  /** column name */
  Address_1 = 'address_1',
  /** column name */
  Address_2 = 'address_2',
  /** column name */
  Bio = 'bio',
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsMinor = 'is_minor',
  /** column name */
  IsNotifyPrimaryEmail = 'is_notify_primary_email',
  /** column name */
  IsNotifySecondaryEmail = 'is_notify_secondary_email',
  /** column name */
  LastName = 'last_name',
  /** column name */
  MiddleName = 'middle_name',
  /** column name */
  PrimaryEmail = 'primary_email',
  /** column name */
  PrimaryPhone = 'primary_phone',
  /** column name */
  SecondaryEmail = 'secondary_email',
  /** column name */
  SecondaryPhone = 'secondary_phone',
  /** column name */
  SignatureEmail = 'signature_email',
  /** column name */
  SignatureIp = 'signature_ip',
  /** column name */
  SignatureName = 'signature_name',
  /** column name */
  SignaturePhone = 'signature_phone',
  /** column name */
  SignatureTs = 'signature_ts',
  /** column name */
  State = 'state',
  /** column name */
  TeamMembershipId = 'team_membership_id',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Zip = 'zip'
}

/** input type for updating data in table "registrations" */
export type Registrations_Set_Input = {
  address_1?: InputMaybe<Scalars['String']>;
  address_2?: InputMaybe<Scalars['String']>;
  bio?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  is_minor?: InputMaybe<Scalars['String']>;
  is_notify_primary_email?: InputMaybe<Scalars['String']>;
  is_notify_secondary_email?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  middle_name?: InputMaybe<Scalars['String']>;
  primary_email?: InputMaybe<Scalars['String']>;
  primary_phone?: InputMaybe<Scalars['String']>;
  secondary_email?: InputMaybe<Scalars['String']>;
  secondary_phone?: InputMaybe<Scalars['String']>;
  signature_email?: InputMaybe<Scalars['String']>;
  signature_ip?: InputMaybe<Scalars['String']>;
  signature_name?: InputMaybe<Scalars['String']>;
  signature_phone?: InputMaybe<Scalars['String']>;
  signature_ts?: InputMaybe<Scalars['timestamp']>;
  state?: InputMaybe<Scalars['String']>;
  team_membership_id?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['numeric']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Registrations_Stddev_Fields = {
  __typename?: 'registrations_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Registrations_Stddev_Pop_Fields = {
  __typename?: 'registrations_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Registrations_Stddev_Samp_Fields = {
  __typename?: 'registrations_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "registrations" */
export type Registrations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Registrations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Registrations_Stream_Cursor_Value_Input = {
  address_1?: InputMaybe<Scalars['String']>;
  address_2?: InputMaybe<Scalars['String']>;
  bio?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  is_minor?: InputMaybe<Scalars['String']>;
  is_notify_primary_email?: InputMaybe<Scalars['String']>;
  is_notify_secondary_email?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  middle_name?: InputMaybe<Scalars['String']>;
  primary_email?: InputMaybe<Scalars['String']>;
  primary_phone?: InputMaybe<Scalars['String']>;
  secondary_email?: InputMaybe<Scalars['String']>;
  secondary_phone?: InputMaybe<Scalars['String']>;
  signature_email?: InputMaybe<Scalars['String']>;
  signature_ip?: InputMaybe<Scalars['String']>;
  signature_name?: InputMaybe<Scalars['String']>;
  signature_phone?: InputMaybe<Scalars['String']>;
  signature_ts?: InputMaybe<Scalars['timestamp']>;
  state?: InputMaybe<Scalars['String']>;
  team_membership_id?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['numeric']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Registrations_Sum_Fields = {
  __typename?: 'registrations_sum_fields';
  id?: Maybe<Scalars['numeric']>;
  team_membership_id?: Maybe<Scalars['numeric']>;
  user_id?: Maybe<Scalars['numeric']>;
};

/** update columns of table "registrations" */
export enum Registrations_Update_Column {
  /** column name */
  Address_1 = 'address_1',
  /** column name */
  Address_2 = 'address_2',
  /** column name */
  Bio = 'bio',
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsMinor = 'is_minor',
  /** column name */
  IsNotifyPrimaryEmail = 'is_notify_primary_email',
  /** column name */
  IsNotifySecondaryEmail = 'is_notify_secondary_email',
  /** column name */
  LastName = 'last_name',
  /** column name */
  MiddleName = 'middle_name',
  /** column name */
  PrimaryEmail = 'primary_email',
  /** column name */
  PrimaryPhone = 'primary_phone',
  /** column name */
  SecondaryEmail = 'secondary_email',
  /** column name */
  SecondaryPhone = 'secondary_phone',
  /** column name */
  SignatureEmail = 'signature_email',
  /** column name */
  SignatureIp = 'signature_ip',
  /** column name */
  SignatureName = 'signature_name',
  /** column name */
  SignaturePhone = 'signature_phone',
  /** column name */
  SignatureTs = 'signature_ts',
  /** column name */
  State = 'state',
  /** column name */
  TeamMembershipId = 'team_membership_id',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Zip = 'zip'
}

export type Registrations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Registrations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Registrations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Registrations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Registrations_Var_Pop_Fields = {
  __typename?: 'registrations_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Registrations_Var_Samp_Fields = {
  __typename?: 'registrations_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Registrations_Variance_Fields = {
  __typename?: 'registrations_variance_fields';
  id?: Maybe<Scalars['Float']>;
  team_membership_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "selection_ballots" */
export type Selection_Ballots = {
  __typename?: 'selection_ballots';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  film_group: Film_Groups;
  film_group_id: Scalars['Int'];
  id: Scalars['Int'];
  is_complete: Scalars['Boolean'];
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id: Scalars['String'];
};

/** aggregated selection of "selection_ballots" */
export type Selection_Ballots_Aggregate = {
  __typename?: 'selection_ballots_aggregate';
  aggregate?: Maybe<Selection_Ballots_Aggregate_Fields>;
  nodes: Array<Selection_Ballots>;
};

/** aggregate fields of "selection_ballots" */
export type Selection_Ballots_Aggregate_Fields = {
  __typename?: 'selection_ballots_aggregate_fields';
  avg?: Maybe<Selection_Ballots_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Selection_Ballots_Max_Fields>;
  min?: Maybe<Selection_Ballots_Min_Fields>;
  stddev?: Maybe<Selection_Ballots_Stddev_Fields>;
  stddev_pop?: Maybe<Selection_Ballots_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Selection_Ballots_Stddev_Samp_Fields>;
  sum?: Maybe<Selection_Ballots_Sum_Fields>;
  var_pop?: Maybe<Selection_Ballots_Var_Pop_Fields>;
  var_samp?: Maybe<Selection_Ballots_Var_Samp_Fields>;
  variance?: Maybe<Selection_Ballots_Variance_Fields>;
};


/** aggregate fields of "selection_ballots" */
export type Selection_Ballots_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Selection_Ballots_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Selection_Ballots_Avg_Fields = {
  __typename?: 'selection_ballots_avg_fields';
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "selection_ballots". All fields are combined with a logical 'AND'. */
export type Selection_Ballots_Bool_Exp = {
  _and?: InputMaybe<Array<Selection_Ballots_Bool_Exp>>;
  _not?: InputMaybe<Selection_Ballots_Bool_Exp>;
  _or?: InputMaybe<Array<Selection_Ballots_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  film_group?: InputMaybe<Film_Groups_Bool_Exp>;
  film_group_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_complete?: InputMaybe<Boolean_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "selection_ballots" */
export enum Selection_Ballots_Constraint {
  /** unique or primary key constraint on columns "user_id", "film_group_id" */
  SelectionBallotsFilmGroupIdUserIdKey = 'selection_ballots_film_group_id_user_id_key',
  /** unique or primary key constraint on columns "id" */
  SelectionBallotsPkey = 'selection_ballots_pkey'
}

/** input type for incrementing numeric columns in table "selection_ballots" */
export type Selection_Ballots_Inc_Input = {
  film_group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "selection_ballots" */
export type Selection_Ballots_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  film_group?: InputMaybe<Film_Groups_Obj_Rel_Insert_Input>;
  film_group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_complete?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Selection_Ballots_Max_Fields = {
  __typename?: 'selection_ballots_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  film_group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Selection_Ballots_Min_Fields = {
  __typename?: 'selection_ballots_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  film_group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "selection_ballots" */
export type Selection_Ballots_Mutation_Response = {
  __typename?: 'selection_ballots_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Selection_Ballots>;
};

/** on_conflict condition type for table "selection_ballots" */
export type Selection_Ballots_On_Conflict = {
  constraint: Selection_Ballots_Constraint;
  update_columns?: Array<Selection_Ballots_Update_Column>;
  where?: InputMaybe<Selection_Ballots_Bool_Exp>;
};

/** Ordering options when selecting data from "selection_ballots". */
export type Selection_Ballots_Order_By = {
  created_at?: InputMaybe<Order_By>;
  film_group?: InputMaybe<Film_Groups_Order_By>;
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_complete?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: selection_ballots */
export type Selection_Ballots_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "selection_ballots" */
export enum Selection_Ballots_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FilmGroupId = 'film_group_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsComplete = 'is_complete',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "selection_ballots" */
export type Selection_Ballots_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  film_group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_complete?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Selection_Ballots_Stddev_Fields = {
  __typename?: 'selection_ballots_stddev_fields';
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Selection_Ballots_Stddev_Pop_Fields = {
  __typename?: 'selection_ballots_stddev_pop_fields';
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Selection_Ballots_Stddev_Samp_Fields = {
  __typename?: 'selection_ballots_stddev_samp_fields';
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "selection_ballots" */
export type Selection_Ballots_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Selection_Ballots_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Selection_Ballots_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  film_group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_complete?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Selection_Ballots_Sum_Fields = {
  __typename?: 'selection_ballots_sum_fields';
  film_group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "selection_ballots" */
export enum Selection_Ballots_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FilmGroupId = 'film_group_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsComplete = 'is_complete',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Selection_Ballots_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Selection_Ballots_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Selection_Ballots_Set_Input>;
  /** filter the rows which have to be updated */
  where: Selection_Ballots_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Selection_Ballots_Var_Pop_Fields = {
  __typename?: 'selection_ballots_var_pop_fields';
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Selection_Ballots_Var_Samp_Fields = {
  __typename?: 'selection_ballots_var_samp_fields';
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Selection_Ballots_Variance_Fields = {
  __typename?: 'selection_ballots_variance_fields';
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "selection_feedback" */
export type Selection_Feedback = {
  __typename?: 'selection_feedback';
  censored: Scalars['Boolean'];
  comments: Scalars['String'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  real_user_id: Scalars['Int'];
  tags: Scalars['String'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['numeric'];
  updated_at: Scalars['timestamptz'];
  user_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "selection_feedback" */
export type Selection_Feedback_Aggregate = {
  __typename?: 'selection_feedback_aggregate';
  aggregate?: Maybe<Selection_Feedback_Aggregate_Fields>;
  nodes: Array<Selection_Feedback>;
};

export type Selection_Feedback_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Selection_Feedback_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Selection_Feedback_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Selection_Feedback_Aggregate_Bool_Exp_Count>;
};

export type Selection_Feedback_Aggregate_Bool_Exp_Bool_And = {
  arguments: Selection_Feedback_Select_Column_Selection_Feedback_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Selection_Feedback_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Selection_Feedback_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Selection_Feedback_Select_Column_Selection_Feedback_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Selection_Feedback_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Selection_Feedback_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Selection_Feedback_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Selection_Feedback_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "selection_feedback" */
export type Selection_Feedback_Aggregate_Fields = {
  __typename?: 'selection_feedback_aggregate_fields';
  avg?: Maybe<Selection_Feedback_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Selection_Feedback_Max_Fields>;
  min?: Maybe<Selection_Feedback_Min_Fields>;
  stddev?: Maybe<Selection_Feedback_Stddev_Fields>;
  stddev_pop?: Maybe<Selection_Feedback_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Selection_Feedback_Stddev_Samp_Fields>;
  sum?: Maybe<Selection_Feedback_Sum_Fields>;
  var_pop?: Maybe<Selection_Feedback_Var_Pop_Fields>;
  var_samp?: Maybe<Selection_Feedback_Var_Samp_Fields>;
  variance?: Maybe<Selection_Feedback_Variance_Fields>;
};


/** aggregate fields of "selection_feedback" */
export type Selection_Feedback_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Selection_Feedback_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "selection_feedback" */
export type Selection_Feedback_Aggregate_Order_By = {
  avg?: InputMaybe<Selection_Feedback_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Selection_Feedback_Max_Order_By>;
  min?: InputMaybe<Selection_Feedback_Min_Order_By>;
  stddev?: InputMaybe<Selection_Feedback_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Selection_Feedback_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Selection_Feedback_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Selection_Feedback_Sum_Order_By>;
  var_pop?: InputMaybe<Selection_Feedback_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Selection_Feedback_Var_Samp_Order_By>;
  variance?: InputMaybe<Selection_Feedback_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "selection_feedback" */
export type Selection_Feedback_Arr_Rel_Insert_Input = {
  data: Array<Selection_Feedback_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Selection_Feedback_On_Conflict>;
};

/** aggregate avg on columns */
export type Selection_Feedback_Avg_Fields = {
  __typename?: 'selection_feedback_avg_fields';
  id?: Maybe<Scalars['Float']>;
  real_user_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "selection_feedback" */
export type Selection_Feedback_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  real_user_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "selection_feedback". All fields are combined with a logical 'AND'. */
export type Selection_Feedback_Bool_Exp = {
  _and?: InputMaybe<Array<Selection_Feedback_Bool_Exp>>;
  _not?: InputMaybe<Selection_Feedback_Bool_Exp>;
  _or?: InputMaybe<Array<Selection_Feedback_Bool_Exp>>;
  censored?: InputMaybe<Boolean_Comparison_Exp>;
  comments?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  real_user_id?: InputMaybe<Int_Comparison_Exp>;
  tags?: InputMaybe<String_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "selection_feedback" */
export enum Selection_Feedback_Constraint {
  /** unique or primary key constraint on columns "id" */
  SelectionFeedbackPkey = 'selection_feedback_pkey',
  /** unique or primary key constraint on columns "real_user_id", "team_id" */
  SelectionFeedbackTeamIdRealUserIdKey = 'selection_feedback_team_id_real_user_id_key'
}

/** input type for incrementing numeric columns in table "selection_feedback" */
export type Selection_Feedback_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  real_user_id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "selection_feedback" */
export type Selection_Feedback_Insert_Input = {
  censored?: InputMaybe<Scalars['Boolean']>;
  comments?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  real_user_id?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Scalars['String']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Selection_Feedback_Max_Fields = {
  __typename?: 'selection_feedback_max_fields';
  comments?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  real_user_id?: Maybe<Scalars['Int']>;
  tags?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "selection_feedback" */
export type Selection_Feedback_Max_Order_By = {
  comments?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  real_user_id?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Selection_Feedback_Min_Fields = {
  __typename?: 'selection_feedback_min_fields';
  comments?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  real_user_id?: Maybe<Scalars['Int']>;
  tags?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "selection_feedback" */
export type Selection_Feedback_Min_Order_By = {
  comments?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  real_user_id?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "selection_feedback" */
export type Selection_Feedback_Mutation_Response = {
  __typename?: 'selection_feedback_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Selection_Feedback>;
};

/** on_conflict condition type for table "selection_feedback" */
export type Selection_Feedback_On_Conflict = {
  constraint: Selection_Feedback_Constraint;
  update_columns?: Array<Selection_Feedback_Update_Column>;
  where?: InputMaybe<Selection_Feedback_Bool_Exp>;
};

/** Ordering options when selecting data from "selection_feedback". */
export type Selection_Feedback_Order_By = {
  censored?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  real_user_id?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: selection_feedback */
export type Selection_Feedback_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "selection_feedback" */
export enum Selection_Feedback_Select_Column {
  /** column name */
  Censored = 'censored',
  /** column name */
  Comments = 'comments',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  RealUserId = 'real_user_id',
  /** column name */
  Tags = 'tags',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "selection_feedback_aggregate_bool_exp_bool_and_arguments_columns" columns of table "selection_feedback" */
export enum Selection_Feedback_Select_Column_Selection_Feedback_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Censored = 'censored'
}

/** select "selection_feedback_aggregate_bool_exp_bool_or_arguments_columns" columns of table "selection_feedback" */
export enum Selection_Feedback_Select_Column_Selection_Feedback_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Censored = 'censored'
}

/** input type for updating data in table "selection_feedback" */
export type Selection_Feedback_Set_Input = {
  censored?: InputMaybe<Scalars['Boolean']>;
  comments?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  real_user_id?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Scalars['String']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Selection_Feedback_Stddev_Fields = {
  __typename?: 'selection_feedback_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  real_user_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "selection_feedback" */
export type Selection_Feedback_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  real_user_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Selection_Feedback_Stddev_Pop_Fields = {
  __typename?: 'selection_feedback_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  real_user_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "selection_feedback" */
export type Selection_Feedback_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  real_user_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Selection_Feedback_Stddev_Samp_Fields = {
  __typename?: 'selection_feedback_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  real_user_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "selection_feedback" */
export type Selection_Feedback_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  real_user_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "selection_feedback" */
export type Selection_Feedback_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Selection_Feedback_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Selection_Feedback_Stream_Cursor_Value_Input = {
  censored?: InputMaybe<Scalars['Boolean']>;
  comments?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  real_user_id?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Scalars['String']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Selection_Feedback_Sum_Fields = {
  __typename?: 'selection_feedback_sum_fields';
  id?: Maybe<Scalars['Int']>;
  real_user_id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "selection_feedback" */
export type Selection_Feedback_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  real_user_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** update columns of table "selection_feedback" */
export enum Selection_Feedback_Update_Column {
  /** column name */
  Censored = 'censored',
  /** column name */
  Comments = 'comments',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  RealUserId = 'real_user_id',
  /** column name */
  Tags = 'tags',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Selection_Feedback_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Selection_Feedback_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Selection_Feedback_Set_Input>;
  /** filter the rows which have to be updated */
  where: Selection_Feedback_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Selection_Feedback_Var_Pop_Fields = {
  __typename?: 'selection_feedback_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  real_user_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "selection_feedback" */
export type Selection_Feedback_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  real_user_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Selection_Feedback_Var_Samp_Fields = {
  __typename?: 'selection_feedback_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  real_user_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "selection_feedback" */
export type Selection_Feedback_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  real_user_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Selection_Feedback_Variance_Fields = {
  __typename?: 'selection_feedback_variance_fields';
  id?: Maybe<Scalars['Float']>;
  real_user_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "selection_feedback" */
export type Selection_Feedback_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  real_user_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "selection_metrics" */
export type Selection_Metrics = {
  __typename?: 'selection_metrics';
  /** An object relationship */
  award: Awards;
  award_id: Scalars['numeric'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  real_user_id: Scalars['Int'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['numeric'];
  updated_at: Scalars['timestamptz'];
  user_id?: Maybe<Scalars['String']>;
  value: Scalars['Int'];
};

/** aggregated selection of "selection_metrics" */
export type Selection_Metrics_Aggregate = {
  __typename?: 'selection_metrics_aggregate';
  aggregate?: Maybe<Selection_Metrics_Aggregate_Fields>;
  nodes: Array<Selection_Metrics>;
};

export type Selection_Metrics_Aggregate_Bool_Exp = {
  count?: InputMaybe<Selection_Metrics_Aggregate_Bool_Exp_Count>;
};

export type Selection_Metrics_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Selection_Metrics_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Selection_Metrics_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "selection_metrics" */
export type Selection_Metrics_Aggregate_Fields = {
  __typename?: 'selection_metrics_aggregate_fields';
  avg?: Maybe<Selection_Metrics_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Selection_Metrics_Max_Fields>;
  min?: Maybe<Selection_Metrics_Min_Fields>;
  stddev?: Maybe<Selection_Metrics_Stddev_Fields>;
  stddev_pop?: Maybe<Selection_Metrics_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Selection_Metrics_Stddev_Samp_Fields>;
  sum?: Maybe<Selection_Metrics_Sum_Fields>;
  var_pop?: Maybe<Selection_Metrics_Var_Pop_Fields>;
  var_samp?: Maybe<Selection_Metrics_Var_Samp_Fields>;
  variance?: Maybe<Selection_Metrics_Variance_Fields>;
};


/** aggregate fields of "selection_metrics" */
export type Selection_Metrics_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Selection_Metrics_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "selection_metrics" */
export type Selection_Metrics_Aggregate_Order_By = {
  avg?: InputMaybe<Selection_Metrics_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Selection_Metrics_Max_Order_By>;
  min?: InputMaybe<Selection_Metrics_Min_Order_By>;
  stddev?: InputMaybe<Selection_Metrics_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Selection_Metrics_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Selection_Metrics_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Selection_Metrics_Sum_Order_By>;
  var_pop?: InputMaybe<Selection_Metrics_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Selection_Metrics_Var_Samp_Order_By>;
  variance?: InputMaybe<Selection_Metrics_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "selection_metrics" */
export type Selection_Metrics_Arr_Rel_Insert_Input = {
  data: Array<Selection_Metrics_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Selection_Metrics_On_Conflict>;
};

/** aggregate avg on columns */
export type Selection_Metrics_Avg_Fields = {
  __typename?: 'selection_metrics_avg_fields';
  award_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  real_user_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "selection_metrics" */
export type Selection_Metrics_Avg_Order_By = {
  award_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  real_user_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "selection_metrics". All fields are combined with a logical 'AND'. */
export type Selection_Metrics_Bool_Exp = {
  _and?: InputMaybe<Array<Selection_Metrics_Bool_Exp>>;
  _not?: InputMaybe<Selection_Metrics_Bool_Exp>;
  _or?: InputMaybe<Array<Selection_Metrics_Bool_Exp>>;
  award?: InputMaybe<Awards_Bool_Exp>;
  award_id?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  real_user_id?: InputMaybe<Int_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "selection_metrics" */
export enum Selection_Metrics_Constraint {
  /** unique or primary key constraint on columns "id" */
  SelectionMetricsPkey = 'selection_metrics_pkey',
  /** unique or primary key constraint on columns "award_id", "real_user_id", "team_id" */
  SelectionMetricsRealUserIdTeamIdAwardIdKey = 'selection_metrics_real_user_id_team_id_award_id_key'
}

/** input type for incrementing numeric columns in table "selection_metrics" */
export type Selection_Metrics_Inc_Input = {
  award_id?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  real_user_id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "selection_metrics" */
export type Selection_Metrics_Insert_Input = {
  award?: InputMaybe<Awards_Obj_Rel_Insert_Input>;
  award_id?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  real_user_id?: InputMaybe<Scalars['Int']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Selection_Metrics_Max_Fields = {
  __typename?: 'selection_metrics_max_fields';
  award_id?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  real_user_id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "selection_metrics" */
export type Selection_Metrics_Max_Order_By = {
  award_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  real_user_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Selection_Metrics_Min_Fields = {
  __typename?: 'selection_metrics_min_fields';
  award_id?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  real_user_id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "selection_metrics" */
export type Selection_Metrics_Min_Order_By = {
  award_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  real_user_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "selection_metrics" */
export type Selection_Metrics_Mutation_Response = {
  __typename?: 'selection_metrics_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Selection_Metrics>;
};

/** on_conflict condition type for table "selection_metrics" */
export type Selection_Metrics_On_Conflict = {
  constraint: Selection_Metrics_Constraint;
  update_columns?: Array<Selection_Metrics_Update_Column>;
  where?: InputMaybe<Selection_Metrics_Bool_Exp>;
};

/** Ordering options when selecting data from "selection_metrics". */
export type Selection_Metrics_Order_By = {
  award?: InputMaybe<Awards_Order_By>;
  award_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  real_user_id?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: selection_metrics */
export type Selection_Metrics_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "selection_metrics" */
export enum Selection_Metrics_Select_Column {
  /** column name */
  AwardId = 'award_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  RealUserId = 'real_user_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "selection_metrics" */
export type Selection_Metrics_Set_Input = {
  award_id?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  real_user_id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Selection_Metrics_Stddev_Fields = {
  __typename?: 'selection_metrics_stddev_fields';
  award_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  real_user_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "selection_metrics" */
export type Selection_Metrics_Stddev_Order_By = {
  award_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  real_user_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Selection_Metrics_Stddev_Pop_Fields = {
  __typename?: 'selection_metrics_stddev_pop_fields';
  award_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  real_user_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "selection_metrics" */
export type Selection_Metrics_Stddev_Pop_Order_By = {
  award_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  real_user_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Selection_Metrics_Stddev_Samp_Fields = {
  __typename?: 'selection_metrics_stddev_samp_fields';
  award_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  real_user_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "selection_metrics" */
export type Selection_Metrics_Stddev_Samp_Order_By = {
  award_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  real_user_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "selection_metrics" */
export type Selection_Metrics_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Selection_Metrics_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Selection_Metrics_Stream_Cursor_Value_Input = {
  award_id?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  real_user_id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Selection_Metrics_Sum_Fields = {
  __typename?: 'selection_metrics_sum_fields';
  award_id?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  real_user_id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['numeric']>;
  value?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "selection_metrics" */
export type Selection_Metrics_Sum_Order_By = {
  award_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  real_user_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** update columns of table "selection_metrics" */
export enum Selection_Metrics_Update_Column {
  /** column name */
  AwardId = 'award_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  RealUserId = 'real_user_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Value = 'value'
}

export type Selection_Metrics_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Selection_Metrics_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Selection_Metrics_Set_Input>;
  /** filter the rows which have to be updated */
  where: Selection_Metrics_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Selection_Metrics_Var_Pop_Fields = {
  __typename?: 'selection_metrics_var_pop_fields';
  award_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  real_user_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "selection_metrics" */
export type Selection_Metrics_Var_Pop_Order_By = {
  award_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  real_user_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Selection_Metrics_Var_Samp_Fields = {
  __typename?: 'selection_metrics_var_samp_fields';
  award_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  real_user_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "selection_metrics" */
export type Selection_Metrics_Var_Samp_Order_By = {
  award_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  real_user_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Selection_Metrics_Variance_Fields = {
  __typename?: 'selection_metrics_variance_fields';
  award_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  real_user_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "selection_metrics" */
export type Selection_Metrics_Variance_Order_By = {
  award_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  real_user_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** columns and relationships of "selection_progress" */
export type Selection_Progress = {
  __typename?: 'selection_progress';
  created_at: Scalars['timestamptz'];
  film_group_id: Scalars['Int'];
  id: Scalars['Int'];
  index: Scalars['Int'];
  real_user_id: Scalars['Int'];
  seek: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "selection_progress" */
export type Selection_Progress_Aggregate = {
  __typename?: 'selection_progress_aggregate';
  aggregate?: Maybe<Selection_Progress_Aggregate_Fields>;
  nodes: Array<Selection_Progress>;
};

export type Selection_Progress_Aggregate_Bool_Exp = {
  count?: InputMaybe<Selection_Progress_Aggregate_Bool_Exp_Count>;
};

export type Selection_Progress_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Selection_Progress_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Selection_Progress_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "selection_progress" */
export type Selection_Progress_Aggregate_Fields = {
  __typename?: 'selection_progress_aggregate_fields';
  avg?: Maybe<Selection_Progress_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Selection_Progress_Max_Fields>;
  min?: Maybe<Selection_Progress_Min_Fields>;
  stddev?: Maybe<Selection_Progress_Stddev_Fields>;
  stddev_pop?: Maybe<Selection_Progress_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Selection_Progress_Stddev_Samp_Fields>;
  sum?: Maybe<Selection_Progress_Sum_Fields>;
  var_pop?: Maybe<Selection_Progress_Var_Pop_Fields>;
  var_samp?: Maybe<Selection_Progress_Var_Samp_Fields>;
  variance?: Maybe<Selection_Progress_Variance_Fields>;
};


/** aggregate fields of "selection_progress" */
export type Selection_Progress_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Selection_Progress_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "selection_progress" */
export type Selection_Progress_Aggregate_Order_By = {
  avg?: InputMaybe<Selection_Progress_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Selection_Progress_Max_Order_By>;
  min?: InputMaybe<Selection_Progress_Min_Order_By>;
  stddev?: InputMaybe<Selection_Progress_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Selection_Progress_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Selection_Progress_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Selection_Progress_Sum_Order_By>;
  var_pop?: InputMaybe<Selection_Progress_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Selection_Progress_Var_Samp_Order_By>;
  variance?: InputMaybe<Selection_Progress_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "selection_progress" */
export type Selection_Progress_Arr_Rel_Insert_Input = {
  data: Array<Selection_Progress_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Selection_Progress_On_Conflict>;
};

/** aggregate avg on columns */
export type Selection_Progress_Avg_Fields = {
  __typename?: 'selection_progress_avg_fields';
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  index?: Maybe<Scalars['Float']>;
  real_user_id?: Maybe<Scalars['Float']>;
  seek?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "selection_progress" */
export type Selection_Progress_Avg_Order_By = {
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  real_user_id?: InputMaybe<Order_By>;
  seek?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "selection_progress". All fields are combined with a logical 'AND'. */
export type Selection_Progress_Bool_Exp = {
  _and?: InputMaybe<Array<Selection_Progress_Bool_Exp>>;
  _not?: InputMaybe<Selection_Progress_Bool_Exp>;
  _or?: InputMaybe<Array<Selection_Progress_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  film_group_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  index?: InputMaybe<Int_Comparison_Exp>;
  real_user_id?: InputMaybe<Int_Comparison_Exp>;
  seek?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "selection_progress" */
export enum Selection_Progress_Constraint {
  /** unique or primary key constraint on columns "film_group_id", "real_user_id" */
  SelectionProgressFilmGroupIdRealUserIdKey = 'selection_progress_film_group_id_real_user_id_key',
  /** unique or primary key constraint on columns "id" */
  SelectionProgressPkey = 'selection_progress_pkey'
}

/** input type for incrementing numeric columns in table "selection_progress" */
export type Selection_Progress_Inc_Input = {
  film_group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  index?: InputMaybe<Scalars['Int']>;
  real_user_id?: InputMaybe<Scalars['Int']>;
  seek?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "selection_progress" */
export type Selection_Progress_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  film_group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  index?: InputMaybe<Scalars['Int']>;
  real_user_id?: InputMaybe<Scalars['Int']>;
  seek?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Selection_Progress_Max_Fields = {
  __typename?: 'selection_progress_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  film_group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  index?: Maybe<Scalars['Int']>;
  real_user_id?: Maybe<Scalars['Int']>;
  seek?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "selection_progress" */
export type Selection_Progress_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  real_user_id?: InputMaybe<Order_By>;
  seek?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Selection_Progress_Min_Fields = {
  __typename?: 'selection_progress_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  film_group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  index?: Maybe<Scalars['Int']>;
  real_user_id?: Maybe<Scalars['Int']>;
  seek?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "selection_progress" */
export type Selection_Progress_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  real_user_id?: InputMaybe<Order_By>;
  seek?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "selection_progress" */
export type Selection_Progress_Mutation_Response = {
  __typename?: 'selection_progress_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Selection_Progress>;
};

/** on_conflict condition type for table "selection_progress" */
export type Selection_Progress_On_Conflict = {
  constraint: Selection_Progress_Constraint;
  update_columns?: Array<Selection_Progress_Update_Column>;
  where?: InputMaybe<Selection_Progress_Bool_Exp>;
};

/** Ordering options when selecting data from "selection_progress". */
export type Selection_Progress_Order_By = {
  created_at?: InputMaybe<Order_By>;
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  real_user_id?: InputMaybe<Order_By>;
  seek?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: selection_progress */
export type Selection_Progress_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "selection_progress" */
export enum Selection_Progress_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FilmGroupId = 'film_group_id',
  /** column name */
  Id = 'id',
  /** column name */
  Index = 'index',
  /** column name */
  RealUserId = 'real_user_id',
  /** column name */
  Seek = 'seek',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "selection_progress" */
export type Selection_Progress_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  film_group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  index?: InputMaybe<Scalars['Int']>;
  real_user_id?: InputMaybe<Scalars['Int']>;
  seek?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Selection_Progress_Stddev_Fields = {
  __typename?: 'selection_progress_stddev_fields';
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  index?: Maybe<Scalars['Float']>;
  real_user_id?: Maybe<Scalars['Float']>;
  seek?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "selection_progress" */
export type Selection_Progress_Stddev_Order_By = {
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  real_user_id?: InputMaybe<Order_By>;
  seek?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Selection_Progress_Stddev_Pop_Fields = {
  __typename?: 'selection_progress_stddev_pop_fields';
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  index?: Maybe<Scalars['Float']>;
  real_user_id?: Maybe<Scalars['Float']>;
  seek?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "selection_progress" */
export type Selection_Progress_Stddev_Pop_Order_By = {
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  real_user_id?: InputMaybe<Order_By>;
  seek?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Selection_Progress_Stddev_Samp_Fields = {
  __typename?: 'selection_progress_stddev_samp_fields';
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  index?: Maybe<Scalars['Float']>;
  real_user_id?: Maybe<Scalars['Float']>;
  seek?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "selection_progress" */
export type Selection_Progress_Stddev_Samp_Order_By = {
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  real_user_id?: InputMaybe<Order_By>;
  seek?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "selection_progress" */
export type Selection_Progress_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Selection_Progress_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Selection_Progress_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  film_group_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  index?: InputMaybe<Scalars['Int']>;
  real_user_id?: InputMaybe<Scalars['Int']>;
  seek?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Selection_Progress_Sum_Fields = {
  __typename?: 'selection_progress_sum_fields';
  film_group_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  index?: Maybe<Scalars['Int']>;
  real_user_id?: Maybe<Scalars['Int']>;
  seek?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "selection_progress" */
export type Selection_Progress_Sum_Order_By = {
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  real_user_id?: InputMaybe<Order_By>;
  seek?: InputMaybe<Order_By>;
};

/** update columns of table "selection_progress" */
export enum Selection_Progress_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FilmGroupId = 'film_group_id',
  /** column name */
  Id = 'id',
  /** column name */
  Index = 'index',
  /** column name */
  RealUserId = 'real_user_id',
  /** column name */
  Seek = 'seek',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Selection_Progress_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Selection_Progress_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Selection_Progress_Set_Input>;
  /** filter the rows which have to be updated */
  where: Selection_Progress_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Selection_Progress_Var_Pop_Fields = {
  __typename?: 'selection_progress_var_pop_fields';
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  index?: Maybe<Scalars['Float']>;
  real_user_id?: Maybe<Scalars['Float']>;
  seek?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "selection_progress" */
export type Selection_Progress_Var_Pop_Order_By = {
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  real_user_id?: InputMaybe<Order_By>;
  seek?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Selection_Progress_Var_Samp_Fields = {
  __typename?: 'selection_progress_var_samp_fields';
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  index?: Maybe<Scalars['Float']>;
  real_user_id?: Maybe<Scalars['Float']>;
  seek?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "selection_progress" */
export type Selection_Progress_Var_Samp_Order_By = {
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  real_user_id?: InputMaybe<Order_By>;
  seek?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Selection_Progress_Variance_Fields = {
  __typename?: 'selection_progress_variance_fields';
  film_group_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  index?: Maybe<Scalars['Float']>;
  real_user_id?: Maybe<Scalars['Float']>;
  seek?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "selection_progress" */
export type Selection_Progress_Variance_Order_By = {
  film_group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  real_user_id?: InputMaybe<Order_By>;
  seek?: InputMaybe<Order_By>;
};

/** columns and relationships of "selection_results" */
export type Selection_Results = {
  __typename?: 'selection_results';
  /** An object relationship */
  award?: Maybe<Awards>;
  award_id?: Maybe<Scalars['numeric']>;
  overall_score?: Maybe<Scalars['numeric']>;
  peer_review_score?: Maybe<Scalars['numeric']>;
  selection_committee_score?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  team?: Maybe<Teams>;
  team_id?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "selection_results" */
export type Selection_Results_Aggregate = {
  __typename?: 'selection_results_aggregate';
  aggregate?: Maybe<Selection_Results_Aggregate_Fields>;
  nodes: Array<Selection_Results>;
};

/** aggregate fields of "selection_results" */
export type Selection_Results_Aggregate_Fields = {
  __typename?: 'selection_results_aggregate_fields';
  avg?: Maybe<Selection_Results_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Selection_Results_Max_Fields>;
  min?: Maybe<Selection_Results_Min_Fields>;
  stddev?: Maybe<Selection_Results_Stddev_Fields>;
  stddev_pop?: Maybe<Selection_Results_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Selection_Results_Stddev_Samp_Fields>;
  sum?: Maybe<Selection_Results_Sum_Fields>;
  var_pop?: Maybe<Selection_Results_Var_Pop_Fields>;
  var_samp?: Maybe<Selection_Results_Var_Samp_Fields>;
  variance?: Maybe<Selection_Results_Variance_Fields>;
};


/** aggregate fields of "selection_results" */
export type Selection_Results_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Selection_Results_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Selection_Results_Avg_Fields = {
  __typename?: 'selection_results_avg_fields';
  award_id?: Maybe<Scalars['Float']>;
  overall_score?: Maybe<Scalars['Float']>;
  peer_review_score?: Maybe<Scalars['Float']>;
  selection_committee_score?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "selection_results". All fields are combined with a logical 'AND'. */
export type Selection_Results_Bool_Exp = {
  _and?: InputMaybe<Array<Selection_Results_Bool_Exp>>;
  _not?: InputMaybe<Selection_Results_Bool_Exp>;
  _or?: InputMaybe<Array<Selection_Results_Bool_Exp>>;
  award?: InputMaybe<Awards_Bool_Exp>;
  award_id?: InputMaybe<Numeric_Comparison_Exp>;
  overall_score?: InputMaybe<Numeric_Comparison_Exp>;
  peer_review_score?: InputMaybe<Numeric_Comparison_Exp>;
  selection_committee_score?: InputMaybe<Numeric_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Selection_Results_Max_Fields = {
  __typename?: 'selection_results_max_fields';
  award_id?: Maybe<Scalars['numeric']>;
  overall_score?: Maybe<Scalars['numeric']>;
  peer_review_score?: Maybe<Scalars['numeric']>;
  selection_committee_score?: Maybe<Scalars['numeric']>;
  team_id?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Selection_Results_Min_Fields = {
  __typename?: 'selection_results_min_fields';
  award_id?: Maybe<Scalars['numeric']>;
  overall_score?: Maybe<Scalars['numeric']>;
  peer_review_score?: Maybe<Scalars['numeric']>;
  selection_committee_score?: Maybe<Scalars['numeric']>;
  team_id?: Maybe<Scalars['numeric']>;
};

/** Ordering options when selecting data from "selection_results". */
export type Selection_Results_Order_By = {
  award?: InputMaybe<Awards_Order_By>;
  award_id?: InputMaybe<Order_By>;
  overall_score?: InputMaybe<Order_By>;
  peer_review_score?: InputMaybe<Order_By>;
  selection_committee_score?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** select columns of table "selection_results" */
export enum Selection_Results_Select_Column {
  /** column name */
  AwardId = 'award_id',
  /** column name */
  OverallScore = 'overall_score',
  /** column name */
  PeerReviewScore = 'peer_review_score',
  /** column name */
  SelectionCommitteeScore = 'selection_committee_score',
  /** column name */
  TeamId = 'team_id'
}

/** aggregate stddev on columns */
export type Selection_Results_Stddev_Fields = {
  __typename?: 'selection_results_stddev_fields';
  award_id?: Maybe<Scalars['Float']>;
  overall_score?: Maybe<Scalars['Float']>;
  peer_review_score?: Maybe<Scalars['Float']>;
  selection_committee_score?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Selection_Results_Stddev_Pop_Fields = {
  __typename?: 'selection_results_stddev_pop_fields';
  award_id?: Maybe<Scalars['Float']>;
  overall_score?: Maybe<Scalars['Float']>;
  peer_review_score?: Maybe<Scalars['Float']>;
  selection_committee_score?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Selection_Results_Stddev_Samp_Fields = {
  __typename?: 'selection_results_stddev_samp_fields';
  award_id?: Maybe<Scalars['Float']>;
  overall_score?: Maybe<Scalars['Float']>;
  peer_review_score?: Maybe<Scalars['Float']>;
  selection_committee_score?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "selection_results" */
export type Selection_Results_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Selection_Results_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Selection_Results_Stream_Cursor_Value_Input = {
  award_id?: InputMaybe<Scalars['numeric']>;
  overall_score?: InputMaybe<Scalars['numeric']>;
  peer_review_score?: InputMaybe<Scalars['numeric']>;
  selection_committee_score?: InputMaybe<Scalars['numeric']>;
  team_id?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Selection_Results_Sum_Fields = {
  __typename?: 'selection_results_sum_fields';
  award_id?: Maybe<Scalars['numeric']>;
  overall_score?: Maybe<Scalars['numeric']>;
  peer_review_score?: Maybe<Scalars['numeric']>;
  selection_committee_score?: Maybe<Scalars['numeric']>;
  team_id?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Selection_Results_Var_Pop_Fields = {
  __typename?: 'selection_results_var_pop_fields';
  award_id?: Maybe<Scalars['Float']>;
  overall_score?: Maybe<Scalars['Float']>;
  peer_review_score?: Maybe<Scalars['Float']>;
  selection_committee_score?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Selection_Results_Var_Samp_Fields = {
  __typename?: 'selection_results_var_samp_fields';
  award_id?: Maybe<Scalars['Float']>;
  overall_score?: Maybe<Scalars['Float']>;
  peer_review_score?: Maybe<Scalars['Float']>;
  selection_committee_score?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Selection_Results_Variance_Fields = {
  __typename?: 'selection_results_variance_fields';
  award_id?: Maybe<Scalars['Float']>;
  overall_score?: Maybe<Scalars['Float']>;
  peer_review_score?: Maybe<Scalars['Float']>;
  selection_committee_score?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "sharables" */
export type Sharables = {
  __typename?: 'sharables';
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  mux_playback_id: Scalars['String'];
  mux_thumb_time?: Maybe<Scalars['numeric']>;
  title: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "sharables" */
export type Sharables_Aggregate = {
  __typename?: 'sharables_aggregate';
  aggregate?: Maybe<Sharables_Aggregate_Fields>;
  nodes: Array<Sharables>;
};

/** aggregate fields of "sharables" */
export type Sharables_Aggregate_Fields = {
  __typename?: 'sharables_aggregate_fields';
  avg?: Maybe<Sharables_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Sharables_Max_Fields>;
  min?: Maybe<Sharables_Min_Fields>;
  stddev?: Maybe<Sharables_Stddev_Fields>;
  stddev_pop?: Maybe<Sharables_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sharables_Stddev_Samp_Fields>;
  sum?: Maybe<Sharables_Sum_Fields>;
  var_pop?: Maybe<Sharables_Var_Pop_Fields>;
  var_samp?: Maybe<Sharables_Var_Samp_Fields>;
  variance?: Maybe<Sharables_Variance_Fields>;
};


/** aggregate fields of "sharables" */
export type Sharables_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sharables_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Sharables_Avg_Fields = {
  __typename?: 'sharables_avg_fields';
  id?: Maybe<Scalars['Float']>;
  mux_thumb_time?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "sharables". All fields are combined with a logical 'AND'. */
export type Sharables_Bool_Exp = {
  _and?: InputMaybe<Array<Sharables_Bool_Exp>>;
  _not?: InputMaybe<Sharables_Bool_Exp>;
  _or?: InputMaybe<Array<Sharables_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  mux_playback_id?: InputMaybe<String_Comparison_Exp>;
  mux_thumb_time?: InputMaybe<Numeric_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "sharables" */
export enum Sharables_Constraint {
  /** unique or primary key constraint on columns "id" */
  SharablesPkey = 'sharables_pkey'
}

/** input type for incrementing numeric columns in table "sharables" */
export type Sharables_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  mux_thumb_time?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "sharables" */
export type Sharables_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  mux_playback_id?: InputMaybe<Scalars['String']>;
  mux_thumb_time?: InputMaybe<Scalars['numeric']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Sharables_Max_Fields = {
  __typename?: 'sharables_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  mux_playback_id?: Maybe<Scalars['String']>;
  mux_thumb_time?: Maybe<Scalars['numeric']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Sharables_Min_Fields = {
  __typename?: 'sharables_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  mux_playback_id?: Maybe<Scalars['String']>;
  mux_thumb_time?: Maybe<Scalars['numeric']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "sharables" */
export type Sharables_Mutation_Response = {
  __typename?: 'sharables_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sharables>;
};

/** on_conflict condition type for table "sharables" */
export type Sharables_On_Conflict = {
  constraint: Sharables_Constraint;
  update_columns?: Array<Sharables_Update_Column>;
  where?: InputMaybe<Sharables_Bool_Exp>;
};

/** Ordering options when selecting data from "sharables". */
export type Sharables_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mux_playback_id?: InputMaybe<Order_By>;
  mux_thumb_time?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sharables */
export type Sharables_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "sharables" */
export enum Sharables_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  MuxPlaybackId = 'mux_playback_id',
  /** column name */
  MuxThumbTime = 'mux_thumb_time',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "sharables" */
export type Sharables_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  mux_playback_id?: InputMaybe<Scalars['String']>;
  mux_thumb_time?: InputMaybe<Scalars['numeric']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Sharables_Stddev_Fields = {
  __typename?: 'sharables_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  mux_thumb_time?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Sharables_Stddev_Pop_Fields = {
  __typename?: 'sharables_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  mux_thumb_time?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Sharables_Stddev_Samp_Fields = {
  __typename?: 'sharables_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  mux_thumb_time?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "sharables" */
export type Sharables_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sharables_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sharables_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  mux_playback_id?: InputMaybe<Scalars['String']>;
  mux_thumb_time?: InputMaybe<Scalars['numeric']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Sharables_Sum_Fields = {
  __typename?: 'sharables_sum_fields';
  id?: Maybe<Scalars['Int']>;
  mux_thumb_time?: Maybe<Scalars['numeric']>;
};

/** update columns of table "sharables" */
export enum Sharables_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  MuxPlaybackId = 'mux_playback_id',
  /** column name */
  MuxThumbTime = 'mux_thumb_time',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Sharables_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sharables_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sharables_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sharables_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sharables_Var_Pop_Fields = {
  __typename?: 'sharables_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  mux_thumb_time?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Sharables_Var_Samp_Fields = {
  __typename?: 'sharables_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  mux_thumb_time?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Sharables_Variance_Fields = {
  __typename?: 'sharables_variance_fields';
  id?: Maybe<Scalars['Float']>;
  mux_thumb_time?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "sms_votes" */
export type Sms_Votes = {
  __typename?: 'sms_votes';
  body: Scalars['String'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  phone: Scalars['String'];
  team_id?: Maybe<Scalars['numeric']>;
  team_number?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
  voided_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "sms_votes" */
export type Sms_Votes_Aggregate = {
  __typename?: 'sms_votes_aggregate';
  aggregate?: Maybe<Sms_Votes_Aggregate_Fields>;
  nodes: Array<Sms_Votes>;
};

/** aggregate fields of "sms_votes" */
export type Sms_Votes_Aggregate_Fields = {
  __typename?: 'sms_votes_aggregate_fields';
  avg?: Maybe<Sms_Votes_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Sms_Votes_Max_Fields>;
  min?: Maybe<Sms_Votes_Min_Fields>;
  stddev?: Maybe<Sms_Votes_Stddev_Fields>;
  stddev_pop?: Maybe<Sms_Votes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sms_Votes_Stddev_Samp_Fields>;
  sum?: Maybe<Sms_Votes_Sum_Fields>;
  var_pop?: Maybe<Sms_Votes_Var_Pop_Fields>;
  var_samp?: Maybe<Sms_Votes_Var_Samp_Fields>;
  variance?: Maybe<Sms_Votes_Variance_Fields>;
};


/** aggregate fields of "sms_votes" */
export type Sms_Votes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sms_Votes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Sms_Votes_Avg_Fields = {
  __typename?: 'sms_votes_avg_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  team_number?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "sms_votes". All fields are combined with a logical 'AND'. */
export type Sms_Votes_Bool_Exp = {
  _and?: InputMaybe<Array<Sms_Votes_Bool_Exp>>;
  _not?: InputMaybe<Sms_Votes_Bool_Exp>;
  _or?: InputMaybe<Array<Sms_Votes_Bool_Exp>>;
  body?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  team_id?: InputMaybe<Numeric_Comparison_Exp>;
  team_number?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  voided_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "sms_votes" */
export enum Sms_Votes_Constraint {
  /** unique or primary key constraint on columns "id" */
  SmsVotesPkey = 'sms_votes_pkey'
}

/** input type for incrementing numeric columns in table "sms_votes" */
export type Sms_Votes_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  team_number?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "sms_votes" */
export type Sms_Votes_Insert_Input = {
  body?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  team_number?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  voided_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Sms_Votes_Max_Fields = {
  __typename?: 'sms_votes_max_fields';
  body?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['numeric']>;
  team_number?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  voided_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Sms_Votes_Min_Fields = {
  __typename?: 'sms_votes_min_fields';
  body?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['numeric']>;
  team_number?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  voided_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "sms_votes" */
export type Sms_Votes_Mutation_Response = {
  __typename?: 'sms_votes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sms_Votes>;
};

/** on_conflict condition type for table "sms_votes" */
export type Sms_Votes_On_Conflict = {
  constraint: Sms_Votes_Constraint;
  update_columns?: Array<Sms_Votes_Update_Column>;
  where?: InputMaybe<Sms_Votes_Bool_Exp>;
};

/** Ordering options when selecting data from "sms_votes". */
export type Sms_Votes_Order_By = {
  body?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  team_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  voided_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sms_votes */
export type Sms_Votes_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "sms_votes" */
export enum Sms_Votes_Select_Column {
  /** column name */
  Body = 'body',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Phone = 'phone',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TeamNumber = 'team_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VoidedAt = 'voided_at'
}

/** input type for updating data in table "sms_votes" */
export type Sms_Votes_Set_Input = {
  body?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  team_number?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  voided_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Sms_Votes_Stddev_Fields = {
  __typename?: 'sms_votes_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  team_number?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Sms_Votes_Stddev_Pop_Fields = {
  __typename?: 'sms_votes_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  team_number?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Sms_Votes_Stddev_Samp_Fields = {
  __typename?: 'sms_votes_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  team_number?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "sms_votes" */
export type Sms_Votes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sms_Votes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sms_Votes_Stream_Cursor_Value_Input = {
  body?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  team_number?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  voided_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Sms_Votes_Sum_Fields = {
  __typename?: 'sms_votes_sum_fields';
  id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['numeric']>;
  team_number?: Maybe<Scalars['Int']>;
};

/** update columns of table "sms_votes" */
export enum Sms_Votes_Update_Column {
  /** column name */
  Body = 'body',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Phone = 'phone',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TeamNumber = 'team_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VoidedAt = 'voided_at'
}

export type Sms_Votes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sms_Votes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sms_Votes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sms_Votes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sms_Votes_Var_Pop_Fields = {
  __typename?: 'sms_votes_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  team_number?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Sms_Votes_Var_Samp_Fields = {
  __typename?: 'sms_votes_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  team_number?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Sms_Votes_Variance_Fields = {
  __typename?: 'sms_votes_variance_fields';
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  team_number?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "sponsors" */
export type Sponsors = {
  __typename?: 'sponsors';
  created: Scalars['timestamp'];
  created_by: Scalars['String'];
  /** An object relationship */
  film_festival: Film_Festivals;
  film_festival_id: Scalars['numeric'];
  id: Scalars['numeric'];
  name?: Maybe<Scalars['String']>;
  the_level?: Maybe<Scalars['String']>;
  updated: Scalars['timestamp'];
  updated_by: Scalars['String'];
  vimeo_url?: Maybe<Scalars['String']>;
};

/** aggregated selection of "sponsors" */
export type Sponsors_Aggregate = {
  __typename?: 'sponsors_aggregate';
  aggregate?: Maybe<Sponsors_Aggregate_Fields>;
  nodes: Array<Sponsors>;
};

export type Sponsors_Aggregate_Bool_Exp = {
  count?: InputMaybe<Sponsors_Aggregate_Bool_Exp_Count>;
};

export type Sponsors_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Sponsors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Sponsors_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "sponsors" */
export type Sponsors_Aggregate_Fields = {
  __typename?: 'sponsors_aggregate_fields';
  avg?: Maybe<Sponsors_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Sponsors_Max_Fields>;
  min?: Maybe<Sponsors_Min_Fields>;
  stddev?: Maybe<Sponsors_Stddev_Fields>;
  stddev_pop?: Maybe<Sponsors_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sponsors_Stddev_Samp_Fields>;
  sum?: Maybe<Sponsors_Sum_Fields>;
  var_pop?: Maybe<Sponsors_Var_Pop_Fields>;
  var_samp?: Maybe<Sponsors_Var_Samp_Fields>;
  variance?: Maybe<Sponsors_Variance_Fields>;
};


/** aggregate fields of "sponsors" */
export type Sponsors_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sponsors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "sponsors" */
export type Sponsors_Aggregate_Order_By = {
  avg?: InputMaybe<Sponsors_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sponsors_Max_Order_By>;
  min?: InputMaybe<Sponsors_Min_Order_By>;
  stddev?: InputMaybe<Sponsors_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Sponsors_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Sponsors_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Sponsors_Sum_Order_By>;
  var_pop?: InputMaybe<Sponsors_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Sponsors_Var_Samp_Order_By>;
  variance?: InputMaybe<Sponsors_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "sponsors" */
export type Sponsors_Arr_Rel_Insert_Input = {
  data: Array<Sponsors_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Sponsors_On_Conflict>;
};

/** aggregate avg on columns */
export type Sponsors_Avg_Fields = {
  __typename?: 'sponsors_avg_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "sponsors" */
export type Sponsors_Avg_Order_By = {
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "sponsors". All fields are combined with a logical 'AND'. */
export type Sponsors_Bool_Exp = {
  _and?: InputMaybe<Array<Sponsors_Bool_Exp>>;
  _not?: InputMaybe<Sponsors_Bool_Exp>;
  _or?: InputMaybe<Array<Sponsors_Bool_Exp>>;
  created?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  film_festival?: InputMaybe<Film_Festivals_Bool_Exp>;
  film_festival_id?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Numeric_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  the_level?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
  vimeo_url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "sponsors" */
export enum Sponsors_Constraint {
  /** unique or primary key constraint on columns "id" */
  SponsorsPkey = 'sponsors_pkey'
}

/** input type for incrementing numeric columns in table "sponsors" */
export type Sponsors_Inc_Input = {
  film_festival_id?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "sponsors" */
export type Sponsors_Insert_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  film_festival?: InputMaybe<Film_Festivals_Obj_Rel_Insert_Input>;
  film_festival_id?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  the_level?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
  vimeo_url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Sponsors_Max_Fields = {
  __typename?: 'sponsors_max_fields';
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  film_festival_id?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  the_level?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
  vimeo_url?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "sponsors" */
export type Sponsors_Max_Order_By = {
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  the_level?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  vimeo_url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sponsors_Min_Fields = {
  __typename?: 'sponsors_min_fields';
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  film_festival_id?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  the_level?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
  vimeo_url?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "sponsors" */
export type Sponsors_Min_Order_By = {
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  the_level?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  vimeo_url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sponsors" */
export type Sponsors_Mutation_Response = {
  __typename?: 'sponsors_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sponsors>;
};

/** input type for inserting object relation for remote table "sponsors" */
export type Sponsors_Obj_Rel_Insert_Input = {
  data: Sponsors_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sponsors_On_Conflict>;
};

/** on_conflict condition type for table "sponsors" */
export type Sponsors_On_Conflict = {
  constraint: Sponsors_Constraint;
  update_columns?: Array<Sponsors_Update_Column>;
  where?: InputMaybe<Sponsors_Bool_Exp>;
};

/** Ordering options when selecting data from "sponsors". */
export type Sponsors_Order_By = {
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  film_festival?: InputMaybe<Film_Festivals_Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  the_level?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  vimeo_url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sponsors */
export type Sponsors_Pk_Columns_Input = {
  id: Scalars['numeric'];
};

/** select columns of table "sponsors" */
export enum Sponsors_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  FilmFestivalId = 'film_festival_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TheLevel = 'the_level',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  VimeoUrl = 'vimeo_url'
}

/** input type for updating data in table "sponsors" */
export type Sponsors_Set_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  film_festival_id?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  the_level?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
  vimeo_url?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Sponsors_Stddev_Fields = {
  __typename?: 'sponsors_stddev_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "sponsors" */
export type Sponsors_Stddev_Order_By = {
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Sponsors_Stddev_Pop_Fields = {
  __typename?: 'sponsors_stddev_pop_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "sponsors" */
export type Sponsors_Stddev_Pop_Order_By = {
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Sponsors_Stddev_Samp_Fields = {
  __typename?: 'sponsors_stddev_samp_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "sponsors" */
export type Sponsors_Stddev_Samp_Order_By = {
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "sponsors" */
export type Sponsors_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sponsors_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sponsors_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  film_festival_id?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  the_level?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
  vimeo_url?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Sponsors_Sum_Fields = {
  __typename?: 'sponsors_sum_fields';
  film_festival_id?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "sponsors" */
export type Sponsors_Sum_Order_By = {
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "sponsors" */
export enum Sponsors_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  FilmFestivalId = 'film_festival_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TheLevel = 'the_level',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  VimeoUrl = 'vimeo_url'
}

export type Sponsors_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sponsors_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sponsors_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sponsors_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sponsors_Var_Pop_Fields = {
  __typename?: 'sponsors_var_pop_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "sponsors" */
export type Sponsors_Var_Pop_Order_By = {
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Sponsors_Var_Samp_Fields = {
  __typename?: 'sponsors_var_samp_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "sponsors" */
export type Sponsors_Var_Samp_Order_By = {
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Sponsors_Variance_Fields = {
  __typename?: 'sponsors_variance_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "sponsors" */
export type Sponsors_Variance_Order_By = {
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "studios" */
export type Studios = {
  __typename?: 'studios';
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  name: Scalars['String'];
  /** An object relationship */
  owner: Users;
  owner_id: Scalars['Int'];
  participating_since?: Maybe<Scalars['String']>;
  slogan?: Maybe<Scalars['String']>;
  /** An array relationship */
  teams: Array<Teams>;
  /** An aggregate relationship */
  teams_aggregate: Teams_Aggregate;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "studios" */
export type StudiosTeamsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


/** columns and relationships of "studios" */
export type StudiosTeams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};

/** aggregated selection of "studios" */
export type Studios_Aggregate = {
  __typename?: 'studios_aggregate';
  aggregate?: Maybe<Studios_Aggregate_Fields>;
  nodes: Array<Studios>;
};

/** aggregate fields of "studios" */
export type Studios_Aggregate_Fields = {
  __typename?: 'studios_aggregate_fields';
  avg?: Maybe<Studios_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Studios_Max_Fields>;
  min?: Maybe<Studios_Min_Fields>;
  stddev?: Maybe<Studios_Stddev_Fields>;
  stddev_pop?: Maybe<Studios_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Studios_Stddev_Samp_Fields>;
  sum?: Maybe<Studios_Sum_Fields>;
  var_pop?: Maybe<Studios_Var_Pop_Fields>;
  var_samp?: Maybe<Studios_Var_Samp_Fields>;
  variance?: Maybe<Studios_Variance_Fields>;
};


/** aggregate fields of "studios" */
export type Studios_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Studios_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Studios_Avg_Fields = {
  __typename?: 'studios_avg_fields';
  id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "studios". All fields are combined with a logical 'AND'. */
export type Studios_Bool_Exp = {
  _and?: InputMaybe<Array<Studios_Bool_Exp>>;
  _not?: InputMaybe<Studios_Bool_Exp>;
  _or?: InputMaybe<Array<Studios_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<Users_Bool_Exp>;
  owner_id?: InputMaybe<Int_Comparison_Exp>;
  participating_since?: InputMaybe<String_Comparison_Exp>;
  slogan?: InputMaybe<String_Comparison_Exp>;
  teams?: InputMaybe<Teams_Bool_Exp>;
  teams_aggregate?: InputMaybe<Teams_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "studios" */
export enum Studios_Constraint {
  /** unique or primary key constraint on columns "name" */
  StudiosNameKey = 'studios_name_key',
  /** unique or primary key constraint on columns "id" */
  StudiosPkey = 'studios_pkey'
}

/** input type for incrementing numeric columns in table "studios" */
export type Studios_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  owner_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "studios" */
export type Studios_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  owner_id?: InputMaybe<Scalars['Int']>;
  participating_since?: InputMaybe<Scalars['String']>;
  slogan?: InputMaybe<Scalars['String']>;
  teams?: InputMaybe<Teams_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Studios_Max_Fields = {
  __typename?: 'studios_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  owner_id?: Maybe<Scalars['Int']>;
  participating_since?: Maybe<Scalars['String']>;
  slogan?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Studios_Min_Fields = {
  __typename?: 'studios_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  owner_id?: Maybe<Scalars['Int']>;
  participating_since?: Maybe<Scalars['String']>;
  slogan?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "studios" */
export type Studios_Mutation_Response = {
  __typename?: 'studios_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Studios>;
};

/** input type for inserting object relation for remote table "studios" */
export type Studios_Obj_Rel_Insert_Input = {
  data: Studios_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Studios_On_Conflict>;
};

/** on_conflict condition type for table "studios" */
export type Studios_On_Conflict = {
  constraint: Studios_Constraint;
  update_columns?: Array<Studios_Update_Column>;
  where?: InputMaybe<Studios_Bool_Exp>;
};

/** Ordering options when selecting data from "studios". */
export type Studios_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Users_Order_By>;
  owner_id?: InputMaybe<Order_By>;
  participating_since?: InputMaybe<Order_By>;
  slogan?: InputMaybe<Order_By>;
  teams_aggregate?: InputMaybe<Teams_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: studios */
export type Studios_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "studios" */
export enum Studios_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  ParticipatingSince = 'participating_since',
  /** column name */
  Slogan = 'slogan',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "studios" */
export type Studios_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['Int']>;
  participating_since?: InputMaybe<Scalars['String']>;
  slogan?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Studios_Stddev_Fields = {
  __typename?: 'studios_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Studios_Stddev_Pop_Fields = {
  __typename?: 'studios_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Studios_Stddev_Samp_Fields = {
  __typename?: 'studios_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "studios" */
export type Studios_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Studios_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Studios_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['Int']>;
  participating_since?: InputMaybe<Scalars['String']>;
  slogan?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Studios_Sum_Fields = {
  __typename?: 'studios_sum_fields';
  id?: Maybe<Scalars['Int']>;
  owner_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "studios" */
export enum Studios_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  ParticipatingSince = 'participating_since',
  /** column name */
  Slogan = 'slogan',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Studios_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Studios_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Studios_Set_Input>;
  /** filter the rows which have to be updated */
  where: Studios_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Studios_Var_Pop_Fields = {
  __typename?: 'studios_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Studios_Var_Samp_Fields = {
  __typename?: 'studios_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Studios_Variance_Fields = {
  __typename?: 'studios_variance_fields';
  id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "submission_summary" */
export type Submission_Summary = {
  __typename?: 'submission_summary';
  film_ts?: Maybe<Scalars['timestamp']>;
  has_reupload?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['numeric']>;
  is_on_time?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  memberships: Array<Team_Memberships>;
  /** An aggregate relationship */
  memberships_aggregate: Team_Memberships_Aggregate;
  official_ts?: Maybe<Scalars['timestamp']>;
  paperwork_ts?: Maybe<Scalars['timestamp']>;
};


/** columns and relationships of "submission_summary" */
export type Submission_SummaryMembershipsArgs = {
  distinct_on?: InputMaybe<Array<Team_Memberships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Memberships_Order_By>>;
  where?: InputMaybe<Team_Memberships_Bool_Exp>;
};


/** columns and relationships of "submission_summary" */
export type Submission_SummaryMemberships_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Team_Memberships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Memberships_Order_By>>;
  where?: InputMaybe<Team_Memberships_Bool_Exp>;
};

/** aggregated selection of "submission_summary" */
export type Submission_Summary_Aggregate = {
  __typename?: 'submission_summary_aggregate';
  aggregate?: Maybe<Submission_Summary_Aggregate_Fields>;
  nodes: Array<Submission_Summary>;
};

/** aggregate fields of "submission_summary" */
export type Submission_Summary_Aggregate_Fields = {
  __typename?: 'submission_summary_aggregate_fields';
  avg?: Maybe<Submission_Summary_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Submission_Summary_Max_Fields>;
  min?: Maybe<Submission_Summary_Min_Fields>;
  stddev?: Maybe<Submission_Summary_Stddev_Fields>;
  stddev_pop?: Maybe<Submission_Summary_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Submission_Summary_Stddev_Samp_Fields>;
  sum?: Maybe<Submission_Summary_Sum_Fields>;
  var_pop?: Maybe<Submission_Summary_Var_Pop_Fields>;
  var_samp?: Maybe<Submission_Summary_Var_Samp_Fields>;
  variance?: Maybe<Submission_Summary_Variance_Fields>;
};


/** aggregate fields of "submission_summary" */
export type Submission_Summary_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Submission_Summary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Submission_Summary_Avg_Fields = {
  __typename?: 'submission_summary_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "submission_summary". All fields are combined with a logical 'AND'. */
export type Submission_Summary_Bool_Exp = {
  _and?: InputMaybe<Array<Submission_Summary_Bool_Exp>>;
  _not?: InputMaybe<Submission_Summary_Bool_Exp>;
  _or?: InputMaybe<Array<Submission_Summary_Bool_Exp>>;
  film_ts?: InputMaybe<Timestamp_Comparison_Exp>;
  has_reupload?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Numeric_Comparison_Exp>;
  is_on_time?: InputMaybe<Boolean_Comparison_Exp>;
  memberships?: InputMaybe<Team_Memberships_Bool_Exp>;
  memberships_aggregate?: InputMaybe<Team_Memberships_Aggregate_Bool_Exp>;
  official_ts?: InputMaybe<Timestamp_Comparison_Exp>;
  paperwork_ts?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** input type for inserting data into table "submission_summary" */
export type Submission_Summary_Insert_Input = {
  film_ts?: InputMaybe<Scalars['timestamp']>;
  has_reupload?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['numeric']>;
  is_on_time?: InputMaybe<Scalars['Boolean']>;
  memberships?: InputMaybe<Team_Memberships_Arr_Rel_Insert_Input>;
  official_ts?: InputMaybe<Scalars['timestamp']>;
  paperwork_ts?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Submission_Summary_Max_Fields = {
  __typename?: 'submission_summary_max_fields';
  film_ts?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['numeric']>;
  official_ts?: Maybe<Scalars['timestamp']>;
  paperwork_ts?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Submission_Summary_Min_Fields = {
  __typename?: 'submission_summary_min_fields';
  film_ts?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['numeric']>;
  official_ts?: Maybe<Scalars['timestamp']>;
  paperwork_ts?: Maybe<Scalars['timestamp']>;
};

/** input type for inserting object relation for remote table "submission_summary" */
export type Submission_Summary_Obj_Rel_Insert_Input = {
  data: Submission_Summary_Insert_Input;
};

/** Ordering options when selecting data from "submission_summary". */
export type Submission_Summary_Order_By = {
  film_ts?: InputMaybe<Order_By>;
  has_reupload?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_on_time?: InputMaybe<Order_By>;
  memberships_aggregate?: InputMaybe<Team_Memberships_Aggregate_Order_By>;
  official_ts?: InputMaybe<Order_By>;
  paperwork_ts?: InputMaybe<Order_By>;
};

/** select columns of table "submission_summary" */
export enum Submission_Summary_Select_Column {
  /** column name */
  FilmTs = 'film_ts',
  /** column name */
  HasReupload = 'has_reupload',
  /** column name */
  Id = 'id',
  /** column name */
  IsOnTime = 'is_on_time',
  /** column name */
  OfficialTs = 'official_ts',
  /** column name */
  PaperworkTs = 'paperwork_ts'
}

/** aggregate stddev on columns */
export type Submission_Summary_Stddev_Fields = {
  __typename?: 'submission_summary_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Submission_Summary_Stddev_Pop_Fields = {
  __typename?: 'submission_summary_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Submission_Summary_Stddev_Samp_Fields = {
  __typename?: 'submission_summary_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "submission_summary" */
export type Submission_Summary_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Submission_Summary_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Submission_Summary_Stream_Cursor_Value_Input = {
  film_ts?: InputMaybe<Scalars['timestamp']>;
  has_reupload?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['numeric']>;
  is_on_time?: InputMaybe<Scalars['Boolean']>;
  official_ts?: InputMaybe<Scalars['timestamp']>;
  paperwork_ts?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type Submission_Summary_Sum_Fields = {
  __typename?: 'submission_summary_sum_fields';
  id?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Submission_Summary_Var_Pop_Fields = {
  __typename?: 'submission_summary_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Submission_Summary_Var_Samp_Fields = {
  __typename?: 'submission_summary_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Submission_Summary_Variance_Fields = {
  __typename?: 'submission_summary_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** An array relationship */
  asset_exports: Array<Asset_Exports>;
  /** An aggregate relationship */
  asset_exports_aggregate: Asset_Exports_Aggregate;
  /** fetch data from the table: "asset_exports" using primary key columns */
  asset_exports_by_pk?: Maybe<Asset_Exports>;
  /** fetch data from the table in a streaming manner: "asset_exports" */
  asset_exports_stream: Array<Asset_Exports>;
  /** fetch data from the table: "asset_types" */
  asset_types: Array<Asset_Types>;
  /** fetch aggregated fields from the table: "asset_types" */
  asset_types_aggregate: Asset_Types_Aggregate;
  /** fetch data from the table: "asset_types" using primary key columns */
  asset_types_by_pk?: Maybe<Asset_Types>;
  /** fetch data from the table in a streaming manner: "asset_types" */
  asset_types_stream: Array<Asset_Types>;
  /** fetch data from the table: "audience_favorite_counts" */
  audience_favorite_counts: Array<Audience_Favorite_Counts>;
  /** fetch aggregated fields from the table: "audience_favorite_counts" */
  audience_favorite_counts_aggregate: Audience_Favorite_Counts_Aggregate;
  /** fetch data from the table in a streaming manner: "audience_favorite_counts" */
  audience_favorite_counts_stream: Array<Audience_Favorite_Counts>;
  /** fetch data from the table: "audience_favorite_votes" */
  audience_favorite_votes: Array<Audience_Favorite_Votes>;
  /** fetch aggregated fields from the table: "audience_favorite_votes" */
  audience_favorite_votes_aggregate: Audience_Favorite_Votes_Aggregate;
  /** fetch data from the table: "audience_favorite_votes" using primary key columns */
  audience_favorite_votes_by_pk?: Maybe<Audience_Favorite_Votes>;
  /** fetch data from the table in a streaming manner: "audience_favorite_votes" */
  audience_favorite_votes_stream: Array<Audience_Favorite_Votes>;
  /** fetch data from the table: "award_asset_types" */
  award_asset_types: Array<Award_Asset_Types>;
  /** fetch aggregated fields from the table: "award_asset_types" */
  award_asset_types_aggregate: Award_Asset_Types_Aggregate;
  /** fetch data from the table: "award_asset_types" using primary key columns */
  award_asset_types_by_pk?: Maybe<Award_Asset_Types>;
  /** fetch data from the table in a streaming manner: "award_asset_types" */
  award_asset_types_stream: Array<Award_Asset_Types>;
  /** An array relationship */
  award_nominations: Array<Award_Nominations>;
  /** An aggregate relationship */
  award_nominations_aggregate: Award_Nominations_Aggregate;
  /** fetch data from the table in a streaming manner: "award_nominations" */
  award_nominations_stream: Array<Award_Nominations>;
  /** fetch data from the table: "award_winners" */
  award_winners: Array<Award_Winners>;
  /** fetch aggregated fields from the table: "award_winners" */
  award_winners_aggregate: Award_Winners_Aggregate;
  /** fetch data from the table: "award_winners" using primary key columns */
  award_winners_by_pk?: Maybe<Award_Winners>;
  /** fetch data from the table in a streaming manner: "award_winners" */
  award_winners_stream: Array<Award_Winners>;
  /** fetch data from the table: "awards" */
  awards: Array<Awards>;
  /** fetch aggregated fields from the table: "awards" */
  awards_aggregate: Awards_Aggregate;
  /** fetch data from the table: "awards" using primary key columns */
  awards_by_pk?: Maybe<Awards>;
  /** fetch data from the table: "awards_ceremony_checkins" */
  awards_ceremony_checkins: Array<Awards_Ceremony_Checkins>;
  /** fetch aggregated fields from the table: "awards_ceremony_checkins" */
  awards_ceremony_checkins_aggregate: Awards_Ceremony_Checkins_Aggregate;
  /** fetch data from the table: "awards_ceremony_checkins" using primary key columns */
  awards_ceremony_checkins_by_pk?: Maybe<Awards_Ceremony_Checkins>;
  /** fetch data from the table in a streaming manner: "awards_ceremony_checkins" */
  awards_ceremony_checkins_stream: Array<Awards_Ceremony_Checkins>;
  /** fetch data from the table in a streaming manner: "awards" */
  awards_stream: Array<Awards>;
  /** fetch data from the table: "countries" */
  countries: Array<Countries>;
  /** fetch aggregated fields from the table: "countries" */
  countries_aggregate: Countries_Aggregate;
  /** fetch data from the table: "countries" using primary key columns */
  countries_by_pk?: Maybe<Countries>;
  /** fetch data from the table in a streaming manner: "countries" */
  countries_stream: Array<Countries>;
  /** fetch data from the table: "exit_interview_recordings" */
  exit_interview_recordings: Array<Exit_Interview_Recordings>;
  /** fetch aggregated fields from the table: "exit_interview_recordings" */
  exit_interview_recordings_aggregate: Exit_Interview_Recordings_Aggregate;
  /** fetch data from the table: "exit_interview_recordings" using primary key columns */
  exit_interview_recordings_by_pk?: Maybe<Exit_Interview_Recordings>;
  /** fetch data from the table in a streaming manner: "exit_interview_recordings" */
  exit_interview_recordings_stream: Array<Exit_Interview_Recordings>;
  /** fetch data from the table: "exit_interviews" */
  exit_interviews: Array<Exit_Interviews>;
  /** fetch aggregated fields from the table: "exit_interviews" */
  exit_interviews_aggregate: Exit_Interviews_Aggregate;
  /** fetch data from the table: "exit_interviews" using primary key columns */
  exit_interviews_by_pk?: Maybe<Exit_Interviews>;
  /** fetch data from the table in a streaming manner: "exit_interviews" */
  exit_interviews_stream: Array<Exit_Interviews>;
  /** fetch data from the table: "expertise" */
  expertise: Array<Expertise>;
  /** fetch aggregated fields from the table: "expertise" */
  expertise_aggregate: Expertise_Aggregate;
  /** fetch data from the table: "expertise" using primary key columns */
  expertise_by_pk?: Maybe<Expertise>;
  /** fetch data from the table in a streaming manner: "expertise" */
  expertise_stream: Array<Expertise>;
  /** fetch data from the table: "festival_badge_type_event_type" */
  festival_badge_type_event_type: Array<Festival_Badge_Type_Event_Type>;
  /** fetch aggregated fields from the table: "festival_badge_type_event_type" */
  festival_badge_type_event_type_aggregate: Festival_Badge_Type_Event_Type_Aggregate;
  /** fetch data from the table: "festival_badge_type_event_type" using primary key columns */
  festival_badge_type_event_type_by_pk?: Maybe<Festival_Badge_Type_Event_Type>;
  /** fetch data from the table in a streaming manner: "festival_badge_type_event_type" */
  festival_badge_type_event_type_stream: Array<Festival_Badge_Type_Event_Type>;
  /** fetch data from the table: "festival_badge_types" */
  festival_badge_types: Array<Festival_Badge_Types>;
  /** fetch aggregated fields from the table: "festival_badge_types" */
  festival_badge_types_aggregate: Festival_Badge_Types_Aggregate;
  /** fetch data from the table: "festival_badge_types" using primary key columns */
  festival_badge_types_by_pk?: Maybe<Festival_Badge_Types>;
  /** fetch data from the table in a streaming manner: "festival_badge_types" */
  festival_badge_types_stream: Array<Festival_Badge_Types>;
  /** An array relationship */
  festival_badges: Array<Festival_Badges>;
  /** An aggregate relationship */
  festival_badges_aggregate: Festival_Badges_Aggregate;
  /** fetch data from the table: "festival_badges" using primary key columns */
  festival_badges_by_pk?: Maybe<Festival_Badges>;
  /** fetch data from the table in a streaming manner: "festival_badges" */
  festival_badges_stream: Array<Festival_Badges>;
  /** fetch data from the table: "festival_event_locations" */
  festival_event_locations: Array<Festival_Event_Locations>;
  /** fetch aggregated fields from the table: "festival_event_locations" */
  festival_event_locations_aggregate: Festival_Event_Locations_Aggregate;
  /** fetch data from the table: "festival_event_locations" using primary key columns */
  festival_event_locations_by_pk?: Maybe<Festival_Event_Locations>;
  /** fetch data from the table in a streaming manner: "festival_event_locations" */
  festival_event_locations_stream: Array<Festival_Event_Locations>;
  /** fetch data from the table: "festival_event_types" */
  festival_event_types: Array<Festival_Event_Types>;
  /** fetch aggregated fields from the table: "festival_event_types" */
  festival_event_types_aggregate: Festival_Event_Types_Aggregate;
  /** fetch data from the table: "festival_event_types" using primary key columns */
  festival_event_types_by_pk?: Maybe<Festival_Event_Types>;
  /** fetch data from the table in a streaming manner: "festival_event_types" */
  festival_event_types_stream: Array<Festival_Event_Types>;
  /** An array relationship */
  festival_events: Array<Festival_Events>;
  /** An aggregate relationship */
  festival_events_aggregate: Festival_Events_Aggregate;
  /** fetch data from the table: "festival_events" using primary key columns */
  festival_events_by_pk?: Maybe<Festival_Events>;
  /** fetch data from the table in a streaming manner: "festival_events" */
  festival_events_stream: Array<Festival_Events>;
  /** An array relationship */
  festival_genres: Array<Festival_Genres>;
  /** An aggregate relationship */
  festival_genres_aggregate: Festival_Genres_Aggregate;
  /** fetch data from the table: "festival_genres" using primary key columns */
  festival_genres_by_pk?: Maybe<Festival_Genres>;
  /** fetch data from the table in a streaming manner: "festival_genres" */
  festival_genres_stream: Array<Festival_Genres>;
  /** fetch data from the table: "festival_submission_assets" */
  festival_submission_assets: Array<Festival_Submission_Assets>;
  /** fetch aggregated fields from the table: "festival_submission_assets" */
  festival_submission_assets_aggregate: Festival_Submission_Assets_Aggregate;
  /** fetch data from the table: "festival_submission_assets" using primary key columns */
  festival_submission_assets_by_pk?: Maybe<Festival_Submission_Assets>;
  /** fetch data from the table in a streaming manner: "festival_submission_assets" */
  festival_submission_assets_stream: Array<Festival_Submission_Assets>;
  /** fetch data from the table: "festival_submission_feedback" */
  festival_submission_feedback: Array<Festival_Submission_Feedback>;
  /** fetch aggregated fields from the table: "festival_submission_feedback" */
  festival_submission_feedback_aggregate: Festival_Submission_Feedback_Aggregate;
  /** fetch data from the table: "festival_submission_feedback" using primary key columns */
  festival_submission_feedback_by_pk?: Maybe<Festival_Submission_Feedback>;
  /** fetch data from the table in a streaming manner: "festival_submission_feedback" */
  festival_submission_feedback_stream: Array<Festival_Submission_Feedback>;
  /** An array relationship */
  festival_submission_vouchers: Array<Festival_Submission_Vouchers>;
  /** An aggregate relationship */
  festival_submission_vouchers_aggregate: Festival_Submission_Vouchers_Aggregate;
  /** fetch data from the table: "festival_submission_vouchers" using primary key columns */
  festival_submission_vouchers_by_pk?: Maybe<Festival_Submission_Vouchers>;
  /** fetch data from the table in a streaming manner: "festival_submission_vouchers" */
  festival_submission_vouchers_stream: Array<Festival_Submission_Vouchers>;
  /** fetch data from the table: "festival_submissions" */
  festival_submissions: Array<Festival_Submissions>;
  /** fetch aggregated fields from the table: "festival_submissions" */
  festival_submissions_aggregate: Festival_Submissions_Aggregate;
  /** fetch data from the table: "festival_submissions" using primary key columns */
  festival_submissions_by_pk?: Maybe<Festival_Submissions>;
  /** fetch data from the table in a streaming manner: "festival_submissions" */
  festival_submissions_stream: Array<Festival_Submissions>;
  /** An array relationship */
  festival_tickets: Array<Festival_Tickets>;
  /** An aggregate relationship */
  festival_tickets_aggregate: Festival_Tickets_Aggregate;
  /** fetch data from the table: "festival_tickets" using primary key columns */
  festival_tickets_by_pk?: Maybe<Festival_Tickets>;
  /** fetch data from the table in a streaming manner: "festival_tickets" */
  festival_tickets_stream: Array<Festival_Tickets>;
  /** fetch data from the table: "film_festivals" */
  film_festivals: Array<Film_Festivals>;
  /** fetch aggregated fields from the table: "film_festivals" */
  film_festivals_aggregate: Film_Festivals_Aggregate;
  /** fetch data from the table: "film_festivals" using primary key columns */
  film_festivals_by_pk?: Maybe<Film_Festivals>;
  /** fetch data from the table in a streaming manner: "film_festivals" */
  film_festivals_stream: Array<Film_Festivals>;
  /** fetch data from the table: "film_group_festival_submissions" */
  film_group_festival_submissions: Array<Film_Group_Festival_Submissions>;
  /** fetch aggregated fields from the table: "film_group_festival_submissions" */
  film_group_festival_submissions_aggregate: Film_Group_Festival_Submissions_Aggregate;
  /** fetch data from the table: "film_group_festival_submissions" using primary key columns */
  film_group_festival_submissions_by_pk?: Maybe<Film_Group_Festival_Submissions>;
  /** fetch data from the table in a streaming manner: "film_group_festival_submissions" */
  film_group_festival_submissions_stream: Array<Film_Group_Festival_Submissions>;
  /** fetch data from the table: "film_group_films" */
  film_group_films: Array<Film_Group_Films>;
  /** fetch aggregated fields from the table: "film_group_films" */
  film_group_films_aggregate: Film_Group_Films_Aggregate;
  /** fetch data from the table: "film_group_films" using primary key columns */
  film_group_films_by_pk?: Maybe<Film_Group_Films>;
  /** fetch data from the table in a streaming manner: "film_group_films" */
  film_group_films_stream: Array<Film_Group_Films>;
  /** fetch data from the table: "film_group_users" */
  film_group_users: Array<Film_Group_Users>;
  /** fetch aggregated fields from the table: "film_group_users" */
  film_group_users_aggregate: Film_Group_Users_Aggregate;
  /** fetch data from the table: "film_group_users" using primary key columns */
  film_group_users_by_pk?: Maybe<Film_Group_Users>;
  /** fetch data from the table in a streaming manner: "film_group_users" */
  film_group_users_stream: Array<Film_Group_Users>;
  /** fetch data from the table: "film_groups" */
  film_groups: Array<Film_Groups>;
  /** fetch aggregated fields from the table: "film_groups" */
  film_groups_aggregate: Film_Groups_Aggregate;
  /** fetch data from the table: "film_groups" using primary key columns */
  film_groups_by_pk?: Maybe<Film_Groups>;
  /** fetch data from the table in a streaming manner: "film_groups" */
  film_groups_stream: Array<Film_Groups>;
  /** fetch data from the table: "films" */
  films: Array<Films>;
  /** fetch aggregated fields from the table: "films" */
  films_aggregate: Films_Aggregate;
  /** fetch data from the table: "films" using primary key columns */
  films_by_pk?: Maybe<Films>;
  /** fetch data from the table in a streaming manner: "films" */
  films_stream: Array<Films>;
  /** fetch data from the table: "genres" */
  genres: Array<Genres>;
  /** fetch aggregated fields from the table: "genres" */
  genres_aggregate: Genres_Aggregate;
  /** fetch data from the table: "genres" using primary key columns */
  genres_by_pk?: Maybe<Genres>;
  /** fetch data from the table in a streaming manner: "genres" */
  genres_stream: Array<Genres>;
  /** fetch data from the table: "kickoff_checkins" */
  kickoff_checkins: Array<Kickoff_Checkins>;
  /** fetch aggregated fields from the table: "kickoff_checkins" */
  kickoff_checkins_aggregate: Kickoff_Checkins_Aggregate;
  /** fetch data from the table: "kickoff_checkins" using primary key columns */
  kickoff_checkins_by_pk?: Maybe<Kickoff_Checkins>;
  /** fetch data from the table in a streaming manner: "kickoff_checkins" */
  kickoff_checkins_stream: Array<Kickoff_Checkins>;
  /** An array relationship */
  location_releases: Array<Location_Releases>;
  /** An aggregate relationship */
  location_releases_aggregate: Location_Releases_Aggregate;
  /** fetch data from the table: "location_releases" using primary key columns */
  location_releases_by_pk?: Maybe<Location_Releases>;
  /** fetch data from the table in a streaming manner: "location_releases" */
  location_releases_stream: Array<Location_Releases>;
  /** An array relationship */
  matchup_requests: Array<Matchup_Requests>;
  /** An aggregate relationship */
  matchup_requests_aggregate: Matchup_Requests_Aggregate;
  /** fetch data from the table: "matchup_requests" using primary key columns */
  matchup_requests_by_pk?: Maybe<Matchup_Requests>;
  /** fetch data from the table in a streaming manner: "matchup_requests" */
  matchup_requests_stream: Array<Matchup_Requests>;
  /** An array relationship */
  music_releases: Array<Music_Releases>;
  /** An aggregate relationship */
  music_releases_aggregate: Music_Releases_Aggregate;
  /** fetch data from the table: "music_releases" using primary key columns */
  music_releases_by_pk?: Maybe<Music_Releases>;
  /** fetch data from the table in a streaming manner: "music_releases" */
  music_releases_stream: Array<Music_Releases>;
  /** fetch data from the table: "nomination_assets" */
  nomination_assets: Array<Nomination_Assets>;
  /** fetch aggregated fields from the table: "nomination_assets" */
  nomination_assets_aggregate: Nomination_Assets_Aggregate;
  /** fetch data from the table: "nomination_assets" using primary key columns */
  nomination_assets_by_pk?: Maybe<Nomination_Assets>;
  /** fetch data from the table in a streaming manner: "nomination_assets" */
  nomination_assets_stream: Array<Nomination_Assets>;
  /** An array relationship */
  nominations: Array<Nominations>;
  /** An aggregate relationship */
  nominations_aggregate: Nominations_Aggregate;
  /** fetch data from the table: "nominations" using primary key columns */
  nominations_by_pk?: Maybe<Nominations>;
  /** fetch data from the table in a streaming manner: "nominations" */
  nominations_stream: Array<Nominations>;
  /** An array relationship */
  online_screening_tickets: Array<Online_Screening_Tickets>;
  /** An aggregate relationship */
  online_screening_tickets_aggregate: Online_Screening_Tickets_Aggregate;
  /** fetch data from the table: "online_screening_tickets" using primary key columns */
  online_screening_tickets_by_pk?: Maybe<Online_Screening_Tickets>;
  /** fetch data from the table in a streaming manner: "online_screening_tickets" */
  online_screening_tickets_stream: Array<Online_Screening_Tickets>;
  /** An array relationship */
  payments: Array<Payments>;
  /** An aggregate relationship */
  payments_aggregate: Payments_Aggregate;
  /** fetch data from the table: "payments" using primary key columns */
  payments_by_pk?: Maybe<Payments>;
  /** fetch data from the table in a streaming manner: "payments" */
  payments_stream: Array<Payments>;
  /** fetch data from the table: "playlist_team" */
  playlist_team: Array<Playlist_Team>;
  /** fetch aggregated fields from the table: "playlist_team" */
  playlist_team_aggregate: Playlist_Team_Aggregate;
  /** fetch data from the table: "playlist_team" using primary key columns */
  playlist_team_by_pk?: Maybe<Playlist_Team>;
  /** fetch data from the table in a streaming manner: "playlist_team" */
  playlist_team_stream: Array<Playlist_Team>;
  /** fetch data from the table: "playlists" */
  playlists: Array<Playlists>;
  /** fetch aggregated fields from the table: "playlists" */
  playlists_aggregate: Playlists_Aggregate;
  /** fetch data from the table: "playlists" using primary key columns */
  playlists_by_pk?: Maybe<Playlists>;
  /** fetch data from the table in a streaming manner: "playlists" */
  playlists_stream: Array<Playlists>;
  /** An array relationship */
  prize_elections: Array<Prize_Elections>;
  /** An aggregate relationship */
  prize_elections_aggregate: Prize_Elections_Aggregate;
  /** fetch data from the table in a streaming manner: "prize_elections" */
  prize_elections_stream: Array<Prize_Elections>;
  /** fetch data from the table: "prizes" */
  prizes: Array<Prizes>;
  /** fetch aggregated fields from the table: "prizes" */
  prizes_aggregate: Prizes_Aggregate;
  /** fetch data from the table: "prizes" using primary key columns */
  prizes_by_pk?: Maybe<Prizes>;
  /** fetch data from the table in a streaming manner: "prizes" */
  prizes_stream: Array<Prizes>;
  /** fetch data from the table: "registrations" */
  registrations: Array<Registrations>;
  /** fetch aggregated fields from the table: "registrations" */
  registrations_aggregate: Registrations_Aggregate;
  /** fetch data from the table: "registrations" using primary key columns */
  registrations_by_pk?: Maybe<Registrations>;
  /** fetch data from the table in a streaming manner: "registrations" */
  registrations_stream: Array<Registrations>;
  /** fetch data from the table: "selection_ballots" */
  selection_ballots: Array<Selection_Ballots>;
  /** fetch aggregated fields from the table: "selection_ballots" */
  selection_ballots_aggregate: Selection_Ballots_Aggregate;
  /** fetch data from the table: "selection_ballots" using primary key columns */
  selection_ballots_by_pk?: Maybe<Selection_Ballots>;
  /** fetch data from the table in a streaming manner: "selection_ballots" */
  selection_ballots_stream: Array<Selection_Ballots>;
  /** fetch data from the table: "selection_feedback" */
  selection_feedback: Array<Selection_Feedback>;
  /** fetch aggregated fields from the table: "selection_feedback" */
  selection_feedback_aggregate: Selection_Feedback_Aggregate;
  /** fetch data from the table: "selection_feedback" using primary key columns */
  selection_feedback_by_pk?: Maybe<Selection_Feedback>;
  /** fetch data from the table in a streaming manner: "selection_feedback" */
  selection_feedback_stream: Array<Selection_Feedback>;
  /** An array relationship */
  selection_metrics: Array<Selection_Metrics>;
  /** An aggregate relationship */
  selection_metrics_aggregate: Selection_Metrics_Aggregate;
  /** fetch data from the table: "selection_metrics" using primary key columns */
  selection_metrics_by_pk?: Maybe<Selection_Metrics>;
  /** fetch data from the table in a streaming manner: "selection_metrics" */
  selection_metrics_stream: Array<Selection_Metrics>;
  /** fetch data from the table: "selection_progress" */
  selection_progress: Array<Selection_Progress>;
  /** fetch aggregated fields from the table: "selection_progress" */
  selection_progress_aggregate: Selection_Progress_Aggregate;
  /** fetch data from the table: "selection_progress" using primary key columns */
  selection_progress_by_pk?: Maybe<Selection_Progress>;
  /** fetch data from the table in a streaming manner: "selection_progress" */
  selection_progress_stream: Array<Selection_Progress>;
  /** fetch data from the table: "selection_results" */
  selection_results: Array<Selection_Results>;
  /** fetch aggregated fields from the table: "selection_results" */
  selection_results_aggregate: Selection_Results_Aggregate;
  /** fetch data from the table in a streaming manner: "selection_results" */
  selection_results_stream: Array<Selection_Results>;
  /** fetch data from the table: "sharables" */
  sharables: Array<Sharables>;
  /** fetch aggregated fields from the table: "sharables" */
  sharables_aggregate: Sharables_Aggregate;
  /** fetch data from the table: "sharables" using primary key columns */
  sharables_by_pk?: Maybe<Sharables>;
  /** fetch data from the table in a streaming manner: "sharables" */
  sharables_stream: Array<Sharables>;
  shouldReloadFestivalSubmission: Scalars['Boolean'];
  shouldReloadTeam: Scalars['Boolean'];
  /** fetch data from the table: "sms_votes" */
  sms_votes: Array<Sms_Votes>;
  /** fetch aggregated fields from the table: "sms_votes" */
  sms_votes_aggregate: Sms_Votes_Aggregate;
  /** fetch data from the table: "sms_votes" using primary key columns */
  sms_votes_by_pk?: Maybe<Sms_Votes>;
  /** fetch data from the table in a streaming manner: "sms_votes" */
  sms_votes_stream: Array<Sms_Votes>;
  /** An array relationship */
  sponsors: Array<Sponsors>;
  /** An aggregate relationship */
  sponsors_aggregate: Sponsors_Aggregate;
  /** fetch data from the table: "sponsors" using primary key columns */
  sponsors_by_pk?: Maybe<Sponsors>;
  /** fetch data from the table in a streaming manner: "sponsors" */
  sponsors_stream: Array<Sponsors>;
  /** fetch data from the table: "studios" */
  studios: Array<Studios>;
  /** fetch aggregated fields from the table: "studios" */
  studios_aggregate: Studios_Aggregate;
  /** fetch data from the table: "studios" using primary key columns */
  studios_by_pk?: Maybe<Studios>;
  /** fetch data from the table in a streaming manner: "studios" */
  studios_stream: Array<Studios>;
  /** fetch data from the table: "submission_summary" */
  submission_summary: Array<Submission_Summary>;
  /** fetch aggregated fields from the table: "submission_summary" */
  submission_summary_aggregate: Submission_Summary_Aggregate;
  /** fetch data from the table in a streaming manner: "submission_summary" */
  submission_summary_stream: Array<Submission_Summary>;
  /** fetch data from the table: "team_assets" */
  team_assets: Array<Team_Assets>;
  /** fetch aggregated fields from the table: "team_assets" */
  team_assets_aggregate: Team_Assets_Aggregate;
  /** fetch data from the table: "team_assets" using primary key columns */
  team_assets_by_pk?: Maybe<Team_Assets>;
  /** fetch data from the table in a streaming manner: "team_assets" */
  team_assets_stream: Array<Team_Assets>;
  /** An array relationship */
  team_memberships: Array<Team_Memberships>;
  /** An aggregate relationship */
  team_memberships_aggregate: Team_Memberships_Aggregate;
  /** fetch data from the table: "team_memberships" using primary key columns */
  team_memberships_by_pk?: Maybe<Team_Memberships>;
  /** fetch data from the table in a streaming manner: "team_memberships" */
  team_memberships_stream: Array<Team_Memberships>;
  /** fetch data from the table: "team_roles" */
  team_roles: Array<Team_Roles>;
  /** fetch aggregated fields from the table: "team_roles" */
  team_roles_aggregate: Team_Roles_Aggregate;
  /** fetch data from the table: "team_roles" using primary key columns */
  team_roles_by_pk?: Maybe<Team_Roles>;
  /** fetch data from the table in a streaming manner: "team_roles" */
  team_roles_stream: Array<Team_Roles>;
  /** An array relationship */
  teams: Array<Teams>;
  /** An aggregate relationship */
  teams_aggregate: Teams_Aggregate;
  /** fetch data from the table: "teams" using primary key columns */
  teams_by_pk?: Maybe<Teams>;
  /** fetch data from the table in a streaming manner: "teams" */
  teams_stream: Array<Teams>;
  /** fetch data from the table: "teams_with_awards_ceremony_checkins" */
  teams_with_awards_ceremony_checkins: Array<Teams_With_Awards_Ceremony_Checkins>;
  /** fetch aggregated fields from the table: "teams_with_awards_ceremony_checkins" */
  teams_with_awards_ceremony_checkins_aggregate: Teams_With_Awards_Ceremony_Checkins_Aggregate;
  /** fetch data from the table in a streaming manner: "teams_with_awards_ceremony_checkins" */
  teams_with_awards_ceremony_checkins_stream: Array<Teams_With_Awards_Ceremony_Checkins>;
  /** fetch data from the table: "teams_with_checkins" */
  teams_with_checkins: Array<Teams_With_Checkins>;
  /** fetch aggregated fields from the table: "teams_with_checkins" */
  teams_with_checkins_aggregate: Teams_With_Checkins_Aggregate;
  /** fetch data from the table in a streaming manner: "teams_with_checkins" */
  teams_with_checkins_stream: Array<Teams_With_Checkins>;
  /** fetch data from the table: "ticket_tailor_vouchers" */
  ticket_tailor_vouchers: Array<Ticket_Tailor_Vouchers>;
  /** fetch aggregated fields from the table: "ticket_tailor_vouchers" */
  ticket_tailor_vouchers_aggregate: Ticket_Tailor_Vouchers_Aggregate;
  /** fetch data from the table: "ticket_tailor_vouchers" using primary key columns */
  ticket_tailor_vouchers_by_pk?: Maybe<Ticket_Tailor_Vouchers>;
  /** fetch data from the table in a streaming manner: "ticket_tailor_vouchers" */
  ticket_tailor_vouchers_stream: Array<Ticket_Tailor_Vouchers>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<Users>;
};


export type Subscription_RootAsset_ExportsArgs = {
  distinct_on?: InputMaybe<Array<Asset_Exports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Asset_Exports_Order_By>>;
  where?: InputMaybe<Asset_Exports_Bool_Exp>;
};


export type Subscription_RootAsset_Exports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Exports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Asset_Exports_Order_By>>;
  where?: InputMaybe<Asset_Exports_Bool_Exp>;
};


export type Subscription_RootAsset_Exports_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAsset_Exports_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Asset_Exports_Stream_Cursor_Input>>;
  where?: InputMaybe<Asset_Exports_Bool_Exp>;
};


export type Subscription_RootAsset_TypesArgs = {
  distinct_on?: InputMaybe<Array<Asset_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Asset_Types_Order_By>>;
  where?: InputMaybe<Asset_Types_Bool_Exp>;
};


export type Subscription_RootAsset_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Asset_Types_Order_By>>;
  where?: InputMaybe<Asset_Types_Bool_Exp>;
};


export type Subscription_RootAsset_Types_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Subscription_RootAsset_Types_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Asset_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Asset_Types_Bool_Exp>;
};


export type Subscription_RootAudience_Favorite_CountsArgs = {
  distinct_on?: InputMaybe<Array<Audience_Favorite_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Audience_Favorite_Counts_Order_By>>;
  where?: InputMaybe<Audience_Favorite_Counts_Bool_Exp>;
};


export type Subscription_RootAudience_Favorite_Counts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Audience_Favorite_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Audience_Favorite_Counts_Order_By>>;
  where?: InputMaybe<Audience_Favorite_Counts_Bool_Exp>;
};


export type Subscription_RootAudience_Favorite_Counts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Audience_Favorite_Counts_Stream_Cursor_Input>>;
  where?: InputMaybe<Audience_Favorite_Counts_Bool_Exp>;
};


export type Subscription_RootAudience_Favorite_VotesArgs = {
  distinct_on?: InputMaybe<Array<Audience_Favorite_Votes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Audience_Favorite_Votes_Order_By>>;
  where?: InputMaybe<Audience_Favorite_Votes_Bool_Exp>;
};


export type Subscription_RootAudience_Favorite_Votes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Audience_Favorite_Votes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Audience_Favorite_Votes_Order_By>>;
  where?: InputMaybe<Audience_Favorite_Votes_Bool_Exp>;
};


export type Subscription_RootAudience_Favorite_Votes_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAudience_Favorite_Votes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Audience_Favorite_Votes_Stream_Cursor_Input>>;
  where?: InputMaybe<Audience_Favorite_Votes_Bool_Exp>;
};


export type Subscription_RootAward_Asset_TypesArgs = {
  distinct_on?: InputMaybe<Array<Award_Asset_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Award_Asset_Types_Order_By>>;
  where?: InputMaybe<Award_Asset_Types_Bool_Exp>;
};


export type Subscription_RootAward_Asset_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Award_Asset_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Award_Asset_Types_Order_By>>;
  where?: InputMaybe<Award_Asset_Types_Bool_Exp>;
};


export type Subscription_RootAward_Asset_Types_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Subscription_RootAward_Asset_Types_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Award_Asset_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Award_Asset_Types_Bool_Exp>;
};


export type Subscription_RootAward_NominationsArgs = {
  distinct_on?: InputMaybe<Array<Award_Nominations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Award_Nominations_Order_By>>;
  where?: InputMaybe<Award_Nominations_Bool_Exp>;
};


export type Subscription_RootAward_Nominations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Award_Nominations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Award_Nominations_Order_By>>;
  where?: InputMaybe<Award_Nominations_Bool_Exp>;
};


export type Subscription_RootAward_Nominations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Award_Nominations_Stream_Cursor_Input>>;
  where?: InputMaybe<Award_Nominations_Bool_Exp>;
};


export type Subscription_RootAward_WinnersArgs = {
  distinct_on?: InputMaybe<Array<Award_Winners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Award_Winners_Order_By>>;
  where?: InputMaybe<Award_Winners_Bool_Exp>;
};


export type Subscription_RootAward_Winners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Award_Winners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Award_Winners_Order_By>>;
  where?: InputMaybe<Award_Winners_Bool_Exp>;
};


export type Subscription_RootAward_Winners_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAward_Winners_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Award_Winners_Stream_Cursor_Input>>;
  where?: InputMaybe<Award_Winners_Bool_Exp>;
};


export type Subscription_RootAwardsArgs = {
  distinct_on?: InputMaybe<Array<Awards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Awards_Order_By>>;
  where?: InputMaybe<Awards_Bool_Exp>;
};


export type Subscription_RootAwards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Awards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Awards_Order_By>>;
  where?: InputMaybe<Awards_Bool_Exp>;
};


export type Subscription_RootAwards_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Subscription_RootAwards_Ceremony_CheckinsArgs = {
  distinct_on?: InputMaybe<Array<Awards_Ceremony_Checkins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Awards_Ceremony_Checkins_Order_By>>;
  where?: InputMaybe<Awards_Ceremony_Checkins_Bool_Exp>;
};


export type Subscription_RootAwards_Ceremony_Checkins_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Awards_Ceremony_Checkins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Awards_Ceremony_Checkins_Order_By>>;
  where?: InputMaybe<Awards_Ceremony_Checkins_Bool_Exp>;
};


export type Subscription_RootAwards_Ceremony_Checkins_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAwards_Ceremony_Checkins_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Awards_Ceremony_Checkins_Stream_Cursor_Input>>;
  where?: InputMaybe<Awards_Ceremony_Checkins_Bool_Exp>;
};


export type Subscription_RootAwards_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Awards_Stream_Cursor_Input>>;
  where?: InputMaybe<Awards_Bool_Exp>;
};


export type Subscription_RootCountriesArgs = {
  distinct_on?: InputMaybe<Array<Countries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Countries_Order_By>>;
  where?: InputMaybe<Countries_Bool_Exp>;
};


export type Subscription_RootCountries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Countries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Countries_Order_By>>;
  where?: InputMaybe<Countries_Bool_Exp>;
};


export type Subscription_RootCountries_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Subscription_RootCountries_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Countries_Stream_Cursor_Input>>;
  where?: InputMaybe<Countries_Bool_Exp>;
};


export type Subscription_RootExit_Interview_RecordingsArgs = {
  distinct_on?: InputMaybe<Array<Exit_Interview_Recordings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exit_Interview_Recordings_Order_By>>;
  where?: InputMaybe<Exit_Interview_Recordings_Bool_Exp>;
};


export type Subscription_RootExit_Interview_Recordings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exit_Interview_Recordings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exit_Interview_Recordings_Order_By>>;
  where?: InputMaybe<Exit_Interview_Recordings_Bool_Exp>;
};


export type Subscription_RootExit_Interview_Recordings_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootExit_Interview_Recordings_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Exit_Interview_Recordings_Stream_Cursor_Input>>;
  where?: InputMaybe<Exit_Interview_Recordings_Bool_Exp>;
};


export type Subscription_RootExit_InterviewsArgs = {
  distinct_on?: InputMaybe<Array<Exit_Interviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exit_Interviews_Order_By>>;
  where?: InputMaybe<Exit_Interviews_Bool_Exp>;
};


export type Subscription_RootExit_Interviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exit_Interviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exit_Interviews_Order_By>>;
  where?: InputMaybe<Exit_Interviews_Bool_Exp>;
};


export type Subscription_RootExit_Interviews_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootExit_Interviews_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Exit_Interviews_Stream_Cursor_Input>>;
  where?: InputMaybe<Exit_Interviews_Bool_Exp>;
};


export type Subscription_RootExpertiseArgs = {
  distinct_on?: InputMaybe<Array<Expertise_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expertise_Order_By>>;
  where?: InputMaybe<Expertise_Bool_Exp>;
};


export type Subscription_RootExpertise_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Expertise_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expertise_Order_By>>;
  where?: InputMaybe<Expertise_Bool_Exp>;
};


export type Subscription_RootExpertise_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Subscription_RootExpertise_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Expertise_Stream_Cursor_Input>>;
  where?: InputMaybe<Expertise_Bool_Exp>;
};


export type Subscription_RootFestival_Badge_Type_Event_TypeArgs = {
  distinct_on?: InputMaybe<Array<Festival_Badge_Type_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Badge_Type_Event_Type_Order_By>>;
  where?: InputMaybe<Festival_Badge_Type_Event_Type_Bool_Exp>;
};


export type Subscription_RootFestival_Badge_Type_Event_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Badge_Type_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Badge_Type_Event_Type_Order_By>>;
  where?: InputMaybe<Festival_Badge_Type_Event_Type_Bool_Exp>;
};


export type Subscription_RootFestival_Badge_Type_Event_Type_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootFestival_Badge_Type_Event_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Festival_Badge_Type_Event_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Festival_Badge_Type_Event_Type_Bool_Exp>;
};


export type Subscription_RootFestival_Badge_TypesArgs = {
  distinct_on?: InputMaybe<Array<Festival_Badge_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Badge_Types_Order_By>>;
  where?: InputMaybe<Festival_Badge_Types_Bool_Exp>;
};


export type Subscription_RootFestival_Badge_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Badge_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Badge_Types_Order_By>>;
  where?: InputMaybe<Festival_Badge_Types_Bool_Exp>;
};


export type Subscription_RootFestival_Badge_Types_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootFestival_Badge_Types_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Festival_Badge_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Festival_Badge_Types_Bool_Exp>;
};


export type Subscription_RootFestival_BadgesArgs = {
  distinct_on?: InputMaybe<Array<Festival_Badges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Badges_Order_By>>;
  where?: InputMaybe<Festival_Badges_Bool_Exp>;
};


export type Subscription_RootFestival_Badges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Badges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Badges_Order_By>>;
  where?: InputMaybe<Festival_Badges_Bool_Exp>;
};


export type Subscription_RootFestival_Badges_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootFestival_Badges_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Festival_Badges_Stream_Cursor_Input>>;
  where?: InputMaybe<Festival_Badges_Bool_Exp>;
};


export type Subscription_RootFestival_Event_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Festival_Event_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Event_Locations_Order_By>>;
  where?: InputMaybe<Festival_Event_Locations_Bool_Exp>;
};


export type Subscription_RootFestival_Event_Locations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Event_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Event_Locations_Order_By>>;
  where?: InputMaybe<Festival_Event_Locations_Bool_Exp>;
};


export type Subscription_RootFestival_Event_Locations_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootFestival_Event_Locations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Festival_Event_Locations_Stream_Cursor_Input>>;
  where?: InputMaybe<Festival_Event_Locations_Bool_Exp>;
};


export type Subscription_RootFestival_Event_TypesArgs = {
  distinct_on?: InputMaybe<Array<Festival_Event_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Event_Types_Order_By>>;
  where?: InputMaybe<Festival_Event_Types_Bool_Exp>;
};


export type Subscription_RootFestival_Event_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Event_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Event_Types_Order_By>>;
  where?: InputMaybe<Festival_Event_Types_Bool_Exp>;
};


export type Subscription_RootFestival_Event_Types_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootFestival_Event_Types_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Festival_Event_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Festival_Event_Types_Bool_Exp>;
};


export type Subscription_RootFestival_EventsArgs = {
  distinct_on?: InputMaybe<Array<Festival_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Events_Order_By>>;
  where?: InputMaybe<Festival_Events_Bool_Exp>;
};


export type Subscription_RootFestival_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Events_Order_By>>;
  where?: InputMaybe<Festival_Events_Bool_Exp>;
};


export type Subscription_RootFestival_Events_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootFestival_Events_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Festival_Events_Stream_Cursor_Input>>;
  where?: InputMaybe<Festival_Events_Bool_Exp>;
};


export type Subscription_RootFestival_GenresArgs = {
  distinct_on?: InputMaybe<Array<Festival_Genres_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Genres_Order_By>>;
  where?: InputMaybe<Festival_Genres_Bool_Exp>;
};


export type Subscription_RootFestival_Genres_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Genres_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Genres_Order_By>>;
  where?: InputMaybe<Festival_Genres_Bool_Exp>;
};


export type Subscription_RootFestival_Genres_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootFestival_Genres_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Festival_Genres_Stream_Cursor_Input>>;
  where?: InputMaybe<Festival_Genres_Bool_Exp>;
};


export type Subscription_RootFestival_Submission_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Festival_Submission_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Submission_Assets_Order_By>>;
  where?: InputMaybe<Festival_Submission_Assets_Bool_Exp>;
};


export type Subscription_RootFestival_Submission_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Submission_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Submission_Assets_Order_By>>;
  where?: InputMaybe<Festival_Submission_Assets_Bool_Exp>;
};


export type Subscription_RootFestival_Submission_Assets_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootFestival_Submission_Assets_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Festival_Submission_Assets_Stream_Cursor_Input>>;
  where?: InputMaybe<Festival_Submission_Assets_Bool_Exp>;
};


export type Subscription_RootFestival_Submission_FeedbackArgs = {
  distinct_on?: InputMaybe<Array<Festival_Submission_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Submission_Feedback_Order_By>>;
  where?: InputMaybe<Festival_Submission_Feedback_Bool_Exp>;
};


export type Subscription_RootFestival_Submission_Feedback_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Submission_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Submission_Feedback_Order_By>>;
  where?: InputMaybe<Festival_Submission_Feedback_Bool_Exp>;
};


export type Subscription_RootFestival_Submission_Feedback_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootFestival_Submission_Feedback_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Festival_Submission_Feedback_Stream_Cursor_Input>>;
  where?: InputMaybe<Festival_Submission_Feedback_Bool_Exp>;
};


export type Subscription_RootFestival_Submission_VouchersArgs = {
  distinct_on?: InputMaybe<Array<Festival_Submission_Vouchers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Submission_Vouchers_Order_By>>;
  where?: InputMaybe<Festival_Submission_Vouchers_Bool_Exp>;
};


export type Subscription_RootFestival_Submission_Vouchers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Submission_Vouchers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Submission_Vouchers_Order_By>>;
  where?: InputMaybe<Festival_Submission_Vouchers_Bool_Exp>;
};


export type Subscription_RootFestival_Submission_Vouchers_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootFestival_Submission_Vouchers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Festival_Submission_Vouchers_Stream_Cursor_Input>>;
  where?: InputMaybe<Festival_Submission_Vouchers_Bool_Exp>;
};


export type Subscription_RootFestival_SubmissionsArgs = {
  distinct_on?: InputMaybe<Array<Festival_Submissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Submissions_Order_By>>;
  where?: InputMaybe<Festival_Submissions_Bool_Exp>;
};


export type Subscription_RootFestival_Submissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Submissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Submissions_Order_By>>;
  where?: InputMaybe<Festival_Submissions_Bool_Exp>;
};


export type Subscription_RootFestival_Submissions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootFestival_Submissions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Festival_Submissions_Stream_Cursor_Input>>;
  where?: InputMaybe<Festival_Submissions_Bool_Exp>;
};


export type Subscription_RootFestival_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Festival_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Tickets_Order_By>>;
  where?: InputMaybe<Festival_Tickets_Bool_Exp>;
};


export type Subscription_RootFestival_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Tickets_Order_By>>;
  where?: InputMaybe<Festival_Tickets_Bool_Exp>;
};


export type Subscription_RootFestival_Tickets_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootFestival_Tickets_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Festival_Tickets_Stream_Cursor_Input>>;
  where?: InputMaybe<Festival_Tickets_Bool_Exp>;
};


export type Subscription_RootFilm_FestivalsArgs = {
  distinct_on?: InputMaybe<Array<Film_Festivals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Film_Festivals_Order_By>>;
  where?: InputMaybe<Film_Festivals_Bool_Exp>;
};


export type Subscription_RootFilm_Festivals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Film_Festivals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Film_Festivals_Order_By>>;
  where?: InputMaybe<Film_Festivals_Bool_Exp>;
};


export type Subscription_RootFilm_Festivals_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Subscription_RootFilm_Festivals_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Film_Festivals_Stream_Cursor_Input>>;
  where?: InputMaybe<Film_Festivals_Bool_Exp>;
};


export type Subscription_RootFilm_Group_Festival_SubmissionsArgs = {
  distinct_on?: InputMaybe<Array<Film_Group_Festival_Submissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Film_Group_Festival_Submissions_Order_By>>;
  where?: InputMaybe<Film_Group_Festival_Submissions_Bool_Exp>;
};


export type Subscription_RootFilm_Group_Festival_Submissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Film_Group_Festival_Submissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Film_Group_Festival_Submissions_Order_By>>;
  where?: InputMaybe<Film_Group_Festival_Submissions_Bool_Exp>;
};


export type Subscription_RootFilm_Group_Festival_Submissions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootFilm_Group_Festival_Submissions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Film_Group_Festival_Submissions_Stream_Cursor_Input>>;
  where?: InputMaybe<Film_Group_Festival_Submissions_Bool_Exp>;
};


export type Subscription_RootFilm_Group_FilmsArgs = {
  distinct_on?: InputMaybe<Array<Film_Group_Films_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Film_Group_Films_Order_By>>;
  where?: InputMaybe<Film_Group_Films_Bool_Exp>;
};


export type Subscription_RootFilm_Group_Films_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Film_Group_Films_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Film_Group_Films_Order_By>>;
  where?: InputMaybe<Film_Group_Films_Bool_Exp>;
};


export type Subscription_RootFilm_Group_Films_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootFilm_Group_Films_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Film_Group_Films_Stream_Cursor_Input>>;
  where?: InputMaybe<Film_Group_Films_Bool_Exp>;
};


export type Subscription_RootFilm_Group_UsersArgs = {
  distinct_on?: InputMaybe<Array<Film_Group_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Film_Group_Users_Order_By>>;
  where?: InputMaybe<Film_Group_Users_Bool_Exp>;
};


export type Subscription_RootFilm_Group_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Film_Group_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Film_Group_Users_Order_By>>;
  where?: InputMaybe<Film_Group_Users_Bool_Exp>;
};


export type Subscription_RootFilm_Group_Users_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootFilm_Group_Users_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Film_Group_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Film_Group_Users_Bool_Exp>;
};


export type Subscription_RootFilm_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Film_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Film_Groups_Order_By>>;
  where?: InputMaybe<Film_Groups_Bool_Exp>;
};


export type Subscription_RootFilm_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Film_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Film_Groups_Order_By>>;
  where?: InputMaybe<Film_Groups_Bool_Exp>;
};


export type Subscription_RootFilm_Groups_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootFilm_Groups_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Film_Groups_Stream_Cursor_Input>>;
  where?: InputMaybe<Film_Groups_Bool_Exp>;
};


export type Subscription_RootFilmsArgs = {
  distinct_on?: InputMaybe<Array<Films_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Films_Order_By>>;
  where?: InputMaybe<Films_Bool_Exp>;
};


export type Subscription_RootFilms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Films_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Films_Order_By>>;
  where?: InputMaybe<Films_Bool_Exp>;
};


export type Subscription_RootFilms_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Subscription_RootFilms_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Films_Stream_Cursor_Input>>;
  where?: InputMaybe<Films_Bool_Exp>;
};


export type Subscription_RootGenresArgs = {
  distinct_on?: InputMaybe<Array<Genres_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Genres_Order_By>>;
  where?: InputMaybe<Genres_Bool_Exp>;
};


export type Subscription_RootGenres_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Genres_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Genres_Order_By>>;
  where?: InputMaybe<Genres_Bool_Exp>;
};


export type Subscription_RootGenres_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Subscription_RootGenres_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Genres_Stream_Cursor_Input>>;
  where?: InputMaybe<Genres_Bool_Exp>;
};


export type Subscription_RootKickoff_CheckinsArgs = {
  distinct_on?: InputMaybe<Array<Kickoff_Checkins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Kickoff_Checkins_Order_By>>;
  where?: InputMaybe<Kickoff_Checkins_Bool_Exp>;
};


export type Subscription_RootKickoff_Checkins_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Kickoff_Checkins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Kickoff_Checkins_Order_By>>;
  where?: InputMaybe<Kickoff_Checkins_Bool_Exp>;
};


export type Subscription_RootKickoff_Checkins_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Subscription_RootKickoff_Checkins_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Kickoff_Checkins_Stream_Cursor_Input>>;
  where?: InputMaybe<Kickoff_Checkins_Bool_Exp>;
};


export type Subscription_RootLocation_ReleasesArgs = {
  distinct_on?: InputMaybe<Array<Location_Releases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Releases_Order_By>>;
  where?: InputMaybe<Location_Releases_Bool_Exp>;
};


export type Subscription_RootLocation_Releases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Location_Releases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Releases_Order_By>>;
  where?: InputMaybe<Location_Releases_Bool_Exp>;
};


export type Subscription_RootLocation_Releases_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Subscription_RootLocation_Releases_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Location_Releases_Stream_Cursor_Input>>;
  where?: InputMaybe<Location_Releases_Bool_Exp>;
};


export type Subscription_RootMatchup_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Matchup_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Matchup_Requests_Order_By>>;
  where?: InputMaybe<Matchup_Requests_Bool_Exp>;
};


export type Subscription_RootMatchup_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Matchup_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Matchup_Requests_Order_By>>;
  where?: InputMaybe<Matchup_Requests_Bool_Exp>;
};


export type Subscription_RootMatchup_Requests_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Subscription_RootMatchup_Requests_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Matchup_Requests_Stream_Cursor_Input>>;
  where?: InputMaybe<Matchup_Requests_Bool_Exp>;
};


export type Subscription_RootMusic_ReleasesArgs = {
  distinct_on?: InputMaybe<Array<Music_Releases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Music_Releases_Order_By>>;
  where?: InputMaybe<Music_Releases_Bool_Exp>;
};


export type Subscription_RootMusic_Releases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Music_Releases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Music_Releases_Order_By>>;
  where?: InputMaybe<Music_Releases_Bool_Exp>;
};


export type Subscription_RootMusic_Releases_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Subscription_RootMusic_Releases_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Music_Releases_Stream_Cursor_Input>>;
  where?: InputMaybe<Music_Releases_Bool_Exp>;
};


export type Subscription_RootNomination_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Nomination_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nomination_Assets_Order_By>>;
  where?: InputMaybe<Nomination_Assets_Bool_Exp>;
};


export type Subscription_RootNomination_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nomination_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nomination_Assets_Order_By>>;
  where?: InputMaybe<Nomination_Assets_Bool_Exp>;
};


export type Subscription_RootNomination_Assets_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Subscription_RootNomination_Assets_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Nomination_Assets_Stream_Cursor_Input>>;
  where?: InputMaybe<Nomination_Assets_Bool_Exp>;
};


export type Subscription_RootNominationsArgs = {
  distinct_on?: InputMaybe<Array<Nominations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nominations_Order_By>>;
  where?: InputMaybe<Nominations_Bool_Exp>;
};


export type Subscription_RootNominations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nominations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nominations_Order_By>>;
  where?: InputMaybe<Nominations_Bool_Exp>;
};


export type Subscription_RootNominations_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Subscription_RootNominations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Nominations_Stream_Cursor_Input>>;
  where?: InputMaybe<Nominations_Bool_Exp>;
};


export type Subscription_RootOnline_Screening_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Online_Screening_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Online_Screening_Tickets_Order_By>>;
  where?: InputMaybe<Online_Screening_Tickets_Bool_Exp>;
};


export type Subscription_RootOnline_Screening_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Online_Screening_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Online_Screening_Tickets_Order_By>>;
  where?: InputMaybe<Online_Screening_Tickets_Bool_Exp>;
};


export type Subscription_RootOnline_Screening_Tickets_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootOnline_Screening_Tickets_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Online_Screening_Tickets_Stream_Cursor_Input>>;
  where?: InputMaybe<Online_Screening_Tickets_Bool_Exp>;
};


export type Subscription_RootPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


export type Subscription_RootPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


export type Subscription_RootPayments_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Subscription_RootPayments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Payments_Stream_Cursor_Input>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


export type Subscription_RootPlaylist_TeamArgs = {
  distinct_on?: InputMaybe<Array<Playlist_Team_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Playlist_Team_Order_By>>;
  where?: InputMaybe<Playlist_Team_Bool_Exp>;
};


export type Subscription_RootPlaylist_Team_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Playlist_Team_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Playlist_Team_Order_By>>;
  where?: InputMaybe<Playlist_Team_Bool_Exp>;
};


export type Subscription_RootPlaylist_Team_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPlaylist_Team_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Playlist_Team_Stream_Cursor_Input>>;
  where?: InputMaybe<Playlist_Team_Bool_Exp>;
};


export type Subscription_RootPlaylistsArgs = {
  distinct_on?: InputMaybe<Array<Playlists_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Playlists_Order_By>>;
  where?: InputMaybe<Playlists_Bool_Exp>;
};


export type Subscription_RootPlaylists_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Playlists_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Playlists_Order_By>>;
  where?: InputMaybe<Playlists_Bool_Exp>;
};


export type Subscription_RootPlaylists_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPlaylists_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Playlists_Stream_Cursor_Input>>;
  where?: InputMaybe<Playlists_Bool_Exp>;
};


export type Subscription_RootPrize_ElectionsArgs = {
  distinct_on?: InputMaybe<Array<Prize_Elections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prize_Elections_Order_By>>;
  where?: InputMaybe<Prize_Elections_Bool_Exp>;
};


export type Subscription_RootPrize_Elections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prize_Elections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prize_Elections_Order_By>>;
  where?: InputMaybe<Prize_Elections_Bool_Exp>;
};


export type Subscription_RootPrize_Elections_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Prize_Elections_Stream_Cursor_Input>>;
  where?: InputMaybe<Prize_Elections_Bool_Exp>;
};


export type Subscription_RootPrizesArgs = {
  distinct_on?: InputMaybe<Array<Prizes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prizes_Order_By>>;
  where?: InputMaybe<Prizes_Bool_Exp>;
};


export type Subscription_RootPrizes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prizes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prizes_Order_By>>;
  where?: InputMaybe<Prizes_Bool_Exp>;
};


export type Subscription_RootPrizes_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Subscription_RootPrizes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Prizes_Stream_Cursor_Input>>;
  where?: InputMaybe<Prizes_Bool_Exp>;
};


export type Subscription_RootRegistrationsArgs = {
  distinct_on?: InputMaybe<Array<Registrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Registrations_Order_By>>;
  where?: InputMaybe<Registrations_Bool_Exp>;
};


export type Subscription_RootRegistrations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Registrations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Registrations_Order_By>>;
  where?: InputMaybe<Registrations_Bool_Exp>;
};


export type Subscription_RootRegistrations_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Subscription_RootRegistrations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Registrations_Stream_Cursor_Input>>;
  where?: InputMaybe<Registrations_Bool_Exp>;
};


export type Subscription_RootSelection_BallotsArgs = {
  distinct_on?: InputMaybe<Array<Selection_Ballots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Selection_Ballots_Order_By>>;
  where?: InputMaybe<Selection_Ballots_Bool_Exp>;
};


export type Subscription_RootSelection_Ballots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Selection_Ballots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Selection_Ballots_Order_By>>;
  where?: InputMaybe<Selection_Ballots_Bool_Exp>;
};


export type Subscription_RootSelection_Ballots_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSelection_Ballots_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Selection_Ballots_Stream_Cursor_Input>>;
  where?: InputMaybe<Selection_Ballots_Bool_Exp>;
};


export type Subscription_RootSelection_FeedbackArgs = {
  distinct_on?: InputMaybe<Array<Selection_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Selection_Feedback_Order_By>>;
  where?: InputMaybe<Selection_Feedback_Bool_Exp>;
};


export type Subscription_RootSelection_Feedback_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Selection_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Selection_Feedback_Order_By>>;
  where?: InputMaybe<Selection_Feedback_Bool_Exp>;
};


export type Subscription_RootSelection_Feedback_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSelection_Feedback_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Selection_Feedback_Stream_Cursor_Input>>;
  where?: InputMaybe<Selection_Feedback_Bool_Exp>;
};


export type Subscription_RootSelection_MetricsArgs = {
  distinct_on?: InputMaybe<Array<Selection_Metrics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Selection_Metrics_Order_By>>;
  where?: InputMaybe<Selection_Metrics_Bool_Exp>;
};


export type Subscription_RootSelection_Metrics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Selection_Metrics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Selection_Metrics_Order_By>>;
  where?: InputMaybe<Selection_Metrics_Bool_Exp>;
};


export type Subscription_RootSelection_Metrics_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSelection_Metrics_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Selection_Metrics_Stream_Cursor_Input>>;
  where?: InputMaybe<Selection_Metrics_Bool_Exp>;
};


export type Subscription_RootSelection_ProgressArgs = {
  distinct_on?: InputMaybe<Array<Selection_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Selection_Progress_Order_By>>;
  where?: InputMaybe<Selection_Progress_Bool_Exp>;
};


export type Subscription_RootSelection_Progress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Selection_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Selection_Progress_Order_By>>;
  where?: InputMaybe<Selection_Progress_Bool_Exp>;
};


export type Subscription_RootSelection_Progress_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSelection_Progress_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Selection_Progress_Stream_Cursor_Input>>;
  where?: InputMaybe<Selection_Progress_Bool_Exp>;
};


export type Subscription_RootSelection_ResultsArgs = {
  distinct_on?: InputMaybe<Array<Selection_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Selection_Results_Order_By>>;
  where?: InputMaybe<Selection_Results_Bool_Exp>;
};


export type Subscription_RootSelection_Results_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Selection_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Selection_Results_Order_By>>;
  where?: InputMaybe<Selection_Results_Bool_Exp>;
};


export type Subscription_RootSelection_Results_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Selection_Results_Stream_Cursor_Input>>;
  where?: InputMaybe<Selection_Results_Bool_Exp>;
};


export type Subscription_RootSharablesArgs = {
  distinct_on?: InputMaybe<Array<Sharables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sharables_Order_By>>;
  where?: InputMaybe<Sharables_Bool_Exp>;
};


export type Subscription_RootSharables_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sharables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sharables_Order_By>>;
  where?: InputMaybe<Sharables_Bool_Exp>;
};


export type Subscription_RootSharables_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSharables_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sharables_Stream_Cursor_Input>>;
  where?: InputMaybe<Sharables_Bool_Exp>;
};


export type Subscription_RootShouldReloadFestivalSubmissionArgs = {
  id: Scalars['ID'];
};


export type Subscription_RootShouldReloadTeamArgs = {
  id: Scalars['ID'];
};


export type Subscription_RootSms_VotesArgs = {
  distinct_on?: InputMaybe<Array<Sms_Votes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sms_Votes_Order_By>>;
  where?: InputMaybe<Sms_Votes_Bool_Exp>;
};


export type Subscription_RootSms_Votes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sms_Votes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sms_Votes_Order_By>>;
  where?: InputMaybe<Sms_Votes_Bool_Exp>;
};


export type Subscription_RootSms_Votes_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSms_Votes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sms_Votes_Stream_Cursor_Input>>;
  where?: InputMaybe<Sms_Votes_Bool_Exp>;
};


export type Subscription_RootSponsorsArgs = {
  distinct_on?: InputMaybe<Array<Sponsors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsors_Order_By>>;
  where?: InputMaybe<Sponsors_Bool_Exp>;
};


export type Subscription_RootSponsors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sponsors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sponsors_Order_By>>;
  where?: InputMaybe<Sponsors_Bool_Exp>;
};


export type Subscription_RootSponsors_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Subscription_RootSponsors_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sponsors_Stream_Cursor_Input>>;
  where?: InputMaybe<Sponsors_Bool_Exp>;
};


export type Subscription_RootStudiosArgs = {
  distinct_on?: InputMaybe<Array<Studios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Studios_Order_By>>;
  where?: InputMaybe<Studios_Bool_Exp>;
};


export type Subscription_RootStudios_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Studios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Studios_Order_By>>;
  where?: InputMaybe<Studios_Bool_Exp>;
};


export type Subscription_RootStudios_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootStudios_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Studios_Stream_Cursor_Input>>;
  where?: InputMaybe<Studios_Bool_Exp>;
};


export type Subscription_RootSubmission_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Submission_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Submission_Summary_Order_By>>;
  where?: InputMaybe<Submission_Summary_Bool_Exp>;
};


export type Subscription_RootSubmission_Summary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Submission_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Submission_Summary_Order_By>>;
  where?: InputMaybe<Submission_Summary_Bool_Exp>;
};


export type Subscription_RootSubmission_Summary_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Submission_Summary_Stream_Cursor_Input>>;
  where?: InputMaybe<Submission_Summary_Bool_Exp>;
};


export type Subscription_RootTeam_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Team_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Assets_Order_By>>;
  where?: InputMaybe<Team_Assets_Bool_Exp>;
};


export type Subscription_RootTeam_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Team_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Assets_Order_By>>;
  where?: InputMaybe<Team_Assets_Bool_Exp>;
};


export type Subscription_RootTeam_Assets_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Subscription_RootTeam_Assets_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Team_Assets_Stream_Cursor_Input>>;
  where?: InputMaybe<Team_Assets_Bool_Exp>;
};


export type Subscription_RootTeam_MembershipsArgs = {
  distinct_on?: InputMaybe<Array<Team_Memberships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Memberships_Order_By>>;
  where?: InputMaybe<Team_Memberships_Bool_Exp>;
};


export type Subscription_RootTeam_Memberships_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Team_Memberships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Memberships_Order_By>>;
  where?: InputMaybe<Team_Memberships_Bool_Exp>;
};


export type Subscription_RootTeam_Memberships_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Subscription_RootTeam_Memberships_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Team_Memberships_Stream_Cursor_Input>>;
  where?: InputMaybe<Team_Memberships_Bool_Exp>;
};


export type Subscription_RootTeam_RolesArgs = {
  distinct_on?: InputMaybe<Array<Team_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Roles_Order_By>>;
  where?: InputMaybe<Team_Roles_Bool_Exp>;
};


export type Subscription_RootTeam_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Team_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Roles_Order_By>>;
  where?: InputMaybe<Team_Roles_Bool_Exp>;
};


export type Subscription_RootTeam_Roles_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Subscription_RootTeam_Roles_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Team_Roles_Stream_Cursor_Input>>;
  where?: InputMaybe<Team_Roles_Bool_Exp>;
};


export type Subscription_RootTeamsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Subscription_RootTeams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Subscription_RootTeams_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Subscription_RootTeams_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Teams_Stream_Cursor_Input>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Subscription_RootTeams_With_Awards_Ceremony_CheckinsArgs = {
  distinct_on?: InputMaybe<Array<Teams_With_Awards_Ceremony_Checkins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_With_Awards_Ceremony_Checkins_Order_By>>;
  where?: InputMaybe<Teams_With_Awards_Ceremony_Checkins_Bool_Exp>;
};


export type Subscription_RootTeams_With_Awards_Ceremony_Checkins_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_With_Awards_Ceremony_Checkins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_With_Awards_Ceremony_Checkins_Order_By>>;
  where?: InputMaybe<Teams_With_Awards_Ceremony_Checkins_Bool_Exp>;
};


export type Subscription_RootTeams_With_Awards_Ceremony_Checkins_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Teams_With_Awards_Ceremony_Checkins_Stream_Cursor_Input>>;
  where?: InputMaybe<Teams_With_Awards_Ceremony_Checkins_Bool_Exp>;
};


export type Subscription_RootTeams_With_CheckinsArgs = {
  distinct_on?: InputMaybe<Array<Teams_With_Checkins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_With_Checkins_Order_By>>;
  where?: InputMaybe<Teams_With_Checkins_Bool_Exp>;
};


export type Subscription_RootTeams_With_Checkins_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_With_Checkins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teams_With_Checkins_Order_By>>;
  where?: InputMaybe<Teams_With_Checkins_Bool_Exp>;
};


export type Subscription_RootTeams_With_Checkins_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Teams_With_Checkins_Stream_Cursor_Input>>;
  where?: InputMaybe<Teams_With_Checkins_Bool_Exp>;
};


export type Subscription_RootTicket_Tailor_VouchersArgs = {
  distinct_on?: InputMaybe<Array<Ticket_Tailor_Vouchers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticket_Tailor_Vouchers_Order_By>>;
  where?: InputMaybe<Ticket_Tailor_Vouchers_Bool_Exp>;
};


export type Subscription_RootTicket_Tailor_Vouchers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticket_Tailor_Vouchers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticket_Tailor_Vouchers_Order_By>>;
  where?: InputMaybe<Ticket_Tailor_Vouchers_Bool_Exp>;
};


export type Subscription_RootTicket_Tailor_Vouchers_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootTicket_Tailor_Vouchers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ticket_Tailor_Vouchers_Stream_Cursor_Input>>;
  where?: InputMaybe<Ticket_Tailor_Vouchers_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** columns and relationships of "team_assets" */
export type Team_Assets = {
  __typename?: 'team_assets';
  /** An object relationship */
  asset_type: Asset_Types;
  asset_type_id: Scalars['numeric'];
  created: Scalars['timestamp'];
  created_by: Scalars['String'];
  file_name: Scalars['String'];
  id: Scalars['numeric'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['numeric'];
  updated: Scalars['timestamp'];
  updated_by: Scalars['String'];
};

/** aggregated selection of "team_assets" */
export type Team_Assets_Aggregate = {
  __typename?: 'team_assets_aggregate';
  aggregate?: Maybe<Team_Assets_Aggregate_Fields>;
  nodes: Array<Team_Assets>;
};

export type Team_Assets_Aggregate_Bool_Exp = {
  count?: InputMaybe<Team_Assets_Aggregate_Bool_Exp_Count>;
};

export type Team_Assets_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Team_Assets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Team_Assets_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "team_assets" */
export type Team_Assets_Aggregate_Fields = {
  __typename?: 'team_assets_aggregate_fields';
  avg?: Maybe<Team_Assets_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Team_Assets_Max_Fields>;
  min?: Maybe<Team_Assets_Min_Fields>;
  stddev?: Maybe<Team_Assets_Stddev_Fields>;
  stddev_pop?: Maybe<Team_Assets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Team_Assets_Stddev_Samp_Fields>;
  sum?: Maybe<Team_Assets_Sum_Fields>;
  var_pop?: Maybe<Team_Assets_Var_Pop_Fields>;
  var_samp?: Maybe<Team_Assets_Var_Samp_Fields>;
  variance?: Maybe<Team_Assets_Variance_Fields>;
};


/** aggregate fields of "team_assets" */
export type Team_Assets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Team_Assets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "team_assets" */
export type Team_Assets_Aggregate_Order_By = {
  avg?: InputMaybe<Team_Assets_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Team_Assets_Max_Order_By>;
  min?: InputMaybe<Team_Assets_Min_Order_By>;
  stddev?: InputMaybe<Team_Assets_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Team_Assets_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Team_Assets_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Team_Assets_Sum_Order_By>;
  var_pop?: InputMaybe<Team_Assets_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Team_Assets_Var_Samp_Order_By>;
  variance?: InputMaybe<Team_Assets_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "team_assets" */
export type Team_Assets_Arr_Rel_Insert_Input = {
  data: Array<Team_Assets_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Team_Assets_On_Conflict>;
};

/** aggregate avg on columns */
export type Team_Assets_Avg_Fields = {
  __typename?: 'team_assets_avg_fields';
  asset_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "team_assets" */
export type Team_Assets_Avg_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "team_assets". All fields are combined with a logical 'AND'. */
export type Team_Assets_Bool_Exp = {
  _and?: InputMaybe<Array<Team_Assets_Bool_Exp>>;
  _not?: InputMaybe<Team_Assets_Bool_Exp>;
  _or?: InputMaybe<Array<Team_Assets_Bool_Exp>>;
  asset_type?: InputMaybe<Asset_Types_Bool_Exp>;
  asset_type_id?: InputMaybe<Numeric_Comparison_Exp>;
  created?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  file_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Numeric_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Numeric_Comparison_Exp>;
  updated?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "team_assets" */
export enum Team_Assets_Constraint {
  /** unique or primary key constraint on columns "id" */
  TeamAssetsPkey = 'team_assets_pkey'
}

/** input type for incrementing numeric columns in table "team_assets" */
export type Team_Assets_Inc_Input = {
  asset_type_id?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['numeric']>;
  team_id?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "team_assets" */
export type Team_Assets_Insert_Input = {
  asset_type?: InputMaybe<Asset_Types_Obj_Rel_Insert_Input>;
  asset_type_id?: InputMaybe<Scalars['numeric']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  file_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Team_Assets_Max_Fields = {
  __typename?: 'team_assets_max_fields';
  asset_type_id?: Maybe<Scalars['numeric']>;
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  file_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  team_id?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "team_assets" */
export type Team_Assets_Max_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Team_Assets_Min_Fields = {
  __typename?: 'team_assets_min_fields';
  asset_type_id?: Maybe<Scalars['numeric']>;
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  file_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  team_id?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "team_assets" */
export type Team_Assets_Min_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "team_assets" */
export type Team_Assets_Mutation_Response = {
  __typename?: 'team_assets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Team_Assets>;
};

/** input type for inserting object relation for remote table "team_assets" */
export type Team_Assets_Obj_Rel_Insert_Input = {
  data: Team_Assets_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Team_Assets_On_Conflict>;
};

/** on_conflict condition type for table "team_assets" */
export type Team_Assets_On_Conflict = {
  constraint: Team_Assets_Constraint;
  update_columns?: Array<Team_Assets_Update_Column>;
  where?: InputMaybe<Team_Assets_Bool_Exp>;
};

/** Ordering options when selecting data from "team_assets". */
export type Team_Assets_Order_By = {
  asset_type?: InputMaybe<Asset_Types_Order_By>;
  asset_type_id?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: team_assets */
export type Team_Assets_Pk_Columns_Input = {
  id: Scalars['numeric'];
};

/** select columns of table "team_assets" */
export enum Team_Assets_Select_Column {
  /** column name */
  AssetTypeId = 'asset_type_id',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  FileName = 'file_name',
  /** column name */
  Id = 'id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** input type for updating data in table "team_assets" */
export type Team_Assets_Set_Input = {
  asset_type_id?: InputMaybe<Scalars['numeric']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  file_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Team_Assets_Stddev_Fields = {
  __typename?: 'team_assets_stddev_fields';
  asset_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "team_assets" */
export type Team_Assets_Stddev_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Team_Assets_Stddev_Pop_Fields = {
  __typename?: 'team_assets_stddev_pop_fields';
  asset_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "team_assets" */
export type Team_Assets_Stddev_Pop_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Team_Assets_Stddev_Samp_Fields = {
  __typename?: 'team_assets_stddev_samp_fields';
  asset_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "team_assets" */
export type Team_Assets_Stddev_Samp_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "team_assets" */
export type Team_Assets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Team_Assets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Team_Assets_Stream_Cursor_Value_Input = {
  asset_type_id?: InputMaybe<Scalars['numeric']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  file_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Team_Assets_Sum_Fields = {
  __typename?: 'team_assets_sum_fields';
  asset_type_id?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['numeric']>;
  team_id?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "team_assets" */
export type Team_Assets_Sum_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** update columns of table "team_assets" */
export enum Team_Assets_Update_Column {
  /** column name */
  AssetTypeId = 'asset_type_id',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  FileName = 'file_name',
  /** column name */
  Id = 'id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by'
}

export type Team_Assets_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Team_Assets_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Team_Assets_Set_Input>;
  /** filter the rows which have to be updated */
  where: Team_Assets_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Team_Assets_Var_Pop_Fields = {
  __typename?: 'team_assets_var_pop_fields';
  asset_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "team_assets" */
export type Team_Assets_Var_Pop_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Team_Assets_Var_Samp_Fields = {
  __typename?: 'team_assets_var_samp_fields';
  asset_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "team_assets" */
export type Team_Assets_Var_Samp_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Team_Assets_Variance_Fields = {
  __typename?: 'team_assets_variance_fields';
  asset_type_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "team_assets" */
export type Team_Assets_Variance_Order_By = {
  asset_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "team_memberships" */
export type Team_Memberships = {
  __typename?: 'team_memberships';
  created: Scalars['timestamp'];
  created_by: Scalars['String'];
  credit?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['timestamptz']>;
  id: Scalars['numeric'];
  is_invited?: Maybe<Scalars['String']>;
  /** An array relationship */
  nominations: Array<Nominations>;
  /** An aggregate relationship */
  nominations_aggregate: Nominations_Aggregate;
  /** An object relationship */
  registration?: Maybe<Registrations>;
  /** An object relationship */
  role: Team_Roles;
  role_id: Scalars['numeric'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['numeric'];
  updated: Scalars['timestamp'];
  updated_by: Scalars['String'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['numeric']>;
};


/** columns and relationships of "team_memberships" */
export type Team_MembershipsNominationsArgs = {
  distinct_on?: InputMaybe<Array<Nominations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nominations_Order_By>>;
  where?: InputMaybe<Nominations_Bool_Exp>;
};


/** columns and relationships of "team_memberships" */
export type Team_MembershipsNominations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nominations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nominations_Order_By>>;
  where?: InputMaybe<Nominations_Bool_Exp>;
};

/** aggregated selection of "team_memberships" */
export type Team_Memberships_Aggregate = {
  __typename?: 'team_memberships_aggregate';
  aggregate?: Maybe<Team_Memberships_Aggregate_Fields>;
  nodes: Array<Team_Memberships>;
};

export type Team_Memberships_Aggregate_Bool_Exp = {
  count?: InputMaybe<Team_Memberships_Aggregate_Bool_Exp_Count>;
};

export type Team_Memberships_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Team_Memberships_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Team_Memberships_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "team_memberships" */
export type Team_Memberships_Aggregate_Fields = {
  __typename?: 'team_memberships_aggregate_fields';
  avg?: Maybe<Team_Memberships_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Team_Memberships_Max_Fields>;
  min?: Maybe<Team_Memberships_Min_Fields>;
  stddev?: Maybe<Team_Memberships_Stddev_Fields>;
  stddev_pop?: Maybe<Team_Memberships_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Team_Memberships_Stddev_Samp_Fields>;
  sum?: Maybe<Team_Memberships_Sum_Fields>;
  var_pop?: Maybe<Team_Memberships_Var_Pop_Fields>;
  var_samp?: Maybe<Team_Memberships_Var_Samp_Fields>;
  variance?: Maybe<Team_Memberships_Variance_Fields>;
};


/** aggregate fields of "team_memberships" */
export type Team_Memberships_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Team_Memberships_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "team_memberships" */
export type Team_Memberships_Aggregate_Order_By = {
  avg?: InputMaybe<Team_Memberships_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Team_Memberships_Max_Order_By>;
  min?: InputMaybe<Team_Memberships_Min_Order_By>;
  stddev?: InputMaybe<Team_Memberships_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Team_Memberships_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Team_Memberships_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Team_Memberships_Sum_Order_By>;
  var_pop?: InputMaybe<Team_Memberships_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Team_Memberships_Var_Samp_Order_By>;
  variance?: InputMaybe<Team_Memberships_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "team_memberships" */
export type Team_Memberships_Arr_Rel_Insert_Input = {
  data: Array<Team_Memberships_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Team_Memberships_On_Conflict>;
};

/** aggregate avg on columns */
export type Team_Memberships_Avg_Fields = {
  __typename?: 'team_memberships_avg_fields';
  id?: Maybe<Scalars['Float']>;
  role_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "team_memberships" */
export type Team_Memberships_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "team_memberships". All fields are combined with a logical 'AND'. */
export type Team_Memberships_Bool_Exp = {
  _and?: InputMaybe<Array<Team_Memberships_Bool_Exp>>;
  _not?: InputMaybe<Team_Memberships_Bool_Exp>;
  _or?: InputMaybe<Array<Team_Memberships_Bool_Exp>>;
  created?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  credit?: InputMaybe<String_Comparison_Exp>;
  deleted?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Numeric_Comparison_Exp>;
  is_invited?: InputMaybe<String_Comparison_Exp>;
  nominations?: InputMaybe<Nominations_Bool_Exp>;
  nominations_aggregate?: InputMaybe<Nominations_Aggregate_Bool_Exp>;
  registration?: InputMaybe<Registrations_Bool_Exp>;
  role?: InputMaybe<Team_Roles_Bool_Exp>;
  role_id?: InputMaybe<Numeric_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Numeric_Comparison_Exp>;
  updated?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "team_memberships" */
export enum Team_Memberships_Constraint {
  /** unique or primary key constraint on columns "id" */
  TeamMembershipsPkey = 'team_memberships_pkey'
}

/** input type for incrementing numeric columns in table "team_memberships" */
export type Team_Memberships_Inc_Input = {
  id?: InputMaybe<Scalars['numeric']>;
  role_id?: InputMaybe<Scalars['numeric']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  user_id?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "team_memberships" */
export type Team_Memberships_Insert_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  credit?: InputMaybe<Scalars['String']>;
  deleted?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['numeric']>;
  is_invited?: InputMaybe<Scalars['String']>;
  nominations?: InputMaybe<Nominations_Arr_Rel_Insert_Input>;
  registration?: InputMaybe<Registrations_Obj_Rel_Insert_Input>;
  role?: InputMaybe<Team_Roles_Obj_Rel_Insert_Input>;
  role_id?: InputMaybe<Scalars['numeric']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type Team_Memberships_Max_Fields = {
  __typename?: 'team_memberships_max_fields';
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  credit?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['numeric']>;
  is_invited?: Maybe<Scalars['String']>;
  role_id?: Maybe<Scalars['numeric']>;
  team_id?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "team_memberships" */
export type Team_Memberships_Max_Order_By = {
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  credit?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_invited?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Team_Memberships_Min_Fields = {
  __typename?: 'team_memberships_min_fields';
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  credit?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['numeric']>;
  is_invited?: Maybe<Scalars['String']>;
  role_id?: Maybe<Scalars['numeric']>;
  team_id?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "team_memberships" */
export type Team_Memberships_Min_Order_By = {
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  credit?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_invited?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "team_memberships" */
export type Team_Memberships_Mutation_Response = {
  __typename?: 'team_memberships_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Team_Memberships>;
};

/** input type for inserting object relation for remote table "team_memberships" */
export type Team_Memberships_Obj_Rel_Insert_Input = {
  data: Team_Memberships_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Team_Memberships_On_Conflict>;
};

/** on_conflict condition type for table "team_memberships" */
export type Team_Memberships_On_Conflict = {
  constraint: Team_Memberships_Constraint;
  update_columns?: Array<Team_Memberships_Update_Column>;
  where?: InputMaybe<Team_Memberships_Bool_Exp>;
};

/** Ordering options when selecting data from "team_memberships". */
export type Team_Memberships_Order_By = {
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  credit?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_invited?: InputMaybe<Order_By>;
  nominations_aggregate?: InputMaybe<Nominations_Aggregate_Order_By>;
  registration?: InputMaybe<Registrations_Order_By>;
  role?: InputMaybe<Team_Roles_Order_By>;
  role_id?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: team_memberships */
export type Team_Memberships_Pk_Columns_Input = {
  id: Scalars['numeric'];
};

/** select columns of table "team_memberships" */
export enum Team_Memberships_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Credit = 'credit',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  IsInvited = 'is_invited',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "team_memberships" */
export type Team_Memberships_Set_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  credit?: InputMaybe<Scalars['String']>;
  deleted?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['numeric']>;
  is_invited?: InputMaybe<Scalars['String']>;
  role_id?: InputMaybe<Scalars['numeric']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type Team_Memberships_Stddev_Fields = {
  __typename?: 'team_memberships_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  role_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "team_memberships" */
export type Team_Memberships_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Team_Memberships_Stddev_Pop_Fields = {
  __typename?: 'team_memberships_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  role_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "team_memberships" */
export type Team_Memberships_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Team_Memberships_Stddev_Samp_Fields = {
  __typename?: 'team_memberships_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  role_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "team_memberships" */
export type Team_Memberships_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "team_memberships" */
export type Team_Memberships_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Team_Memberships_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Team_Memberships_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  credit?: InputMaybe<Scalars['String']>;
  deleted?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['numeric']>;
  is_invited?: InputMaybe<Scalars['String']>;
  role_id?: InputMaybe<Scalars['numeric']>;
  team_id?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Team_Memberships_Sum_Fields = {
  __typename?: 'team_memberships_sum_fields';
  id?: Maybe<Scalars['numeric']>;
  role_id?: Maybe<Scalars['numeric']>;
  team_id?: Maybe<Scalars['numeric']>;
  user_id?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "team_memberships" */
export type Team_Memberships_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "team_memberships" */
export enum Team_Memberships_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Credit = 'credit',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  IsInvited = 'is_invited',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  UserId = 'user_id'
}

export type Team_Memberships_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Team_Memberships_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Team_Memberships_Set_Input>;
  /** filter the rows which have to be updated */
  where: Team_Memberships_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Team_Memberships_Var_Pop_Fields = {
  __typename?: 'team_memberships_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  role_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "team_memberships" */
export type Team_Memberships_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Team_Memberships_Var_Samp_Fields = {
  __typename?: 'team_memberships_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  role_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "team_memberships" */
export type Team_Memberships_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Team_Memberships_Variance_Fields = {
  __typename?: 'team_memberships_variance_fields';
  id?: Maybe<Scalars['Float']>;
  role_id?: Maybe<Scalars['Float']>;
  team_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "team_memberships" */
export type Team_Memberships_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "team_roles" */
export type Team_Roles = {
  __typename?: 'team_roles';
  created: Scalars['timestamp'];
  created_by: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['numeric'];
  name?: Maybe<Scalars['String']>;
  updated: Scalars['timestamp'];
  updated_by: Scalars['String'];
};

/** aggregated selection of "team_roles" */
export type Team_Roles_Aggregate = {
  __typename?: 'team_roles_aggregate';
  aggregate?: Maybe<Team_Roles_Aggregate_Fields>;
  nodes: Array<Team_Roles>;
};

/** aggregate fields of "team_roles" */
export type Team_Roles_Aggregate_Fields = {
  __typename?: 'team_roles_aggregate_fields';
  avg?: Maybe<Team_Roles_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Team_Roles_Max_Fields>;
  min?: Maybe<Team_Roles_Min_Fields>;
  stddev?: Maybe<Team_Roles_Stddev_Fields>;
  stddev_pop?: Maybe<Team_Roles_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Team_Roles_Stddev_Samp_Fields>;
  sum?: Maybe<Team_Roles_Sum_Fields>;
  var_pop?: Maybe<Team_Roles_Var_Pop_Fields>;
  var_samp?: Maybe<Team_Roles_Var_Samp_Fields>;
  variance?: Maybe<Team_Roles_Variance_Fields>;
};


/** aggregate fields of "team_roles" */
export type Team_Roles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Team_Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Team_Roles_Avg_Fields = {
  __typename?: 'team_roles_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "team_roles". All fields are combined with a logical 'AND'. */
export type Team_Roles_Bool_Exp = {
  _and?: InputMaybe<Array<Team_Roles_Bool_Exp>>;
  _not?: InputMaybe<Team_Roles_Bool_Exp>;
  _or?: InputMaybe<Array<Team_Roles_Bool_Exp>>;
  created?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Numeric_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "team_roles" */
export enum Team_Roles_Constraint {
  /** unique or primary key constraint on columns "id" */
  TeamRolesPkey = 'team_roles_pkey'
}

/** input type for incrementing numeric columns in table "team_roles" */
export type Team_Roles_Inc_Input = {
  id?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "team_roles" */
export type Team_Roles_Insert_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Team_Roles_Max_Fields = {
  __typename?: 'team_roles_max_fields';
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Team_Roles_Min_Fields = {
  __typename?: 'team_roles_min_fields';
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "team_roles" */
export type Team_Roles_Mutation_Response = {
  __typename?: 'team_roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Team_Roles>;
};

/** input type for inserting object relation for remote table "team_roles" */
export type Team_Roles_Obj_Rel_Insert_Input = {
  data: Team_Roles_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Team_Roles_On_Conflict>;
};

/** on_conflict condition type for table "team_roles" */
export type Team_Roles_On_Conflict = {
  constraint: Team_Roles_Constraint;
  update_columns?: Array<Team_Roles_Update_Column>;
  where?: InputMaybe<Team_Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "team_roles". */
export type Team_Roles_Order_By = {
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: team_roles */
export type Team_Roles_Pk_Columns_Input = {
  id: Scalars['numeric'];
};

/** select columns of table "team_roles" */
export enum Team_Roles_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** input type for updating data in table "team_roles" */
export type Team_Roles_Set_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Team_Roles_Stddev_Fields = {
  __typename?: 'team_roles_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Team_Roles_Stddev_Pop_Fields = {
  __typename?: 'team_roles_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Team_Roles_Stddev_Samp_Fields = {
  __typename?: 'team_roles_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "team_roles" */
export type Team_Roles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Team_Roles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Team_Roles_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Team_Roles_Sum_Fields = {
  __typename?: 'team_roles_sum_fields';
  id?: Maybe<Scalars['numeric']>;
};

/** update columns of table "team_roles" */
export enum Team_Roles_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by'
}

export type Team_Roles_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Team_Roles_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Team_Roles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Team_Roles_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Team_Roles_Var_Pop_Fields = {
  __typename?: 'team_roles_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Team_Roles_Var_Samp_Fields = {
  __typename?: 'team_roles_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Team_Roles_Variance_Fields = {
  __typename?: 'team_roles_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "teams" */
export type Teams = {
  __typename?: 'teams';
  /** An array relationship */
  asset_exports: Array<Asset_Exports>;
  /** An aggregate relationship */
  asset_exports_aggregate: Asset_Exports_Aggregate;
  /** An array relationship */
  assets: Array<Team_Assets>;
  /** An aggregate relationship */
  assets_aggregate: Team_Assets_Aggregate;
  /** An array relationship */
  award_nominations: Array<Award_Nominations>;
  /** An aggregate relationship */
  award_nominations_aggregate: Award_Nominations_Aggregate;
  /** An array relationship */
  award_wins: Array<Award_Winners>;
  /** An aggregate relationship */
  award_wins_aggregate: Award_Winners_Aggregate;
  created: Scalars['timestamp'];
  created_by: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
  /** An object relationship */
  exit_interview?: Maybe<Exit_Interviews>;
  /** An array relationship */
  festival_badges: Array<Festival_Badges>;
  /** An aggregate relationship */
  festival_badges_aggregate: Festival_Badges_Aggregate;
  /** An array relationship */
  festival_submission_vouchers: Array<Festival_Submission_Vouchers>;
  /** An aggregate relationship */
  festival_submission_vouchers_aggregate: Festival_Submission_Vouchers_Aggregate;
  /** An object relationship */
  film?: Maybe<Films>;
  /** An object relationship */
  film_festival: Film_Festivals;
  film_festival_id: Scalars['numeric'];
  /** An object relationship */
  film_group?: Maybe<Film_Group_Films>;
  /** An array relationship */
  film_groups: Array<Film_Group_Films>;
  /** An aggregate relationship */
  film_groups_aggregate: Film_Group_Films_Aggregate;
  film_name?: Maybe<Scalars['String']>;
  genre?: Maybe<Scalars['String']>;
  id: Scalars['numeric'];
  inspiration_meta: Scalars['jsonb'];
  is_no_music?: Maybe<Scalars['String']>;
  /** An array relationship */
  location_releases: Array<Location_Releases>;
  /** An aggregate relationship */
  location_releases_aggregate: Location_Releases_Aggregate;
  /** An array relationship */
  matchup_requests: Array<Matchup_Requests>;
  /** An aggregate relationship */
  matchup_requests_aggregate: Matchup_Requests_Aggregate;
  /** An array relationship */
  memberships: Array<Team_Memberships>;
  /** An aggregate relationship */
  memberships_aggregate: Team_Memberships_Aggregate;
  /** An array relationship */
  music_releases: Array<Music_Releases>;
  /** An aggregate relationship */
  music_releases_aggregate: Music_Releases_Aggregate;
  name?: Maybe<Scalars['String']>;
  /** An object relationship */
  owner?: Maybe<Users>;
  owner_id: Scalars['numeric'];
  /** An array relationship */
  payments: Array<Payments>;
  /** An aggregate relationship */
  payments_aggregate: Payments_Aggregate;
  /** An array relationship */
  prize_elections: Array<Prize_Elections>;
  /** An aggregate relationship */
  prize_elections_aggregate: Prize_Elections_Aggregate;
  /** An array relationship */
  selection_feedbacks: Array<Selection_Feedback>;
  /** An aggregate relationship */
  selection_feedbacks_aggregate: Selection_Feedback_Aggregate;
  /** An array relationship */
  selection_metrics: Array<Selection_Metrics>;
  /** An aggregate relationship */
  selection_metrics_aggregate: Selection_Metrics_Aggregate;
  /** An object relationship */
  studio?: Maybe<Studios>;
  studio_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  submission?: Maybe<Submission_Summary>;
  submitted_at?: Maybe<Scalars['timestamp']>;
  team_number?: Maybe<Scalars['numeric']>;
  updated: Scalars['timestamp'];
  updated_by: Scalars['String'];
};


/** columns and relationships of "teams" */
export type TeamsAsset_ExportsArgs = {
  distinct_on?: InputMaybe<Array<Asset_Exports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Asset_Exports_Order_By>>;
  where?: InputMaybe<Asset_Exports_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsAsset_Exports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_Exports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Asset_Exports_Order_By>>;
  where?: InputMaybe<Asset_Exports_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsAssetsArgs = {
  distinct_on?: InputMaybe<Array<Team_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Assets_Order_By>>;
  where?: InputMaybe<Team_Assets_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsAssets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Team_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Assets_Order_By>>;
  where?: InputMaybe<Team_Assets_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsAward_NominationsArgs = {
  distinct_on?: InputMaybe<Array<Award_Nominations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Award_Nominations_Order_By>>;
  where?: InputMaybe<Award_Nominations_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsAward_Nominations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Award_Nominations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Award_Nominations_Order_By>>;
  where?: InputMaybe<Award_Nominations_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsAward_WinsArgs = {
  distinct_on?: InputMaybe<Array<Award_Winners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Award_Winners_Order_By>>;
  where?: InputMaybe<Award_Winners_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsAward_Wins_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Award_Winners_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Award_Winners_Order_By>>;
  where?: InputMaybe<Award_Winners_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsFestival_BadgesArgs = {
  distinct_on?: InputMaybe<Array<Festival_Badges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Badges_Order_By>>;
  where?: InputMaybe<Festival_Badges_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsFestival_Badges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Badges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Badges_Order_By>>;
  where?: InputMaybe<Festival_Badges_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsFestival_Submission_VouchersArgs = {
  distinct_on?: InputMaybe<Array<Festival_Submission_Vouchers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Submission_Vouchers_Order_By>>;
  where?: InputMaybe<Festival_Submission_Vouchers_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsFestival_Submission_Vouchers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Festival_Submission_Vouchers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Festival_Submission_Vouchers_Order_By>>;
  where?: InputMaybe<Festival_Submission_Vouchers_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsFilm_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Film_Group_Films_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Film_Group_Films_Order_By>>;
  where?: InputMaybe<Film_Group_Films_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsFilm_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Film_Group_Films_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Film_Group_Films_Order_By>>;
  where?: InputMaybe<Film_Group_Films_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsInspiration_MetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "teams" */
export type TeamsLocation_ReleasesArgs = {
  distinct_on?: InputMaybe<Array<Location_Releases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Releases_Order_By>>;
  where?: InputMaybe<Location_Releases_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsLocation_Releases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Location_Releases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Location_Releases_Order_By>>;
  where?: InputMaybe<Location_Releases_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsMatchup_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Matchup_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Matchup_Requests_Order_By>>;
  where?: InputMaybe<Matchup_Requests_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsMatchup_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Matchup_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Matchup_Requests_Order_By>>;
  where?: InputMaybe<Matchup_Requests_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsMembershipsArgs = {
  distinct_on?: InputMaybe<Array<Team_Memberships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Memberships_Order_By>>;
  where?: InputMaybe<Team_Memberships_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsMemberships_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Team_Memberships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Memberships_Order_By>>;
  where?: InputMaybe<Team_Memberships_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsMusic_ReleasesArgs = {
  distinct_on?: InputMaybe<Array<Music_Releases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Music_Releases_Order_By>>;
  where?: InputMaybe<Music_Releases_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsMusic_Releases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Music_Releases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Music_Releases_Order_By>>;
  where?: InputMaybe<Music_Releases_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payments_Order_By>>;
  where?: InputMaybe<Payments_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsPrize_ElectionsArgs = {
  distinct_on?: InputMaybe<Array<Prize_Elections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prize_Elections_Order_By>>;
  where?: InputMaybe<Prize_Elections_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsPrize_Elections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prize_Elections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Prize_Elections_Order_By>>;
  where?: InputMaybe<Prize_Elections_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsSelection_FeedbacksArgs = {
  distinct_on?: InputMaybe<Array<Selection_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Selection_Feedback_Order_By>>;
  where?: InputMaybe<Selection_Feedback_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsSelection_Feedbacks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Selection_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Selection_Feedback_Order_By>>;
  where?: InputMaybe<Selection_Feedback_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsSelection_MetricsArgs = {
  distinct_on?: InputMaybe<Array<Selection_Metrics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Selection_Metrics_Order_By>>;
  where?: InputMaybe<Selection_Metrics_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsSelection_Metrics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Selection_Metrics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Selection_Metrics_Order_By>>;
  where?: InputMaybe<Selection_Metrics_Bool_Exp>;
};

/** aggregated selection of "teams" */
export type Teams_Aggregate = {
  __typename?: 'teams_aggregate';
  aggregate?: Maybe<Teams_Aggregate_Fields>;
  nodes: Array<Teams>;
};

export type Teams_Aggregate_Bool_Exp = {
  count?: InputMaybe<Teams_Aggregate_Bool_Exp_Count>;
};

export type Teams_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Teams_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Teams_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "teams" */
export type Teams_Aggregate_Fields = {
  __typename?: 'teams_aggregate_fields';
  avg?: Maybe<Teams_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Teams_Max_Fields>;
  min?: Maybe<Teams_Min_Fields>;
  stddev?: Maybe<Teams_Stddev_Fields>;
  stddev_pop?: Maybe<Teams_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Teams_Stddev_Samp_Fields>;
  sum?: Maybe<Teams_Sum_Fields>;
  var_pop?: Maybe<Teams_Var_Pop_Fields>;
  var_samp?: Maybe<Teams_Var_Samp_Fields>;
  variance?: Maybe<Teams_Variance_Fields>;
};


/** aggregate fields of "teams" */
export type Teams_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Teams_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "teams" */
export type Teams_Aggregate_Order_By = {
  avg?: InputMaybe<Teams_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Teams_Max_Order_By>;
  min?: InputMaybe<Teams_Min_Order_By>;
  stddev?: InputMaybe<Teams_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Teams_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Teams_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Teams_Sum_Order_By>;
  var_pop?: InputMaybe<Teams_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Teams_Var_Samp_Order_By>;
  variance?: InputMaybe<Teams_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Teams_Append_Input = {
  inspiration_meta?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "teams" */
export type Teams_Arr_Rel_Insert_Input = {
  data: Array<Teams_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Teams_On_Conflict>;
};

/** aggregate avg on columns */
export type Teams_Avg_Fields = {
  __typename?: 'teams_avg_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
  studio_id?: Maybe<Scalars['Float']>;
  team_number?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "teams" */
export type Teams_Avg_Order_By = {
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  studio_id?: InputMaybe<Order_By>;
  team_number?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "teams". All fields are combined with a logical 'AND'. */
export type Teams_Bool_Exp = {
  _and?: InputMaybe<Array<Teams_Bool_Exp>>;
  _not?: InputMaybe<Teams_Bool_Exp>;
  _or?: InputMaybe<Array<Teams_Bool_Exp>>;
  asset_exports?: InputMaybe<Asset_Exports_Bool_Exp>;
  asset_exports_aggregate?: InputMaybe<Asset_Exports_Aggregate_Bool_Exp>;
  assets?: InputMaybe<Team_Assets_Bool_Exp>;
  assets_aggregate?: InputMaybe<Team_Assets_Aggregate_Bool_Exp>;
  award_nominations?: InputMaybe<Award_Nominations_Bool_Exp>;
  award_nominations_aggregate?: InputMaybe<Award_Nominations_Aggregate_Bool_Exp>;
  award_wins?: InputMaybe<Award_Winners_Bool_Exp>;
  award_wins_aggregate?: InputMaybe<Award_Winners_Aggregate_Bool_Exp>;
  created?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  duration?: InputMaybe<String_Comparison_Exp>;
  exit_interview?: InputMaybe<Exit_Interviews_Bool_Exp>;
  festival_badges?: InputMaybe<Festival_Badges_Bool_Exp>;
  festival_badges_aggregate?: InputMaybe<Festival_Badges_Aggregate_Bool_Exp>;
  festival_submission_vouchers?: InputMaybe<Festival_Submission_Vouchers_Bool_Exp>;
  festival_submission_vouchers_aggregate?: InputMaybe<Festival_Submission_Vouchers_Aggregate_Bool_Exp>;
  film?: InputMaybe<Films_Bool_Exp>;
  film_festival?: InputMaybe<Film_Festivals_Bool_Exp>;
  film_festival_id?: InputMaybe<Numeric_Comparison_Exp>;
  film_group?: InputMaybe<Film_Group_Films_Bool_Exp>;
  film_groups?: InputMaybe<Film_Group_Films_Bool_Exp>;
  film_groups_aggregate?: InputMaybe<Film_Group_Films_Aggregate_Bool_Exp>;
  film_name?: InputMaybe<String_Comparison_Exp>;
  genre?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Numeric_Comparison_Exp>;
  inspiration_meta?: InputMaybe<Jsonb_Comparison_Exp>;
  is_no_music?: InputMaybe<String_Comparison_Exp>;
  location_releases?: InputMaybe<Location_Releases_Bool_Exp>;
  location_releases_aggregate?: InputMaybe<Location_Releases_Aggregate_Bool_Exp>;
  matchup_requests?: InputMaybe<Matchup_Requests_Bool_Exp>;
  matchup_requests_aggregate?: InputMaybe<Matchup_Requests_Aggregate_Bool_Exp>;
  memberships?: InputMaybe<Team_Memberships_Bool_Exp>;
  memberships_aggregate?: InputMaybe<Team_Memberships_Aggregate_Bool_Exp>;
  music_releases?: InputMaybe<Music_Releases_Bool_Exp>;
  music_releases_aggregate?: InputMaybe<Music_Releases_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<Users_Bool_Exp>;
  owner_id?: InputMaybe<Numeric_Comparison_Exp>;
  payments?: InputMaybe<Payments_Bool_Exp>;
  payments_aggregate?: InputMaybe<Payments_Aggregate_Bool_Exp>;
  prize_elections?: InputMaybe<Prize_Elections_Bool_Exp>;
  prize_elections_aggregate?: InputMaybe<Prize_Elections_Aggregate_Bool_Exp>;
  selection_feedbacks?: InputMaybe<Selection_Feedback_Bool_Exp>;
  selection_feedbacks_aggregate?: InputMaybe<Selection_Feedback_Aggregate_Bool_Exp>;
  selection_metrics?: InputMaybe<Selection_Metrics_Bool_Exp>;
  selection_metrics_aggregate?: InputMaybe<Selection_Metrics_Aggregate_Bool_Exp>;
  studio?: InputMaybe<Studios_Bool_Exp>;
  studio_id?: InputMaybe<Int_Comparison_Exp>;
  submission?: InputMaybe<Submission_Summary_Bool_Exp>;
  submitted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  team_number?: InputMaybe<Numeric_Comparison_Exp>;
  updated?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "teams" */
export enum Teams_Constraint {
  /** unique or primary key constraint on columns "id" */
  TeamsPkey = 'teams_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Teams_Delete_At_Path_Input = {
  inspiration_meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Teams_Delete_Elem_Input = {
  inspiration_meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Teams_Delete_Key_Input = {
  inspiration_meta?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "teams" */
export type Teams_Inc_Input = {
  film_festival_id?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['numeric']>;
  owner_id?: InputMaybe<Scalars['numeric']>;
  studio_id?: InputMaybe<Scalars['Int']>;
  team_number?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "teams" */
export type Teams_Insert_Input = {
  asset_exports?: InputMaybe<Asset_Exports_Arr_Rel_Insert_Input>;
  assets?: InputMaybe<Team_Assets_Arr_Rel_Insert_Input>;
  award_nominations?: InputMaybe<Award_Nominations_Arr_Rel_Insert_Input>;
  award_wins?: InputMaybe<Award_Winners_Arr_Rel_Insert_Input>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['String']>;
  exit_interview?: InputMaybe<Exit_Interviews_Obj_Rel_Insert_Input>;
  festival_badges?: InputMaybe<Festival_Badges_Arr_Rel_Insert_Input>;
  festival_submission_vouchers?: InputMaybe<Festival_Submission_Vouchers_Arr_Rel_Insert_Input>;
  film?: InputMaybe<Films_Obj_Rel_Insert_Input>;
  film_festival?: InputMaybe<Film_Festivals_Obj_Rel_Insert_Input>;
  film_festival_id?: InputMaybe<Scalars['numeric']>;
  film_group?: InputMaybe<Film_Group_Films_Obj_Rel_Insert_Input>;
  film_groups?: InputMaybe<Film_Group_Films_Arr_Rel_Insert_Input>;
  film_name?: InputMaybe<Scalars['String']>;
  genre?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  inspiration_meta?: InputMaybe<Scalars['jsonb']>;
  is_no_music?: InputMaybe<Scalars['String']>;
  location_releases?: InputMaybe<Location_Releases_Arr_Rel_Insert_Input>;
  matchup_requests?: InputMaybe<Matchup_Requests_Arr_Rel_Insert_Input>;
  memberships?: InputMaybe<Team_Memberships_Arr_Rel_Insert_Input>;
  music_releases?: InputMaybe<Music_Releases_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  owner_id?: InputMaybe<Scalars['numeric']>;
  payments?: InputMaybe<Payments_Arr_Rel_Insert_Input>;
  prize_elections?: InputMaybe<Prize_Elections_Arr_Rel_Insert_Input>;
  selection_feedbacks?: InputMaybe<Selection_Feedback_Arr_Rel_Insert_Input>;
  selection_metrics?: InputMaybe<Selection_Metrics_Arr_Rel_Insert_Input>;
  studio?: InputMaybe<Studios_Obj_Rel_Insert_Input>;
  studio_id?: InputMaybe<Scalars['Int']>;
  submission?: InputMaybe<Submission_Summary_Obj_Rel_Insert_Input>;
  submitted_at?: InputMaybe<Scalars['timestamp']>;
  team_number?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Teams_Max_Fields = {
  __typename?: 'teams_max_fields';
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
  film_festival_id?: Maybe<Scalars['numeric']>;
  film_name?: Maybe<Scalars['String']>;
  genre?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  is_no_music?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner_id?: Maybe<Scalars['numeric']>;
  studio_id?: Maybe<Scalars['Int']>;
  submitted_at?: Maybe<Scalars['timestamp']>;
  team_number?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "teams" */
export type Teams_Max_Order_By = {
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  film_name?: InputMaybe<Order_By>;
  genre?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_no_music?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  studio_id?: InputMaybe<Order_By>;
  submitted_at?: InputMaybe<Order_By>;
  team_number?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Teams_Min_Fields = {
  __typename?: 'teams_min_fields';
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
  film_festival_id?: Maybe<Scalars['numeric']>;
  film_name?: Maybe<Scalars['String']>;
  genre?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  is_no_music?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner_id?: Maybe<Scalars['numeric']>;
  studio_id?: Maybe<Scalars['Int']>;
  submitted_at?: Maybe<Scalars['timestamp']>;
  team_number?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "teams" */
export type Teams_Min_Order_By = {
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  film_name?: InputMaybe<Order_By>;
  genre?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_no_music?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  studio_id?: InputMaybe<Order_By>;
  submitted_at?: InputMaybe<Order_By>;
  team_number?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "teams" */
export type Teams_Mutation_Response = {
  __typename?: 'teams_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Teams>;
};

/** input type for inserting object relation for remote table "teams" */
export type Teams_Obj_Rel_Insert_Input = {
  data: Teams_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Teams_On_Conflict>;
};

/** on_conflict condition type for table "teams" */
export type Teams_On_Conflict = {
  constraint: Teams_Constraint;
  update_columns?: Array<Teams_Update_Column>;
  where?: InputMaybe<Teams_Bool_Exp>;
};

/** Ordering options when selecting data from "teams". */
export type Teams_Order_By = {
  asset_exports_aggregate?: InputMaybe<Asset_Exports_Aggregate_Order_By>;
  assets_aggregate?: InputMaybe<Team_Assets_Aggregate_Order_By>;
  award_nominations_aggregate?: InputMaybe<Award_Nominations_Aggregate_Order_By>;
  award_wins_aggregate?: InputMaybe<Award_Winners_Aggregate_Order_By>;
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  exit_interview?: InputMaybe<Exit_Interviews_Order_By>;
  festival_badges_aggregate?: InputMaybe<Festival_Badges_Aggregate_Order_By>;
  festival_submission_vouchers_aggregate?: InputMaybe<Festival_Submission_Vouchers_Aggregate_Order_By>;
  film?: InputMaybe<Films_Order_By>;
  film_festival?: InputMaybe<Film_Festivals_Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  film_group?: InputMaybe<Film_Group_Films_Order_By>;
  film_groups_aggregate?: InputMaybe<Film_Group_Films_Aggregate_Order_By>;
  film_name?: InputMaybe<Order_By>;
  genre?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inspiration_meta?: InputMaybe<Order_By>;
  is_no_music?: InputMaybe<Order_By>;
  location_releases_aggregate?: InputMaybe<Location_Releases_Aggregate_Order_By>;
  matchup_requests_aggregate?: InputMaybe<Matchup_Requests_Aggregate_Order_By>;
  memberships_aggregate?: InputMaybe<Team_Memberships_Aggregate_Order_By>;
  music_releases_aggregate?: InputMaybe<Music_Releases_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Users_Order_By>;
  owner_id?: InputMaybe<Order_By>;
  payments_aggregate?: InputMaybe<Payments_Aggregate_Order_By>;
  prize_elections_aggregate?: InputMaybe<Prize_Elections_Aggregate_Order_By>;
  selection_feedbacks_aggregate?: InputMaybe<Selection_Feedback_Aggregate_Order_By>;
  selection_metrics_aggregate?: InputMaybe<Selection_Metrics_Aggregate_Order_By>;
  studio?: InputMaybe<Studios_Order_By>;
  studio_id?: InputMaybe<Order_By>;
  submission?: InputMaybe<Submission_Summary_Order_By>;
  submitted_at?: InputMaybe<Order_By>;
  team_number?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: teams */
export type Teams_Pk_Columns_Input = {
  id: Scalars['numeric'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Teams_Prepend_Input = {
  inspiration_meta?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "teams" */
export enum Teams_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Duration = 'duration',
  /** column name */
  FilmFestivalId = 'film_festival_id',
  /** column name */
  FilmName = 'film_name',
  /** column name */
  Genre = 'genre',
  /** column name */
  Id = 'id',
  /** column name */
  InspirationMeta = 'inspiration_meta',
  /** column name */
  IsNoMusic = 'is_no_music',
  /** column name */
  Name = 'name',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  StudioId = 'studio_id',
  /** column name */
  SubmittedAt = 'submitted_at',
  /** column name */
  TeamNumber = 'team_number',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** input type for updating data in table "teams" */
export type Teams_Set_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['String']>;
  film_festival_id?: InputMaybe<Scalars['numeric']>;
  film_name?: InputMaybe<Scalars['String']>;
  genre?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  inspiration_meta?: InputMaybe<Scalars['jsonb']>;
  is_no_music?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['numeric']>;
  studio_id?: InputMaybe<Scalars['Int']>;
  submitted_at?: InputMaybe<Scalars['timestamp']>;
  team_number?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Teams_Stddev_Fields = {
  __typename?: 'teams_stddev_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
  studio_id?: Maybe<Scalars['Float']>;
  team_number?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "teams" */
export type Teams_Stddev_Order_By = {
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  studio_id?: InputMaybe<Order_By>;
  team_number?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Teams_Stddev_Pop_Fields = {
  __typename?: 'teams_stddev_pop_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
  studio_id?: Maybe<Scalars['Float']>;
  team_number?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "teams" */
export type Teams_Stddev_Pop_Order_By = {
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  studio_id?: InputMaybe<Order_By>;
  team_number?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Teams_Stddev_Samp_Fields = {
  __typename?: 'teams_stddev_samp_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
  studio_id?: Maybe<Scalars['Float']>;
  team_number?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "teams" */
export type Teams_Stddev_Samp_Order_By = {
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  studio_id?: InputMaybe<Order_By>;
  team_number?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "teams" */
export type Teams_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Teams_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Teams_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['String']>;
  film_festival_id?: InputMaybe<Scalars['numeric']>;
  film_name?: InputMaybe<Scalars['String']>;
  genre?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  inspiration_meta?: InputMaybe<Scalars['jsonb']>;
  is_no_music?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['numeric']>;
  studio_id?: InputMaybe<Scalars['Int']>;
  submitted_at?: InputMaybe<Scalars['timestamp']>;
  team_number?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Teams_Sum_Fields = {
  __typename?: 'teams_sum_fields';
  film_festival_id?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['numeric']>;
  owner_id?: Maybe<Scalars['numeric']>;
  studio_id?: Maybe<Scalars['Int']>;
  team_number?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "teams" */
export type Teams_Sum_Order_By = {
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  studio_id?: InputMaybe<Order_By>;
  team_number?: InputMaybe<Order_By>;
};

/** update columns of table "teams" */
export enum Teams_Update_Column {
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Duration = 'duration',
  /** column name */
  FilmFestivalId = 'film_festival_id',
  /** column name */
  FilmName = 'film_name',
  /** column name */
  Genre = 'genre',
  /** column name */
  Id = 'id',
  /** column name */
  InspirationMeta = 'inspiration_meta',
  /** column name */
  IsNoMusic = 'is_no_music',
  /** column name */
  Name = 'name',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  StudioId = 'studio_id',
  /** column name */
  SubmittedAt = 'submitted_at',
  /** column name */
  TeamNumber = 'team_number',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by'
}

export type Teams_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Teams_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Teams_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Teams_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Teams_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Teams_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Teams_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Teams_Set_Input>;
  /** filter the rows which have to be updated */
  where: Teams_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Teams_Var_Pop_Fields = {
  __typename?: 'teams_var_pop_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
  studio_id?: Maybe<Scalars['Float']>;
  team_number?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "teams" */
export type Teams_Var_Pop_Order_By = {
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  studio_id?: InputMaybe<Order_By>;
  team_number?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Teams_Var_Samp_Fields = {
  __typename?: 'teams_var_samp_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
  studio_id?: Maybe<Scalars['Float']>;
  team_number?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "teams" */
export type Teams_Var_Samp_Order_By = {
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  studio_id?: InputMaybe<Order_By>;
  team_number?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Teams_Variance_Fields = {
  __typename?: 'teams_variance_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
  studio_id?: Maybe<Scalars['Float']>;
  team_number?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "teams" */
export type Teams_Variance_Order_By = {
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  studio_id?: InputMaybe<Order_By>;
  team_number?: InputMaybe<Order_By>;
};

/** columns and relationships of "teams_with_awards_ceremony_checkins" */
export type Teams_With_Awards_Ceremony_Checkins = {
  __typename?: 'teams_with_awards_ceremony_checkins';
  awards_ceremony_checkins?: Maybe<Scalars['bigint']>;
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
  film_festival_id?: Maybe<Scalars['numeric']>;
  film_name?: Maybe<Scalars['String']>;
  genre?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  is_no_music?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner_id?: Maybe<Scalars['numeric']>;
  studio_id?: Maybe<Scalars['Int']>;
  submitted_at?: Maybe<Scalars['timestamp']>;
  team_number?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** aggregated selection of "teams_with_awards_ceremony_checkins" */
export type Teams_With_Awards_Ceremony_Checkins_Aggregate = {
  __typename?: 'teams_with_awards_ceremony_checkins_aggregate';
  aggregate?: Maybe<Teams_With_Awards_Ceremony_Checkins_Aggregate_Fields>;
  nodes: Array<Teams_With_Awards_Ceremony_Checkins>;
};

/** aggregate fields of "teams_with_awards_ceremony_checkins" */
export type Teams_With_Awards_Ceremony_Checkins_Aggregate_Fields = {
  __typename?: 'teams_with_awards_ceremony_checkins_aggregate_fields';
  avg?: Maybe<Teams_With_Awards_Ceremony_Checkins_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Teams_With_Awards_Ceremony_Checkins_Max_Fields>;
  min?: Maybe<Teams_With_Awards_Ceremony_Checkins_Min_Fields>;
  stddev?: Maybe<Teams_With_Awards_Ceremony_Checkins_Stddev_Fields>;
  stddev_pop?: Maybe<Teams_With_Awards_Ceremony_Checkins_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Teams_With_Awards_Ceremony_Checkins_Stddev_Samp_Fields>;
  sum?: Maybe<Teams_With_Awards_Ceremony_Checkins_Sum_Fields>;
  var_pop?: Maybe<Teams_With_Awards_Ceremony_Checkins_Var_Pop_Fields>;
  var_samp?: Maybe<Teams_With_Awards_Ceremony_Checkins_Var_Samp_Fields>;
  variance?: Maybe<Teams_With_Awards_Ceremony_Checkins_Variance_Fields>;
};


/** aggregate fields of "teams_with_awards_ceremony_checkins" */
export type Teams_With_Awards_Ceremony_Checkins_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Teams_With_Awards_Ceremony_Checkins_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Teams_With_Awards_Ceremony_Checkins_Avg_Fields = {
  __typename?: 'teams_with_awards_ceremony_checkins_avg_fields';
  awards_ceremony_checkins?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
  studio_id?: Maybe<Scalars['Float']>;
  team_number?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "teams_with_awards_ceremony_checkins". All fields are combined with a logical 'AND'. */
export type Teams_With_Awards_Ceremony_Checkins_Bool_Exp = {
  _and?: InputMaybe<Array<Teams_With_Awards_Ceremony_Checkins_Bool_Exp>>;
  _not?: InputMaybe<Teams_With_Awards_Ceremony_Checkins_Bool_Exp>;
  _or?: InputMaybe<Array<Teams_With_Awards_Ceremony_Checkins_Bool_Exp>>;
  awards_ceremony_checkins?: InputMaybe<Bigint_Comparison_Exp>;
  created?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  duration?: InputMaybe<String_Comparison_Exp>;
  film_festival_id?: InputMaybe<Numeric_Comparison_Exp>;
  film_name?: InputMaybe<String_Comparison_Exp>;
  genre?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Numeric_Comparison_Exp>;
  is_no_music?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner_id?: InputMaybe<Numeric_Comparison_Exp>;
  studio_id?: InputMaybe<Int_Comparison_Exp>;
  submitted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  team_number?: InputMaybe<Numeric_Comparison_Exp>;
  updated?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "teams_with_awards_ceremony_checkins" */
export type Teams_With_Awards_Ceremony_Checkins_Inc_Input = {
  awards_ceremony_checkins?: InputMaybe<Scalars['bigint']>;
  film_festival_id?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['numeric']>;
  owner_id?: InputMaybe<Scalars['numeric']>;
  studio_id?: InputMaybe<Scalars['Int']>;
  team_number?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "teams_with_awards_ceremony_checkins" */
export type Teams_With_Awards_Ceremony_Checkins_Insert_Input = {
  awards_ceremony_checkins?: InputMaybe<Scalars['bigint']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['String']>;
  film_festival_id?: InputMaybe<Scalars['numeric']>;
  film_name?: InputMaybe<Scalars['String']>;
  genre?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  is_no_music?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['numeric']>;
  studio_id?: InputMaybe<Scalars['Int']>;
  submitted_at?: InputMaybe<Scalars['timestamp']>;
  team_number?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Teams_With_Awards_Ceremony_Checkins_Max_Fields = {
  __typename?: 'teams_with_awards_ceremony_checkins_max_fields';
  awards_ceremony_checkins?: Maybe<Scalars['bigint']>;
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
  film_festival_id?: Maybe<Scalars['numeric']>;
  film_name?: Maybe<Scalars['String']>;
  genre?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  is_no_music?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner_id?: Maybe<Scalars['numeric']>;
  studio_id?: Maybe<Scalars['Int']>;
  submitted_at?: Maybe<Scalars['timestamp']>;
  team_number?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Teams_With_Awards_Ceremony_Checkins_Min_Fields = {
  __typename?: 'teams_with_awards_ceremony_checkins_min_fields';
  awards_ceremony_checkins?: Maybe<Scalars['bigint']>;
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
  film_festival_id?: Maybe<Scalars['numeric']>;
  film_name?: Maybe<Scalars['String']>;
  genre?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  is_no_music?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner_id?: Maybe<Scalars['numeric']>;
  studio_id?: Maybe<Scalars['Int']>;
  submitted_at?: Maybe<Scalars['timestamp']>;
  team_number?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "teams_with_awards_ceremony_checkins" */
export type Teams_With_Awards_Ceremony_Checkins_Mutation_Response = {
  __typename?: 'teams_with_awards_ceremony_checkins_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Teams_With_Awards_Ceremony_Checkins>;
};

/** Ordering options when selecting data from "teams_with_awards_ceremony_checkins". */
export type Teams_With_Awards_Ceremony_Checkins_Order_By = {
  awards_ceremony_checkins?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  film_name?: InputMaybe<Order_By>;
  genre?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_no_music?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  studio_id?: InputMaybe<Order_By>;
  submitted_at?: InputMaybe<Order_By>;
  team_number?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** select columns of table "teams_with_awards_ceremony_checkins" */
export enum Teams_With_Awards_Ceremony_Checkins_Select_Column {
  /** column name */
  AwardsCeremonyCheckins = 'awards_ceremony_checkins',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Duration = 'duration',
  /** column name */
  FilmFestivalId = 'film_festival_id',
  /** column name */
  FilmName = 'film_name',
  /** column name */
  Genre = 'genre',
  /** column name */
  Id = 'id',
  /** column name */
  IsNoMusic = 'is_no_music',
  /** column name */
  Name = 'name',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  StudioId = 'studio_id',
  /** column name */
  SubmittedAt = 'submitted_at',
  /** column name */
  TeamNumber = 'team_number',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** input type for updating data in table "teams_with_awards_ceremony_checkins" */
export type Teams_With_Awards_Ceremony_Checkins_Set_Input = {
  awards_ceremony_checkins?: InputMaybe<Scalars['bigint']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['String']>;
  film_festival_id?: InputMaybe<Scalars['numeric']>;
  film_name?: InputMaybe<Scalars['String']>;
  genre?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  is_no_music?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['numeric']>;
  studio_id?: InputMaybe<Scalars['Int']>;
  submitted_at?: InputMaybe<Scalars['timestamp']>;
  team_number?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Teams_With_Awards_Ceremony_Checkins_Stddev_Fields = {
  __typename?: 'teams_with_awards_ceremony_checkins_stddev_fields';
  awards_ceremony_checkins?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
  studio_id?: Maybe<Scalars['Float']>;
  team_number?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Teams_With_Awards_Ceremony_Checkins_Stddev_Pop_Fields = {
  __typename?: 'teams_with_awards_ceremony_checkins_stddev_pop_fields';
  awards_ceremony_checkins?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
  studio_id?: Maybe<Scalars['Float']>;
  team_number?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Teams_With_Awards_Ceremony_Checkins_Stddev_Samp_Fields = {
  __typename?: 'teams_with_awards_ceremony_checkins_stddev_samp_fields';
  awards_ceremony_checkins?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
  studio_id?: Maybe<Scalars['Float']>;
  team_number?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "teams_with_awards_ceremony_checkins" */
export type Teams_With_Awards_Ceremony_Checkins_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Teams_With_Awards_Ceremony_Checkins_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Teams_With_Awards_Ceremony_Checkins_Stream_Cursor_Value_Input = {
  awards_ceremony_checkins?: InputMaybe<Scalars['bigint']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['String']>;
  film_festival_id?: InputMaybe<Scalars['numeric']>;
  film_name?: InputMaybe<Scalars['String']>;
  genre?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  is_no_music?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['numeric']>;
  studio_id?: InputMaybe<Scalars['Int']>;
  submitted_at?: InputMaybe<Scalars['timestamp']>;
  team_number?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Teams_With_Awards_Ceremony_Checkins_Sum_Fields = {
  __typename?: 'teams_with_awards_ceremony_checkins_sum_fields';
  awards_ceremony_checkins?: Maybe<Scalars['bigint']>;
  film_festival_id?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['numeric']>;
  owner_id?: Maybe<Scalars['numeric']>;
  studio_id?: Maybe<Scalars['Int']>;
  team_number?: Maybe<Scalars['numeric']>;
};

export type Teams_With_Awards_Ceremony_Checkins_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Teams_With_Awards_Ceremony_Checkins_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Teams_With_Awards_Ceremony_Checkins_Set_Input>;
  /** filter the rows which have to be updated */
  where: Teams_With_Awards_Ceremony_Checkins_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Teams_With_Awards_Ceremony_Checkins_Var_Pop_Fields = {
  __typename?: 'teams_with_awards_ceremony_checkins_var_pop_fields';
  awards_ceremony_checkins?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
  studio_id?: Maybe<Scalars['Float']>;
  team_number?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Teams_With_Awards_Ceremony_Checkins_Var_Samp_Fields = {
  __typename?: 'teams_with_awards_ceremony_checkins_var_samp_fields';
  awards_ceremony_checkins?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
  studio_id?: Maybe<Scalars['Float']>;
  team_number?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Teams_With_Awards_Ceremony_Checkins_Variance_Fields = {
  __typename?: 'teams_with_awards_ceremony_checkins_variance_fields';
  awards_ceremony_checkins?: Maybe<Scalars['Float']>;
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
  studio_id?: Maybe<Scalars['Float']>;
  team_number?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "teams_with_checkins" */
export type Teams_With_Checkins = {
  __typename?: 'teams_with_checkins';
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
  film_festival_id?: Maybe<Scalars['numeric']>;
  film_name?: Maybe<Scalars['String']>;
  genre?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  is_no_music?: Maybe<Scalars['String']>;
  kickoff_checkins?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  owner_id?: Maybe<Scalars['numeric']>;
  studio_id?: Maybe<Scalars['Int']>;
  submitted_at?: Maybe<Scalars['timestamp']>;
  team_number?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** aggregated selection of "teams_with_checkins" */
export type Teams_With_Checkins_Aggregate = {
  __typename?: 'teams_with_checkins_aggregate';
  aggregate?: Maybe<Teams_With_Checkins_Aggregate_Fields>;
  nodes: Array<Teams_With_Checkins>;
};

/** aggregate fields of "teams_with_checkins" */
export type Teams_With_Checkins_Aggregate_Fields = {
  __typename?: 'teams_with_checkins_aggregate_fields';
  avg?: Maybe<Teams_With_Checkins_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Teams_With_Checkins_Max_Fields>;
  min?: Maybe<Teams_With_Checkins_Min_Fields>;
  stddev?: Maybe<Teams_With_Checkins_Stddev_Fields>;
  stddev_pop?: Maybe<Teams_With_Checkins_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Teams_With_Checkins_Stddev_Samp_Fields>;
  sum?: Maybe<Teams_With_Checkins_Sum_Fields>;
  var_pop?: Maybe<Teams_With_Checkins_Var_Pop_Fields>;
  var_samp?: Maybe<Teams_With_Checkins_Var_Samp_Fields>;
  variance?: Maybe<Teams_With_Checkins_Variance_Fields>;
};


/** aggregate fields of "teams_with_checkins" */
export type Teams_With_Checkins_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Teams_With_Checkins_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Teams_With_Checkins_Avg_Fields = {
  __typename?: 'teams_with_checkins_avg_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  kickoff_checkins?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
  studio_id?: Maybe<Scalars['Float']>;
  team_number?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "teams_with_checkins". All fields are combined with a logical 'AND'. */
export type Teams_With_Checkins_Bool_Exp = {
  _and?: InputMaybe<Array<Teams_With_Checkins_Bool_Exp>>;
  _not?: InputMaybe<Teams_With_Checkins_Bool_Exp>;
  _or?: InputMaybe<Array<Teams_With_Checkins_Bool_Exp>>;
  created?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  duration?: InputMaybe<String_Comparison_Exp>;
  film_festival_id?: InputMaybe<Numeric_Comparison_Exp>;
  film_name?: InputMaybe<String_Comparison_Exp>;
  genre?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Numeric_Comparison_Exp>;
  is_no_music?: InputMaybe<String_Comparison_Exp>;
  kickoff_checkins?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner_id?: InputMaybe<Numeric_Comparison_Exp>;
  studio_id?: InputMaybe<Int_Comparison_Exp>;
  submitted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  team_number?: InputMaybe<Numeric_Comparison_Exp>;
  updated?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "teams_with_checkins" */
export type Teams_With_Checkins_Inc_Input = {
  film_festival_id?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['numeric']>;
  kickoff_checkins?: InputMaybe<Scalars['bigint']>;
  owner_id?: InputMaybe<Scalars['numeric']>;
  studio_id?: InputMaybe<Scalars['Int']>;
  team_number?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "teams_with_checkins" */
export type Teams_With_Checkins_Insert_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['String']>;
  film_festival_id?: InputMaybe<Scalars['numeric']>;
  film_name?: InputMaybe<Scalars['String']>;
  genre?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  is_no_music?: InputMaybe<Scalars['String']>;
  kickoff_checkins?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['numeric']>;
  studio_id?: InputMaybe<Scalars['Int']>;
  submitted_at?: InputMaybe<Scalars['timestamp']>;
  team_number?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Teams_With_Checkins_Max_Fields = {
  __typename?: 'teams_with_checkins_max_fields';
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
  film_festival_id?: Maybe<Scalars['numeric']>;
  film_name?: Maybe<Scalars['String']>;
  genre?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  is_no_music?: Maybe<Scalars['String']>;
  kickoff_checkins?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  owner_id?: Maybe<Scalars['numeric']>;
  studio_id?: Maybe<Scalars['Int']>;
  submitted_at?: Maybe<Scalars['timestamp']>;
  team_number?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Teams_With_Checkins_Min_Fields = {
  __typename?: 'teams_with_checkins_min_fields';
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
  film_festival_id?: Maybe<Scalars['numeric']>;
  film_name?: Maybe<Scalars['String']>;
  genre?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  is_no_music?: Maybe<Scalars['String']>;
  kickoff_checkins?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  owner_id?: Maybe<Scalars['numeric']>;
  studio_id?: Maybe<Scalars['Int']>;
  submitted_at?: Maybe<Scalars['timestamp']>;
  team_number?: Maybe<Scalars['numeric']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "teams_with_checkins" */
export type Teams_With_Checkins_Mutation_Response = {
  __typename?: 'teams_with_checkins_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Teams_With_Checkins>;
};

/** Ordering options when selecting data from "teams_with_checkins". */
export type Teams_With_Checkins_Order_By = {
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  film_name?: InputMaybe<Order_By>;
  genre?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_no_music?: InputMaybe<Order_By>;
  kickoff_checkins?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  studio_id?: InputMaybe<Order_By>;
  submitted_at?: InputMaybe<Order_By>;
  team_number?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** select columns of table "teams_with_checkins" */
export enum Teams_With_Checkins_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Duration = 'duration',
  /** column name */
  FilmFestivalId = 'film_festival_id',
  /** column name */
  FilmName = 'film_name',
  /** column name */
  Genre = 'genre',
  /** column name */
  Id = 'id',
  /** column name */
  IsNoMusic = 'is_no_music',
  /** column name */
  KickoffCheckins = 'kickoff_checkins',
  /** column name */
  Name = 'name',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  StudioId = 'studio_id',
  /** column name */
  SubmittedAt = 'submitted_at',
  /** column name */
  TeamNumber = 'team_number',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** input type for updating data in table "teams_with_checkins" */
export type Teams_With_Checkins_Set_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['String']>;
  film_festival_id?: InputMaybe<Scalars['numeric']>;
  film_name?: InputMaybe<Scalars['String']>;
  genre?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  is_no_music?: InputMaybe<Scalars['String']>;
  kickoff_checkins?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['numeric']>;
  studio_id?: InputMaybe<Scalars['Int']>;
  submitted_at?: InputMaybe<Scalars['timestamp']>;
  team_number?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Teams_With_Checkins_Stddev_Fields = {
  __typename?: 'teams_with_checkins_stddev_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  kickoff_checkins?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
  studio_id?: Maybe<Scalars['Float']>;
  team_number?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Teams_With_Checkins_Stddev_Pop_Fields = {
  __typename?: 'teams_with_checkins_stddev_pop_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  kickoff_checkins?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
  studio_id?: Maybe<Scalars['Float']>;
  team_number?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Teams_With_Checkins_Stddev_Samp_Fields = {
  __typename?: 'teams_with_checkins_stddev_samp_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  kickoff_checkins?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
  studio_id?: Maybe<Scalars['Float']>;
  team_number?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "teams_with_checkins" */
export type Teams_With_Checkins_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Teams_With_Checkins_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Teams_With_Checkins_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['String']>;
  film_festival_id?: InputMaybe<Scalars['numeric']>;
  film_name?: InputMaybe<Scalars['String']>;
  genre?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  is_no_music?: InputMaybe<Scalars['String']>;
  kickoff_checkins?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['numeric']>;
  studio_id?: InputMaybe<Scalars['Int']>;
  submitted_at?: InputMaybe<Scalars['timestamp']>;
  team_number?: InputMaybe<Scalars['numeric']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Teams_With_Checkins_Sum_Fields = {
  __typename?: 'teams_with_checkins_sum_fields';
  film_festival_id?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['numeric']>;
  kickoff_checkins?: Maybe<Scalars['bigint']>;
  owner_id?: Maybe<Scalars['numeric']>;
  studio_id?: Maybe<Scalars['Int']>;
  team_number?: Maybe<Scalars['numeric']>;
};

export type Teams_With_Checkins_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Teams_With_Checkins_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Teams_With_Checkins_Set_Input>;
  /** filter the rows which have to be updated */
  where: Teams_With_Checkins_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Teams_With_Checkins_Var_Pop_Fields = {
  __typename?: 'teams_with_checkins_var_pop_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  kickoff_checkins?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
  studio_id?: Maybe<Scalars['Float']>;
  team_number?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Teams_With_Checkins_Var_Samp_Fields = {
  __typename?: 'teams_with_checkins_var_samp_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  kickoff_checkins?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
  studio_id?: Maybe<Scalars['Float']>;
  team_number?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Teams_With_Checkins_Variance_Fields = {
  __typename?: 'teams_with_checkins_variance_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  kickoff_checkins?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
  studio_id?: Maybe<Scalars['Float']>;
  team_number?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "ticket_tailor_vouchers" */
export type Ticket_Tailor_Vouchers = {
  __typename?: 'ticket_tailor_vouchers';
  code: Scalars['String'];
  created_at: Scalars['timestamptz'];
  film_festival_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  issued_at?: Maybe<Scalars['timestamptz']>;
  updated_at: Scalars['timestamptz'];
  user_id?: Maybe<Scalars['Int']>;
  value: Scalars['Int'];
};

/** aggregated selection of "ticket_tailor_vouchers" */
export type Ticket_Tailor_Vouchers_Aggregate = {
  __typename?: 'ticket_tailor_vouchers_aggregate';
  aggregate?: Maybe<Ticket_Tailor_Vouchers_Aggregate_Fields>;
  nodes: Array<Ticket_Tailor_Vouchers>;
};

/** aggregate fields of "ticket_tailor_vouchers" */
export type Ticket_Tailor_Vouchers_Aggregate_Fields = {
  __typename?: 'ticket_tailor_vouchers_aggregate_fields';
  avg?: Maybe<Ticket_Tailor_Vouchers_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Ticket_Tailor_Vouchers_Max_Fields>;
  min?: Maybe<Ticket_Tailor_Vouchers_Min_Fields>;
  stddev?: Maybe<Ticket_Tailor_Vouchers_Stddev_Fields>;
  stddev_pop?: Maybe<Ticket_Tailor_Vouchers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ticket_Tailor_Vouchers_Stddev_Samp_Fields>;
  sum?: Maybe<Ticket_Tailor_Vouchers_Sum_Fields>;
  var_pop?: Maybe<Ticket_Tailor_Vouchers_Var_Pop_Fields>;
  var_samp?: Maybe<Ticket_Tailor_Vouchers_Var_Samp_Fields>;
  variance?: Maybe<Ticket_Tailor_Vouchers_Variance_Fields>;
};


/** aggregate fields of "ticket_tailor_vouchers" */
export type Ticket_Tailor_Vouchers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ticket_Tailor_Vouchers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Ticket_Tailor_Vouchers_Avg_Fields = {
  __typename?: 'ticket_tailor_vouchers_avg_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ticket_tailor_vouchers". All fields are combined with a logical 'AND'. */
export type Ticket_Tailor_Vouchers_Bool_Exp = {
  _and?: InputMaybe<Array<Ticket_Tailor_Vouchers_Bool_Exp>>;
  _not?: InputMaybe<Ticket_Tailor_Vouchers_Bool_Exp>;
  _or?: InputMaybe<Array<Ticket_Tailor_Vouchers_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  film_festival_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  issued_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  value?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "ticket_tailor_vouchers" */
export enum Ticket_Tailor_Vouchers_Constraint {
  /** unique or primary key constraint on columns "code" */
  TicketTailorVouchersCodeKey = 'ticket_tailor_vouchers_code_key',
  /** unique or primary key constraint on columns "id" */
  TicketTailorVouchersPkey = 'ticket_tailor_vouchers_pkey'
}

/** input type for incrementing numeric columns in table "ticket_tailor_vouchers" */
export type Ticket_Tailor_Vouchers_Inc_Input = {
  film_festival_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "ticket_tailor_vouchers" */
export type Ticket_Tailor_Vouchers_Insert_Input = {
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  film_festival_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  issued_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Ticket_Tailor_Vouchers_Max_Fields = {
  __typename?: 'ticket_tailor_vouchers_max_fields';
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  film_festival_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  issued_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Ticket_Tailor_Vouchers_Min_Fields = {
  __typename?: 'ticket_tailor_vouchers_min_fields';
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  film_festival_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  issued_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "ticket_tailor_vouchers" */
export type Ticket_Tailor_Vouchers_Mutation_Response = {
  __typename?: 'ticket_tailor_vouchers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ticket_Tailor_Vouchers>;
};

/** on_conflict condition type for table "ticket_tailor_vouchers" */
export type Ticket_Tailor_Vouchers_On_Conflict = {
  constraint: Ticket_Tailor_Vouchers_Constraint;
  update_columns?: Array<Ticket_Tailor_Vouchers_Update_Column>;
  where?: InputMaybe<Ticket_Tailor_Vouchers_Bool_Exp>;
};

/** Ordering options when selecting data from "ticket_tailor_vouchers". */
export type Ticket_Tailor_Vouchers_Order_By = {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  film_festival_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issued_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ticket_tailor_vouchers */
export type Ticket_Tailor_Vouchers_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "ticket_tailor_vouchers" */
export enum Ticket_Tailor_Vouchers_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FilmFestivalId = 'film_festival_id',
  /** column name */
  Id = 'id',
  /** column name */
  IssuedAt = 'issued_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "ticket_tailor_vouchers" */
export type Ticket_Tailor_Vouchers_Set_Input = {
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  film_festival_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  issued_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Ticket_Tailor_Vouchers_Stddev_Fields = {
  __typename?: 'ticket_tailor_vouchers_stddev_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Ticket_Tailor_Vouchers_Stddev_Pop_Fields = {
  __typename?: 'ticket_tailor_vouchers_stddev_pop_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Ticket_Tailor_Vouchers_Stddev_Samp_Fields = {
  __typename?: 'ticket_tailor_vouchers_stddev_samp_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ticket_tailor_vouchers" */
export type Ticket_Tailor_Vouchers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ticket_Tailor_Vouchers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ticket_Tailor_Vouchers_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  film_festival_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  issued_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Ticket_Tailor_Vouchers_Sum_Fields = {
  __typename?: 'ticket_tailor_vouchers_sum_fields';
  film_festival_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Int']>;
};

/** update columns of table "ticket_tailor_vouchers" */
export enum Ticket_Tailor_Vouchers_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FilmFestivalId = 'film_festival_id',
  /** column name */
  Id = 'id',
  /** column name */
  IssuedAt = 'issued_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Value = 'value'
}

export type Ticket_Tailor_Vouchers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ticket_Tailor_Vouchers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ticket_Tailor_Vouchers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ticket_Tailor_Vouchers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ticket_Tailor_Vouchers_Var_Pop_Fields = {
  __typename?: 'ticket_tailor_vouchers_var_pop_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Ticket_Tailor_Vouchers_Var_Samp_Fields = {
  __typename?: 'ticket_tailor_vouchers_var_samp_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Ticket_Tailor_Vouchers_Variance_Fields = {
  __typename?: 'ticket_tailor_vouchers_variance_fields';
  film_festival_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']>;
  _gt?: InputMaybe<Scalars['timestamp']>;
  _gte?: InputMaybe<Scalars['timestamp']>;
  _in?: InputMaybe<Array<Scalars['timestamp']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamp']>;
  _lte?: InputMaybe<Scalars['timestamp']>;
  _neq?: InputMaybe<Scalars['timestamp']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  auth0_id?: Maybe<Scalars['String']>;
  created: Scalars['timestamp'];
  created_by: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['numeric'];
  meta: Scalars['jsonb'];
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  online_screening_tickets: Array<Online_Screening_Tickets>;
  /** An aggregate relationship */
  online_screening_tickets_aggregate: Online_Screening_Tickets_Aggregate;
  picture?: Maybe<Scalars['String']>;
  /** An array relationship */
  selection_metrics: Array<Selection_Metrics>;
  /** An aggregate relationship */
  selection_metrics_aggregate: Selection_Metrics_Aggregate;
  stripe_customer_id?: Maybe<Scalars['String']>;
  sub?: Maybe<Scalars['String']>;
  /** An array relationship */
  team_memberships: Array<Team_Memberships>;
  /** An aggregate relationship */
  team_memberships_aggregate: Team_Memberships_Aggregate;
  updated: Scalars['timestamp'];
  updated_by: Scalars['String'];
};


/** columns and relationships of "users" */
export type UsersMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersOnline_Screening_TicketsArgs = {
  distinct_on?: InputMaybe<Array<Online_Screening_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Online_Screening_Tickets_Order_By>>;
  where?: InputMaybe<Online_Screening_Tickets_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersOnline_Screening_Tickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Online_Screening_Tickets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Online_Screening_Tickets_Order_By>>;
  where?: InputMaybe<Online_Screening_Tickets_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSelection_MetricsArgs = {
  distinct_on?: InputMaybe<Array<Selection_Metrics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Selection_Metrics_Order_By>>;
  where?: InputMaybe<Selection_Metrics_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSelection_Metrics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Selection_Metrics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Selection_Metrics_Order_By>>;
  where?: InputMaybe<Selection_Metrics_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTeam_MembershipsArgs = {
  distinct_on?: InputMaybe<Array<Team_Memberships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Memberships_Order_By>>;
  where?: InputMaybe<Team_Memberships_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTeam_Memberships_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Team_Memberships_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Memberships_Order_By>>;
  where?: InputMaybe<Team_Memberships_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  avg?: Maybe<Users_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
  stddev?: Maybe<Users_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Sum_Fields>;
  var_pop?: Maybe<Users_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Var_Samp_Fields>;
  variance?: Maybe<Users_Variance_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Users_Append_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Users_Avg_Fields = {
  __typename?: 'users_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  auth0_id?: InputMaybe<String_Comparison_Exp>;
  created?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Numeric_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  online_screening_tickets?: InputMaybe<Online_Screening_Tickets_Bool_Exp>;
  online_screening_tickets_aggregate?: InputMaybe<Online_Screening_Tickets_Aggregate_Bool_Exp>;
  picture?: InputMaybe<String_Comparison_Exp>;
  selection_metrics?: InputMaybe<Selection_Metrics_Bool_Exp>;
  selection_metrics_aggregate?: InputMaybe<Selection_Metrics_Aggregate_Bool_Exp>;
  stripe_customer_id?: InputMaybe<String_Comparison_Exp>;
  sub?: InputMaybe<String_Comparison_Exp>;
  team_memberships?: InputMaybe<Team_Memberships_Bool_Exp>;
  team_memberships_aggregate?: InputMaybe<Team_Memberships_Aggregate_Bool_Exp>;
  updated?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "email" */
  UsersEmailKey = 'users_email_key',
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey',
  /** unique or primary key constraint on columns "sub" */
  UsersSubKey = 'users_sub_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Users_Delete_At_Path_Input = {
  meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Users_Delete_Elem_Input = {
  meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Users_Delete_Key_Input = {
  meta?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "users" */
export type Users_Inc_Input = {
  id?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  auth0_id?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  online_screening_tickets?: InputMaybe<Online_Screening_Tickets_Arr_Rel_Insert_Input>;
  picture?: InputMaybe<Scalars['String']>;
  selection_metrics?: InputMaybe<Selection_Metrics_Arr_Rel_Insert_Input>;
  stripe_customer_id?: InputMaybe<Scalars['String']>;
  sub?: InputMaybe<Scalars['String']>;
  team_memberships?: InputMaybe<Team_Memberships_Arr_Rel_Insert_Input>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  auth0_id?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
  stripe_customer_id?: Maybe<Scalars['String']>;
  sub?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  auth0_id?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
  stripe_customer_id?: Maybe<Scalars['String']>;
  sub?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  auth0_id?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  online_screening_tickets_aggregate?: InputMaybe<Online_Screening_Tickets_Aggregate_Order_By>;
  picture?: InputMaybe<Order_By>;
  selection_metrics_aggregate?: InputMaybe<Selection_Metrics_Aggregate_Order_By>;
  stripe_customer_id?: InputMaybe<Order_By>;
  sub?: InputMaybe<Order_By>;
  team_memberships_aggregate?: InputMaybe<Team_Memberships_Aggregate_Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  id: Scalars['numeric'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Users_Prepend_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  Auth0Id = 'auth0_id',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  Picture = 'picture',
  /** column name */
  StripeCustomerId = 'stripe_customer_id',
  /** column name */
  Sub = 'sub',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  auth0_id?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  picture?: InputMaybe<Scalars['String']>;
  stripe_customer_id?: InputMaybe<Scalars['String']>;
  sub?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Users_Stddev_Fields = {
  __typename?: 'users_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Users_Stddev_Pop_Fields = {
  __typename?: 'users_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Users_Stddev_Samp_Fields = {
  __typename?: 'users_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  auth0_id?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  picture?: InputMaybe<Scalars['String']>;
  stripe_customer_id?: InputMaybe<Scalars['String']>;
  sub?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Users_Sum_Fields = {
  __typename?: 'users_sum_fields';
  id?: Maybe<Scalars['numeric']>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  Auth0Id = 'auth0_id',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  Picture = 'picture',
  /** column name */
  StripeCustomerId = 'stripe_customer_id',
  /** column name */
  Sub = 'sub',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedBy = 'updated_by'
}

export type Users_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Users_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Users_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Users_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Users_Var_Pop_Fields = {
  __typename?: 'users_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Users_Var_Samp_Fields = {
  __typename?: 'users_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Users_Variance_Fields = {
  __typename?: 'users_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

export type RemoveSelectionAssignmentMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveSelectionAssignmentMutation = { __typename?: 'mutation_root', delete_film_group_users_by_pk?: { __typename?: 'film_group_users', id: number } | null };

export type FilmGroupFestivalSubmissionUpMutationVariables = Exact<{
  filmGroupId: Scalars['Int'];
  oldSort: Scalars['Int'];
  newSort: Scalars['Int'];
}>;


export type FilmGroupFestivalSubmissionUpMutation = { __typename?: 'mutation_root', reserve?: { __typename?: 'film_group_festival_submissions_mutation_response', affected_rows: number } | null, bulk?: { __typename?: 'film_group_festival_submissions_mutation_response', affected_rows: number } | null, swap?: { __typename?: 'film_group_festival_submissions_mutation_response', affected_rows: number } | null };

export type FilmGroupFestivalSubmissionDownMutationVariables = Exact<{
  filmGroupId: Scalars['Int'];
  oldSort: Scalars['Int'];
  newSort: Scalars['Int'];
}>;


export type FilmGroupFestivalSubmissionDownMutation = { __typename?: 'mutation_root', reserve?: { __typename?: 'film_group_festival_submissions_mutation_response', affected_rows: number } | null, bulk?: { __typename?: 'film_group_festival_submissions_mutation_response', affected_rows: number } | null, swap?: { __typename?: 'film_group_festival_submissions_mutation_response', affected_rows: number } | null };

export type FilmGroupFestivalSubmissionRemoveMutationVariables = Exact<{
  filmGroupId: Scalars['Int'];
  sort: Scalars['Int'];
}>;


export type FilmGroupFestivalSubmissionRemoveMutation = { __typename?: 'mutation_root', delete_film_group_festival_submissions?: { __typename?: 'film_group_festival_submissions_mutation_response', affected_rows: number } | null, update_film_group_festival_submissions?: { __typename?: 'film_group_festival_submissions_mutation_response', affected_rows: number } | null };

export type SpliceFilmGroupFestivalSubmissionMutationVariables = Exact<{
  filmGroupId: Scalars['Int'];
  sort: Scalars['Int'];
  festival_submission_id: Scalars['Int'];
}>;


export type SpliceFilmGroupFestivalSubmissionMutation = { __typename?: 'mutation_root', update_film_group_festival_submissions?: { __typename?: 'film_group_festival_submissions_mutation_response', affected_rows: number } | null, insert_film_group_festival_submissions_one?: { __typename?: 'film_group_festival_submissions', id: number } | null };

export type SelectionBallotQueryVariables = Exact<{
  filmGroupId: Scalars['Int'];
  uid: Scalars['Int'];
}>;


export type SelectionBallotQuery = { __typename?: 'query_root', film_groups_by_pk?: { __typename?: 'film_groups', id: number, teams: Array<{ __typename?: 'film_group_films', id: number, team: { __typename?: 'teams', id: any, award_nominations_aggregate: { __typename?: 'award_nominations_aggregate', aggregate?: { __typename?: 'award_nominations_aggregate_fields', count: number } | null } } }> } | null, selection_metrics: Array<{ __typename?: 'selection_metrics', id: number, team_id: any, value: number }> };

export type FilmGroupFilmUpMutationVariables = Exact<{
  filmGroupId: Scalars['Int'];
  oldSort: Scalars['Int'];
  newSort: Scalars['Int'];
}>;


export type FilmGroupFilmUpMutation = { __typename?: 'mutation_root', reserve?: { __typename?: 'film_group_films_mutation_response', affected_rows: number } | null, bulk?: { __typename?: 'film_group_films_mutation_response', affected_rows: number } | null, swap?: { __typename?: 'film_group_films_mutation_response', affected_rows: number } | null };

export type FilmGroupFilmDownMutationVariables = Exact<{
  filmGroupId: Scalars['Int'];
  oldSort: Scalars['Int'];
  newSort: Scalars['Int'];
}>;


export type FilmGroupFilmDownMutation = { __typename?: 'mutation_root', reserve?: { __typename?: 'film_group_films_mutation_response', affected_rows: number } | null, bulk?: { __typename?: 'film_group_films_mutation_response', affected_rows: number } | null, swap?: { __typename?: 'film_group_films_mutation_response', affected_rows: number } | null };

export type FilmGroupFilmRemoveMutationVariables = Exact<{
  filmGroupId: Scalars['Int'];
  sort: Scalars['Int'];
}>;


export type FilmGroupFilmRemoveMutation = { __typename?: 'mutation_root', delete_film_group_films?: { __typename?: 'film_group_films_mutation_response', affected_rows: number } | null, update_film_group_films?: { __typename?: 'film_group_films_mutation_response', affected_rows: number } | null };

export type SpliceFilmGroupFilmMutationVariables = Exact<{
  filmGroupId: Scalars['Int'];
  sort: Scalars['Int'];
  team_id: Scalars['numeric'];
}>;


export type SpliceFilmGroupFilmMutation = { __typename?: 'mutation_root', update_film_group_films?: { __typename?: 'film_group_films_mutation_response', affected_rows: number } | null, insert_film_group_films_one?: { __typename?: 'film_group_films', id: number } | null };

export type AdminCreateUserMutationVariables = Exact<{
  email: Scalars['String'];
  name: Scalars['String'];
  createdBy: Scalars['String'];
}>;


export type AdminCreateUserMutation = { __typename?: 'mutation_root', insert_users_one?: { __typename?: 'users', id: any, name?: string | null, email?: string | null } | null };

export type AdminEditUserMutationVariables = Exact<{
  id: Scalars['numeric'];
  name: Scalars['String'];
}>;


export type AdminEditUserMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: any, name?: string | null, email?: string | null } | null };

export type TerminalCheckoutMutationVariables = Exact<{
  amount: Scalars['Int'];
}>;


export type TerminalCheckoutMutation = { __typename?: 'mutation_root', stripeTerminalCharge: string };

export type TerminalCancelMutationVariables = Exact<{ [key: string]: never; }>;


export type TerminalCancelMutation = { __typename?: 'mutation_root', stripeTerminalCancel: boolean };

export type FiveFestAcademyFeedbackMutationVariables = Exact<{
  festivalSubmissionId: Scalars['Int'];
  comments?: InputMaybe<Scalars['String']>;
}>;


export type FiveFestAcademyFeedbackMutation = { __typename?: 'mutation_root', insert_festival_submission_feedback_one?: { __typename?: 'festival_submission_feedback', id: number, comments: string } | null };

export type FestivalSubmissionVouchersQueryVariables = Exact<{ [key: string]: never; }>;


export type FestivalSubmissionVouchersQuery = { __typename?: 'query_root', festival_submission_vouchers: Array<{ __typename?: 'festival_submission_vouchers', id: number, team: { __typename?: 'teams', id: any, team_number?: any | null, name?: string | null } }> };

export type ClaimFestivalSubmissionVoucherMutationVariables = Exact<{
  voucherId: Scalars['Int'];
  submissionId: Scalars['Int'];
}>;


export type ClaimFestivalSubmissionVoucherMutation = { __typename?: 'mutation_root', claimFestivalSubmissionVoucher: boolean };

export type SubmitFiveFestMutationVariables = Exact<{
  id: Scalars['Int'];
  signature_name: Scalars['String'];
  is_minor: Scalars['Boolean'];
  signature_email?: InputMaybe<Scalars['String']>;
  signature_phone?: InputMaybe<Scalars['String']>;
}>;


export type SubmitFiveFestMutation = { __typename?: 'mutation_root', submitFiveFest: boolean };

export type StudioInterviewDetailsQueryVariables = Exact<{
  id?: Scalars['numeric'];
  poster?: Scalars['numeric'];
}>;


export type StudioInterviewDetailsQuery = { __typename?: 'query_root', studios: Array<{ __typename?: 'studios', id: number, name: string, teams: Array<{ __typename?: 'teams', id: any, created: any, name?: string | null, team_number?: any | null, film_name?: string | null, genre?: string | null, description?: string | null, poster: Array<{ __typename?: 'team_assets', id: any, file_name: string }>, film?: { __typename?: 'films', id: any, mux_playback_id?: string | null, mux_thumbnail_time?: any | null } | null, award_nominations: Array<{ __typename?: 'award_nominations', id?: any | null, award?: { __typename?: 'awards', id: any, name?: string | null } | null, assets: Array<{ __typename?: 'nomination_assets', id: any, file_name: string }>, membership?: { __typename?: 'team_memberships', id: any, registration?: { __typename?: 'registrations', id: any, first_name?: string | null, last_name?: string | null } | null } | null }>, prize_elections: Array<{ __typename?: 'prize_elections', id?: any | null, prize?: { __typename?: 'prizes', id: any, name?: string | null } | null }>, submission?: { __typename?: 'submission_summary', id?: any | null, official_ts?: any | null, is_on_time?: boolean | null } | null, awards: Array<{ __typename?: 'award_winners', id: number, rank: number, award: { __typename?: 'awards', id: any, name?: string | null } }> }> }> };

export type CreateStudioMutationVariables = Exact<{
  studio: Studios_Insert_Input;
  ffid: Scalars['numeric'];
}>;


export type CreateStudioMutation = { __typename?: 'mutation_root', insert_studios_one?: { __typename?: 'studios', id: number, name: string, owner_id: number, teams: Array<{ __typename?: 'teams', id: any, name?: string | null, team_number?: any | null, submitted_at?: any | null }> } | null };

export type UpdateTeamDetailsMutationVariables = Exact<{
  id: Scalars['numeric'];
  set: Teams_Set_Input;
}>;


export type UpdateTeamDetailsMutation = { __typename?: 'mutation_root', update_teams_by_pk?: { __typename?: 'teams', id: any, name?: string | null, film_name?: string | null, genre?: string | null, description?: string | null } | null };

export type MyExitInterviewQueryVariables = Exact<{
  teamId: Scalars['Int'];
}>;


export type MyExitInterviewQuery = { __typename?: 'query_root', exit_interviews: Array<{ __typename?: 'exit_interviews', id: number, ready_at?: any | null }> };

export type MyExitInterviewSubSubscriptionVariables = Exact<{
  teamId: Scalars['Int'];
}>;


export type MyExitInterviewSubSubscription = { __typename?: 'subscription_root', exit_interviews: Array<{ __typename?: 'exit_interviews', id: number, ready_at?: any | null }> };

export type ReadyExitInterviewMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ReadyExitInterviewMutation = { __typename?: 'mutation_root', update_exit_interviews_by_pk?: { __typename?: 'exit_interviews', id: number, ready_at?: any | null } | null };

export type DeleteAwardNominationMutationVariables = Exact<{
  id: Scalars['numeric'];
}>;


export type DeleteAwardNominationMutation = { __typename?: 'mutation_root', delete_nominations_by_pk?: { __typename?: 'nominations', id: any } | null };

export type DeleteNominationAssetMutationVariables = Exact<{
  id: Scalars['numeric'];
}>;


export type DeleteNominationAssetMutation = { __typename?: 'mutation_root', delete_nomination_assets_by_pk?: { __typename?: 'nomination_assets', id: any } | null };

export type DeleteLocationReleaseMutationVariables = Exact<{
  id: Scalars['numeric'];
}>;


export type DeleteLocationReleaseMutation = { __typename?: 'mutation_root', delete_location_releases_by_pk?: { __typename?: 'location_releases', id: any } | null };

export type DeleteMembershipMutationVariables = Exact<{
  id: Scalars['numeric'];
}>;


export type DeleteMembershipMutation = { __typename?: 'mutation_root', update_team_memberships_by_pk?: { __typename?: 'team_memberships', id: any, deleted?: any | null } | null };

export type DeleteMusicReleaseMutationVariables = Exact<{
  id: Scalars['numeric'];
}>;


export type DeleteMusicReleaseMutation = { __typename?: 'mutation_root', delete_music_releases_by_pk?: { __typename?: 'music_releases', id: any } | null };

export type LoadRegistrationQueryVariables = Exact<{
  id: Scalars['numeric'];
}>;


export type LoadRegistrationQuery = { __typename?: 'query_root', team_membership?: { __typename?: 'team_memberships', id: any, role_id: any, is_invited?: string | null, registration?: { __typename?: 'registrations', address_1?: string | null, address_2?: string | null, bio?: string | null, city?: string | null, country?: string | null, first_name?: string | null, id: any, last_name?: string | null, middle_name?: string | null, primary_email?: string | null, primary_phone?: string | null, secondary_email?: string | null, secondary_phone?: string | null, state?: string | null, zip?: string | null } | null } | null };

export type ReqeustSignatureMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ReqeustSignatureMutation = { __typename?: 'mutation_root', sendGuestSignatureMail?: string | null };

export type InviteMemberMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type InviteMemberMutation = { __typename?: 'mutation_root', sendTeamInvitationMail?: string | null };

export type InviteGuestMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type InviteGuestMutation = { __typename?: 'mutation_root', sendGuestSignatureMail?: string | null };

export type CreateTeamMemberMutationVariables = Exact<{
  object: Registrations_Insert_Input;
}>;


export type CreateTeamMemberMutation = { __typename?: 'mutation_root', registration?: { __typename?: 'registrations', id: any, team_membership: { __typename?: 'team_memberships', id: any, team_id: any, is_invited?: string | null } } | null };

export type TeamAwardNominationsQueryVariables = Exact<{
  id: Scalars['numeric'];
}>;


export type TeamAwardNominationsQuery = { __typename?: 'query_root', awards: Array<{ __typename?: 'awards', id: any, name?: string | null, description?: string | null, max_nominations: number, nominations: Array<{ __typename?: 'award_nominations', id?: any | null, team_membership?: { __typename?: 'team_memberships', id: any, role: { __typename?: 'team_roles', id: any, name?: string | null }, registration?: { __typename?: 'registrations', id: any, first_name?: string | null, last_name?: string | null } | null } | null, assets: Array<{ __typename?: 'nomination_assets', id: any, file_name: string, asset_type_id: any }>, asset_types: Array<{ __typename?: 'award_asset_types', id: any, asset_type_id: any }> }>, required_asset_types: Array<{ __typename?: 'award_asset_types', id: any, mime?: string | null, asset_type: { __typename?: 'asset_types', id: any, title?: string | null } }> }> };

export type CreateAwardNominationMutationVariables = Exact<{
  nomination: Nominations_Insert_Input;
}>;


export type CreateAwardNominationMutation = { __typename?: 'mutation_root', insert_nominations_one?: { __typename?: 'nominations', id: any } | null };

export type DeleteTeamAssetMutationVariables = Exact<{
  id: Scalars['numeric'];
}>;


export type DeleteTeamAssetMutation = { __typename?: 'mutation_root', delete_team_assets_by_pk?: { __typename?: 'team_assets', id: any } | null };

export type DownloadTeamAssetMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type DownloadTeamAssetMutation = { __typename?: 'mutation_root', assetSign?: string | null };

export type UpdateFilmDetailsMutationVariables = Exact<{
  id: Scalars['numeric'];
  set: Teams_Set_Input;
}>;


export type UpdateFilmDetailsMutation = { __typename?: 'mutation_root', update_teams_by_pk?: { __typename?: 'teams', id: any, name?: string | null, film_name?: string | null, genre?: string | null, description?: string | null, inspiration_meta: any } | null };

export type CreateFestivalSubmissionMutationVariables = Exact<{
  object?: Festival_Submissions_Insert_Input;
}>;


export type CreateFestivalSubmissionMutation = { __typename?: 'mutation_root', insert_festival_submissions_one?: { __typename?: 'festival_submissions', id: number } | null };

export type AttachAssetToLocationReleaseMutationVariables = Exact<{
  id: Scalars['numeric'];
  assetId: Scalars['numeric'];
}>;


export type AttachAssetToLocationReleaseMutation = { __typename?: 'mutation_root', update_location_releases_by_pk?: { __typename?: 'location_releases', id: any, asset?: { __typename?: 'team_assets', id: any, file_name: string } | null } | null };

export type MyMatchupQueryVariables = Exact<{
  filmFestivalId: Scalars['numeric'];
  userId: Scalars['numeric'];
}>;


export type MyMatchupQuery = { __typename?: 'query_root', matchup_requests: Array<{ __typename?: 'matchup_requests', id: any, first_name: string, last_name: string, email?: string | null, phone?: string | null, type?: string | null, expertise_json: any, genres_json: any, notes?: string | null, withdrawn?: any | null, withdrawn_type?: string | null }> };

export type MatchupRequestsQueryVariables = Exact<{
  filmFestivalId: Scalars['numeric'];
  type: Scalars['String'];
}>;


export type MatchupRequestsQuery = { __typename?: 'query_root', requests: Array<{ __typename?: 'matchup_requests', id: any, first_name: string, last_name: string, email?: string | null, phone?: string | null, type?: string | null, expertise_json: any, genres_json: any, notes?: string | null }> };

export type SaveMyMatchupMutationVariables = Exact<{
  request: Matchup_Requests_Insert_Input;
}>;


export type SaveMyMatchupMutation = { __typename?: 'mutation_root', insert_matchup_requests_one?: { __typename?: 'matchup_requests', id: any, first_name: string, last_name: string, email?: string | null, phone?: string | null, type?: string | null, expertise_json: any, genres_json: any, notes?: string | null, withdrawn?: any | null, withdrawn_type?: string | null } | null };

export type AttachAssetToMusicReleaseMutationVariables = Exact<{
  id: Scalars['numeric'];
  assetId: Scalars['numeric'];
}>;


export type AttachAssetToMusicReleaseMutation = { __typename?: 'mutation_root', update_music_releases_by_pk?: { __typename?: 'music_releases', id: any, asset?: { __typename?: 'team_assets', id: any, file_name: string } | null } | null };

export type ToggleNoMusicMutationVariables = Exact<{
  teamId: Scalars['numeric'];
  isNoMusic: Scalars['String'];
}>;


export type ToggleNoMusicMutation = { __typename?: 'mutation_root', update_teams_by_pk?: { __typename?: 'teams', id: any, is_no_music?: string | null } | null };

export type TeamPaymentMutationVariables = Exact<{
  returnUrl: Scalars['String'];
  lineItems: Array<StripeLineItem> | StripeLineItem;
  teamId?: InputMaybe<Scalars['Int']>;
  badgeId?: InputMaybe<Scalars['Int']>;
}>;


export type TeamPaymentMutation = { __typename?: 'mutation_root', url: string };

export type TeamPrizeNominationsQueryVariables = Exact<{
  ffid: Scalars['numeric'];
}>;


export type TeamPrizeNominationsQuery = { __typename?: 'query_root', prizes: Array<{ __typename?: 'prizes', id: any, name?: string | null, description?: string | null, mux_playback_id?: string | null, sponsor?: { __typename?: 'sponsors', id: any, name?: string | null } | null }> };

export type PrizeOptInMutationVariables = Exact<{
  nomination: Nominations_Insert_Input;
}>;


export type PrizeOptInMutation = { __typename?: 'mutation_root', insert_nominations_one?: { __typename?: 'nominations', id: any } | null };

export type DeletePrizeNominationMutationVariables = Exact<{
  nomination: Nominations_Bool_Exp;
}>;


export type DeletePrizeNominationMutation = { __typename?: 'mutation_root', delete_nominations?: { __typename?: 'nominations_mutation_response', affected_rows: number } | null };

export type SubmitTeamMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type SubmitTeamMutation = { __typename?: 'mutation_root', submitTeam: boolean };

export type SetThumbTimeMutationVariables = Exact<{
  id: Scalars['numeric'];
  time: Scalars['numeric'];
}>;


export type SetThumbTimeMutation = { __typename?: 'mutation_root', update_films_by_pk?: { __typename?: 'films', id: any, mux_thumbnail_time?: any | null } | null };

export type SignAssetMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type SignAssetMutation = { __typename?: 'mutation_root', assetSign?: string | null };

export type CreateAssetUploadMutationVariables = Exact<{
  filename: Scalars['String'];
}>;


export type CreateAssetUploadMutation = { __typename?: 'mutation_root', assetUpload?: { __typename?: 'AssetUpload', name: string, uploadUrl: string } | null };

export type UploadTeamAssetMutationVariables = Exact<{
  asset: Team_Assets_Insert_Input;
}>;


export type UploadTeamAssetMutation = { __typename?: 'mutation_root', insert_team_assets_one?: { __typename?: 'team_assets', id: any } | null };

export type CreateAwardNominationAssetMutationVariables = Exact<{
  asset: Nomination_Assets_Insert_Input;
}>;


export type CreateAwardNominationAssetMutation = { __typename?: 'mutation_root', insert_nomination_assets_one?: { __typename?: 'nomination_assets', id: any } | null };

export type UploadFilmMutationVariables = Exact<{
  fileName: Scalars['String'];
  fileSize: Scalars['Int'];
  teamId: Scalars['Int'];
}>;


export type UploadFilmMutation = { __typename?: 'mutation_root', muxCreateUpload: string };

export type UploadFiveFestFilmMutationVariables = Exact<{
  fileName: Scalars['String'];
  fileSize: Scalars['Int'];
  submissionId: Scalars['Int'];
}>;


export type UploadFiveFestFilmMutation = { __typename?: 'mutation_root', muxCreateFiveFestUpload: string };

export type UploadFestivalSubmissionAssetMutationVariables = Exact<{
  asset: Festival_Submission_Assets_Insert_Input;
}>;


export type UploadFestivalSubmissionAssetMutation = { __typename?: 'mutation_root', insert_festival_submission_assets_one?: { __typename?: 'festival_submission_assets', id: number } | null };

export type JoinLiveKitExitInterviewMutationVariables = Exact<{
  teamId: Scalars['Int'];
  displayName: Scalars['String'];
}>;


export type JoinLiveKitExitInterviewMutation = { __typename?: 'mutation_root', joinLiveKitExitInterview: string };

export type CreateLocationReleaseMutationVariables = Exact<{
  release: Location_Releases_Insert_Input;
}>;


export type CreateLocationReleaseMutation = { __typename?: 'mutation_root', insert_location_releases_one?: { __typename?: 'location_releases', id: any } | null };

export type UpdateLocationReleaseMutationVariables = Exact<{
  id: Scalars['numeric'];
  release: Location_Releases_Set_Input;
}>;


export type UpdateLocationReleaseMutation = { __typename?: 'mutation_root', update_location_releases_by_pk?: { __typename?: 'location_releases', id: any, venue_name?: string | null, first_name?: string | null, middle_name?: string | null, last_name?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, is_owned_by_team?: string | null, asset?: { __typename?: 'team_assets', id: any, file_name: string } | null } | null };

export type MatchupExpertiseQueryVariables = Exact<{ [key: string]: never; }>;


export type MatchupExpertiseQuery = { __typename?: 'query_root', expertise: Array<{ __typename?: 'expertise', id: any, name: string }>, genres: Array<{ __typename?: 'genres', id: any, name: string, description?: string | null }> };

export type CreateMusicReleaseMutationVariables = Exact<{
  release: Music_Releases_Insert_Input;
}>;


export type CreateMusicReleaseMutation = { __typename?: 'mutation_root', insert_music_releases_one?: { __typename?: 'music_releases', id: any } | null };

export type UpdateMusicReleaseMutationVariables = Exact<{
  id: Scalars['numeric'];
  release: Music_Releases_Set_Input;
}>;


export type UpdateMusicReleaseMutation = { __typename?: 'mutation_root', update_music_releases_by_pk?: { __typename?: 'music_releases', id: any, composer?: string | null, duration?: string | null, is_original?: string | null, is_royalty_free?: string | null, publisher?: string | null, royalty_free_source?: string | null, society?: string | null, song_title?: string | null, start_time?: string | null, use_type?: string | null, asset?: { __typename?: 'team_assets', id: any, file_name: string } | null } | null };

export type LastRegistrationQueryVariables = Exact<{
  user_id: Scalars['numeric'];
}>;


export type LastRegistrationQuery = { __typename?: 'query_root', pastRegistrations: Array<{ __typename?: 'registrations', first_name?: string | null, middle_name?: string | null, last_name?: string | null, primary_phone?: string | null, secondary_phone?: string | null, primary_email?: string | null, secondary_email?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null }> };

export type SaveRegistrationMutationVariables = Exact<{
  id: Scalars['numeric'];
  _set: Registrations_Set_Input;
}>;


export type SaveRegistrationMutation = { __typename?: 'mutation_root', update_registrations_by_pk?: { __typename?: 'registrations', id: any } | null };

export type SignRegistrationMutationVariables = Exact<{
  id: Scalars['Int'];
  hash?: InputMaybe<Scalars['String']>;
  signature_name: Scalars['String'];
  signature_phone?: InputMaybe<Scalars['String']>;
  signature_email?: InputMaybe<Scalars['String']>;
  is_minor?: InputMaybe<Scalars['Boolean']>;
}>;


export type SignRegistrationMutation = { __typename?: 'mutation_root', provideRegistrationSignature: boolean };

export type AwardsCeremonyCheckinQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AwardsCeremonyCheckinQueryQuery = { __typename?: 'query_root', teams: Array<{ __typename?: 'teams', id: any, team_number?: any | null, name?: string | null, film_name?: string | null, studio?: { __typename?: 'studios', id: number, name: string } | null, poster: Array<{ __typename?: 'team_assets', id: any, file_name: string }> }>, festival_submissions: Array<{ __typename?: 'festival_submissions', id: number, film_title: string, production_company: string, first_name: string, last_name: string, poster: Array<{ __typename?: 'festival_submission_assets', id: number, file_name: string }> }> };

export type RecordAwardsCeremonyCheckinMutationVariables = Exact<{
  announce: Scalars['String'];
  teamId?: InputMaybe<Scalars['Int']>;
  festivalSubmissionId?: InputMaybe<Scalars['Int']>;
}>;


export type RecordAwardsCeremonyCheckinMutation = { __typename?: 'mutation_root', recordAwardsCeremonyCheckin: boolean };

export type ExitInterviewsQueryVariables = Exact<{ [key: string]: never; }>;


export type ExitInterviewsQuery = { __typename?: 'query_root', exit_interviews: Array<{ __typename?: 'exit_interviews', id: number, live_kit_room_status?: string | null, mux_live_stream_playback_id?: string | null, mux_live_stream_status?: string | null, created_at: any, ready_at?: any | null, team: { __typename?: 'teams', id: any, team_number?: any | null, name?: string | null, film_name?: string | null, studio?: { __typename?: 'studios', id: number, name: string } | null }, interviewer?: { __typename?: 'users', id: any, name?: string | null, picture?: string | null } | null }> };

export type ExitInterviewsSubSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ExitInterviewsSubSubscription = { __typename?: 'subscription_root', exit_interviews: Array<{ __typename?: 'exit_interviews', id: number, live_kit_room_status?: string | null, mux_live_stream_playback_id?: string | null, mux_live_stream_status?: string | null, created_at: any, ready_at?: any | null, team: { __typename?: 'teams', id: any, team_number?: any | null, name?: string | null, film_name?: string | null, studio?: { __typename?: 'studios', id: number, name: string } | null }, interviewer?: { __typename?: 'users', id: any, name?: string | null, picture?: string | null } | null }> };

export type ClaimExitInterviewMutationVariables = Exact<{
  id: Scalars['Int'];
  userId?: InputMaybe<Scalars['Int']>;
}>;


export type ClaimExitInterviewMutation = { __typename?: 'mutation_root', update_exit_interviews_by_pk?: { __typename?: 'exit_interviews', id: number, claimed_by?: number | null, interviewer?: { __typename?: 'users', id: any, sub?: string | null, name?: string | null, picture?: string | null } | null } | null };

export type FilmGroupFilmsQueryVariables = Exact<{
  ffid: Scalars['numeric'];
  poster: Scalars['numeric'];
  ffidInt: Scalars['Int'];
  posterInt: Scalars['Int'];
}>;


export type FilmGroupFilmsQuery = { __typename?: 'query_root', teams: Array<{ __typename?: 'teams', id: any, team_number?: any | null, name?: string | null, film_name?: string | null, poster: Array<{ __typename?: 'team_assets', id: any, file_name: string }> }>, festival_submissions: Array<{ __typename?: 'festival_submissions', id: number, film_title: string, genre: { __typename?: 'festival_genres', id: number, name: string }, poster: Array<{ __typename?: 'festival_submission_assets', id: number, file_name: string }> }>, film_groups: Array<{ __typename?: 'film_groups', id: number, name: string, type: string, teams: Array<{ __typename?: 'film_group_films', id: number, sort: number, team: { __typename?: 'teams', id: any, team_number?: any | null, name?: string | null, film_name?: string | null, poster: Array<{ __typename?: 'team_assets', id: any, file_name: string }> } }>, festival_submissions: Array<{ __typename?: 'film_group_festival_submissions', id: number, sort: number, festival_submission: { __typename?: 'festival_submissions', id: number, film_title: string, genre: { __typename?: 'festival_genres', id: number, name: string }, poster: Array<{ __typename?: 'festival_submission_assets', id: number, file_name: string }> } }> }> };

export type FilmGroupAssignmentsQueryVariables = Exact<{
  ffid: Scalars['numeric'];
}>;


export type FilmGroupAssignmentsQuery = { __typename?: 'query_root', film_groups: Array<{ __typename?: 'film_groups', id: number, name: string, type: string, users: Array<{ __typename?: 'film_group_users', id: number, film_group_id: number, rankings: any, updated_at: any, submitted_at?: any | null, user: { __typename?: 'users', id: any, name?: string | null, email?: string | null, sub?: string | null, picture?: string | null } }> }> };

export type UsersByRoleQueryVariables = Exact<{
  role: Scalars['String'];
}>;


export type UsersByRoleQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, name?: string | null, email?: string | null, picture?: string | null, meta: any }> };

export type AssignFilmGroupMutationVariables = Exact<{
  objects: Array<Film_Group_Users_Insert_Input> | Film_Group_Users_Insert_Input;
}>;


export type AssignFilmGroupMutation = { __typename?: 'mutation_root', insert_film_group_users?: { __typename?: 'film_group_users_mutation_response', affected_rows: number } | null };

export type FiveFestAcademyReviewQueryVariables = Exact<{ [key: string]: never; }>;


export type FiveFestAcademyReviewQuery = { __typename?: 'query_root', film_groups: Array<{ __typename?: 'film_groups', id: number, name: string, festival_submissions: Array<{ __typename?: 'film_group_festival_submissions', id: number, sort: number, festival_submission: { __typename?: 'festival_submissions', id: number, film_title: string, genre: { __typename?: 'festival_genres', id: number, name: string }, poster: Array<{ __typename?: 'festival_submission_assets', id: number, file_name: string }> } }>, users: Array<{ __typename?: 'film_group_users', id: number, film_group_id: number, rankings: any, user: { __typename?: 'users', id: any, sub?: string | null, name?: string | null, email?: string | null, picture?: string | null } }>, festival_genre?: { __typename?: 'festival_genres', id: number, name: string } | null }> };

export type JudgeReviewQueryVariables = Exact<{
  ffid: Scalars['numeric'];
}>;


export type JudgeReviewQuery = { __typename?: 'query_root', film_groups: Array<{ __typename?: 'film_groups', id: number, name: string, teams: Array<{ __typename?: 'film_group_films', id: number, sort: number, team: { __typename?: 'teams', id: any, team_number?: any | null, name?: string | null, film_name?: string | null, poster: Array<{ __typename?: 'team_assets', id: any, file_name: string }> } }>, users: Array<{ __typename?: 'film_group_users', id: number, film_group_id: number, rankings: any, user: { __typename?: 'users', id: any, sub?: string | null, name?: string | null, email?: string | null, picture?: string | null } }>, award?: { __typename?: 'awards', id: any, name?: string | null, description?: string | null } | null }> };

export type SelectionReviewQueryVariables = Exact<{
  ffid: Scalars['numeric'];
}>;


export type SelectionReviewQuery = { __typename?: 'query_root', film_groups: Array<{ __typename?: 'film_groups', id: number, name: string, teams: Array<{ __typename?: 'film_group_films', id: number, sort: number, team: { __typename?: 'teams', id: any, team_number?: any | null, name?: string | null, film_name?: string | null, poster: Array<{ __typename?: 'team_assets', id: any, file_name: string }>, selection_metrics: Array<{ __typename?: 'selection_metrics', id: number, team_id: any, award_id: any, real_user_id: number, value: number }>, award_nominations_aggregate: { __typename?: 'award_nominations_aggregate', aggregate?: { __typename?: 'award_nominations_aggregate_fields', count: number } | null } } }>, users: Array<{ __typename?: 'film_group_users', id: number, user: { __typename?: 'users', id: any, sub?: string | null, name?: string | null, email?: string | null, picture?: string | null } }> }>, awards: Array<{ __typename?: 'awards', id: any, name?: string | null, description?: string | null, max_nominations: number }> };

export type SuperSharablesQueryVariables = Exact<{ [key: string]: never; }>;


export type SuperSharablesQuery = { __typename?: 'query_root', sharables: Array<{ __typename?: 'sharables', id: number, title: string, description?: string | null, mux_playback_id: string, mux_thumb_time?: any | null }> };

export type SuperFilmsForSharingQueryVariables = Exact<{ [key: string]: never; }>;


export type SuperFilmsForSharingQuery = { __typename?: 'query_root', teams: Array<{ __typename?: 'teams', id: any, name?: string | null, team_number?: any | null, film_name?: string | null, film_festival: { __typename?: 'film_festivals', id: any, name: string }, film?: { __typename?: 'films', id: any, mux_playback_id?: string | null, mux_thumbnail_time?: any | null } | null }> };

export type AdminTeamsSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type AdminTeamsSearchQuery = { __typename?: 'query_root', teams_aggregate: { __typename?: 'teams_aggregate', aggregate?: { __typename?: 'teams_aggregate_fields', count: number } | null }, teams: Array<{ __typename?: 'teams', id: any, team_number?: any | null, name?: string | null, film_name?: string | null, genre?: string | null, submitted_at?: any | null, owner_id: any, film_festival: { __typename?: 'film_festivals', id: any, name: string, due_at?: any | null }, studio?: { __typename?: 'studios', id: number, name: string } | null, film?: { __typename?: 'films', id: any, mux_playback_id?: string | null } | null }> };

export type AdminUsersSearchQueryVariables = Exact<{
  search: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type AdminUsersSearchQuery = { __typename?: 'query_root', users_aggregate: { __typename?: 'users_aggregate', aggregate?: { __typename?: 'users_aggregate_fields', count: number } | null }, users: Array<{ __typename?: 'users', id: any, sub?: string | null, name?: string | null, email?: string | null, picture?: string | null, meta: any, created: any, roles: any }> };

export type AdminUsersSetMetaMutationVariables = Exact<{
  id: Scalars['numeric'];
  meta: Scalars['jsonb'];
}>;


export type AdminUsersSetMetaMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: any, meta: any, roles: any } | null };

export type PackageInventoryQueryVariables = Exact<{
  ffid?: Scalars['Int'];
}>;


export type PackageInventoryQuery = { __typename?: 'query_root', ticket_tailor_vouchers: Array<{ __typename?: 'ticket_tailor_vouchers', id: number, value: number }> };

export type MyVouchersQueryVariables = Exact<{
  ffid?: Scalars['Int'];
}>;


export type MyVouchersQuery = { __typename?: 'query_root', ticket_tailor_vouchers: Array<{ __typename?: 'ticket_tailor_vouchers', id: number, code: string, value: number }> };

export type GetGuestRegistrationQueryVariables = Exact<{
  hash: Scalars['String'];
}>;


export type GetGuestRegistrationQuery = { __typename?: 'query_root', registration?: { __typename?: 'ObscuredRegistration', id: number, first_name: string, middle_name: string, last_name: string, primary_email: string, secondary_email: string, primary_phone: string, secondary_phone: string, address_1: string, address_2: string, city: string, state: string, zip: string, country: string, role: string, film_festival: string, team: string, signature_ts?: string | null, signature_name?: string | null, is_minor: boolean, signature_phone?: string | null, signature_email?: string | null } | null };

export type MyPendingInvitesQueryVariables = Exact<{
  ffid: Scalars['numeric'];
  email: Scalars['String'];
}>;


export type MyPendingInvitesQuery = { __typename?: 'query_root', invitations: Array<{ __typename?: 'team_memberships', id: any, registration?: { __typename?: 'registrations', id: any, first_name?: string | null, middle_name?: string | null, last_name?: string | null, primary_email?: string | null, secondary_email?: string | null, primary_phone?: string | null, secondary_phone?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, role: { __typename?: 'team_roles', id: any, name?: string | null }, team: { __typename?: 'teams', id: any, name?: string | null, team_number?: any | null, studio?: { __typename?: 'studios', id: number, name: string } | null } }> };

export type ShouldReloadTeamSubscriptionVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ShouldReloadTeamSubscription = { __typename?: 'subscription_root', shouldReloadTeam: boolean };

export type CreateTeamMutationVariables = Exact<{
  object: Registrations_Insert_Input;
}>;


export type CreateTeamMutation = { __typename?: 'mutation_root', insert_registrations_one?: { __typename?: 'registrations', id: any, team_membership: { __typename?: 'team_memberships', id: any, team_id: any } } | null };

export type ShouldReloadFestivalSubmissionSubscriptionVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ShouldReloadFestivalSubmissionSubscription = { __typename?: 'subscription_root', shouldReloadFestivalSubmission: boolean };

export type PrizeSponsorFilmGroupsQueryVariables = Exact<{
  ffid: Scalars['numeric'];
  poster: Scalars['numeric'];
}>;


export type PrizeSponsorFilmGroupsQuery = { __typename?: 'query_root', filmGroups: Array<{ __typename?: 'film_groups', id: number, name: string, teams: Array<{ __typename?: 'film_group_films', id: number, team: { __typename?: 'teams', id: any, name?: string | null, team_number?: any | null, film_name?: string | null, genre?: string | null, description?: string | null, poster: Array<{ __typename?: 'team_assets', id: any, file_name: string }>, film?: { __typename?: 'films', id: any, mux_playback_id?: string | null, mux_thumbnail_time?: any | null } | null, studio?: { __typename?: 'studios', id: number, name: string } | null } }> }> };

export type ArchiveFestivalQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ArchiveFestivalQueryQuery = { __typename?: 'query_root', awards: Array<{ __typename?: 'awards', id: any, name?: string | null }>, film_festivals: Array<{ __typename?: 'film_festivals', id: any, name: string, is_fm: boolean, teams: Array<{ __typename?: 'teams', id: any, team_number?: any | null, name?: string | null, film_name?: string | null, genre?: string | null, description?: string | null, poster: Array<{ __typename?: 'team_assets', id: any, file_name: string }>, film?: { __typename?: 'films', id: any, mux_playback_id?: string | null, mux_thumbnail_time?: any | null } | null, studio?: { __typename?: 'studios', id: number, name: string } | null, awards: Array<{ __typename?: 'award_winners', id: number, rank: number, award_id: number }> }> }> };

export type FilmGroupsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type FilmGroupsQueryQuery = { __typename?: 'query_root', film_groups: Array<{ __typename?: 'film_groups', id: number, name: string, teams: Array<{ __typename?: 'film_group_films', id: number, sort: number, team: { __typename?: 'teams', id: any, team_number?: any | null, name?: string | null, film_name?: string | null, poster: Array<{ __typename?: 'team_assets', id: any, file_name: string }> } }> }> };

export type AudienceFavoriteCountsQueryVariables = Exact<{
  ffid: Scalars['numeric'];
}>;


export type AudienceFavoriteCountsQuery = { __typename?: 'query_root', audience_favorite_counts: Array<{ __typename?: 'audience_favorite_counts', count?: any | null, id?: number | null, team?: { __typename?: 'teams', id: any, name?: string | null, film_name?: string | null } | null }> };

export type RecordAudienceFavoriteVoteMutationVariables = Exact<{
  teamId: Scalars['Int'];
  userId: Scalars['Int'];
}>;


export type RecordAudienceFavoriteVoteMutation = { __typename?: 'mutation_root', insert_audience_favorite_votes_one?: { __typename?: 'audience_favorite_votes', id: number } | null };

export type TeamRoleFragment = { __typename?: 'team_roles', id: any, name?: string | null, description?: string | null } & { ' $fragmentName'?: 'TeamRoleFragment' };

export type CountryFragment = { __typename?: 'countries', id: any, name?: string | null, code?: string | null } & { ' $fragmentName'?: 'CountryFragment' };

export type StudioInfoLiteFragment = { __typename?: 'studios', id: number, name: string, owner_id: number, teams: Array<{ __typename?: 'teams', id: any, name?: string | null, team_number?: any | null, submitted_at?: any | null }> } & { ' $fragmentName'?: 'StudioInfoLiteFragment' };

export type GenreFragment = { __typename?: 'genres', id: any, name: string, description?: string | null } & { ' $fragmentName'?: 'GenreFragment' };

export type FestivalGenreFragment = { __typename?: 'festival_genres', id: number, name: string, description?: string | null } & { ' $fragmentName'?: 'FestivalGenreFragment' };

export type AssetTypeFragment = { __typename?: 'asset_types', id: any, title?: string | null } & { ' $fragmentName'?: 'AssetTypeFragment' };

export type FestivalManagerCacheQueryVariables = Exact<{
  userId: Scalars['numeric'];
  userIdInt: Scalars['Int'];
  ffid: Scalars['Int'];
  ffidNum: Scalars['numeric'];
}>;


export type FestivalManagerCacheQuery = { __typename?: 'query_root', team_roles: Array<(
    { __typename?: 'team_roles' }
    & { ' $fragmentRefs'?: { 'TeamRoleFragment': TeamRoleFragment } }
  )>, countries: Array<(
    { __typename?: 'countries' }
    & { ' $fragmentRefs'?: { 'CountryFragment': CountryFragment } }
  )>, genres: Array<(
    { __typename?: 'genres' }
    & { ' $fragmentRefs'?: { 'GenreFragment': GenreFragment } }
  )>, festival_genres: Array<(
    { __typename?: 'festival_genres' }
    & { ' $fragmentRefs'?: { 'FestivalGenreFragment': FestivalGenreFragment } }
  )>, studios: Array<(
    { __typename?: 'studios' }
    & { ' $fragmentRefs'?: { 'StudioInfoLiteFragment': StudioInfoLiteFragment } }
  )>, assetTypes: Array<(
    { __typename?: 'asset_types' }
    & { ' $fragmentRefs'?: { 'AssetTypeFragment': AssetTypeFragment } }
  )> };

export type UpsertFiveFestAcademyRankingsMutationVariables = Exact<{
  object: Film_Group_Users_Insert_Input;
}>;


export type UpsertFiveFestAcademyRankingsMutation = { __typename?: 'mutation_root', insert_film_group_users_one?: { __typename?: 'film_group_users', id: number, film_group_id: number, user_id: number, rankings: any, submitted_at?: any | null } | null };

export type FiveFestAcademyFilmGroupsQueryVariables = Exact<{
  ffid: Scalars['numeric'];
  poster: Scalars['Int'];
}>;


export type FiveFestAcademyFilmGroupsQuery = { __typename?: 'query_root', filmGroups: Array<{ __typename?: 'film_groups', id: number, name: string, users: Array<{ __typename?: 'film_group_users', id: number, film_group_id: number, user_id: number, rankings: any, submitted_at?: any | null }>, festival_submissions: Array<{ __typename?: 'film_group_festival_submissions', id: number, sort: number, festival_submission: { __typename?: 'festival_submissions', id: number, film_title: string, tagline?: string | null, synopsis: string, production_company: string, production_year: string, mux_playback_id?: string | null, mux_thumbnail_time?: any | null, poster: Array<{ __typename?: 'festival_submission_assets', id: number, file_name: string }>, genre: { __typename?: 'festival_genres', id: number, name: string }, feedback: Array<{ __typename?: 'festival_submission_feedback', id: number, comments: string }> } }> }> };

export type FestivalSubmissionQueryQueryVariables = Exact<{
  ffid: Scalars['Int'];
  poster: Scalars['Int'];
}>;


export type FestivalSubmissionQueryQuery = { __typename?: 'query_root', festival_submissions: Array<{ __typename?: 'festival_submissions', id: number, film_title: string, tagline?: string | null, paid_at?: any | null, submitted_at?: any | null, poster: Array<{ __typename?: 'festival_submission_assets', id: number, file_name: string }> }> };

export type LoadFestivalSubmissionQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LoadFestivalSubmissionQuery = { __typename?: 'query_root', festival_submissions_by_pk?: { __typename?: 'festival_submissions', id: number, first_name: string, middle_name?: string | null, last_name: string, primary_phone: string, secondary_phone?: string | null, primary_email: string, secondary_email?: string | null, address_1: string, address_2?: string | null, city: string, state: string, zip: string, country: string, film_title: string, tagline?: string | null, production_year: string, production_company: string, synopsis: string, mux_asset_id?: string | null, mux_upload_id?: string | null, mux_playback_id?: string | null, mux_asset_data?: any | null, paid_at?: any | null, submitted_at?: any | null, genre: { __typename?: 'festival_genres', id: number, name: string, description?: string | null }, assets: Array<{ __typename?: 'festival_submission_assets', id: number, file_name: string, created_at: any, asset_type: { __typename?: 'asset_types', id: any, title?: string | null } }>, vouchers: Array<{ __typename?: 'festival_submission_vouchers', id: number, team: { __typename?: 'teams', id: any, studio_id?: number | null, team_number?: any | null, name?: string | null } }> } | null };

export type SubmissionPaymentMutationVariables = Exact<{
  returnUrl: Scalars['String'];
  lineItems: Array<StripeLineItem> | StripeLineItem;
  festivalSubmissionId: Scalars['Int'];
}>;


export type SubmissionPaymentMutation = { __typename?: 'mutation_root', url: string };

export type SaveFestivalSubmissionMutationVariables = Exact<{
  id: Scalars['Int'];
  _set?: InputMaybe<Festival_Submissions_Set_Input>;
}>;


export type SaveFestivalSubmissionMutation = { __typename?: 'mutation_root', update_festival_submissions_by_pk?: { __typename?: 'festival_submissions', id: number } | null };

export type JudgeSaveRankingsMutationVariables = Exact<{
  id: Scalars['Int'];
  rankings?: InputMaybe<Scalars['jsonb']>;
}>;


export type JudgeSaveRankingsMutation = { __typename?: 'mutation_root', update_film_group_users_by_pk?: { __typename?: 'film_group_users', id: number, film_group_id: number, user_id: number, rankings: any, submitted_at?: any | null } | null };

export type JudgeSaveSubmittedAtMutationVariables = Exact<{
  id: Scalars['Int'];
  submittedAt?: InputMaybe<Scalars['timestamptz']>;
}>;


export type JudgeSaveSubmittedAtMutation = { __typename?: 'mutation_root', update_film_group_users_by_pk?: { __typename?: 'film_group_users', id: number, film_group_id: number, user_id: number, rankings: any, submitted_at?: any | null } | null };

export type JudgeFilmGroupsQueryVariables = Exact<{
  ffid: Scalars['numeric'];
  poster: Scalars['numeric'];
}>;


export type JudgeFilmGroupsQuery = { __typename?: 'query_root', filmGroups: Array<{ __typename?: 'film_groups', id: number, name: string, users: Array<{ __typename?: 'film_group_users', id: number, film_group_id: number, user_id: number, rankings: any, submitted_at?: any | null }>, award?: { __typename?: 'awards', id: any, name?: string | null, description?: string | null } | null, teams: Array<{ __typename?: 'film_group_films', id: number, sort: number, team: { __typename?: 'teams', id: any, name?: string | null, team_number?: any | null, film_name?: string | null, genre?: string | null, description?: string | null, poster: Array<{ __typename?: 'team_assets', id: any, file_name: string }>, film?: { __typename?: 'films', id: any, mux_playback_id?: string | null, mux_thumbnail_time?: any | null } | null, studio?: { __typename?: 'studios', id: number, name: string } | null, award_nominations: Array<{ __typename?: 'award_nominations', id?: any | null, award?: { __typename?: 'awards', id: any, name?: string | null } | null, assets: Array<{ __typename?: 'nomination_assets', id: any, file_name: string }>, membership?: { __typename?: 'team_memberships', id: any, registration?: { __typename?: 'registrations', id: any, first_name?: string | null, last_name?: string | null } | null } | null }> } }> }> };

export type ScreeningPlaylistQueryVariables = Exact<{ [key: string]: never; }>;


export type ScreeningPlaylistQuery = { __typename?: 'query_root', film_groups: Array<{ __typename?: 'film_groups', id: number, name: string, teams: Array<{ __typename?: 'film_group_films', id: number, sort: number, film_group_id: number, team: { __typename?: 'teams', id: any, team_number?: any | null, name?: string | null, film_name?: string | null, genre?: string | null, description?: string | null, poster: Array<{ __typename?: 'team_assets', id: any, file_name: string }>, film?: { __typename?: 'films', id: any, mux_playback_id?: string | null, mux_thumbnail_time?: any | null } | null, studio?: { __typename?: 'studios', id: number, name: string } | null } }> }>, five_fest_film_groups: Array<{ __typename?: 'film_groups', id: number, name: string, festival_submissions: Array<{ __typename?: 'film_group_festival_submissions', id: number, sort: number, festival_submission: { __typename?: 'festival_submissions', id: number, film_title: string, production_company: string, production_year: string, synopsis: string, tagline?: string | null, first_name: string, last_name: string, mux_playback_id?: string | null, genre: { __typename?: 'festival_genres', id: number, name: string }, poster: Array<{ __typename?: 'festival_submission_assets', id: number, file_name: string }> } }> }> };

export type SelectionFilmGroupsQueryVariables = Exact<{
  ffid: Scalars['numeric'];
  poster: Scalars['numeric'];
}>;


export type SelectionFilmGroupsQuery = { __typename?: 'query_root', filmGroups: Array<{ __typename?: 'film_groups', id: number, name: string, teams: Array<{ __typename?: 'film_group_films', id: number, team: { __typename?: 'teams', id: any, name?: string | null, team_number?: any | null, film_name?: string | null, genre?: string | null, description?: string | null, poster: Array<{ __typename?: 'team_assets', id: any, file_name: string }>, film?: { __typename?: 'films', id: any, mux_playback_id?: string | null, mux_thumbnail_time?: any | null } | null, studio?: { __typename?: 'studios', id: number, name: string } | null, selection_metrics_aggregate: { __typename?: 'selection_metrics_aggregate', aggregate?: { __typename?: 'selection_metrics_aggregate_fields', count: number } | null }, selection_metrics: Array<{ __typename?: 'selection_metrics', id: number, award_id: any, value: number }>, award_nominations: Array<{ __typename?: 'award_nominations', id?: any | null, award?: { __typename?: 'awards', id: any, name?: string | null } | null, assets: Array<{ __typename?: 'nomination_assets', id: any, file_name: string }>, membership?: { __typename?: 'team_memberships', id: any, registration?: { __typename?: 'registrations', id: any, first_name?: string | null, last_name?: string | null } | null } | null }> } }>, selection_progresses: Array<{ __typename?: 'selection_progress', id: number, index: number, seek: number }> }>, awards: Array<{ __typename?: 'awards', id: any, name?: string | null, description?: string | null, max_nominations: number }> };

export type UpsertSelectionProgressMutationVariables = Exact<{
  film_group_id: Scalars['Int'];
  index: Scalars['Int'];
}>;


export type UpsertSelectionProgressMutation = { __typename?: 'mutation_root', insert_selection_progress_one?: { __typename?: 'selection_progress', id: number, index: number, seek: number } | null };

export type UpsertSelectionMetricMutationVariables = Exact<{
  award_id: Scalars['numeric'];
  team_id: Scalars['numeric'];
  value: Scalars['Int'];
}>;


export type UpsertSelectionMetricMutation = { __typename?: 'mutation_root', insert_selection_metrics_one?: { __typename?: 'selection_metrics', id: number, team_id: any, award_id: any, value: number, team: { __typename?: 'teams', id: any, selection_metrics_aggregate: { __typename?: 'selection_metrics_aggregate', aggregate?: { __typename?: 'selection_metrics_aggregate_fields', count: number } | null } } } | null };

export type UserFragment = { __typename?: 'users', id: any, name?: string | null, email?: string | null, sub?: string | null, picture?: string | null } & { ' $fragmentName'?: 'UserFragment' };

export type WhoamiQueryVariables = Exact<{ [key: string]: never; }>;


export type WhoamiQuery = { __typename?: 'query_root', users: Array<(
    { __typename?: 'users' }
    & { ' $fragmentRefs'?: { 'UserFragment': UserFragment } }
  )> };

export type StudioCacheQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type StudioCacheQuery = { __typename?: 'query_root', studio?: { __typename?: 'studios', id: number, name: string, owner_id: number, participating_since?: string | null, slogan?: string | null, teams: Array<{ __typename?: 'teams', id: any, name?: string | null, film_name?: string | null, team_number?: any | null, film_festival: { __typename?: 'film_festivals', id: any, name: string }, film?: { __typename?: 'films', id: any, vimeo_url?: string | null, mux_playback_id?: string | null, mux_thumbnail_time?: any | null, recommendations?: any | null } | null, memberships_aggregate: { __typename?: 'team_memberships_aggregate', aggregate?: { __typename?: 'team_memberships_aggregate_fields', count: number } | null }, memberships: Array<{ __typename?: 'team_memberships', id: any, user_id?: any | null, role: { __typename?: 'team_roles', id: any, name?: string | null }, registration?: { __typename?: 'registrations', id: any, first_name?: string | null, last_name?: string | null } | null }> }> } | null };

export type TeamCacheQueryVariables = Exact<{
  id: Scalars['numeric'];
  posterAssetTypeId: Scalars['numeric'];
}>;


export type TeamCacheQuery = { __typename?: 'query_root', team?: { __typename?: 'teams', id: any, studio_id?: number | null, owner_id: any, name?: string | null, team_number?: any | null, film_name?: string | null, genre?: string | null, description?: string | null, duration?: string | null, is_no_music?: string | null, submitted_at?: any | null, inspiration_meta: any, film_festival: { __typename?: 'film_festivals', id: any, name: string, registration_fee: any, due_at?: any | null }, festival_submission_vouchers: Array<{ __typename?: 'festival_submission_vouchers', id: number, redeemed_at?: any | null, festival_submission?: { __typename?: 'festival_submissions', id: number, film_title: string, mux_playback_id?: string | null, submitted_at?: any | null } | null }>, memberships: Array<{ __typename?: 'team_memberships', id: any, is_invited?: string | null, user_id?: any | null, registration?: { __typename?: 'registrations', id: any, first_name?: string | null, last_name?: string | null, primary_email?: string | null, signature_ts?: any | null } | null, role: { __typename?: 'team_roles', id: any, name?: string | null }, user?: { __typename?: 'users', id: any, sub?: string | null } | null }>, award_nominations: Array<{ __typename?: 'award_nominations', id?: any | null, award_id?: any | null, asset_types: Array<{ __typename?: 'award_asset_types', id: any, asset_type_id: any }>, assets: Array<{ __typename?: 'nomination_assets', id: any, asset_type_id: any }> }>, prize_elections: Array<{ __typename?: 'prize_elections', id?: any | null, prize_id?: any | null }>, music_releases: Array<{ __typename?: 'music_releases', id: any, song_title?: string | null, composer?: string | null, publisher?: string | null, start_time?: string | null, duration?: string | null, society?: string | null, use_type?: string | null, is_royalty_free?: string | null, royalty_free_source?: string | null, is_original?: string | null, asset?: { __typename?: 'team_assets', id: any, file_name: string } | null }>, location_releases: Array<{ __typename?: 'location_releases', id: any, venue_name?: string | null, first_name?: string | null, middle_name?: string | null, last_name?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, is_owned_by_team?: string | null, asset?: { __typename?: 'team_assets', id: any, file_name: string } | null }>, payments_aggregate: { __typename?: 'payments_aggregate', aggregate?: { __typename?: 'payments_aggregate_fields', sum?: { __typename?: 'payments_sum_fields', amount?: any | null } | null } | null }, film?: { __typename?: 'films', id: any, duration?: any | null, mux_playback_id?: string | null, mux_thumbnail_time?: any | null, uploaded_at?: any | null, recommendations?: any | null } | null, posters: Array<{ __typename?: 'team_assets', id: any, file_name: string }>, assets: Array<{ __typename?: 'team_assets', id: any, file_name: string, asset_type: { __typename?: 'asset_types', id: any, title?: string | null } }>, submission?: { __typename?: 'submission_summary', id?: any | null, paperwork_ts?: any | null, film_ts?: any | null, has_reupload?: boolean | null, official_ts?: any | null, is_on_time?: boolean | null } | null, matchup_requests_aggregate: { __typename?: 'matchup_requests_aggregate', aggregate?: { __typename?: 'matchup_requests_aggregate_fields', count: number } | null } } | null, awards: Array<{ __typename?: 'awards', id: any }> };

export const TeamRoleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamRole"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"team_roles"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<TeamRoleFragment, unknown>;
export const CountryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Country"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"countries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]} as unknown as DocumentNode<CountryFragment, unknown>;
export const StudioInfoLiteFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StudioInfoLite"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"studios"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"owner_id"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_festival_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ffidNum"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"team_number"}},{"kind":"Field","name":{"kind":"Name","value":"submitted_at"}}]}}]}}]} as unknown as DocumentNode<StudioInfoLiteFragment, unknown>;
export const GenreFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Genre"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"genres"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<GenreFragment, unknown>;
export const FestivalGenreFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FestivalGenre"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"festival_genres"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<FestivalGenreFragment, unknown>;
export const AssetTypeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssetType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"asset_types"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]} as unknown as DocumentNode<AssetTypeFragment, unknown>;
export const UserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"User"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sub"}},{"kind":"Field","name":{"kind":"Name","value":"picture"}}]}}]} as unknown as DocumentNode<UserFragment, unknown>;
export const RemoveSelectionAssignmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveSelectionAssignment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_film_group_users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveSelectionAssignmentMutation, RemoveSelectionAssignmentMutationVariables>;
export const FilmGroupFestivalSubmissionUpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FilmGroupFestivalSubmissionUp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filmGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oldSort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newSort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"reserve"},"name":{"kind":"Name","value":"update_film_group_festival_submissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"IntValue","value":"-1"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_group_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filmGroupId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oldSort"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"bulk"},"name":{"kind":"Name","value":"update_film_group_festival_submissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_inc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"IntValue","value":"-1"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_group_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filmGroupId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oldSort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newSort"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"swap"},"name":{"kind":"Name","value":"update_film_group_festival_submissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newSort"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_group_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filmGroupId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"-1"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<FilmGroupFestivalSubmissionUpMutation, FilmGroupFestivalSubmissionUpMutationVariables>;
export const FilmGroupFestivalSubmissionDownDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FilmGroupFestivalSubmissionDown"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filmGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oldSort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newSort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"reserve"},"name":{"kind":"Name","value":"update_film_group_festival_submissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"IntValue","value":"-1"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_group_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filmGroupId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oldSort"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"bulk"},"name":{"kind":"Name","value":"update_film_group_festival_submissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_inc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"IntValue","value":"1"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_group_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filmGroupId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newSort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oldSort"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"swap"},"name":{"kind":"Name","value":"update_film_group_festival_submissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newSort"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_group_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filmGroupId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"-1"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<FilmGroupFestivalSubmissionDownMutation, FilmGroupFestivalSubmissionDownMutationVariables>;
export const FilmGroupFestivalSubmissionRemoveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FilmGroupFestivalSubmissionRemove"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filmGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_film_group_festival_submissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_group_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filmGroupId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_film_group_festival_submissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_group_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filmGroupId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_inc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"IntValue","value":"-1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<FilmGroupFestivalSubmissionRemoveMutation, FilmGroupFestivalSubmissionRemoveMutationVariables>;
export const SpliceFilmGroupFestivalSubmissionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SpliceFilmGroupFestivalSubmission"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filmGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"festival_submission_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_film_group_festival_submissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_group_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filmGroupId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_inc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_film_group_festival_submissions_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_group_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filmGroupId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"festival_submission_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"festival_submission_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SpliceFilmGroupFestivalSubmissionMutation, SpliceFilmGroupFestivalSubmissionMutationVariables>;
export const SelectionBallotDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SelectionBallot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filmGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"film_groups_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filmGroupId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"award_nominations_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"award_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"selection_metrics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"real_user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_group_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filmGroupId"}}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<SelectionBallotQuery, SelectionBallotQueryVariables>;
export const FilmGroupFilmUpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FilmGroupFilmUp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filmGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oldSort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newSort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"reserve"},"name":{"kind":"Name","value":"update_film_group_films"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"IntValue","value":"-1"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_group_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filmGroupId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oldSort"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"bulk"},"name":{"kind":"Name","value":"update_film_group_films"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_inc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"IntValue","value":"-1"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_group_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filmGroupId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oldSort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newSort"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"swap"},"name":{"kind":"Name","value":"update_film_group_films"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newSort"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_group_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filmGroupId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"-1"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<FilmGroupFilmUpMutation, FilmGroupFilmUpMutationVariables>;
export const FilmGroupFilmDownDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FilmGroupFilmDown"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filmGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oldSort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newSort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"reserve"},"name":{"kind":"Name","value":"update_film_group_films"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"IntValue","value":"-1"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_group_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filmGroupId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oldSort"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"bulk"},"name":{"kind":"Name","value":"update_film_group_films"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_inc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"IntValue","value":"1"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_group_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filmGroupId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newSort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oldSort"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"swap"},"name":{"kind":"Name","value":"update_film_group_films"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newSort"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_group_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filmGroupId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"-1"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<FilmGroupFilmDownMutation, FilmGroupFilmDownMutationVariables>;
export const FilmGroupFilmRemoveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FilmGroupFilmRemove"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filmGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_film_group_films"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_group_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filmGroupId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_film_group_films"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_group_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filmGroupId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_inc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"IntValue","value":"-1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<FilmGroupFilmRemoveMutation, FilmGroupFilmRemoveMutationVariables>;
export const SpliceFilmGroupFilmDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SpliceFilmGroupFilm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filmGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_film_group_films"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_group_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filmGroupId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_inc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_film_group_films_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_group_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filmGroupId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SpliceFilmGroupFilmMutation, SpliceFilmGroupFilmMutationVariables>;
export const AdminCreateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminCreateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdBy"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_users_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdBy"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"updated_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdBy"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<AdminCreateUserMutation, AdminCreateUserMutationVariables>;
export const AdminEditUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminEditUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<AdminEditUserMutation, AdminEditUserMutationVariables>;
export const TerminalCheckoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TerminalCheckout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripeTerminalCharge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amount"}}}]}]}}]} as unknown as DocumentNode<TerminalCheckoutMutation, TerminalCheckoutMutationVariables>;
export const TerminalCancelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TerminalCancel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripeTerminalCancel"}}]}}]} as unknown as DocumentNode<TerminalCancelMutation, TerminalCancelMutationVariables>;
export const FiveFestAcademyFeedbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FiveFestAcademyFeedback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"festivalSubmissionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comments"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_festival_submission_feedback_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"festival_submission_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"festivalSubmissionId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"comments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comments"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"festival_submission_feedback_festival_submission_id_user_id_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"comments"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}}]}}]}}]} as unknown as DocumentNode<FiveFestAcademyFeedbackMutation, FiveFestAcademyFeedbackMutationVariables>;
export const FestivalSubmissionVouchersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FestivalSubmissionVouchers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"festival_submission_vouchers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_festival_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"24"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"redeemed_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<FestivalSubmissionVouchersQuery, FestivalSubmissionVouchersQueryVariables>;
export const ClaimFestivalSubmissionVoucherDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ClaimFestivalSubmissionVoucher"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"voucherId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"submissionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"claimFestivalSubmissionVoucher"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"voucherId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"voucherId"}}},{"kind":"Argument","name":{"kind":"Name","value":"festivalSubmissionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"submissionId"}}}]}]}}]} as unknown as DocumentNode<ClaimFestivalSubmissionVoucherMutation, ClaimFestivalSubmissionVoucherMutationVariables>;
export const SubmitFiveFestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitFiveFest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signature_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"is_minor"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signature_email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signature_phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitFiveFest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"signature_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signature_name"}}},{"kind":"Argument","name":{"kind":"Name","value":"is_minor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"is_minor"}}},{"kind":"Argument","name":{"kind":"Name","value":"signature_email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signature_email"}}},{"kind":"Argument","name":{"kind":"Name","value":"signature_phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signature_phone"}}}]}]}}]} as unknown as DocumentNode<SubmitFiveFestMutation, SubmitFiveFestMutationVariables>;
export const StudioInterviewDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StudioInterviewDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}},"defaultValue":{"kind":"IntValue","value":"1095"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"poster"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}},"defaultValue":{"kind":"StringValue","value":"4","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"studios"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"submitted_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"team_number"}},{"kind":"Field","name":{"kind":"Name","value":"film_name"}},{"kind":"Field","name":{"kind":"Name","value":"genre"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"poster"},"name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset_type_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"poster"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"film"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mux_playback_id"}},{"kind":"Field","name":{"kind":"Name","value":"mux_thumbnail_time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"award_nominations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"award"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"award"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"membership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"prize_elections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prize"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"submission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"official_ts"}},{"kind":"Field","name":{"kind":"Name","value":"is_on_time"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"awards"},"name":{"kind":"Name","value":"award_wins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rank"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"award"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<StudioInterviewDetailsQuery, StudioInterviewDetailsQueryVariables>;
export const CreateStudioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateStudio"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"studio"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"studios_insert_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ffid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_studios_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"studio"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"owner_id"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_festival_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ffid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"team_number"}},{"kind":"Field","name":{"kind":"Name","value":"submitted_at"}}]}}]}}]}}]} as unknown as DocumentNode<CreateStudioMutation, CreateStudioMutationVariables>;
export const UpdateTeamDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTeamDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"teams_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"film_name"}},{"kind":"Field","name":{"kind":"Name","value":"genre"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<UpdateTeamDetailsMutation, UpdateTeamDetailsMutationVariables>;
export const MyExitInterviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyExitInterview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exit_interviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ready_at"}}]}}]}}]} as unknown as DocumentNode<MyExitInterviewQuery, MyExitInterviewQueryVariables>;
export const MyExitInterviewSubDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"MyExitInterviewSub"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exit_interviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ready_at"}}]}}]}}]} as unknown as DocumentNode<MyExitInterviewSubSubscription, MyExitInterviewSubSubscriptionVariables>;
export const ReadyExitInterviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReadyExitInterview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_exit_interviews_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ready_at"},"value":{"kind":"StringValue","value":"now","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ready_at"}}]}}]}}]} as unknown as DocumentNode<ReadyExitInterviewMutation, ReadyExitInterviewMutationVariables>;
export const DeleteAwardNominationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAwardNomination"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_nominations_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteAwardNominationMutation, DeleteAwardNominationMutationVariables>;
export const DeleteNominationAssetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteNominationAsset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_nomination_assets_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteNominationAssetMutation, DeleteNominationAssetMutationVariables>;
export const DeleteLocationReleaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteLocationRelease"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_location_releases_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteLocationReleaseMutation, DeleteLocationReleaseMutationVariables>;
export const DeleteMembershipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteMembership"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_team_memberships_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"StringValue","value":"now","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deleted"}}]}}]}}]} as unknown as DocumentNode<DeleteMembershipMutation, DeleteMembershipMutationVariables>;
export const DeleteMusicReleaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteMusicRelease"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_music_releases_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteMusicReleaseMutation, DeleteMusicReleaseMutationVariables>;
export const LoadRegistrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoadRegistration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"team_membership"},"name":{"kind":"Name","value":"team_memberships_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_invited"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address_1"}},{"kind":"Field","name":{"kind":"Name","value":"address_2"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"middle_name"}},{"kind":"Field","name":{"kind":"Name","value":"primary_email"}},{"kind":"Field","name":{"kind":"Name","value":"primary_phone"}},{"kind":"Field","name":{"kind":"Name","value":"secondary_email"}},{"kind":"Field","name":{"kind":"Name","value":"secondary_phone"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}}]}}]}}]} as unknown as DocumentNode<LoadRegistrationQuery, LoadRegistrationQueryVariables>;
export const ReqeustSignatureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReqeustSignature"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendGuestSignatureMail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"teamMembershipId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<ReqeustSignatureMutation, ReqeustSignatureMutationVariables>;
export const InviteMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InviteMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendTeamInvitationMail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"teamMembershipId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<InviteMemberMutation, InviteMemberMutationVariables>;
export const InviteGuestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InviteGuest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendGuestSignatureMail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"teamMembershipId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<InviteGuestMutation, InviteGuestMutationVariables>;
export const CreateTeamMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTeamMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"registrations_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"registration"},"name":{"kind":"Name","value":"insert_registrations_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_membership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_invited"}}]}}]}}]}}]} as unknown as DocumentNode<CreateTeamMemberMutation, CreateTeamMemberMutationVariables>;
export const TeamAwardNominationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeamAwardNominations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"awards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"max_nominations"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"max_nominations"}},{"kind":"Field","alias":{"kind":"Name","value":"nominations"},"name":{"kind":"Name","value":"award_nominations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"membership"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"team_membership"},"name":{"kind":"Name","value":"membership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"asset_type_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asset_type_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"required_asset_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mime"}},{"kind":"Field","name":{"kind":"Name","value":"asset_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TeamAwardNominationsQuery, TeamAwardNominationsQueryVariables>;
export const CreateAwardNominationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAwardNomination"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nomination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"nominations_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_nominations_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nomination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateAwardNominationMutation, CreateAwardNominationMutationVariables>;
export const DeleteTeamAssetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTeamAsset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_team_assets_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteTeamAssetMutation, DeleteTeamAssetMutationVariables>;
export const DownloadTeamAssetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DownloadTeamAsset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetSign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}]}}]} as unknown as DocumentNode<DownloadTeamAssetMutation, DownloadTeamAssetMutationVariables>;
export const UpdateFilmDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateFilmDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"teams_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"film_name"}},{"kind":"Field","name":{"kind":"Name","value":"genre"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"inspiration_meta"}}]}}]}}]} as unknown as DocumentNode<UpdateFilmDetailsMutation, UpdateFilmDetailsMutationVariables>;
export const CreateFestivalSubmissionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateFestivalSubmission"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"festival_submissions_insert_input"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_festival_submissions_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateFestivalSubmissionMutation, CreateFestivalSubmissionMutationVariables>;
export const AttachAssetToLocationReleaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AttachAssetToLocationRelease"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_location_releases_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"release_asset_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}}]}}]} as unknown as DocumentNode<AttachAssetToLocationReleaseMutation, AttachAssetToLocationReleaseMutationVariables>;
export const MyMatchupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyMatchup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filmFestivalId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matchup_requests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_festival_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filmFestivalId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"expertise_json"}},{"kind":"Field","name":{"kind":"Name","value":"genres_json"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"withdrawn"}},{"kind":"Field","name":{"kind":"Name","value":"withdrawn_type"}}]}}]}}]} as unknown as DocumentNode<MyMatchupQuery, MyMatchupQueryVariables>;
export const MatchupRequestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MatchupRequests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filmFestivalId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"requests"},"name":{"kind":"Name","value":"matchup_requests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_festival_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filmFestivalId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"withdrawn"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"expertise_json"}},{"kind":"Field","name":{"kind":"Name","value":"genres_json"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}}]}}]} as unknown as DocumentNode<MatchupRequestsQuery, MatchupRequestsQueryVariables>;
export const SaveMyMatchupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveMyMatchup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"matchup_requests_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_matchup_requests_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"matchup_requests_film_festival_id_user_id_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"first_name"},{"kind":"EnumValue","value":"last_name"},{"kind":"EnumValue","value":"email"},{"kind":"EnumValue","value":"phone"},{"kind":"EnumValue","value":"expertise_json"},{"kind":"EnumValue","value":"genres_json"},{"kind":"EnumValue","value":"notes"},{"kind":"EnumValue","value":"type"},{"kind":"EnumValue","value":"withdrawn"},{"kind":"EnumValue","value":"withdrawn_type"},{"kind":"EnumValue","value":"team_id"}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"expertise_json"}},{"kind":"Field","name":{"kind":"Name","value":"genres_json"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"withdrawn"}},{"kind":"Field","name":{"kind":"Name","value":"withdrawn_type"}}]}}]}}]} as unknown as DocumentNode<SaveMyMatchupMutation, SaveMyMatchupMutationVariables>;
export const AttachAssetToMusicReleaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AttachAssetToMusicRelease"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_music_releases_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"release_asset_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}}]}}]} as unknown as DocumentNode<AttachAssetToMusicReleaseMutation, AttachAssetToMusicReleaseMutationVariables>;
export const ToggleNoMusicDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ToggleNoMusic"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isNoMusic"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_no_music"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isNoMusic"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_no_music"}}]}}]}}]} as unknown as DocumentNode<ToggleNoMusicMutation, ToggleNoMusicMutationVariables>;
export const TeamPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TeamPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"returnUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lineItems"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StripeLineItem"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"badgeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"url"},"name":{"kind":"Name","value":"stripeCreatePurchase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"returnUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"returnUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"lineItems"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lineItems"}}},{"kind":"Argument","name":{"kind":"Name","value":"teamId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"badgeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"badgeId"}}}]}]}}]} as unknown as DocumentNode<TeamPaymentMutation, TeamPaymentMutationVariables>;
export const TeamPrizeNominationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeamPrizeNominations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ffid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prizes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_festival_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ffid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"sponsor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mux_playback_id"}}]}}]}}]} as unknown as DocumentNode<TeamPrizeNominationsQuery, TeamPrizeNominationsQueryVariables>;
export const PrizeOptInDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PrizeOptIn"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nomination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"nominations_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_nominations_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nomination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<PrizeOptInMutation, PrizeOptInMutationVariables>;
export const DeletePrizeNominationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePrizeNomination"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nomination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"nominations_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_nominations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nomination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeletePrizeNominationMutation, DeletePrizeNominationMutationVariables>;
export const SubmitTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitTeam"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<SubmitTeamMutation, SubmitTeamMutationVariables>;
export const SetThumbTimeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetThumbTime"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"time"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_films_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mux_thumbnail_time"},"value":{"kind":"Variable","name":{"kind":"Name","value":"time"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mux_thumbnail_time"}}]}}]}}]} as unknown as DocumentNode<SetThumbTimeMutation, SetThumbTimeMutationVariables>;
export const SignAssetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SignAsset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetSign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}]}}]} as unknown as DocumentNode<SignAssetMutation, SignAssetMutationVariables>;
export const CreateAssetUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAssetUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filename"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filename"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filename"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"uploadUrl"}}]}}]}}]} as unknown as DocumentNode<CreateAssetUploadMutation, CreateAssetUploadMutationVariables>;
export const UploadTeamAssetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadTeamAsset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"asset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"team_assets_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_team_assets_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"asset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UploadTeamAssetMutation, UploadTeamAssetMutationVariables>;
export const CreateAwardNominationAssetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAwardNominationAsset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"asset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"nomination_assets_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_nomination_assets_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"asset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateAwardNominationAssetMutation, CreateAwardNominationAssetMutationVariables>;
export const UploadFilmDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadFilm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"muxCreateUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fileName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}}},{"kind":"Argument","name":{"kind":"Name","value":"fileSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"teamId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}]}}]} as unknown as DocumentNode<UploadFilmMutation, UploadFilmMutationVariables>;
export const UploadFiveFestFilmDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadFiveFestFilm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"submissionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"muxCreateFiveFestUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fileName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}}},{"kind":"Argument","name":{"kind":"Name","value":"fileSize"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"submissionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"submissionId"}}}]}]}}]} as unknown as DocumentNode<UploadFiveFestFilmMutation, UploadFiveFestFilmMutationVariables>;
export const UploadFestivalSubmissionAssetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadFestivalSubmissionAsset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"asset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"festival_submission_assets_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_festival_submission_assets_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"asset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UploadFestivalSubmissionAssetMutation, UploadFestivalSubmissionAssetMutationVariables>;
export const JoinLiveKitExitInterviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"JoinLiveKitExitInterview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"joinLiveKitExitInterview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"teamId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"displayName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"displayName"}}}]}]}}]} as unknown as DocumentNode<JoinLiveKitExitInterviewMutation, JoinLiveKitExitInterviewMutationVariables>;
export const CreateLocationReleaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateLocationRelease"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"release"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"location_releases_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_location_releases_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"release"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateLocationReleaseMutation, CreateLocationReleaseMutationVariables>;
export const UpdateLocationReleaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLocationRelease"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"release"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"location_releases_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_location_releases_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"release"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"venue_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"middle_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"address_1"}},{"kind":"Field","name":{"kind":"Name","value":"address_2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"is_owned_by_team"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLocationReleaseMutation, UpdateLocationReleaseMutationVariables>;
export const MatchupExpertiseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MatchupExpertise"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expertise"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"genres"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<MatchupExpertiseQuery, MatchupExpertiseQueryVariables>;
export const CreateMusicReleaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMusicRelease"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"release"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"music_releases_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_music_releases_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"release"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateMusicReleaseMutation, CreateMusicReleaseMutationVariables>;
export const UpdateMusicReleaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMusicRelease"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"release"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"music_releases_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_music_releases_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"release"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"composer"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"is_original"}},{"kind":"Field","name":{"kind":"Name","value":"is_royalty_free"}},{"kind":"Field","name":{"kind":"Name","value":"publisher"}},{"kind":"Field","name":{"kind":"Name","value":"royalty_free_source"}},{"kind":"Field","name":{"kind":"Name","value":"society"}},{"kind":"Field","name":{"kind":"Name","value":"song_title"}},{"kind":"Field","name":{"kind":"Name","value":"start_time"}},{"kind":"Field","name":{"kind":"Name","value":"use_type"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateMusicReleaseMutation, UpdateMusicReleaseMutationVariables>;
export const LastRegistrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LastRegistration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"pastRegistrations"},"name":{"kind":"Name","value":"registrations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"signature_ts"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"middle_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"primary_phone"}},{"kind":"Field","name":{"kind":"Name","value":"secondary_phone"}},{"kind":"Field","name":{"kind":"Name","value":"primary_email"}},{"kind":"Field","name":{"kind":"Name","value":"secondary_email"}},{"kind":"Field","name":{"kind":"Name","value":"address_1"}},{"kind":"Field","name":{"kind":"Name","value":"address_2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]} as unknown as DocumentNode<LastRegistrationQuery, LastRegistrationQueryVariables>;
export const SaveRegistrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveRegistration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_set"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"registrations_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_registrations_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SaveRegistrationMutation, SaveRegistrationMutationVariables>;
export const SignRegistrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SignRegistration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hash"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signature_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signature_phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signature_email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"is_minor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provideRegistrationSignature"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"hash"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hash"}}},{"kind":"Argument","name":{"kind":"Name","value":"signature_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signature_name"}}},{"kind":"Argument","name":{"kind":"Name","value":"signature_phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signature_phone"}}},{"kind":"Argument","name":{"kind":"Name","value":"signature_email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signature_email"}}},{"kind":"Argument","name":{"kind":"Name","value":"is_minor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"is_minor"}}}]}]}}]} as unknown as DocumentNode<SignRegistrationMutation, SignRegistrationMutationVariables>;
export const AwardsCeremonyCheckinQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AwardsCeremonyCheckinQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_festival_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"24"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"submitted_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"studio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"film_name"}},{"kind":"Field","alias":{"kind":"Name","value":"poster"},"name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset_type_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"21"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"festival_submissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_festival_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"24"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"submitted_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"film_title"}},{"kind":"Field","name":{"kind":"Name","value":"production_company"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","alias":{"kind":"Name","value":"poster"},"name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset_type_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"21"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}}]}}]} as unknown as DocumentNode<AwardsCeremonyCheckinQueryQuery, AwardsCeremonyCheckinQueryQueryVariables>;
export const RecordAwardsCeremonyCheckinDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RecordAwardsCeremonyCheckin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"announce"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"festivalSubmissionId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordAwardsCeremonyCheckin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"announce"},"value":{"kind":"Variable","name":{"kind":"Name","value":"announce"}}},{"kind":"Argument","name":{"kind":"Name","value":"teamId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"festivalSubmissionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"festivalSubmissionId"}}}]}]}}]} as unknown as DocumentNode<RecordAwardsCeremonyCheckinMutation, RecordAwardsCeremonyCheckinMutationVariables>;
export const ExitInterviewsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExitInterviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exit_interviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"live_kit_room_status"}},{"kind":"Field","name":{"kind":"Name","value":"mux_live_stream_playback_id"}},{"kind":"Field","name":{"kind":"Name","value":"mux_live_stream_status"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"film_name"}},{"kind":"Field","name":{"kind":"Name","value":"studio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"ready_at"}},{"kind":"Field","name":{"kind":"Name","value":"interviewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"picture"}}]}}]}}]}}]} as unknown as DocumentNode<ExitInterviewsQuery, ExitInterviewsQueryVariables>;
export const ExitInterviewsSubDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ExitInterviewsSub"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exit_interviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"live_kit_room_status"}},{"kind":"Field","name":{"kind":"Name","value":"mux_live_stream_playback_id"}},{"kind":"Field","name":{"kind":"Name","value":"mux_live_stream_status"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"film_name"}},{"kind":"Field","name":{"kind":"Name","value":"studio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"ready_at"}},{"kind":"Field","name":{"kind":"Name","value":"interviewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"picture"}}]}}]}}]}}]} as unknown as DocumentNode<ExitInterviewsSubSubscription, ExitInterviewsSubSubscriptionVariables>;
export const ClaimExitInterviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ClaimExitInterview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_exit_interviews_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"claimed_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_by"}},{"kind":"Field","name":{"kind":"Name","value":"interviewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sub"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"picture"}}]}}]}}]}}]} as unknown as DocumentNode<ClaimExitInterviewMutation, ClaimExitInterviewMutationVariables>;
export const FilmGroupFilmsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FilmGroupFilms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ffid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"poster"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ffidInt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"posterInt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_festival_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ffid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"submitted_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"film_name"}},{"kind":"Field","alias":{"kind":"Name","value":"poster"},"name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset_type_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"poster"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"festival_submissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_festival_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ffidInt"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"submitted_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_title"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"film_title"}},{"kind":"Field","name":{"kind":"Name","value":"genre"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"poster"},"name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset_type_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"posterInt"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"film_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_festival_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ffid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"film_name"}},{"kind":"Field","alias":{"kind":"Name","value":"poster"},"name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset_type_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"poster"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"festival_submissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"festival_submission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"film_title"}},{"kind":"Field","name":{"kind":"Name","value":"genre"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"poster"},"name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset_type_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"posterInt"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FilmGroupFilmsQuery, FilmGroupFilmsQueryVariables>;
export const FilmGroupAssignmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FilmGroupAssignments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ffid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"film_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_festival_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ffid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"screening","block":false},{"kind":"StringValue","value":"fivefest","block":false}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"film_group_id"}},{"kind":"Field","name":{"kind":"Name","value":"rankings"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"submitted_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sub"}},{"kind":"Field","name":{"kind":"Name","value":"picture"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FilmGroupAssignmentsQuery, FilmGroupAssignmentsQueryVariables>;
export const UsersByRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UsersByRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"meta"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"roles"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"role"}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"picture"}},{"kind":"Field","name":{"kind":"Name","value":"meta"}}]}}]}}]} as unknown as DocumentNode<UsersByRoleQuery, UsersByRoleQueryVariables>;
export const AssignFilmGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AssignFilmGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"film_group_users_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_film_group_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<AssignFilmGroupMutation, AssignFilmGroupMutationVariables>;
export const FiveFestAcademyReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FiveFestAcademyReview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"film_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_festival_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"24"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"fivefest","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"festival_submissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"festival_submission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"film_title"}},{"kind":"Field","name":{"kind":"Name","value":"genre"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"poster"},"name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset_type_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"21"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"submitted_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"film_group_id"}},{"kind":"Field","name":{"kind":"Name","value":"rankings"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sub"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"picture"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"festival_genre"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<FiveFestAcademyReviewQuery, FiveFestAcademyReviewQueryVariables>;
export const JudgeReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JudgeReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ffid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"film_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_festival_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ffid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"judge","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"film_name"}},{"kind":"Field","alias":{"kind":"Name","value":"poster"},"name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset_type_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"21"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"film_group_id"}},{"kind":"Field","name":{"kind":"Name","value":"rankings"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sub"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"picture"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"award"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<JudgeReviewQuery, JudgeReviewQueryVariables>;
export const SelectionReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SelectionReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ffid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"film_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_festival_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ffid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"selection","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"film_name"}},{"kind":"Field","alias":{"kind":"Name","value":"poster"},"name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset_type_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"21"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selection_metrics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"award_id"}},{"kind":"Field","name":{"kind":"Name","value":"real_user_id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"award_nominations_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"award_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sub"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"picture"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"awards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"max_nominations"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"IntValue","value":"0"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"max_nominations"}}]}}]}}]} as unknown as DocumentNode<SelectionReviewQuery, SelectionReviewQueryVariables>;
export const SuperSharablesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SuperSharables"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sharables"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mux_playback_id"}},{"kind":"Field","name":{"kind":"Name","value":"mux_thumb_time"}}]}}]}}]} as unknown as DocumentNode<SuperSharablesQuery, SuperSharablesQueryVariables>;
export const SuperFilmsForSharingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SuperFilmsForSharing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_festival_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"24"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"team_number"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"submitted_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_number"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"film_festival"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"team_number"}},{"kind":"Field","name":{"kind":"Name","value":"film_name"}},{"kind":"Field","name":{"kind":"Name","value":"film"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mux_playback_id"}},{"kind":"Field","name":{"kind":"Name","value":"mux_thumbnail_time"}}]}}]}}]}}]} as unknown as DocumentNode<SuperFilmsForSharingQuery, SuperFilmsForSharingQueryVariables>;
export const AdminTeamsSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminTeamsSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"%","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"0"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_number"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"studio"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_number"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"studio"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_festival_id"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_number"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"film_festival"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team_number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"studio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"film_name"}},{"kind":"Field","name":{"kind":"Name","value":"genre"}},{"kind":"Field","name":{"kind":"Name","value":"film"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mux_playback_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"submitted_at"}},{"kind":"Field","name":{"kind":"Name","value":"owner_id"}}]}}]}}]} as unknown as DocumentNode<AdminTeamsSearchQuery, AdminTeamsSearchQueryVariables>;
export const AdminUsersSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminUsersSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"0"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sub"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"picture"}},{"kind":"Field","name":{"kind":"Name","value":"meta"}},{"kind":"Field","alias":{"kind":"Name","value":"roles"},"name":{"kind":"Name","value":"meta"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"roles","block":false}}]},{"kind":"Field","name":{"kind":"Name","value":"created"}}]}}]}}]} as unknown as DocumentNode<AdminUsersSearchQuery, AdminUsersSearchQueryVariables>;
export const AdminUsersSetMetaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminUsersSetMeta"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"meta"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"meta"},"value":{"kind":"Variable","name":{"kind":"Name","value":"meta"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"meta"}},{"kind":"Field","alias":{"kind":"Name","value":"roles"},"name":{"kind":"Name","value":"meta"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"roles","block":false}}]}]}}]}}]} as unknown as DocumentNode<AdminUsersSetMetaMutation, AdminUsersSetMetaMutationVariables>;
export const PackageInventoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PackageInventory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ffid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"24"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticket_tailor_vouchers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_festival_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ffid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<PackageInventoryQuery, PackageInventoryQueryVariables>;
export const MyVouchersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyVouchers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ffid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"24"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticket_tailor_vouchers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_festival_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ffid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<MyVouchersQuery, MyVouchersQueryVariables>;
export const GetGuestRegistrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetGuestRegistration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hash"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"registration"},"name":{"kind":"Name","value":"fetchedObscuredRegistration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"hash"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hash"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"middle_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"primary_email"}},{"kind":"Field","name":{"kind":"Name","value":"secondary_email"}},{"kind":"Field","name":{"kind":"Name","value":"primary_phone"}},{"kind":"Field","name":{"kind":"Name","value":"secondary_phone"}},{"kind":"Field","name":{"kind":"Name","value":"address_1"}},{"kind":"Field","name":{"kind":"Name","value":"address_2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"film_festival"}},{"kind":"Field","name":{"kind":"Name","value":"team"}},{"kind":"Field","name":{"kind":"Name","value":"signature_ts"}},{"kind":"Field","name":{"kind":"Name","value":"signature_name"}},{"kind":"Field","name":{"kind":"Name","value":"is_minor"}},{"kind":"Field","name":{"kind":"Name","value":"signature_phone"}},{"kind":"Field","name":{"kind":"Name","value":"signature_email"}}]}}]}}]} as unknown as DocumentNode<GetGuestRegistrationQuery, GetGuestRegistrationQueryVariables>;
export const MyPendingInvitesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyPendingInvites"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ffid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"invitations"},"name":{"kind":"Name","value":"team_memberships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_festival_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ffid"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"registration"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary_email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"middle_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"primary_email"}},{"kind":"Field","name":{"kind":"Name","value":"secondary_email"}},{"kind":"Field","name":{"kind":"Name","value":"primary_phone"}},{"kind":"Field","name":{"kind":"Name","value":"secondary_phone"}},{"kind":"Field","name":{"kind":"Name","value":"address_1"}},{"kind":"Field","name":{"kind":"Name","value":"address_2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"team_number"}},{"kind":"Field","name":{"kind":"Name","value":"studio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MyPendingInvitesQuery, MyPendingInvitesQueryVariables>;
export const ShouldReloadTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ShouldReloadTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shouldReloadTeam"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<ShouldReloadTeamSubscription, ShouldReloadTeamSubscriptionVariables>;
export const CreateTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"registrations_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_registrations_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_membership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateTeamMutation, CreateTeamMutationVariables>;
export const ShouldReloadFestivalSubmissionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ShouldReloadFestivalSubmission"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shouldReloadFestivalSubmission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<ShouldReloadFestivalSubmissionSubscription, ShouldReloadFestivalSubmissionSubscriptionVariables>;
export const PrizeSponsorFilmGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PrizeSponsorFilmGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ffid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"poster"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"filmGroups"},"name":{"kind":"Name","value":"film_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_festival_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ffid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"prize","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"team_number"}},{"kind":"Field","name":{"kind":"Name","value":"film_name"}},{"kind":"Field","name":{"kind":"Name","value":"genre"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"poster"},"name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset_type_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"poster"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"film"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mux_playback_id"}},{"kind":"Field","name":{"kind":"Name","value":"mux_thumbnail_time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PrizeSponsorFilmGroupsQuery, PrizeSponsorFilmGroupsQueryVariables>;
export const ArchiveFestivalQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ArchiveFestivalQuery"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"300"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"awards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"film_festivals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"is_fm"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"submitted_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"film_name"}},{"kind":"Field","name":{"kind":"Name","value":"genre"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"poster"},"name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset_type_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"21"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"film"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mux_playback_id"}},{"kind":"Field","name":{"kind":"Name","value":"mux_thumbnail_time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"awards"},"name":{"kind":"Name","value":"award_wins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rank"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"award_id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ArchiveFestivalQueryQuery, ArchiveFestivalQueryQueryVariables>;
export const FilmGroupsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FilmGroupsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"film_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"screening","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"film_festival_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"24"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"film_name"}},{"kind":"Field","alias":{"kind":"Name","value":"poster"},"name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset_type_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"21"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FilmGroupsQueryQuery, FilmGroupsQueryQueryVariables>;
export const AudienceFavoriteCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AudienceFavoriteCounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ffid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"audience_favorite_counts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_festival_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ffid"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"film_name"}}]}}]}}]}}]} as unknown as DocumentNode<AudienceFavoriteCountsQuery, AudienceFavoriteCountsQueryVariables>;
export const RecordAudienceFavoriteVoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RecordAudienceFavoriteVote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_audience_favorite_votes_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RecordAudienceFavoriteVoteMutation, RecordAudienceFavoriteVoteMutationVariables>;
export const FestivalManagerCacheDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FestivalManagerCache"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIdInt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ffid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ffidNum"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_roles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamRole"}}]}},{"kind":"Field","name":{"kind":"Name","value":"countries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"genres"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Genre"}}]}},{"kind":"Field","name":{"kind":"Name","value":"festival_genres"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_festival_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ffid"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FestivalGenre"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studios"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"owner_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIdInt"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"owner_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"memberships"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StudioInfoLite"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"assetTypes"},"name":{"kind":"Name","value":"asset_types"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hidden"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hidden"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"Y","block":false}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssetType"}}]}}]}},...TeamRoleFragmentDoc.definitions,...CountryFragmentDoc.definitions,...GenreFragmentDoc.definitions,...FestivalGenreFragmentDoc.definitions,...StudioInfoLiteFragmentDoc.definitions,...AssetTypeFragmentDoc.definitions]} as unknown as DocumentNode<FestivalManagerCacheQuery, FestivalManagerCacheQueryVariables>;
export const UpsertFiveFestAcademyRankingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertFiveFestAcademyRankings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"film_group_users_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_film_group_users_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"film_group_users_user_id_film_group_id_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"rankings"},{"kind":"EnumValue","value":"submitted_at"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"film_group_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"rankings"}},{"kind":"Field","name":{"kind":"Name","value":"submitted_at"}}]}}]}}]} as unknown as DocumentNode<UpsertFiveFestAcademyRankingsMutation, UpsertFiveFestAcademyRankingsMutationVariables>;
export const FiveFestAcademyFilmGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FiveFestAcademyFilmGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ffid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"poster"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"filmGroups"},"name":{"kind":"Name","value":"film_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_festival_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ffid"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"film_group_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"rankings"}},{"kind":"Field","name":{"kind":"Name","value":"submitted_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"festival_submissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"festival_submission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"film_title"}},{"kind":"Field","name":{"kind":"Name","value":"tagline"}},{"kind":"Field","name":{"kind":"Name","value":"synopsis"}},{"kind":"Field","name":{"kind":"Name","value":"production_company"}},{"kind":"Field","name":{"kind":"Name","value":"production_year"}},{"kind":"Field","name":{"kind":"Name","value":"mux_playback_id"}},{"kind":"Field","name":{"kind":"Name","value":"mux_thumbnail_time"}},{"kind":"Field","alias":{"kind":"Name","value":"poster"},"name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset_type_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"poster"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"genre"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FiveFestAcademyFilmGroupsQuery, FiveFestAcademyFilmGroupsQueryVariables>;
export const FestivalSubmissionQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FestivalSubmissionQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ffid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"poster"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"festival_submissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_festival_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ffid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"film_title"}},{"kind":"Field","name":{"kind":"Name","value":"tagline"}},{"kind":"Field","name":{"kind":"Name","value":"paid_at"}},{"kind":"Field","name":{"kind":"Name","value":"submitted_at"}},{"kind":"Field","alias":{"kind":"Name","value":"poster"},"name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset_type_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"poster"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}}]}}]} as unknown as DocumentNode<FestivalSubmissionQueryQuery, FestivalSubmissionQueryQueryVariables>;
export const LoadFestivalSubmissionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoadFestivalSubmission"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"festival_submissions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"middle_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"primary_phone"}},{"kind":"Field","name":{"kind":"Name","value":"secondary_phone"}},{"kind":"Field","name":{"kind":"Name","value":"primary_email"}},{"kind":"Field","name":{"kind":"Name","value":"secondary_email"}},{"kind":"Field","name":{"kind":"Name","value":"address_1"}},{"kind":"Field","name":{"kind":"Name","value":"address_2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"film_title"}},{"kind":"Field","name":{"kind":"Name","value":"tagline"}},{"kind":"Field","name":{"kind":"Name","value":"genre"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"production_year"}},{"kind":"Field","name":{"kind":"Name","value":"production_company"}},{"kind":"Field","name":{"kind":"Name","value":"synopsis"}},{"kind":"Field","name":{"kind":"Name","value":"mux_asset_id"}},{"kind":"Field","name":{"kind":"Name","value":"mux_upload_id"}},{"kind":"Field","name":{"kind":"Name","value":"mux_playback_id"}},{"kind":"Field","name":{"kind":"Name","value":"mux_asset_data"}},{"kind":"Field","name":{"kind":"Name","value":"paid_at"}},{"kind":"Field","name":{"kind":"Name","value":"submitted_at"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"asset_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vouchers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"studio_id"}},{"kind":"Field","name":{"kind":"Name","value":"team_number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LoadFestivalSubmissionQuery, LoadFestivalSubmissionQueryVariables>;
export const SubmissionPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmissionPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"returnUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lineItems"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StripeLineItem"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"festivalSubmissionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"url"},"name":{"kind":"Name","value":"stripeCreatePurchase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"returnUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"returnUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"lineItems"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lineItems"}}},{"kind":"Argument","name":{"kind":"Name","value":"festivalSubmissionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"festivalSubmissionId"}}}]}]}}]} as unknown as DocumentNode<SubmissionPaymentMutation, SubmissionPaymentMutationVariables>;
export const SaveFestivalSubmissionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveFestivalSubmission"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_set"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"festival_submissions_set_input"}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_festival_submissions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SaveFestivalSubmissionMutation, SaveFestivalSubmissionMutationVariables>;
export const JudgeSaveRankingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"JudgeSaveRankings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rankings"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_film_group_users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rankings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rankings"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"film_group_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"rankings"}},{"kind":"Field","name":{"kind":"Name","value":"submitted_at"}}]}}]}}]} as unknown as DocumentNode<JudgeSaveRankingsMutation, JudgeSaveRankingsMutationVariables>;
export const JudgeSaveSubmittedAtDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"JudgeSaveSubmittedAt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"submittedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_film_group_users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"submitted_at"},"value":{"kind":"Variable","name":{"kind":"Name","value":"submittedAt"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"film_group_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"rankings"}},{"kind":"Field","name":{"kind":"Name","value":"submitted_at"}}]}}]}}]} as unknown as DocumentNode<JudgeSaveSubmittedAtMutation, JudgeSaveSubmittedAtMutationVariables>;
export const JudgeFilmGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JudgeFilmGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ffid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"poster"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"filmGroups"},"name":{"kind":"Name","value":"film_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_festival_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ffid"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"film_group_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"rankings"}},{"kind":"Field","name":{"kind":"Name","value":"submitted_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"award"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"team_number"}},{"kind":"Field","name":{"kind":"Name","value":"film_name"}},{"kind":"Field","name":{"kind":"Name","value":"genre"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"poster"},"name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset_type_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"poster"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"film"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mux_playback_id"}},{"kind":"Field","name":{"kind":"Name","value":"mux_thumbnail_time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"award_nominations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"award"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"award"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"membership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<JudgeFilmGroupsQuery, JudgeFilmGroupsQueryVariables>;
export const ScreeningPlaylistDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ScreeningPlaylist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"film_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"screening","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nlike"},"value":{"kind":"StringValue","value":"%Winners%","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"film_group_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"film_name"}},{"kind":"Field","name":{"kind":"Name","value":"genre"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"poster"},"name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"film"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mux_playback_id"}},{"kind":"Field","name":{"kind":"Name","value":"mux_thumbnail_time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"five_fest_film_groups"},"name":{"kind":"Name","value":"film_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"fivefest","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_like"},"value":{"kind":"StringValue","value":"Block%","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"festival_submissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"festival_submission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"film_title"}},{"kind":"Field","name":{"kind":"Name","value":"production_company"}},{"kind":"Field","name":{"kind":"Name","value":"production_year"}},{"kind":"Field","name":{"kind":"Name","value":"synopsis"}},{"kind":"Field","name":{"kind":"Name","value":"tagline"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"mux_playback_id"}},{"kind":"Field","name":{"kind":"Name","value":"genre"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"poster"},"name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ScreeningPlaylistQuery, ScreeningPlaylistQueryVariables>;
export const SelectionFilmGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SelectionFilmGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ffid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"poster"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"filmGroups"},"name":{"kind":"Name","value":"film_groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_festival_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ffid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"selection","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"team_number"}},{"kind":"Field","name":{"kind":"Name","value":"film_name"}},{"kind":"Field","name":{"kind":"Name","value":"genre"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"poster"},"name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset_type_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"poster"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"film"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mux_playback_id"}},{"kind":"Field","name":{"kind":"Name","value":"mux_thumbnail_time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selection_metrics_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"selection_metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"award_id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"award_nominations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"award"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"award"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"membership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"selection_progresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"seek"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"awards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"max_nominations"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"IntValue","value":"0"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"max_nominations"}}]}}]}}]} as unknown as DocumentNode<SelectionFilmGroupsQuery, SelectionFilmGroupsQueryVariables>;
export const UpsertSelectionProgressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertSelectionProgress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"film_group_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"index"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_selection_progress_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"film_group_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"film_group_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"index"},"value":{"kind":"Variable","name":{"kind":"Name","value":"index"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"seek"},"value":{"kind":"IntValue","value":"0"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"selection_progress_film_group_id_real_user_id_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"index"},{"kind":"EnumValue","value":"seek"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"seek"}}]}}]}}]} as unknown as DocumentNode<UpsertSelectionProgressMutation, UpsertSelectionProgressMutationVariables>;
export const UpsertSelectionMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertSelectionMetric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"award_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_selection_metrics_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"award_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"award_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"selection_metrics_real_user_id_team_id_award_id_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"EnumValue","value":"value"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"award_id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"selection_metrics_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpsertSelectionMetricMutation, UpsertSelectionMetricMutationVariables>;
export const WhoamiDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Whoami"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"User"}}]}}]}},...UserFragmentDoc.definitions]} as unknown as DocumentNode<WhoamiQuery, WhoamiQueryVariables>;
export const StudioCacheDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StudioCache"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"studio"},"name":{"kind":"Name","value":"studios_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"owner_id"}},{"kind":"Field","name":{"kind":"Name","value":"participating_since"}},{"kind":"Field","name":{"kind":"Name","value":"slogan"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"film_name"}},{"kind":"Field","name":{"kind":"Name","value":"team_number"}},{"kind":"Field","name":{"kind":"Name","value":"film_festival"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"film"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vimeo_url"}},{"kind":"Field","name":{"kind":"Name","value":"mux_playback_id"}},{"kind":"Field","name":{"kind":"Name","value":"mux_thumbnail_time"}},{"kind":"Field","alias":{"kind":"Name","value":"recommendations"},"name":{"kind":"Name","value":"mux_asset_data"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"non_standard_input_reasons","block":false}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"memberships_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<StudioCacheQuery, StudioCacheQueryVariables>;
export const TeamCacheDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeamCache"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"posterAssetTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"team"},"name":{"kind":"Name","value":"teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"film_festival"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"registration_fee"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studio_id"}},{"kind":"Field","name":{"kind":"Name","value":"owner_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"team_number"}},{"kind":"Field","name":{"kind":"Name","value":"film_name"}},{"kind":"Field","name":{"kind":"Name","value":"genre"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"is_no_music"}},{"kind":"Field","name":{"kind":"Name","value":"submitted_at"}},{"kind":"Field","name":{"kind":"Name","value":"inspiration_meta"}},{"kind":"Field","name":{"kind":"Name","value":"festival_submission_vouchers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"redeemed_at"}},{"kind":"Field","name":{"kind":"Name","value":"festival_submission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"film_title"}},{"kind":"Field","name":{"kind":"Name","value":"mux_playback_id"}},{"kind":"Field","name":{"kind":"Name","value":"submitted_at"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_invited"}},{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"primary_email"}},{"kind":"Field","name":{"kind":"Name","value":"signature_ts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sub"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"award_nominations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"award_id"}},{"kind":"Field","name":{"kind":"Name","value":"asset_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asset_type_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asset_type_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"prize_elections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prize_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"music_releases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"song_title"}},{"kind":"Field","name":{"kind":"Name","value":"composer"}},{"kind":"Field","name":{"kind":"Name","value":"publisher"}},{"kind":"Field","name":{"kind":"Name","value":"start_time"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"society"}},{"kind":"Field","name":{"kind":"Name","value":"use_type"}},{"kind":"Field","name":{"kind":"Name","value":"is_royalty_free"}},{"kind":"Field","name":{"kind":"Name","value":"royalty_free_source"}},{"kind":"Field","name":{"kind":"Name","value":"is_original"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"location_releases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"venue_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"middle_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"address_1"}},{"kind":"Field","name":{"kind":"Name","value":"address_2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"is_owned_by_team"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"payments_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"film"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"mux_playback_id"}},{"kind":"Field","name":{"kind":"Name","value":"mux_thumbnail_time"}},{"kind":"Field","name":{"kind":"Name","value":"uploaded_at"}},{"kind":"Field","alias":{"kind":"Name","value":"recommendations"},"name":{"kind":"Name","value":"mux_asset_data"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"non_standard_input_reasons","block":false}}]}]}},{"kind":"Field","alias":{"kind":"Name","value":"posters"},"name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset_type_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"posterAssetTypeId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"asset_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hidden"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hidden"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"Y","block":false}}]}}]}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"asset_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"submission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"paperwork_ts"}},{"kind":"Field","name":{"kind":"Name","value":"film_ts"}},{"kind":"Field","name":{"kind":"Name","value":"has_reupload"}},{"kind":"Field","name":{"kind":"Name","value":"official_ts"}},{"kind":"Field","name":{"kind":"Name","value":"is_on_time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"matchup_requests_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"withdrawn"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"awards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"max_nominations"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<TeamCacheQuery, TeamCacheQueryVariables>;